webpackJsonp([9],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LIST_APPOINTMENTS_IN_RANGE_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ACTIVE_APPOINTMENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LIST_CLIENTS_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SEARCH_CLIENTS_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LIST_ACTIVE_CLIENTS_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LIST_INVOICES_IN_RANGE_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LIST_TRANSACTIONS_IN_RANGE_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DELETE_INVOICE_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LIST_GROUPS_REQ; });
/* unused harmony export GET_ACTIVE_INVOICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CREATE_APPOINTMENT_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_INVOICE_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return GET_INVOICE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SAVE_PAYMENT_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CODE_SUGGESTIONS; });
/* unused harmony export CODE_CUD_REQ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NOTE_SAVE_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_CLIENT_RELATIONSHIP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_ME_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GET_LOOKUPS_REQ; });
/* unused harmony export CLIENT_REQ */
/* unused harmony export APPOINTMENT_REQ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return INVOICE_REQ; });
/* unused harmony export MEDICAL_RECORD_REQ */
/* unused harmony export MEDICAL_AID_SAVE_RECORD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CLIENT_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CLIENT_ACTIVE_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return KONG_TOKEN_KEY; });
/* unused harmony export ACTIVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ACTIVATE_RANGE_PICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_REFRESH_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TRIGGER_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_SETTING; });
/* unused harmony export SET_GLOBAL_APPOINTMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_ACTIVE_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_ACTIVE_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_ACTIVE_DATE_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_SPACE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return HIDE_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_POST_LOGIN_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SHOW_APPOINTMENT_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STATUSES; });
/* unused harmony export PAYABLE_STATUSES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TITLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CODETYPES; });
/* unused harmony export CHARTCOLORS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PAYMENT_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SMALL_BREAKPOINT; });
/* unused harmony export DEFAULT_TIMEOUT */
/* unused harmony export APPOINTMENT_OBJ */
/* unused harmony export RESCHEDULE_PROCESS */
/* unused harmony export CANCEL_PROCESS */
/* unused harmony export SEND_PAYMENT_REQUEST */
/* unused harmony export MARK_AS_PAID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LINKS; });

var LIST_APPOINTMENTS_IN_RANGE_REQ = 'list-appointments-in-range-request';
var ACTIVE_APPOINTMENT_DETAIL = 'list-appointment-detail-request';
var LIST_CLIENTS_REQ = 'clients-list-request';
var SEARCH_CLIENTS_REQ = 'clients-search-request';
var LIST_ACTIVE_CLIENTS_REQ = 'clients-list-active-request';
var LIST_INVOICES_IN_RANGE_REQ = 'list-invoices-in-range-request';
var LIST_TRANSACTIONS_IN_RANGE_REQ = 'list-transactions-in-range-request';
var DELETE_INVOICE_REQ = 'delete-invoice-request';
var LIST_GROUPS_REQ = 'groups-list-request';
var GET_ACTIVE_INVOICE = 'get-active-invoice-request';
var CREATE_APPOINTMENT_REQ = 'create-appointment-request';
var SAVE_INVOICE_REQ = 'save-invoice-request';
var GET_INVOICE_SETTINGS = 'invoicesettings-req';
var SAVE_PAYMENT_REQ = 'save-payment-req';
var CODE_SUGGESTIONS = 'suggestionsReqId';
var CODE_CUD_REQ = 'appointment-code-req';
var NOTE_SAVE_REQ = 'appointment-notes-request';
var GET_CLIENT_RELATIONSHIP_REQUEST = 'get-relationship-request';

var GET_ME_REQ = 'me-request';
var GET_LOOKUPS_REQ = 'get-me-lookups-request';
var CLIENT_REQ = function CLIENT_REQ(id) {
  return 'client-detail-request-' + id;
};
var APPOINTMENT_REQ = function APPOINTMENT_REQ(id) {
  return 'appointment-detail-request-' + id;
};
var INVOICE_REQ = function INVOICE_REQ(id) {
  return 'invoice-detail-request-' + id;
};
var MEDICAL_RECORD_REQ = function MEDICAL_RECORD_REQ(id) {
  return 'medical-aid-get-request-' + id;
};
var MEDICAL_AID_SAVE_RECORD = 'medical-aid-save-request';
var CLIENT_PAGE_SIZE = 300;
var CLIENT_ACTIVE_LIMIT = 2400;
var KONG_TOKEN_KEY = 'kong_appointmentguru_token';

var ACTIVE = {
  'PRACTITIONER': 'practitioner',
  'CLIENT': 'client',
  'APPOINTMENT': 'appointment'
};

var ACTIVATE_RANGE_PICKER = 'ACTIVATE_RANGE_PICKER';
var SET_TOKEN = 'SET_TOKEN';
var SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
var TRIGGER_EVENT = 'TRIGGER_EVENT';
var SET_NOTIFICATION = 'SET_NOTIFICATION';
var SET_SETTING = 'SET_SETTING';
var SET_GLOBAL_APPOINTMENT = 'SET_GLOBAL_APPOINTMENT';
var SET_ACTIVE_APPOINTMENT = 'SET_ACTIVE_APPOINTMENT';
var SET_ACTIVE_DIALOG = 'SET_ACTIVE_DIALOG';
var SET_ACTIVE_DATE_RANGE = 'SET_ACTIVE_DATE_RANGE';
var SET_SPACE_VALUE = 'SET_SPACE_VALUE';
var SET_SPACE = 'SET_SPACE';
var HIDE_SPACE = 'HIDE_SPACE';

var INIT = 'INIT';
var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var SET_POST_LOGIN_REDIRECT = 'SET_POST_LOGIN_REDIRECT';
var SHOW_APPOINTMENT_DIALOG = 'SHOW_APPOINTMENT_DIALOG';

var STATUSES = {
  'B': { title: 'Blocked', color: '#f0f0f0', bright: '#607D8B', icon: 'ic_remove_circle_outline', theme: 'grey lighten-2' },
  'N': { title: 'New', color: '#00D8FF', bright: '#2196F3', icon: 'ic_event', theme: 'blue' },
  'C': { title: 'Cancelled', color: '#F7464A', bright: '#F44336', icon: 'ic_not_interested', theme: 'red lighten-1' },

  'I': { title: 'Invoiced', color: '#c9c9ff', bright: '#00BCD4', icon: 'receipt', theme: 'light-blue' },
  'P': { title: 'Paid', color: '#e1f7d5', bright: '#4CAF50', icon: 'ic_account_balance', theme: 'success' }
};
var PAYABLE_STATUSES = ['B', 'N', 'C', 'I'];
var TITLES = ['Dr', 'Mr', 'Mrs', 'Miss', 'Ms', 'Mx', 'Baby boy', 'Baby girl'];
var CODETYPES = ['icd10', 'process', 'procedure', 'nappi'];

var CHARTCOLORS = {
  'red': 'rgb(255, 99, 132)',
  'orange': 'rgb(255, 159, 64)',
  'yellow': 'rgb(255, 205, 86)',
  'green': 'rgb(75, 192, 192)',
  'blue': 'rgb(54, 162, 235)',
  'purple': 'rgb(153, 102, 255)',
  'grey': 'rgb(201, 203, 207)'
};

var ACTIONS = {
  'ASSIGN_PAYMENT': 'payment_transaction_assignment'
};

var PAYMENT_METHODS = [{
  value: 'eft',
  text: 'EFT'
}, {
  value: 'cash',
  text: 'Cash'
}, {
  value: 'snapscan',
  text: 'SnapScan'
}, {
  value: 'credit_card',
  text: 'Creditcard'
}, {
  value: 'medicalaid',
  text: 'Medical Aid'
}, {
  value: 'gift',
  text: 'Gift'
}, {
  value: 'client_credit',
  text: 'Client Credit'
}, {
  value: 'voucher',
  text: 'Voucher'
}, {
  value: 'write_off',
  text: 'Write off'
}, {
  value: 'other',
  text: 'Other'
}];

var SMALL_BREAKPOINT = 1024;
var DEFAULT_TIMEOUT = 2000;

var APPOINTMENT_OBJ = 'appointment';

var RESCHEDULE_PROCESS = 'schedule.models.AppointmentProcess.reschedule';
var CANCEL_PROCESS = 'schedule.models.AppointmentProcess.cancel';
var SEND_PAYMENT_REQUEST = 'schedule.models.AppointmentProcess.requestPayment';
var MARK_AS_PAID = 'schedule.models.AppointmentProcess.updateStatus';

var RULES = {
  required: function required(value) {
    return !!value || 'This field is required.';
  },
  email: function email(value) {
    if (!value) {
      return true;
    }
    var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || 'Please provide a valid e-mail address.';
  }
};

var LINKS = {
  SETTINGS: 'https://settings.appointmentguru.co/',
  SETTINGS_SPACES: 'https://settings.appointmentguru.co/#/settings/spaces/',
  SETTINGS_PROFILE: 'https://settings.appointmentguru.co/#/settings/me/profile/',
  DASHBOARD: 'https://dashboard.appointmentguru.co/',
  INVITE: 'https://settings.appointmentguru.co/#/wizards/invite/'
};

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(975)
  __webpack_require__(976)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1488),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-82f2e89e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(991)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1525),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_debounce__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mixins_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sentry_browser__ = __webpack_require__(122);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestsMixin',
  data: function data() {
    return {
      requestTimeout: null,
      globalRequests: {
        appointmentsv2: {
          resource: 'ag.practitioner.appointments'
        }
      }
    };
  },

  computed: {
    getMeReq: function getMeReq() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["f" /* GET_ME_REQ */], true);
    },
    getMeReqStatus: function getMeReqStatus() {
      return this.getMeReq.status;
    },
    getLookupsReq: function getLookupsReq() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["K" /* GET_LOOKUPS_REQ */], true);
    },
    globalDataLoading: function globalDataLoading() {
      return this.getLookupsReq.loading || this.getMeReq.loading;
    },
    getClientRelationship: function getClientRelationship() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["s" /* GET_CLIENT_RELATIONSHIP_REQUEST */], true);
    },
    getClientsReq: function getClientsReq() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["d" /* LIST_CLIENTS_REQ */], true);
    },
    getClientsReqStatus: function getClientsReqStatus() {
      return this.getClientsReq.status;
    },
    getClientSearchReq: function getClientSearchReq() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["Q" /* SEARCH_CLIENTS_REQ */], true);
    },
    getClientSearchReqStatus: function getClientSearchReqStatus() {
      return this.getClientSearchReq.status;
    },
    getInvoiceSettingsRequest: function getInvoiceSettingsRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["T" /* GET_INVOICE_SETTINGS */], false);
    },
    getInvoiceSettingsRequestStatus: function getInvoiceSettingsRequestStatus() {
      return this.getInvoiceSettingsRequest.status;
    },
    getCachedCodeSuggestions: function getCachedCodeSuggestions() {
      var req = this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["r" /* CODE_SUGGESTIONS */], false);
      return this.getObjectPath(req, 'result.data.codes', []);
    },
    getAppointmentsInRangeRequest: function getAppointmentsInRangeRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */], false);
    },
    getAppointmentsInRangeRequestStatus: function getAppointmentsInRangeRequestStatus() {
      return this.getAppointmentsInRangeRequest.status;
    },
    getLookupsRequest: function getLookupsRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_5__store_constants__["K" /* GET_LOOKUPS_REQ */], false);
    },
    getLookupsRequestStatus: function getLookupsRequestStatus() {
      return this.getLookupsRequest.status;
    },
    globalInitRequestLoading: function globalInitRequestLoading() {
      return this.getLookupsRequest.loading || this.getMeReq.loading;
    },
    globalAppointmentsV2RequestStatus: function globalAppointmentsV2RequestStatus() {
      if (this.globalRequests && this.globalRequests.appointmentsv2) {
        return this.globalRequests.appointmentsv2.status;
      }
      return 0;
    }
  },
  watch: {
    getClientsReqStatus: function getClientsReqStatus() {
      if (this.getClientsReqStatus === 200) {
        var response = this.getObjectPath(this.getClientsReq, 'result.data', {});
        if (response.next) {
          var currentPage = this.getObjectPath(this.getClientsReq, 'params.page', 1);
          this.getClients(currentPage + 1, __WEBPACK_IMPORTED_MODULE_5__store_constants__["O" /* CLIENT_PAGE_SIZE */]);
        }
        this.updateClientDb(response);
      }
    },
    getClientSearchReqStatus: function getClientSearchReqStatus() {
      if (this.getClientSearchReqStatus === 200) {
        var response = this.getObjectPath(this.getClientSearchReq, 'result.data', {});
        this.updateClientDb(response);
      }
    },
    getAppointmentsInRangeRequestStatus: function getAppointmentsInRangeRequestStatus() {
      if (this.getAppointmentsInRangeRequestStatus === 200) {
        this.updateAppointmentDb();
      }
    },
    globalAppointmentsV2RequestStatus: function globalAppointmentsV2RequestStatus() {
      if (this.globalAppointmentsV2RequestStatus === 200) {
        var appts = this.getObjectPath(this.globalRequests.appointmentsv2, 'result.results', []);
        this.$store.commit('addAppointments', appts);
      }
    }
  },
  methods: {
    updateAppointmentDb: __WEBPACK_IMPORTED_MODULE_7__mixins_debounce___default()(function () {
      var appts = this.getObjectPath(this.getAppointmentsInRangeRequest, 'result.data', []);
      this.$store.commit('addAppointments', appts);
    }, 1000),
    updateClientDb: __WEBPACK_IMPORTED_MODULE_7__mixins_debounce___default()(function (response) {
      this.$store.commit('addManyClients', response.results);
    }, 500),
    reloadPage: function reloadPage() {
      if (this.refreshRequestIds) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.refreshRequestIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var reqId = _step.value;

            this.$store.dispatch('RETRY', reqId);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    performAction: function performAction(service, context, collection, id, action, data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, headers, options;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = service.baseUrl + '/api/v3/' + context + '/' + collection + '/actions/' + action + '/';

                if (id) {
                  url = service.baseUrl + '/api/v3/' + context + '/' + collection + '/' + id + '/actions/' + action + '/';
                }
                headers = service.headers;
                options = {
                  url: url,
                  headers: headers,
                  data: data,
                  method: 'post'
                };
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default()(options);

              case 6:
                return _context.abrupt('return', _context.sent);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    action: function action(service, context, collection, id, _action, data, response) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'status', 0);
                __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'loading', true);
                _context2.next = 5;
                return _this2.performAction(service, context, collection, id, _action, data);

              case 5:
                result = _context2.sent;

                if (result.status > 199) {
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'status', result.status);
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'loading', false);
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'result', result.data);
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                if (_context2.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'status', _context2.t0.response.status);
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'loading', false);
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'result', _context2.t0.response.data);
                } else if (_context2.t0.request) {
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'loading', false);
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'status', 500);
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'result', { message: 'No response from the server' });
                } else {
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'loading', false);
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'status', 500);
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'result', { message: 'Unable to make request' });
                }

              case 12:
                _context2.prev = 12;

                __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(response, 'loading', false);
                return _context2.finish(12);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9, 12, 15]]);
      }))();
    },
    performProcess: function performProcess(id, processName, practitionerId, appointmentId, payload) {
      var data = {
        'practitioner': practitionerId,
        'appointment': appointmentId,
        'name': processName,
        'request_data': __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload)
      };
      this.$appointmentguru.resource('process').id(id).create(data);
    },
    getAppointment: function getAppointment(id) {
      this.$appointmentguru.resource('practitioner.appointments').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["k" /* ACTIVE_APPOINTMENT_DETAIL */]).get(id);
    },
    getPractitionerAppointments: function getPractitionerAppointments(practitionerId, fromDate, toDate) {
      if (!fromDate) {
        fromDate = this.$store.state.application.activeDateRange.from;
      }
      if (!toDate) {
        toDate = this.$store.state.application.activeDateRange.to;
      }

      this.globalRequests.appointmentsv2.params = {};
      this.globalRequests.appointmentsv2.params.after_utc = fromDate;
      this.globalRequests.appointmentsv2.params.before_utc = toDate;
      this.globalRequests.appointmentsv2.params.page_size = 1000;
      if (practitionerId) {
        this.globalRequests.appointmentsv2.params.practitioner = practitionerId;
      }

      this.$request('get', this.globalRequests.appointmentsv2);
    },
    getAppointmentsInRange: function getAppointmentsInRange() {
      var _this3 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var fromDate = this.$store.state.application.activeDateRange.from;
      var toDate = this.$store.state.application.activeDateRange.to;
      if (!params) {
        params = {};
      }
      params.after_utc = fromDate;
      params.before_utc = toDate;

      if (!this.getAppointmentsInRangeRequest.loading || force) {
        this.$appointmentguru.resource('practitioner.appointments').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */]).list(params);
      } else {
        window.clearTimeout(this.requestTimeout);
        this.requestTimeout = window.setTimeout(function () {
          _this3.$appointmentguru.resource('practitioner.appointments').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */]).list(params);
        }, 2000);
      }
    },
    loadInvoices: function loadInvoices() {
      var dateType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'due';
      var initialParams = arguments[1];

      var params = {
        facets: 'practitioner_id,space_id'
      };
      if (initialParams) {
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, initialParams);
      }
      var dateRange = this.$store.state.application.activeDateRange;
      var fromDate = false;
      var toDate = false;
      __WEBPACK_IMPORTED_MODULE_9__sentry_browser__["b" /* configureScope */](function (scope) {
        scope.setExtra('DateRange', dateRange);
      });
      if (dateRange && dateRange.from) {
        fromDate = dateRange.from;
        if (fromDate.trim) {
          fromDate = fromDate.trim();
        }
      }
      if (dateRange && dateRange.to) {
        toDate = dateRange.to;
        if (toDate.trim) {
          toDate = toDate.trim();
        }
      }
      if (dateType === 'due') {
        if (fromDate) {
          params['due_after_utc'] = fromDate;
        }
        if (toDate) {
          params['due_before_utc'] = toDate;
        }
      } else {
        if (fromDate) {
          params['after_utc'] = fromDate;
        }
        if (toDate) {
          params['before_utc'] = toDate;
        }
      }

      this.$invoiceguru.resource('invoices').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["e" /* LIST_INVOICES_IN_RANGE_REQ */]).list(params);
    },
    getInvoiceSettings: function getInvoiceSettings() {
      this.$invoiceguru.resource('invoiceSettings').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["T" /* GET_INVOICE_SETTINGS */]).get();
    },
    init: function init() {
      this.getMe();
      this.getLookups();
    },
    getMe: function getMe() {
      this.$appointmentguru.resource('practitioner.me').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["f" /* GET_ME_REQ */]).list();
    },
    getLookups: function getLookups() {
      this.$appointmentguru.resource('practitioner.lookups').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["K" /* GET_LOOKUPS_REQ */]).list();
    },
    refreshGlobalSettings: function refreshGlobalSettings() {
      if (!this.globalDataLoading) {
        this.getMe();
        this.getLookups();
      }
    },
    getRemoteRelationship: function getRemoteRelationship(id) {
      this.$appointmentguru.resource('practitioner.v3.relationships').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["s" /* GET_CLIENT_RELATIONSHIP_REQUEST */]).get(id);
    },
    getGroups: function getGroups() {
      this.$multiguru.resource('group.expanded').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["g" /* LIST_GROUPS_REQ */]).list();
    },
    getClients: function getClients() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_5__store_constants__["O" /* CLIENT_PAGE_SIZE */];

      var params = {
        'page': page,
        'page_size': pageSize
      };
      this.$appointmentguru.resource('practitioner.clients').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["d" /* LIST_CLIENTS_REQ */]).list(params);
    },
    getActiveClients: function getActiveClients() {
      var params = {
        from_date: this.globalActiveDateRange.from,
        to_date: this.globalActiveDateRange.to
      };
      this.$appointmentguru.resource('practitioner.v3.clients.active').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["o" /* LIST_ACTIVE_CLIENTS_REQ */]).list(params);
    },
    searchClients: function searchClients(searchString) {
      var params = {
        'search': searchString
      };
      this.$appointmentguru.resource('practitioner.clients').id(__WEBPACK_IMPORTED_MODULE_5__store_constants__["Q" /* SEARCH_CLIENTS_REQ */]).list(params);
    },
    getInvoice: function getInvoice(id) {
      var reqId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_constants__["U" /* INVOICE_REQ */])(id);
      this.$invoiceguru.resource('invoices').id(reqId).get(id);
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(1502),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(916)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1376),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1389),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-365373f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1004)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1551),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1443),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(782),
  /* template */
  __webpack_require__(1396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1485),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(1438),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(980)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1495),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(932)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1407),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1493),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppointmentsMixin',
  methods: {
    getAppointmentActionItemsByKeyList: function getAppointmentActionItemsByKeyList(li) {
      return this.appointmentActions.filter(function (item) {
        if (li.indexOf(item.id) !== -1) {
          return item;
        }
      });
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('appointments', ['getRecentlyUpdated']), {
    appointmentActions: function appointmentActions() {
      var _this = this;

      var appointmentActions = [];
      if (this.appointment.client) {
        appointmentActions = [{
          icon: 'open_in_new',
          id: 'appointment_view',
          title: 'Open Appointment',
          ownerCan: true,
          onclick: function onclick() {
            _this.$emit('actionselected');
            _this.$emit('close');
            _this.$router.push('/appointments/' + _this.appointment.id);
          }
        }, {
          icon: 'person',
          id: 'show_client',
          title: 'Show client',
          ownerCan: true,
          disableIf: function disableIf(appointment) {
            if (appointment) {
              if (appointment.status === 'B') {
                return true;
              }
              if (!appointment.computed_relationship_id) {
                return true;
              }
              return false;
            } else {
              return true;
            }
          },
          extraActions: function extraActions(appointment) {
            if (appointment && appointment.computed_relationship_id) {
              var relationshipId = appointment.computed_relationship_id;

              if (relationshipId) {
                return [{
                  icon: 'edit',
                  text: 'Edit',
                  action: function action(appointment) {
                    _this.$emit('actionselected');
                    _this.$emit('close');
                    if (appointment && appointment.computed_relationship_id) {
                      _this.launchCustomerDetailsDialog(appointment.computed_relationship_id, true);
                    }
                  }
                }];
              }
              return [];
            }
          },
          onclick: function onclick() {
            _this.$emit('actionselected');
            _this.$emit('close');
            var relationshipId = _this.getObjectPath(_this.appointment, 'computed_relationship_id');
            if (relationshipId) {
              _this.gotoRelationship(relationshipId);
            }
          }
        }, { type: 'divider', id: 'div-price-stuff' }, {
          id: 'bulk_add_codes',
          icon: 'local_hospital',
          title: 'Manage codes',
          ownerCan: true,
          onclick: function onclick(appointment) {
            if (!appointment) {
              appointment = _this.appointment;
            }
            _this.$emit('actionselected');
            var options = {
              appointmentId: appointment.id,
              value: appointment,
              editable: true,
              withTitle: true,
              withTotal: true,
              withRefresh: true,
              withInvoiceable: true
            };
            _this.launchDiagnosisCodes(options);
          }
        }, {
          id: 'create_invoice',
          icon: 'receipt',
          title: 'Invoice',
          ownerCan: true,
          onclick: function onclick(appointment) {
            if (!appointment) {
              appointment = _this.appointment;
            }
            _this.$emit('actionselected');
            _this.launchInvoiceDetailsDialog(_this.appointment);
          }
        }, {
          icon: 'credit_card',
          id: 'bulk_add_payment',
          title: 'Track payment',
          ownerCan: true,
          disableIf: function disableIf(appointment) {
            return appointment.status === 'P';
          },
          onclick: function onclick(appointment) {
            _this.$emit('actionselected');
            if (!appointment) {
              appointment = _this.appointment;
            }
            var options = {
              appointment: appointment,
              touch: Math.random()
            };
            _this.launchAppointmentPaymentDialog(options);
          }
        }, { type: 'divider', id: 'div-extra-stuff' }, {
          id: 'add_note',
          icon: 'note_add',
          title: 'Add a note',
          ownerCan: true,
          onclick: function onclick() {
            _this.$emit('actionselected');
            var options = { appointment: _this.appointment };
            _this.openGlobalDialog(true, 'Notes', options);
          }
        }, {
          id: 'bulk_add_products',
          icon: 'shopping_basket',
          title: 'Product sales',
          ownerCan: true,
          onclick: function onclick(appointment) {
            if (!appointment) {
              appointment = _this.appointment;
            }
            _this.$emit('actionselected');
            var options = {
              appointmentId: appointment.id
            };
            _this.launchAppointmentProduct(options);
          }
        }, {
          id: 'bulk_make_online',
          icon: 'headset_mic',
          title: 'Make online',
          disableIf: function disableIf(appointment) {
            return appointment.is_online;
          },
          onclick: function onclick() {
            _this.$emit('actionselected');
            var options = { appointment: _this.appointment };
            _this.launchMakeAppointmentOnline(options);
          }
        }, {
          icon: 'tag',
          id: 'add_tags',
          title: 'Add tags',
          ownerCan: true,
          onclick: function onclick(appointment) {
            _this.$emit('actionselected');
            if (!appointment) {
              appointment = _this.appointment;
            }
            var options = {
              appointmentIds: [appointment.id]
            };
            _this.launchAppointmentTags(options);
          }
        }, { type: 'divider', id: 'div-schedule-stuff' }, {
          id: 'bulk_reschedule',
          icon: 'replay',
          title: 'Reschedule',
          ownerCan: true,
          onclick: function onclick() {
            _this.$emit('actionselected');
            _this.openGlobalDialog(true, 'Reschedule', { appointment: _this.appointment });
          }
        }, {
          icon: 'file_copy',
          id: 'clone',
          title: 'Clone',
          ownerCan: true,
          onclick: function onclick(appointment) {
            _this.$emit('actionselected');
            if (!appointment) {
              appointment = _this.appointment;
            }
            var options = {
              appointment: appointment,
              touch: Math.random()
            };
            _this.launchCloneAppointment(options);
          },
          disableIf: function disableIf(appointment) {
            if (appointment.is_online === true) {
              return true;
            }
            return false;
          }
        }, {
          id: 'bulk_cancel',
          icon: 'close',
          title: 'Cancel',
          ownerCan: true,
          onclick: function onclick() {
            _this.$emit('actionselected');
            _this.openGlobalDialog(true, 'Cancel', { appointment: _this.appointment });
          }
        }, {
          id: 'bulk_delete',
          icon: 'delete',
          ownerCan: true,
          title: 'Delete',
          onclick: function onclick() {
            _this.$emit('actionselected');
            _this.openGlobalDialog(true, 'Delete', { appointment: _this.appointment });
          }
        }];
      } else {
        appointmentActions = [{
          icon: 'open_in_new',
          id: 'open_appointment',
          title: 'Open Appointment',
          onclick: function onclick() {
            _this.$emit('actionselected');
            _this.$emit('close');
            _this.$router.push('/appointments/' + _this.appointment.id);
          }
        }, {
          icon: 'account_circle',
          id: 'assign_client',
          title: 'Assign to client',
          onclick: function onclick() {
            var options = {
              value: _this.appointment
            };
            _this.launchSetAppointmentClient(options);
          }
        }, {
          id: 'cancel_appointment',
          icon: 'close',
          title: 'Cancel',
          onclick: function onclick() {
            _this.$emit('actionselected');
            _this.openGlobalDialog(true, 'Cancel', { appointment: _this.appointment });
          }
        }, {
          id: 'delete_appointment',
          icon: 'delete',
          title: 'Delete',
          onclick: function onclick() {
            _this.$emit('actionselected');
            _this.openGlobalDialog(true, 'Delete', { appointment: _this.appointment });
          }
        }];
      }
      return appointmentActions;
    },
    appointmentBulkActions: function appointmentBulkActions() {
      return [{
        title: 'Add ICD-10 codes'
      }, {
        title: 'Add a payment'
      }, {
        title: 'Create an invoice'
      }, {
        title: 'Add Tags'
      }, {
        title: 'Cancel'
      }, {
        title: 'Delete'
      }];
    }
  })
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InvoiceMixin',
  data: function data() {
    var _this = this;

    return {
      invoiceEvents: {
        'edit': function edit(invoice) {
          _this.$router.push({ path: '/invoices/' + invoice.id });
        },
        'showcustomer': function showcustomer(invoice) {
          if (invoice.relationship_id) {
            return _this.$router.push({ path: '/clients/r/' + invoice.relationship_id });
          }
          if (invoice.customer_id) {
            return _this.$router.push({ path: '/clients/' + invoice.customer_id });
          }
        },
        'sendtomedicalaid': function sendtomedicalaid(invoice) {
          _this.invoice = invoice;

          _this.launchSendToMedicalAidDialog({
            invoice: invoice,
            withCancel: true
          });
        },
        'send': function send(invoice) {
          _this.invoice = invoice;
          var client = _this.setClientFromId(invoice.customer_id);
          _this.launchSendInvoiceDialog({
            invoice: invoice,
            client: client,
            withClose: false
          });
        },
        'share': function share(invoice) {
          if (!_this.invoice && _this.invoice) {
            invoice = _this.invoice;
          }

          _this.invoice = invoice;
          var baseUrl = _this.$invoiceguru.baseUrl;
          if (baseUrl.endsWith('/')) {
            baseUrl = baseUrl.substr(0, baseUrl.length - 1);
          }

          var fName = _this.getObjectPath(_this.me, 'first_name');
          var lName = _this.getObjectPath(_this.me, 'last_name');
          var profession = _this.getObjectPath(_this.me, 'profile.profession.name');
          var fullname = fName + ' ' + lName;
          if (profession) {
            fullname = fullname + ' ' + profession;
          }
          var link = {
            title: 'Your invoice from ' + fullname,
            description: '',
            url: baseUrl + invoice.get_view_url
          };
          var options = {
            relationshipId: invoice.relationship_id,
            links: [link]
          };
          _this.launchShareDialog(options);
        },
        'view': function view(invoice) {
          if (invoice && invoice.id) {
            var base = _this.$invoiceguru.baseUrl;
            var path = invoice.get_view_url;
            if (!path) {
              path = '/invoice/view/' + invoice.id + '/?key=' + invoice.password;
            }
            var url = base + path;
            window.open(url, '_blank');
          }
        },
        'showpaymentdialog': function showpaymentdialog(invoice) {
          var amount = _this.formatCurrency(invoice.currency, invoice.invoice_amount);
          var options = {
            title: 'Pay ' + amount + ' with SnapScan',
            snapUrl: invoice.get_snapscan_url,
            snapImg: invoice.get_snapscan_qr
          };
          _this.launchSnapDialog(options);
        },

        'addpayment': function addpayment(invoice) {
          _this.$store.dispatch('SET_SPACE', ['globalDialog', 'Payment', 'Record a payment', {
            appointmentIds: invoice.appointments,
            touch: Math.random(),
            withHeader: false
          }, {}, _this.$vuetify.breakpoint.xs]);
        },
        'delete': function _delete(invoice) {
          var doDelete = window.confirm('Are you sure you want to delete this invoice?');
          if (doDelete) {
            _this.$invoiceguru.resource('invoices').id(__WEBPACK_IMPORTED_MODULE_0__store_constants__["n" /* DELETE_INVOICE_REQ */]).delete(invoice.id);
          }
        }
      }
    };
  },

  computed: {
    invoiceActions: function invoiceActions() {
      return [{
        icon: 'edit',
        action: 'edit',
        text: 'Edit'
      }, {
        icon: 'person',
        action: 'showcustomer',
        text: 'Show client'
      }, {
        icon: 'share',
        action: 'share',
        text: 'Share'
      }, {
        icon: 'mail',
        action: 'send',
        text: 'Send'
      }, {
        icon: 'local_hospital',
        action: 'sendtomedicalaid',
        text: 'Send to medical aid'
      }, {
        icon: 'open_in_new',
        action: 'view',
        text: 'View'
      }, {
        icon: 'credit_card',
        action: 'showpaymentdialog',
        text: 'Take payment',
        disableIf: function disableIf(invoice) {
          return invoice.status.toLowerCase() === 'paid';
        }
      }, {
        icon: 'attach_money',
        action: 'addpayment',
        text: 'Add a payment',
        disableIf: function disableIf(invoice) {
          return invoice.status.toLowerCase() === 'paid';
        }
      }, {
        icon: 'delete',
        action: 'delete',
        text: 'Delete'
      }];
    }
  }
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1001)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1548),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(943)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1423),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1416),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(1439),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1357),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(1428),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-556e172a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(882)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(1308),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(961)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1463),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1422),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(889)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1324),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c2c28d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(895)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1337),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-163f5881",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1471),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(977)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1489),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1434),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(900)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(1351),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1541),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(1388),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(944)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(1425),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(904)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(1356),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(913)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(1371),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e01d4f1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(899)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(777),
  /* template */
  __webpack_require__(1347),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(892)
  __webpack_require__(891)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(788),
  /* template */
  __webpack_require__(1330),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1266b1e3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */,
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROUTES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Home__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Calendar__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_Calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Appointments__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Appointments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_Appointments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Appointment__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Appointment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_Appointment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Clients__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Clients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_Clients__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Client__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_Client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_ClientHome__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_ClientHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_ClientHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Invoices__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Invoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_Invoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_Invoice__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_Invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_Invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Financials__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Financials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_Financials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_invoice_layout_Transactions__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_invoice_layout_Transactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_invoice_layout_Transactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_Reports__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_Reports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_pages_Reports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_Billing__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_Billing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pages_Billing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_Integrations_IntegrationsList__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_Integrations_IntegrationsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_pages_Integrations_IntegrationsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_guides_GetStarted_vue__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_guides_GetStarted_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_pages_guides_GetStarted_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pages_Settings__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pages_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_pages_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_settings_locations_ProductWizard__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_settings_locations_ProductWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_pages_settings_locations_ProductWizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_pages_settings_Profile__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_pages_settings_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_pages_settings_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_pages_settings_Earn__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_pages_settings_Earn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_pages_settings_Earn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_pages_settings_Online__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_pages_settings_Online___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_pages_settings_Online__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_settings_Calendar__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_settings_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_pages_settings_Calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pages_communications__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pages_communications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_pages_communications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_Login__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__ = __webpack_require__(548);




































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var ROUTES = [{
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Home___default.a,
  meta: {
    icon: 'home',
    with_datepicker: false,
    helpdocs: 'contextualhelphomepage'
  },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/calendar',
  name: 'Calendar',
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Calendar___default.a,
  meta: {
    icon: 'today',
    with_datepicker: false,
    helpdocs: 'contextualhelpappointmentspage"'
  },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/calendar/team/:page?',
  name: 'TeamCalendar',
  props: true,
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1557));
  },
  meta: {
    icon: 'today',
    with_datepicker: false,
    hidden_from_nav: true,
    helpdocs: 'contextualhelpappointmentspage"'
  },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/appointments',
  name: 'Appointments',
  component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Appointments___default.a,
  meta: { icon: 'alarm_on', hidden_from_nav: false, with_datepicker: false, new: false, klass: 'hidden-xs-only' },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/appointments/:id',
  name: 'Appointment',
  component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Appointment___default.a,
  meta: { icon: 'alarm_on', hidden_from_nav: true, with_back_btn: true, with_datepicker: false },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/clients',
  name: 'Clients',
  component: __WEBPACK_IMPORTED_MODULE_6__components_pages_Clients___default.a,
  meta: { icon: 'group', with_datepicker: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/clients/home',
  name: 'ClientsHome',
  component: __WEBPACK_IMPORTED_MODULE_8__components_pages_ClientHome___default.a,
  meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true, with_datepicker: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/clients/merge/:relationshipId?',
  name: 'ClientsMerge',
  props: true,

  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1558));
  },
  meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true, with_datepicker: false },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/clients/r/:relationshipId',
  name: 'ClientByRelationship',
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_Client___default.a,
  meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/clients/r/:relationshipId/:tab',
  name: 'ClientByRelationshipWithTab',
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_Client___default.a,
  meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/clients/:id',
  name: 'Client',
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_Client___default.a,
  meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/clients/:id/:tab',
  name: 'ClientWithTab',
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_Client___default.a,
  meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'Invoices',
  path: '/invoices',
  component: __WEBPACK_IMPORTED_MODULE_9__components_pages_Invoices___default.a,
  meta: {
    icon: 'content_copy',
    with_datepicker: true,
    helpdocs: 'contextualhelpinvoicespage'
  },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'Transactions',
  path: '/transactions',
  component: __WEBPACK_IMPORTED_MODULE_12__components_invoice_layout_Transactions___default.a,
  meta: {
    hidden_from_nav: true,
    icon: 'content_copy',
    with_datepicker: true
  },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'Financials',
  path: '/financials',
  component: __WEBPACK_IMPORTED_MODULE_11__components_pages_Financials___default.a,
  meta: { hidden_from_nav: true, icon: 'content_copy', with_datepicker: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'Messages',
  path: '/messages',
  component: __WEBPACK_IMPORTED_MODULE_23__components_pages_communications___default.a,
  meta: { hidden_from_nav: false, icon: 'send', with_datepicker: false },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'EditInvoice',
  path: '/invoices/:id',
  component: __WEBPACK_IMPORTED_MODULE_10__components_pages_Invoice___default.a,
  meta: { icon: 'content_copy', hidden_from_nav: true, with_back_btn: true, with_datepicker: false },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'Reports',
  path: '/reports',
  component: __WEBPACK_IMPORTED_MODULE_13__components_pages_Reports___default.a,
  meta: { icon: 'trending_up', with_datepicker: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'Free Stuff',
  path: '/settings/earn',
  component: __WEBPACK_IMPORTED_MODULE_20__components_pages_settings_Earn___default.a,
  meta: { icon: 'attach_money', with_datepicker: false, new: false },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'Settings',
  path: '/settings',
  redirect: '/settings/profile',
  component: __WEBPACK_IMPORTED_MODULE_17__components_pages_Settings___default.a,
  meta: { icon: 'settings', showChildren: true, with_datepicker: false, updated: true },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired,
  children: [{
    name: 'Home',
    path: '/settings/home',
    component: __WEBPACK_IMPORTED_MODULE_18__components_pages_settings_locations_ProductWizard___default.a,
    meta: { icon: 'home', with_datepicker: false, hidden_from_nav: true },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    name: 'Spaces',
    path: '/settings/locations',
    component: __WEBPACK_IMPORTED_MODULE_18__components_pages_settings_locations_ProductWizard___default.a,
    meta: { icon: 'location_on', with_datepicker: false },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    name: 'Profile',
    path: '/settings/profile',
    component: __WEBPACK_IMPORTED_MODULE_19__components_pages_settings_Profile___default.a,
    meta: { icon: 'person', with_datepicker: false },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    name: 'Get Online',
    path: '/settings/get-online',
    component: __WEBPACK_IMPORTED_MODULE_21__components_pages_settings_Online___default.a,
    meta: { icon: 'link', with_datepicker: false },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    name: 'For your phone',
    path: '/settings/calendar-feed',
    component: __WEBPACK_IMPORTED_MODULE_22__components_pages_settings_Calendar___default.a,
    meta: { icon: 'smartphone', with_datepicker: false },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    name: 'Billing',
    path: '/billing',
    component: __WEBPACK_IMPORTED_MODULE_14__components_pages_Billing___default.a,
    meta: { icon: 'credit_card', hidden_from_nav: false },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }]
}, {
  name: 'Configure your account',
  path: '/guides/configure',
  redirect: function redirect(to) {
    return { path: '/get-started' };
  },
  meta: { icon: 'help', showChildren: true, with_datepicker: false },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  name: 'Get Started',
  path: '/get-started',
  component: __WEBPACK_IMPORTED_MODULE_16__components_pages_guides_GetStarted_vue___default.a,
  meta: { icon: 'help', showChildren: true, with_datepicker: false },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
}, {
  path: '/integrations',
  name: 'Integrations',

  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1563));
  },
  meta: { icon: 'device_hub', showChildren: false, hidden_from_nav: false, with_back_btn: true, updated: false, with_datepicker: false },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired,
  children: [{
    path: '/',
    name: 'Integrations',
    component: __WEBPACK_IMPORTED_MODULE_15__components_pages_Integrations_IntegrationsList___default.a,
    meta: { icon: 'device_hub', hidden_from_nav: false, with_back_btn: true, new: false, with_datepicker: false },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    path: 'setmore',
    name: 'Setmore integration',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1562));
    },
    meta: { hidden_from_nav: true, with_back_btn: true, new: true, with_datepicker: false },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    path: 'yoco',
    name: 'Yoco integration',
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 439));
    },
    meta: {
      hidden_from_nav: true,
      with_back_btn: true,
      new: true,
      with_datepicker: false,
      installHelp: 'https://help.appointmentguru.co/using-yoco-with-appointmentguru.html'
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    path: 'mailchimp',
    name: 'Mailchimp integration',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1560));
    },
    meta: {
      hidden_from_nav: true,
      with_back_btn: true,
      new: false,
      with_datepicker: false,
      installHelp: 'https://help.appointmentguru.co/using-mailchimp-with-appointmentguru.html'
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    path: 'jotform',
    name: 'JotForm integration',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1559));
    },
    meta: {
      hidden_from_nav: true,
      with_back_btn: true,
      new: false,
      with_datepicker: false,
      intallHelp: 'https://help.appointmentguru.co/courses/go-paperless-with-appointmentguru-and-jotform.html'
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }, {
    path: 'physitrack',
    name: 'Physitrack integration',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1561));
    },
    meta: {
      hidden_from_nav: true,
      with_back_btn: true,
      new: true,
      with_datepicker: false,
      installHelp: 'https://help.appointmentguru.co/integrate-appointmentguru-with-physitrack.html'
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__mixins_Auth__["a" /* default */].loginRequired
  }]
}, {
  name: 'TestPage',
  path: '/test',

  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1565));
  },
  meta: { hidden_from_nav: true, with_datepicker: true }
}, {
  name: 'Login',
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_24__components_pages_Login___default.a,
  meta: { icon: 'settings', hidden_from_nav: true, with_back_btn: false }
}, {
  name: 'Logout',
  path: '/logout',

  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1564));
  },
  meta: { hidden_from_nav: true, with_datepicker: false }
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: ROUTES
}));

/***/ }),
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(1382),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32055b19",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(1498),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      calendars: {},
      ignoredStatuses: ['c']
    };
  },

  methods: {
    getPractitionerCalendar: function getPractitionerCalendar() {
      var practitionerId = this.getObjectPath(this, 'practitioner.id', this.meId);
      var fromDate = this.$store.state.application.activeDateRange.from;
      var toDate = this.$store.state.application.activeDateRange.to;
      this.getPractitionerAppointments(practitionerId, fromDate, toDate);
    },
    formatEvents: function formatEvents(events) {
      var _this = this;

      var facets = {
        spaces: {},
        products: {}
      };
      if (!events) {
        return [];
      }
      var formatted = events.map(function (evt) {
        evt['start'] = __WEBPACK_IMPORTED_MODULE_0_moment___default()(evt.start_time).format('HH:mm');
        evt['end'] = __WEBPACK_IMPORTED_MODULE_0_moment___default()(evt.end_time).format('HH:mm');
        evt['highlight'] = false;
        if (evt.space) {
          facets.spaces[evt.space] = {
            title: evt.service_name
          };
          if (parseInt(_this.selectedSpace) === parseInt(evt.space)) {
            evt['highlight'] = true;
          }
          facets.products[evt.product] = {
            title: evt.product_name
          };
        }
        if (_this.facets && facets) {
          _this.facets = facets;
        }
        return evt;
      });
      return formatted.filter(function (evt) {
        return _this.ignoredStatuses.indexOf(evt.status.toLowerCase()) === -1;
      });
    }
  },
  computed: {
    myEvents: function myEvents() {
      return this.$store.getters.appointments;
    },
    events: function events() {
      var events = [];
      if (this.practitioner && this.practitioner.id !== this.me.id) {
        var path = this.practitioner.id + '.result.results';
        events = this.getObjectPath(this.calendars, path, []);
      } else {
        events = this.myEvents;
      }
      return this.formatEvents(events);
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BACKGROUNDS; });
var BACKGROUNDS = {
  morning: ['https://images.unsplash.com/38/L2NfDz5SOm7Gbf755qpw_DSCF0490.jpg?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/22/good-mornin.JPG?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1432667278278-2a715bbcba52?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1422433555807-2559a27433bd?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/reserve/Af0sF2OS5S5gatqrKzVP_Silhoutte.jpg?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1489533119213-66a5cd877091?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1466527496777-6ed64c30572e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1503293962593-47247718a17a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1511371496040-1fb40794e675?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1484627147104-f5197bcd6651?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1502091791712-a43262c96f9b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1489493887464-892be6d1daae?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60', 'https://images.unsplash.com/photo-1489556155750-152ab23025bc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=900&q=60', 'https://images.unsplash.com/photo-1504736038806-94bd1115084e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=900&q=60'],
  afternoon: ['https://images.unsplash.com/photo-1456949037425-4b097bbcc0e8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1419833173245-f59e1b93f9ee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1470526446583-d0fe2363d8cb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1440507232006-bc246e7c681d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1500100586562-f75ff6540087?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1472313420546-a46e561861d8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60', 'https://images.unsplash.com/photo-1552084162-ec07b3f162dc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1458852535794-f5552aa49872?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1516687401797-25297ff1462c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1507910564623-a44cbc44255a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1508776781619-132e6a483b60?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=900&q=60'],
  evening: ['https://images.unsplash.com/photo-1499578124509-1611b77778c8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1437751059337-ea72d4f73fcf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1415025148099-17fe74102b28?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1468276311594-df7cb65d8df6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1524261399568-56d8c862aaf8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60', 'https://images.unsplash.com/photo-1569597137793-1873e6a6cc15?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60', 'https://images.unsplash.com/6/blurred_lines.jpeg?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&crop=crop&w=900&q=60', 'https://images.unsplash.com/photo-1496303861503-f6ec4e50034e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60', 'https://images.unsplash.com/photo-1506971456216-7b494f54d588?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60', 'https://images.unsplash.com/photo-1495855720902-bb60e936d7ca?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60', 'https://images.unsplash.com/photo-1495277493816-4c359911b7f1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60', 'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60', 'https://images.unsplash.com/photo-1502790671504-542ad42d5189?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60', 'https://images.unsplash.com/photo-1528353518104-dbd48bee7bc4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60', 'https://images.unsplash.com/photo-1501504413881-5888acd06076?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60', 'https://images.unsplash.com/photo-1462007895615-c8c073bebcd8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60', 'https://images.unsplash.com/photo-1531177071211-ed1b7991958b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60', 'https://images.unsplash.com/photo-1468276311594-df7cb65d8df6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60']
};

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = function debounce(fn, delay) {
  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      statementRequest: {
        resource: 'ag.practitioner.statement.3.1'
      },
      statementTimeout: null,
      statementTimeoutDelay: 1000
    };
  },

  computed: {
    medicalAid: function medicalAid() {
      return this.getObjectPath(this.request, 'result.invoice.medical_aid', null);
    },
    billingContact: function billingContact() {
      return this.getObjectPath(this.request, 'result.invoice.billing.contact', null);
    },
    statementAppointments: function statementAppointments() {
      var statementAppointments = this.getObjectPath(this.statementRequest, 'result.results', null);
      if (!statementAppointments && this.appointments) {
        return this.appointments;
      }
      return statementAppointments;
    },
    statementRequestStatus: function statementRequestStatus() {
      return this.statementRequest.status;
    },
    currency: function currency() {
      if (this.statementAppointments && this.statementAppointments.length > 0) {
        return this.statementAppointments[0].currency;
      }
      return this.defaultCurrency;
    }
  },
  methods: {
    debouncedGetStatement: function debouncedGetStatement() {
      if (this.statementTimeout) {
        window.clearTimeout(this.statementTimeout);
        this.statementTimeout = window.setTimeout(this.getStatement, this.statementTimeoutDelay);
      } else {
        this.statementTimeout = window.setTimeout(this.getStatement, 0);
      }
    },
    getStatement: function getStatement() {
      if (this.appointmentIds && this.appointmentIds.length > 0) {
        var appointmentIds = this.appointmentIds.join(',');
        this.statementRequest.params = {
          appointments: appointmentIds,
          ordering: 'start_time'
        };
        this.$request('get', this.statementRequest);
      } else {
        console.error('this.appointmentIds not defined');
      }
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_application__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_requests_src_store_modules_requests__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_charts__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_clients__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_appointments__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_communications__ = __webpack_require__(563);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);








/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    application: __WEBPACK_IMPORTED_MODULE_2__modules_application__["a" /* default */],
    requests: __WEBPACK_IMPORTED_MODULE_3_vuex_requests_src_store_modules_requests__["a" /* default */],
    charts: __WEBPACK_IMPORTED_MODULE_4__modules_charts__["a" /* default */],
    clients: __WEBPACK_IMPORTED_MODULE_5__modules_clients__["a" /* default */],
    communications: __WEBPACK_IMPORTED_MODULE_7__modules_communications__["a" /* default */],
    appointments: __WEBPACK_IMPORTED_MODULE_6__modules_appointments__["a" /* default */]
  }
}));

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1476),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1410),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1506),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1418),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(981)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1497),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1003)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1550),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1369),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1442),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1383),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(915)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1375),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f0b117c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1394),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1468),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1531),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1413),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1461),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(972)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1482),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(960)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1459),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(886)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1315),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1400),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40a9d0ee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1404),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1392),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1328),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1325),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1372),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(941)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1420),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d081ae0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1360),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(951)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(1444),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(1386),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(1349),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(954)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(747),
  /* template */
  __webpack_require__(1448),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(969)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(1478),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(1399),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(1545),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(958)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(773),
  /* template */
  __webpack_require__(1457),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(966)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(785),
  /* template */
  __webpack_require__(1469),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(985)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(1507),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1536),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(1524),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(801),
  /* template */
  __webpack_require__(1430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(806),
  /* template */
  __webpack_require__(1472),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return globalMessages; });
var globalMessages = {
  message: {
    hello: 'test'
  }
};

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return helpMessages; });
var helpMessages = {
  invoices: {
    quickcreateSaveHelpText: 'When we save this invoice it will move to "in progress".',
    invoiceable: {
      title: 'Invoiceable clients',
      text: 'These are clients you\'ve seen during the active time range.<br/>Clients with a tick may have already been invoiced. <br/>Click the arrow to choose which appointments to invoice them for'
    },
    inProgress: {
      title: 'Invoices in progress',
      text: 'These are invoices that you\'re still working on. You can still edit the details of these appoinments. Click the "send" icon to send this appointment to yourself, or directly to the customer'
    },
    sent: {
      title: 'Sent invoices',
      text: 'Thes are invoices that have already been sent. You can no longer edit them, but your can send them again. Click the tick to mark the invoice as paid'
    },
    quickInvoice: {
      title: 'What is QuickInvoice',
      text: 'QuickInvoice allows you to quickly generate and/or send an invoice for a single appointment'
    }
  }
};

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_multiguru__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_requests_src_store_backends_API__ = __webpack_require__(36);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'APIMixin',
  data: function data() {
    return {
      multiguru: __WEBPACK_IMPORTED_MODULE_1__apis_multiguru__["a" /* multiguru */]
    };
  },

  computed: {
    $multiguru: function $multiguru() {
      var token = this.$store.getters.token;
      var config = {
        baseUrl: "https://multiguru.appointmentguru.co",
        headers: {
          authorization: 'Bearer ' + token
        }
      };
      return this.getAPI('multiguru', config);
    }
  },
  methods: {
    getAPI: function getAPI(name) {
      var _this = this;

      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var api = new __WEBPACK_IMPORTED_MODULE_2_vuex_requests_src_store_backends_API__["a" /* default */](name, this.$store);
      api.baseUrl = __webpack_require__.i({"NODE_ENV":"production-web","APPOINTMENTGURU_API_ROOT":"https://v2.appointmentguru.co","MULTIGURU_API_ROOT":"https://multiguru.appointmentguru.co","METADATAGURU_API_ROOT":"https://metadataguru.appointmentguru.co","INVOICEGURU_API_ROOT":"https://invoiceguru-v2.appointmentguru.co","MEDICALAIDGURU_API_ROOT":"https://medicalaidguru.appointmentguru.co","AUTHENTICATIONGURU_API_ROOT":"https://authguru.appointmentguru.co","CODEGURU_API_ROOT":"https://codeguru.appointmentguru.co","COMMUNICATIONGURU_API_ROOT":"https://unibox.appointmentguru.co","SUBSCRIPTIONGURU_API_ROOT":"https://subscriptionguru.appointmentguru.co/api","CLIENT_ID":"1E10898B-9D2F-43E3-838A-56E203A6EE38","CLIENT_SECRET":"D657BFCB-F7ED-47A5-A976-D47D57540409","APP_NAME":"app.next.web","APP_STYLE":"web","GA_CODE":"UA-93898571-1"})[name.toUpperCase() + '_URL'];
      api.headers = { 'Content-Type': 'application/json' };
      api.resources = function () {
        return _this[name].resources;
      };

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(api, config);

      return api;
    }
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GlobalMixin',
  data: function data() {
    return {
      ignoredStatuses: ['c'],
      appIsReady: false,
      globalappdialogwatcher: 0
    };
  },

  watch: {
    globaldialogvisible: function globaldialogvisible() {
      if (!this.globaldialogvisible) {
        this.globalappdialogwatcher++;
      }
    },
    globalsecondarydialogvisible: function globalsecondarydialogvisible() {
      if (!this.globalsecondarydialogvisible) {
        this.globalappdialogwatcher++;
      }
    },
    globalactivedialog: function globalactivedialog() {
      if (!this.globalactivedialog) {
        this.globalappdialogwatcher++;
      }
    }
  },
  computed: {
    themeColor: function themeColor() {
      return 'orange';
    },
    appPlatform: function appPlatform() {
      return "web";
    },
    isMobileApp: function isMobileApp() {
      return __webpack_require__.i({"NODE_ENV":"production-web","APPOINTMENTGURU_API_ROOT":"https://v2.appointmentguru.co","MULTIGURU_API_ROOT":"https://multiguru.appointmentguru.co","METADATAGURU_API_ROOT":"https://metadataguru.appointmentguru.co","INVOICEGURU_API_ROOT":"https://invoiceguru-v2.appointmentguru.co","MEDICALAIDGURU_API_ROOT":"https://medicalaidguru.appointmentguru.co","AUTHENTICATIONGURU_API_ROOT":"https://authguru.appointmentguru.co","CODEGURU_API_ROOT":"https://codeguru.appointmentguru.co","COMMUNICATIONGURU_API_ROOT":"https://unibox.appointmentguru.co","SUBSCRIPTIONGURU_API_ROOT":"https://subscriptionguru.appointmentguru.co/api","CLIENT_ID":"1E10898B-9D2F-43E3-838A-56E203A6EE38","CLIENT_SECRET":"D657BFCB-F7ED-47A5-A976-D47D57540409","APP_NAME":"app.next.web","APP_STYLE":"web","GA_CODE":"UA-93898571-1"}).MOBILE_APP;
    },
    mobileCardActionsClasses: function mobileCardActionsClasses() {
      if (this.$vuetify.breakpoint.xs) {
        return ['grey', 'darken-2'];
      }
      return [];
    },
    mobileCardActionsStyles: function mobileCardActionsStyles() {
      if (this.$vuetify.breakpoint.xs) {
        return { position: 'fixed', bottom: '0px', left: '0px', right: '0px' };
      }
      return [];
    },
    globaldialogvisible: function globaldialogvisible() {
      return this.$store.state.application.spaces.globalDialog.visible;
    },
    globalsecondarydialogvisible: function globalsecondarydialogvisible() {
      return this.$store.state.application.spaces.secondaryGlobalDialog.visible;
    },
    globalactivedialog: function globalactivedialog() {
      return this.$store.state.application.activeDialog;
    },

    globalSelectedAppointments: {
      get: function get() {
        return this.$store.state.application.selectedAppointments;
      },
      set: function set(val) {
        this.$store.commit('setGlobalSelectedAppointments', val);
      }
    },
    globalSelectedAppointmentIds: function globalSelectedAppointmentIds() {
      return this.globalSelectedAppointments.map(function (appt) {
        return appt.id;
      });
    },
    billingToken: function billingToken() {
      var token = this.getObjectPath(this.$store.getters.me, 'channel');
      if (token) {
        return token.replace('practitioner-', '');
      }
    },
    billingUrl: function billingUrl() {
      var productId = this.getObjectPath(this.$store.getters.me, 'profile.ag_subscription_product_id', 19);
      if (!productId) {
        productId = 19;
      }

      return "https://subscriptionguru.appointmentguru.co/api" + '/pay/' + productId + '/?t=' + this.billingToken;
    },
    showUpgrade: function showUpgrade() {
      var isActive = this.getObjectPath(this.$store.getters.me, 'profile.is_active');
      if (!isActive) {
        return true;
      }
      var converted = this.getObjectPath(this.$store.getters.me, 'profile.conversion_date');
      if (converted) {
        return false;
      }
      var expiry = this.getObjectPath(this.$store.getters.me, 'profile.free_trial_expiry_date');
      var dt = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromISO(expiry);
      var isFreeTrial = dt > __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local();
      if (isFreeTrial) {
        return true;
      }
      return false;
    },
    globalActiveDateRange: function globalActiveDateRange() {
      return this.$store.getters.activeDateRange;
    },
    globalActiveDateRangeFormatted: function globalActiveDateRangeFormatted() {
      var range = this.$store.getters.activeDateRange;
      var format = 'D MMM YYYY';
      return this.dateformat(range.from, format) + ' to ' + this.dateformat(range.to, format);
    },
    me: function me() {
      return this.$store.getters.me;
    },
    meId: function meId() {
      var me = this.$store.getters.me;
      if (me && me.id) {
        return me.id;
      }
    },
    isMedical: function isMedical() {
      if (this.me) {
        return this.getObjectPath(this.me, 'profile.profession.is_medical', true);
      }
      return true;
    },
    hasColleagues: function hasColleagues() {
      if (this.$store.getters.getColleagues && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.getColleagues).length > 1) {
        return true;
      } else {
        return false;
      }
    },
    localeInformation: function localeInformation() {},
    defaultCurrency: function defaultCurrency() {
      return this.getObjectPath(this.$store.getters.settings, 'currency', 'ZAR');
    },
    normalizedClient: function normalizedClient() {
      if (this.client && this.client.client) {
        return this.client.client;
      }
      return this.client;
    }
  },

  methods: {
    logout: function logout() {
      this.$store.commit('LOGOUT_REQUEST');
    },
    goto: function goto(navItem) {
      this.$router.push(navItem.path);
    },
    gotoPath: function gotoPath(path) {
      this.$router.push(path);
    },
    gotoPage: function gotoPage(context, id) {
      var contextMap = {
        invoice: '/invoices/',
        appointment: '/appointments/',
        client: '/clients/'
      };
      if (context in contextMap) {
        var path = contextMap[context] + id;
        this.gotoPath(path);
      } else {
        console.error('Context: ' + context + ' not found in ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(contextMap));
      }
    },
    getPermissions: function getPermissions(practitionerId, spaceId) {
      return [];
    },
    initials: function initials(client) {
      var first = '';
      var last = '';
      if (client) {
        if (client.first_name) {
          first = client.first_name.substr(0, 1);
        }
        if (client.last_name) {
          last = client.last_name.substr(0, 1);
        }
        if (client.full_name) {
          var bits = client.full_name.split(' ');
          if (bits.length > 0) {
            first = bits[0].substr(0, 1);
          }
          if (bits.length > 1) {
            last = bits[1].substr(0, 1);
          }
        }
      }
      return ('' + first + last).toUpperCase();
    },
    getProfilePicture: function getProfilePicture(practitioner) {
      if (practitioner) {
        var url = this.getObjectPath(practitioner, 'profile.profile_picture');
        if (!url) {
          url = this.getObjectPath(practitioner, 'profile_picture');
        }
        if (url) {
          return this.imageKitUrl(url, 'n-avatar_md');
        }
      }
      return null;
    },
    getLogoPicture: function getLogoPicture(item) {
      if (!item) {
        return null;
      }
      var url = item.logo_picture;
      if (!url) {
        url = this.getObjectPath(item, 'profile.logo_picture');
      }
      if (!url) {
        url = this.getObjectPath(item, 'settings.logo_picture');
      }
      if (url) {
        return this.imageKitUrl(url, 'n-avatar_md');
      }
      return null;
    },
    imageKitUrl: function imageKitUrl(url, transform) {
      if (url) {
        var parts = url.split('/practitioner/images/');
        var imgkit = 'https://ik.imagekit.io/appointmentguru/';

        if (parts && parts.length > 1) {
          return imgkit + parts[1] + '?tr=' + transform;
        }
      }
      return url;
    },
    gotoRelationship: function gotoRelationship(id, tab) {
      if (isNaN(id)) {
        id = id.id;
      }
      console.log('goto', id, tab);
      this.$store.dispatch('HIDE_SPACE', 'globalDialog');
      var tabPage = '';
      if (tab) {
        tabPage = '/' + tab;
      }
      this.$router.push('/clients/r/' + id + tabPage);
    },
    gotoClient: function gotoClient(client, tab) {
      this.$emit('close');
      this.$store.dispatch('HIDE_SPACE', 'globalDialog');
      var tabPage = '';
      if (tab) {
        tabPage = '/' + tab;
      }
      if (client && client.client) {
        this.$router.push('/clients/r/' + client.id + tabPage);
      } else {
        console.warn('Invalid client pushed. We expected an id');
        this.$router.push('/clients/' + client.id + tabPage);
      }
    },
    getAppointmentShareLink: function getAppointmentShareLink(appointment) {
      if (appointment && appointment.relationships && appointment.relationships.length === 1) {
        var rel = appointment.relationships[0];
        var path = this.getObjectPath(rel, 'get_absolute_url');
        if (path) {
          return {
            url: 'https://appt.guru/' + path,
            title: 'Appointment Page'
          };
        }
      }
      return null;
    },
    whatsappIt: function whatsappIt(number, text) {
      var url = null;
      var base = 'https://wa.me/';

      if (number) {
        number = number.replace('+', '');
        url = '' + base + number;
      }
      if (text) {
        url = '' + base + number + '?text=' + text;
      }
      return url;
    },
    roleColor: function roleColor(role) {
      if (role) {
        if (role === 'Owner') {
          return 'success';
        }
        if (role === 'Member') {
          return 'grey';
        }
      }
      return 'info';
    },
    mailIt: function mailIt(email, link) {
      if (!this.isRealEmail(email)) {
        email = '';
      }
      var body = link.description + '\n\n' + link.url;
      return 'mailto:' + email + '?subject=' + link.title + '&body=' + body;
    },
    notify: function notify(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'secondary';

      var msg = {
        message: message,
        type: type
      };
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_constants__["A" /* SET_NOTIFICATION */], msg);
    },
    reloadData: function reloadData(requestIds) {},
    getGravatar: function getGravatar(email) {
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;

      var MD5 = function MD5(s) {
        function L(k, d) {
          return k << d | k >>> 32 - d;
        }function K(G, k) {
          var I, d, F, H, x;F = G & 2147483648;H = k & 2147483648;I = G & 1073741824;d = k & 1073741824;x = (G & 1073741823) + (k & 1073741823);if (I & d) {
            return x ^ 2147483648 ^ F ^ H;
          }if (I | d) {
            if (x & 1073741824) {
              return x ^ 3221225472 ^ F ^ H;
            } else {
              return x ^ 1073741824 ^ F ^ H;
            }
          } else {
            return x ^ F ^ H;
          }
        }function r(d, F, k) {
          return d & F | ~d & k;
        }function q(d, F, k) {
          return d & k | F & ~k;
        }function p(d, F, k) {
          return d ^ F ^ k;
        }function n(d, F, k) {
          return F ^ (d | ~k);
        }function u(G, F, aa, Z, k, H, I) {
          G = K(G, K(K(r(F, aa, Z), k), I));return K(L(G, H), F);
        }function f(G, F, aa, Z, k, H, I) {
          G = K(G, K(K(q(F, aa, Z), k), I));return K(L(G, H), F);
        }function D(G, F, aa, Z, k, H, I) {
          G = K(G, K(K(p(F, aa, Z), k), I));return K(L(G, H), F);
        }function t(G, F, aa, Z, k, H, I) {
          G = K(G, K(K(n(F, aa, Z), k), I));return K(L(G, H), F);
        }function e(G) {
          var Z;var F = G.length;var x = F + 8;var k = (x - x % 64) / 64;var I = (k + 1) * 16;var aa = Array(I - 1);var d = 0;var H = 0;while (H < F) {
            Z = (H - H % 4) / 4;d = H % 4 * 8;aa[Z] = aa[Z] | G.charCodeAt(H) << d;H++;
          }Z = (H - H % 4) / 4;d = H % 4 * 8;aa[Z] = aa[Z] | 128 << d;aa[I - 2] = F << 3;aa[I - 1] = F >>> 29;return aa;
        }function B(x) {
          var k = "",
              F = "",
              G,
              d;for (d = 0; d <= 3; d++) {
            G = x >>> d * 8 & 255;F = "0" + G.toString(16);k = k + F.substr(F.length - 2, 2);
          }return k;
        }function J(k) {
          k = k.replace(/rn/g, "n");var d = "";for (var F = 0; F < k.length; F++) {
            var x = k.charCodeAt(F);if (x < 128) {
              d += String.fromCharCode(x);
            } else {
              if (x > 127 && x < 2048) {
                d += String.fromCharCode(x >> 6 | 192);d += String.fromCharCode(x & 63 | 128);
              } else {
                d += String.fromCharCode(x >> 12 | 224);d += String.fromCharCode(x >> 6 & 63 | 128);d += String.fromCharCode(x & 63 | 128);
              }
            }
          }return d;
        }var C = Array();var P, h, E, v, g, Y, X, W, V;var S = 7,
            Q = 12,
            N = 17,
            M = 22;var A = 5,
            z = 9,
            y = 14,
            w = 20;var o = 4,
            m = 11,
            l = 16,
            j = 23;var U = 6,
            T = 10,
            R = 15,
            O = 21;s = J(s);C = e(s);Y = 1732584193;X = 4023233417;W = 2562383102;V = 271733878;for (P = 0; P < C.length; P += 16) {
          h = Y;E = X;v = W;g = V;Y = u(Y, X, W, V, C[P + 0], S, 3614090360);V = u(V, Y, X, W, C[P + 1], Q, 3905402710);W = u(W, V, Y, X, C[P + 2], N, 606105819);X = u(X, W, V, Y, C[P + 3], M, 3250441966);Y = u(Y, X, W, V, C[P + 4], S, 4118548399);V = u(V, Y, X, W, C[P + 5], Q, 1200080426);W = u(W, V, Y, X, C[P + 6], N, 2821735955);X = u(X, W, V, Y, C[P + 7], M, 4249261313);Y = u(Y, X, W, V, C[P + 8], S, 1770035416);V = u(V, Y, X, W, C[P + 9], Q, 2336552879);W = u(W, V, Y, X, C[P + 10], N, 4294925233);X = u(X, W, V, Y, C[P + 11], M, 2304563134);Y = u(Y, X, W, V, C[P + 12], S, 1804603682);V = u(V, Y, X, W, C[P + 13], Q, 4254626195);W = u(W, V, Y, X, C[P + 14], N, 2792965006);X = u(X, W, V, Y, C[P + 15], M, 1236535329);Y = f(Y, X, W, V, C[P + 1], A, 4129170786);V = f(V, Y, X, W, C[P + 6], z, 3225465664);W = f(W, V, Y, X, C[P + 11], y, 643717713);X = f(X, W, V, Y, C[P + 0], w, 3921069994);Y = f(Y, X, W, V, C[P + 5], A, 3593408605);V = f(V, Y, X, W, C[P + 10], z, 38016083);W = f(W, V, Y, X, C[P + 15], y, 3634488961);X = f(X, W, V, Y, C[P + 4], w, 3889429448);Y = f(Y, X, W, V, C[P + 9], A, 568446438);V = f(V, Y, X, W, C[P + 14], z, 3275163606);W = f(W, V, Y, X, C[P + 3], y, 4107603335);X = f(X, W, V, Y, C[P + 8], w, 1163531501);Y = f(Y, X, W, V, C[P + 13], A, 2850285829);V = f(V, Y, X, W, C[P + 2], z, 4243563512);W = f(W, V, Y, X, C[P + 7], y, 1735328473);X = f(X, W, V, Y, C[P + 12], w, 2368359562);Y = D(Y, X, W, V, C[P + 5], o, 4294588738);V = D(V, Y, X, W, C[P + 8], m, 2272392833);W = D(W, V, Y, X, C[P + 11], l, 1839030562);X = D(X, W, V, Y, C[P + 14], j, 4259657740);Y = D(Y, X, W, V, C[P + 1], o, 2763975236);V = D(V, Y, X, W, C[P + 4], m, 1272893353);W = D(W, V, Y, X, C[P + 7], l, 4139469664);X = D(X, W, V, Y, C[P + 10], j, 3200236656);Y = D(Y, X, W, V, C[P + 13], o, 681279174);V = D(V, Y, X, W, C[P + 0], m, 3936430074);W = D(W, V, Y, X, C[P + 3], l, 3572445317);X = D(X, W, V, Y, C[P + 6], j, 76029189);Y = D(Y, X, W, V, C[P + 9], o, 3654602809);V = D(V, Y, X, W, C[P + 12], m, 3873151461);W = D(W, V, Y, X, C[P + 15], l, 530742520);X = D(X, W, V, Y, C[P + 2], j, 3299628645);Y = t(Y, X, W, V, C[P + 0], U, 4096336452);V = t(V, Y, X, W, C[P + 7], T, 1126891415);W = t(W, V, Y, X, C[P + 14], R, 2878612391);X = t(X, W, V, Y, C[P + 5], O, 4237533241);Y = t(Y, X, W, V, C[P + 12], U, 1700485571);V = t(V, Y, X, W, C[P + 3], T, 2399980690);W = t(W, V, Y, X, C[P + 10], R, 4293915773);X = t(X, W, V, Y, C[P + 1], O, 2240044497);Y = t(Y, X, W, V, C[P + 8], U, 1873313359);V = t(V, Y, X, W, C[P + 15], T, 4264355552);W = t(W, V, Y, X, C[P + 6], R, 2734768916);X = t(X, W, V, Y, C[P + 13], O, 1309151649);Y = t(Y, X, W, V, C[P + 4], U, 4149444226);V = t(V, Y, X, W, C[P + 11], T, 3174756917);W = t(W, V, Y, X, C[P + 2], R, 718787259);X = t(X, W, V, Y, C[P + 9], O, 3951481745);Y = K(Y, h);X = K(X, E);W = K(W, v);V = K(V, g);
        }var i = B(Y) + B(X) + B(W) + B(V);return i.toLowerCase();
      };

      return 'http://www.gravatar.com/avatar/' + MD5(email) + '.jpg?s=' + size;
    },
    setGlobalActiveDateRange: function setGlobalActiveDateRange(from, to) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_constants__["v" /* SET_ACTIVE_DATE_RANGE */], [from, to]);
    },
    setGlobalActiveDate: function setGlobalActiveDate(date) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_constants__["j" /* SET_SETTING */], ['activeDate', date]);
    },
    setClientFromId: function setClientFromId(clientId) {
      return this.$store.getters.clients.find(function (client) {
        if (client && client.client && client.client.id) {
          return client.client.id.toString() === clientId.toString();
        }
      });
    },
    clientHasContacts: function clientHasContacts(client) {
      if (client) {
        return client.phone_number || this.isRealEmail(client.email);
      }
      return false;
    },
    isRealEmail: function isRealEmail(email) {
      if (!email) {
        return false;
      }

      if (email.endsWith('@appointmentguru.co')) {
        if (email.startsWith('+')) {
          return false;
        }

        var bits = email.split('@');
        if (bits.length < 2) {
          return false;
        }
        if (bits[0].length === 36) {
          return false;
        }

        if (bits[0].length === 41 && bits[0].startsWith('user+')) {
          return false;
        }
      }
      return true;
    },
    openGlobalDialog: function openGlobalDialog(isOpen, component, options) {
      if (isOpen === false) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_constants__["H" /* SHOW_APPOINTMENT_DIALOG */], [false]);
      } else {
        var args = [true, component];
        if (options) {
          if (options.appointment) {
            args.push(options.appointment);
          }
        }
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_constants__["H" /* SHOW_APPOINTMENT_DIALOG */], args);
      }
    },
    launchClientSearch: function launchClientSearch() {
      var options = {
        showListInitially: true,
        withCreate: false,
        withWhatsApp: true,
        touch: Math.random()
      };
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'ClientList', 'Find a client', options, { relationshipselected: this.gotoRelationship }, fullscreen]);
    },
    launchCloneAppointment: function launchCloneAppointment(options) {
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'CloneAppointment', 'Close appointment', options, { clientselected: this.gotoClient }, true]);
    },
    launchDateRangePicker: function launchDateRangePicker() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_constants__["D" /* ACTIVATE_RANGE_PICKER */]);
    },
    launchCreateAppointment: function launchCreateAppointment() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options.touch = Math.random();
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'AppointmentQuickCreate', 'New appointment', options, actions, true]);
    },
    launchAppointmentPicker: function launchAppointmentPicker() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.$store.dispatch('SET_SPACE', ['globalDialog', 'AppointmentPicker', 'Choose appointments', options, actions, false]);
    },
    launchSetAppointmentClient: function launchSetAppointmentClient() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var touch = Math.random();
      options.touch = touch;
      console.log(touch);
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'SetClient', 'Set the client for this appointment', options, actions, false]);
    },
    launchMakeAppointmentOnline: function launchMakeAppointmentOnline() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.$store.dispatch('SET_SPACE', ['globalDialog', 'MakeAppointmentOnline', 'Make appointment an online appointment', options, actions, true]);
    },
    launchShareDialog: function launchShareDialog() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.$store.dispatch('SET_SPACE', ['globalDialog', 'ShareCard', 'Quick share', options, actions, this.$vuetify.breakpoint.xs]);
    },
    launchAppointmentSendMessage: function launchAppointmentSendMessage() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options.templateContext = 'Appointment';
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'SendTemplate', 'Send a message', options, actions, true]);
    },
    launchAppointmentTags: function launchAppointmentTags() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.$store.dispatch('SET_SPACE', ['globalDialog', 'AppointmentTags', 'Add tags', options, actions, false]);
    },
    launchDiagnosisCodes: function launchDiagnosisCodes() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options.touch = Math.random();
      this.$store.dispatch('SET_SPACE', ['secondaryGlobalDialog', 'AppointmentCodes', 'Add codes', options, actions, this.$vuetify.breakpoint.xsOnly]);
    },
    launchAppointmentProduct: function launchAppointmentProduct() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options.touch = Math.random();
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'AppointmentProduct', 'Add product sales', options, actions, this.$vuetify.breakpoint.xsOnly]);
    },
    launchAppointmentPaymentDialog: function launchAppointmentPaymentDialog(options) {
      if (!options) {
        options = {};
      }
      options.touch = Math.random();
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'Payment', 'Record a payment', options, {}, true]);
    },
    launchPaymentDialog: function launchPaymentDialog(options) {
      if (!options) {
        options = {};
      }
      options.componentName = 'Payment';
      options.touch = Math.random();
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'AppointmentAction', 'Record a payment', options, {}, true]);
    },
    launchInvoiceDetailsDialog: function launchInvoiceDetailsDialog(appointment) {
      var withCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var options = {
        appointment: appointment,
        withCreate: withCreate
      };
      this.openGlobalDialog(true, 'InvoiceDetails', options);
    },
    launchSnapDialog: function launchSnapDialog(options) {
      options.touch = Math.random();
      options.withDone = false;
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'SnapCode', 'Scan to pay', options, {}, false]);
    },
    launchSendInvoiceDialog: function launchSendInvoiceDialog(options) {
      options.withClose = true;
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'SendInvoice', 'Send', options, {}, this.$vuetify.breakpoint.xsOnly]);
    },
    launchSendToMedicalAidDialog: function launchSendToMedicalAidDialog(options) {
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'SendToMedicalAid', 'Send to medical aid', options, {}, this.$vuetify.breakpoint.xsOnly]);
    },
    launchQuickInvoiceDialog: function launchQuickInvoiceDialog(options) {
      if (!options.touch) {
        options.touch = Math.random();
      }

      this.$store.dispatch('SET_SPACE', ['globalDialog', 'InvoiceQuickCreate', 'Create an invoice or receipt', options, {}]);
    },
    launchInvoiceDialog: function launchInvoiceDialog(options) {
      var component = 'AppointmentAction';

      options.touch = Math.floor(Math.random() * 1000000);
      options.componentName = 'CreateInvoice';
      options.relationship = null;
      options.initialRelationship = null;
      if (options.relationshipId) {
        var rel = this.getRelationById(options.relationshipId);
        if (rel) {
          options.initialRelationship = rel;
          options.relationship = rel;
        }
      }

      this.$store.dispatch('SET_SPACE', ['globalDialog', component, 'Create an invoice', options, {}]);
    },
    launchInvoiceSettingsDialog: function launchInvoiceSettingsDialog(_ref) {
      var spaceId = _ref.spaceId,
          settings = _ref.settings;

      var options = {
        spaceId: spaceId,
        value: settings,
        touch: Math.random()
      };
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'InvoiceSettings', 'Invoice Settings', options, {}, this.$vuetify.breakpoint.xs]);
    },
    launchNewClientDialog: function launchNewClientDialog() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      options.withHeader = false;
      this.$store.dispatch('SET_SPACE', ['globalDialog', 'Client', 'Create a customer', options, {}]);
    },
    launchCustomerDetailsDialog: function launchCustomerDetailsDialog(relationshipId) {
      var withContactDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var tab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var options = {
        fetch: true,
        touch: Math.random(),
        withContactDetails: withContactDetails,
        withHeader: false,
        withDone: true,
        activeTab: tab,
        relationshipId: relationshipId
      };
      this.$store.dispatch('SET_SPACE', ['secondaryGlobalDialog', 'PatientInformationForm', 'Customer Information', options, {}]);
    },
    formatnumber: function formatnumber(val, isCurrency, currency) {
      var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'en-ZA';

      var options = {};
      if (isCurrency) {
        var defaultCurrency = this.defaultCurrency;
        if (!currency) {
          currency = defaultCurrency;
        }
        options = { style: 'currency', currency: currency };
      }
      return new Intl.NumberFormat(locale, options).format(val);
    },
    getLuxon: function getLuxon() {
      return __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"];
    },
    luxonDateformat: function luxonDateformat(isoDateString, format) {
      var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';

      if (!isoDateString) {
        isoDateString = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local().toISO();
      }
      var dt = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromISO(isoDateString);
      if (format) {
        return dt.setLocale(locale).toFormat(format);
      }
      return dt.toHTTP();
    },
    dateformat: function dateformat(dateString, format) {
      if (!dateString) {
        dateString = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      }
      if (!format) {
        format = 'ddd DD MMM YYYY';
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateString).format(format);
    },
    setPageLoading: function setPageLoading(isTrue) {
      this.$store.state.application.pageLoading = isTrue;
    },
    naturalday: function naturalday(date) {
      var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).calendar(today, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'ddd D MMM '
      });
    },
    formatFromTo: function formatFromTo(from, to) {
      var day = this.dateformat(from, 'ddd D MMM YYYY');
      var startTime = this.dateformat(from, 'H:mma');
      var endTime = this.dateformat(to, 'H:mma');
      return day + ', ' + startTime + ' - ' + endTime;
    },
    formatStatus: function formatStatus(statusCode) {
      try {
        var status = __WEBPACK_IMPORTED_MODULE_3__store_constants__["m" /* STATUSES */][statusCode];
        if (!status) {
          return {
            title: 'unknown'
          };
        }
        return status;
      } catch (e) {
        return {};
      }
    },
    appointmentTitle: function appointmentTitle(appt) {
      if (appt.title) {
        return appt.title;
      }
      if (appt.full_name) {
        return appt.full_name;
      }
      return 'Appointment';
    },
    formatFullName: function formatFullName(user) {
      var name = null;
      if (user) {
        if (user.full_name) {
          return user.full_name;
        }
        if (user.first_name) {
          name = user.first_name;
        }
        if (user.last_name) {
          name += ' ' + user.last_name;
        }
        if (name) {
          return name;
        }
      }
      if (user && user.client) {
        if (user.client.first_name) {
          name = user.client.first_name;
        }
        if (user.client.last_name) {
          name += ' ' + user.client.last_name;
        }
        if (name) {
          return name;
        }
      }
      return name;
    },
    formatCurrency: function formatCurrency(currency, number) {
      var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-ZA';

      if (!currency) {
        currency = this.defaultCurrency;
      }
      if (currency) {
        var formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency
        });
        return formatter.format(number);
      } else {
        return number;
      }
    },
    timeStringToMoment: function timeStringToMoment(timeString, dt) {
      if (!timeString) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      }
      if (timeString.endsWith('am')) {
        timeString = timeString.substr(0, timeString.length - 2);
      }
      if (timeString.endsWith('pm')) {
        var bits = timeString.split(':');
        var hour = parseInt(bits[0]) + 12;
        var mins = bits[1].substr(0, bits[1].length - 2);
        timeString = hour + ':' + mins;
      }
      if (timeString.length === 4) {
        timeString = '0' + timeString;
      }
      if (!dt) {
        dt = this.date;
        if (!this.date) {
          dt = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
        }
      }
      dt = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dt).format('YYYY-MM-DD');
      var dateString = dt + ' ' + timeString;
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateString);
    },
    getClientById: function getClientById(id) {
      var client = this.$store.getters.clients.find(function (client) {
        return parseInt(client.client.id) === parseInt(id);
      });
      if (!client) {
        return {};
      }
      if (client.client) {
        return client.client;
      }
      return client;
    },
    getRelationByClientId: function getRelationByClientId(id) {
      console.log('looking up with clientid :(');
      var client = this.$store.getters.clients.find(function (client) {
        return parseInt(client.client.id) === parseInt(id);
      });
      if (!client) {
        return {};
      }
      return client;
    },
    getRelationById: function getRelationById(id) {
      try {
        console.log('client found with id');
        return this.$store.state.clients.objects[id];
      } catch (err) {
        console.log(err);
      }
      console.log('id lookup failed, searching array');
      var client = this.$store.getters.clients.find(function (client) {
        if (client && client.id && id) {
          return client.id.toString() === id.toString();
        }
      });
      if (!client) {
        return {};
      }
      return client;
    },
    idsAreEqual: function idsAreEqual(id1, id2, verbose) {
      if (id1 === null || id2 === null) {
        return false;
      }
      var result = parseInt(id1) === parseInt(id2);
      if (verbose) {
        console.log(id1, id2, result);
      }
      return result;
    },
    getObjectPath: function getObjectPath(object, path, defaultResponse) {
      if (object) {
        var bits = path.split('.');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(bits), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            try {
              if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(object).indexOf(key) !== -1) {
                object = object[key];
              } else {
                return defaultResponse;
              }
            } catch (e) {
              if (e instanceof TypeError) {
                return defaultResponse;
              }
              throw e;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return object;
      }
      return defaultResponse;
    },
    getProductById: function getProductById(id, expand) {
      var me = this.$store.getters.me;
      if (me && me.profile && me.profile.services) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(me.profile.services), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var service = _step2.value;

            if (service && service.products) {
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(service.products), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var product = _step3.value;

                  if (product.id === id) {
                    if (expand) {
                      product.serviceData = {
                        id: service.id,
                        hours: service.hours,
                        address: service.address
                      };
                    }
                    return product;
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return {};
    }
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);







var SERVICES = {
  authenticationguru: "https://authguru.appointmentguru.co",
  appointmentguru: "https://v2.appointmentguru.co",
  unibox: "https://unibox.appointmentguru.co",
  invoiceguru: "https://invoiceguru-v2.appointmentguru.co",
  metadataguru: "https://metadataguru.appointmentguru.co"
};

var RESOURCE = {
  'auth.login': {
    base: SERVICES.authenticationguru,
    path: '/login/'
  },
  'auth.headers': {
    base: SERVICES.authenticationguru,
    path: '/headers/'
  },
  'auth.session': {
    base: SERVICES.authenticationguru,
    path: '/session/'
  },
  'auth.logout': {
    base: SERVICES.authenticationguru,
    path: '/logout/'
  },
  'ag.auth': {
    base: SERVICES.appointmentguru,
    path: '/api/auth/'
  },

  'ag.user': {
    base: SERVICES.appointmentguru,
    path: '/api/users/'
  },
  'ag.auth.session': {
    base: SERVICES.appointmentguru,
    path: '/api/auth/session/'
  },
  'ag.practitioner.me': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/practitioners/me/'
  },
  'ag.practitioner': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/practitioners/'
  },
  'ag.practitioner.me.profile': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/me/profile/'
  },
  'ag.appointments': {
    base: SERVICES.appointmentguru,
    path: '/api/appointments/'
  },
  'ag.practitioner.appointments': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/appointments/'
  },
  'ag.practitioner.calendars': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/calendars/'
  },
  'ag.practitioner.statement': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/statement/'
  },
  'ag.practitioner.statement.3.1': {
    base: SERVICES.appointmentguru,
    path: '/api/v3-1/practitioner/statement/'
  },
  'ag.practitioner.rules': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/rules/'
  },
  'ag.spaces.practitioner.v2': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/services/'
  },
  'ag.spaces.practitioner': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/spaces/'
  },
  'ag.clients': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/clients/'
  },
  'ag.v3.clients': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/clients/'
  },
  'ag.spaces.relationships': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/relationships/',
    detailMutation: 'addClientDetail'
  },
  'ag.spaces.forms': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/forms/'
  },
  'ag.spaces.settings': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/:spaceId/settings/'
  },
  'ag.settings.messages': {
    base: SERVICES.appointmentguru,
    path: '/api/practitioners/settings/messages/'
  },
  'ag.spaces.members': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/:spaceId/members/'
  },
  'ag.spaces.appointmenttypes': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/:spaceId/appointment-types/'
  },
  'ag.spaces.addresses': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/:spaceId/addresses/'
  },
  'ag.spaces': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/'
  },
  'ag.addresses': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/address/'
  },
  'ag.integrations': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/integrations/'
  },
  'ag.integrations.setmore': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/integrations/setmore/'
  },
  'ag.codes': {
    base: SERVICES.appointmentguru,
    path: '/api/appointments/codes/'
  },
  'ag.codes.bulk': {
    base: SERVICES.appointmentguru,
    path: '/api/appointments/bulk/'
  },

  'unibox.templates': {
    base: SERVICES.unibox,
    path: '/templates/'
  },
  'unibox.comms': {
    base: SERVICES.unibox,
    path: '/api/v2/communications/'
  },

  'invoiceguru.transactions': {
    base: SERVICES.invoiceguru,
    path: '/transactions/'
  },
  'invoiceguru.invoices': {
    base: SERVICES.invoiceguru,
    path: '/invoices/'
  },
  'metadataguru.notes': {
    base: SERVICES.metadataguru,
    path: '/v3/notes/'
  }
};

function getUrl(resource) {
  var resourceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var actionId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var kwargs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  if (!(resource in RESOURCE)) {
    console.error(resource + ' not found in RESOURCE');
    console.error(RESOURCE);
  }
  var config = RESOURCE[resource];

  if (!('base' in config)) {
    console.error('base not defined in config: ', config);
  }
  var resourceUrl = '' + config.base + config.path;

  if (resourceId) {
    resourceUrl += resourceId + '/';
  }
  if (actionId) {
    resourceUrl += 'actions/' + actionId + '/';
  }
  if (extra) {
    resourceUrl += extra + '/';
  }
  if (kwargs) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(kwargs).forEach(function (k) {
      resourceUrl = resourceUrl.replace(':' + k, kwargs[k]);
    });
  }
  return resourceUrl;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      $RESOURCES: RESOURCE,
      httpDebounceTimeout: null
    };
  },

  methods: {
    requestAuthHeaders: function requestAuthHeaders() {
      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var headers = {
        'content-type': 'application/json'
      };
      console.log(service);
      if (this.$store.getters.token) {
        headers['authorization'] = 'Bearer ' + this.$store.getters.token;
      }
      return headers;
    },
    makeRequest: function makeRequest(config, options) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'loading', true);
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'status', '0');
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'errors', {});

                if (options.params) {
                  options.params = new URLSearchParams(options.params);
                }
                if (config.resource && config.resource.startsWith('auth.')) {
                  options.withCredentials = true;
                  options.headers['X-CSRFToken'] = _this.$cookies.get('_csrftoken');
                }
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default()(options);

              case 8:
                res = _context.sent;

                if (res && res.status) {
                  if (res.status > 199) {
                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'result', res.data);
                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'headers', res.headers);
                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'status', res.status);
                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'error', false);
                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'loading', false);
                    if (RESOURCE[config.resource].detailMutation) {
                      if (config.resourceId && !config.extra) {
                        _this.$store.commit(RESOURCE[config.resource].detailMutation, res.data);
                      }
                    }
                  }
                }
                return _context.abrupt('return', res);

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                if (_context.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'errors', _context.t0.response.data);
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'status', _context.t0.response.status);

                  if (_context.t0.response.status === 401) {
                    if (_context.t0.response.detail === 'Authentication credentials were not provided.') {
                      console.log('user is logged out');
                      _this.$store.commit('LOGIN_CHALLENGE');
                    }
                  }
                } else if (_context.t0.request) {
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'errors', { message: 'Server error occured' });
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'status', 500);
                } else {
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'status', 500);
                }
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'error', true);
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'loading', false);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    },
    $request: function $request(action, config) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(config, 'actionMethod', action);

                if (!(action === 'get')) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', _this2.__fetch(config));

              case 3:
                if (!(action === 'save')) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return', _this2.__save(config));

              case 5:
                if (!(action === 'delete')) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', _this2.__delete(config));

              case 7:
                console.error(action + ' is not a supported action. Try: \'get\', \'save\' or \'delete\'');

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    __fetch: function __fetch(config) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url, headers, method, params, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = getUrl(config.resource, config.resourceId, null, config.extra, config.kwargs);
                headers = _this3.requestAuthHeaders();
                method = 'get';
                params = {};

                if (config.params) {
                  params = config.params;
                }
                options = { url: url, headers: headers, method: method, params: params };
                return _context3.abrupt('return', _this3.makeRequest(config, options));

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    __delete: function __delete(config) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var url, headers, method, params, data, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = getUrl(config.resource, config.resourceId, null, config.extra, config.kwargs);
                headers = _this4.requestAuthHeaders();
                method = 'delete';
                params = {};

                if (config.params) {
                  params = config.params;
                }
                data = {};

                if (config.data) {
                  data = config.data;
                }
                options = { url: url, headers: headers, method: method, params: params, data: data };
                return _context4.abrupt('return', _this4.makeRequest(config, options));

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    __save: function __save(config) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var url, headers, method, params, data, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                url = getUrl(config.resource, config.resourceId, null, config.extra, config.kwargs);
                headers = _this5.requestAuthHeaders();
                method = 'post';

                if (config.resourceId) {
                  method = 'patch';
                }
                if (config.method) {
                  method = config.method;
                }
                params = {};

                if (config.params) {
                  params = config.params;
                }
                data = {};

                if (config.data) {
                  data = config.data;
                }
                options = { url: url, headers: headers, method: method, params: params, data: data };
                return _context5.abrupt('return', _this5.makeRequest(config, options));

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getAction: function getAction(config) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', _this6.performAction(config, {}, 'get'));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    }
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACTIONS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var OWNER = 'Owner';

var ACTIONS = {
  CANCEL_APPOINTEMNT: 'cancel',
  CREATE_APPOINTMENT: 'create_appointment',
  RESCHEDULE_APPOINTMENT: 'reschedule',
  BULK_DELETE_APPOINTMENT: 'bulk_delete',
  BULK_ADD_CODES_TO_APPOINTMENT: 'bulk_add_codes',
  BULK_ADD_PRODUCTS: 'bulk_add_products',
  BULK_CANCEL_APPOINTMENT: 'bulk_cancel',

  CREATE_INVOICE: 'create_invoice',
  BULK_ADD_PAYMENT: 'bulk_add_payment',
  BULK_ADD_CODES: 'bulk_add_codes'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    permissionsCanCreateInvoice: function permissionsCanCreateInvoice() {
      return this.hasPermission(ACTIONS.CREATE_INVOICE, this.spaceIds, this.globalSelectedAppointments);
    },
    permissionsCanBulkAddPayment: function permissionsCanBulkAddPayment() {
      return this.hasPermission(ACTIONS.BULK_ADD_PAYMENT, this.spaceIds, this.globalSelectedAppointments);
    },
    permissionsCanBulkAddCodes: function permissionsCanBulkAddCodes() {
      return this.hasPermission(ACTIONS.BULK_ADD_CODES, this.spaceIds, this.globalSelectedAppointments);
    },
    infoTeamCount: function infoTeamCount() {
      var team = this.$store.getters.getColleagues;
      if (team) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(team);
        if (keys) {
          return keys.length;
        }
      }
      return 0;
    },
    infoIsTeamAccount: function infoIsTeamAccount() {
      return this.infoTeamCount > 1;
    }
  },
  methods: {
    normalizedPractitionerId: function normalizedPractitionerId(appt) {
      var id = this.getObjectPath(appt, 'practitioner');
      if (!id) {
        id = this.getObjectPath(appt, 'practitioner_id');
      }
      if (id) {
        if (isNaN(id)) {
          id = parseInt(id.id);
        } else {
          id = parseInt(id);
        }
      }
      return id;
    },
    permissionsCanCreateInvoiceMethod: function permissionsCanCreateInvoiceMethod(spaceIds, appointments) {
      return this.hasPermission(ACTIONS.CREATE_INVOICE, spaceIds, appointments);
    },
    rolesIsOwnerOfSpace: function rolesIsOwnerOfSpace(spaceId) {
      var space = this.$store.getters.getSpaceById(spaceId);
      if (space) {
        if (space.membership_active === false) {
          return false;
        }
        if (space.role === OWNER) {
          return true;
        }
      }
      return false;
    },
    hasPermission: function hasPermission(action, spaceIds, appointments) {
      var _this = this;

      if (appointments && appointments.length > 0) {
        var actorId = this.meId;
        if (actorId) {
          var ownsAllAppointments = appointments.every(function (appt) {
            var apptPractitionerId = _this.normalizedPractitionerId(appt);
            if (!apptPractitionerId) {
              return false;
            }

            return apptPractitionerId === parseInt(actorId);
          });
          if (ownsAllAppointments) {
            return true;
          }
        }
      }

      if (spaceIds && spaceIds.length > 0) {
        return spaceIds.every(function (spaceId) {
          var space = _this.$store.getters.getSpaceById(spaceId);
          if (space) {
            if (!space.membership_active) {
              return false;
            }
            if (space.role === OWNER) {
              return true;
            }

            if (space.enabled_actions && space.enabled_actions.length > 0) {
              return space.enabled_actions.indexOf(action) !== -1;
            }
          }
          return false;
        });
      }
      return false;
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backends_appointmentguru__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backends_metadataguru__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backends_invoiceguru__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__backends_authenticationguru__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__backends_medicalaidguru__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__backends_communicationguru__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__backends_codeguru__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__backends_subscriptionguru__ = __webpack_require__(558);










/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */],
  install: function install(Vue, options) {
    Vue.prototype.$env = __webpack_require__.i({"NODE_ENV":"production-web","APPOINTMENTGURU_API_ROOT":"https://v2.appointmentguru.co","MULTIGURU_API_ROOT":"https://multiguru.appointmentguru.co","METADATAGURU_API_ROOT":"https://metadataguru.appointmentguru.co","INVOICEGURU_API_ROOT":"https://invoiceguru-v2.appointmentguru.co","MEDICALAIDGURU_API_ROOT":"https://medicalaidguru.appointmentguru.co","AUTHENTICATIONGURU_API_ROOT":"https://authguru.appointmentguru.co","CODEGURU_API_ROOT":"https://codeguru.appointmentguru.co","COMMUNICATIONGURU_API_ROOT":"https://unibox.appointmentguru.co","SUBSCRIPTIONGURU_API_ROOT":"https://subscriptionguru.appointmentguru.co/api","CLIENT_ID":"1E10898B-9D2F-43E3-838A-56E203A6EE38","CLIENT_SECRET":"D657BFCB-F7ED-47A5-A976-D47D57540409","APP_NAME":"app.next.web","APP_STYLE":"web","GA_CODE":"UA-93898571-1"});
    Vue.prototype.$store = __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */];
    Vue.prototype.$appointmentguru = new __WEBPACK_IMPORTED_MODULE_1__backends_appointmentguru__["a" /* default */]('appointmentguru', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
    Vue.prototype.$metadataguru = new __WEBPACK_IMPORTED_MODULE_2__backends_metadataguru__["a" /* default */]('metadataguru', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
    Vue.prototype.$invoiceguru = new __WEBPACK_IMPORTED_MODULE_3__backends_invoiceguru__["a" /* default */]('invoiceguru', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
    Vue.prototype.$authenticationguru = new __WEBPACK_IMPORTED_MODULE_4__backends_authenticationguru__["a" /* default */]('authenticationguru', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
    Vue.prototype.$medicalaidguru = new __WEBPACK_IMPORTED_MODULE_5__backends_medicalaidguru__["a" /* default */]('medicalaidguru', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
    Vue.prototype.$communicationguru = new __WEBPACK_IMPORTED_MODULE_6__backends_communicationguru__["a" /* default */]('communicationguru', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
    Vue.prototype.$codeguru = new __WEBPACK_IMPORTED_MODULE_7__backends_codeguru__["a" /* default */]('codeguru', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
    Vue.prototype.$subscriptionguru = new __WEBPACK_IMPORTED_MODULE_8__backends_subscriptionguru__["a" /* default */]('subscriptionguru', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
  }
});

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
  __webpack_require__(931)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1406),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(978)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1490),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1000)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1546),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1427),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(986)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1508),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */,
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1368),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1403),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1487),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(896)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1338),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1643540f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1503),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(1320),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(781),
  /* template */
  __webpack_require__(1373),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reqId: 'integrations-list',
      connectReqId: 'integrations-connect-zoom'
    };
  },

  computed: {
    oauthUrl: function oauthUrl() {
      return 'https://api.appointmentguru.co/integrations/zoom/';
    },
    integration: function integration() {
      var lookups = this.$store.getters.lookups;
      if ('integrations' in lookups) {
        return lookups.integrations.find(function (integration) {
          return integration.title === 'Zoom';
        });
      }
      return null;
    },
    integrationsRequest: function integrationsRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    oAuthCode: function oAuthCode() {
      if (this.$route.query.code) {
        return this.$route.query.code;
      }
      var qs = this.getQueryString();
      if ('code' in qs) {
        return qs.code;
      }
      return null;
    }
  },
  methods: {
    getIntegrations: function getIntegrations() {
      this.$appointmentguru.resource('practitioner.integrations').list();
    },
    getQueryString: function getQueryString() {
      var pairs = window.location.search.slice(1).split('&');
      var result = {};
      pairs.forEach(function (pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
      });
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
    },
    connectToZoom: function connectToZoom() {
      var data = {
        auth_code: this.oAuthCode
      };
      this.$appointmentguru.resource('practitioner.integrations.zoom').id(this.connectReqId).create(data);
    }
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MERGE_TAGS; });
var MERGE_TAGS = [{ key: 'title', text: 'Appointment title', example: 'Peter Parker', tags: ['appointment'] }, { key: 'start_time', text: 'Appointment starttime', example: '2020-01-17T11:00:00Z', tags: ['appointment'] }, { key: 'end_time', text: 'Appointment endtime', example: '2020-01-17T12:00:00Z', tags: ['appointment'] }, { key: 'currency', text: 'Appointment currency', example: 'ZAR', tags: ['appointment'] }, { key: 'price', text: 'Appointment price', example: '0.00', tags: ['appointment'] }, { key: 'notes', text: 'Appointment notes', example: '', tags: ['appointment'] }, { key: 'status_formatted', text: 'Appointment status', example: 'New', tags: ['appointment'] }, { key: 'created_date', text: 'Date appointment was created', example: '2020-01-14T07:46:48.923047Z', tags: ['appointment'] }, { key: 'practitioner.profile.practice_name', text: 'Practice name', example: 'AppointmentGuru', tags: ['appointment'] }, { key: 'practitioner.profile.practice_number', text: 'Practice_number', example: '', tags: ['appointment'] }, { key: 'practitioner.profile.profession.name', text: 'Practitioner profession.', example: 'AppointmentGuru Consultant', tags: ['appointment'] }, { key: 'practitioner.profile.user.first_name', text: 'Practitioner first name', example: 'Christo', tags: ['appointment'] }, { key: 'practitioner.profile.user.last_name', text: 'Practitioner last name', example: 'Crampton', tags: ['appointment'] }, { key: 'practitioner.profile.user.email', text: 'Practitioner email', example: 'christo@appointmentguru.co', tags: ['appointment'] }, { key: 'practitioner.profile.user.phone_number', text: 'Practitioner phone number', example: '+27832566533', tags: ['appointment'] }, { key: 'client.first_name', text: 'Client first name', example: 'Gary', tags: ['appointment'] }, { key: 'client.last_name', text: 'Client last name', example: 'Calitz', tags: ['appointment'] }, { key: 'client.email', text: 'Client email', example: 'gc.biokinetics@yahoo.co.za', tags: ['appointment'] }, { key: 'client.phone_number', text: 'Client phone', example: '+27272273791', tags: ['appointment'] }, { key: 'space.title', text: 'Space title', example: 'AppointmentGuru HQ', tags: ['appointment'] }, { key: 'appointment_type.title', text: 'Appointment type title', example: 'Meeting', tags: ['appointment'] }, { key: 'appointment_type.description', text: 'Appointment type description', example: 'Let\'s get together for a coffee and chat!', tags: ['appointment'] }, { key: 'appointment_type.duration', text: 'Appointment type duration', example: '60', tags: ['appointment'] }, { key: 'appointment_type.currency', text: 'Appointment type currency', example: 'ZAR', tags: ['appointment'] }, { key: 'appointment_type.price', text: 'Appointment type price', example: '1000.00', tags: ['appointment'] }, { key: 'appointment_type.notification_text', text: 'Appointment type notification information', example: '', tags: ['appointment'] }, { key: 'address.name', text: 'Address name', example: 'AppointmentGuru', tags: ['appointment'] }, { key: 'address.notes', text: 'Address notes', example: 'Ring the doorbell.', tags: ['appointment'] }, { key: 'address.latitude', text: 'Address latitude', example: '-26.13496', tags: ['appointment'] }, { key: 'address.longitude', text: 'Address longitude', example: '28.022760000000062', tags: ['appointment'] }, { key: 'address.place_id', text: 'Address Google place id', example: '5fc60bd92591dd8dbbae01fed0ffe0fb2da1c87f', tags: ['appointment'] }, { key: 'address.address', text: 'Address', example: '64 2nd Ave, Randburg, 2193, South Africa', tags: ['appointment'] }, { key: 'financials.appointment_unit_price', text: 'Appointment unit price', example: '0.00', tags: ['appointment'] }, { key: 'financials.products_total_price', text: 'Appointment product cost', example: '0', tags: ['appointment'] }, { key: 'financials.payments_received', text: 'Appointment payments received', example: '0', tags: ['appointment'] }, { key: 'financials.final_price', text: 'Appointment final price', example: '0.00', tags: ['appointment'] }, { key: 'financials.final_due', text: 'Appointment final amount due', example: '0.00', tags: ['appointment'] }, { key: 'starttime_formatted.zone', text: 'Timezone', example: 'Africa/Johannesburg', tags: ['appointment'] }, { key: 'starttime_formatted.zoned_date_formatted', text: 'Appointment date', example: 'Fri 17 Jan 2020', tags: ['appointment'] }, { key: 'starttime_formatted.zoned_time_formatted', text: 'Appointment time', example: '13:00 PM', tags: ['appointment'] }, { key: 'recipient.first_name', text: 'Recipient first name', example: 'Joe' }, { key: 'recipient.last_name', text: 'Recipient last name', example: 'Soap' }, { key: 'recipient.full_name', text: 'Recipient full name', example: 'Joe Soap' }, { key: 'recipient.email', text: 'Recipient email', example: 'joe@soap.com' }, { key: 'recipient.phone_number', text: 'Recipient phone number', example: '+27831234567' }, { key: 'sender.first_name', text: 'Sender first name', example: 'Jane' }, { key: 'sender.last_name', text: 'Sender last name', example: 'Soap' }, { key: 'sender.full_name', text: 'Sender full name', example: 'Jane Soap' }, { key: 'sender.email', text: 'Sender email', example: 'jane@soap.com' }, { key: 'sender.phone_number', text: 'Sender phone number', example: '+27831234567' }];

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    items: function items() {
      return [{
        id: 'create_appointment',
        title: 'Create your first appointment',
        description: 'Create an appointment and see how notifications work',
        instructions: {
          video: 'https://www.loom.com/embed/4497e5302f7d4904800a72c665c4ec9e',
          steps: [{ title: 'Click on the blue plus button in the bottom right of the screen' }, {
            title: 'Choose "New appointment" (the first icon in the pop-up)',
            items: ['Create a contact with your own details', 'Create an appointment for tomorrow just a little past the current time (that way you will get a confirmation and a reminder)', 'Make sure that you check the box to send notifications']
          }],
          results: ['How to create an appointment', 'Add a new client', 'How automated notifications work'],
          screenshot: null
        },
        done: this.appointments.length > 0
      }, {
        id: 'add_codes',
        title: 'Add ICD-10 codes to your appointment',
        description: 'In AppointmentGuru appointments are the most important thing. You can store information like ICD-10 codes, notes, product sales, discounts etc. on appointments - these are then reflected on your invoices and on other reports. This means that you can manage you appointments on a day to day, and then easily generate invoices whenever you need to.',
        disabled: this.appointments.length === 0,
        instructions: {
          video: 'https://www.loom.com/embed/a46d5c235d4d4db3850b1adb75d984e0',
          steps: [{ title: 'Click on the three dots on the appointment below' }, { title: 'From the menu, click on: "Manage codes"' }, { title: 'Add some ICD-10 codes in the following dialog' }, {
            title: '<b>Notes</b>',
            items: ['You can usually bring up this menu wherever you see an appointment in AppointmentGuru', 'On the calendar, clicking on an appopintment will give you this menu']
          }],
          results: ['How to add ICD-10 codes to an appointment', 'How to search our database of codes', 'How to add multiple ICD-10 codes', 'How to add extra information like notes and product sales to appointments']
        },
        done: this.invoices.length > 0
      }, {
        id: 'create_invoice',
        title: 'Create an invoice',
        description: 'Once you\'ve loaded all the relevant information on an appointment it\'s quick and easy to create an invoice for that appointment',
        disabled: this.appointments.length === 0,
        instructions: {
          video: 'https://www.loom.com/embed/ff3ad08dafbd4908a2f3b32dff1da36e',
          steps: [{ title: 'Click on the three dots on the appointment below' }, { title: 'From the menu, click on: "Create invoice"' }],
          results: ['How to create an invoice for a single invoice', 'The various information that you can add to appointments and invoices', 'How to password protect your invoice', 'How to add a client\'s medical aid information as you are creating the invoice', 'How to add a discount on an appointment']
        },
        done: this.invoices.length > 0
      }, {
        id: 'send_invoice',
        title: 'Share the invoice',
        description: 'AppointmentGuru makes it easy to share the invoice directly to the client via many different means such as email, sms or whatsapp',
        instructions: {
          video: 'https://www.loom.com/embed/9e95b67ee4154493b7600febe09d7675',
          steps: [{ title: 'Click on the three dots next to the invoice below' }, { title: 'From the menu, click on: "Send"' }, { title: '<b>Note:</b> You can usually bring up this menu wherever you see an invoice in AppointmentGuru' }],
          results: ['How to send an invoice an email attachement', 'How to send an invoice as a link via SMS', 'Various options for sharing an invoice', 'Sending an invoice to medical aid']
        }
      }];
    }
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_plugin__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VuexLoader__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VuexLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_VuexLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VuexBtn__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VuexBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_VuexBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_VuexSnackbar__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_VuexSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_VuexSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HelpDialog__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HelpDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_HelpDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ui_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ui_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ui_RequestStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_analytics__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_cookies__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_global__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_api__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_http__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_permissions__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sentry_browser__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__i18n_app__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__i18n_help__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__router__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_dist_vuetify_min_css__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_style_css__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_style_css__);

































var isProd = "production-web".startsWith('production');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_cookies___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_analytics___default.a, {
  id: "UA-93898571-1",
  router: __WEBPACK_IMPORTED_MODULE_22__router__["a" /* default */],
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});

if (isProd) {
  __WEBPACK_IMPORTED_MODULE_18__sentry_browser__["a" /* init */]({
    dsn: 'https://cca253c0b28c4c21a8f3e21aaac48996@sentry.io/116851',
    release: '3.1.5',
    integrations: [new __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["default"], attachProps: true })]
  });
  console.log('sentry initted');
}

var messages = {
  en: {
    message: {
      hello: 'hello world'
    },
    global: __WEBPACK_IMPORTED_MODULE_20__i18n_app__["a" /* globalMessages */],
    help: __WEBPACK_IMPORTED_MODULE_21__i18n_help__["a" /* helpMessages */],
    buttons: {
      cancel: 'Cancel',
      close: 'Close',
      delete: 'Delete',
      save: 'Save',
      next: 'Next',
      back: 'Back',
      done: 'Done',
      edit: 'Edit'
    }
  },
  ja: {
    message: {
      hello: 'こんにちは、世界'
    }
  }
};

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: messages
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__store_plugin__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_13__mixins_global__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_14__mixins_requests__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_15__mixins_api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_16__mixins_http__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_17__mixins_permissions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('vuex-loader', __WEBPACK_IMPORTED_MODULE_6__components_VuexLoader___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('vuex-btn', __WEBPACK_IMPORTED_MODULE_7__components_VuexBtn___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('help-dialog', __WEBPACK_IMPORTED_MODULE_9__components_HelpDialog___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('vuex-snackbar', __WEBPACK_IMPORTED_MODULE_8__components_VuexSnackbar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('request-status', __WEBPACK_IMPORTED_MODULE_10__components_ui_RequestStatus___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  i18n: i18n,
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_22__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

window.guruinstaller = null;
window.addEventListener('beforeinstallprompt', function (e) {
  window.guruinstaller = e;

  console.log('\'beforeinstallprompt\' event was fired.');
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(216);




/* harmony default export */ __webpack_exports__["a"] = ({
  loginRequired: function loginRequired(to, from, next) {
    if (to.query.t) {
      var token = to.query.t;
      var payload = { access_token: token };
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_0__store_constants__["i" /* LOGIN */], payload);
    }
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.application.token) {
      if (['/logout', '/login'].indexOf(to.path) === -1) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_0__store_constants__["w" /* SET_POST_LOGIN_REDIRECT */], to.path);
      }
      return next('/login');
    }
    return next();
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return multiguru; });
var multiguru = {
  resources: {
    proxy: 'proxy/',
    become: 'become/',
    'group': 'groups/',
    'group.expanded': 'groups/expand/'
  }
};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getNormalized: function getNormalized(client) {
      var normalized = client;
      if (client.client && client.client.first_name) {
        normalized = client.client;
      }
      return normalized;
    },
    getfullName: function getfullName(client) {
      var fname = '';
      if (client.first_name) {
        fname = client.first_name;
      }
      if (client.last_name) {
        fname += ' ' + client.last_name;
      }
      return fname;
    },
    asRecipient: function asRecipient(client) {
      var normalized = this.getNormalized(client);
      var userId = this.getObjectPath(client, 'client.id', null);
      var data = {
        relationship_id: client.id,
        full_name: this.getfullName(normalized),
        first_name: normalized.first_name,
        last_name: normalized.last_name,
        email: normalized.email,
        phone_number: normalized.phone_number
      };
      if (userId) {
        data['user_id'] = userId;
      }
      return data;
    }
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__ = __webpack_require__(36);








var AppointmentGuruBackend = function (_API) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AppointmentGuruBackend, _API);

  function AppointmentGuruBackend() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'appointmentguru';
    var store = arguments[1];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AppointmentGuruBackend);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AppointmentGuruBackend.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AppointmentGuruBackend)).call(this, name, store));

    _this.store = store;
    _this.baseUrl = "https://v2.appointmentguru.co";
    _this.headers = {
      'Content-Type': 'application/json'
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AppointmentGuruBackend, [{
    key: 'endpoints',
    value: function endpoints() {
      return {
        'auth-identify': {
          url: 'api/auth/identify/',
          method: 'POST',
          params: { phone_number: { type: 'number', required: true } }
        },
        'auth-validate-otp': {
          url: 'api/auth/otp/',
          method: 'POST',
          params: {
            phone_number: { type: 'number', required: true },
            otp: { type: 'number', required: true }
          }
        },
        'auth-forgot-password': {
          url: 'api/auth/forgot-password/',
          method: 'POST',
          requiresAuth: false,
          params: {
            phone_number: { type: 'number', required: true }
          }
        },
        'auth-set-password': {
          url: 'api/auth/set-password/',
          method: 'POST',
          requiresAuth: true,
          params: {
            phone_number: { type: 'number', required: true },
            otp: { type: 'number', required: true }
          }
        },
        'auth-login-phone': {
          url: 'api/auth/phone/token/',
          method: 'POST',
          params: {
            phone_number: { type: 'number', required: true },
            password: { type: 'string', required: true }
          }
        },
        'auth-register': {
          url: 'api/auth/register/',
          method: 'POST',
          params: {
            full_name: { type: 'string', required: true },
            email: { type: 'email', required: true },
            phone_number: { type: 'number', required: true },
            password1: { type: 'string', required: true },
            password2: { type: 'string', required: true }
          }
        },
        'location.touch': {
          url: 'api/v2/practitioner/services/touch/',
          method: 'POST',
          params: {
            name: { type: 'string', required: false }
          }
        },
        'me': {
          url: 'api/users/me/',
          method: 'PATCH',
          params: {}
        }
      };
    }
  }, {
    key: 'resources',
    value: function resources() {
      return {
        login: 'api/auth/login',
        'users': 'api/users/',
        'home': 'api/home/',
        'auth.become': 'api/auth/become/',
        'client.practitioners': 'api/client/practitioners/',
        'client.appointments': 'api/client/appointments/',
        'client.v2.appointments': 'api/v2/client/appointments/',
        'client.v2.compare': 'api/v3/practitioner/relationships/compare/',
        'appointment': 'api/appointments/',
        'appointment.practitioner.v3': 'api/v3/practitioner/appointments/',
        'appointment.recurring': 'api/appointments/recurring/',
        'appointment.recurring.clashes': 'api/appointments/recurring/precreate/',
        'appointment.clashes': 'api/appointments/clashes/',
        'appointment.bulk': 'api/appointments/bulk/',
        'appointment.codes': 'api/appointments/codes/',
        'appointment.products': 'api/appointments/lineitems/',
        'appointment.codes.many': 'api/appointments/codes/many/',
        'appointment.codes.suggestions': 'api/appointments/codes/suggestions/',
        'appointment.tags': 'api/appointments/tags/',
        appointments: 'api/v2/client/appointments/',
        process: 'api/appointments/processes/',
        'practitioner.integrations': 'api/v2/practitioner/integrations/',
        'practitioner.integrations.zoom': 'api/v2/practitioner/integrations/zoom/',
        'practitioner.integrations.netcash': 'api/v2/practitioner/integrations/netcash/configure/',
        'practitioner.lookups': 'api/v3/practitioner/practitioners/me/lookups/',
        'practitioner.professions': 'api/practitioners/professions/',
        'practitioner.messages': 'api/practitioners/settings/messages/',
        'practitioner.messages.defaults': 'api/practitioners/settings/messages/defaults/',
        'practitioner.appointments.clashes': 'api/appointments/clashes/',
        'practitioner.me': 'api/v2/practitioner/me/',
        'practitioner.me.profile': 'api/v2/practitioner/me/profile/',
        'practitioner.appointments': 'api/appointments/',
        'practitioner.clients': 'api/v2/practitioner/clients/',

        'practitioner.clients.new': 'api/v2/practitioner/clients/new/',
        'practitioner.services': 'api/v2/practitioner/services/',
        'practitioner.services.address': 'api/v2/practitioner/services/addresses/',
        'practitioner.services.hours': 'api/v2/practitioner/services/hours/',
        'practitioner.services.products': 'api/v2/practitioner/services/products/',
        'practitioner.comms.default': 'api/practitioners/settings/messages/defaults/',
        'practitioner.communications': 'api/practitioners/settings/messages/',
        'practitioner.communications.send': 'api/practitioners/settings/messages/:slug/send/',
        'v3.statement': 'api/v3/practitioner/statement/',
        'v3.1.statement': 'api/v3-1/practitioner/statement/',
        'practitioner.v2.clients.treatment': 'api/v3/practitioner/treatment/',
        'practitioner.v3.clients': 'api/v3/clients/',
        'practitioner.v3.payments': 'api/v3/practitioner/payment/',
        'practitioner.v3.clients.active': 'api/v3/clients/active/',
        'practitioner.v3.dashboard': 'api/v3/clients/active/',
        'practitioner.v3.relationships': 'api/v3/practitioner/relationships/'
      };
    }
  }]);

  return AppointmentGuruBackend;
}(__WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AppointmentGuruBackend);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__ = __webpack_require__(36);







var AuthenticationGuruBackend = function (_API) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AuthenticationGuruBackend, _API);

  function AuthenticationGuruBackend() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'authenticationguru';
    var store = arguments[1];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AuthenticationGuruBackend);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AuthenticationGuruBackend.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AuthenticationGuruBackend)).call(this, name, store, options));

    _this.store = store;
    _this.baseUrl = "https://authguru.appointmentguru.co";
    _this.headers = { 'Content-Type': 'application/json' };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AuthenticationGuruBackend, [{
    key: 'resources',
    value: function resources() {
      return {
        ping: 'headers/',
        refresh: 'oauth2/token/'
      };
    }
  }]);

  return AuthenticationGuruBackend;
}(__WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AuthenticationGuruBackend);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__ = __webpack_require__(36);







var CodeGuruBackend = function (_API) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CodeGuruBackend, _API);

  function CodeGuruBackend() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'codeguru';
    var store = arguments[1];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CodeGuruBackend);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CodeGuruBackend.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CodeGuruBackend)).call(this, name, store, options));

    _this.store = store;
    _this.baseUrl = "https://codeguru.appointmentguru.co";
    _this.headers = { 'Content-Type': 'application/json' };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CodeGuruBackend, [{
    key: 'resources',
    value: function resources() {
      return {
        code: 'codes/',
        processcode: 'processcodes/'
      };
    }
  }]);

  return CodeGuruBackend;
}(__WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CodeGuruBackend);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__ = __webpack_require__(36);







var CommunicationGuruBackend = function (_API) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CommunicationGuruBackend, _API);

  function CommunicationGuruBackend() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'communicationguru';
    var store = arguments[1];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CommunicationGuruBackend);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CommunicationGuruBackend.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CommunicationGuruBackend)).call(this, name, store, options));

    _this.store = store;
    _this.baseUrl = "https://unibox.appointmentguru.co";
    _this.headers = { 'Content-Type': 'application/json' };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CommunicationGuruBackend, [{
    key: 'resources',
    value: function resources() {
      return {
        communication: 'communications/',
        template: 'templates/',
        'template.context': 'templates/categories/',
        send: 'communications/send/',
        backendSMS: 'messages/backends/sms/',
        slack: 'incoming/slack/'
      };
    }
  }]);

  return CommunicationGuruBackend;
}(__WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CommunicationGuruBackend);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_requests_src_store_backends_API__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var InvoiceGuruBackend = function (_API) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InvoiceGuruBackend, _API);

  function InvoiceGuruBackend() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'invoiceguru';
    var store = arguments[1];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InvoiceGuruBackend);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InvoiceGuruBackend.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InvoiceGuruBackend)).call(this, name, store, options));

    _this.store = store;
    _this.baseUrl = "https://invoiceguru-v2.appointmentguru.co";
    _this.headers = {
      'Content-Type': 'application/json'
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InvoiceGuruBackend, [{
    key: 'resources',
    value: function resources() {
      return {
        invoices: 'invoices/',
        statements: 'statements/',
        upgrade: 'invoices/upgrade/',
        invoiceSettings: '/invoices/settings/',
        transactions: 'transactions/',
        overdue: 'invoices/reports/overdue/',
        actions: 'action/'
      };
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var token = this.store.getters.token;
      var headers = {
        'authorization': 'bearer ' + token,
        'content-type': 'application/json'
      };
      return { headers: headers };
    }
  }, {
    key: 'performAction',
    value: function performAction(resource, action, pk, params) {
      var options = this.getOptions();
      var url = this.baseUrl + '/' + resource + '/' + pk + '/actions/' + action + '/';
      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(url, params, options);
    }
  }, {
    key: 'sendInvoice',
    value: function sendInvoice(invoiceId, emails, sms) {
      var options = this.getOptions();
      var data = {
        'to_email': emails
      };
      if (sms) {
        data['to_phone'] = sms;
      }
      var url = this.baseUrl + '/invoices/' + invoiceId + '/send/';
      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(url, data, options);
    }
  }, {
    key: 'validateInvoice',
    value: function validateInvoice(invoiceId, emails, sms) {
      var options = this.getOptions();
      var url = this.baseUrl + '/invoices/' + invoiceId + '/validations/';
      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url, options);
    }
  }, {
    key: 'quickCreate',
    value: function quickCreate(practitionerId, clientId, appointmentIds, context) {
      var baseurl = "https://invoiceguru-v2.appointmentguru.co";
      appointmentIds = appointmentIds.join(',');
      var qs = 'practitioner_id=' + practitionerId + '&appointment_ids=' + appointmentIds + '&client_id=' + clientId;
      var url = baseurl + '/invoices/construct/?' + qs;
      var token = this.store.getters.token;
      var headers = {
        'authorization': 'bearer ' + token,
        'content-type': 'application/json'
      };
      var options = { headers: headers };
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        context: context
      });
      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(url, data, options);
    }
  }, {
    key: 'markAsPaid',
    value: function markAsPaid(invoice) {
      var baseurl = "https://invoiceguru-v2.appointmentguru.co";
      var url = baseurl + '/invoices/' + invoice.id + '/paid/';
      var token = this.store.getters.token;
      var headers = {
        'authorization': 'bearer ' + token
      };
      var options = { headers: headers };
      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(url, {}, options);
    }
  }]);

  return InvoiceGuruBackend;
}(__WEBPACK_IMPORTED_MODULE_6_vuex_requests_src_store_backends_API__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (InvoiceGuruBackend);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__ = __webpack_require__(36);







var MedicalAidGuruBackend = function (_API) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MedicalAidGuruBackend, _API);

  function MedicalAidGuruBackend() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medicalaidguru';
    var store = arguments[1];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MedicalAidGuruBackend);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MedicalAidGuruBackend.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MedicalAidGuruBackend)).call(this, name, store, options));

    _this.store = store;
    _this.baseUrl = "https://medicalaidguru.appointmentguru.co";
    _this.headers = { 'Content-Type': 'application/json' };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MedicalAidGuruBackend, [{
    key: 'resources',
    value: function resources() {
      return {
        record: 'records/',
        'record.v2': 'v2/records/',
        birthdays: 'records/birthdays/',
        person: 'people/',
        relationship: 'people/relationships/',
        referrer: 'records/therapists/',
        treatmentlog: 'records/treatmentlog/',
        therapist: 'therapists/'
      };
    }
  }]);

  return MedicalAidGuruBackend;
}(__WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MedicalAidGuruBackend);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__ = __webpack_require__(36);







var MetaDataGuruBackend = function (_API) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MetaDataGuruBackend, _API);

  function MetaDataGuruBackend() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'metadataguru';
    var store = arguments[1];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MetaDataGuruBackend);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MetaDataGuruBackend.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MetaDataGuruBackend)).call(this, name, store, options));

    _this.store = store;
    _this.baseUrl = "https://metadataguru.appointmentguru.co";
    _this.headers = { 'Content-Type': 'application/json' };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MetaDataGuruBackend, [{
    key: 'resources',
    value: function resources() {
      return {
        lineitems: 'lineitems/',
        notes: 'v3/notes/',
        documents: 'v3/documents/'
      };
    }
  }]);

  return MetaDataGuruBackend;
}(__WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MetaDataGuruBackend);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__ = __webpack_require__(36);







var SubscriptionGuruBackend = function (_API) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SubscriptionGuruBackend, _API);

  function SubscriptionGuruBackend() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'subscriptionguru';
    var store = arguments[1];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SubscriptionGuruBackend);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SubscriptionGuruBackend.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SubscriptionGuruBackend)).call(this, name, store, options));

    _this.store = store;
    _this.baseUrl = "https://subscriptionguru.appointmentguru.co/api";
    _this.headers = { 'Content-Type': 'application/json' };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SubscriptionGuruBackend, [{
    key: 'resources',
    value: function resources() {
      return {
        transaction: 'transactions/',
        scheduledpayment: 'scheduled-payments/'
      };
    }
  }]);

  return SubscriptionGuruBackend;
}(__WEBPACK_IMPORTED_MODULE_5_vuex_requests_src_store_backends_API__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubscriptionGuruBackend);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_constants__ = __webpack_require__(2);



var _mutations, _actions;






/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    token: null,
    refreshToken: null,
    isLoggedIn: false,
    channel: null,
    loginRedirect: '/',
    pageLoading: false,
    loginChallenge: 0,
    logoutRequest: 0,
    notification: {},
    tutorialLink: 'https://appointmentguru-co.appointmentguru.workers.dev/en/support-docs/grid-view/how-does-appointmentguru-work',
    activeDateRange: {
      from: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.min(__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month'), __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract('2', 'days')).format('YYYY-MM-DD'),
      to: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.max(__WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month'), __WEBPACK_IMPORTED_MODULE_2_moment___default()().add('7', 'days')).format('YYYY-MM-DD')
    },
    calendarDate: null,
    globalSettings: {
      startTime: null,
      endTime: null,
      activeDate: null,
      activeProduct: {},
      activePractitioner: null
    },
    spaces: {
      globalDialog: {
        title: null,
        component: null,
        options: {},
        actions: {},
        visible: false,
        fullscreen: true
      },
      secondaryGlobalDialog: {
        title: null,
        component: null,
        options: {},
        actions: {},
        visible: false,
        fullscreen: false
      }
    },
    triggers: {
      selectDateRange: Math.random()
    },
    ignoredAppointmentStatuses: ['c'],
    activeDialog: '',
    activateRangePicker: 0,
    activeAppointment: {},
    activeAppointmentTab: 'Reschedule',
    me: {},
    selectedAppointments: [],
    appointments: [],
    clients: [],
    globalEventInformation: {}
  },
  mutations: (_mutations = {
    'SET_TUTORIAL': function SET_TUTORIAL(state, link) {
      state.tutorialLink = link;
    },
    'LOGIN_CHALLENGE': function LOGIN_CHALLENGE(state) {
      state.loginChallenge++;
    },
    'LOGOUT_REQUEST': function LOGOUT_REQUEST(state) {
      state.logoutRequest++;
    },
    'SET_LOGGEDIN': function SET_LOGGEDIN(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["x" /* SET_TOKEN */], function (state, token) {
    state.token = token;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["y" /* SET_REFRESH_TOKEN */], function (state, token) {
    state.refreshToken = token;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["z" /* TRIGGER_EVENT */], function (state, args) {
    state.triggers[args[0]] = Math.random();
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["j" /* SET_SETTING */], function (state, settings) {
    if (settings.length === 2) {
      var key = settings[0];
      var value = settings[1];
      if (state.globalSettings[key] !== value) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.globalSettings, key, value);
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["A" /* SET_NOTIFICATION */], function (state, messageObject) {
    state.notification = messageObject;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["w" /* SET_POST_LOGIN_REDIRECT */], function (state, redirect) {
    state.loginRedirect = redirect;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["B" /* SET_ACTIVE_APPOINTMENT */], function (state, appointment) {
    state.activeAppointment = appointment;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["C" /* SET_ACTIVE_DIALOG */], function (state, id) {
    state.activeDialog = id;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["v" /* SET_ACTIVE_DATE_RANGE */], function (state, args) {
    state.activeDateRange.from = args[0];
    state.activeDateRange.to = args[1];
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["D" /* ACTIVATE_RANGE_PICKER */], function (state, value) {
    state.activateRangePicker = value;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_constants__["E" /* SET_SPACE_VALUE */], function (state, spaceKeyValue) {
    if (Array.isArray(spaceKeyValue)) {
      var space = spaceKeyValue[0];
      var key = spaceKeyValue[1];
      var val = spaceKeyValue[2];
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.spaces[space], key, val);
    } else {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.spaces, spaceKeyValue.space, spaceKeyValue);
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'setCalendarDate', function setCalendarDate(state, date) {
    state.calendarDate = date;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'globalEvent', function globalEvent(state, _ref) {
    var componentName = _ref.componentName,
        data = _ref.data;

    var touch = Math.random();
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.globalEventInformation, componentName, { touch: touch, data: data });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'setGlobalSelectedAppointments', function setGlobalSelectedAppointments(state, val) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state, 'selectedAppointments', val);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'toggleGloballySelectedAppointment', function toggleGloballySelectedAppointment(state, appointment) {
    if (appointment && appointment.id) {
      var selectedIndex = state.selectedAppointments.findIndex(function (appt) {
        return parseInt(appt.id) === parseInt(appointment.id);
      });
      var isSelected = selectedIndex > -1;
      if (isSelected) {
        state.selectedAppointments.splice(selectedIndex, 1);
      } else {
        state.selectedAppointments.push(appointment);
      }
    } else {
      console.error('toggleGloballySelectedAppointment must be passed an appointment object');
    }
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__store_constants__["F" /* INIT */], function (_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    var token = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$cookies.get(__WEBPACK_IMPORTED_MODULE_4__store_constants__["G" /* KONG_TOKEN_KEY */]);
    if (!token) {
      token = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__store_constants__["G" /* KONG_TOKEN_KEY */]);
    }
    var refreshToken = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__store_constants__["G" /* KONG_TOKEN_KEY */] + '-refresh');

    if (token) {
      var payload = {
        access_token: token,
        refresh_token: refreshToken
      };
      dispatch(__WEBPACK_IMPORTED_MODULE_4__store_constants__["i" /* LOGIN */], payload);
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, 'CLEAR_STORAGE', function CLEAR_STORAGE() {
    var domain = 'appointmentguru.co';
    if (false) {
      domain = 'docker.localhost';
    }
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$cookies.remove(__WEBPACK_IMPORTED_MODULE_4__store_constants__["G" /* KONG_TOKEN_KEY */], null, domain);
    window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_4__store_constants__["G" /* KONG_TOKEN_KEY */]);
    window.localStorage.removeItem('appointmentguru_practitioner_token');
    window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_4__store_constants__["G" /* KONG_TOKEN_KEY */] + '-refresh');
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__store_constants__["i" /* LOGIN */], function (_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    var token = payload.access_token;
    var refreshToken = payload.refresh_token;
    dispatch(__WEBPACK_IMPORTED_MODULE_4__store_constants__["h" /* LOGOUT */]);
    commit('SET_TOKEN', token);
    commit('SET_REFRESH_TOKEN', refreshToken);
    commit('BACKEND_CONFIG_SET_HEADER', ['appointmentguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['metadataguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['invoiceguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['authenticationguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['medicalaidguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['communicationguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['codeguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['subscriptionguru', 'Authorization', 'Bearer ' + token]);

    dispatch('CLEAR_STORAGE');
    commit('SET_LOGGEDIN', true);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__store_constants__["h" /* LOGOUT */], function (_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    var token = null;
    commit('SET_TOKEN', token);
    window.localStorage.clear();
    commit('SET_TOKEN', token);
    commit('SET_REFRESH_TOKEN', token);
    commit('BACKEND_CONFIG_SET_HEADER', ['appointmentguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['metadataguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['invoiceguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['authenticationguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['medicalaidguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['communicationguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['codeguru', 'Authorization', 'Bearer ' + token]);
    commit('BACKEND_CONFIG_SET_HEADER', ['subscriptionguru', 'Authorization', 'Bearer ' + token]);
    commit('clearClients');
    dispatch('CLEAR_STORAGE');
    commit('SET_LOGGEDIN', false);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__store_constants__["H" /* SHOW_APPOINTMENT_DIALOG */], function (_ref5, args) {
    var commit = _ref5.commit;

    var visible = args[0];
    var id = args[1];
    var appointment = args[2];


    if (visible === false) {
      commit(__WEBPACK_IMPORTED_MODULE_4__store_constants__["C" /* SET_ACTIVE_DIALOG */], null);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_4__store_constants__["C" /* SET_ACTIVE_DIALOG */], id);
      commit(__WEBPACK_IMPORTED_MODULE_4__store_constants__["B" /* SET_ACTIVE_APPOINTMENT */], appointment);
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__store_constants__["D" /* ACTIVATE_RANGE_PICKER */], function (_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__store_constants__["D" /* ACTIVATE_RANGE_PICKER */], Math.random());
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__store_constants__["I" /* HIDE_SPACE */], function (_ref7, space) {
    var commit = _ref7.commit;

    commit('SET_SPACE_VALUE', [space, 'visible', false]);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__store_constants__["J" /* SET_SPACE */], function (_ref8, args) {
    var commit = _ref8.commit;

    var space = args[0];
    var component = args[1];
    var title = args[2];
    var options = args[3];
    var actions = args[4];

    var isFullScreen = true;
    if (args.length === 6) {
      isFullScreen = args[5];
    }
    var settings = {
      space: space, component: component, title: title, options: options, actions: actions, visible: true, fullscreen: isFullScreen
    };
    commit('SET_SPACE_VALUE', settings);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, 'fetchAppointments', function fetchAppointments(_ref9) {
    var commit = _ref9.commit;
  }), _actions),
  getters: {
    loginChallengeCount: function loginChallengeCount(state) {
      return state.loginChallenge;
    },
    logoutRequestCount: function logoutRequestCount(state) {
      return state.logoutRequest;
    },
    isLoggedIn: function isLoggedIn(state, getters) {
      return state.isLoggedIn && getters.token;
    },

    getRequestData: function getRequestData(state, getters) {
      return function (id, defaultResult) {
        var req = getters.getRequestById(id);
        if (req && req !== -1 && req.result && req.result.data) {
          return req.result.data;
        }
        return defaultResult;
      };
    },
    getTutorial: function getTutorial(state) {
      return state.tutorialLink;
    },
    token: function token(state) {
      return state.token;
    },
    refreshToken: function refreshToken(state) {
      return state.refreshToken;
    },
    pageLoading: function pageLoading(state) {
      return state.pageLoading;
    },
    loginRedirect: function loginRedirect(state) {
      return state.loginRedirect;
    },
    settings: function settings(state, getters) {
      var settings = state.globalSettings;
      var me = getters.me;
      if (me && me.profile) {
        settings['currency'] = me.profile.currency;
        settings['timezone'] = me.profile.timezone;
        settings['free_trial_expiry_date'] = me.profile.free_trial_expiry_date;
      }
      return settings;
    },
    globalCalendarDate: function globalCalendarDate(state) {
      return state.calendarDate;
    },
    activeDateRange: function activeDateRange(state) {
      return state.activeDateRange;
    },
    me: function me(state, getters) {
      var result = getters.getRequestData(__WEBPACK_IMPORTED_MODULE_4__store_constants__["f" /* GET_ME_REQ */], {});
      if (result && result.results && result.results.length > 0) {
        return result.results[0];
      }
      return {};
    },
    meId: function meId(state, getters) {
      var me = getters.me;
      if (me) {
        return me.id;
      }
      return null;
    },
    isAdmin: function isAdmin(state, getters) {
      return getters.me.is_admin;
    },
    isReadOnly: function isReadOnly(state, getters) {
      var me = getters.me;
      if (getters.businesses.length > 0 && getters.activeBusinesses.length === 0) {
        return true;
      }
      if (me && me.profile && me.profile.is_active === false) {
        return true;
      }
      return false;
    },
    services: function services(state, getters) {
      var me = getters.me;
      if (me && me.profile && me.profile.services) {
        return me.profile.services;
      }
      return [];
    },
    appointments: function appointments(state, getters) {
      return getters.getRequestData(__WEBPACK_IMPORTED_MODULE_4__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */], []);
    },
    activeAppointments: function activeAppointments(state, getters) {
      return getters.appointments.filter(function (appt) {
        return state.ignoredAppointmentStatuses.indexOf(appt.status.toLowerCase()) === -1;
      });
    },
    appointmentsNeedingAttention: function appointmentsNeedingAttention(state, getters) {
      return getters.appointments.filter(function (appt) {
        return appt.status.toLowerCase() === 'n' && appt.invoiceable === false;
      });
    },
    invoices: function invoices(state, getters) {
      var data = getters.getRequestData(__WEBPACK_IMPORTED_MODULE_4__store_constants__["e" /* LIST_INVOICES_IN_RANGE_REQ */], []);
      if (data && data.results) {
        return data.results;
      }
      return [];
    },

    getInvoicesByStatus: function getInvoicesByStatus(state, getters) {
      return function (status) {
        if (getters.invoices) {
          return getters.invoices.filter(function (invoice) {
            return invoice.status === status;
          });
        }
        return [];
      };
    },
    clientsInRange: function clientsInRange(state, getters) {
      var clients = [];
      var appointmentsByClient = {};

      var addPriceDetails = function addPriceDetails(li, appt) {
        if (appt.price) {
          var price = parseFloat(appt.price);
          if (appt.status === 'P') {
            li.totalPaid += price;
          } else {
            li.totalOwed += price;
          }
        }
      };

      getters.appointments.map(function (appt) {
        if (clients.indexOf(appt.client) === -1) {
          clients.push(appt.client);
        }
        try {
          appointmentsByClient[appt.client].push(appt);
          addPriceDetails(appointmentsByClient[appt.client], appt);
        } catch (e) {
          appointmentsByClient[appt.client] = [];
          appointmentsByClient[appt.client].push(appt);
          appointmentsByClient[appt.client].totalOwed = 0;
          appointmentsByClient[appt.client].totalPaid = 0;
          addPriceDetails(appointmentsByClient[appt.client], appt);
        }
      });
      return {
        clients: clients,
        appointmentsByClient: appointmentsByClient
      };
    },
    lookups: function lookups(state, getters) {
      var res = getters.getRequestById(__WEBPACK_IMPORTED_MODULE_4__store_constants__["K" /* GET_LOOKUPS_REQ */], true);
      var lookups = null;
      if (res && res.result && res.result.data) {
        lookups = res.result.data;
      }
      if (lookups) {
        return lookups;
      }
      return {};
    },
    businesses: function businesses(state, getters) {
      if (getters.lookups && getters.lookups.businesses) {
        return getters.lookups.businesses;
      }
      return [];
    },
    activeBusinesses: function activeBusinesses(state, getters) {
      if (getters.businesses) {
        return getters.businesses.filter(function (biz) {
          return biz.is_active;
        });
      }
      return [];
    },

    locationsBySpace: function locationsBySpace(state, getters) {
      return function (spaceId) {
        if (getters.lookups && getters.lookups.spaces && spaceId in getters.lookups.spaces) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(getters.lookups.spaces[spaceId].locations);
        }
        return null;
      };
    },
    products: function products(state, getters) {
      if (getters.lookups && getters.lookups.products) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(getters.lookups.products);
      }
      return [];
    },
    spaces: function spaces(state, getters) {
      if (getters.lookups && getters.lookups.spaces) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(getters.lookups.spaces);
      }

      return getters.services.map(function (space) {
        var logo = null;

        if (space.logo_picture) {
          logo = space.logo_picture;
        }
        return {
          title: space.title,
          id: space.id,
          logo_picture: logo
        };
      });
    },

    getIntegration: function getIntegration(state, getters) {
      return function (integrationName, spaceId) {
        if (getters.lookups && getters.lookups.integrations) {
          return getters.lookups.integrations.find(function (integration) {
            if (spaceId) {
              return integration.title === integrationName && parseInt(integration.space) === parseInt(spaceId);
            } else {
              return integration.title === integrationName;
            }
          });
        }
        return null;
      };
    },
    getAppointmentById: function getAppointmentById(state) {
      return function (id) {
        if (id in state.appointments.objects) {
          return state.appointments.objects;
        }
        return null;
      };
    },
    getSpaceById: function getSpaceById(state, getters) {
      return function (id) {
        if (getters.lookups && getters.lookups.spaces && id in getters.lookups.spaces) {
          return getters.lookups.spaces[id];
        }
        return null;
      };
    },
    getSpacesByPractitionerId: function getSpacesByPractitionerId(state, getters) {
      return function (practitionerId) {
        var spaces = getters.lookups.spaces;
        if (spaces) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(spaces).filter(function (space) {
            return space.members.indexOf(practitionerId) !== -1 && space.membership_active !== false;
          });
        }
        return [];
      };
    },
    getProductsBySpaceAndPractitionerId: function getProductsBySpaceAndPractitionerId(state, getters) {
      return function (practitionerId, spaceId) {
        var products = getters.lookups.products;
        return products.filter(function (product) {
          var isProductOwner = String(product.owner === String(practitionerId));
          var isInSpace = String(product.space) === String(spaceId);
          return isProductOwner && isInSpace;
        });
      };
    },
    getProducts: function getProducts(state, getters) {
      return function (practitionerId, spaceId, locationId) {
        var products = getters.lookups.products;
        if (products) {
          var productList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(products);
          return productList.filter(function (product) {
            var isProductOwner = true;
            var isInSpace = true;
            var isInLocation = true;
            if (product.archived === true) {
              return false;
            }
            if (practitionerId) {
              isProductOwner = String(product.owner) === String(practitionerId);
            }
            if (spaceId) {
              isInSpace = String(product.space) === String(spaceId);
            }
            if (locationId) {
              if (product.locations) {
                isInLocation = product.locationIds.indexOf(locationId) !== -1;
              } else {
                isInLocation = false;
              }
            }
            return isProductOwner && isInSpace && isInLocation;
          });
        }
        return [];
      };
    },
    getProductById: function getProductById(state, getters) {
      return function (id) {
        if (getters.lookups && getters.lookups.products && id in getters.lookups.products) {
          return getters.lookups.products[id];
        }
        return null;
      };
    },
    getLocations: function getLocations(state, getters) {
      if (getters.lookups && getters.lookups.locations && getters.lookups.locations.length > 0) {
        return getters.lookups.locations;
      }
      return [];
    },

    getLocationsBySpaceId: function getLocationsBySpaceId(state, getters) {
      return function (spaceId, showArchived) {
        return getters.getLocations.filter(function (loc) {
          if (loc.spaces) {
            return loc.spaces.indexOf(spaceId) >= 0;
          }
          return false;
        });
      };
    },
    getLocationById: function getLocationById(state, getters) {
      return function (id) {
        return getters.getLocations.find(function (loc) {
          return loc.id === id;
        });
      };
    },
    getSharedCalendars: function getSharedCalendars(state, getters) {
      return getters.lookups.shared_calendars || [];
    },
    getColleagues: function getColleagues(state, getters) {
      return getters.lookups.practitioners || [];
    },

    getPractitionerById: function getPractitionerById(state, getters) {
      return function (id) {
        if (getters.lookups && getters.lookups.practitioners && id in getters.lookups.practitioners) {
          return getters.lookups.practitioners[id];
        }
        return {};
      };
    },
    getGlobalDialogEvent: function getGlobalDialogEvent(state, getters) {
      return function (dialogId) {
        if (dialogId in state.globalEventInformation) {
          return state.globalEventInformation[dialogId];
        }
        return { data: {}, touch: 0 };
      };
    }
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









function getObjectPath(object, path, defaultResponse) {
  if (object) {
    var bits = path.split('.');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(bits), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        try {
          if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(object).indexOf(key) !== -1) {
            object = object[key];
          } else {
            return defaultResponse;
          }
        } catch (e) {
          if (e instanceof TypeError) {
            return defaultResponse;
          }
          throw e;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return object;
  }
  return defaultResponse;
}

function sortDaysEvents(day) {
  if (day && day.items) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(day.items).sort(function (a, b) {
      if (a.start_time > b.start_time) {
        return 1;
      }
      if (a.start_time < b.start_time) {
        return -1;
      }
      return 0;
    });
  } else {
    return null;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    objects: {},
    detail: {},
    calendars: {}
  },
  mutations: {
    addAppointments: function addAppointments(state, appointments) {
      var updatedDays = [];

      appointments.forEach(function (appointment) {
        if (!appointment.id) {
          return null;
        }
        var practitionerId = appointment.practitioner;
        if (appointment.start_time && appointment.start_time.indexOf('T') > -1) {
          var dt = appointment.start_time.split('T')[0];
          updatedDays.push([practitionerId, dt]);
          if (!(practitionerId in state.calendars)) {
            var newCalendar = { title: '', dates: {}, facets: {} };
            __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(state.calendars, practitionerId, newCalendar);
          }
          if (!(dt in state.calendars[practitionerId].dates)) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(state.calendars[practitionerId].dates, dt, { 'list': [], 'items': {} });
          }

          var startMoment = __WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.start_time);
          var endMoment = __WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.end_time);
          appointment.dt = dt;
          appointment.start = startMoment.format('HH:mm');
          appointment.end = endMoment.format('HH:mm');
          appointment.duration = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.duration(endMoment.diff(startMoment)).minutes();
          if (!appointment.dates) {
            appointment.dates = [dt];
          } else {
            if (appointment.dates.indexOf(dt) === -1) {
              appointment.dates.push(dt);
            }
          }

          var day = state.calendars[practitionerId].dates[dt];

          __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(day.items, appointment.id, appointment);

          if (!day.list || day.list.length === 0) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(day, 'list', [appointment]);
          } else {
            var existsIndex = day.list.findIndex(function (appt) {
              var compareString1 = '' + appt.id + appt.start_time + appt.end_time;
              var compareString2 = '' + appointment.id + appointment.start_time + appointment.end_time;
              if (compareString1 === compareString2) {
                return true;
              }
            });
            var exists = existsIndex > -1;
            if (exists) {
              __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(day.list, existsIndex, appointment);
            } else {
              var insertIndex = day.list.findIndex(function (appt) {
                return appointment.start_time <= appt.start_time;
              });
              if (insertIndex > -1) {
                day.list.splice(insertIndex, 0, appointment);
              } else {
                day.list.push(appointment);
              }
            }
          }
        } else {
          console.error('no start time found on appointment');
        }

        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(state.objects, appointment.id, appointment);
      });
    },
    removeAppointment: function removeAppointment(state, appointmentId) {
      if (appointmentId in state.objects) {
        var appt = state.objects[appointmentId];

        if (appt.practitioner && appt.practitioner in state.calendars) {
          var path = 'calendars.' + appt.practitioner + '.dates.' + appt.dt + '.items';
          var item = getObjectPath(state, path);
          __WEBPACK_IMPORTED_MODULE_6_vue__["default"].delete(item, appointmentId);

          var day = getObjectPath(state, 'calendars.' + appt.practitioner + '.dates.' + appt.dt, null);
          var sorted = sortDaysEvents(day);
          if (sorted) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(day, 'list', sorted);
          }
        }

        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].delete(state.objects, appointmentId);
      }
    },
    cleanAppointment: function cleanAppointment(state, _ref) {
      var id = _ref.id,
          practitionerId = _ref.practitionerId,
          dt = _ref.dt;

      var path = 'calendars.' + practitionerId + '.dates.' + dt + '.items';
      var item = getObjectPath(state, path);
      if (item) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].delete(item, id);
      }

      var day = getObjectPath(state, 'calendars.' + practitionerId + '.dates.' + dt, null);
      var sorted = sortDaysEvents(day);
      if (sorted) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(day, 'list', sorted);
      }
    }
  },
  actions: {
    fetchAppointments: function fetchAppointments(_ref2, appointmentIds) {
      var _this = this;

      var commit = _ref2.commit,
          getters = _ref2.getters;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var base, path, url, options, result, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(appointmentIds && appointmentIds.length > 0)) {
                  _context.next = 13;
                  break;
                }

                base = "https://v2.appointmentguru.co";
                path = '/api/v3/practitioner/appointments/';
                url = base + path + '?id-in=' + appointmentIds.join(',');
                options = {
                  headers: {
                    'Authorization': 'Bearer ' + getters.token
                  }
                };
                _context.next = 7;
                return fetch(url, options);

              case 7:
                result = _context.sent;

                if (!result.ok) {
                  _context.next = 13;
                  break;
                }

                _context.next = 11;
                return result.json();

              case 11:
                data = _context.sent;

                commit('addAppointments', data.results);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    rescheduleAppointment: function rescheduleAppointment(_ref3, data) {
      var commit = _ref3.commit,
          getters = _ref3.getters;

      if (data) {
        var appt = getters.getAppointment(data.id);

        if (appt) {
          appt = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(appt));
          if (data.original_start_time && data.original_start_time.indexOf('T') > 0) {
            var oldDate = data.original_start_time.split('T')[0];
            var options = { id: appt.id, practitionerId: appt.practitioner, dt: oldDate };
            commit('cleanAppointment', options);
          }

          appt.dt = data.new_start_time.split('T')[0];
          appt.start_time = data.new_start_time;
          appt.end_time = data.new_end_time;
          commit('addAppointments', [appt]);
        }
      }
    }
  },
  getters: {
    getEventRange: function getEventRange(state) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(state.objects);
    },
    getRecentlyUpdated: function getRecentlyUpdated(state) {
      return state.recentlyUpdated;
    },

    getAppointment: function getAppointment(state) {
      return function (id) {
        if (id in state.objects) {
          return state.objects[id];
        }
        return null;
      };
    },
    getCalendarsDay: function getCalendarsDay(state) {
      return function (calendarIds, dt) {
        var events = [];
        calendarIds.forEach(function (calendarId) {
          if (state.calendars && state.calendars[calendarId] && state.calendars[calendarId].dates[dt]) {
            events = events.concat(state.calendars[calendarId].dates[dt].list);
          }
        });
        events = events.sort(function (a, b) {
          if (a.start_time > b.start_time) {
            return 1;
          }
          if (a.start_time < b.start_time) {
            return -1;
          }
          return 0;
        });
        return events;
      };
    },
    getCalendarDay: function getCalendarDay(state) {
      return function (calendarId, dt) {
        var path = 'calendars.' + calendarId + '.dates.' + dt + '.list';
        return getObjectPath(state, path, []);
      };
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_constants__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},
  getters: {
    totalAppointments: function totalAppointments(state, getters) {
      return getters.activeAppointments.length;
    },
    totalMonetaryValue: function totalMonetaryValue(state, getters) {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy___default()(getters.activeAppointments, function (o) {
        return parseFloat(o.price);
      });
    },
    totalPaidMonetaryValue: function totalPaidMonetaryValue(state, getters) {
      var paidAppointments = getters.activeAppointments.filter(function (item) {
        return item.status.toLowerCase() === 'p';
      });
      return __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy___default()(paidAppointments, function (o) {
        return parseFloat(o.price);
      });
    },
    totalMoneyOutstanding: function totalMoneyOutstanding(state, getters) {
      return getters.totalMonetaryValue - getters.totalPaidMonetaryValue;
    },
    appointmentsOverTime: function appointmentsOverTime(state, getters) {
      var firstDay = __WEBPACK_IMPORTED_MODULE_5_moment___default()(getters.activeDateRange.from);
      var lastDay = __WEBPACK_IMPORTED_MODULE_5_moment___default()(getters.activeDateRange.to);
      var data = [];
      var labels = [];

      var currentDate = firstDay;

      var _loop = function _loop() {
        var formattedDate = currentDate.format('YYYY-MM-DD');

        var currentDateAppointments = getters.activeAppointments.filter(function (item) {
          if (item && item.start_time) {
            return item.start_time.split('T')[0] === formattedDate;
          }
        });
        data.push(currentDateAppointments.length);
        labels.push(formattedDate);
        currentDate = currentDate.add(1, 'days');
      };

      while (currentDate <= lastDay) {
        _loop();
      }
      return {
        labels: labels,
        data: data
      };
    },
    stackedAppointmentsOverTime: function stackedAppointmentsOverTime(state, getters) {
      var counts = {};
      var statusKeys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__store_constants__["m" /* STATUSES */]);
      statusKeys.map(function (key) {
        counts[key] = {};
      });
      var currentDay = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(getters.activeAppointments), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var appt = _step.value;

          if (appt && appt.start_time) {
            var day = appt.start_time.split('T')[0];
            if (day !== currentDay) {
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(statusKeys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var _k = _step3.value;

                  counts[_k][day] = 0;
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
            counts[appt.status][day] = counts[appt.status][day] + 1;
            currentDay = day;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var labels = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(counts['B']);
      var datas = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(statusKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var k = _step2.value;

          var data = counts[k];
          datas.push({
            label: __WEBPACK_IMPORTED_MODULE_6__store_constants__["m" /* STATUSES */][k].title,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_6__store_constants__["m" /* STATUSES */][k].color,
            borderColor: '#000',
            lineTension: 0,
            pointRadius: 1,
            borderWidth: 1,
            legend: {
              display: false
            },
            title: 'Appointments by status over time',
            data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(data)
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return {
        labels: labels,
        datasets: datas
      };
    },
    appointmentsByDay: function appointmentsByDay(state, getters) {
      var labels = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
      var data = [0, 0, 0, 0, 0, 0, 0];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(getters.activeAppointments), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var appointment = _step4.value;

          var day = __WEBPACK_IMPORTED_MODULE_5_moment___default()(appointment.start_time).day();
          data[day] = data[day] + 1;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return {
        labels: labels,
        data: data
      };
    },
    appointmentsByHour: function appointmentsByHour(state, getters) {
      var labels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      var data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(getters.activeAppointments), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var appointment = _step5.value;

          var hour = __WEBPACK_IMPORTED_MODULE_5_moment___default()(appointment.start_time).hour();
          data[hour] = data[hour] + 1;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return {
        labels: labels,
        data: data
      };
    },
    productTypeBreakdown: function productTypeBreakdown(state, getters) {
      var products = [];
      getters.services.map(function (service) {
        products = products.concat(service.products);
      });
      var labels = products.map(function (product) {
        return product.title;
      });
      var productIds = products.map(function (product) {
        return product.id;
      });
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(labels.length), function () {
        return 0;
      });
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(getters.activeAppointments), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var appointment = _step6.value;

          var index = productIds.indexOf(appointment.product);
          data[index] = data[index] + 1;
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return {
        labels: labels,
        data: data
      };
    },
    statusBreakdown: function statusBreakdown(state, getters) {
      var results = {};
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(getters.appointments), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var appointment = _step7.value;

          if (!results[appointment.status]) {
            results[appointment.status] = 0;
          }
          results[appointment.status] = results[appointment.status] + 1;
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__store_constants__["m" /* STATUSES */]);
      var labels = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_6__store_constants__["m" /* STATUSES */]).map(function (item) {
        return item.title;
      });
      var data = [];
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(keys), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var key = _step8.value;

          var res = results[key];
          if (!res) {
            res = 0;
          }
          data.push(res);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return {
        labels: labels,
        data: data
      };
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    objects: {},
    detail: {},
    indices: {
      'clientId': {}
    }
  },
  mutations: {
    addClientDetail: function addClientDetail(state, relationship) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.detail, relationship.id.toString(), relationship);
    },
    addClient: function addClient(state, client) {
      if (client && client.id) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.objects, client.id.toString(), client);
      }
    },
    addManyClients: function addManyClients(state, clients) {
      if (clients) {
        clients.forEach(function (client) {
          if (client && client.id) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.objects, client.id.toString(), client);
          }
        });
        window.localStorage.setItem('clients', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state));
      }
    },
    deleteClient: function deleteClient(state, client) {
      if (client && client.id) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.objects, client.id.toString());
      }
    },
    clearClients: function clearClients(state) {
      state.objects = {};
    },
    setState: function setState(state, newState) {
      state = newState;
    }
  },
  actions: {
    loadClientsFromOffline: function loadClientsFromOffline(_ref) {
      var state = _ref.state,
          commit = _ref.commit,
          rootState = _ref.rootState;

      var clientList = window.localStorage.getItem('clients');
      if (clientList) {
        commit('setState', JSON.parse(clientList));
      }
    }
  },
  getters: {
    clients: function clients(state) {
      var copy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.objects);

      return copy.sort(function (a, b) {
        if (a.client.first_name < b.client.first_name) {
          return -1;
        }
        if (a.client.first_name > b.client.first_name) {
          return 1;
        }
        return 0;
      });
    },

    getClientByUserId: function getClientByUserId(state, getters) {
      return function (id) {};
    },
    getClientByRelationshipId: function getClientByRelationshipId(state, getters) {
      return function (id) {
        try {
          return state.objects[id];
        } catch (err) {
          console.log(err);
          return null;
        }
      };
    },
    getClientDetailByRelationshipId: function getClientDetailByRelationshipId(state, getters) {
      return function (id) {
        try {
          return state.detail[id];
        } catch (err) {
          console.log(err);
          return null;
        }
      };
    }
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    communications: {},
    asyncMessages: []
  },
  mutations: {
    addCommunication: function addCommunication(state, communication) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.communications, communication.id, communication);
    },
    addManyCommunications: function addManyCommunications(state, communications) {
      communications.forEach(function (communication) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.communications, communication.id, communication);
      });
    },
    addAsyncMessage: function addAsyncMessage(state, message) {
      state.asyncMessages.unshift(message);
    }
  },
  getters: {
    getCommunication: function getCommunication(state) {
      return function (id) {
        if (id in state.communications) {
          return state.communications[id];
        }
      };
    },
    getCommsByBatchId: function getCommsByBatchId(state) {
      return function (batchId) {
        var commsList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.communications);
        return commsList.filter(function (comm) {
          return comm.batch_id === batchId;
        });
      };
    },
    getAsyncMessagesById: function getAsyncMessagesById(state) {
      return function (id) {
        return state.asyncMessages.filter(function (message) {
          return message.object_id === id;
        });
      };
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GlobalDialogContainer__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GlobalDialogContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_GlobalDialogContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RealTimeBeacon__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RealTimeBeacon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_RealTimeBeacon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RandomSplash__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RandomSplash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_RandomSplash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_auth_Session__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_auth_Session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_auth_Session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Version__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Version__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Login__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pickers_DateRangePicker__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pickers_DateRangePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pickers_DateRangePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_ReadOnlyBlock__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_ReadOnlyBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_app_ReadOnlyBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_appointment_Create__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_appointment_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_appointment_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_unibox_SendTemplate__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_unibox_SendTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_unibox_SendTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ui_SnapCode__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ui_SnapCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_ui_SnapCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_settings_media_Uploader__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_settings_media_Uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_pages_settings_media_Uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_actions_AppointmentAction_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_actions_AppointmentAction_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_actions_AppointmentAction_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_invoice_manage_create_confirm_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_invoice_manage_create_confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_invoice_manage_create_confirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_appointment_SetClient__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_appointment_SetClient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_appointment_SetClient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_cards_ShareCard__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_cards_ShareCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_cards_ShareCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_appointment_actions_CreateTransaction__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_appointment_actions_CreateTransaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_appointment_actions_CreateTransaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_client_Create__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_client_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_client_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_client_ClientList__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_client_ClientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_client_ClientList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_medicalaid_PatientInformationForm__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_medicalaid_PatientInformationForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_medicalaid_PatientInformationForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_invoice_SendInvoice__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_invoice_SendInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_invoice_SendInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_actions_SendToMedicalAid__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_actions_SendToMedicalAid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_actions_SendToMedicalAid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_invoice_manage_InvoiceSettings__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_invoice_manage_InvoiceSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_invoice_manage_InvoiceSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_appointment_actions_CloneAppointment_vue__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_appointment_actions_CloneAppointment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_appointment_actions_CloneAppointment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_appointment_AppointmentCodes__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_appointment_AppointmentCodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_appointment_AppointmentCodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_appointment_AppointmentProduct__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_appointment_AppointmentProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_appointment_AppointmentProduct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_forms_Zoom_MakeAppointmentOnline__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_forms_Zoom_MakeAppointmentOnline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_forms_Zoom_MakeAppointmentOnline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_auth_AccountSwitcher_vue__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_auth_AccountSwitcher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_auth_AccountSwitcher_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_appointment_Tag__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_appointment_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_appointment_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_help__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_global_events__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_statement_BulkActions_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_statement_BulkActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_statement_BulkActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_ui_AgIframe_vue__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_ui_AgIframe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_ui_AgIframe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__sentry_browser__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_axios__);






















































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_requests__["a" /* default */]],
  components: {
    AgIframe: __WEBPACK_IMPORTED_MODULE_36__components_ui_AgIframe_vue___default.a,
    GlobalEvents: __WEBPACK_IMPORTED_MODULE_34_vue_global_events__["a" /* default */],
    BulkActions: __WEBPACK_IMPORTED_MODULE_35__components_statement_BulkActions_vue___default.a,
    ReadOnlyBlock: __WEBPACK_IMPORTED_MODULE_11__components_app_ReadOnlyBlock___default.a,
    ContextualHelp: __WEBPACK_IMPORTED_MODULE_33__components_help___default.a,
    GlobalDialogContainer: __WEBPACK_IMPORTED_MODULE_4__components_GlobalDialogContainer___default.a,
    Version: __WEBPACK_IMPORTED_MODULE_8__components_Version___default.a,
    LoginPage: __WEBPACK_IMPORTED_MODULE_9__components_pages_Login___default.a,
    RealTimeBeacon: __WEBPACK_IMPORTED_MODULE_5__components_RealTimeBeacon___default.a,
    RandomSplash: __WEBPACK_IMPORTED_MODULE_6__components_RandomSplash___default.a,
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_10__components_pickers_DateRangePicker___default.a,
    Session: __WEBPACK_IMPORTED_MODULE_7__components_auth_Session___default.a,
    Uploader: __WEBPACK_IMPORTED_MODULE_15__components_pages_settings_media_Uploader___default.a,
    AccountSwitcher: __WEBPACK_IMPORTED_MODULE_31__components_auth_AccountSwitcher_vue___default.a,

    AppointmentAction: __WEBPACK_IMPORTED_MODULE_16__components_actions_AppointmentAction_vue___default.a,

    InvoiceQuickCreate: __WEBPACK_IMPORTED_MODULE_17__components_invoice_manage_create_confirm_vue___default.a,
    SendToMedicalAid: __WEBPACK_IMPORTED_MODULE_25__components_actions_SendToMedicalAid___default.a,
    SendTemplate: __WEBPACK_IMPORTED_MODULE_13__components_unibox_SendTemplate___default.a,
    SetClient: __WEBPACK_IMPORTED_MODULE_18__components_appointment_SetClient___default.a,
    Payment: __WEBPACK_IMPORTED_MODULE_20__components_appointment_actions_CreateTransaction___default.a,
    SnapCode: __WEBPACK_IMPORTED_MODULE_14__components_ui_SnapCode___default.a,
    ShareCard: __WEBPACK_IMPORTED_MODULE_19__components_cards_ShareCard___default.a,
    Client: __WEBPACK_IMPORTED_MODULE_21__components_client_Create___default.a,
    ClientList: __WEBPACK_IMPORTED_MODULE_22__components_client_ClientList___default.a,
    PatientInformationForm: __WEBPACK_IMPORTED_MODULE_23__components_medicalaid_PatientInformationForm___default.a,
    SendInvoice: __WEBPACK_IMPORTED_MODULE_24__components_invoice_SendInvoice___default.a,
    InvoiceSettings: __WEBPACK_IMPORTED_MODULE_26__components_invoice_manage_InvoiceSettings___default.a,
    CloneAppointment: __WEBPACK_IMPORTED_MODULE_27__components_appointment_actions_CloneAppointment_vue___default.a,
    AppointmentQuickCreate: __WEBPACK_IMPORTED_MODULE_12__components_appointment_Create___default.a,

    AppointmentCodes: __WEBPACK_IMPORTED_MODULE_28__components_appointment_AppointmentCodes___default.a,
    AppointmentProduct: __WEBPACK_IMPORTED_MODULE_29__components_appointment_AppointmentProduct___default.a,
    AppointmentTags: __WEBPACK_IMPORTED_MODULE_32__components_appointment_Tag___default.a,
    MakeAppointmentOnline: __WEBPACK_IMPORTED_MODULE_30__components_forms_Zoom_MakeAppointmentOnline___default.a
  },
  data: function data() {
    return {
      appIsReady: false,
      mobileAppNotice: false,
      showiframe: false,
      iframeSrc: 'https://settings.appointmentguru.co?frame=i#/wizards/invite/',
      showInstallInstructions: false,
      showBottomNav: true,
      offsetTop: 0,
      upgradeDialog: false,
      drawer: false,
      mini: true,
      showFab: false,
      showHelp: false,
      tutToucher: 1,
      expandFab: false,
      showRangePicker: false,
      showProfileDialog: false,
      navItems: __WEBPACK_IMPORTED_MODULE_2__router__["b" /* ROUTES */],
      right: null,
      appStyle: {},
      appClasses: ["web"],
      date: __WEBPACK_IMPORTED_MODULE_39_moment___default()().format('YYYY-MM-DD'),
      activeDialog: false,
      showGlobalDialogSpace: false,
      showGlobalDialogSecondarySpace: false,
      LINKS: __WEBPACK_IMPORTED_MODULE_1__store_constants__["a" /* LINKS */]
    };
  },

  watch: {
    isLoggedIn: function isLoggedIn() {
      if (this.isLoggedIn) {
        this.initSession();
      }
    },
    showHelp: function showHelp() {
      this.tutToucher++;
    },
    currentPath: function currentPath() {
      if (this.globalSelectedAppointments && this.globalSelectedAppointments.length > 0) {
        this.globalSelectedAppointments = [];
      }
    },
    meId: function meId() {
      var _this = this;

      if (this.meId) {
        if (window.plugins && window.plugins.OneSignal) {
          window.plugins.OneSignal.sendTag('practitioner.' + this.meId, 'general');
          window.plugins.OneSignal.syncHashedEmail(this.me.email);
        }

        this.$ga.set('userId', this.meId);
        this.$ga.event('authentication', 'user authenticated');

        if (this.$cookies.get('referrers')) {
          var referrers = decodeURIComponent(this.$cookies.get('referrers'));
          try {
            referrers = JSON.parse(referrers);
          } catch (ex) {
            console.error('cookie is not json');
          }
          if (Array.isArray(referrers)) {
            referrers = referrers.join(',');
          }
          var url = 'https://api.appointmentguru.co/api/practitioners/' + this.meId + '/add_source/';

          var headers = this.$appointmentguru.headers;
          var data = { sources: referrers };
          var options = { url: url, data: data, headers: headers, method: 'post' };
          __WEBPACK_IMPORTED_MODULE_40_axios___default()(options).then(function (res) {
            _this.$cookies.remove('referrers');
          }).catch(function (res) {
            console.log('server error');
          });
        } else {
          this.$cookies.remove('referrers');
        }
        this.appIsReady = true;
        setTimeout(this.checkForUpdates, 3000);
      }
      try {
        __WEBPACK_IMPORTED_MODULE_37__sentry_browser__["b" /* configureScope */](function (scope) {
          scope.setUser({ id: _this.meId });
        });
      } catch (err) {
        console.log('something wrong with sentry');
      }
    },
    getInvoiceSettingsRequestStatus: function getInvoiceSettingsRequestStatus() {
      if (this.getInvoiceSettingsRequestStatus === 200) {
        var data = this.getInvoiceSettingsRequest.result.data;
        if (data && data.active_version !== 1) {}
      }
    },
    dialogVisibility: function dialogVisibility() {
      this.activeDialog = this.dialogVisibility;
    },
    globalDialogIsVisible: function globalDialogIsVisible() {
      this.showGlobalDialogSpace = this.globalDialogIsVisible;
    },
    globalSecondaryDialogIsVisible: function globalSecondaryDialogIsVisible() {
      this.showGlobalDialogSecondarySpace = this.globalSecondaryDialogIsVisible;
    },
    dateRangeActivated: function dateRangeActivated() {
      this.showRangePicker = true;
    },
    saveInvoiceRequestStatus: function saveInvoiceRequestStatus() {
      if (this.saveInvoiceRequestStatus === 201) {
        this.loadInvoices();
      }
    }
  },
  methods: {
    initSession: function initSession() {
      console.log('initing session');
      this.getMe();
      this.getAppointmentsInRange();
      this.getClients();
      this.getGroups();
      this.getLookups();
    },
    checkForUpdates: function checkForUpdates() {},
    setBackground: function setBackground(stylez) {
      this.appStyle = stylez;
    },
    openHelp: function openHelp() {
      window.open('https://appointmentguru.co/help/', '_blank');
    },
    onScroll: function onScroll(e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    },
    doLogin: function doLogin(payload) {
      this.$store.dispatch('LOGIN', payload);
    },
    installMobile: function installMobile() {
      if (window.guruinstaller && window.guruinstaller.prompt) {
        window.guruinstaller.prompt();
      } else {
        this.showInstallInstructions = true;
      }
    },
    pushGlobalEvent: function pushGlobalEvent(data) {
      var componentName = this.getObjectPath(this.spaces, 'globalDialog.component', null);
      if (componentName) {
        var options = { componentName: componentName, data: data };
        this.$store.commit('globalEvent', options);
      }
    },
    globalEventFilter: function globalEventFilter(event, handler, eventName) {
      if (event.target.tagName === 'INPUT') {
        return false;
      }
      if (event.target.tagName === 'TEXTAREA') {
        return false;
      }
      return true;
    },
    closeActiveDialog: function closeActiveDialog() {
      var _this2 = this;

      this.activeDialog = false;
      setTimeout(function () {
        _this2.$store.dispatch('SHOW_APPOINTMENT_DIALOG', [false]);
      }, 100);
    }
  },
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38_vuex__["b" /* mapGetters */])(['settings', 'token', 'lookups', 'isReadOnly', 'isLoggedIn']), {
    currentPath: function currentPath() {
      return this.$route.fullPath;
    },
    guruinstaller: function guruinstaller() {
      return window.guruinstaller;
    },
    isInstalled: function isInstalled() {
      if (window.navigator.standalone) {
        return true;
      }
      return false;
    },

    activeDateRange: {
      get: function get() {
        return this.$store.getters.activeDateRange;
      },
      set: function set(value) {
        this.$store.commit('SET_ACTIVE_DATE_RANGE', [value.from, value.to]);
      }
    },
    dateRangeActivated: function dateRangeActivated() {
      return this.$store.state.application.activateRangePicker;
    },
    version: function version() {
      return '0.0.39';
    },
    saveInvoiceRequest: function saveInvoiceRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_1__store_constants__["b" /* SAVE_INVOICE_REQ */], true);
    },
    saveInvoiceRequestStatus: function saveInvoiceRequestStatus() {
      return this.saveInvoiceRequest.status;
    },
    pageLoading: function pageLoading() {
      var globalRequests = [__WEBPACK_IMPORTED_MODULE_1__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */], __WEBPACK_IMPORTED_MODULE_1__store_constants__["d" /* LIST_CLIENTS_REQ */], __WEBPACK_IMPORTED_MODULE_1__store_constants__["e" /* LIST_INVOICES_IN_RANGE_REQ */], __WEBPACK_IMPORTED_MODULE_1__store_constants__["f" /* GET_ME_REQ */]];
      for (var reqId in globalRequests) {
        var req = this.$store.getters.getRequestById(reqId);
        if (req.loading) {
          return true;
        }
      }
      return false;
    },
    dialogVisibility: function dialogVisibility() {
      return this.$store.state.application.activeDialog;
    },
    activeComponent: function activeComponent() {
      return this.$store.state.application.activeDialog;
    },
    spaces: function spaces() {
      return this.$store.state.application.spaces;
    },
    globalDialogIsVisible: function globalDialogIsVisible() {
      return this.spaces.globalDialog.visible;
    },
    globalSecondaryDialogIsVisible: function globalSecondaryDialogIsVisible() {
      return this.spaces.secondaryGlobalDialog.visible;
    },
    dialogTitle: function dialogTitle() {
      var titles = {
        'Reschedule': 'Reschedule',
        'Notes': 'Add a note',
        'Cancel': 'Cancel appointment',
        'CreateClient': 'New client',
        'InvoiceDetails': 'Add invoice details',
        'QuickCreate': 'New appointment'
      };
      var dialog = this.activeDialog;
      if (dialog) {
        return titles[dialog];
      }
    },
    appointment: function appointment() {
      return this.$store.state.application.activeAppointment || {};
    },
    me: function me() {
      return this.$store.getters.me;
    },
    meId: function meId() {
      return this.$store.getters.me.id;
    },
    groups: function groups() {
      var req = this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_1__store_constants__["g" /* LIST_GROUPS_REQ */], true);
      if (req && req.result && req.result.data && req.result.data) {
        return req.result.data;
      }
      return [];
    },
    profilePicture: function profilePicture() {
      if (this.me && this.me.profile) {
        if (this.me.profile.profile_picture) {
          return this.me.profile.profile_picture;
        }
        if (this.me.profile.logo_picture) {
          return this.me.profile.logo_picture;
        }
      }
    }
  })
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrudTable',
  props: {
    loading: { type: Boolean, default: false },
    deleteable: { type: Boolean, default: true },
    withInlineDelete: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    waitForServer: { type: Boolean, default: false },
    closeOnEdit: { type: Boolean, default: true },
    deleteReqId: { type: String, required: false },
    editReqId: { type: String, required: false },
    createReqId: { type: String, required: false },
    noDataText: { type: String, default: 'No items found' },
    headers: { type: Array, default: function _default() {
        return [];
      } },
    dialogWidth: { type: Number, default: 400 },
    items: { type: Array, default: function _default() {
        return [];
      } },
    ignoredFields: { type: Array, default: function _default() {
        return ['del'];
      } },
    selectable: { type: Boolean, default: false },
    withExpand: { type: Boolean, default: false },
    withInlineHelp: { type: Boolean, default: false },
    emptyBtnText: { type: String, default: 'Add new record' },
    confirmDeleteTitle: { type: String, default: 'Are you sure?' },
    confirmDeleteTagline: { type: String, default: 'Are you sure you want to delete this row?' },
    deleteIcon: { type: String, default: 'delete' },
    deleteText: { type: String, default: 'Delete' }
  },
  computed: {
    tableHeaders: function tableHeaders() {
      return this.headers.filter(function (header) {
        return header.displayInTable !== false;
      });
    },
    editRequest: function editRequest() {
      return this.$store.getters.getRequestById(this.editReqId, true);
    },
    editRequestStatus: function editRequestStatus() {
      return this.editRequest.status;
    },
    createRequest: function createRequest() {
      return this.$store.getters.getRequestById(this.createReqId, true);
    },
    createRequestStatus: function createRequestStatus() {
      return this.createRequest.status;
    },
    deleteRequest: function deleteRequest() {
      return this.$store.getters.getRequestById(this.deleteReqId, true);
    },
    deleteRequestStatus: function deleteRequestStatus() {
      return this.deleteRequest.status;
    },
    errors: function errors() {
      if (this.editRequestStatus === 400 || this.createRequestStatus === 400) {
        return this.getObjectPath(this.editRequest, 'result.data', {});
      }
      return {};
    }
  },
  methods: {
    getErrors: function getErrors(field) {
      if (this.errors && this.errors[field]) {
        return this.errors[field];
      }
      return [];
    },
    setBlankSelectedRow: function setBlankSelectedRow() {
      this.selectedRow = {};
      if (this.headers) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.headers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var field = _step.value;

            if (this.ignoredFields.indexOf(field.value) === -1) {
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.selectedRow, field.value, '');
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    addRow: function addRow(withClose) {
      this.$emit('add', this.selectedRow);
      this.items.push(this.selectedRow);
      if (withClose) {
        if (!this.waitForServer) {
          this.addedit = false;
          this.$emit('crud:adddialogclosed');
        }
      } else {
        var oldSelectedRow = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedRow));
        this.setBlankSelectedRow();
        if (this.headers) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.headers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var field = _step2.value;

              if (this.ignoredFields.indexOf(field.value) === -1) {
                __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.selectedRow, field.value, oldSelectedRow[field.value]);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }
    },
    editRow: function editRow() {
      if (this.closeOnEdit) {
        this.addedit = false;
      }
      this.$emit('edit', this.selectedRow);
    },
    deleteRow: function deleteRow() {
      this.$emit('delete', this.selectedRow);
      if (!this.waitForServer) {
        this.confirmDelete = false;
        this.addedit = false;
      }
    },
    noop: function noop() {}
  },
  mounted: function mounted() {
    this.tableItems = this.items;
    if (this.waitForServer === true) {
      if (!this.editReqId || !this.createReqId || !this.deleteReqId) {
        console.error('WaitforServer is true. But one of editReqId, createReqId or deleteReqId is missing');
        console.log('edit', this.editReqId);
        console.log('create', this.createReqId);
        console.log('create', this.deleteReqId);
      }
    }
  },

  watch: {
    tableItems: function tableItems() {
      this.$emit('input', this.tableItems);
    },
    items: function items() {
      if (this.items) {
        this.tableItems = this.items;
      }
    },
    selectAll: function selectAll() {
      console.log(this.tableItems);
      if (this.selectAll === true) {
        this.selected = this.tableItems;
      } else {
        this.selected = [];
      }
    },
    editRequestStatus: function editRequestStatus() {
      if (this.editRequestStatus === 200) {
        this.successsnacker = true;
        var vm = this;
        window.setTimeout(function () {
          vm.successsnacker = false;
        }, 2000);
      }
    },
    createRequestStatus: function createRequestStatus() {
      if (this.editRequestStatus === 201) {
        this.successsnacker = true;
        var vm = this;
        window.setTimeout(function () {
          vm.successsnacker = false;
          vm.addedit = false;
        }, 2000);
      }
    },
    deleteRequestStatus: function deleteRequestStatus() {
      if (this.editRequestStatus === 204) {
        this.successsnacker = true;
        var vm = this;
        window.setTimeout(function () {
          vm.successsnacker = false;
          vm.confirmDelete = false;
          vm.addedit = false;
        }, 2000);
      }
    }
  },
  data: function data() {
    return {
      selectAll: false,
      successsnacker: false,
      isValid: false,
      tableItems: [],
      addedit: false,
      confirmDelete: false,
      editmode: 'add',
      selectedRow: [],
      selected: [],
      selectedIndex: 0
    };
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_edit_Reschedule__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_edit_Reschedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_edit_Reschedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_edit_InvoiceDetails__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_edit_InvoiceDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appointment_edit_InvoiceDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_edit_Notes__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_edit_Notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_appointment_edit_Notes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_Cancel__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_Cancel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_Cancel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_appointment_edit_Delete__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_appointment_edit_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_appointment_edit_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_Create__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_appointment_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_client_Create__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_client_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_client_Create__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GlobalDialogContainer',
  props: {
    appointment: { type: Object, default: function _default() {
        return {};
      } },
    initial: { type: String, default: 'Reschedule' },
    withToolbar: { type: Boolean, default: true }
  },
  components: {
    Reschedule: __WEBPACK_IMPORTED_MODULE_0__components_appointment_edit_Reschedule___default.a,
    InvoiceDetails: __WEBPACK_IMPORTED_MODULE_1__components_appointment_edit_InvoiceDetails___default.a,
    Notes: __WEBPACK_IMPORTED_MODULE_2__components_appointment_edit_Notes___default.a,
    Cancel: __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_Cancel___default.a,
    Delete: __WEBPACK_IMPORTED_MODULE_4__components_appointment_edit_Delete___default.a,
    QuickCreate: __WEBPACK_IMPORTED_MODULE_5__components_appointment_Create___default.a,

    CreateClient: __WEBPACK_IMPORTED_MODULE_6__components_client_Create___default.a
  },
  watch: {
    initial: function initial() {
      this.activeComponent = this.initial;
    },
    activeComponent: function activeComponent() {
      if (this.activeComponent !== 'QuickCreate') {
        this.touch++;
      }
    }
  },
  data: function data() {
    return {
      activeComponent: this.initial,
      touch: 1
    };
  },

  computed: {
    standAlone: function standAlone() {
      return this.activeComponent === 'Reschedule';
    },
    withTimeSelector: function withTimeSelector() {
      return this.activeComponent === 'QuickCreate';
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HelpDialog',
  props: {
    title: { type: String, default: '' },
    text: { type: String, default: '' }
  },
  data: function data() {
    return {
      dialog: false
    };
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ObjectChip__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ObjectChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ObjectChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_edit_Notes__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_edit_Notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appointment_edit_Notes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_Tombstone__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_Tombstone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_Tombstone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_lists_SpaceFaces_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_lists_SpaceFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_lists_SpaceFaces_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lists_PractitionerFaces_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lists_PractitionerFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_lists_PractitionerFaces_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_marked__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_constants__ = __webpack_require__(2);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NoteList',
  components: { ObjectChip: __WEBPACK_IMPORTED_MODULE_0__components_ObjectChip___default.a, Notes: __WEBPACK_IMPORTED_MODULE_1__components_appointment_edit_Notes___default.a, Tombstone: __WEBPACK_IMPORTED_MODULE_2__components_app_Tombstone___default.a, SpaceFaces: __WEBPACK_IMPORTED_MODULE_3__components_lists_SpaceFaces_vue___default.a, PractitionerFaces: __WEBPACK_IMPORTED_MODULE_4__components_lists_PractitionerFaces_vue___default.a },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },

    client: { required: false },
    relationshipId: { required: false, type: Number },

    touch: { type: Number, default: 0 },
    withAdd: { type: Boolean, default: true },
    withDescription: { type: Boolean, default: true },
    emptyText: { type: String, default: 'No notes for this appointment' }
  },
  data: function data() {
    return {
      showNotes: false,
      selectedNote: null,
      pageSize: 5,
      expanded: true,
      numNotesToShow: 5,
      reqId: 'appointment-notes-list-request'
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.appointment = this.value;
      this.getNotes();
    }
  },

  watch: {
    value: function value() {
      if (this.value) {
        this.appointment = this.value;
      }
    },
    expanded: function expanded() {
      if (this.expanded === true) {
        this.getNotes();
      }
    },
    touch: function touch() {
      this.getNotes();
    },
    appointmentId: function appointmentId() {
      if (this.appointmentId) {
        this.getNotes();
      }
    },
    clientId: function clientId() {
      if (this.clientId) {
        this.getNotes();
      }
    },
    noteSaveRequestStatus: function noteSaveRequestStatus() {
      if (this.noteSaveRequestStatus === 200 || this.noteSaveRequestStatus === 201) {
        this.getNotes();
      }
    }
  },
  computed: {
    appointmentId: function appointmentId() {
      if (this.appointment) {
        return this.appointment.id;
      }
    },
    clientId: function clientId() {
      if (this.client) {
        return this.getObjectPath(this.client, 'client.id');
      }
    },
    noteSaveRequest: function noteSaveRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_6__store_constants__["t" /* NOTE_SAVE_REQ */], true);
    },
    noteSaveRequestStatus: function noteSaveRequestStatus() {
      return this.noteSaveRequest.status;
    },
    noteRequest: function noteRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    notes: function notes() {
      return this.getObjectPath(this.noteRequest, 'result.data.results', []);
    },
    notesExist: function notesExist() {
      return this.notes && this.notes.length > 0;
    },
    notesToShow: function notesToShow() {
      if (this.notesExist) {
        return this.notes.slice(0, this.numNotesToShow);
      }
      return [];
    },
    areMoreNotesToShow: function areMoreNotesToShow() {
      if (this.notesExist) {
        return this.numNotesToShow <= this.notes.length;
      }
      return false;
    }
  },
  methods: {
    canEdit: function canEdit(note) {
      console.log(note);
      if (note.owners) {
        var owners = note.owners.map(function (owner) {
          return parseInt(owner);
        });
        var meId = parseInt(this.meId);
        console.log(owners, meId);
        return owners.indexOf(meId) > -1;
      }
      return false;
    },
    isNewDate: function isNewDate(note, notes, index) {
      if (index > 0) {
        var format = 'YYYY-MM-DD';
        return this.dateformat(note.created_date, format) !== this.dateformat(notes[index - 1].created_date, format);
      }
      return true;
    },
    markdown: function markdown(text) {
      __WEBPACK_IMPORTED_MODULE_5_marked___default.a.setOptions({ sanitize: true });
      return __WEBPACK_IMPORTED_MODULE_5_marked___default()(text);
    },
    getNotes: function getNotes() {
      var params = {};
      var hasFilter = false;
      if (this.appointment && this.appointment.id) {
        params.objects_appointment = this.appointment.id;
        hasFilter = true;
      }

      if (this.relationshipId) {
        params.relationship_id = this.relationshipId;
        hasFilter = true;
      }
      if (hasFilter) {
        this.$metadataguru.resource('notes').id(this.reqId).list(params);
      }
    }
  },
  i18n: {
    messages: {
      en: {
        summary: '{count} note since {date}|{count} notes since {date}'
      }
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ObjectChip',
  props: {
    object: { type: String, default: '' }
  },
  computed: {
    objectType: function objectType() {
      if (this.object && this.object.indexOf(':') !== -1) {
        return this.object.split(':')[0];
      }
    },
    id: function id() {
      if (this.object && this.object.indexOf(':') !== -1) {
        return this.object.split(':')[1];
      }
    }
  },
  methods: {
    clicked: function clicked() {
      if (this.objectType && this.id) {
        if (this.objectType === 'appointment') {
          this.gotoPath('/appointments/' + this.id);
        }
        if (this.objectType === 'client') {
          this.gotoPath('/clients/' + this.id);
        }
      }
    }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PageToolbar',
  props: {
    value: { type: String, default: '' },
    initialExtended: { type: Boolean, default: false },
    withSearch: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      extended: this.initialExtended,
      searchText: this.value
    };
  },
  mounted: function mounted() {
    this.extended = this.initialExtended;
  },

  watch: {
    searchText: function searchText() {
      this.$emit('input', this.searchText);
    }
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js__ = __webpack_require__(192);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PhoneNumberInput',
  props: {
    value: { type: String },
    touch: { type: String },
    selectedCountryCode: { type: String, default: 'ZA' },
    verbose: { type: Boolean, default: false },
    shortList: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      rawPhoneNumber: null,
      countryCodePicker: false,
      isocode: 'ZA',
      searchString: null,
      countryCodes: [{ 'code': 93, 'name': 'Afghanistan', 'iso2': 'AF' }, { 'code': 358, 'name': 'Aland Islands', 'iso2': 'AX' }, { 'code': 355, 'name': 'Albania', 'iso2': 'AL' }, { 'code': 213, 'name': 'Algeria', 'iso2': 'DZ' }, { 'code': 1, 'name': 'American Samoa', 'iso2': 'AS' }, { 'code': 376, 'name': 'Andorra', 'iso2': 'AD' }, { 'code': 244, 'name': 'Angola', 'iso2': 'AO' }, { 'code': 1, 'name': 'Anguilla', 'iso2': 'AI' }, { 'code': null, 'name': 'Antarctica', 'iso2': 'AQ' }, { 'code': 1, 'name': 'Antigua and Barbuda', 'iso2': 'AG' }, { 'code': 54, 'name': 'Argentina', 'iso2': 'AR' }, { 'code': 374, 'name': 'Armenia', 'iso2': 'AM' }, { 'code': 297, 'name': 'Aruba', 'iso2': 'AW' }, { 'code': 61, 'name': 'Australia', 'iso2': 'AU' }, { 'code': 43, 'name': 'Austria', 'iso2': 'AT' }, { 'code': 994, 'name': 'Azerbaijan', 'iso2': 'AZ' }, { 'code': 1, 'name': 'Bahamas', 'iso2': 'BS' }, { 'code': 973, 'name': 'Bahrain', 'iso2': 'BH' }, { 'code': 880, 'name': 'Bangladesh', 'iso2': 'BD' }, { 'code': 1, 'name': 'Barbados', 'iso2': 'BB' }, { 'code': 375, 'name': 'Belarus', 'iso2': 'BY' }, { 'code': 32, 'name': 'Belgium', 'iso2': 'BE' }, { 'code': 501, 'name': 'Belize', 'iso2': 'BZ' }, { 'code': 229, 'name': 'Benin', 'iso2': 'BJ' }, { 'code': 1, 'name': 'Bermuda', 'iso2': 'BM' }, { 'code': 975, 'name': 'Bhutan', 'iso2': 'BT' }, { 'code': 591, 'name': 'Bolivia,  Plurinational State of', 'iso2': 'BO' }, { 'code': 599, 'name': 'Bonaire,  Sint Eustatius and Saba', 'iso2': 'BQ' }, { 'code': 387, 'name': 'Bosnia and Herzegovina', 'iso2': 'BA' }, { 'code': 267, 'name': 'Botswana', 'iso2': 'BW' }, { 'code': null, 'name': 'Bouvet Island', 'iso2': 'BV' }, { 'code': 55, 'name': 'Brazil', 'iso2': 'BR' }, { 'code': 246, 'name': 'British Indian Ocean Territory', 'iso2': 'IO' }, { 'code': 673, 'name': 'Brunei Darussalam', 'iso2': 'BN' }, { 'code': 359, 'name': 'Bulgaria', 'iso2': 'BG' }, { 'code': 226, 'name': 'Burkina Faso', 'iso2': 'BF' }, { 'code': 257, 'name': 'Burundi', 'iso2': 'BI' }, { 'code': 238, 'name': 'Cabo Verde', 'iso2': 'CV' }, { 'code': 855, 'name': 'Cambodia', 'iso2': 'KH' }, { 'code': 237, 'name': 'Cameroon', 'iso2': 'CM' }, { 'code': 1, 'name': 'Canada', 'iso2': 'CA' }, { 'code': 1, 'name': 'Cayman Islands', 'iso2': 'KY' }, { 'code': 236, 'name': 'Central African Republic', 'iso2': 'CF' }, { 'code': 235, 'name': 'Chad', 'iso2': 'TD' }, { 'code': 56, 'name': 'Chile', 'iso2': 'CL' }, { 'code': 86, 'name': 'China', 'iso2': 'CN' }, { 'code': 61, 'name': 'Christmas Island', 'iso2': 'CX' }, { 'code': 61, 'name': 'Cocos (Keeling) Islands', 'iso2': 'CC' }, { 'code': 57, 'name': 'Colombia', 'iso2': 'CO' }, { 'code': 269, 'name': 'Comoros', 'iso2': 'KM' }, { 'code': 242, 'name': 'Congo', 'iso2': 'CG' }, { 'code': 243, 'name': 'Congo,  The Democratic Republic of the', 'iso2': 'CD' }, { 'code': 682, 'name': 'Cook Islands', 'iso2': 'CK' }, { 'code': 506, 'name': 'Costa Rica', 'iso2': 'CR' }, { 'code': 385, 'name': 'Croatia', 'iso2': 'HR' }, { 'code': 53, 'name': 'Cuba', 'iso2': 'CU' }, { 'code': 599, 'name': 'Curaçao', 'iso2': 'CW' }, { 'code': 357, 'name': 'Cyprus', 'iso2': 'CY' }, { 'code': 420, 'name': 'Czechia', 'iso2': 'CZ' }, { 'code': 225, 'name': 'Côte dIvoire', 'iso2': 'CI' }, { 'code': 45, 'name': 'Denmark', 'iso2': 'DK' }, { 'code': 253, 'name': 'Djibouti', 'iso2': 'DJ' }, { 'code': 1, 'name': 'Dominica', 'iso2': 'DM' }, { 'code': 1, 'name': 'Dominican Republic', 'iso2': 'DO' }, { 'code': 593, 'name': 'Ecuador', 'iso2': 'EC' }, { 'code': 20, 'name': 'Egypt', 'iso2': 'EG' }, { 'code': 503, 'name': 'El Salvador', 'iso2': 'SV' }, { 'code': 240, 'name': 'Equatorial Guinea', 'iso2': 'GQ' }, { 'code': 291, 'name': 'Eritrea', 'iso2': 'ER' }, { 'code': 372, 'name': 'Estonia', 'iso2': 'EE' }, { 'code': 251, 'name': 'Ethiopia', 'iso2': 'ET' }, { 'code': 500, 'name': 'Falkland Islands (Malvinas)', 'iso2': 'FK' }, { 'code': 298, 'name': 'Faroe Islands', 'iso2': 'FO' }, { 'code': 679, 'name': 'Fiji', 'iso2': 'FJ' }, { 'code': 358, 'name': 'Finland', 'iso2': 'FI' }, { 'code': 33, 'name': 'France', 'iso2': 'FR' }, { 'code': 594, 'name': 'French Guiana', 'iso2': 'GF' }, { 'code': 689, 'name': 'French Polynesia', 'iso2': 'PF' }, { 'code': null, 'name': 'French Southern Territories', 'iso2': 'TF' }, { 'code': 241, 'name': 'Gabon', 'iso2': 'GA' }, { 'code': 220, 'name': 'Gambia', 'iso2': 'GM' }, { 'code': 995, 'name': 'Georgia', 'iso2': 'GE' }, { 'code': 49, 'name': 'Germany', 'iso2': 'DE' }, { 'code': 233, 'name': 'Ghana', 'iso2': 'GH' }, { 'code': 350, 'name': 'Gibraltar', 'iso2': 'GI' }, { 'code': 30, 'name': 'Greece', 'iso2': 'GR' }, { 'code': 299, 'name': 'Greenland', 'iso2': 'GL' }, { 'code': 1, 'name': 'Grenada', 'iso2': 'GD' }, { 'code': 590, 'name': 'Guadeloupe', 'iso2': 'GP' }, { 'code': 1, 'name': 'Guam', 'iso2': 'GU' }, { 'code': 502, 'name': 'Guatemala', 'iso2': 'GT' }, { 'code': 44, 'name': 'Guernsey', 'iso2': 'GG' }, { 'code': 224, 'name': 'Guinea', 'iso2': 'GN' }, { 'code': 245, 'name': 'Guinea-Bissau', 'iso2': 'GW' }, { 'code': 592, 'name': 'Guyana', 'iso2': 'GY' }, { 'code': 509, 'name': 'Haiti', 'iso2': 'HT' }, { 'code': null, 'name': 'Heard Island and McDonald Islands', 'iso2': 'HM' }, { 'code': 39, 'name': 'Holy See (Vatican City State)', 'iso2': 'VA' }, { 'code': 504, 'name': 'Honduras', 'iso2': 'HN' }, { 'code': 852, 'name': 'Hong Kong', 'iso2': 'HK' }, { 'code': 36, 'name': 'Hungary', 'iso2': 'HU' }, { 'code': 354, 'name': 'Iceland', 'iso2': 'IS' }, { 'code': 91, 'name': 'India', 'iso2': 'IN' }, { 'code': 62, 'name': 'Indonesia', 'iso2': 'ID' }, { 'code': 98, 'name': 'Iran,  Islamic Republic of', 'iso2': 'IR' }, { 'code': 964, 'name': 'Iraq', 'iso2': 'IQ' }, { 'code': 353, 'name': 'Ireland', 'iso2': 'IE' }, { 'code': 44, 'name': 'Isle of Man', 'iso2': 'IM' }, { 'code': 972, 'name': 'Israel', 'iso2': 'IL' }, { 'code': 39, 'name': 'Italy', 'iso2': 'IT' }, { 'code': 1, 'name': 'Jamaica', 'iso2': 'JM' }, { 'code': 81, 'name': 'Japan', 'iso2': 'JP' }, { 'code': 44, 'name': 'Jersey', 'iso2': 'JE' }, { 'code': 962, 'name': 'Jordan', 'iso2': 'JO' }, { 'code': 7, 'name': 'Kazakhstan', 'iso2': 'KZ' }, { 'code': 254, 'name': 'Kenya', 'iso2': 'KE' }, { 'code': 686, 'name': 'Kiribati', 'iso2': 'KI' }, { 'code': 850, 'name': 'Democratic Peoples Republic of Korea', 'iso2': 'KP' }, { 'code': 82, 'name': 'Republic of Korea', 'iso2': 'KR' }, { 'code': 965, 'name': 'Kuwait', 'iso2': 'KW' }, { 'code': 996, 'name': 'Kyrgyzstan', 'iso2': 'KG' }, { 'code': 856, 'name': 'Lao Peoples Democratic Republic', 'iso2': 'LA' }, { 'code': 371, 'name': 'Latvia', 'iso2': 'LV' }, { 'code': 961, 'name': 'Lebanon', 'iso2': 'LB' }, { 'code': 266, 'name': 'Lesotho', 'iso2': 'LS' }, { 'code': 231, 'name': 'Liberia', 'iso2': 'LR' }, { 'code': 218, 'name': 'Libya', 'iso2': 'LY' }, { 'code': 423, 'name': 'Liechtenstein', 'iso2': 'LI' }, { 'code': 370, 'name': 'Lithuania', 'iso2': 'LT' }, { 'code': 352, 'name': 'Luxembourg', 'iso2': 'LU' }, { 'code': 853, 'name': 'Macao', 'iso2': 'MO' }, { 'code': 389, 'name': 'Macedonia Republic of', 'iso2': 'MK' }, { 'code': 261, 'name': 'Madagascar', 'iso2': 'MG' }, { 'code': 265, 'name': 'Malawi', 'iso2': 'MW' }, { 'code': 60, 'name': 'Malaysia', 'iso2': 'MY' }, { 'code': 960, 'name': 'Maldives', 'iso2': 'MV' }, { 'code': 223, 'name': 'Mali', 'iso2': 'ML' }, { 'code': 356, 'name': 'Malta', 'iso2': 'MT' }, { 'code': 692, 'name': 'Marshall Islands', 'iso2': 'MH' }, { 'code': 596, 'name': 'Martinique', 'iso2': 'MQ' }, { 'code': 222, 'name': 'Mauritania', 'iso2': 'MR' }, { 'code': 230, 'name': 'Mauritius', 'iso2': 'MU' }, { 'code': 262, 'name': 'Mayotte', 'iso2': 'YT' }, { 'code': 52, 'name': 'Mexico', 'iso2': 'MX' }, { 'code': 691, 'name': 'Micronesia', 'iso2': 'FM' }, { 'code': 373, 'name': 'Moldova', 'iso2': 'MD' }, { 'code': 377, 'name': 'Monaco', 'iso2': 'MC' }, { 'code': 976, 'name': 'Mongolia', 'iso2': 'MN' }, { 'code': 382, 'name': 'Montenegro', 'iso2': 'ME' }, { 'code': 1, 'name': 'Montserrat', 'iso2': 'MS' }, { 'code': 212, 'name': 'Morocco', 'iso2': 'MA' }, { 'code': 258, 'name': 'Mozambique', 'iso2': 'MZ' }, { 'code': 95, 'name': 'Myanmar', 'iso2': 'MM' }, { 'code': 264, 'name': 'Namibia', 'iso2': 'NA' }, { 'code': 674, 'name': 'Nauru', 'iso2': 'NR' }, { 'code': 977, 'name': 'Nepal', 'iso2': 'NP' }, { 'code': 31, 'name': 'Netherlands', 'iso2': 'NL' }, { 'code': 687, 'name': 'New Caledonia', 'iso2': 'NC' }, { 'code': 64, 'name': 'New Zealand', 'iso2': 'NZ' }, { 'code': 505, 'name': 'Nicaragua', 'iso2': 'NI' }, { 'code': 227, 'name': 'Niger', 'iso2': 'NE' }, { 'code': 234, 'name': 'Nigeria', 'iso2': 'NG' }, { 'code': 683, 'name': 'Niue', 'iso2': 'NU' }, { 'code': 672, 'name': 'Norfolk Island', 'iso2': 'NF' }, { 'code': 1, 'name': 'Northern Mariana Islands', 'iso2': 'MP' }, { 'code': 47, 'name': 'Norway', 'iso2': 'NO' }, { 'code': 968, 'name': 'Oman', 'iso2': 'OM' }, { 'code': 92, 'name': 'Pakistan', 'iso2': 'PK' }, { 'code': 680, 'name': 'Palau', 'iso2': 'PW' }, { 'code': 970, 'name': 'Palestine', 'iso2': 'PS' }, { 'code': 507, 'name': 'Panama', 'iso2': 'PA' }, { 'code': 675, 'name': 'Papua New Guinea', 'iso2': 'PG' }, { 'code': 595, 'name': 'Paraguay', 'iso2': 'PY' }, { 'code': 51, 'name': 'Peru', 'iso2': 'PE' }, { 'code': 63, 'name': 'Philippines', 'iso2': 'PH' }, { 'code': null, 'name': 'Pitcairn', 'iso2': 'PN' }, { 'code': 48, 'name': 'Poland', 'iso2': 'PL' }, { 'code': 351, 'name': 'Portugal', 'iso2': 'PT' }, { 'code': 1, 'name': 'Puerto Rico', 'iso2': 'PR' }, { 'code': 974, 'name': 'Qatar', 'iso2': 'QA' }, { 'code': 40, 'name': 'Romania', 'iso2': 'RO' }, { 'code': 7, 'name': 'Russian Federation', 'iso2': 'RU' }, { 'code': 250, 'name': 'Rwanda', 'iso2': 'RW' }, { 'code': 262, 'name': 'Réunion', 'iso2': 'RE' }, { 'code': 590, 'name': 'Saint Barthélemy', 'iso2': 'BL' }, { 'code': 290, 'name': 'Saint Helena Ascension and Tristan da Cunha', 'iso2': 'SH' }, { 'code': 1, 'name': 'Saint Kitts and Nevis', 'iso2': 'KN' }, { 'code': 1, 'name': 'Saint Lucia', 'iso2': 'LC' }, { 'code': 590, 'name': 'Saint Martin (French part)', 'iso2': 'MF' }, { 'code': 508, 'name': 'Saint Pierre and Miquelon', 'iso2': 'PM' }, { 'code': 1, 'name': 'Saint Vincent and the Grenadines', 'iso2': 'VC' }, { 'code': 685, 'name': 'Samoa', 'iso2': 'WS' }, { 'code': 378, 'name': 'San Marino', 'iso2': 'SM' }, { 'code': 239, 'name': 'Sao Tome and Principe', 'iso2': 'ST' }, { 'code': 966, 'name': 'Saudi Arabia', 'iso2': 'SA' }, { 'code': 221, 'name': 'Senegal', 'iso2': 'SN' }, { 'code': 381, 'name': 'Serbia', 'iso2': 'RS' }, { 'code': 248, 'name': 'Seychelles', 'iso2': 'SC' }, { 'code': 232, 'name': 'Sierra Leone', 'iso2': 'SL' }, { 'code': 65, 'name': 'Singapore', 'iso2': 'SG' }, { 'code': 1, 'name': 'Sint Maarten (Dutch part)', 'iso2': 'SX' }, { 'code': 421, 'name': 'Slovakia', 'iso2': 'SK' }, { 'code': 386, 'name': 'Slovenia', 'iso2': 'SI' }, { 'code': 677, 'name': 'Solomon Islands', 'iso2': 'SB' }, { 'code': 252, 'name': 'Somalia', 'iso2': 'SO' }, { 'code': 27, 'name': 'South Africa', 'iso2': 'ZA' }, { 'code': null, 'name': 'South Georgia and the South Sandwich Islands', 'iso2': 'GS' }, { 'code': 211, 'name': 'South Sudan', 'iso2': 'SS' }, { 'code': 34, 'name': 'Spain', 'iso2': 'ES' }, { 'code': 94, 'name': 'Sri Lanka', 'iso2': 'LK' }, { 'code': 249, 'name': 'Sudan', 'iso2': 'SD' }, { 'code': 597, 'name': 'Suriname', 'iso2': 'SR' }, { 'code': 47, 'name': 'Svalbard and Jan Mayen', 'iso2': 'SJ' }, { 'code': 268, 'name': 'Swaziland', 'iso2': 'SZ' }, { 'code': 46, 'name': 'Sweden', 'iso2': 'SE' }, { 'code': 41, 'name': 'Switzerland', 'iso2': 'CH' }, { 'code': 963, 'name': 'Syrian Arab Republic', 'iso2': 'SY' }, { 'code': 886, 'name': 'Taiwan', 'iso2': 'TW' }, { 'code': 992, 'name': 'Tajikistan', 'iso2': 'TJ' }, { 'code': 255, 'name': 'Tanzania', 'iso2': 'TZ' }, { 'code': 66, 'name': 'Thailand', 'iso2': 'TH' }, { 'code': 670, 'name': 'Timor-Leste', 'iso2': 'TL' }, { 'code': 228, 'name': 'Togo', 'iso2': 'TG' }, { 'code': 690, 'name': 'Tokelau', 'iso2': 'TK' }, { 'code': 676, 'name': 'Tonga', 'iso2': 'TO' }, { 'code': 1, 'name': 'Trinidad and Tobago', 'iso2': 'TT' }, { 'code': 216, 'name': 'Tunisia', 'iso2': 'TN' }, { 'code': 90, 'name': 'Turkey', 'iso2': 'TR' }, { 'code': 993, 'name': 'Turkmenistan', 'iso2': 'TM' }, { 'code': 1, 'name': 'Turks and Caicos Islands', 'iso2': 'TC' }, { 'code': 688, 'name': 'Tuvalu', 'iso2': 'TV' }, { 'code': 256, 'name': 'Uganda', 'iso2': 'UG' }, { 'code': 380, 'name': 'Ukraine', 'iso2': 'UA' }, { 'code': 971, 'name': 'United Arab Emirates', 'iso2': 'AE' }, { 'code': 44, 'name': 'United Kingdom', 'iso2': 'GB' }, { 'code': 1, 'name': 'United States', 'iso2': 'US' }, { 'code': null, 'name': 'United States Minor Outlying Islands', 'iso2': 'UM' }, { 'code': 598, 'name': 'Uruguay', 'iso2': 'UY' }, { 'code': 998, 'name': 'Uzbekistan', 'iso2': 'UZ' }, { 'code': 678, 'name': 'Vanuatu', 'iso2': 'VU' }, { 'code': 58, 'name': 'Venezuela', 'iso2': 'VE' }, { 'code': 84, 'name': 'Viet Nam', 'iso2': 'VN' }, { 'code': 1, 'name': 'British Virgin Islands', 'iso2': 'VG' }, { 'code': 1, 'name': 'US Virgin Islands', 'iso2': 'VI' }, { 'code': 681, 'name': 'Wallis and Futuna', 'iso2': 'WF' }, { 'code': 212, 'name': 'Western Sahara', 'iso2': 'EH' }, { 'code': 967, 'name': 'Yemen', 'iso2': 'YE' }, { 'code': 260, 'name': 'Zambia', 'iso2': 'ZM' }, { 'code': 263, 'name': 'Zimbabwe', 'iso2': 'ZW' }]
    };
  },

  methods: {
    emitNumber: function emitNumber() {
      var numbers = this.typedNumber;
      var number = this.parsedNumber;
      var isValid = this.isValidNumber;
      this.$emit('input', number);
      this.$emit('number', number);
      this.$emit('meta', numbers);
      this.$emit('valid', isValid);
    },
    setCountry: function setCountry(country) {
      this.isocode = country.iso2;
      this.countryCodePicker = false;
      this.emitNumber();
    }
  },
  computed: {
    selectedCountry: function selectedCountry() {
      var _this = this;

      return this.countryCodes.find(function (item) {
        return _this.isocode === item.iso2;
      });
    },
    filteredCountries: function filteredCountries() {
      var _this2 = this;

      if (this.searchString === null || this.searchString.length < 1) {
        return this.countryCodes;
      }
      return this.countryCodes.filter(function (item) {
        if (!item.code || !item.name) {
          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
        } else {
          var search = _this2.searchString.toLowerCase();
          var codeMatch = item.code.toString().toLowerCase().indexOf(search) !== -1;
          var nameMatch = item.name.toLowerCase().indexOf(search) !== -1;
          return codeMatch || nameMatch;
        }
      });
    },
    filteredShortList: function filteredShortList() {
      var _this3 = this;

      if (this.shortList.length === 0) {
        return [];
      }
      return this.filteredCountries.filter(function (item) {
        return _this3.shortList.indexOf(item.iso2) !== -1;
      });
    },
    isValidNumber: function isValidNumber() {
      if (this.typedNumber) {
        return this.typedNumber.isValid();
      }
      return false;
    },
    parsedNumber: function parsedNumber() {
      if (this.typedNumber) {
        return this.typedNumber.number;
      }
      return '';
    },
    formattedNumber: function formattedNumber() {
      if (this.typedNumber) {
        return this.typedNumber.formatInternational();
      }
      return '';
    },
    numberType: function numberType() {
      if (this.typedNumber) {
        return this.typedNumber.getType();
      }
    },
    inferredCountryCode: function inferredCountryCode() {
      if (this.typedNumber) {
        return this.typedNumber.country;
      }
    },
    iconAppend: function iconAppend() {
      if (this.isValidNumber) {
        return 'check';
      }
      return 'cross';
    },
    hintText: function hintText() {
      if (!this.rawPhoneNumber) {
        return 'Please provide a valid phone number';
      }
      if (this.isValidNumber) {
        return '✓ Valid number for ' + this.selectedCountry.name + ': ' + this.formattedNumber;
      } else {
        return 'Not a valid phone number. Are you sure you have the correct country code?';
      }
    },
    typedNumber: function typedNumber() {
      if (!this.rawPhoneNumber) {
        this.rawPhoneNumber = '';
      }
      var ayt = new __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js__["a" /* AsYouType */](this.isocode);
      var inputIsInternational = this.rawPhoneNumber.startsWith('+');
      if (inputIsInternational) {
        ayt = new __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js__["a" /* AsYouType */]();
      }
      ayt.input(this.rawPhoneNumber);
      var number = ayt.getNumber();
      return number;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          var ayt = new __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js__["a" /* AsYouType */](this.value);
          ayt.input(this.value);
          var number = ayt.getNumber();
          if (number && number.isValid()) {
            this.rawPhoneNumber = this.value;
          }
        }
      }
    },
    selectedCountryCode: function selectedCountryCode() {
      if (this.selectedCountryCode) {
        this.isocode = this.selectedCountryCode;
      }
    },

    inferredCountryCode: {
      immediate: true,
      handler: function handler() {
        var typedNumberContainsCountryCode = this.rawPhoneNumber.startsWith('+');

        if (typedNumberContainsCountryCode && this.inferredCountryCode && this.inferredCountryCode !== this.isocode) {
          this.isocode = this.inferredCountryCode;
        }
      }
    },
    touch: function touch() {
      this.rawPhoneNumber = this.touch;
      this.emitNumber();
    },
    rawPhoneNumber: function rawPhoneNumber() {
      this.emitNumber();
    }
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RandomSplash',
  data: function data() {
    return {
      result: {}
    };
  },

  props: {
    withAccreditation: true,
    withDescription: true
  },
  mounted: function mounted() {
    this.changeBackground();
  },

  methods: {
    changeBackground: function changeBackground() {
      var _this = this;

      var payload = {
        headers: {
          Authorization: 'Client-ID e844ef6b655e466ae6355a7ad45e990ca3f96928ad4fa9dc1e6a3939592a3039'
        }
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.unsplash.com/photos/random?collections=1145600', payload).then(function (data) {
        vm.result = data;
        var appStyle = {
          'backgroundImage': 'url(\'' + data.data.urls.regular + '\')',
          'backgroundSize': 'cover'
        };
        _this.$emit('unpashbackground', appStyle);
      });
    }
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_requests__ = __webpack_require__(28);






var NETWORK_OFFLINE_MESSAGE = 'You are no longer connected to the internet.';
var NETWORK_RECONNECTED_MESSAGE = '\\o/ We\'re back online!';


var DEFAULT_TIMEOUT = 6000;

/* harmony default export */ __webpack_exports__["default"] = ({
  findIndex: __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default.a,
  moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_requests__["a" /* default */]],
  data: function data() {
    return {
      pubnub: null,
      snackbarVisible: false,
      message: '',
      snackbarTimeout: 6000,
      snackbarStatus: 'secondary'
    };
  },

  computed: {
    token: function token() {
      return this.$store.getters.token;
    },
    channel: function channel() {
      return this.$store.getters.me.channel;
    },
    globalNotification: function globalNotification() {
      return this.$store.state.application.notification;
    },
    activeDateRange: function activeDateRange() {
      var fromDate = this.$store.state.application.activeDateRange.from;
      var toDate = this.$store.state.application.activeDateRange.to;
      var result = fromDate + ' to ' + toDate;
      return result;
    }
  },
  watch: {
    channel: function channel() {
      if (this.channel) {
        this.pubSubInit();
      }
    },
    globalNotification: function globalNotification() {
      this.snackbar(this.globalNotification.message, DEFAULT_TIMEOUT, this.globalNotification.type);
    },
    activeDateRange: function activeDateRange() {
      this.getAppointmentsInRange();
    },
    token: function token() {
      if (!this.token) {
        if (this.pubnub) {
          this.pubnub.unsubscribeAll();
          console.log('unsubscribed');
        }
      }
    }
  },
  methods: {
    performMutation: function performMutation(_ref) {
      var mutation = _ref.mutation,
          data = _ref.data,
          mutation_type = _ref.mutation_type;

      console.log(mutation_type, mutation, data);
      if (mutation_type === 'MUTATION') {
        this.$store.commit(mutation, data);
      }
      if (mutation_type === 'ACTION') {
        this.$store.dispatch(mutation, data);
      }
    },
    getMessage: function getMessage(appointment) {
      var friendlyDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(appointment.start_time).format('HH:mm on ddd D MMM');
      var appointmentString = appointment.full_name + ' at ' + friendlyDate;
      var messageMap = {
        'schedule.models.AppointmentProcess': 'New appointment: ' + appointmentString,

        'schedule.models.AppointmentProcess.reschedule': appointment.full_name + ' rescheduled to ' + friendlyDate,

        'schedule.models.AppointmentProcess.cancel': 'Appointment cancelled: ' + appointmentString,

        'schedule.models.AppointmentProcess.updateStatus': appointment.full_name + ' updated',

        'schedule.models.AppointmentProcess.requestPayment': 'Payment request sent for ' + appointmentString,

        'schedule.models.AppointmentProcess.paymentReceived': appointmentString + ' marked as paid'
      };
      if (appointment && appointment.start_time) {
        this.$store.commit('addAppointments', [appointment]);
      }

      if (appointment.type === 'asyncmessage') {
        return appointment.message;
      }
      return messageMap[appointment.mutation];
    },
    payloadReceived: function payloadReceived(payload) {
      var isMutation = payload.message && payload.message.mutation && payload.message.mutation_type;
      if (isMutation) {
        return this.performMutation(payload.message);
      }
      var appointment = payload.message;

      var message = this.getMessage(appointment);
      if (message) {
        this.snackbar(message);
      }

      this.$store.dispatch('RETRY', __WEBPACK_IMPORTED_MODULE_2__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */]);
    },
    pubSubInit: function pubSubInit() {
      var vm = this;
      vm.networkOfflineNotification = null;
      vm.networkCompromizedNotification = null;

      var pubnub = new PubNub({
        publishKey: 'pub-c-f303e204-ee0c-4b74-8dd0-436d4a833af7',
        subscribeKey: 'sub-c-ce333652-65fa-11e6-9be8-0619f8945a4f'
      });
      vm.pubnub = pubnub;
      pubnub.addListener({
        status: function status(statusEvent) {
          var networkOfflineStatus = ['PNNetworkDownCategory', 'PNAccessDeniedCategory'];
          var networkReconnectedStatus = ['PNReconnectedCategory', 'PNNetworkUpCategory'];

          console.log(statusEvent.category);
          if (statusEvent.category === 'PNConnectedCategory') {
            console.log('realtime connected');
          }
          var networkIsOffline = networkOfflineStatus.indexOf(statusEvent.category) !== -1;

          var networkReconnected = networkReconnectedStatus.indexOf(statusEvent.category) !== -1;

          if (networkIsOffline) {
            vm.snackbar(NETWORK_OFFLINE_MESSAGE, 0, 'error');
          }

          if (networkReconnected) {
            console.log('reconnected');
            vm.snackbar(NETWORK_RECONNECTED_MESSAGE, 6000, 'success');
          }
        },
        message: function message(_message) {
          console.log(_message);
          var isWarningMessage = _message.subscribedChannel.indexOf('warnings') !== -1;
          if (isWarningMessage) {
            vm.snackbar(_message.message.title);
          } else {
            if (_message.message.type === 'invoices') {
              vm.getAppointmentsInRange();
              return vm.$store.dispatch('RETRY', __WEBPACK_IMPORTED_MODULE_2__store_constants__["e" /* LIST_INVOICES_IN_RANGE_REQ */]);
            }
            if (_message.message.type === 'asyncmessage') {
              vm.$store.commit('addAsyncMessage', _message.message);
            }
            var isCommunication = _message.message.communicationstatus;
            if (isCommunication) {
              vm.$store.commit('addCommunication', _message.message);

              return true;
            }
            vm.payloadReceived(_message);
          }
        },
        presence: function presence(presenceEvent) {
          console.log(presenceEvent);
        },
        signal: function signal(s) {
          if (s.message.rpc && s.message.args) {
            vm[s.message.rpc](s.message.args);
          } else {
            vm[s.message.rpc]();
          }
        }
      });

      pubnub.subscribe({
        channels: [vm.channel, vm.channel + '-warnings']
      });
    },
    snackbar: function snackbar(message) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6000;
      var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'secondary';

      this.snackbarVisible = false;
      this.message = message;
      this.snackbarTimeout = timeout;
      this.snackbarStatus = status;
      this.snackbarVisible = true;
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ServerErrors',
  props: {
    request: { type: Object, required: true },
    title: { type: String, default: 'There where some errors with your request' },
    alertType: { type: String, default: 'error' }
  },
  computed: {
    errorsIsIterable: function errorsIsIterable() {
      if (!this.errors) {
        return false;
      }
      if (typeof this.errors === 'string') {
        return false;
      }
      return true;
    },
    errors: function errors() {
      if (this.request && this.request.errors) {
        return this.request.errors;
      }
      if (this.request && this.request.result && this.request.result.data) {
        return this.request.result.data;
      }
      if (this.request && this.request.data) {
        if (this.request.data.message) {
          return this.request.data.message;
        }
        return this.request.data;
      }
      if (this.request && this.request.result) {
        return this.request.result;
      }
    },
    showAlert: function showAlert() {
      return this.errors.length > 0;
    }
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Version',
  props: {
    withReload: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      version: null,
      latestVersion: null,
      reloadRequired: false
    };
  },
  mounted: function mounted() {
    this.getVersion();
    setInterval(this.getVersion, 300000);
  },

  methods: {
    getVersion: function getVersion() {
      var _this = this;

      if (localStorage && localStorage.getItem('version')) {
        this.version = localStorage.getItem('version');
      }
      this.$emit('input', this.version);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/static/about.json').then(function (result) {
        var latestVersion = result.data.version;
        if (latestVersion !== _this.version) {
          caches.keys().then(function (keys) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;
                caches.delete(key);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          });
          localStorage.setItem('version', latestVersion);
          if (_this.version) {
            _this.reloadRequired = true;
          }
          _this.version = latestVersion;
        }
      });
    },
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VuexButton',
  props: {
    reqId: { type: String },
    text: { type: String },
    color: { type: String, default: 'primary' },
    classes: { type: Array, default: function _default() {
        return [];
      } },
    buttonType: { type: String, default: 'primary' },
    loadingText: { type: String, default: 'loading' },
    successText: { type: String, default: 'success' },
    successIcon: { type: String, default: 'check' },
    errorText: { type: String, default: 'Something went wrong' },
    errorIcon: { type: String, default: 'error' },
    isDisabled: { type: Boolean, default: false },
    isBlock: { type: Boolean, default: false },
    isFlat: { type: Boolean, default: false },
    initialButtonType: { type: String, default: 'primary' },
    icon: { type: String, default: '' },
    successWaitTime: { type: Number, default: 2500 }
  },
  data: function data() {
    return {
      isSuccess: false,
      isError: false,
      iconText: this.icon,
      buttonText: this.text,
      originalIcon: this.icon,
      originalText: this.text,
      state: 'neutral',
      loading: false
    };
  },
  mounted: function mounted() {
    if (this.initialButtonType === 'error') {
      this.isError = true;
    }
    if (this.initialButtonType === 'success') {
      this.isSuccess = true;
    }
  },

  computed: {
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    isPrimary: function isPrimary() {
      return this.buttonType === 'primary';
    }
  },
  watch: {
    requestStatus: function requestStatus() {
      var successResponses = [200, 201];
      if (successResponses.indexOf(this.requestStatus) !== -1) {
        this.buttonText = this.successText;
        this.iconText = this.successIcon;
        this.isSuccess = true;
        setTimeout(this.backToOriginal, this.successWaitTime);
      }
      if (this.requestStatus === 400) {
        this.buttonText = this.errorText;
        this.iconText = this.errorIcon;
        this.isError = true;
        setTimeout(this.backToOriginal, this.successWaitTime);
      }
    }
  },
  methods: {
    save: function save() {
      this.$emit('save');
    },
    backToOriginal: function backToOriginal() {
      this.buttonText = this.originalText;
      this.iconText = this.originalIcon;
      this.isSuccess = false;
      this.isError = false;
    }
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VuexLoader',
  props: {
    requestId: { type: String, required: true }
  },
  computed: {
    loading: function loading() {
      if (this.requestId) {
        var req = this.$store.getters.getRequestById(this.requestId, true);
        return req.loading;
      }
      return false;
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VuexSnackbar',
  props: {
    successMessage: { type: String },
    errorMessage: { type: String },
    reqId: { type: String }
  },
  data: function data() {
    return {
      message: null,
      snacker: false,
      color: null
    };
  },

  watch: {
    reqStatus: function reqStatus() {
      if (this.reqStatus < 300) {
        this.message = this.successMessage;
        this.color = 'success';
      } else {
        this.message = this.errorMessage;
        this.color = 'danger';
      }
      this.snacker = true;
    }
  },
  computed: {
    req: function req() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    reqStatus: function reqStatus() {
      return this.req.status;
    }
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_MobileStepLayout_vue__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_MobileStepLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_MobileStepLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_StepLayout_vue__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_StepLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_StepLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filters_AppointmentFilters_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filters_AppointmentFilters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_filters_AppointmentFilters_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lists_AppointmentList_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lists_AppointmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_lists_AppointmentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_edit_InvoiceDetails__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_edit_InvoiceDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_appointment_edit_InvoiceDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_Tombstone_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_Tombstone_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_app_Tombstone_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_invoice_manage_create_confirm_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_invoice_manage_create_confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_invoice_manage_create_confirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_CreateTransaction__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_CreateTransaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_CreateTransaction__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentAction',
  components: { AppointmentFilters: __WEBPACK_IMPORTED_MODULE_3__components_filters_AppointmentFilters_vue___default.a, AppointmentList: __WEBPACK_IMPORTED_MODULE_4__components_lists_AppointmentList_vue___default.a, InvoiceDetails: __WEBPACK_IMPORTED_MODULE_5__components_appointment_edit_InvoiceDetails___default.a, Tombstone: __WEBPACK_IMPORTED_MODULE_6__components_app_Tombstone_vue___default.a },
  props: {
    title: { type: String, required: false, default: 'Choose appointments' },
    componentName: { type: String, required: true },
    initialRelationship: { type: Object, required: false, default: null },
    initialFilters: { type: Object, required: false },
    compact: { type: Boolean, default: false },
    touch: { type: Number, default: 0 },
    pageSize: { type: Number, default: 20 }
  },
  data: function data() {
    return {
      step: 0,
      dirty: false,
      showinvoicedetails: false,
      oldestFirst: true,
      withPaid: false,
      withInvoiced: false,
      fullscreen: false,
      withPersonalFilter: false,
      filterTouch: 0,
      listTouch: 0,
      appointmentsLoading: false,
      cardView: false,
      invoice: {},
      relationshipCount: -1,
      relationship: null,
      selectedAppointment: null,
      appointments: [],
      filters: {},
      requests: {}
    };
  },

  methods: {
    setRelationship: function setRelationship(relationship) {
      this.relationship = relationship;
      if (this.relationshipId) {
        this.step++;
      }
    },
    setCount: function setCount(cnt) {
      this.relationshipCount = cnt;
    },
    reset: function reset() {
      this.step = 0;
      this.relationshipCount = -1;
      this.appointments = [];
      this.filterTouch++;

      if (this.initialRelationship) {
        this.setRelationship(this.initialRelationship);
      } else {
        this.setRelationship(null);
      }
    }
  },
  watch: {
    initialRelationship: {
      immediate: true,
      handler: function handler() {
        this.setRelationship(this.initialRelationship);
        this.listTouch++;
      }
    },
    initialFilters: {
      immediate: true,
      handler: function handler() {
        this.filters = this.initialFilters;
      }
    },
    secondaryspacevisible: function secondaryspacevisible() {
      var refreshingComponents = ['AppointmentCodes'];
      if (this.secondaryspace && this.secondaryspace.component) {
        var needsRefresh = refreshingComponents.indexOf(this.secondaryspace.component) >= 0;
        if (this.secondaryspacevisible === false && needsRefresh) {
          this.listTouch++;
        }
      }
    },
    relationshipId: function relationshipId() {
      this.appointments = [];
    },
    touch: function touch() {
      this.reset();
    },
    showinvoicedetails: function showinvoicedetails() {
      if (this.showinvoicedetails === true) {
        this.dirty = false;
      } else {
        if (this.dirty === true) {
          this.listTouch++;
        }
        this.dirty = false;
      }
    }
  },
  computed: {
    canNext: function canNext() {
      if (this.step === 0 && this.relationshipId) {
        return true;
      }
      if (this.step === 1 && this.appointments && this.appointments.length > 0) {
        return true;
      }
      return false;
    },
    secondaryspace: function secondaryspace() {
      return this.$store.state.application.spaces.secondaryGlobalDialog;
    },
    secondaryspacevisible: function secondaryspacevisible() {
      return this.$store.state.application.spaces.secondaryGlobalDialog.visible;
    },
    computedPractitionerId: function computedPractitionerId() {
      if (this.withPersonalFilter) {
        return this.meId;
      }
      return null;
    },
    layoutComponent: function layoutComponent() {
      if (this.$vuetify.breakpoint.xs) {
        return __WEBPACK_IMPORTED_MODULE_1__components_layouts_MobileStepLayout_vue___default.a;
      }
      return __WEBPACK_IMPORTED_MODULE_2__components_layouts_StepLayout_vue___default.a;
    },
    activeComponent: function activeComponent() {
      return this.components[this.componentName];
    },
    relationshipId: function relationshipId() {
      return this.getObjectPath(this.relationship, 'id', null);
    },
    initialStatuses: function initialStatuses() {
      return this.activeComponent.defaultStatuses;
    },
    statuses: function statuses() {
      var stats = this.initialStatuses;
      if (this.withInvoiced === true) {
        stats += ',I';
      }
      if (this.withPaid === true) {
        stats += ',P';
      }
      return stats;
    },
    params: function params() {
      var params = {};
      try {
        params = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filters));
      } catch (err) {
        console.log('no filters');
      }
      if (this.relationship) {
        params.relationships = this.relationship.id;
      }
      params.ordering = 'start_time';
      if (this.oldestFirst === false) {
        params.ordering = '-start_time';
      }
      if (this.withPersonalFilter) {
        params.practitioner = this.meId;
      }
      params.statuses = this.statuses;
      return params;
    },
    components: function components() {
      return {
        'CreateInvoice': {
          component: __WEBPACK_IMPORTED_MODULE_7__components_invoice_manage_create_confirm_vue___default.a,
          defaultStatuses: 'N,C',
          attrs: {
            value: this.invoice,
            title: 'Create invoice'
          },
          step1Instructions: {
            title: 'Step 1: Find appointments to invoice',
            bullets: ['Use the filters on the left to find the appointments you would like to invoice', 'When you choose a date range, it will limit the client list to only show the clients who have appointments during that date range', 'By default we only list appointments with New and Cancelled statuses', 'But you can expand the search to also include previously invoiced and paid appointments']
          },
          step2Instructions: {
            title: 'Step 2: Choose the appointments to invoice',
            bullets: ['Click on the appointments you would like to generate an invoice for']
          }
        },
        'Payment': {
          component: __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_CreateTransaction___default.a,
          title: 'Track payment',
          icon: 'paid',
          defaultStatuses: 'N,C,I',
          attrs: {},
          step1Instructions: {
            title: 'Step 1: Choose a client to track a payment for',
            bullets: ['Find a client from the filters on the left', 'When you choose a date range, it will limit the client list to only show the clients who have appointments during that date range', 'This filter expluces appointments that are already paid']
          },
          step2Instructions: {
            title: 'Step 2: Choose the appointments that are paid',
            bullets: ['Click on the appointments you would like to mark as paid']
          }
        }
      };
    }
  }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_MedicalAidPicker__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_MedicalAidPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_MedicalAidPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceListItem__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_unibox_MessageDeliveryStatus__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_unibox_MessageDeliveryStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_unibox_MessageDeliveryStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ui_RequestStatus__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SendToMedicalAid',
  components: { InvoiceListItem: __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceListItem___default.a, HelpPopover: __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover___default.a, MedicalAidPicker: __WEBPACK_IMPORTED_MODULE_0__components_pickers_MedicalAidPicker___default.a, MessageDeliveryStatus: __WEBPACK_IMPORTED_MODULE_3__components_unibox_MessageDeliveryStatus___default.a, RequestStatus: __WEBPACK_IMPORTED_MODULE_4__components_ui_RequestStatus___default.a },
  props: {
    invoice: { type: Object, required: true },
    withCancel: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      choosemedicalaiddialog: false,
      window: 0,
      step: 0,
      customemail: null,
      sendFrom: 'me',
      reimburse: 'me',
      ccme: true,
      medicalaid: {},
      invoiceDetail: {},
      requests: {
        get: {
          resource: 'invoiceguru.invoices'
        },
        send: {
          resource: 'invoiceguru.invoices'
        }
      }
    };
  },

  watch: {
    invoiceId: {
      immediate: true,
      handler: function handler() {
        if (this.invoiceId) {
          this.window = 0;
          this.step = 0;
          this.setInitialState();
          this.invoiceDetail = this.invoice;
          this.getInvoice();
          this.batchId = Math.random().toString().replace('.', '');
        }
      }
    },
    getInvoiceStatus: function getInvoiceStatus() {
      if (this.getInvoiceStatus === 200) {
        this.invoiceDetail = this.requests.get.result;
      }
    },
    sendStatus: function sendStatus() {
      if (this.sendStatus === 200) {
        this.window = 1;
      }
    }
  },
  computed: {
    medicalAidSelected: function medicalAidSelected() {
      if (this.medicalaid && this.medicalaid.name) {
        return true;
      }
      return false;
    },
    invoiceId: function invoiceId() {
      if (this.invoice) {
        return this.invoice.id;
      }
      return null;
    },
    invoicePreviewUrl: function invoicePreviewUrl() {
      var base = this.$invoiceguru.baseUrl;
      if (this.invoiceDetail && this.invoiceDetail.get_download_url) {
        return '' + base + this.invoiceDetail.get_download_url;
      }
      return false;
    },
    getInvoiceStatus: function getInvoiceStatus() {
      return this.requests.get.status;
    },
    sendStatus: function sendStatus() {
      return this.requests.send.status;
    },
    me: function me() {
      return this.invoiceDetail.practitioner_data;
    },
    clientEmail: function clientEmail() {
      if (this.clientHasEmail) {
        return this.invoiceDetail.client_data.email;
      }
      return null;
    },
    clientHasEmail: function clientHasEmail() {
      if (this.invoiceDetail.client_data && this.invoiceDetail.client_data.email) {
        return true;
      }
      return false;
    },
    fromPerson: function fromPerson() {
      if (this.sendFrom === 'me') {
        return this.invoiceDetail.practitioner_data;
      }
      if (this.sendFrom === 'client') {
        return this.invoiceDetail.client_data;
      }
      return null;
    },
    medicalAidHint: function medicalAidHint() {
      if (this.medicalaid && this.medicalaid.email) {
        return 'Claims email for ' + this.medicalaid.name + ' is ' + this.medicalaid.email;
      }
      return 'Please choose a medical aid';
    },
    medicalAidEmail: function medicalAidEmail() {
      if (this.step === 0) {
        return this.medicalaid.email;
      }
      if (this.step === 1) {
        var isValid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.customemail);
        if (isValid) {
          return this.customemail;
        }
      }
      return null;
    },
    payload: function payload() {
      return {
        sender: this.sendFrom,
        reimburse: this.reimburse,
        cc_me: this.ccme,
        bcc_me: this.bccme,
        medical_aid_email: this.medicalAidEmail,
        batch_id: this.batchId
      };
    }
  },
  methods: {
    getInvoice: function getInvoice() {
      if (this.invoiceId) {
        this.requests.get.resourceId = this.invoiceId;
        this.$request('get', this.requests.get);
      }
    },
    send: function send() {
      this.requests.send.resourceId = this.invoiceId;
      this.requests.send.extra = 'send_to_medical_aid';
      this.requests.send.method = 'post';
      this.requests.send.data = this.payload;
      this.$request('save', this.requests.send);
    },
    setInitialState: function setInitialState() {
      this.medicalaid = {};
      this.customemail = '';
      this.sendFrom = 'me';
      this.ccme = true;
      this.reimburse = 'me';
    }
  }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_PractitionerProductPicker_vue__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_PractitionerProductPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_PractitionerProductPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TransferAppointment',
  components: { PractitionerProductPicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_PractitionerProductPicker_vue___default.a },
  props: {
    appointment: { type: Object, required: true }
  },
  data: function data() {
    return {
      toproduct: { id: null, title: '' },
      topractitioner: { id: null },
      tolocation: { id: null },
      req: {
        resource: 'ag.practitioner.appointments',
        extra: 'actions/bulk_set_product',
        method: 'post'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['products']), {
    locationId: function locationId() {
      return this.getObjectPath(this.tolocation, 'id');
    },
    product: function product() {
      if (this.appointment && this.appointment.product) {
        return this.getProductById(this.appointment.product);
      }
      return {};
    },
    toSpaceId: function toSpaceId() {
      return this.getObjectPath(this.toproduct, 'space');
    },
    payload: function payload() {
      return {
        appointments: String(this.appointment.id),
        practitioner: this.topractitioner.id,
        product: this.toproduct.id,
        location: this.tolocation.id,
        space: this.toSpaceId
      };
    }
  }),
  methods: {
    save: function save() {
      this.req.data = this.payload;
      this.$request('save', this.req);
    },
    getProductById: function getProductById(id) {
      var _this = this;

      return this.products.find(function (prod) {
        return _this.idsAreEqual(prod.id, id);
      });
    },
    transferSuccess: function transferSuccess() {
      this.$emit('saved', this.req);
      this.$store.dispatch('fetchAppointments');
    }
  }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReadOnlyBlock',
  props: {
    text: {
      type: String,
      default: 'This account is in read-only mode because either your free trial has expired or your most recent payment has failed.<br/> This means you\'ll be able to view your data but you won\'t be able to create new appointments. To resolve this issue either click on Upgrade or contact Support.'
    }
  },
  data: function data() {
    return { showmore: false };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isReadOnly']))
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tombstone',
  props: {
    height: { type: String, default: '200px' }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ApplyAppointmentCodes',
  props: {
    appointment: { type: Object, required: true },
    cta: { type: String, default: 'Apply to all appointments in series' },
    disabled: { type: Boolean, required: false }
  },
  data: function data() {
    return {
      step: 0,
      dialog: false,
      withClear: true,
      onlyAfter: false,
      excludeInvoiced: true,
      request: {
        resource: 'ag.practitioner.appointments',
        extra: 'actions/apply_codes',
        method: 'post'
      }
    };
  },

  computed: {
    appointmentId: function appointmentId() {
      return this.appointment.id;
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    afterDate: function afterDate() {
      if (this.appointment && this.appointment.start_time) {
        return this.appointment.start_time.split('T')[0];
      }
      return null;
    }
  },
  watch: {
    appointmentId: function appointmentId() {
      this.step = 0;
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        this.step = 1;
      }
    }
  },
  methods: {
    save: function save() {
      this.request.resourceId = this.appointmentId;
      this.request.data = { clear_existing_codes: this.withClear };
      if (this.onlyAfter && this.afterDate) {
        this.request.data.after = this.afterDate;
      }
      if (this.excludeInvoiced === true) {
        this.request.data.exclude_statuses = 'I,P';
      }
      this.$request('save', this.request);
    }
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CrudTable__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CrudTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CrudTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pickers_IcdPicker__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pickers_IcdPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pickers_IcdPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pickers_ProcessCodePicker__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pickers_ProcessCodePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pickers_ProcessCodePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_appointment_CloneAppointmentCodes_vue__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_appointment_CloneAppointmentCodes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_appointment_CloneAppointmentCodes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_appointment_ApplyAppointmentCodes_vue__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_appointment_ApplyAppointmentCodes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_appointment_ApplyAppointmentCodes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_appointment_CopyCodes_vue__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_appointment_CopyCodes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_appointment_CopyCodes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms_IcdInput_vue__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms_IcdInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_forms_IcdInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(3);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentCodes',
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_3__components_CrudTable___default.a,
    IcdPicker: __WEBPACK_IMPORTED_MODULE_4__components_pickers_IcdPicker___default.a,
    IcdInput: __WEBPACK_IMPORTED_MODULE_9__components_forms_IcdInput_vue___default.a,
    ProcessCodePicker: __WEBPACK_IMPORTED_MODULE_5__components_pickers_ProcessCodePicker___default.a,
    CloneAppointmentCodes: __WEBPACK_IMPORTED_MODULE_6__components_appointment_CloneAppointmentCodes_vue___default.a,
    CopyCodes: __WEBPACK_IMPORTED_MODULE_8__components_appointment_CopyCodes_vue___default.a,
    ApplyAppointmentCodes: __WEBPACK_IMPORTED_MODULE_7__components_appointment_ApplyAppointmentCodes_vue___default.a
  },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    title: { type: String, required: false },
    appointmentId: {},
    appointments: { type: Array, default: function _default() {
        return [];
      } },
    dark: { type: Boolean, default: false },
    withClone: { type: Boolean, default: true },
    withDone: { type: Boolean, default: true },
    editable: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: false },
    withInvoiceable: { type: Boolean, default: false },
    withTotal: { type: Boolean, default: false },
    touch: { type: Number, default: 10 }
  },
  data: function data() {
    return {
      icdCode: '',
      appointment: {},
      copycodes: false,
      showOrder: false,
      ICD10codepicker: false,
      processcodepicker: false,
      showCodesSetResult: false,
      moreCodes: false,
      processSearchString: null,
      codeSearchString: null,
      typedProcessCode: null,
      typedIcd10Code: null,
      icdtouch: 1,
      process: null,
      code: null,
      resource: 'appointment.codes',
      requests: {
        appointment: __WEBPACK_IMPORTED_MODULE_2__store_constants__["k" /* ACTIVE_APPOINTMENT_DETAIL */],
        delete: 'appointment-codes-delete-request',
        edit: 'appointment-codes-edit-request',
        add: 'appointment-codes-add-request',
        setorder: {
          resource: 'ag.practitioner.appointments',
          extra: 'actions/set_code_order',
          method: 'post'
        }
      },
      alert: {
        message: '',
        type: 'success',
        visible: false
      },
      snack: {
        message: '',
        type: 'success',
        visible: false
      },
      codeOrder: {}
    };
  },

  computed: {
    appointmentRequest: function appointmentRequest() {
      return this.$store.getters.getRequestById(this.requests.appointment, true);
    },
    appointmentRequestStatus: function appointmentRequestStatus() {
      return this.appointmentRequest.status;
    },
    deleteRequest: function deleteRequest() {
      return this.$store.getters.getRequestById(this.requests.delete, true);
    },
    addRequest: function addRequest() {
      return this.$store.getters.getRequestById(this.requests.add, true);
    },
    addRequestStatus: function addRequestStatus() {
      return this.addRequest.status;
    },
    editRequest: function editRequest() {
      return this.$store.getters.getRequestById(this.requests.edit, true);
    },
    editRequestStatus: function editRequestStatus() {
      return this.editRequest.status;
    },
    deleteRequestStatus: function deleteRequestStatus() {
      return this.deleteRequest.status;
    },
    codesUpdating: function codesUpdating() {
      return this.deleteRequest.loading || this.editRequest.loading || this.addRequest.loading;
    },
    orderRequestStatus: function orderRequestStatus() {
      return this.requests.setorder.status;
    },
    suggestedICD10: function suggestedICD10() {
      var _this = this;

      if (this.typedIcd10Code && this.typedIcd10Code.length > 0 && this.getCachedCodeSuggestions && this.getCachedCodeSuggestions.icd10) {
        var items = this.getCachedCodeSuggestions.icd10.filter(function (item) {
          if (item && item.startsWith(_this.typedIcd10Code)) {
            return item;
          }
        });
        return items.slice(0, 3);
      }
      return [];
    },
    suggestedPrices: function suggestedPrices() {
      var _this2 = this;

      if (this.typedProcessCode && this.typedProcessCode.length > 2 && this.getCachedCodeSuggestions && this.getCachedCodeSuggestions.process) {
        var items = this.getCachedCodeSuggestions.process.filter(function (item) {
          if (item && item.name && item.name.startsWith(_this2.typedProcessCode)) {
            return item;
          }
        });
        return items.slice(0, 6);
      }
      return [];
    },
    table: function table() {
      var headers = [{ text: 'ICD10 Code', value: 'icd10' }, { text: 'Process Code', value: 'process' }, { text: 'NAPPI', value: 'nappi', required: false }, { text: 'Price', value: 'price', required: true, type: 'number' }];
      if (this.showOrder) {
        headers = [{ text: 'Order', value: 'order' }].concat(headers);
      }
      var activeCodes = [];
      if (this.appointment && this.appointment.id && this.appointment.codes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.appointment.codes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var row = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2__store_constants__["L" /* CODETYPES */]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var code = _step2.value;

                if (row[code] && row[code] !== null) {
                  if (activeCodes.indexOf(code) === -1) {
                    activeCodes.push(code);
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return {
        headers: headers,
        activeCodeTypes: activeCodes,
        data: this.appointment.codes || []
      };
    },
    totalPrice: function totalPrice() {
      if (this.appointment.codes) {
        return this.appointment.codes.reduce(function (sum, item) {
          return parseFloat(sum) + parseFloat(item.price);
        }, 0);
      }
      return 0;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
        }
      }
    },
    appointment: function appointment() {
      this.$emit('input', this.appointment);
    },
    touch: function touch() {
      var vm = this;
      this.showOrder = false;
      window.setTimeout(function () {
        if (vm.appointmentId) {
          vm.clearAndLoadAppointments();
        }
      }, 100);
    },
    ICD10codepicker: function ICD10codepicker() {
      if (this.ICD10codepicker) {
        this.icdtouch++;
      }
    },

    appointmentId: {
      immediate: true,
      handler: function handler() {
        this.clearAndLoadAppointments();
      }
    },
    appointmentRequestStatus: function appointmentRequestStatus() {
      if (this.appointmentRequestStatus === 200) {
        this.appointment = this.getObjectPath(this.appointmentRequest, 'result.data', {});
      }
    },
    orderRequestStatus: function orderRequestStatus() {
      if (this.orderRequestStatus > 199) {
        this.clearAndLoadAppointments();
        this.showOrder = false;
      }
    },
    totalPrice: function totalPrice() {
      if (this.totalPrice && this.totalPrice > 0) {
        this.$emit('pricechange', this.totalPrice);
      }
    },
    addRequestStatus: function addRequestStatus() {
      if (this.addRequestStatus === 201) {
        this.$emit('added');
        this.showAlert('Code added', 'success', 'snack');
        this.loadAppointments();
      }
      if (this.addRequestStatus > 299) {
        this.showAlert('Unable to add code. Please try again', 'error');
      }
    },
    editRequestStatus: function editRequestStatus() {
      if (this.editRequestStatus === 200) {
        this.$emit('edited');
      }
      if (this.editRequestStatus > 299) {
        this.showAlert('Unable to edit code', 'error');
      }
      this.loadAppointments();
    },
    deleteRequestStatus: function deleteRequestStatus() {
      if (this.deleteRequestStatus === 204) {
        this.$emit('deleted');
      }
      if (this.deleteRequestStatus === 404) {
        this.showAlert('Unable to delete code', 'error');
      }
      this.loadAppointments();
    }
  },
  methods: {
    noop: function noop() {},
    setcodes: function setcodes(selected) {
      var _this3 = this;

      selected.forEach(function (item) {
        item.icd10 = _this3.icdCode;
      });
    },
    updateOrder: function updateOrder(item, order) {
      order = parseInt(order);
      if (!isNaN(order)) {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(this.codeOrder, item.id, order);
      }
    },
    showAlert: function showAlert(msg, type) {
      var alertType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'alert';

      this[alertType].message = msg;
      this[alertType].type = type;
      this[alertType].visible = true;
    },
    saveInvoiceable: function saveInvoiceable() {
      if (this.appointment && this.appointment.id) {
        var data = { invoiceable: this.appointment.invoiceable };
        this.$appointmentguru.resource('appointment').id(this.requests.edit).save(this.appointment.id, data);
      }
    },
    clearAndLoadAppointments: function clearAndLoadAppointments() {
      if (this.appointmentId) {
        this.appointment = {};
        this.loadAppointments();
      }
    },
    loadAppointments: function loadAppointments() {
      if (this.appointmentId) {
        this.getAppointment(this.appointmentId);
      }
    },
    addCode: function addCode(code) {
      code.appointment = this.appointment.id;
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(code);
      this.$appointmentguru.resource(this.resource).id(this.requests.add).create(data);
    },
    editCode: function editCode(code) {
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(code);
      this.$appointmentguru.resource(this.resource).id(this.requests.edit).save(code.id, data);
    },
    deleteCode: function deleteCode(data) {
      var id = data.id;
      var params = { appointment_id: this.appointment.id };
      this.$appointmentguru.resource(this.resource).id(this.requests.delete).delete(id, params);
    },
    showProcessPicker: function showProcessPicker(props) {
      this.processcodepicker = true;
      this.processSearchString = props.selectedRow[props.header.value];
    },
    showICDPicker: function showICDPicker(props) {
      this.ICD10codepicker = true;
      this.codeSearchString = props.selectedRow[props.header.value];
    },
    setProcessCode: function setProcessCode(props) {
      this.typedProcessCode = this.process.name;
      props.selectedRow[props.header.value] = this.process.name;
      if (this.process.discovery_rate) {
        props.selectedRow.price = this.process.discovery_rate;
      }
      if (this.process.price) {
        props.selectedRow.price = this.process.price;
      }
      this.processcodepicker = false;
    },
    setIcdCode: function setIcdCode(props) {
      props.selectedRow[props.header.value] = this.code.name;
      this.ICD10codepicker = false;
    },
    setOrder: function setOrder() {
      this.requests.setorder.resourceId = this.appointmentId;
      this.requests.setorder.data = { order: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.codeOrder) };
      this.$request('save', this.requests.setorder);
    }
  },
  i18n: {
    messages: {
      en: {
        messages: {
          nocodes: 'This appointment has no codes'
        },
        alerts: {
          addedcode: 'Code successfully added'
        },
        dialogs: {
          titles: {
            icd10picker: 'Find an ICD10 code',
            processpicker: 'Find a code'
          }
        }
      }
    }
  }
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_ActionMenu__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_ActionMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_ActionMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_FlexibleComponentContainer__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_FlexibleComponentContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_FlexibleComponentContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_AppointmentCard__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_AppointmentCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cards_AppointmentCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__detail_NotesTab__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__detail_NotesTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__detail_NotesTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detail_NotificationsTab__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detail_NotificationsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__detail_NotificationsTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_appointment_edit_InvoiceDetails__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_appointment_edit_InvoiceDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_appointment_edit_InvoiceDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_constants__ = __webpack_require__(2);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentDetail',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_requests__["a" /* default */]],
  components: {
    FlexibleComponentContainer: __WEBPACK_IMPORTED_MODULE_3__components_ui_FlexibleComponentContainer___default.a,
    ActionMenu: __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_ActionMenu___default.a
  },
  props: {
    initialAppointment: { type: Object, default: function _default() {
        return {};
      } },
    appointmentId: { default: null },
    isCompact: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      appointment: {},
      editReqId: 'appointment-edit',
      processReqId: 'appointment-process',
      editTitle: false,
      edits: [{ title: 'Invoice details' }, { title: 'Notes' }, { title: 'Reschedule' }, { title: 'Change customer' }],
      actions: [{ title: 'Send payment reminder' }, { title: 'Mark as paid' }, { title: 'Mark as done' }],
      dangerActions: [{ title: 'Cancel' }]
    };
  },
  mounted: function mounted() {
    if (this.initalAppointment) {
      this.appointment = this.initalAppointment;
    }
    this.loadAppointment();
  },

  watch: {
    appointmentId: function appointmentId() {
      if (this.appointmentId) {
        this.loadAppointment();
      }
    },
    initialAppointment: function initialAppointment() {
      if (this.initalAppointment) {
        this.appointment = this.initalAppointment;
      }
    },
    appointmentRequestStatus: function appointmentRequestStatus() {
      if (this.appointmentRequestStatus === 200) {
        this.appointment = this.appointmentRequest.result.data;
      }
    },
    editAppointmentRequestStatus: function editAppointmentRequestStatus() {
      if (this.editAppointmentRequestStatus === 200) {
        this.appointment = this.appointmentRequest.result.data;
        this.editTitle = false;
      }
    }
  },
  computed: {
    routeId: function routeId() {
      if (this.$route.params) {
        return this.$route.params.id;
      }
    },
    items: function items() {
      return [{
        id: 'AppointmentHomepage',
        title: 'Appointment details',
        component: __WEBPACK_IMPORTED_MODULE_4__components_cards_AppointmentCard___default.a,
        attrs: {
          value: this.appointment
        }
      }, {
        id: 'AppointmentNotifications',
        title: 'Notifications',
        component: __WEBPACK_IMPORTED_MODULE_6__detail_NotificationsTab___default.a,
        attrs: {
          value: this.appointment
        }
      }, {
        id: 'AppointmentNotes',
        title: 'Notes',
        component: __WEBPACK_IMPORTED_MODULE_5__detail_NotesTab___default.a,
        attrs: {
          value: this.appointment
        }
      }, {
        id: 'AppointmentInvoiceDetails',
        title: 'Invoice details',
        component: __WEBPACK_IMPORTED_MODULE_7__components_appointment_edit_InvoiceDetails___default.a,
        attrs: {
          value: this.appointment,
          deletable: true,
          withDone: false
        }
      }];
    },
    appointmentRequest: function appointmentRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_8__store_constants__["k" /* ACTIVE_APPOINTMENT_DETAIL */], true);
    },
    appointmentRequestStatus: function appointmentRequestStatus() {
      return this.appointmentRequest.status;
    },
    editAppointmentRequest: function editAppointmentRequest() {
      return this.$store.getters.getRequestById(this.editReqId, true);
    },
    editAppointmentRequestStatus: function editAppointmentRequestStatus() {
      return this.editAppointmentRequest.status;
    }
  },
  methods: {
    savetitle: function savetitle(title) {
      var data = {
        title: title
      };
      this.updateAppointment(data);
    },
    updateAppointment: function updateAppointment(data) {
      this.$appointmentguru.resource('appointment').id(this.editReqId).save(this.appointmentId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    },
    loadAppointment: function loadAppointment() {
      var vm = this;
      vm.getAppointment(vm.appointmentId);
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionMenu__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentListItem',
  components: { AppointmentActionMenu: __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionMenu___default.a },
  props: {
    appointment: { type: Object, required: true },
    withActions: { type: Boolean, default: false },
    withAction: { type: Boolean, default: true },
    withPricing: { type: Boolean, default: false },
    withTags: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    withColorCoding: { type: Boolean, default: true },
    withStatusChips: { type: Boolean, default: false }
  },
  computed: {
    listItemColor: function listItemColor() {
      if (!this.withColorCoding) {
        return '';
      }
      return this.appointmentStatusClass;
    },
    formattedStatus: function formattedStatus() {
      if (this.appointment && this.appointment.status) {
        return this.formatStatus(this.appointment.status);
      }
      return {};
    },
    appointmentStatusClass: function appointmentStatusClass() {
      if (this.appointment.status) {
        return 'status-' + this.appointment.status.toLowerCase();
      }
    },
    threeLine: function threeLine() {
      return this.withTags;
    }
  }
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CrudTable__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CrudTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CrudTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentProduct',
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_0__components_CrudTable___default.a
  },
  props: {
    appointmentId: { type: Number }
  },
  data: function data() {
    return {
      appointment: {},
      productType: 'simple',
      requests: {
        appointment: __WEBPACK_IMPORTED_MODULE_1__store_constants__["k" /* ACTIVE_APPOINTMENT_DETAIL */],
        get: 'appointment-lineitems-get-request',
        manage: 'appointment-lineitems-manage-request'
      }
    };
  },

  watch: {
    appointmentId: {
      immediate: true,
      handler: function handler() {
        this.getLineitems();
      }
    },
    manageRequestStatus: function manageRequestStatus() {
      this.getLineitems();
      this.$emit('updated', this.products);
    }
  },
  methods: {
    addProduct: function addProduct(product) {
      product.appointment = this.appointmentId;
      this.$appointmentguru.resource('appointment.products').id(this.requests.manage).create(product);
    },
    editProduct: function editProduct(product) {
      this.$appointmentguru.resource('appointment.products').id(this.requests.manage).save(product.id, product);
    },
    deleteProduct: function deleteProduct(product) {
      this.$appointmentguru.resource('appointment.products').id(this.requests.manage).delete(product.id);
    },
    loadAppointment: function loadAppointment() {
      if (this.appointmentId) {
        this.getAppointment(this.appointmentId);
      }
    },
    getLineitems: function getLineitems() {
      if (this.appointmentId) {
        var params = {
          appointment_id: this.appointmentId
        };
        this.$appointmentguru.resource('appointment.products').id(this.requests.get).list(params);
      }
    }
  },
  computed: {
    getProductsRequest: function getProductsRequest() {
      return this.$store.getters.getRequestById(this.requests.get, true);
    },
    products: function products() {
      return this.getObjectPath(this.getProductsRequest, 'result.data', []);
    },
    appointmentRequest: function appointmentRequest() {
      return this.$store.getters.getRequestById(this.requests.appointment, true);
    },
    appointmentRequestStatus: function appointmentRequestStatus() {
      return this.appointmentRequest.status;
    },
    manageRequest: function manageRequest() {
      return this.$store.getters.getRequestById(this.requests.manage, true);
    },
    manageRequestStatus: function manageRequestStatus() {
      return this.manageRequest.status;
    },
    data: function data() {
      var headers = [{ text: 'Quantity', value: 'quantity', type: 'number', required: false }, { text: 'Description', value: 'description', required: false }, { text: 'Price', value: 'unit_price', required: true, type: 'number' }];
      if (this.productType === 'advanced') {
        headers.push({ text: 'NAPPI', value: 'nappi', required: false });
        headers.push({ text: 'ICD-10 Code', value: 'icd10', required: false });
        headers.push({ text: 'Process Code', value: 'process', required: false });
      }
      var table = {
        headers: headers,
        data: this.products
      };
      return table;
    }
  },
  i18n: {
    messages: {
      en: {
        noresults: ''
      }
    }
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AutomationIndicator',
  props: {
    practitionerId: { required: false },
    relationshipId: { required: false },
    productId: { required: false },
    dt: { required: false }
  },
  data: function data() {
    return {
      showdetail: false,
      req: {
        resource: 'ag.spaces.relationships',
        extra: 'autocodes'
      },
      productheaders: [{ text: 'ICD-10', value: 'icd10' }, { text: 'Process', value: 'process' }, { text: 'Price', value: 'price' }],
      headers: [{ text: 'ICD-10', value: 'icd10' }, { text: 'Process', value: 'process' }, { text: 'Price', value: 'price' }, { text: 'Valid from', value: 'start_date' }, { text: 'Valid till', value: 'stop_date' }]
    };
  },

  computed: {
    watchString: function watchString() {
      return this.practitionerId + '-' + this.dt + '-' + this.relationshipId + '-' + this.productId;
    },
    isValid: function isValid() {
      return this.practitionerId && this.dt && this.relationshipId;
    },
    autocodes: function autocodes() {
      var codes = this.getObjectPath(this.req, 'result');
      if (codes && Array.isArray(codes)) {
        return codes;
      }
      return this.getObjectPath(this.req, 'result.client', []);
    },
    productAutocodes: function productAutocodes() {
      return this.getObjectPath(this.req, 'result.product', []);
    },
    tables: function tables() {
      var t = [];
      if (this.req.status === 404) {
        return [];
      }
      if (this.autocodes && this.autocodes.length > 0) {
        t.push({
          id: 'client',
          title: 'Code automatically added for client',
          headers: this.headers,
          codes: this.autocodes,
          footertext: 'You can edit autocodes for a client from the client detail page under the "codes" tab'
        });
      }
      if (this.productAutocodes && this.productAutocodes.length > 0) {
        t.push({
          id: 'product',
          title: 'Code automatically added due to appointment type',
          headers: this.productheaders,
          codes: this.productAutocodes,
          footertext: 'You can add autocodes for an appointment type from the edit screen in advanced settings (settings.appointmentguru.co)'
        });
      }
      return t;
    },
    payload: function payload() {
      var data = {
        dt: this.dt,
        practitioner: this.practitionerId
      };
      if (this.productId) {
        data['product'] = this.productId;
      }
      return data;
    }
  },
  watch: {
    watchString: {
      immediate: true,
      handler: function handler() {
        this.check();
      }
    }
  },
  methods: {
    check: function check() {
      if (this.isValid) {
        this.req.resourceId = this.relationshipId;
        this.req.params = this.payload;
        this.$request('get', this.req);
      }
    }
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_IcdPicker__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_IcdPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pickers_IcdPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pickers_ProcessCodePicker__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pickers_ProcessCodePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pickers_ProcessCodePicker__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BulkAddCodes',
  components: { IcdPicker: __WEBPACK_IMPORTED_MODULE_3__components_pickers_IcdPicker___default.a, ProcessCodePicker: __WEBPACK_IMPORTED_MODULE_4__components_pickers_ProcessCodePicker___default.a },
  props: {
    appointmentIds: { type: Array, default: function _default() {
        return [];
      } },
    touch: { type: Number, default: 10 },
    withDone: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: false }
  },
  data: function data() {
    var _this = this;

    return {
      window: 0,
      loading: false,
      valid: false,
      done: false,
      code: {
        'currency': 'ZAR',
        'icd10': null,
        'process': null,
        'price': null
      },
      icdtouch: 1,
      processcodepicker: false,
      processSearchString: '',
      codeSearchString: '',
      ICD10codepicker: false,
      codes: [],
      fields: [{
        label: 'ICD10 code',
        key: 'icd10',
        rules: [function (v) {
          return !!v || 'ICD10 code is required';
        }],
        appendIcon: 'search',
        appendIconCb: function appendIconCb() {
          return _this.showICDPicker();
        }
      }, {
        label: 'Process code',
        key: 'process',
        rules: [function (v) {
          return !!v || 'process code is required';
        }],
        appendIcon: 'search',
        appendIconCb: function appendIconCb() {
          return _this.showProcessPicker();
        }
      }, {
        label: 'Price',
        key: 'price',
        type: 'number',
        rules: [function (v) {
          return !!v || 'price is required';
        }]
      }]
    };
  },

  computed: {
    payload: function payload() {
      return {
        codes: this.codes
      };
    },
    codeCount: function codeCount() {
      return this.codes.length;
    }
  },
  watch: {
    touch: function touch() {
      this.window = 0;
    },
    ICD10codepicker: function ICD10codepicker() {
      if (this.ICD10codepicker) {
        this.icdtouch = Math.random();
      }
    }
  },
  methods: {
    add: function add() {
      var copy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.code));
      this.codes.push(copy);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.code, 'process', null);
    },
    save: function save() {
      var vm = this;
      var ids = this.appointmentIds.join(',');
      var url = this.$appointmentguru.baseUrl + '/api/appointments/bulk/' + ids + '/codes/';
      var options = {
        headers: this.$appointmentguru.headers
      };
      vm.loading = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, this.payload, options).then(function (res) {
        vm.$emit('saved', res.data);
        vm.codes = [];
        vm.window = 1;
      }).catch(function () {}).then(function () {
        vm.loading = false;
      });
    },
    del: function del(index) {
      this.codes.splice(index, 1);
    },
    showICDPicker: function showICDPicker() {
      this.ICD10codepicker = true;
      this.codeSearchString = this.code.icd10;
    },
    setIcdCode: function setIcdCode(code) {
      this.code.icd10 = code.name;
      this.ICD10codepicker = false;
    },
    showProcessPicker: function showProcessPicker() {
      this.processcodepicker = true;
      this.processSearchString = this.code.process;
    },
    setProcessCode: function setProcessCode(code) {
      this.code.process = code.name;
      if (code.discovery_rate) {
        this.code.price = code.discovery_rate;
      }
      if (code.price) {
        this.code.price = code.price;
      }
      this.processcodepicker = false;
    }
  },
  i18n: {
    messages: {
      en: {
        messages: {
          selectedappointments: '{n} selected appointments | {n} selected appointment | {n} selected appointments'
        },
        dialogs: {
          titles: {
            icd10picker: 'Find a code',
            processpicker: 'Find a code'
          }
        }
      }
    }
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CloneAppointmentCodes',
  props: {
    appointment: { type: Object, required: true },
    cta: { type: String, default: 'Always use these codes for this client' },
    disabled: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      step: 0,
      dialog: false,
      startDate: null,
      stopDate: null,
      dateFocus: 'start',
      clearExisting: false,
      request: {
        resource: 'ag.spaces.relationships',
        method: 'post',
        extra: 'actions/set_treatment_codes'
      }
    };
  },

  computed: {
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    appointmentId: function appointmentId() {
      if (this.appointment) {
        return this.appointment.id;
      }
      return null;
    },
    relationshipId: function relationshipId() {
      return this.getObjectPath(this.appointment, 'computed_relationship_id');
    },
    practitionerName: function practitionerName() {
      var fname = this.getObjectPath(this.appointment, 'practitioner.first_name', '');
      var lname = this.getObjectPath(this.appointment, 'practitioner.last_name', '');
      return fname + ' ' + lname;
    },
    clientName: function clientName() {
      var fname = this.getObjectPath(this.appointment, 'client.first_name', '');
      var lname = this.getObjectPath(this.appointment, 'client.last_name', '');
      return fname + ' ' + lname;
    },

    startStopDate: {
      get: function get() {
        if (this.dateFocus === 'start') {
          return this.startDate;
        }
        if (this.dateFocus === 'stop') {
          return this.stopDate;
        }
        return null;
      },
      set: function set(val) {
        if (this.dateFocus === 'start') {
          this.startDate = val;
        }
        if (this.dateFocus === 'stop') {
          this.stopDate = val;
        }
      }
    },
    calMin: function calMin() {
      if (this.dateFocus === 'stop') {
        return this.startDate;
      }
      return null;
    },
    calMax: function calMax() {
      if (this.dateFocus === 'start') {
        return this.stopDate;
      }
      return null;
    }
  },
  watch: {
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        this.step = 1;
      }
    },

    appointmentId: {
      immediate: true,
      handler: function handler() {
        this.step = 0;
        if (this.appointment && this.appointment.start_time) {
          this.startDate = this.dateformat(this.appointment.start_time, 'YYYY-MM-DD');
        }
      }
    }
  },
  methods: {
    setCodes: function setCodes() {
      this.request.data = { appointment: this.appointmentId };
      if (this.startDate) {
        this.request.data.start_date = this.startDate;
      }
      if (this.stopDate) {
        this.request.data.stop_date = this.stopDate;
      }
      if (this.clearExisting) {
        this.request.data.terminate_existing_logs = true;
      }
      this.request.resourceId = this.relationshipId;
      this.$request('save', this.request);
    },
    dateSelected: function dateSelected() {
      if (this.dateFocus === 'start') {
        this.dateFocus = 'stop';
      }
    }
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmAppointment',
  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem_vue___default.a },
  props: {
    appointment: { type: Object, required: true },
    practitioner: { type: Object, required: true },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      recurranceIntervalPicker: false,
      recurranceItems: ['Daily', 'Weekly', 'Monthly', 'Yearly'],
      confirmOptions: {
        create_process: false,
        recurring: false,
        recurrance: {
          count: 1,
          interval: 'Weekly'
        }
      }
    };
  },

  watch: {
    hasContacts: function hasContacts() {
      if (!this.hasContacts) {
        this.confirmOptions.create_process = false;
      }
    }
  },
  methods: {
    editClient: function editClient() {
      if (this.relationshipId) {
        this.launchCustomerDetailsDialog(this.relationshipId, true);
      }
    }
  },
  computed: {
    isInPast: function isInPast() {
      var startTime = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local();
      var now = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local();
      if (this.appointment && this.appointment.start_time) {
        var startDateTime = this.appointment.day + 'T' + this.appointment.start_time;
        startTime = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(startDateTime);
      }
      return startTime <= now;
    },
    profilePicture: function profilePicture() {
      return this.getProfilePicture(this.practitioner);
    },
    relationship: function relationship() {
      return this.getObjectPath(this.appointment, 'relationship');
    },
    relationshipId: function relationshipId() {
      if (this.relationship) {
        return this.relationship.id;
      }
      return null;
    },
    clientPhoneNumber: function clientPhoneNumber() {
      return this.getObjectPath(this.relationship, 'client.phone_number', null);
    },
    clientEmail: function clientEmail() {
      var email = this.getObjectPath(this.relationship, 'client.email', null);
      if (this.isRealEmail(email)) {
        return email;
      }
      return null;
    },
    hasContacts: function hasContacts() {
      if (this.clientPhoneNumber || this.clientEmail) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CopyCodes',
  props: {
    appointment: { type: Object, required: false }
  },
  data: function data() {
    return {
      withClear: false,
      req: {
        resource: 'ag.codes',
        extra: 'suggestions'
      },
      savereq: {
        resource: 'ag.codes.bulk',
        extra: 'codes'
      },
      headers: [{ text: 'ICD-10', value: 'icd10' }, { text: 'Process', value: 'process' }, { text: 'Price', value: 'price' }],
      selectedIds: [],
      selectedItems: []
    };
  },

  computed: {
    requestStatus: function requestStatus() {
      return this.req.status;
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.savereq.status;
    },
    appointmentId: function appointmentId() {
      return this.getObjectPath(this.appointment, 'id');
    },
    relationshipId: function relationshipId() {
      return this.getObjectPath(this.appointment, 'computed_relationship_id');
    },
    appointments: function appointments() {
      return this.getObjectPath(this.req, 'result.appointments', []);
    },
    payload: function payload() {
      var data = { codes: this.selectedItems };
      if (this.withClear === true) {
        data['with_clear'] = true;
      }
      return data;
    }
  },
  watch: {
    appointmentId: {
      immediate: true,
      handler: function handler() {
        this.get();
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200) {
        this.clear();
        var vm = this;
        window.setTimeout(function () {
          vm.$emit('update');
          vm.$emit('close');
        }, 100);
      }
    }
  },
  methods: {
    get: function get() {
      this.req.params = {
        relationship_id: this.relationshipId
      };
      this.$request('get', this.req);
    },
    getNewCode: function getNewCode(code) {
      return {
        currency: code.currency,
        icd10: code.icd10,
        nappi: code.nappi,
        order: code.order,
        price: code.price,
        process: code.process
      };
    },
    toggleCode: function toggleCode(code) {
      var id = code.id;
      var index = this.selectedIds.indexOf(id);
      if (index === -1) {
        this.selectedIds.push(id);
        this.selectedItems.push(this.getNewCode(code));
      } else {
        this.selectedIds.splice(index, 1);
        this.selectedItems.splice(index, 1);
      }
    },
    save: function save() {
      this.savereq.resourceId = this.appointmentId;
      this.savereq.data = this.payload;
      this.savereq.method = 'post';
      this.$request('save', this.savereq);
    },
    clear: function clear() {
      this.selectedIds = [];
      this.selectedItems = [];
    }
  }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_ReadOnlyBlock__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_ReadOnlyBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_app_ReadOnlyBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pickers_ProductSheet__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pickers_ProductSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pickers_ProductSheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_ClientPickerDialog__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_ClientPickerDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pickers_ClientPickerDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_calendar_PractitionerDayView__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_calendar_PractitionerDayView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_calendar_PractitionerDayView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_After__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_After___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_After__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_listitems_PractitionerListItem_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_listitems_PractitionerListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_listitems_PractitionerListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pickers_PractitionerPicker_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pickers_PractitionerPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pickers_PractitionerPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_appointment_Confirm_vue__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_appointment_Confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_appointment_Confirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_appointment_AutomationIndicator_vue__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_appointment_AutomationIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_appointment_AutomationIndicator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_cards_AppointmentCard_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_cards_AppointmentCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_cards_AppointmentCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_constants__ = __webpack_require__(2);





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentQuickCreate',
  components: {
    ReadOnlyBlock: __WEBPACK_IMPORTED_MODULE_4__components_app_ReadOnlyBlock___default.a,
    ProductSheet: __WEBPACK_IMPORTED_MODULE_5__components_pickers_ProductSheet___default.a,
    PractitionerListItem: __WEBPACK_IMPORTED_MODULE_9__components_listitems_PractitionerListItem_vue___default.a,
    PractitionerPicker: __WEBPACK_IMPORTED_MODULE_10__components_pickers_PractitionerPicker_vue___default.a,
    ClientPickerDialog: __WEBPACK_IMPORTED_MODULE_6__components_pickers_ClientPickerDialog___default.a,
    PractitionerDayView: __WEBPACK_IMPORTED_MODULE_7__components_calendar_PractitionerDayView___default.a,
    AppointmentsAfterActions: __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_After___default.a,
    AutomationIndicator: __WEBPACK_IMPORTED_MODULE_12__components_appointment_AutomationIndicator_vue___default.a,
    AppointmentCard: __WEBPACK_IMPORTED_MODULE_13__components_cards_AppointmentCard_vue___default.a,
    ConfirmAppointment: __WEBPACK_IMPORTED_MODULE_11__components_appointment_Confirm_vue___default.a
  },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    relationship: { type: Object, required: false },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      step: 0,
      reqId: __WEBPACK_IMPORTED_MODULE_16__store_constants__["M" /* CREATE_APPOINTMENT_REQ */],
      timeout: null,
      LINKS: __WEBPACK_IMPORTED_MODULE_16__store_constants__["a" /* LINKS */],

      reqClashCheckId: 'request-check-for-clashes',
      clientToucher: 1,
      daymodal: false,
      showcalendar: false,
      starttime: false,
      endtime: false,
      productpicker: false,
      clientmodal: false,
      invalidReason: false,
      sheetdateselected: false,
      overrideZoomIntegration: false,
      appointmentURL: null,

      confirmAndCreate: false,
      ignoredStatuses: ['c'],
      appointmentLocation: null,
      practitioner: { id: null },
      days: ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'],
      savedAppointment: null,
      appointment: {
        resetting: false,
        title: null,
        create_process: true,
        day: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
        start_time: null,
        end_time: null,
        is_custom: false,
        product: {},
        service: {},
        client: {},
        relationship: {},
        recurring: false,
        recurrance: {
          count: 4,
          interval: 'Weekly'
        }
      },
      selectedRelationship: {},
      selectCustomTitle: false,
      nextfield: null
    };
  },
  mounted: function mounted() {
    if (!this.practitioner) {
      this.practitioner = this.me;
    }
  },

  methods: {
    confirmAndSave: function confirmAndSave(confirmationData) {
      this.appointment = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.appointment, confirmationData);
      this.save();
      this.confirmAndCreate = false;
    },
    save: function save() {
      this.$emit('quickcreate:save', this.formattedAppointment);

      var data = this.formattedAppointment;

      data.source = "app.next.web";
      if (!this.appointment.recurring) {
        this.$appointmentguru.resource('appointment').id(this.reqId).create(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
      } else {
        var _data = {
          start_time: this.formattedAppointment.start_time,
          end_time: this.formattedAppointment.end_time,
          practitioner: this.me.id,
          num_recurrances: this.appointment.recurrance.count,
          recurrance_rate: this.appointment.recurrance.interval.toUpperCase(),
          appointment: this.formattedAppointment
        };
        this.$appointmentguru.resource('appointment.recurring').id(this.reqId).create(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_data));
      }
      this.$ga.event('appointment', 'created');
    },
    recurringTest: function recurringTest() {
      var start = this.timeStringToMoment(this.appointment.start_time, this.appointment.day).utc().format('YYYY-MM-DD HH:mm');
      var end = this.timeStringToMoment(this.appointment.end_time, this.appointment.day).utc().format('YYYY-MM-DD HH:mm');
      var data = {
        practitioner: this.me.id,
        start_time: start,
        end_time: end,
        num_recurrances: this.appointment.recurrance.count,
        recurrance_rate: this.appointment.recurrance.interval.toUpperCase()
      };
      this.$appointmentguru.resource('appointment.recurring.clashes').id(this.reqClashCheckId).create(data);
    },
    clear: function clear() {
      this.selectCustomTitle = false;
      this.appointment.resetting = true;

      this.appointment.title = null;
      this.appointment.create_process = true;

      this.appointment.start_time = null;
      this.appointment.end_time = null;
      this.appointment.is_custom = false;
      this.appointment.product = {};
      this.appointment.service = {};
      this.appointment.client = {};
      this.appointment.relationship = {};
      this.appointment.recurring = false;
      this.appointment.zoom_join_url = null;
      this.appointment.recurrance = {
        count: 4,
        interval: 'Weekly'
      };
      if (this.globalPractitioner && this.globalPractitioner.id) {
        this.practitioner = this.globalPractitioner;
      } else {
        this.practitioner = this.me;
      }
      this.appointment.resetting = false;
      this.savedAppointment = false;
      this.appointmentURL = null;
      this.overrideZoomIntegration = false;
    },
    productSelected: function productSelected(payload) {
      if (payload && payload.product) {
        this.appointment.product = payload.product;
        this.appointment.service = payload.service;
        this.appointment.address = payload.location;
        this.productpicker = false;

        if (this.appointment.start_time) {
          if (!this.appointment.end_time) {
            this.startTimeChanged(this.appointment.start_time);
          }
        }
      }
    },
    editClient: function editClient() {
      if (this.relationshipId) {
        this.launchCustomerDetailsDialog(this.relationshipId, true);
      }
    },
    clientSelected: function clientSelected(client) {
      this.appointment.client = client;
      this.clientmodal = false;
      if (!this.hasContacts) {
        this.appointment.create_process = false;
      }
    },
    relationshipSelected: function relationshipSelected(rel) {
      this.selectedRelationship = rel;
      __WEBPACK_IMPORTED_MODULE_15_vue__["default"].set(this.appointment, 'relationship', rel);
    },
    slotSelected: function slotSelected(evt) {
      this.sheetdateselected = true;
      if (this.isSuccess) {
        this.clear();
      }
      this.appointment.day = __WEBPACK_IMPORTED_MODULE_3_moment___default()(evt.start_time).format('YYYY-MM-DD');
      this.appointment.start_time = evt.start;

      if (this.appointment.product && this.appointment.product.duration) {
        this.startTimeChanged(evt.start);
      } else {
        __WEBPACK_IMPORTED_MODULE_15_vue__["default"].set(this.appointment, 'end_time', evt.end);
      }
    },
    startTimeChanged: function startTimeChanged(time) {
      if (this.appointment.product && this.appointment.product.duration) {
        var datetimeString = this.timeStringToMoment(time, this.day);
        var endTimeMoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(datetimeString).add(this.appointment.product.duration, 'minutes');
        this.appointment.end_time = endTimeMoment.format('HH:mm');
      }
    },
    formatHours: function formatHours(hours) {
      if (hours) {
        return hours.split('|').join(', ');
      }
      return '';
    },
    moveDay: function moveDay(days) {
      if (this.appointment.day) {
        this.appointment.day = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.appointment.day).add(days, 'days').format('YYYY-MM-DD');
      }
    },
    setDefaultStartTime: function setDefaultStartTime() {
      if (!this.appointment.start_time) {
        this.appointment.start_time = __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('hour').format('HH:mm');
      }
    },
    setDefaultEndTime: function setDefaultEndTime() {
      if (!this.appointment.end_time) {
        this.appointment.end_time = __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('hour').add(1, 'hour').format('HH:mm');
      }
    },
    debounceGetAppointmentsForDay: function debounceGetAppointmentsForDay(delay) {
      if (!delay) {
        delay = 250;
      }
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(this.getPractitionerAppointments, delay);
    },
    getAppointmentsForDay: function getAppointmentsForDay() {
      this.getPractitionerAppointments(this.practitionerId, this.appointment.day, this.appointment.day);
    },
    getStepClasses: function getStepClasses(step) {
      if (step === this.nextfield) {
        return 'elevation-5 accent lighten-3';
      }
      return [];
    }
  },
  watch: {
    isSuccess: function isSuccess() {
      console.log('success', this.isSuccess);
      if (this.isSuccess) {
        this.step = 1;
      } else {
        this.step = 0;
      }
    },
    dialogVisibility: function dialogVisibility() {
      this.clear();
    },
    showcalendar: function showcalendar() {
      if (this.showcalendar === true) {
        this.sheetdateselected = false;
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 201) {
        var vm = this;

        vm.savedAppointment = vm.saveRequest.result.data;
        vm.$emit('success', vm.saveRequest);
        if (!this.appointment.recurring) {
          this.$store.commit('addAppointments', [vm.savedAppointment]);
        }
        if (this.appointment && this.appointment.day) {
          this.$store.commit('setCalendarDate', this.appointment.day);
        }
      }
    },
    spaceId: function spaceId() {
      this.appointment.client = null;
    },
    globalStartTime: function globalStartTime() {
      this.appointment.day = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.globalStartTime).format('YYYY-MM-DD');
      this.appointment.start_time = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.globalStartTime).format('HH:mm');
    },
    globalPractitioner: function globalPractitioner() {
      if (this.globalPractitioner) {
        this.practitioner = this.globalPractitioner;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_16__store_constants__["j" /* SET_SETTING */], ['activePractitioner', null]);
      }
    },
    isCustomEvent: function isCustomEvent() {
      if (this.isCustomEvent === true) {
        this.appointment.create_process = false;
      } else {
        this.appointment.create_process = false;
      }
    },

    touch: {
      immediate: true,
      handler: function handler() {
        this.clear();
        if (this.relationship && this.relationship.client) {
          this.clientSelected(this.relationship.client);
        }
      }
    },
    relationship: {
      immediate: true,
      handler: function handler() {
        if (this.relationship && this.relationship.client) {
          this.clientSelected(this.relationship.client);
        }
      }
    },
    appointmentDay: function appointmentDay() {
      this.daymodal = false;

      this.getAppointmentsForDay();
    },
    practitionerId: function practitionerId() {
      if (this.practitionerId) {
        __WEBPACK_IMPORTED_MODULE_15_vue__["default"].set(this.appointment, 'product', {});
        __WEBPACK_IMPORTED_MODULE_15_vue__["default"].set(this.appointment, 'service', {});

        this.getAppointmentsForDay();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapGetters */])(['getIntegration']), {
    isSuccess: function isSuccess() {
      return this.getObjectPath(this.savedAppointment, 'id');
    },
    appointmentServiceId: function appointmentServiceId() {
      return this.getObjectPath(this.appointment, 'service.id');
    },
    appointmentServiceTitle: function appointmentServiceTitle() {
      return this.getObjectPath(this.appointment, 'service.title');
    },
    hasZoomIntegration: function hasZoomIntegration() {
      return this.getIntegration('Zoom');
    },
    clientIsSharedWithSelectedSpace: function clientIsSharedWithSelectedSpace() {
      var spaceId = this.appointmentServiceId;
      var relationshipSpaces = this.getObjectPath(this.selectedRelationship, 'spaces', []);
      return relationshipSpaces.indexOf(spaceId) > -1;
    },
    appointmentDay: function appointmentDay() {
      return this.appointment.day;
    },
    appointmentPreview: function appointmentPreview() {
      if (this.savedAppointment && this.savedAppointment.id) {
        return null;
      }
      if (this.appointment) {
        return this.appointment;
      }
      return null;
    },
    clientFirstName: function clientFirstName() {
      return this.getObjectPath(this.selectedRelationship, 'client.first_name', null);
    },
    clientLastName: function clientLastName() {
      return this.getObjectPath(this.selectedRelationship, 'client.last_name', null);
    },
    clientPhoneNumber: function clientPhoneNumber() {
      return this.getObjectPath(this.selectedRelationship, 'client.phone_number', null);
    },
    clientEmail: function clientEmail() {
      var email = this.getObjectPath(this.selectedRelationship, 'client.email', null);
      if (this.isRealEmail(email)) {
        return email;
      }
      return null;
    },
    dayIsInActiveRange: function dayIsInActiveRange() {
      if (this.appointmentDay) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.appointment.day).isBetween(this.activeDateRange.from, this.activeDateRange.to);
      }
      return true;
    },
    activeDateRange: function activeDateRange() {
      return this.$store.getters.activeDateRange;
    },
    relationshipId: function relationshipId() {
      if (this.selectedRelationship && this.selectedRelationship.id) {
        return this.selectedRelationship.id;
      }
      if (this.appointment && this.appointment.client && this.appointment.client.id) {
        var rel = this.getRelationByClientId(this.appointment.client.id);
        if (rel && rel.id) {
          return rel.id;
        }
      }
      return null;
    },
    saveRequest: function saveRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.saveRequest.status;
    },
    autoCodes: function autoCodes() {
      return this.getObjectPath(this.requests, 'automation.result', []);
    },
    isProductSelected: function isProductSelected() {
      if (this.appointment.product && this.appointment.product.id) {
        return true;
      }
      return false;
    },
    spaceId: function spaceId() {
      return this.getObjectPath(this.appointment, 'service.id');
    },
    addressId: function addressId() {
      return this.getObjectPath(this.appointment, 'address.id');
    },
    operationHoursLink: function operationHoursLink() {
      var spaceId = this.spaceId;
      var addressId = this.addressId;
      if (spaceId && addressId) {
        return '' + __WEBPACK_IMPORTED_MODULE_16__store_constants__["a" /* LINKS */].SETTINGS_SPACES + spaceId + '/locations/' + addressId + '/hours';
      }
      return false;
    },
    dialogVisibility: function dialogVisibility() {
      return this.$store.state.application.activeDialog;
    },
    services: function services() {
      return this.$store.getters.services;
    },
    isSingleProduct: function isSingleProduct() {
      if (this.services) {
        var isSingleProduct = this.services && this.services.length === 1 && this.services[0].products.length === 1;

        if (isSingleProduct === true) {
          var service = {
            service: this.services[0],
            product: this.services[0].products[0]
          };
          this.productSelected(service);
        }
        return isSingleProduct;
      }
    },
    recurringVerifyRequest: function recurringVerifyRequest() {
      return this.$store.getters.getRequestById(this.reqClashCheckId, true);
    },
    recurringVerifyRequestStatus: function recurringVerifyRequestStatus() {
      return this.recurringVerifyRequest.status;
    },
    isCustomEvent: function isCustomEvent() {
      return this.appointment.is_custom;
    },
    selectedDate: function selectedDate() {
      return this.appointment.day;
    },
    selectedServiceTitle: function selectedServiceTitle() {
      if (this.appointment && this.appointment.service) {
        var title = this.getObjectPath(this.appointment, 'service.title');
        if (!title) {
          title = this.getObjectPath(this.appointment, 'service.address.name');
        }
        return title;
      }
      return null;
    },
    appointmentIsValid: function appointmentIsValid() {
      this.nextfield = null;
      if (this.appointment.is_custom) {
        if (!this.appointment.title) {
          this.invalidReason = 'Please provide a title';
          this.nextfield = 'title';
          return false;
        }
      } else {
        if (!this.formattedAppointment.product) {
          this.invalidReason = 'Choose an appointment type';
          this.nextfield = 'product';
          return false;
        }
      }
      if (!this.appointment.day) {
        this.invalidReason = 'Please choose a date';
        this.nextfield = 'day';
        return false;
      }
      if (!this.appointment.start_time) {
        this.invalidReason = 'Choose a start time';
        this.nextfield = 'time';
        return false;
      }
      if (!this.appointment.end_time) {
        this.invalidReason = 'Choose an end time';
        this.nextfield = 'time';
        return false;
      }
      if (!this.formattedAppointment.client) {
        this.invalidReason = 'Choose a contact person';
        this.nextfield = 'client';
        return false;
      }
      if (this.selectCustomTitle && !this.appointment.title) {
        this.invalidReason = 'Please provide a dependant name';
        return false;
      }
      return true;
    },
    globalStartTime: function globalStartTime() {
      return this.$store.state.application.globalSettings.startTime;
    },
    globalPractitioner: function globalPractitioner() {
      return this.$store.state.application.globalSettings.activePractitioner;
    },
    me: function me() {
      return this.$store.getters.me;
    },
    hasContacts: function hasContacts() {
      if (this.clientPhoneNumber || this.clientEmail) {
        return true;
      }
      return false;
    },
    practitionerId: function practitionerId() {
      if (this.practitioner && this.practitioner.id) {
        return this.practitioner.id;
      }
    },
    practitionerName: function practitionerName() {
      if (this.practitioner) {
        return this.practitioner.first_name || this.practitioner.full_name;
      }
      return null;
    },
    formattedAppointment: function formattedAppointment() {
      var data = {
        'practitioner': this.practitionerId,
        'create_process': this.appointment.create_process
      };
      data.start_time = this.timeStringToMoment(this.appointment.start_time, this.appointment.day);
      data.end_time = this.timeStringToMoment(this.appointment.end_time, this.appointment.day);

      if (this.appointment.product && this.appointment.product.id) {
        data.product = this.appointment.product.id;
      }
      if (this.appointment.address && this.appointment.address.id) {
        data.address = this.appointment.address.id;
        data.location = this.appointment.address.id;
      }
      if (this.appointmentURL) {
        data.zoom_join_url = this.appointmentURL;
      }

      if (this.appointment.client) {
        data.title = this.formatFullName(this.appointment.client);
        if (this.appointment.client.custom_id) {
          data.title = '[' + this.appointment.client.custom_id + '] ' + data.title;
        }
        if (this.selectCustomTitle) {
          data.title = this.appointment.title;
          data.full_name = this.appointment.title;
        }
        data.client = this.appointment.client.id;
      }

      if (this.relationshipId) {
        data.relationships = this.relationshipId;
      }

      var comesToYou = this.getObjectPath(this.appointment, 'product.comes_to_you');
      if (comesToYou && this.appointmentLocation) {
        data.location = { name: this.appointmentLocation };
      }

      if (this.appointment.is_custom) {
        data.title = this.appointment.title;
        data.client = this.me.id;
        data.status = 'B';
        if (data.product) {
          delete data['product'];
        }
      }
      return data;
    },
    operatingHours: function operatingHours() {
      if (this.appointment.day && this.appointment.service && this.appointment.service.id && this.appointment.address && this.appointment.address.id) {
        var addr = this.appointment.address;
        var vm = this;
        var hours = addr.operation_hours.find(function (hrs) {
          return hrs.practitioner === vm.practitionerId;
        });
        if (hours) {
          return hours;
        }
      }
      return null;
    },
    selectedDayHours: function selectedDayHours() {
      var hrs = null;
      if (this.appointment && this.appointment.day) {
        var day = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.appointment.day).format('ddd').toLocaleLowerCase();
        if (day === 'thu') {
          day = 'thurs';
        }
        if (day === 'tue') {
          day = 'tues';
        }
        try {
          hrs = this.formatHours(this.operatingHours[day]);
        } catch (e) {
          console.error('could not find hours');
        }
      }
      if (hrs) {
        return hrs;
      }
      return 'Off';
    },
    dayViewSettings: function dayViewSettings() {
      var dayViewSettings = {
        startHour: 6,
        endHour: 20,
        periodInMins: 15
      };
      if (this.operatingHours && this.appointment.product.id && this.appointment.day) {
        var day = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.appointment.day).format('ddd').toLocaleLowerCase();
        if (day === 'thu') {
          day = 'thurs';
        }
        if (day === 'tue') {
          day = 'tues';
        }
        var hours = this.operatingHours[day];
        if (hours) {
          var timesRanges = hours.split('-');
          var first = timesRanges[0].split(':')[0];
          var last = timesRanges[timesRanges.length - 1].split(':')[0];
          dayViewSettings.startHour = parseInt(first);
          dayViewSettings.endHour = parseInt(last) + 1;
          dayViewSettings.defaultNewEventLength = parseInt(this.appointment.product.duration);
        }
      }
      return dayViewSettings;
    }
  })
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectedAppointmentsPreview',
  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default.a },
  props: {
    appointmentIds: { type: Array, default: function _default() {
        return [];
      } },
    flat: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      showDetails: false,
      reqId: 'get-specific-appointments-request'
    };
  },

  computed: {
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    appointments: function appointments() {
      return this.getObjectPath(this.request, 'result.data', []);
    }
  },
  methods: {
    expand: function expand() {
      this.showDetails = true;
      this.getAppointments();
    },
    getAppointments: function getAppointments() {
      var params = {
        ids: this.appointmentIds.join(',')
      };
      this.$appointmentguru.resource('appointment').id(this.reqId).list(params);
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'With selected appointment | With {count} selected appointments',
        sleecteditems: 'Selected appointments',
        buttons: {
          more: 'Show details',
          less: 'Hide details'
        }
      }
    }
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PhoneNumberInput__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PhoneNumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PhoneNumberInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_ClientList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_constants__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SetClient',
  components: {
    PhoneNumberInput: __WEBPACK_IMPORTED_MODULE_0__components_PhoneNumberInput___default.a,
    ClientList: __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList___default.a,
    ClientListItem: __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem___default.a,
    AppointmentListItem: __WEBPACK_IMPORTED_MODULE_3__components_appointment_AppointmentListItem___default.a
  },
  props: {
    value: { type: Object, required: true },
    touch: { type: Number, default: 0 },
    withDependent: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      window: 0,
      activeTab: 0,
      fullname: '',
      email: '',
      phone: '',
      selectedclient: null,
      actionRequest: {
        loading: false,
        status: 0,
        data: {}
      },
      requests: {
        dep: {
          resource: 'ag.appointments',
          resourceId: 0
        }
      },
      appointment: {
        title: '',
        full_name: ''
      },
      showSetDependent: false
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
          this.title = this.appointment.title;
          this.fullname = this.appointment.full_name;
          this.email = this.appointment.contact_email;
          this.phone = this.appointment.contact_phone;

          if (this.appointment.id && !this.appointment.contact_email) {
            this.get(this.appointment.id);
          }
        }
      }
    },
    touch: function touch() {
      this.selectedclient = null;
      this.activeTab = 0;
      this.window = 0;
    },
    appointmentDetailRequestStatus: function appointmentDetailRequestStatus() {
      if (this.appointmentDetailRequestStatus === 200) {
        this.appointment = this.remoteAppointment;
        this.fullname = this.appointment.full_name;
        this.email = this.appointment.contact_email;
        this.phone = this.appointment.contact_phone;
      }
    },
    actionStatus: function actionStatus() {
      if (this.actionStatus === 200) {
        this.window = 1;
        this.getAppointment(this.appointment.id);
        this.getClients();
        this.getAppointmentsInRange();
      }
    }
  },
  computed: {
    appointmentDetailRequest: function appointmentDetailRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_4__store_constants__["k" /* ACTIVE_APPOINTMENT_DETAIL */], true);
    },
    appointmentDetailRequestStatus: function appointmentDetailRequestStatus() {
      return this.appointmentDetailRequest.status;
    },
    actionStatus: function actionStatus() {
      return this.actionRequest.status;
    },
    remoteAppointment: function remoteAppointment() {
      return this.getObjectPath(this.appointmentDetailRequest, 'result.data', {});
    },
    payload: function payload() {
      var setNewClient = this.activeTab === 0;
      if (setNewClient) {
        return {
          'full_name': this.fullname,
          'email': this.email,
          'phone_number': this.phone
        };
      } else {
        if (this.selectedclient) {
          return {
            'relationship_id': this.selectedclient.id
          };
        }
      }
    }
  },
  methods: {
    setSelected: function setSelected(client) {
      this.selectedclient = client;
    },
    get: function get(appointmentId) {
      this.getAppointment(appointmentId);
    },
    set: function set() {
      this.action(this.$appointmentguru, 'practitioner', 'appointments', this.appointment.id, 'set_client', this.payload, this.actionRequest);
    },
    saveDependent: function saveDependent() {
      this.requests.dep.resourceId = this.appointment.id;
      this.requests.dep.data = {
        full_name: this.appointment.full_name,
        title: this.appointment.title
      };
      this.$request('save', this.requests.dep);
    }
  }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_SelectedAppointmentsPreview__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_SelectedAppointmentsPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_SelectedAppointmentsPreview__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagIt',
  components: { SelectedAppointmentsPreview: __WEBPACK_IMPORTED_MODULE_0__components_appointment_SelectedAppointmentsPreview___default.a },
  props: {
    appointmentIds: { type: Array, default: function _default() {
        return [];
      } },
    originalTags: { type: Array, default: function _default() {
        return [];
      } },
    multiple: { type: Boolean, default: false },
    touch: { type: Number, default: 2 }
  },
  data: function data() {
    return {
      text: '',
      tags: [],
      requests: {
        add: 'appointment-add-tags-request',
        remove: 'appointment-remove-tags-request'
      },
      successMessage: false,
      errorMessage: false
    };
  },
  mounted: function mounted() {
    this.text = this.originalTags.join(',');
  },

  watch: {
    originalTags: function originalTags() {
      this.tags = this.originalTags;
    },
    text: function text() {
      this.tags = this.text.split(',');
    },
    touch: function touch() {
      this.reset();
    },
    addRequestStatus: function addRequestStatus() {
      if (this.addRequestStatus === 200) {
        this.successMessage = true;
        this.errorMessage = false;
      }
      if (this.addRequestStatus > 299) {
        this.successMessage = false;
        this.errorMessage = true;
      }
    }
  },
  methods: {
    reset: function reset() {
      this.successMessaage = false;
    },
    save: function save() {
      var data = {
        appointments: this.appointmentIds.join(','),
        tags: this.tagsText
      };
      this.$appointmentguru.resource('appointment.tags').id(this.requests.add).create(data);
    },
    remove: function remove(tag) {
      var rawText = this.text.replace(tag, '');
      var tags = rawText.split(',').filter(function (tag) {
        return tag;
      });
      this.text = tags.join(',');
    }
  },
  computed: {
    addRequest: function addRequest() {
      return this.$store.getters.getRequestById(this.requests.add, true);
    },
    addRequestStatus: function addRequestStatus() {
      return this.addRequest.status;
    },
    isValid: function isValid() {
      if (this.tags) {
        if (this.tags.length === 1 && this.tags[0] === '') {
          return false;
        }
        return true;
      }
      return false;
    },
    tagsText: function tagsText() {
      return this.tags.join(',');
    }
  },
  i18n: {
    messages: {
      en: {
        buttons: {
          save: 'Add tags'
        },
        text: {
          label: 'Type tags to add',
          hint: 'Split new tags with a comma'
        },
        messages: {
          success: 'Successfully added tags',
          error: 'There was a problem adding your tabs. Please try again'
        }
      }
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagList',
  props: {
    appointment: {
      type: Object,
      required: true
    },
    deleteable: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      tagBeingDeleted: null,
      successfullyDeleted: [],
      reqId: 'tag-delete-request'
    };
  },

  computed: {
    deleteRequest: function deleteRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    deleteRequestStatus: function deleteRequestStatus() {
      return this.deleteRequest.status;
    }
  },
  watch: {
    deleteRequestStatus: function deleteRequestStatus() {
      if (this.deleteRequestStatus === 200) {
        this.successfullyDeleted.push(this.tagBeingDeleted);
        this.tagBeingDeleted = null;
      }
    }
  },
  methods: {
    remove: function remove(tag) {
      this.tagBeingDeleted = tag;
      var data = {
        appointments: this.appointment.id.toString(),
        tags: tag,
        action: 'delete'
      };
      this.$appointmentguru.resource('appointment.tags').id(this.reqId).create(data);
    }
  },
  i18n: {
    messages: {
      en: {
        buttons: {
          add: 'Add tags'
        }
      }
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_appointments__ = __webpack_require__(93);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActionList',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_appointments__["a" /* default */]],
  props: {
    appointment: { type: Object, default: function _default() {
        return {};
      } },
    exclude: { type: Array, default: function _default() {
        return [];
      } }
  },
  methods: {
    itemAction: function itemAction(action) {
      action.onclick();
      this.$ga.event('appointment', action.title + ' clicked');
    }
  },
  computed: {
    spaceIds: function spaceIds() {
      if (this.appointment) {
        return [this.appointment.space];
      }
      return [];
    },
    isSpaceOwner: function isSpaceOwner() {
      if (this.appointment && this.appointment.status === 'B') {
        return true;
      }
      if (this.appointment && this.appointment.space) {
        var spaceId = this.appointment.space;
        if (this.$store.getters.lookups && this.$store.getters.lookups.spaces && spaceId in this.$store.getters.lookups.spaces) {
          return this.$store.getters.lookups.spaces[spaceId].role === 'Owner';
        }
      }
      return false;
    },
    isOwner: function isOwner() {
      return parseInt(this.appointment.practitioner) === parseInt(this.meId);
    },
    filteredActions: function filteredActions() {
      var _this = this;

      if (this.appointmentActions) {
        if (this.isOwner) {
          return this.appointmentActions;
        }
        return this.appointmentActions.filter(function (action) {
          if (action.type === 'divider') {
            return action;
          }
          if (_this.isSpaceOwner && action.ownerCan) {
            return action;
          }
          if (action.id === 'show_client') {
            return action;
          }
          if (_this.hasPermission(action.id, [_this.appointment.space], [_this.appointment])) {
            return action;
          }
        });
      }
      return [];
    }
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionList_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionList_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActionMenu',
  components: { ActionList: __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionList_vue___default.a },
  props: {
    appointment: { type: Object, default: function _default() {
        return {};
      } },
    icon: { type: String, default: 'more_vert' },
    text: { type: String, default: '' },
    exclude: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return { visible: false };
  },

  methods: {
    show: function show() {
      var _this = this;

      this.visible = false;
      window.setTimeout(function () {
        _this.visible = true;
      }, 100);
    }
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_SmallAppointmentCard_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_SmallAppointmentCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cards_SmallAppointmentCard_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AfterAppointmentActions',

  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default.a, SmallAppointmentCard: __WEBPACK_IMPORTED_MODULE_1__components_cards_SmallAppointmentCard_vue___default.a },
  props: {
    appointment: { type: Object, required: true }
  },
  data: function data() {
    return {
      exclude: ['show_client', 'reschedule', 'cancel_appointment', 'delete_appointment']
    };
  },

  methods: {
    itemAction: function itemAction(action) {
      action.onclick();
      this.$ga.event('appointment', action.title + ' clicked');
    }
  },
  computed: {
    isRecurring: function isRecurring() {
      return this.appointment.num_recurrances && this.appointment.num_recurrances > 0;
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_ShareAppointment_vue__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_ShareAppointment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_ShareAppointment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_ActionList_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_ActionList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_ActionList_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentBottomSheet',
  components: { ActionList: __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_ActionList_vue___default.a, ShareAppointment: __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_ShareAppointment_vue___default.a },
  props: {
    value: { type: Boolean, default: false },

    appointment: { type: Object, default: function _default() {
        return {};
      } },
    readOnly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      screen: 0,
      preview: false,
      visible: false,
      withPreview: false,
      sharedialog: false,
      screens: {
        ACTIONS: 0,
        PREVIEW: 1
      }
    };
  },
  mounted: function mounted() {
    this.visible = this.value;
  },

  watch: {
    value: function value() {
      this.visible = this.value;
    }
  },
  computed: {
    title: function title() {
      if (this.appointment) {
        var title = '';
        if (this.appointment.title) {
          title = this.appointment.title;
        } else {
          title = this.appointment.full_name;
        }
        var formattedDate = this.dateformat(this.appointment.start_time, 'ddd DD MMM YYYY');
        title = title + '. ' + formattedDate;

        return title;
      }
      return 'Choose an action';
    },
    appointmentId: function appointmentId() {
      if (this.appointment) {
        return this.appointment.id;
      }
    },
    relationshipId: function relationshipId() {
      if (this.appointment && this.appointment.client) {
        var rel = this.getRelationByClientId(this.appointment.client);
        return rel.id;
      }
      return null;
    },
    formattedStatus: function formattedStatus() {
      if (this.appointment && this.appointment.status) {
        return this.formatStatus(this.appointment.status);
      }
      return {};
    },
    appointmentDetail: function appointmentDetail() {
      return this.getObjectPath(this.appointmentDetailRequest, 'result.data');
    },
    appointmentDetailRequest: function appointmentDetailRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_0__store_constants__["k" /* ACTIVE_APPOINTMENT_DETAIL */]);
    },
    product: function product() {
      if (this.appointment && this.appointment.product) {
        var product = this.appointment.product;
        if (isNaN(product)) {
          return product;
        } else {
          return this.getProductById(product, true);
        }
      }
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_client_ClientListItem__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_client_ClientListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_client_ClientListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_client_ClientList__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_client_ClientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_client_ClientList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(3);











var WINDOWS = {
  START: 0,
  CLIENT_CLONE: 1,
  DATE_CLONE: 2,
  SUCCESS: 3
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CloneAppointment',
  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_3__components_appointment_AppointmentListItem___default.a, ClientList: __WEBPACK_IMPORTED_MODULE_5__components_client_ClientList___default.a, ClientListItem: __WEBPACK_IMPORTED_MODULE_4__components_client_ClientListItem___default.a },
  props: {
    appointment: { type: Object, required: true },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      window: 0,
      WINDOWS: WINDOWS,
      d: false,
      year: null,

      selected: [],
      selectedRelationships: {},
      withReminders: false,
      copyCodes: true,
      request: {
        resource: 'ag.practitioner.appointments',
        extra: 'actions/clone',
        method: 'post'
      }
    };
  },

  computed: {
    events: function events() {
      if (this.appointment && this.appointment.start_time) {
        return [__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(this.appointment.start_time).toISODate()];
      }
    },
    appointmentId: function appointmentId() {
      return this.getObjectPath(this.appointment, 'id', null);
    },
    selectedRelationshipsList: function selectedRelationshipsList() {
      if (this.selectedRelationships) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.selectedRelationships);
      }
      return [];
    },
    months: function months() {
      var dt = __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local();
      if (this.appointment && this.appointment.start_time) {
        dt = __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(this.appointment.start_time);
      }
      this.year = dt.year;
      this.month = dt.month;
      var months = [];
      for (var x = 0; x <= 7; x++) {
        var mo = dt.plus({ months: x });
        months.push(mo.year + '-' + mo.month);
      }
      return months;
    },
    payload: function payload() {
      var data = {
        with_reminder: this.withReminders,
        copy_codes: this.copyCodes
      };
      if (this.window === WINDOWS.DATE_CLONE) {
        data['dates'] = this.selected.join(',');
      }
      if (this.window === WINDOWS.CLIENT_CLONE) {
        var relIds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selectedRelationships);
        data['relationships'] = relIds.join(',');
      }
      return data;
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    clones: function clones() {
      return this.getObjectPath(this.request, 'result.clones', []);
    }
  },
  watch: {
    touch: function touch() {
      this.reset();
    },
    appointmentId: function appointmentId() {
      this.reset();
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        this.getAppointmentsInRange();
        this.window = WINDOWS.SUCCESS;
        this.selected = [];
        this.selectedRelationships = {};
      }
    }
  },
  methods: {
    reset: function reset() {
      this.selected = [];
      this.selectedRelationships = {};
      this.window = 0;
    },
    isAllowed: function isAllowed(date) {
      if (this.events && this.events.length === 1) {
        return date !== this.events[0];
      }
      return true;
    },
    relationshipselected: function relationshipselected(rel) {
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.selectedRelationships, rel.id, rel);
    },
    removeRelationship: function removeRelationship(rel) {
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].delete(this.selectedRelationships, rel.id);
    },
    save: function save() {
      this.request.resourceId = this.appointment.id;
      this.request.data = this.payload;
      this.$request('save', this.request);
    }
  }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_lists_ReadOnlyStatementList_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_lists_ReadOnlyStatementList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_lists_ReadOnlyStatementList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateTransaction',
  components: {
    ReadOnlyStatementList: __WEBPACK_IMPORTED_MODULE_2__components_lists_ReadOnlyStatementList_vue___default.a,
    ClientListItem: __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem_vue___default.a
  },
  props: {
    appointment: { type: Object },
    appointments: { type: Array, default: function _default() {
        return [];
      } },
    appointmentIds: { type: Array, default: function _default() {
        return [];
      } },
    value: { type: Object },
    loading: { type: Boolean, default: false },
    withActions: { type: Boolean, default: true },
    floatingActions: { type: Boolean, default: false },
    withDone: { type: Boolean, default: true },
    withAppointmentInfo: { type: Boolean, default: true },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      active: 0,
      dialog: false,
      paidInFull: false,
      success: false,
      statementTouch: 0,
      statementLoading: false,
      paymentMethods: __WEBPACK_IMPORTED_MODULE_0__store_constants__["S" /* PAYMENT_METHODS */],
      totalDue: null,
      relationships: [],
      payment: {
        date: null,
        amount: 0,
        payment_method: 'eft',
        currency: 'ZAR'
      },
      paymentRequest: {
        resource: 'invoiceguru.transactions',
        status: 0
      },
      sendReceipt: true,
      done: false
    };
  },
  mounted: function mounted() {
    if (!this.payment.date) {
      this.payment.date = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].local().toISODate();
    }
    if (this.totalDue) {
      this.payment.amount = this.totalDue;
    }
  },

  watch: {
    value: function value() {
      if (this.value) {
        this.payment = this.value;
      }
    },
    payment: function payment() {
      this.$emit('input', this.payment);
    },
    paidInFull: function paidInFull() {
      this.payment.amount = this.totalDue;
    },
    paymentDate: function paymentDate() {
      this.dialog = false;
    },
    paymentRequestStatus: function paymentRequestStatus() {
      if (this.paymentRequestStatus === 201) {
        this.statementTouch++;
        this.payment.amount = 0;
        this.$emit('success');
      }
    },
    touch: function touch() {
      this.reset();
    }
  },
  methods: {
    trackPayment: function trackPayment() {
      this.paymentRequest.data = this.payload;
      this.$request('save', this.paymentRequest);
    },
    setCurrency: function setCurrency(currency) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.payment, 'currency', currency);
    },
    reset: function reset() {
      this.success = false;
      this.paidInFull = false;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.payment, 'reference', null);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.payment, 'amount', 0);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.paymentRequest, 'status', 0);
    }
  },
  computed: {
    paymentRequestStatus: function paymentRequestStatus() {
      return this.paymentRequest.status;
    },
    currency: function currency() {
      return this.payment.currency;
    },
    percentPaid: function percentPaid() {
      if (this.totalDue > 0 && this.payment.amount > 0) {
        return parseFloat(this.payment.amount) / parseFloat(this.totalDue) * 100;
      }
      return 0;
    },
    isSuccess: function isSuccess() {
      return this.paymentRequestStatus === 201;
    },
    paymentDate: function paymentDate() {
      return this.payment.date;
    },
    computedAppointmentIds: function computedAppointmentIds() {
      if (this.appointmentIds && this.appointmentIds.length > 0) {
        return this.appointmentIds;
      }
      if (this.appointments && this.appointments.length > 0) {
        return this.appointments.map(function (a) {
          return a.id;
        });
      }
      if (this.appointment) {
        return [this.appointment.id];
      }
      return [];
    },
    relationship: function relationship() {
      if (this.relationships) {
        if (Array.isArray(this.relationships) && this.relationships.length > 0) {
          return this.relationships[0];
        }
        if (!Array.isArray(this.relationships)) {
          return this.relationships;
        }
      }
      return null;
    },
    relationshipId: function relationshipId() {
      if (this.relationship && this.relationship.id) {
        return this.relationship.id;
      }
      return null;
    },
    userId: function userId() {
      if (this.relationship && this.relationship.client) {
        return this.relationship.client;
      }
    },
    payload: function payload() {
      var dt = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(this.payment.date).toISODate();
      var tm = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].local().toISOTime();
      var dtme = dt + 'T' + tm;

      return {
        actor_id: this.me.id,
        practitioner_id: this.me.id,
        customer_id: this.userId,
        relationship_id: this.relationshipId,
        method: this.payment.payment_method,
        reference: this.payment.reference,
        date: dtme,
        appointments: this.computedAppointmentIds,
        amount: this.payment.amount,
        type: 'Payment'
      };
    },
    dueAfterPayment: function dueAfterPayment() {
      if (this.payment) {
        return parseFloat(this.totalDue) - parseFloat(this.payment.amount);
      }
      return false;
    },
    paymentExceedsAppointments: function paymentExceedsAppointments() {
      var remaining = parseFloat(this.totalDue) - parseFloat(this.payment.amount);
      return remaining < 0;
    },
    isValid: function isValid() {
      if (!this.payment.amount) {
        return 'Please choose an amount';
      }
      if (!this.payment.payment_method) {
        return 'Please choose a payment method';
      }
      if (!this.payment.date) {
        return 'Please choose an amount';
      }
      if (!this.payload.relationship_id) {
        return 'No relationship found';
      }
      if (!this.payload.customer_id) {
        return 'No customer id specified';
      }
      return true;
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_ShareCard_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_ShareCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_cards_ShareCard_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShareAppointment',
  components: { ShareCard: __WEBPACK_IMPORTED_MODULE_0__components_cards_ShareCard_vue___default.a },
  props: {
    appointmentId: { required: true }
  },
  data: function data() {
    return {
      req: {
        resource: 'ag.appointments'
      }
    };
  },

  watch: {
    appointmentId: {
      immediate: true,
      handler: function handler() {
        if (this.appointmentId) {
          this.get();
        }
      }
    }
  },
  computed: {
    appointment: function appointment() {
      return this.getObjectPath(this.req, 'result', {});
    },
    relationshipId: function relationshipId() {
      return this.getObjectPath(this.appointment, 'computed_relationship_id');
    },
    link: function link() {
      if (this.appointment && this.appointment.id) {
        return this.getAppointmentShareLink(this.appointment);
      }
      return null;
    },
    links: function links() {
      if (this.link) {
        return [this.link];
      }
      return [];
    }
  },
  methods: {
    get: function get() {
      this.req.resourceId = this.appointmentId;
      this.$request('get', this.req);
    }
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NoteList__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NoteList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_NoteList__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotesTab',
  components: { NoteList: __WEBPACK_IMPORTED_MODULE_0__components_NoteList___default.a },
  props: {
    value: { type: Object, required: true },
    touch: { type: Number, default: 0 },
    flat: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      appointment: false,
      sendMessageDialog: false,
      loading: false
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
        }
      }
    }
  },
  computed: {
    clientObject: function clientObject() {
      var _this = this;

      if (isNaN(this.appointment.client)) {
        if (this.appointment && this.appointment.client) {
          var obj = this.appointment.client;
          obj.client = { id: obj.id };
          return obj;
        }
      } else {
        var cli = this.clients.find(function (client) {
          return _this.appointment.client === client.client.id;
        });

        if (cli && cli.client) {
          var _obj = cli.client;
          _obj.client = { id: cli.client.id };
          return _obj;
        }
        return {};
      }
    },
    clients: function clients() {
      return this.$store.getters.clients;
    }
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_CommunicationList__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_CommunicationList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_lists_CommunicationList__);



var SCHEDULED_TASKS = {
  'schedule.tasks.new_appointment_received': {
    title: 'Send notification to practitioner'
  },
  'schedule.tasks.send_appointment_confirmation': {
    title: 'Send confirmation notification to client'
  },
  'schedule.tasks.send_appointment_reminder': {
    title: 'Send reminder to client'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotificationsTab',
  components: { CommunicationList: __WEBPACK_IMPORTED_MODULE_0__components_lists_CommunicationList___default.a },
  props: {
    value: { type: Object, required: true },
    touch: { type: Number, default: 0 },
    flat: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      SCHEDULED_TASKS: SCHEDULED_TASKS,
      appointment: false,
      sendMessageDialog: false,
      loading: false
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
        }
      }
    }
  },
  methods: {
    setLoading: function setLoading(loading) {
      this.loading = loading;
    }
  },
  i18n: {
    messages: {
      en: {
        comms: {
          title: 'Notifications',
          buttons: {
            send: 'Send a message'
          },
          templatelist: {
            title: 'Choose a message to send'
          },
          messagelist: {
            title: 'The following communications have been sent for this appointment'
          }
        }
      },
      es: {}
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentPriceDetails',
  props: {
    appointmentId: { required: false },
    value: { type: Object, required: false },
    touch: { type: Number, default: 0 },
    withTitle: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      req: {
        resource: 'ag.practitioner.appointments'
      }
    };
  },

  computed: {
    requestStatus: function requestStatus() {
      return this.req.status;
    },
    appointment: function appointment() {
      return this.getObjectPath(this.req, 'result', {});
    },
    financials: function financials() {
      var remoteFinancials = this.getObjectPath(this.req, 'result.financials', null);
      if (this.appointmentId && remoteFinancials) {
        return remoteFinancials;
      }
      if (this.value) {
        return this.value;
      }
      return {};
    },
    finalPrice: function finalPrice() {
      return this.getObjectPath(this.financials, 'final_due');
    }
  },
  watch: {
    appointmentId: {
      immediate: true,
      handler: function handler() {
        this.get();
      }
    },
    touch: function touch() {
      this.get();
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        this.$emit('update:financials', this.financials);
      }
    },
    finalPrice: function finalPrice(val) {
      this.$emit('finalprice', val);
    }
  },
  methods: {
    get: function get() {
      if (this.appointmentId) {
        this.req.resourceId = this.appointmentId;
        this.$request('get', this.req);
      }
    }
  }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CancelAppointment',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_requests__["a" /* default */]],
  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_0__AppointmentListItem___default.a },
  props: {
    appointment: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      reqId: 'cancelappointment-save-request',
      withCommunication: true,
      withBookingLink: false,
      clearprice: false,
      price: 0,
      invoiceDescription: '',
      withInvoiceDescription: false,
      response: { status: 0 }
    };
  },
  mounted: function mounted() {
    if (!this.hasContacts) {
      this.withCommunication = false;
    }
  },

  watch: {
    cancelRequestStatus: function cancelRequestStatus() {
      if (this.cancelRequestStatus === 200) {
        this.$emit('appointmentcancelled', this.cancelRequest);
        this.getAppointmentsInRange();
        this.$emit('close');
      }
    },
    hasContacts: function hasContacts() {
      if (!this.hasContacts) {
        this.withCommunication = false;
      }
    },

    appointmentId: {
      immediate: true,
      handler: function handler() {
        if (this.appointmentId) {
          this.price = this.appointment.price;
          this.getAppointment(this.appointmentId);
        }
      }
    }
  },
  computed: {
    payload: function payload() {
      if (this.appointmentId) {
        var data = {
          appointments: this.appointmentId.toString(),
          send_notifications: this.withCommunication,
          include_booking_link: this.withBookingLink
        };
        if (this.clearprice) {
          data['price'] = this.price;
        }
        if (this.withInvoiceDescription) {
          data['invoice_description'] = this.invoiceDescription;
        }
        return data;
      }
      return {};
    },
    cancelMessage: function cancelMessage() {
      var firstName = '';
      if (this.client) {
        firstName = this.client.first_name;
      }
      var dt = this.dateformat(this.appointment.start_time);
      var msg = 'Hi ' + firstName + '.%0aYour appointment on ' + dt + ' has been cancelled.';
      if (this.withBookingLink) {
        msg = msg + '%0a\nIf you would like to schedule a new appointment, click here:%0a\nhttps://widget.bookme.guru/?p=' + this.appointment.practitioner;
      }
      return msg;
    },
    appointmentRequest: function appointmentRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_2__store_constants__["k" /* ACTIVE_APPOINTMENT_DETAIL */], true);
    },
    appointmentDetail: function appointmentDetail() {
      return this.getObjectPath(this.appointmentRequest, 'result.data', {});
    },
    cancelRequestStatus: function cancelRequestStatus() {
      return this.response.status;
    },
    appointmentId: function appointmentId() {
      if (this.appointment) {
        return this.appointment.id;
      }
    },
    client: function client() {
      return this.getClientById(this.appointment.client);
    },
    sendCommsHint: function sendCommsHint() {
      if (!this.clientHasContacts(this.client)) {
        return 'No contact details found for this client';
      }
    },
    hasContacts: function hasContacts() {
      if (this.client) {
        return this.clientHasContacts(this.client);
      }
      return false;
    },
    clearpriceIcon: function clearpriceIcon() {
      if (this.clearprice) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    },
    withInvoiceDescriptionIcon: function withInvoiceDescriptionIcon() {
      if (this.withInvoiceDescription) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },
  methods: {
    save: function save() {
      this.action(this.$appointmentguru, 'practitioner', 'appointments', false, 'bulk_cancel', this.payload, this.response);
    },
    toggleInvoiceDescription: function toggleInvoiceDescription() {
      this.withInvoiceDescription = !this.withInvoiceDescription;
      if (!this.withInvoiceDescription) {
        this.invoiceDescription = '';
      }
    },
    toggleClearPrice: function toggleClearPrice() {
      this.clearprice = !this.clearprice;
      if (!this.clearprice) {
        this.price = this.appointment.price;
      }
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AppointmentListItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DeleteAppointment',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_requests__["a" /* default */]],
  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_1__AppointmentListItem___default.a },
  props: {
    appointment: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      reqId: 'deleteappointment-request',
      withCommunication: true
    };
  },

  watch: {
    deleteRequestStatus: function deleteRequestStatus() {
      if (this.deleteRequestStatus === 204) {
        this.$emit('appointmentdeleteled', this.deleteRequest);
        this.getAppointmentsInRange();
        this.$emit('close');
      }
    }
  },
  computed: {
    deleteRequest: function deleteRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    deleteRequestStatus: function deleteRequestStatus() {
      return this.deleteRequest.status;
    }
  },
  methods: {
    save: function save() {
      this.$appointmentguru.resource('appointment').id(this.reqId).delete(this.appointment.id);
    }
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentList',
  props: {
    noteId: { type: Number, required: true },
    value: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      documents: [],
      files: [],
      confirmDeleteFile: false,
      uploading: false,
      deleting: false
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.documents = this.value;
        }
      }
    },
    documentLength: function documentLength() {
      this.$emit('input', this.documents);
    }
  },
  computed: {
    documentLength: function documentLength() {
      return this.documents.length;
    }
  },
  methods: {
    clearfiles: function clearfiles() {
      this.$refs.file.value = '';
      this.files = [];
    },
    setFiles: function setFiles(file) {
      this.files = this.$refs.file.files;
    },
    deleteFile: function deleteFile(file, index) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(file, 'deleting', true);
      var url = this.$metadataguru.baseUrl + '/v3/notes/' + this.noteId + '/document/';
      var headers = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$metadataguru.headers));
      var method = 'delete';
      var params = { document: file.id };
      this.deleting = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: url, headers: headers, method: method, params: params }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(file, 'deleting', false);
        _this.deleting = false;
        _this.documents.splice(index, 1);
        _this.confirmDeleteFile = false;
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(file, 'deleting', false);
        _this.deleting = false;
        window.alert('Unable to delete this file');
      });
    },
    upload: function upload() {
      var _this2 = this;

      for (var i = 0; i < this.files.length; i++) {
        var file = this.files[i];
        if (file) {
          (function () {
            var vm = _this2;
            vm.uploading = true;
            var data = new FormData();
            data.append('file', file);
            data.append('name', file.name.substring(0, 50));
            var url = _this2.$metadataguru.baseUrl + '/v3/notes/' + _this2.noteId + '/actions/upload/';
            var headers = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.$metadataguru.headers));
            headers['Content-Type'] = 'multipart/form-data';

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, data, { headers: headers }).then(function (res) {
              vm.uploading = false;
              vm.documents.push(res.data);
              vm.clearfiles();
            }).catch(function () {
              vm.uploading = false;
            });
          })();
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        upload: {
          button: 'Choose files to upload|upload {n} file|upload {n} files'
        }
      },
      es: {}
    }
  }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_AppointmentPriceDetails_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_AppointmentPriceDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_AppointmentPriceDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentProduct_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentProduct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_appointment_AppointmentCodes__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_appointment_AppointmentCodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_appointment_AppointmentCodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_statement_PaymentList_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_statement_PaymentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_statement_PaymentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_CreateTransaction_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_CreateTransaction_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_CreateTransaction_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_invoice_manage_create_confirm_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_invoice_manage_create_confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_invoice_manage_create_confirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_invoice_InvoiceList__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_invoice_InvoiceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_invoice_InvoiceList__);
















var PANELS = {
  INFO: 0,
  CODES: 1,
  PRODUCTS: 2,
  INVOICES: 3,
  PAYMENTS: 4
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceDetails',
  components: {
    AppointmentCodes: __WEBPACK_IMPORTED_MODULE_6__components_appointment_AppointmentCodes___default.a,
    AppointmentProduct: __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentProduct_vue___default.a,
    AppointmentListItem: __WEBPACK_IMPORTED_MODULE_4__components_appointment_AppointmentListItem___default.a,
    AppointmentPriceDetails: __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_AppointmentPriceDetails_vue___default.a,
    PaymentList: __WEBPACK_IMPORTED_MODULE_7__components_statement_PaymentList_vue___default.a,
    CreateTransaction: __WEBPACK_IMPORTED_MODULE_8__components_appointment_actions_CreateTransaction_vue___default.a,
    ConfirmInvoice: __WEBPACK_IMPORTED_MODULE_9__components_invoice_manage_create_confirm_vue___default.a,

    InvoiceList: __WEBPACK_IMPORTED_MODULE_10__components_invoice_InvoiceList___default.a
  },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    closeable: { type: Boolean, default: true },
    withCreate: { type: Boolean, default: true },
    withDone: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      invoice: {},
      activePanel: null,
      createInvoice: false,
      addPaymentDialog: false,
      touchPayment: 0,
      PANELS: PANELS,
      reqId: __WEBPACK_IMPORTED_MODULE_2__store_constants__["k" /* ACTIVE_APPOINTMENT_DETAIL */],
      fetchAppointmentTimeout: null,
      appointment: {},
      editReqId: 'invoice-edit-appointment-request',
      invoiceReqId: 'get-invoices-for-appt',
      readyForInvoicing: null,
      discountdialog: false,
      showDescription: false,
      showProductPicker: false,
      selectedProduct: null,
      codeLineItemSubTotal: 0,
      invoiceTitle: null,
      invoiceDescription: null,
      editTitle: false,
      addCodes: false,
      requests: {
        set_discount: {
          resource: 'ag.practitioner.appointments',
          extra: 'actions/set_discount',
          method: 'post'
        }
      },
      appointmentPriceRules: [function (v) {
        return !!v || 'Price is required';
      }]
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.appointment = this.value;
    }
  },

  watch: {
    appointmentId: {
      immediate: true,
      handler: function handler() {
        if (this.appointmentId) {
          this.activePanel = null;
          this.loadAppointment();
        }
      }
    },
    value: function value() {
      if (this.value) {
        this.appointment = this.value;
      }
    },
    activePanel: function activePanel() {
      if (this.activePanel === PANELS.INVOICES) {
        this.loadInvoices();
      }
    },
    appointment: function appointment() {
      this.$emit('input', this.appointment);
    },
    appointmentRequestStatus: function appointmentRequestStatus() {
      if (this.appointmentRequestStatus === 200) {
        this.appointment = this.appointmentRequest.result.data;
        this.invoiceTitle = this.appointment.invoice_title || this.appointmentInvoiceTitle;
        this.invoiceDescription = this.appointment.invoice_description;
        this.editTitle = false;
      }
    },
    appointmentDiscountStatus: function appointmentDiscountStatus() {
      if (this.appointmentDiscountStatus === 200) {
        this.loadAppointment();
      }
    },
    appointmentEditRequestStatus: function appointmentEditRequestStatus() {
      if (this.appointmentEditRequestStatus === 200) {
        this.loadAppointment();
      }
    },
    readyForInvoicing: function readyForInvoicing() {
      if (this.readyForInvoicing !== null) {
        this.markAsInvoiceable(this.readyForInvoicing);
      }
    }
  },
  computed: {
    appointmentId: function appointmentId() {
      if (this.appointment.id) {
        return this.appointment.id;
      }
      return 0;
    },
    appointmentInvoiceTitle: function appointmentInvoiceTitle() {
      if (this.appointment.invoice_title) {
        return this.appointment.invoice_title;
      }
      var title = this.appointment.title;
      if (!title) {
        title = this.appointment.full_name;
      }
      var appointmentDateFormatted = this.dateformat(this.appointment.start_time, 'ddd DD MMM YYYY');
      return title + '. ' + appointmentDateFormatted;
    },
    computedRelationship: function computedRelationship() {
      if (this.appointment && this.appointment.relationships && this.appointment.relationships.length > 0) {
        return this.appointment.relationships[0].relationship;
      }
      return null;
    },
    appointmentRequest: function appointmentRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    appointmentDetail: function appointmentDetail() {
      return this.getObjectPath(this.appointmentRequest, 'result.data', {});
    },
    appointmentRequestStatus: function appointmentRequestStatus() {
      return this.appointmentRequest.status;
    },
    appointmentEditRequest: function appointmentEditRequest() {
      return this.$store.getters.getRequestById(this.editReqId, true);
    },
    appointmentEditRequestStatus: function appointmentEditRequestStatus() {
      return this.appointmentEditRequest.status;
    },
    appointmentDiscountStatus: function appointmentDiscountStatus() {
      return this.requests.set_discount.status;
    },
    invoices: function invoices() {
      return this.getObjectPath(this.invoiceRequest, 'result.data.results', []);
    },
    invoiceRequest: function invoiceRequest() {
      return this.$store.getters.getRequestById(this.invoiceReqId, true);
    },
    isPaid: function isPaid() {
      return this.appointment.status === 'P';
    },
    hasCodes: function hasCodes() {
      return this.appointment.codes && this.appointment.codes.length > 0;
    },
    invoiceableStatus: function invoiceableStatus() {
      if (this.appointmentEditRequest.loading) {
        return 'updating..';
      }
      if (this.appointment) {
        if (this.appointment.invoiceable === true) {
          return 'Appointment IS READY for invoicing';
        }
      }
      return 'Appointment is NOT ready for invoicing';
    },
    formattedStatus: function formattedStatus() {
      if (this.appointment && this.appointment.status) {
        var formatted = this.formatStatus(this.appointment.status);
        if (formatted) {
          return formatted;
        }
      }
      return {};
    },
    product: function product() {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(parseInt(this.appointment.product))) {
        return this.getProductById(this.appointment.product, true);
      }
      return this.appointment.product;
    },
    appointmentPriceHint: function appointmentPriceHint() {
      if (this.hasCodes) {
        return 'Price is the sum of medical aid line items. It is not editable';
      }
      return 'The price for this appointment as will be used for invoicing';
    }
  },
  methods: {
    save: function save() {
      this.$metadataguru.resource('lineitems').create(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.lineitems));
    },
    setDiscount: function setDiscount() {
      if (!this.appointment.discount_amount) {
        this.appointment.discount_amount = 0;
      }
      this.requests.set_discount.data = {
        discount_amount: this.appointment.discount_amount,
        appointment: this.appointment.id
      };
      this.requests.set_discount.resourceId = this.appointment.id;
      this.$request('save', this.requests.set_discount);
    },
    setAppointmentPrice: function setAppointmentPrice(price) {
      var data = {
        price: price
      };
      this.$appointmentguru.resource('appointment').save(this.appointment.id, data);
      this.appointment.price = price;
    },
    saveAppointmentProduct: function saveAppointmentProduct(productId) {
      var data = { product: productId };
      this.$appointmentguru.resource('appointment').id(this.editReqId).save(this.appointment.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    },
    saveAppointmentDetails: function saveAppointmentDetails() {
      if (this.appointmentEditRequest.loading) {
        return false;
      }
      var data = {
        price: this.appointment.price,
        invoice_title: this.invoiceTitle,
        invoice_description: this.invoiceDescription
      };
      this.$appointmentguru.resource('appointment').id(this.editReqId).save(this.appointment.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    },
    markAsInvoiceable: function markAsInvoiceable() {
      var data = { invoiceable: this.appointment.invoiceable };
      this.$appointmentguru.resource('appointment').id(this.editReqId).save(this.appointment.id, data);
    },
    productSelected: function productSelected(data) {
      this.appointment.product = data.product;
      this.saveAppointmentProduct(data.product.id);
      this.showProductPicker = false;
    },
    loadAppointment: function loadAppointment() {
      if (this.appointmentId && !this.appointmentRequest.loading) {
        this.getAppointment(this.appointmentId);
      }
    },
    loadInvoices: function loadInvoices() {
      var params = {
        appointments: this.appointment.id
      };
      this.$invoiceguru.resource('invoices').id(this.invoiceReqId).list(params);
    },
    launchInvoiceDialog: function launchInvoiceDialog() {
      var client = this.appointmentDetail.client;
      var options = {
        appointments: [this.appointment],
        client: client
      };
      this.launchQuickInvoiceDialog(options);
    },
    gotoInvoice: function gotoInvoice(invoice) {
      this.$router.push('/invoices/' + invoice.id);
      this.$emit('close');
    },
    codeLineItemSubTotalChanged: function codeLineItemSubTotalChanged(newValue) {
      this.codeLineItemSubTotal = newValue;
    }
  },
  i18n: {
    messages: {
      en: {
        titles: {
          invoices: 'Invoices'
        }
      }
    }
  }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ServerErrors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ServerErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ServerErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_DocumentList__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_DocumentList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_DocumentList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pickers_SpacePicker__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pickers_SpacePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pickers_SpacePicker__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Notes',
  components: { ServerErrors: __WEBPACK_IMPORTED_MODULE_2__components_ServerErrors___default.a, DocumentList: __WEBPACK_IMPORTED_MODULE_3__components_appointment_edit_DocumentList___default.a, SpacePicker: __WEBPACK_IMPORTED_MODULE_4__components_pickers_SpacePicker___default.a },
  props: {
    value: { type: Object, required: false },
    appointment: { type: Object, default: function _default() {
        return {};
      } },
    client: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      valid: false,
      dirty: false,
      choosedate: false,
      confirmDelete: false,
      reqId: __WEBPACK_IMPORTED_MODULE_1__store_constants__["t" /* NOTE_SAVE_REQ */],
      getReqId: 'get-note-request',
      delReqId: 'delete-note-request',
      title: '',
      text: '',
      noteDate: null,
      sharing: [],
      id: 0,
      errors: {},
      sharingHint: 'You can choose to share this with members of one of your spaces. Space members will be able to read the note (but not change it). Don\'t share if you would prefer to keep it private'
    };
  },
  mounted: function mounted() {
    if (!this.noteDate) {
      this.noteDate = this.dateformat(null, 'YYYY-MM-DD');
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value && !this.valueIsAppointment) {
          this.setNote(this.value);
        } else {
          this.newNote();
        }
      }
    },
    noteString: function noteString() {
      this.dirty = true;
    },
    noteDate: function noteDate() {
      this.choosedate = false;
    },

    appointmentDate: {
      immediate: true,
      handler: function handler() {
        if (this.appointmentDate) {
          this.noteDate = this.appointmentDate;
        }
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 201) {
        var note = this.getObjectPath(this.saveRequest, 'result.data');
        this.$emit('input', note);
        this.setNote(note);
        this.dirty = false;
      }
      if (this.saveRequestStatus >= 200 && this.saveRequestStatus < 300) {
        this.dirty = false;
      }
    },
    getRequestStatus: function getRequestStatus() {
      var note = this.getObjectPath(this.getRequest, 'result.data', {});
      this.setNote(note);
    },
    delRequestStatus: function delRequestStatus() {
      if (this.delRequestStatus === 204) {
        this.$emit('note:deleted', this.delRequestStatus);
        this.newNote();
        this.confirmDelete = false;
      }
    }
  },
  computed: {
    isNewNote: function isNewNote() {
      return !this.id || this.id === 0;
    },
    valueIsAppointment: function valueIsAppointment() {
      if (this.value && this.appointment && this.value.id === this.appointment.id) {
        return true;
      }
      return false;
    },
    appointmentDate: function appointmentDate() {
      if (this.appointment && this.appointment.start_time) {
        var dateBits = this.appointment.start_time.split('T');
        if (dateBits.length === 2) {
          return dateBits[0];
        }
      }
      return null;
    },
    noteString: function noteString() {
      return this.id + this.title + this.text + this.noteDate + this.sharing;
    },
    saveText: function saveText() {
      if (this.isNewNote) {
        return 'Create';
      }
      return 'Save';
    },
    me: function me() {
      return this.$store.getters.me;
    },
    getRequest: function getRequest() {
      return this.$store.getters.getRequestById(this.getReqId, true);
    },
    getRequestStatus: function getRequestStatus() {
      return this.getRequest.status;
    },
    saveRequest: function saveRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.saveRequest.status;
    },
    delRequest: function delRequest() {
      return this.$store.getters.getRequestById(this.delReqId, true);
    },
    delRequestStatus: function delRequestStatus() {
      return this.delRequest.status;
    },
    headingClasses: function headingClasses() {
      if (this.isNewNote) {
        return ['grey', 'lighten-2'];
      }
      return [];
    },
    userObject: function userObject() {
      if (this.client && this.client.client) {
        return this.client.client;
      }
      if (this.client) {
        return this.client;
      }
      return {};
    },
    relationshipId: function relationshipId() {
      if (this.client) {
        return this.client.id;
      }
    },
    appointmentId: function appointmentId() {
      if (this.appointment) {
        return this.appointment.id;
      }
    }
  },
  methods: {
    setNote: function setNote(note) {
      console.log(note);
      this.id = note.id;
      this.noteDate = note.date;
      this.title = note.title;
      this.text = note.text;
      this.documents = note.documents;
      this.sharing = note.spaces;
    },
    newNote: function newNote() {
      this.title = '';
      this.text = '';
      this.noteDate = this.dateformat(null, 'YYYY-MM-DD');
      this.id = 0;
      this.sharing = [];
    },
    addTemplate: function addTemplate() {
      var text = '\n    Subjective:\n    Objective:\n    Assessment:\n    Plan:\n    ';
      this.text += text;
    },
    getNote: function getNote() {
      return this.$metadataguru.resource('notes').id(this.getReqId).get(this.id);
    },
    doDelete: function doDelete() {
      return this.$metadataguru.resource('notes').id(this.delReqId).delete(this.id);
    },
    save: function save() {
      var data = {
        title: this.title,
        text: this.text,
        date: this.noteDate,
        spaces: this.sharing
      };
      if (this.isNewNote) {
        data.owners = [this.me.id];
        data.object_ids = [];
        if (this.userObject && this.userObject.id) {
          data.object_ids.push('client:' + this.userObject.id);
        }
        if (this.relationshipId) {
          data['relationship_id'] = this.relationshipId;
        }
        if (this.appointment && this.appointment.id) {
          data.object_ids = ['appointment:' + this.appointment.id];
          if (this.appointment.client) {
            var clientId = this.appointment.client;
            if (this.appointment.client.id) {
              clientId = this.appointment.client.id;
            }
            data.object_ids.push('client:' + clientId);
            var relationship = this.getRelationByClientId(clientId);
            if (relationship) {
              data['relationship_id'] = relationship.id;
            }
          }
        }
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
        return this.$metadataguru.resource('notes').id(this.reqId).create(data);
      } else {
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
        return this.$metadataguru.resource('notes').id(this.reqId).save(this.id, data);
      }
    }
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_communications_BatchIdList__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_communications_BatchIdList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_communications_BatchIdList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_calendar_PractitionerDayView_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_calendar_PractitionerDayView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_calendar_PractitionerDayView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(3);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Reschedule',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_requests__["a" /* default */]],
  components: {
    BatchIdList: __WEBPACK_IMPORTED_MODULE_4__components_communications_BatchIdList___default.a,
    AppointmentListItem: __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentListItem___default.a,
    PractitionerDayView: __WEBPACK_IMPORTED_MODULE_6__components_calendar_PractitionerDayView_vue___default.a
  },
  props: {
    appointment: { type: Object, default: function _default() {
        return {};
      } },
    standAlone: true
  },
  data: function data() {
    return {
      reqId: 'reschedule-request',
      window: 1,
      batchId: null,
      loading: false,
      saveRequest: false,
      saveRequestStatus: false,
      updatedAppointment: null,
      apptDetailReq: {
        resource: 'ag.practitioner.appointments'
      },
      clientReq: {
        resource: 'ag.clients'
      },
      messageReq: {
        resource: 'ag.settings.messages',
        resourceId: 'appointment_reminder'
      },
      viz: {
        daymodal: false,
        starttime: false,
        endtime: false
      },
      timeData: {
        date: null,
        start: null,
        end: null
      },
      notifications: true
    };
  },
  mounted: function mounted() {
    this.init();
    if (!this.messageTarget) {
      this.notifications = false;
    }
  },

  watch: {
    appointmentId: function appointmentId() {
      this.init();
    },
    relationship: function relationship() {
      if (this.relationshipId) {
        this.$store.commit('addClient', this.relationship);
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200) {
        this.window = 1;
      }
    },
    formattedAppointment: function formattedAppointment() {
      this.$emit('input', this.formattedAppointment);
    },
    messageTarget: function messageTarget() {
      if (!this.messageTarget) {
        this.notifications = false;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getPractitionerById']), {
    serverError: function serverError() {
      if (this.saveRequestStatus === -1) {
        return 'Unable to connect to the internet. Please check your internet connection';
      }
      if (this.saveRequestStatus >= 500) {
        return 'Something went wrong. Please try again.';
      }
    },
    appointmentDetail: function appointmentDetail() {
      return this.getObjectPath(this.apptDetailReq, 'result', {});
    },
    message: function message() {
      return this.getObjectPath(this.messageReq, 'result', {});
    },
    practitioner: function practitioner() {
      if (this.appointment && this.appointment.practitioner) {
        if (isNaN(this.appointment.practitioner) && this.appointment.practitioner.id) {
          return this.appointment.practitioner;
        } else {
          return this.getPractitionerById(this.appointment.practitioner);
        }
      }
      return null;
    },
    relationshipId: function relationshipId() {
      return this.getObjectPath(this.appointment, 'computed_relationship_id');
    },
    relationship: function relationship() {
      return this.getObjectPath(this.clientReq, 'result', {});
    },
    client: function client() {
      var serverClient = this.getObjectPath(this.appointmentDetail, 'client', null);
      if (serverClient) {
        return serverClient;
      }
      if (this.appointment && this.appointment.client) {
        if (isNaN(this.appointment.client)) {
          return this.appointment.client;
        } else {
          return this.getClientById(this.appointment.client);
        }
      }
    },
    isNewTime: function isNewTime() {
      if (this.appointment && this.timeData && this.timeData.start && this.timeData.end) {
        return this.timeData.start !== this.appointment.start || this.timeData.end !== this.appointment.end || this.timeData.date !== this.appointment.dt;
      }
      return false;
    },
    previewEvent: function previewEvent() {
      if (this.isNewTime) {
        return {
          start_time: this.timeData.start,
          end_time: this.timeData.end
        };
      }
      return null;
    },
    messageTarget: function messageTarget() {
      if (this.client && this.clientHasContacts(this.client)) {
        if (this.message.type === 'Email') {
          if (this.isRealEmail(this.client.email)) {
            return this.client.email;
          }
        }
        if (this.message.type === 'SMS') {
          return this.client.phone_number;
        }
      }
      return null;
    },
    appointmentId: function appointmentId() {
      return this.appointment.id;
    },
    rescheduleRequest: function rescheduleRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    startDateFormated: function startDateFormated() {
      return this.timeData.date;
    },
    startMoment: function startMoment() {
      if (this.timeData && this.timeData.start) {
        return this.timeStringToMoment(this.timeData.start);
      }
    },
    formattedStartTimeString: function formattedStartTimeString() {
      if (this.timeData && this.timeData.start) {
        var time = this.timeStringToMoment(this.timeData.start, this.timeData.date);
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).utc().toISOString();
      }
    },
    formattedEndTimeString: function formattedEndTimeString() {
      if (this.timeData && this.timeData.end) {
        var time = this.timeStringToMoment(this.timeData.end, this.timeData.date);
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).utc().toISOString();
      }
    },
    clientErrors: function clientErrors() {
      var errors = [];
      if (this.appointmentLength <= 0) {
        errors.push('End time must be after start time');
      }
      return errors;
    },
    isValid: function isValid() {
      return this.clientErrors.length <= 0;
    },
    formattedAppointment: function formattedAppointment() {
      var data = {
        send_notifications: this.notifications,
        new_start_time: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('hour'),
        new_end_time: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'hour').startOf('hour')
      };
      if (this.timeData && this.timeData.start) {
        data['new_start_time'] = this.timeStringToMoment(this.timeData.start, this.timeData.date);
      }
      if (this.timeData && this.timeData.end) {
        data['new_end_time'] = this.timeStringToMoment(this.timeData.end, this.timeData.date);
      }
      return data;
    },
    appointmentLength: function appointmentLength() {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.formattedAppointment.new_start_time);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.formattedAppointment.new_end_time);
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(end.diff(start)).asMinutes();
    }
  }),
  methods: {
    init: function init() {
      if (this.appointment && this.appointment.start_time) {
        this.timeData = this.fromAppointment(this.appointment);
      }
      this.window = 0;
      this.batchId = null;
      this.updatedAppointment = null;
      this.loading = false;
      this.saveRequest = false;
      this.saveRequestStatus = false;

      if (this.appointmentId) {
        this.apptDetailReq.resourceId = this.appointmentId;
        this.$request('get', this.apptDetailReq);
      }
      this.getRelationship();
      this.getMessage();
    },
    getMessage: function getMessage() {
      this.$request('get', this.messageReq);
    },
    getRelationship: function getRelationship() {
      if (this.relationshipId) {
        this.clientReq.resourceId = this.relationshipId;
        this.$request('get', this.clientReq);
      }
    },
    setStartTime: function setStartTime(data) {
      __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(this.timeData, 'start', data.start);
      this.startTimeChanged();
    },
    allowedMinutes: function allowedMinutes() {
      return [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];
    },
    resetDateTime: function resetDateTime() {
      this.timeData = this.fromAppointment(this.appointment);
    },
    fromAppointment: function fromAppointment(appointment) {
      if (appointment.start_time && appointment.end_time) {
        var startMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(appointment.start_time);
        var endMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(appointment.end_time);
        var data = {
          date: startMoment.format('YYYY-MM-DD'),
          start: startMoment.format('HH:mm'),
          end: endMoment.format('HH:mm'),
          difference: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(endMoment.diff(startMoment)).asMinutes()
        };
        return data;
      }
    },
    dateDelta: function dateDelta(days) {
      var newdate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.timeData.date).add(days, 'days').format('YYYY-MM-DD');
      this.timeData.date = newdate;
    },
    startTimeChanged: function startTimeChanged() {
      var endMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.formattedAppointment.new_start_time).add(this.timeData.difference, 'minutes');

      this.timeData.end = endMoment.format('HH:mm');
    },
    endTimeChanged: function endTimeChanged() {
      var startMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.formattedAppointment.new_start_time);
      var endMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.formattedAppointment.new_end_time);
      this.timeData.difference = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(endMoment.diff(startMoment)).asMinutes();
    },
    save: function save() {
      var _this = this;

      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formattedAppointment));
      data.new_start_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.new_start_time).utc().format('YYYY-MM-DD HH:mm');
      data.new_end_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.new_end_time).utc().format('YYYY-MM-DD HH:mm');
      this.loading = true;
      this.saveRequestStatus = 0;

      this.performAction(this.$appointmentguru, 'practitioner', 'appointments', this.appointment.id, 'reschedule', data).then(function (result) {
        _this.batchId = result.data.batch_id;
        _this.saveRequest = result;
        _this.saveRequestStatus = result.status;
        _this.updatedAppointment = result.data;

        _this.$store.commit('addAppointments', [result.data]);

        _this.loading = false;
        _this.window = 1;
      }).catch(function (result) {
        _this.batchId = null;
        _this.loading = false;
        if (result && result.response) {
          _this.saveRequest = result.response;
          _this.saveRequestStatus = result.response.status;
        } else {
          _this.saveRequest = null;
          _this.saveRequestStatus = -1;
        }
      });
    }
  }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_auth_UserStatus__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_auth_UserStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_auth_UserStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_GroupedPractitionerPicker__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_GroupedPractitionerPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_GroupedPractitionerPicker__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountSwitcher',
  components: { GroupedPractitionerPicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_GroupedPractitionerPicker___default.a, UserStatus: __WEBPACK_IMPORTED_MODULE_0__components_auth_UserStatus___default.a },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    groups: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      visible: false,
      dialog: false,
      status: null,
      currentUser: {},
      originalUser: {},
      reqId: 'become-request'
    };
  },

  watch: {
    value: function value() {
      if (this.value) {
        this.currentUser = this.value;
      }
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        this.status = 'success';
        this.$emit('became', this.request.result.data);
        var vm = this;
        setTimeout(function () {
          vm.dialog = false;
          vm.status = null;
        }, 2000);
      }
    }
  },
  methods: {
    triggerBecome: function triggerBecome(practitioner) {
      this.currentUser = practitioner;

      this.dialog = true;
      this.status = 'switching';
      var data = {
        become_id: practitioner.id
      };
      this.$multiguru.resource('become').id(this.reqId).create(data);
    }
  },
  computed: {
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    }
  },
  i18n: {
    messages: {
      en: {
        message: {
          switching: 'Switching Accounts',
          progress: 'Logging in as {user}',
          success: 'You are now logged in as {user}'
        }
      }
    }
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Login_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Login_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Session',
  components: { Login: __WEBPACK_IMPORTED_MODULE_2__components_pages_Login_vue___default.a },
  data: function data() {
    return {
      refreshtype: 'ping',
      loginchallenge: false,
      logoutDialog: false,
      requests: {
        refresh: {
          resource: 'ag.auth.session',
          method: 'post',
          status: 0
        }
      },
      heartbeatIntervalTime: 600000,

      heartbeatInterval: null
    };
  },

  watch: {
    loginChallengeCount: function loginChallengeCount() {
      if (['/login', '/logout'].indexOf(this.$route.path) === -1) {
        this.$store.commit('SET_POST_LOGIN_REDIRECT', this.$route.path);
        this.refreshtype = '401';
        this.loginchallenge = true;
      }
    },
    logoutRequestCount: function logoutRequestCount() {
      this.logout();
    },
    unauthorizedRequestCount: function unauthorizedRequestCount() {
      if (this.unauthorizedRequestCount > 0) {
        this.$store.commit('LOGIN_CHALLENGE');
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['token', 'loginChallengeCount', 'logoutRequestCount']), {
    unauthorizedRequestCount: function unauthorizedRequestCount() {
      return this.$store.getters.getRequestByStatusCode(401).length;
    },
    logoutStatus: function logoutStatus() {
      return this.requests.logout.status;
    }
  }),
  methods: {
    logout: function logout() {
      this.$router.push({ path: '/logout' });
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserStatus',
  props: {
    practitioner: { type: Object },
    withDropdown: { type: Boolean, default: false }
  },
  computed: {
    profilePic: function profilePic() {
      return this.getObjectPath(this.practitioner, 'profile.profile_picture', false);
    }
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InviteBtn',
  props: {
    icon: { type: String },
    text: { type: String, default: 'Invite teammates' },
    attrs: { type: Object, default: function _default() {} }
  },
  data: function data() {
    return { LINKS: __WEBPACK_IMPORTED_MODULE_0__store_constants__["a" /* LINKS */] };
  }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);




var SETTINGS_KEY = 'ag.calendar.settings';
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CalendarSettings',
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      visible: false,
      settings: {
        density: 1
      },
      options: [{
        text: 'Density',
        value: 'density',
        items: [{ text: 'Compact', value: 1 }, { text: 'Comfortable', value: 2 }, { text: 'Max spacing', value: 3 }]
      }, {
        text: 'Days to show',
        value: 'numDays',
        items: [{ text: 'Auto', value: null }, { text: '4', value: 4 }, { text: '5', value: 5 }, { text: '7', value: 7 }]
      }]
    };
  },
  mounted: function mounted() {
    var settings = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$cookies.get(SETTINGS_KEY);
    if (settings) {
      this.$emit('input', settings);
    }
  },

  watch: {
    value: function value() {
      if (this.value) {
        this.settings = this.value;
      }
    },
    settingsString: function settingsString() {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$cookies.set(SETTINGS_KEY, this.settings);
      if (window.localStorage) {
        window.localStorage.setItem(SETTINGS_KEY, this.settingsString);

        window.localStorage.getItem(SETTINGS_KEY);
      }
    }
  },
  methods: {
    setItem: function setItem(key, value) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.settings, key, value);
      this.$emit('input', this.settings);
    }
  },
  computed: {
    settingsString: function settingsString() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.settings);
    }
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DayEvent',
  props: {
    value: { type: Object, required: true },
    selectedEvent: { type: Object },
    eventOffset: { type: Number, default: 5 },
    startHour: { type: Number, default: 5 },
    periodInMins: { type: Number, default: 15 },
    defaultNewEventLength: { type: Number, default: 30 },
    pixelToMinuteRatio: { type: Number, default: 1 },
    maxWidthPercentage: { type: Number, default: 90 }
  },
  data: function data() {
    return {
      tooltips: {
        invoiceable: false
      }
    };
  },

  methods: {
    timeToPixels: function timeToPixels(fromTimeString, toTimeString) {
      var startMoment = this.timeStringToMoment(fromTimeString);
      var toMoment = this.timeStringToMoment(toTimeString);
      var duration = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(toMoment.diff(startMoment));
      var height = duration.asMinutes();
      if (this.pixelToMinuteRatio > 1) {
        height = height * this.pixelToMinuteRatio;
      }
      return height;
    }
  },
  computed: {
    event: function event() {
      return this.value;
    },
    periodHeight: function periodHeight() {
      return this.periodInMins * this.pixelToMinuteRatio;
    },
    eventClass: function eventClass() {
      var event = this.event;
      var selectedEvent = this.selectedEvent;
      var data = {};
      if (selectedEvent) {
        data['elevation-5'] = event.id === selectedEvent.id;
      }
      if (event.selected) {
        data['elevation-5'] = true;
      }
      if (this.globalSelectedAppointmentIds && this.globalSelectedAppointmentIds.length > 0) {
        if (this.globalSelectedAppointmentIds.indexOf(event.id) > -1) {
          data['elevation-5'] = true;
        }
      }
      if (event.highlight) {
        data['elevation-5'] = true;
      }
      if (event.status) {
        var statusClass = 'status-' + event.status.toLowerCase();
        data[statusClass] = true;
      }

      return data;
    },
    eventStyle: function eventStyle() {
      var event = this.event;
      var top = this.timeToPixels('0' + this.startHour + ':00', event.start);
      if (this.pixelToMinuteRatio > 1) {
        top = top - this.periodHeight / this.pixelToMinuteRatio;
      }
      var styles = {
        top: top + 'px',
        height: this.timeToPixels(event.start, event.end) + 'px'
      };
      if (event.partialOverlapCount > 0) {
        var offset = event.partialOverlapCount * this.eventOffset;
        var width = this.maxWidthPercentage - offset;
        styles['left'] = offset + '%';
        styles['width'] = width + '%';
      }
      if (event.exactOverlapCount > 1) {
        var unitPercent = this.maxWidthPercentage / event.exactOverlapCount;
        styles['left'] = event.exactOverlapSequence * unitPercent + '%';
        styles['width'] = unitPercent + '%';
      }
      var target = document.getElementById('event-' + event.id);
      if (target) {
        target.style.transform = 'translate(0px, 0px)';

        target.setAttribute('data-x', 0);
        target.setAttribute('data-y', 0);
      }

      return styles;
    }
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_AppointmentBottomSheet_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_AppointmentBottomSheet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_AppointmentBottomSheet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DayEvent_vue__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DayEvent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DayEvent_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,

  name: 'DayView',
  components: { AppointmentBottomSheet: __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_AppointmentBottomSheet_vue___default.a, DayEvent: __WEBPACK_IMPORTED_MODULE_3__DayEvent_vue___default.a },
  props: {
    eventOffset: { type: Number, default: 5 },
    startHour: { type: Number, default: 5 },
    endHour: { type: Number, default: 20 },
    periodInMins: { type: Number, default: 15 },
    defaultNewEventLength: { type: Number, default: 30 },
    pixelToMinuteRatio: { type: Number, default: 1 },
    maxWidthPercentage: { type: Number, default: 90 },
    flat: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false },

    date: { type: String, default: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD') },
    events: { type: Array, default: function _default() {
        return [];
      } },
    selectedAppointment: { type: Object, required: false },
    previewEvent: { type: Object, required: false }
  },
  data: function data() {
    return {
      bottomsheet: false,
      dragging: false,
      selectedEvent: {},
      activeTime: 0,
      activePixels: 0,
      activeEvent: {},
      eventClickWatcher: Math.random()
    };
  },

  computed: {
    numPeriods: function numPeriods() {
      return (this.endHour * 60 - this.startHour * 60) / this.periodInMins;
    },
    selectedEventId: function selectedEventId() {
      if (this.selectedEvent) {
        return this.selectedEvent.id;
      }
    },
    periodsPerHour: function periodsPerHour() {
      return 60 / this.periodInMins;
    },
    periodHeight: function periodHeight() {
      return this.periodInMins * this.pixelToMinuteRatio;
    },
    dragTime: function dragTime() {
      var mins = this.activePixels;
      var startTime = this.timeStringToMoment(this.activeEvent.start);
      return startTime.add(mins, 'minutes').format('HH:mm');
    },
    previewEventTitle: function previewEventTitle() {
      if (this.previewEvent) {
        if (this.previewEvent.is_custom && this.previewEvent.title) {
          return this.previewEvent.title;
        }

        if (this.previewEvent.client && this.previewEvent.client.first_name) {
          var title = this.previewEvent.client.first_name;
          if (this.previewEvent.client.last_name) {
            title = title + ' ' + this.previewEvent.client.last_name;
          }
          return title;
        }
      }
      return null;
    },
    previewEventStyle: function previewEventStyle() {
      if (this.previewEvent && this.previewEvent.start_time && this.previewEvent.end_time && this.previewEvent.end_time > this.previewEvent.start_time) {
        var evt = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.previewEvent));
        evt.start = evt.start_time;
        evt.end = evt.end_time;
        var style = this.getStyle(evt);
        return style;
      }
      return null;
    },
    markedUpEvents: function markedUpEvents() {
      var _this = this;

      var index = 0;
      var vm = this;
      var events = [];
      events = this.events.filter(function (evt) {
        if (!evt.id) {
          return false;
        }

        if (_this.readOnly === true) {
          return true;
        }
        var freshEvt = _this.$store.getters.getAppointment(evt.id);
        var existsToday = freshEvt.dt === _this.date;
        var existsForPractitioner = freshEvt.practitioner === evt.practitioner;

        if (!existsForPractitioner) {
          var options = { id: evt.id, practitionerId: evt.practitioner, dt: _this.date };
          _this.$store.commit('cleanAppointment', options);
        }
        if (!existsToday) {
          var _options = { id: evt.id, practitionerId: evt.practitioner, dt: _this.date };
          _this.$store.commit('cleanAppointment', _options);
        }
        return existsToday && existsForPractitioner;
      });
      events = events.sort(function (a, b) {
        if (vm.timeStringToMoment(a.start).isBefore(vm.timeStringToMoment(b.start))) {
          return -1;
        }
        return 1;
      });
      while (index <= events.length) {
        var event = events[index];
        var exactOverlaps = this.getExactOverlaps(events, event, index);
        var overlapIndex = 0;

        while (overlapIndex <= exactOverlaps.length + 1) {
          var overlapevent = events[index + overlapIndex];
          if (overlapevent) {
            overlapevent.exactOverlapSequence = overlapIndex;
            overlapevent.exactOverlapCount = exactOverlaps.length;
          }
          overlapIndex++;
        }
        if (index > 0) {
          var previousEvent = events[index - 1];
          if (this.hasPartialOverlap(event, previousEvent)) {
            var overlapCount = previousEvent.partialOverlapCount || 0;
            event.hasPartialOverlap = true;
            event.partialOverlapCount = overlapCount + 1;
          }
        }
        index += Math.max(1, exactOverlaps.length);
      }

      return events;
    }
  },
  watch: {
    selectedAppointment: function selectedAppointment() {
      if (this.selectedAppointment) {
        this.bottomsheet = true;
        this.selectedEvent = this.selectedAppointment;
      }
    }
  },
  methods: {
    eventClicked: function eventClicked(event) {
      this.globalSelectedAppointments = [];

      this.selectedEvent = event;
      this.$emit('dayview:eventclicked', event);
      this.bottomsheet = false;
      var vm = this;
      setTimeout(function () {
        vm.bottomsheet = true;
      }, 100);
      return false;
    },
    newEvent: function newEvent(period) {
      var dayStartMoment = this.timeStringToMoment(this.startHour + ':00');
      var minsFromStart = period * this.periodInMins;
      var startMoment = dayStartMoment.add(minsFromStart, 'minutes');
      var endMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(startMoment).add(this.defaultNewEventLength, 'minutes');
      var data = {
        start_time: startMoment,
        end_time: endMoment,
        start: startMoment.format('HH:mm'),
        end: endMoment.format('HH:mm')
      };
      this.$emit('dayview:createevent', data);
    },
    timeToPixels: function timeToPixels(fromTimeString, toTimeString) {
      var startMoment = this.timeStringToMoment(fromTimeString);
      var toMoment = this.timeStringToMoment(toTimeString);
      var duration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(toMoment.diff(startMoment));

      var height = duration.asMinutes();
      if (this.pixelToMinuteRatio > 1) {
        height = height * this.pixelToMinuteRatio;
      }

      return height;
    },
    timeOfDay: function timeOfDay(start, period, interval) {
      var startMins = start * 60;
      var timeFromStart = period * interval;
      var totalMins = startMins + timeFromStart;
      if (!(totalMins % 60)) {
        return totalMins / 60;
      }
    },
    getStyle: function getStyle(event) {
      var top = this.timeToPixels('0' + this.startHour + ':00', event.start);
      if (this.pixelToMinuteRatio > 1) {
        top = top - this.periodHeight / this.pixelToMinuteRatio;
      }

      var styles = {
        top: top + 'px',
        height: this.timeToPixels(event.start, event.end) + 'px'
      };
      if (event.partialOverlapCount > 0) {
        var offset = event.partialOverlapCount * this.eventOffset;
        var width = this.maxWidthPercentage - offset;
        styles['left'] = offset + '%';
        styles['width'] = width + '%';
      }
      if (event.exactOverlapCount > 1) {
        var unitPercent = this.maxWidthPercentage / event.exactOverlapCount;
        styles['left'] = event.exactOverlapSequence * unitPercent + '%';
        styles['width'] = unitPercent + '%';
      }

      var target = document.getElementById('event-' + event.id);
      if (target) {
        target.style.transform = 'translate(0px, 0px)';

        target.setAttribute('data-x', 0);
        target.setAttribute('data-y', 0);
      }

      return styles;
    },
    hasPartialOverlap: function hasPartialOverlap(currentEvent, previousEvent) {
      if (currentEvent && previousEvent) {
        var previousEnd = this.timeStringToMoment(previousEvent.end);
        var currentStart = this.timeStringToMoment(currentEvent.start);
        return currentStart.isBefore(previousEnd, 'minute');
      }
      return false;
    },
    getExactOverlaps: function getExactOverlaps(events, event, index) {
      var overlaps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      if (events.length === 0) {
        return [];
      }
      overlaps.push(event);
      if (index < events.length) {
        var nextEvent = events[index + 1];
        if (nextEvent && event) {
          var exactOverlap = event.start === nextEvent.start && event.end === nextEvent.end;
          if (exactOverlap) {
            this.getExactOverlaps(events, nextEvent, index + 1, overlaps);
          } else {
            return overlaps;
          }
        }
      }
      return overlaps;
    }
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_calendar_DayView__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_calendar_DayView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_calendar_DayView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarMixins_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_listitems_PractitionerListItem_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_listitems_PractitionerListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_listitems_PractitionerListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PractitionerDayView',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__CalendarMixins_js__["a" /* default */]],
  components: { DayView: __WEBPACK_IMPORTED_MODULE_1__components_calendar_DayView___default.a, PractitionerListItem: __WEBPACK_IMPORTED_MODULE_3__components_listitems_PractitionerListItem_vue___default.a },
  props: {
    practitioner: { type: Object, required: true },
    settings: { type: Object, required: false, default: function _default() {
        return {};
      } },
    date: { type: String, required: true },
    withTitle: { type: Boolean, default: false },
    withDateBar: { type: Boolean, default: false },
    blockEvents: { type: Boolean, default: false },
    withAdd: { type: Boolean, default: false },
    withFetch: { type: Boolean, default: false },
    withWeek: { type: Boolean, default: false },
    hideCancelled: { type: Boolean, default: true },
    flat: { type: Boolean, default: true },
    touch: { type: Number, default: 0 },
    filterSpaces: { type: Array, default: function _default() {
        return [];
      } },
    filterLocations: { type: Array, default: function _default() {
        return [];
      } },
    selectedAppointment: { type: Object, required: false },
    previewEvent: { type: Object, required: false }
  },
  data: function data() {
    return {
      request: {
        resource: 'ag.practitioner.appointments'
      }
    };
  },
  mounted: function mounted() {
    if (this.withFetch) {
      this.get();
    }
  },

  computed: {
    practitionerId: function practitionerId() {
      return this.getObjectPath(this.practitioner, 'id', null);
    },
    dateFormatted: function dateFormatted() {
      if (this.date) {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.date).format('ddd D MMM YYYY');
      }
      return null;
    },
    week: function week() {
      __WEBPACK_IMPORTED_MODULE_4_moment___default.a.updateLocale('en', { week: { dow: 1 } });
      if (this.withWeek && this.date) {
        var dt = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.date);
        var days = [];
        var wkEnd = __WEBPACK_IMPORTED_MODULE_4_moment___default()(dt.endOf('week'));
        var currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(dt.startOf('week'));
        while (currentDate.isSameOrBefore(wkEnd)) {
          var day = currentDate.format('YYYY-MM-DD');
          days.push(__WEBPACK_IMPORTED_MODULE_4_moment___default()(day));
          currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(currentDate).add(1, 'days');
        }
        return days;
      }
      return null;
    },
    events: function events() {
      var _this = this;

      var evts = this.$store.getters.getCalendarDay(this.practitionerId, this.date).slice();

      return evts.filter(function (evt) {
        if (_this.hideCancelled) {
          if (evt.status === 'C') {
            return false;
          }
        }
        if (_this.filterSpaces && _this.filterSpaces.length > 0) {
          if (_this.filterSpaces.indexOf(evt.space) === -1) {
            return false;
          }
        }
        if (_this.filterLocations && _this.filterLocations.length > 0) {
          if (_this.filterLocations.indexOf(evt.address_id) === -1) {
            return false;
          }
        }
        return true;
      });
    },
    watchString: function watchString() {
      return this.practitionerId + this.date + this.touch;
    },
    isNotMe: function isNotMe() {
      return this.practitionerId !== this.me.id;
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    }
  },
  watch: {
    watchString: function watchString() {
      if (this.withFetch) {
        this.get();
      }
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        var events = this.getObjectPath(this.request, 'result.results', []);
        events = this.formatEvents(events);
        this.$store.commit('addAppointments', events);
      }
    }
  },
  methods: {
    multiselect: function multiselect(appointment) {
      if (this.blockEvents) {
        this.$emit('multiselect', appointment);
      } else {
        this.$store.commit('toggleGloballySelectedAppointment', appointment);
      }
    },
    moveWeek: function moveWeek(numWeeks) {
      var newDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.date).add(numWeeks, 'weeks').format('YYYY-MM-DD');
      this.$emit('update:date', newDate);
    },
    slotSelected: function slotSelected(slot) {
      this.$emit('slotSelected', slot);
      this.$emit('dayview:createevent', slot);
      if (this.blockEvents) {
        return null;
      }

      var vm = this;
      var startTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.date);
      if (slot && slot.start_time) {
        startTime = slot.start_time;
      }
      this.openGlobalDialog(true, 'QuickCreate');
      setTimeout(function () {
        vm.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_constants__["j" /* SET_SETTING */], ['startTime', startTime]);
        vm.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_constants__["j" /* SET_SETTING */], ['activePractitioner', vm.practitioner]);
      }, 500);
    },
    get: function get() {
      if (this.practitionerId) {
        var params = {
          before_utc: this.date,
          after_utc: this.date,
          practitioner: this.practitionerId
        };
        this.request.params = params;
        return this.$request('get', this.request);
      }
    }
  }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_AppointmentBottomSheet__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_AppointmentBottomSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_AppointmentBottomSheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_Detail__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_backgrounds__ = __webpack_require__(213);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScheduleTimeline',
  components: { HomeDetail: __WEBPACK_IMPORTED_MODULE_3__components_home_Detail___default.a, AppointmentListItem: __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem___default.a, AppointmentBottomSheet: __WEBPACK_IMPORTED_MODULE_2__components_appointment_actions_AppointmentBottomSheet___default.a },
  props: {
    schedule: { type: Object, default: function _default() {
        return {};
      } },
    appointment: { type: Object, default: function _default() {
        return {};
      } },
    withAction: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    date: { type: String }
  },
  data: function data() {
    return {
      firstload: true,
      showNavDrawer: false,
      showDatepicker: false,
      showBottomSheet: false,
      activeClient: null,
      localDate: null,
      selectedAppointment: null,
      debouncedDay: null,
      timeout: null,
      dow: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    };
  },
  mounted: function mounted() {
    this.localDate = this.date;
    this.debouncedDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date).day();
  },

  watch: {
    localDate: function localDate() {
      this.$vuetify.goTo(0);
      this.$emit('date', this.localDate);
      this.showDatepicker = false;
    },
    date: function date() {
      if (this.date) {
        this.localDate = this.date;
        this.debouncedDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date).day();
      }
    },
    loading: function loading() {
      if (this.loading === false) {
        this.firstload = false;
      }
    }
  },
  computed: {
    appointments: function appointments() {
      if (this.schedule && this.schedule.schedule) {
        return this.schedule.schedule;
      }
      return [];
    },
    backgroundImg: function backgroundImg() {
      var images = __WEBPACK_IMPORTED_MODULE_4__components_home_backgrounds__["a" /* BACKGROUNDS */][this.timeOfDay];
      var index = Math.floor(Math.random() * images.length);
      return images[index];
    },
    navDrawerIsVisible: function navDrawerIsVisible() {
      if (this.$vuetify.breakpoint.xs) {
        return true;
      }
      return this.showNavDrawer;
    },
    isToday: function isToday() {
      var today = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
      return today === this.date;
    },
    todaysClients: function todaysClients() {
      var clients = [];
      this.appointments.filter(function (appt) {
        if (appt.status === 'B') {
          return false;
        }
        var isNew = clients.indexOf(appt.client) === -1;
        if (isNew) {
          clients.push(appt.client);
        }
        return isNew;
      }, []);
      return clients;
    },
    timeOfDay: function timeOfDay() {
      var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
      var currentHour = now.hour();
      if (currentHour >= 12 && currentHour <= 17) return 'afternoon';else if (currentHour >= 18) return 'evening';else return 'morning';
    },
    greeting: function greeting() {
      var greetings = {
        morning: 'Good morning',
        afternoon: 'Good afternoon',
        evening: 'Good evening'
      };
      return greetings[this.timeOfDay];
    },
    welcomeNote: function welcomeNote() {
      var note = '';
      if (this.appointments && this.appointments.length > 0) {
        var first = this.dateformat(this.appointments[0].start_time, 'HH:mm a');
        var lastAppt = this.appointments[this.appointments.length - 1];
        var last = this.dateformat(lastAppt.end_time, 'HH:mm a');
        if (this.todaysClients.length === 1) {
          note += this.todaysClients.length + ' client ' + this.relativeDate + '. ';
        } else if (this.todaysClients.length === 0) {
          note += 'No clients ' + this.relativeDate + '. ';
        } else {
          note += this.todaysClients.length + ' clients ' + this.relativeDate + '. ';
        }
        if (this.appointments.length === 1) {
          note += 'Your first appointment is at ' + first;
        } else {
          note += 'Your first appointment is at ' + first + ' and your last appointment ends at ' + last;
        }
      }
      return note;
    },
    relativeDate: function relativeDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'on dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'DD/MM/YYYY'
      });
    }
  },
  methods: {
    settoday: function settoday() {
      this.localDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
    },
    dowChanged: function dowChanged() {
      var initialDow = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date).day();
      var diff = this.debouncedDay - initialDow;
      console.log(initialDow, diff, this.localDate);
      this.localDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.localDate).add(diff, 'days').format('YYYY-MM-DD');
    },
    getColor: function getColor(appointment) {
      if (appointment && appointment.id) {
        var status = this.formatStatus(appointment.status);
        if (status && status.theme) {
          return status.theme;
        }
        if (this.appointment && this.appointment.id === appointment.id) {
          return 'pink';
        }
      }
      return 'teal lighten-3';
    },
    getActiveColor: function getActiveColor(appointment) {
      if (this.appointment && this.appointment.id === appointment.id) {
        return 'grey lighten-3 active-timeline-item';
      }
      return '';
    },
    product: function product(appointment) {
      if (appointment && appointment.product) {
        var product = appointment.product;
        if (isNaN(product)) {
          return product;
        } else {
          return this.getProductById(product, true);
        }
      }
      return false;
    },
    newAppointmentClicked: function newAppointmentClicked() {
      var _this = this;

      var vm = this;
      setTimeout(function () {
        var startTime = _this.localDate + ' 08:00';
        vm.$store.commit('SET_SETTING', ['startTime', startTime]);
      }, 1000);
      this.openGlobalDialog(true, 'QuickCreate');
    },
    iconClicked: function iconClicked(appointment) {
      var _this2 = this;

      this.showBottomSheet = false;
      this.selectedAppointment = appointment;
      window.setTimeout(function () {
        _this2.showBottomSheet = true;
      }, 10);
      console.log('icon clicked!!');
    },
    itemClicked: function itemClicked(appointment) {
      if (this.$vuetify.breakpoint.xs) {
        var activeClientId = null;
        if (this.activeClient) {
          activeClientId = this.activeClient.id;
        }
        if (appointment.client !== activeClientId) {
          this.activeClient = this.$store.getters.clients.find(function (client) {
            if (client && client.client && client.client.id && appointment && appointment.client) {
              return client.client.id.toString() === appointment.client.toString();
            }
          });
        }
        this.showNavDrawer = true;
      }
      this.$emit('selected', appointment);
    }
  },
  i18n: {
    messages: {
      en: {
        messages: {
          endofday: 'Home time!'
        }
      }
    }
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_TagList__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_TagList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_appointment_TagList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_RecurringAppointmentForm__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_RecurringAppointmentForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_forms_RecurringAppointmentForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_OnlineMeetingCard__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_OnlineMeetingCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cards_OnlineMeetingCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentCodes_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentCodes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentCodes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cards_ShareCard_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cards_ShareCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_cards_ShareCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_actions_TransferAppointment_Index_vue__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_actions_TransferAppointment_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_actions_TransferAppointment_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentCard',
  components: {
    ClientListItem: __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem___default.a,
    TagList: __WEBPACK_IMPORTED_MODULE_2__components_appointment_TagList___default.a,
    RecurringAppointmentForm: __WEBPACK_IMPORTED_MODULE_3__components_forms_RecurringAppointmentForm___default.a,
    OnlineMeetingCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_OnlineMeetingCard___default.a,
    AppointmentCodes: __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentCodes_vue___default.a,
    TransferAppointment: __WEBPACK_IMPORTED_MODULE_7__components_actions_TransferAppointment_Index_vue___default.a,
    ShareCard: __WEBPACK_IMPORTED_MODULE_6__components_cards_ShareCard_vue___default.a
  },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    flat: { type: Boolean, default: true },
    fetch: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      appointment: {},
      editLocation: false,
      sharedialog: false,
      apptReq: {
        resource: 'ag.appointments'
      },
      getApptReq: {
        resource: 'ag.appointments'
      },
      move: {
        practitioner: null,
        product: { id: null, title: '' }
      },
      changeAppointmentType: false,
      locationIsValid: false,
      urlRules: [function (value) {
        if (!value) {
          return true;
        }
        var pattern = new RegExp('^(https?:\\/\\/)?' + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + '((\\d{1,3}\\.){3}\\d{1,3}))' + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + '(\\?[;&a-z\\d%_.~+=-]*)?' + '(\\#[-a-z\\d_]*)?$', 'i');
        return pattern.test(value) || 'Please enter a valid link';
      }]
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
        }
      }
    },
    apptReqStatus: function apptReqStatus() {
      if (this.apptReqStatus === 200) {
        this.editLocation = false;
      }
    },
    getApptReqStatus: function getApptReqStatus() {
      if (this.getApptReqStatus === 200) {
        this.appointment = this.getApptReq.result;
      }
    },
    appointmentId: function appointmentId() {
      if (this.appointmentId && this.fetch) {
        this.get();
      }
    },
    practitionerId: function practitionerId() {
      if (this.appointment) {
        return this.appointment.practitioner;
      }
      return null;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['products']), {
    apptReqStatus: function apptReqStatus() {
      return this.apptReq.status;
    },
    getApptReqStatus: function getApptReqStatus() {
      return this.getApptReq.status;
    },
    appointmentId: function appointmentId() {
      return this.getObjectPath(this.appointment, 'id');
    },
    practitionerId: function practitionerId() {
      return this.getObjectPath(this.appointment, 'practitioner.id');
    },
    codes: function codes() {
      return this.getObjectPath(this.appointment, 'codes', []);
    },
    sharelink: function sharelink() {
      if (this.appointment && this.appointment.relationships && this.appointment.relationships.length === 1) {
        var rel = this.appointment.relationships[0];
        var path = this.getObjectPath(rel, 'get_absolute_url');
        if (path) {
          return {
            url: 'https://appt.guru/' + path,
            title: 'Appointment Page'
          };
        }
      }
      return null;
    },
    relationship: function relationship() {
      if (this.appointment && this.appointment.client) {
        if (this.appointment.client.id) {
          return this.appointment.client;
        }
        var userId = this.appointment.client;
        if (isNaN(this.appointment.client)) {
          userId = this.appointment.client.id;
        }
        return this.getRelationByClientId(userId);
      }
    },
    fullName: function fullName() {
      if (this.relationship && this.relationship.first_name) {
        return this.relationship.first_name + ' ' + this.relationship.last_name;
      }
      return null;
    },
    productData: function productData() {
      if (this.appointment && this.appointment.product) {
        return this.getProductById(this.appointment.product);
      }
      return null;
    }
  }),
  methods: {
    locationMap: function locationMap(addr) {
      if (addr.latitude && addr.longitude) {
        var latlng = addr.latitude + ',' + addr.longitude;
        var key = 'AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY';
        var url = 'https://maps.googleapis.com/maps/api/staticmap?center=' + latlng + '&zoom=14&size=640x180&scale=2&markers=color:blue%7C' + latlng + '&key=' + key;
        return url;
      }
    },
    getProductById: function getProductById(id) {
      var _this = this;

      return this.products.find(function (prod) {
        console.log(prod.id, id);
        return _this.idsAreEqual(prod.id, id);
      });
    },
    get: function get() {
      if (this.appointmentId) {
        this.getApptReq.resourceId = this.appointmentId;
        this.$request('get', this.getApptReq);
      }
    },
    save: function save(data) {
      if (this.appointmentId) {
        this.apptReq.resourceId = this.appointmentId;
        this.apptReq.data = data;
        this.$request('save', this.apptReq);
      }
    }
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dompurify__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dompurify__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FormSubmissionCard',
  props: {
    submissionId: { required: false },
    value: { type: Object, default: function _default() {} },
    visible: { type: Boolean, default: false },
    withClose: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/submission',
        result: null
      }
    };
  },

  watch: {
    submissionId: {
      immediate: true,
      handler: function handler() {
        if (this.submissionId) {
          this.getSubmission();
        }
      }
    },
    visible: function visible() {
      if (this.visible && this.submissionId) {
        this.getSubmission();
      }
    },

    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.submission = this.value;
        }
      }
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        this.submission = this.request.result.content;
      }
    }
  },
  computed: {
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    submissionLink: function submissionLink() {
      if (this.submission.form_id && this.submission.id) {
        return 'https://jotform.com/inbox/' + this.submission.form_id + '/' + this.submission.id;
      }
      return null;
    }
  },
  methods: {
    getSubmission: function getSubmission() {
      this.request.extra = 'jotform/' + this.submissionId + '/submission';

      this.$request('get', this.request);
    },
    getRawAnswer: function getRawAnswer(index, answer) {
      var key = 'q' + index + '_' + answer.name;

      return this.getObjectPath(this.request, 'result.linked_submission.raw_data.' + key);
    },
    getUploadProxy: function getUploadProxy(url) {
      var base = this.$appointmentguru.baseUrl;
      var u = encodeURI(url);
      return base + '/api/v2/practitioner/integrations/jotform/image/?url=' + u;
    },
    sanitize: function sanitize(txt) {
      return __WEBPACK_IMPORTED_MODULE_0_dompurify__["sanitize"](txt, { USE_PROFILES: { html: true } });
    }
  }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CopyTextField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CopyTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CopyTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_Zoom_ManualOnlineMeetingForm__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_Zoom_ManualOnlineMeetingForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_forms_Zoom_ManualOnlineMeetingForm__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ZoomMeetingCard',
  components: { CopyTextField: __WEBPACK_IMPORTED_MODULE_0__components_ui_CopyTextField___default.a, ManualOnlineMeetingForm: __WEBPACK_IMPORTED_MODULE_1__components_forms_Zoom_ManualOnlineMeetingForm___default.a },
  props: {
    appointment: { type: Object, required: true },
    editmode: { type: Boolean, default: false },
    withedit: { type: Boolean, default: false },
    flat: { type: Boolean, default: true }
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_CopyTextField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_CopyTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_CopyTextField__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShareCard',
  components: { CopyTextField: __WEBPACK_IMPORTED_MODULE_2__components_ui_CopyTextField___default.a },
  props: {
    links: { type: Array, default: function _default() {
        return [];
      } },
    relationshipId: { required: false },
    bgImage: {
      type: String,
      default: 'https://cdn.vuetifyjs.com/images/cards/desert.jpg'
    }
  },
  computed: {
    link: function link() {
      if (this.links && this.links.length > 0) {
        return this.links[0];
      }
    },
    qr: function qr() {
      if (this.link) {
        var base = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=';
        return base + this.link.url;
      }
    },
    relationship: function relationship() {
      if (this.relationshipId) {
        var rel = this.$store.getters.getClientByRelationshipId(this.relationshipId);
        if (rel) {
          return rel;
        }
      }
      return {};
    },
    firstName: function firstName() {
      return this.getObjectPath(this.relationship, 'client.first_name', null);
    },
    lastName: function lastName() {
      return this.getObjectPath(this.relationship, 'client.last_name', null);
    },
    email: function email() {
      var email = this.getObjectPath(this.relationship, 'client.email', null);
      if (this.isRealEmail(email)) {
        return email;
      }
      return null;
    },
    phone: function phone() {
      return this.getObjectPath(this.relationship, 'client.phone_number', null);
    },
    canShare: function canShare() {
      if (navigator.share) {
        return true;
      }
      return false;
    }
  },
  methods: {
    share: function share() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!navigator.share) {
                  _context.next = 9;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return navigator.share(_this.link);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 6]]);
      }))();
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentCodes_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentCodes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentCodes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cards_ShareCard_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cards_ShareCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cards_ShareCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_ActionList_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_ActionList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_ActionList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_backgrounds__ = __webpack_require__(213);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmallAppointmentCard',
  props: {
    value: { type: Object, required: true },
    dark: { type: Boolean, default: false }
  },
  components: {
    AppointmentCodes: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentCodes_vue___default.a,
    ShareCard: __WEBPACK_IMPORTED_MODULE_2__components_cards_ShareCard_vue___default.a,
    ClientListItem: __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem_vue___default.a,
    ActionList: __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_ActionList_vue___default.a
  },
  data: function data() {
    return {};
  },

  methods: {
    share: function share() {
      var options = {
        links: [this.sharelink],
        relationship: this.relationshipId
      };
      this.launchShareDialog(options);
    }
  },
  watch: {},
  computed: {
    appointment: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        console.log('spot the difference', this.value, val);
      }
    },
    backgroundImg: function backgroundImg() {
      if (this.product && this.product.background_picture) {
        return this.product.background_picture;
      }
      return this.backupBackgroundImg;
    },
    timeOfDay: function timeOfDay() {
      var currentHour = new Date().getHours();
      if (currentHour >= 12 && currentHour <= 17) return 'afternoon';else if (currentHour >= 18) return 'evening';else return 'morning';
    },
    backupBackgroundImg: function backupBackgroundImg() {
      var images = __WEBPACK_IMPORTED_MODULE_4__components_home_backgrounds__["a" /* BACKGROUNDS */][this.timeOfDay];
      var index = Math.floor(Math.random() * images.length);
      return images[index];
    },
    appointmentId: function appointmentId() {
      if (this.value) {
        return this.value.id;
      }
      return 0;
    },
    relationshipId: function relationshipId() {
      if (this.appointment && this.appointment.computed_relationship_id) {
        return this.appointment.computed_relationship_id;
      }
      if (this.appointment && this.appointment.relationships && this.appointment.relationships.length === 1) {
        return this.appointment.relationships[0];
      }
      return null;
    },
    relationship: function relationship() {
      if (this.relationshipId) {
        return this.getRelationById(this.relationshipId);
      }
      return null;
    },
    product: function product() {
      if (this.appointment && this.appointment.product) {
        return this.getProductById(this.appointment.product);
      }
      return null;
    },
    sharelink: function sharelink() {
      return {
        url: this.getObjectPath(this.appointment, 'client_detail_url', null),
        title: this.appointment.title
      };
    }
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActiveClientsList',
  components: { HelpPopover: __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover___default.a },
  props: {
    withSearch: { type: Boolean, default: true },
    withClose: { type: Boolean, default: false },
    highlightSelected: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      searchString: '',
      activeIndex: -1,
      selectedClient: {}
    };
  },
  mounted: function mounted() {
    this.getActiveClients();
  },

  watch: {
    globalActiveDateRangeFormatted: function globalActiveDateRangeFormatted() {
      this.getActiveClients();
    },
    activeIndex: function activeIndex() {
      if (this.activeIndex >= 0) {
        this.selectedClient = this.activeClients[this.activeIndex];
      }
    }
  },
  methods: {
    setSelected: function setSelected(relationship, index) {
      this.activeIndex = index;
      this.$emit('selected', relationship, index);
    }
  },
  computed: {
    activeClientsRequest: function activeClientsRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_0__store_constants__["o" /* LIST_ACTIVE_CLIENTS_REQ */], true);
    },
    activeClients: function activeClients() {
      return this.getObjectPath(this.activeClientsRequest, 'result.data.results', []);
    },
    filteredActiveClients: function filteredActiveClients() {
      var _this = this;

      if (this.searchString && this.searchString.length > 0) {
        return this.activeClients.filter(function (item) {
          var indexString = (item.client.id + ' ' + item.client.first_name + ' ' + item.client.last_name + ' ' + item.client.email + ' ' + item.client.phone_number).toLowerCase();
          var searchMatch = indexString.indexOf(_this.searchString.toLowerCase()) > -1;
          if (searchMatch) {
            return item;
          }
        });
      } else {
        return this.activeClients;
      }
    }
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientCard',
  props: {
    relationshipId: { required: true },
    initialData: { type: Object, required: false },
    touch: { type: Number, required: false, default: 0 },
    flat: { type: Boolean, default: false },
    withClientName: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      request: {
        resource: 'ag.spaces.relationships',
        loading: false
      }
    };
  },

  watch: {
    relationshipId: function relationshipId() {
      this.get();
    },
    record: function record() {
      this.$emit('record', this.record);
    },
    relationship: function relationship() {
      this.$emit('relationship', this.relationship);
    }
  },
  mounted: function mounted() {
    this.get();
  },

  computed: {
    relationship: function relationship() {
      if (this.relationshipId) {
        return this.$store.getters.getClientDetailByRelationshipId(this.relationshipId);
      }
      return {};
    },
    client: function client() {
      if (this.relationship) {
        var relationshipListView = this.$store.getters.getClientByRelationshipId(this.relationshipId);
        if (relationshipListView && relationshipListView.client) {
          return relationshipListView.client;
        }
      }
    },
    record: function record() {
      if (this.relationship) {
        return this.relationship.record;
      }
    }
  },
  methods: {
    get: function get() {
      if (this.relationshipId) {
        this.request.resourceId = this.relationshipId;
        this.$request('get', this.request);
      }
    }
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codes_TreatmentLogs__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codes_TreatmentLogs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__codes_TreatmentLogs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__codes_HistoricalUsage__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__codes_HistoricalUsage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__codes_HistoricalUsage__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientCodes',
  components: { HelpPopover: __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover___default.a, HistoricalUsage: __WEBPACK_IMPORTED_MODULE_3__codes_HistoricalUsage___default.a, TreatmentLogs: __WEBPACK_IMPORTED_MODULE_2__codes_TreatmentLogs___default.a },
  props: {
    relationshipId: { type: Number, required: true },
    clientId: { type: Number, required: true },

    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      activeTab: 0,
      'searchString': '',
      'orderByLastUsed': true,
      'codes': [],
      'codeCount': 4,
      'loading': false,
      'requests': {
        record: 'record-get-request',
        get: 'get-treatment-logs',
        change: 'change-treatment-logs'
      },
      touchers: {
        editform: 1
      },
      dialogs: {
        add: false
      }
    };
  },

  computed: {
    orderByText: function orderByText() {
      if (this.orderByLastUsed) {
        return this.$t('lastused');
      }
      return this.$t('firstused');
    },
    orderByValue: function orderByValue() {
      if (this.orderByLastUsed) {
        return 'last_used';
      }
      return 'first_used';
    },
    mostRecentAppointmentDate: function mostRecentAppointmentDate() {
      if (this.sortedHistoricalTreatmentLogs && this.sortedHistoricalTreatmentLogs.length > 0) {
        var dt = this.sortedHistoricalTreatmentLogs[0].last_used;
        return this.luxonDateformat(dt, 'ccc d MMM yyyy');
      }
    },
    oldestAppointmentDate: function oldestAppointmentDate() {
      if (this.sortedHistoricalTreatmentLogs && this.sortedHistoricalTreatmentLogs.length > 0) {
        var codes = this.sortedHistoricalTreatmentLogs;
        var dt = codes[codes.length - 1].last_used;
        return this.luxonDateformat(dt, 'ccc d MMM yyyy');
      }
    },
    recordRequest: function recordRequest() {
      return this.$store.getters.getRequestById(this.requests.record, true);
    },
    treatmentLogsRequest: function treatmentLogsRequest() {
      return this.$store.getters.getRequestById(this.requests.get, true);
    },
    changeLogsRequest: function changeLogsRequest() {
      return this.$store.getters.getRequestById(this.requests.change, true);
    },
    changeLogsRequestStatus: function changeLogsRequestStatus() {
      return this.changeLogsRequest.status;
    },
    record: function record() {
      return this.getObjectPath(this.recordRequest, 'result.data', {});
    },
    historicalTreatmentLogs: function historicalTreatmentLogs() {
      return this.getObjectPath(this.treatmentLogsRequest, 'result.data', []);
    },
    sortedHistoricalTreatmentLogs: function sortedHistoricalTreatmentLogs() {
      if (!this.historicalTreatmentLogs) {
        return [];
      }
      var order = this.orderByValue || 'last_used';
      return this.historicalTreatmentLogs.sort(function (a, b) {
        if (a[order] === b[order]) {
          return 0;
        }
        if (a[order] > b[order]) {
          return -1;
        }
        return 1;
      });
    },
    filteredHistoricalTreatmentLogs: function filteredHistoricalTreatmentLogs() {
      var _this = this;

      var sorted = this.sortedHistoricalTreatmentLogs;
      if (this.searchString && this.searchString.length > 0) {
        return sorted.filter(function (log) {
          if (log.code) {
            return log.code.toLowerCase().indexOf(_this.searchString.toLowerCase()) > -1;
          }
        });
      }
      return sorted;
    },
    currentTreatmentLogs: function currentTreatmentLogs() {
      return this.record.treatmentlogs || [];
    }
  },
  watch: {
    touch: {
      immediate: true,
      handler: function handler() {
        this.getCodes();
      }
    }
  },
  methods: {
    getRecord: function getRecord() {
      var params = {
        practitioner_id: this.me.id,
        customer_id: this.clientId
      };
      this.$medicalaidguru.resource('record').id(this.requests.record).get(this.clientId, params);
    },
    getCodes: function getCodes() {
      var suffix = this.clientId + '/codes';
      this.$appointmentguru.resource('practitioner.clients').id(this.requests.get).get(suffix);
    },
    save: function save(log) {
      log.record = this.record.id;
      this.$medicalaidguru.resource('treatmentlog').id(this.requests.change).create(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(log));
    },
    dodelete: function dodelete(log) {
      this.$medicalaidguru.resource('treatmentlog').id(this.requests.change).delete(log.id);
    },
    isNewDate: function isNewDate(log, index, logs) {
      if (index === 0) {
        return true;
      }
      var last = logs[index - 1];
      return log[this.orderByValue] !== last[this.orderByValue];
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Diagnosis and treatment history',
        nologsfound: 'No treatment logs found',
        timesUsed: 'Never used | Used once | Used {count} times',
        zerocurrentresults: 'No history recorded yet',
        zerosearchresults: 'Your search returned no results',
        lastused: 'last used',
        firstused: 'first used',
        buttons: {
          add: 'Add',
          addwithdescription: 'Add an item'
        },
        tabs: {
          history: 'Client History',
          usage: 'Code usage'
        },
        logs: {
          historical: 'Codes previously used',
          historicalsubtitle: '(sorted by last time used)',
          count: 'Never used|Used once|Used twice|Used {n} times',
          summary: '{n} codes used | {n} code used since {from} | {n} codes used since {from}',
          searchinfo: 'Searching for {string}',
          lastseen: 'Last seen: {date}'
        },
        help: {
          history: 'Treatment logs help you keep track of diagnosis and treatments for a patient over time. You can also use them to speed up your invoicing by automatically adding current treatment codes to new appointments for this patient',
          usage: 'Code usage shows the codes as you have actually used them on appointments over time'
        }
      }
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_Create__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_client_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_Tombstone__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_Tombstone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_app_Tombstone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_WhatsAppBtn_vue__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_WhatsAppBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_WhatsAppBtn_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientContactDetails',
  components: { ClientCreate: __WEBPACK_IMPORTED_MODULE_0__components_client_Create___default.a, Tombstone: __WEBPACK_IMPORTED_MODULE_1__components_app_Tombstone___default.a, WhatsAppBtn: __WEBPACK_IMPORTED_MODULE_2__components_ui_WhatsAppBtn_vue___default.a },
  props: {
    value: { type: Object, default: function _default() {
        return { client: {} };
      } },
    relationshipId: { required: true },
    withEdit: { type: Boolean, default: false },
    editOnly: { type: Boolean, default: false },
    withFetch: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      client: {},
      displayMode: 'view',
      reqId: 'get-relationships-request'
    };
  },
  mounted: function mounted() {
    if (this.editOnly) {
      this.displayMode = 'edit';
    }
  },

  watch: {
    valueId: {
      immediate: true,
      handler: function handler() {
        this.client = {};
        if (this.value) {
          this.client = this.value;
        } else {
          console.error('value changed, but it has no data .. :^/');
        }
      }
    },
    relationshipId: {
      immediate: true,
      handler: function handler() {
        if (this.withFetch && this.relationshipId) {
          this.get();
        }
      }
    },
    getRequestStatus: function getRequestStatus() {
      if (this.getRequestStatus === 200 && this.remoteRelationship && this.remoteRelationship.id) {
        if (this.remoteRelationship.id === this.relationshipId) {
          this.client = this.remoteRelationship;
          this.$emit('relationship', this.remoteRelationship);
        }
      }
    },
    displayMode: function displayMode() {
      this.$emit('mode', this.displayMode);
    }
  },
  computed: {
    valueId: function valueId() {
      if (this.value) {
        return this.value.id;
      }
      return 0;
    },
    getRequest: function getRequest() {
      return this.$store.getters.getRequestById(this.reqId);
    },
    getRequestStatus: function getRequestStatus() {
      return this.getRequest.status;
    },
    remoteRelationship: function remoteRelationship() {
      return this.getObjectPath(this.getRequest, 'result.data', {});
    }
  },
  methods: {
    get: function get() {
      if (this.relationshipId) {
        this.$appointmentguru.resource('practitioner.v3.relationships').id(this.reqId).get(this.relationshipId);
      } else {
        console.error('Could not fetch relationship. Relationship is null');
      }
    },
    clientUpdated: function clientUpdated(clientData) {
      this.client = clientData;

      this.$emit('input', clientData);
      if (this.editOnly === true) {
        this.displayMode = 'edit';
      } else {
        this.displayMode = 'view';
      }
    },
    setMode: function setMode(mode) {
      if (this.withEdit) {
        this.displayMode = mode;
      }
    },
    updateLoading: function updateLoading(loading) {
      this.$emit('update:loading', loading);
    }
  }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PatientInformationForm__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PatientInformationForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PatientInformationForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_detail_ClientAppointments__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_detail_ClientAppointments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_detail_ClientAppointments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientIndex__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_ClientIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NoteList__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NoteList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NoteList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_client_ClientInvoices__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_client_ClientInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_client_ClientInvoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_statement__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_statement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_statement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_client_ClientCodes__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_client_ClientCodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_client_ClientCodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Integrations_Mailchimp_MailchimpChip__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Integrations_Mailchimp_MailchimpChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_Integrations_Mailchimp_MailchimpChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Integrations_Physitrack_PhysitrackEmbed__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Integrations_Physitrack_PhysitrackEmbed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_Integrations_Physitrack_PhysitrackEmbed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pickers_SpacePicker_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pickers_SpacePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pickers_SpacePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ui_SharingInformation_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ui_SharingInformation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ui_SharingInformation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_client_forms_ReportForm_vue__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_client_forms_ReportForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_client_forms_ReportForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { type: Object, default: function _default() {
        return { client: {} };
      } },

    fetch: { type: Boolean, default: false },
    isCompact: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: true }
  },
  components: {
    ClientAppointments: __WEBPACK_IMPORTED_MODULE_1__components_client_detail_ClientAppointments___default.a,
    NoteList: __WEBPACK_IMPORTED_MODULE_3__components_NoteList___default.a,
    PatientInformationForm: __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PatientInformationForm___default.a,
    SharingInformation: __WEBPACK_IMPORTED_MODULE_11__components_ui_SharingInformation_vue___default.a,

    ClientCodes: __WEBPACK_IMPORTED_MODULE_6__components_client_ClientCodes___default.a,

    ClientInvoices: __WEBPACK_IMPORTED_MODULE_4__components_client_ClientInvoices___default.a,
    Statement: __WEBPACK_IMPORTED_MODULE_5__components_statement___default.a,
    SpacePicker: __WEBPACK_IMPORTED_MODULE_9__components_pickers_SpacePicker_vue___default.a,
    MailchimpChip: __WEBPACK_IMPORTED_MODULE_7__components_pages_Integrations_Mailchimp_MailchimpChip___default.a,
    PhysitrackEmbed: __WEBPACK_IMPORTED_MODULE_8__components_pages_Integrations_Physitrack_PhysitrackEmbed___default.a,
    HelpPopover: __WEBPACK_IMPORTED_MODULE_10__components_ui_HelpPopover___default.a,
    ReportForm: __WEBPACK_IMPORTED_MODULE_12__components_client_forms_ReportForm_vue___default.a
  },
  data: function data() {
    return {
      reqId: 'get-appointments-request',
      clientReqId: 'get-client-request',
      activeTab: 0,
      client: {},
      clientContactDetailsComponent: 'client-contact-details',
      clientsReqId: __WEBPACK_IMPORTED_MODULE_13__store_constants__["d" /* LIST_CLIENTS_REQ */],
      touchers: {
        home: 1,
        record: 1,
        notes: 1,
        invoices: 1,
        codes: 1
      },
      showReportDialog: false,
      reportName: null,
      sharingdialog: false,
      appointment: null,
      statementRequestId: 'statement-detail-request',
      selectedAppointments: [],
      statementFilters: {
        from_date: __WEBPACK_IMPORTED_MODULE_14_moment___default()().startOf('month').format('YYYY-MM-DD')
      },
      requests: {
        share: {}
      },
      actionItems: ['appointment_codes', 'show_payment']
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.client = this.value;
        }
      }
    },
    clientId: {
      immediate: true,
      handler: function handler() {
        this.getClient();
        this.getActiveTab();
      }
    },
    shareRequestStatus: function shareRequestStatus() {
      if (this.shareRequestStatus === 200) {
        console.log(this.activeTab);
        this.touchers.home++;
        this.getClient();
      }
    },
    storeClient: function storeClient() {
      if (this.storeClient && this.storeClient.id) {
        this.client = this.storeClient;
      }
    },
    activeTab: function activeTab() {
      this.getActiveTab();
    },
    clientRequestStatus: function clientRequestStatus() {
      if (this.clientRequestStatus === 200) {
        this.client = this.clientRequest.result.data;
        this.$emit('input', this.clientRequest.result.data);
      }
    },

    paramTab: {
      immediate: true,
      handler: function handler() {
        if (this.paramTab) {
          var tab = parseInt(this.paramTab);
          if (isNaN(tab)) {
            this.gotoTabName(this.paramTab);
          } else {
            this.setTab(tab);
          }
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.$vuetify.breakpoint.xsOnly) {
      this.activeTab = null;
    }
    if (this.clientId) {
      this.getActiveTab();
    }
  },

  computed: {
    clientId: function clientId() {
      return this.client.id;
    },
    storeClient: function storeClient() {
      if (this.client) {
        return this.getRelationById(this.client.id);
      }
    },
    paramTab: function paramTab() {
      return this.$route.params.tab;
    },
    relationshipId: function relationshipId() {
      return this.client.id;
    },
    userId: function userId() {
      return this.getObjectPath(this.client, 'client.id');
    },
    clientFullName: function clientFullName() {
      var name = '';
      if (this.client && this.client.client) {
        var cli = this.client.client;
        if (cli.first_name) {
          name = cli.first_name;
        }
        if (cli.last_name) {
          name = name + ' ' + cli.last_name;
        }
      }
      return name;
    },
    accountReport: function accountReport() {
      return this.$appointmentguru.baseUrl + '/' + this.relationshipId + '/reports/';
    },
    clientEmail: function clientEmail() {
      if (this.client && this.client.client) {
        return this.client.client.email;
      }
    },
    clientRequest: function clientRequest() {
      return this.$store.getters.getRequestById(this.clientReqId, true);
    },
    clientRequestStatus: function clientRequestStatus() {
      return this.clientRequest.status;
    },
    clientAppointmentsRequest: function clientAppointmentsRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    clientAppointments: function clientAppointments() {
      return this.getObjectPath(this.clientAppointmentsRequest, 'result.data.results', []);
    },
    me: function me() {
      return this.$store.getters.me;
    },
    statementRequest: function statementRequest() {
      return this.$store.getters.getRequestById(this.statementRequestId, true);
    },
    statement: function statement() {
      return this.getObjectPath(this.statementRequest, 'result.data', {});
    },
    mailchimpIntegration: function mailchimpIntegration() {
      return this.$store.getters.getIntegration('Mailchimp');
    },
    physitrackIntegration: function physitrackIntegration() {
      return this.$store.getters.getIntegration('Physitrack');
    },
    isOwner: function isOwner() {
      return this.client.practitioner === this.me.id;
    },
    ownerId: function ownerId() {
      return this.getObjectPath(this.client, 'practitioner');
    },
    shareRequestStatus: function shareRequestStatus() {
      return this.requests.share.status;
    },
    items: function items() {
      var _this = this;

      var vm = this;
      var relationship = this.client;
      var clientId = null;
      var relationshipId = relationship.id;
      if (relationship.client) {
        clientId = relationship.client.id;
      }
      return [{
        id: 'home',
        title: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_2__components_client_ClientIndex___default.a,
        attrs: {
          relationshipId: relationshipId,
          isCompact: this.isCompact,
          touch: this.touchers.home
        },
        on: function on() {
          vm.touchers.home++;
        }
      }, {
        id: 'Record',
        title: this.$t('tabs.clientinfo.title'),
        component: __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PatientInformationForm___default.a,
        attrs: {
          touch: this.touchers.codes,
          relationshipId: relationshipId,
          fetch: true,
          withContactDetails: true,
          practitionerId: this.me.id
        },
        on: function on() {
          vm.touchers.record++;
        }
      }, {
        id: 'Notes',
        title: this.$t('tabs.notes.title'),
        component: __WEBPACK_IMPORTED_MODULE_3__components_NoteList___default.a,
        attrs: {
          withAdd: true,
          touch: this.touchers.notes,
          emptyText: 'No notes for this client',
          client: relationship,
          relationshipId: relationshipId
        },
        on: function on() {
          vm.touchers.notes++;
        }
      }, {
        id: 'Statement',
        title: this.$t('tabs.statement.title'),
        component: __WEBPACK_IMPORTED_MODULE_5__components_statement___default.a,
        attrs: {
          value: this.statement,
          client: relationship,
          initialFilterText: 'Showing all appointments for this month',
          filterFromDate: this.statementFilters.from_date,
          withSelectable: true,
          withReload: true,
          withPreNext: false,
          withFilters: true,
          isCompact: this.isCompact,
          loading: this.statementRequest.loading
        },
        evnts: {
          dateRangeChangeRequested: this.launchDateRangePicker,
          reload: this.getStatement
        },
        on: function on() {
          vm.getStatement();
        }
      }, {
        id: 'Appointments',
        title: this.$t('tabs.appointments.title'),
        component: __WEBPACK_IMPORTED_MODULE_1__components_client_detail_ClientAppointments___default.a,
        attrs: {
          relationship: relationship,
          appointments: this.clientAppointments,
          loading: this.clientAppointmentsRequest.loading
        },
        evnts: {
          'refresh': function refresh() {
            vm.getAppointments();
          }
        },
        on: function on() {
          vm.getAppointments();
        }
      }, {
        id: 'Invoices',
        title: this.$t('tabs.invoices.title'),
        component: __WEBPACK_IMPORTED_MODULE_4__components_client_ClientInvoices___default.a,
        attrs: {
          touch: this.touchers.invoices,
          clientId: clientId,
          relationshipId: relationshipId
        },
        on: function on() {
          _this.touchers.invoices++;
        }
      }, {
        id: 'Codes',
        title: this.$t('tabs.codes.title'),
        component: __WEBPACK_IMPORTED_MODULE_6__components_client_ClientCodes___default.a,
        attrs: {
          touch: this.touchers.codes,
          relationshipId: relationshipId,
          clientId: clientId
        },
        on: function on() {
          _this.touchers.codes++;
        }
      }];
    }
  },
  methods: {
    reload: function reload() {
      this.getClients();
    },
    getActiveTab: function getActiveTab() {
      if (this.activeTab !== null) {
        var activeComponent = this.items[this.activeTab];
        if (activeComponent) {
          activeComponent.on();
        }
      }
    },
    gotoTabName: function gotoTabName(tabname) {
      var index = this.items.findIndex(function (item) {
        return item.id.toLowerCase() === tabname;
      });
      this.setTab(index);
    },
    setTab: function setTab(index) {
      this.activeTab = index;
    },
    getStatement: function getStatement(filters) {
      if (filters) {
        this.statementFilters = filters;
      }
      this.$appointmentguru.resource('v3.statement').id(this.statementRequestId).get(this.client.client.id, this.statementFilters);
    },
    actionClicked: function actionClicked(action, appointment) {
      appointment.client = this.client;
      action.onclick(appointment);
    },
    showReport: function showReport(reportName) {
      this.showReportDialog = true;
      this.reportName = reportName;
    },
    getClient: function getClient() {
      this.$appointmentguru.resource('practitioner.clients').id(this.clientReqId).get(this.clientId);
    },
    getAppointments: function getAppointments() {
      var params = {
        practitioner: this.$store.getters.me.id,
        client: this.client.client.id,
        ordering: '-start_time'
      };
      this.$appointmentguru.resource('appointments').id(this.reqId).list(params);
    },
    setSharing: function setSharing() {
      var data = { spaces: this.client.spaces.join(',') };
      this.action(this.$appointmentguru, 'practitioner', 'relationships', this.relationshipId, 'set_spaces', data, this.requests.share);
    }
  },
  i18n: {
    messages: {
      en: {
        tabs: {
          statement: {
            title: 'Account'
          },
          appointments: {
            title: 'Appointments'
          },
          clientinfo: {
            title: 'Client info'
          },
          notes: {
            title: 'Notes'
          },
          invoices: {
            title: 'Invoices'
          },
          codes: {
            title: 'Codes'
          }
        }
      }
    }
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientContactDetails__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientContactDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_ClientContactDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_Tombstone__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_Tombstone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_Tombstone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_medicalaid_TreatmentLogListItem__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_medicalaid_TreatmentLogListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_medicalaid_TreatmentLogListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_SharingInformation_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_SharingInformation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ui_SharingInformation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_marked__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_marked__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientIndex',
  props: {
    relationshipId: { type: Number, required: true },
    touch: { type: Number, default: 1 }
  },
  components: {
    ClientContactDetails: __WEBPACK_IMPORTED_MODULE_2__components_client_ClientContactDetails___default.a,
    TreatmentLogListItem: __WEBPACK_IMPORTED_MODULE_4__components_medicalaid_TreatmentLogListItem___default.a,
    SharingInformation: __WEBPACK_IMPORTED_MODULE_6__components_ui_SharingInformation_vue___default.a,
    HelpPopover: __WEBPACK_IMPORTED_MODULE_5__components_ui_HelpPopover___default.a,
    Tombstone: __WEBPACK_IMPORTED_MODULE_3__components_app_Tombstone___default.a
  },
  data: function data() {
    return {
      del: {
        showConfirmation: false,
        reqId: 'delete-client-request',
        permanent: false,
        withAppointments: false
      }
    };
  },

  methods: {
    initPage: function initPage() {
      if (this.relationshipId) {
        this.getRemoteRelationship(this.relationshipId);
      }
    },
    deleteRelationship: function deleteRelationship(id) {
      var params = {};
      if (this.del.withAppointments) {
        params['delete_appointments'] = this.del.withAppointments;
      }
      if (this.del.permanent) {
        params['permanent'] = this.del.permanent;
      }
      this.$appointmentguru.resource('practitioner.clients').id(this.del.reqId).delete(id, params);
    }
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler: function handler() {
        this.initPage();
      }
    },
    touch: function touch() {
      this.initPage();
    },
    deleteRequestStatus: function deleteRequestStatus() {
      if (this.deleteRequestStatus === 204) {
        this.$store.commit('deleteClient', this.relationship);
        var vm = this;
        vm.del.window = 1;
        setTimeout(function () {
          vm.del.showConfirmation = false;
          vm.del.window = 0;
          vm.$emit('close');
          vm.$router.push({ path: '/clients' });
        }, 1000);
      }
    }
  },
  computed: {
    isOwner: function isOwner() {
      if (this.relationship && this.relationship.owner && this.relationship.owner.id) {
        return parseInt(this.relationship.owner.id) === parseInt(this.meId);
      }
      return false;
    },
    ownerId: function ownerId() {
      return this.getObjectPath(this.relationship, 'owner.id');
    },
    record: function record() {
      var record = this.getObjectPath(this.relationship, 'record', {});
      if (record.status && record.status !== 200) {
        return {};
      }
      return record;
    },
    formattedBio: function formattedBio() {
      if (this.record) {
        __WEBPACK_IMPORTED_MODULE_7_marked___default.a.setOptions({ sanitize: true });
        var bio = this.getObjectPath(this.record, 'patient.notes');
        if (bio) {
          return __WEBPACK_IMPORTED_MODULE_7_marked___default()(bio);
        }
      }
      return null;
    },
    deleteRequest: function deleteRequest() {
      return this.$store.getters.getRequestById(this.del.reqId, true);
    },
    deleteRequestStatus: function deleteRequestStatus() {
      return this.deleteRequest.status;
    },
    percentPaid: function percentPaid() {
      var total = parseFloat(this.getObjectPath(this.relationship, 'computed_meta.financials.grand_total', 0));
      var received = parseFloat(this.getObjectPath(this.relationship, 'computed_meta.financials.payments_received', 0));
      if (total === 0) {
        return 100;
      }
      return Math.round(received / total * 100);
    },
    medicalaid: function medicalaid() {
      if (this.record) {
        return this.record.medical_aid;
      }
    },
    birthday: function birthday() {
      return this.getObjectPath(this.record, 'patient.date_of_birth');
    },
    age: function age() {
      if (this.birthday) {
        var today = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local();
        var bday = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(this.birthday);
        return Math.floor(today.diff(bday).as('years'));
      }
      return null;
    },
    request: function request() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_1__store_constants__["s" /* GET_CLIENT_RELATIONSHIP_REQUEST */]);
    },

    relationship: {
      get: function get() {
        return this.getObjectPath(this.request, 'result.data', {});
      },
      set: function set(newVal) {
        this.$store.commit('addClient', newVal);
      }
    },
    currentReferrers: function currentReferrers() {
      if (this.record && this.record.referrers && this.record.referrers.length > 0) {
        var referrers = this.record.referrers;
        var currentReferrers = referrers.filter(function (item) {
          return item.is_current_referrer;
        });
        if (currentReferrers && currentReferrers.length > 0) {
          return currentReferrers;
        }
      }
      return false;
    }
  }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_Statement__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_Statement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_forms_Statement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_lists_StatementList__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_lists_StatementList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_lists_StatementList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_invoice__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_constants__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientInvoices',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_invoice__["a" /* default */]],
  props: {
    relationshipId: { default: null },
    clientId: { default: null },
    touch: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 }
  },
  components: { InvoiceList: __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList___default.a, Statement: __WEBPACK_IMPORTED_MODULE_0__components_forms_Statement___default.a, StatementList: __WEBPACK_IMPORTED_MODULE_2__components_lists_StatementList___default.a },
  data: function data() {
    return {
      activeTab: 0,
      statementToucher: 0,
      statementListToucher: 0,
      resource: 'invoices',
      reqId: 'get-invcoices-client',
      itemsToShow: 10,
      selectedInvoices: [],
      showCreateStatement: false
    };
  },
  mounted: function mounted() {
    this.getInvoices();
    this.itemsToShow = this.pageSize;
  },

  methods: {
    getInvoices: function getInvoices() {
      if (this.clientId && this.me.id) {
        var params = {
          relationship_id: this.relationshipId,
          facets: 'practitioner_id,space_id'
        };
        this.$invoiceguru.resource(this.resource).id(this.reqId).list(params);
      }
    },
    invoiceUrl: function invoiceUrl(invoice) {
      return '/invoices/' + invoice.id;
    },
    gotoInvoice: function gotoInvoice(invoice) {
      this.$router.push({ path: this.invoiceUrl(invoice) });
    },
    setSelected: function setSelected(invoice) {
      var index = this.selectedInvoices.findIndex(function (i) {
        return i.id === invoice.id;
      });
      if (index === -1) {
        this.selectedInvoices.push(invoice);
      } else {
        this.selectedInvoices.splice(index, 1);
      }
    }
  },
  computed: {
    me: function me() {
      return this.$store.getters.me;
    },
    hasMore: function hasMore() {
      return this.invoices.length >= this.itemsToShow;
    },
    watchString: function watchString() {
      return this.globalInvoiceQuickCreate.touch + this.globalCreateInvoice.touch + this.globalAppointmentAction.touch;
    },
    globalInvoiceQuickCreate: function globalInvoiceQuickCreate() {
      return this.$store.getters.getGlobalDialogEvent('InvoiceQuickCreate');
    },
    globalCreateInvoice: function globalCreateInvoice() {
      return this.$store.getters.getGlobalDialogEvent('CreateInvoice');
    },
    globalAppointmentAction: function globalAppointmentAction() {
      return this.$store.getters.getGlobalDialogEvent('AppointmentAction');
    },
    invoicesRequest: function invoicesRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    deleteInvoiceRequest: function deleteInvoiceRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_4__store_constants__["n" /* DELETE_INVOICE_REQ */], true);
    },
    deleteInvoiceRequestStatus: function deleteInvoiceRequestStatus() {
      return this.deleteInvoiceRequest.status;
    },
    invoices: function invoices() {
      return this.getObjectPath(this.invoicesRequest, 'result.data.results', []);
    },
    selectedInvoiceIds: function selectedInvoiceIds() {
      return this.selectedInvoices.map(function (inv) {
        return inv.id;
      });
    },
    pagedInvoices: function pagedInvoices() {
      return this.invoices.slice(0, this.itemsToShow);
    }
  },
  watch: {
    activeTab: function activeTab() {
      if (this.activeTab === 1) {
        this.statementListToucher++;
      }
    },
    clientId: function clientId() {
      this.selectedInvoices = [];
      this.getInvoices();
    },
    showCreateStatement: function showCreateStatement() {
      this.statementToucher++;
    },
    touch: function touch() {
      this.getInvoices();
    },
    deleteInvoiceRequestStatus: function deleteInvoiceRequestStatus() {
      if (this.deleteInvoiceRequestStatus === 204) {
        this.getInvoices();
      }
    },
    watchString: function watchString() {
      this.getInvoices();
    }
  },
  i18n: {
    messages: {
      en: {
        tabs: {
          one: 'Invoices',
          two: 'Statements'
        },
        dialogs: {
          titles: {
            statement: 'Create a statement'
          }
        },
        buttons: {
          createstatement: 'Statement'
        }
      }
    }
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientList',
  components: { ClientListItem: __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem___default.a },
  props: {
    initialText: { type: String },
    showListInitially: { type: Boolean, default: true },
    withClientsInRange: { type: Boolean, default: false },
    withNotInvoicedFilter: { type: Boolean, default: true },
    withCreate: { type: Boolean, default: true },
    withWhatsApp: { type: Boolean, default: false },
    withAction: { type: Boolean, default: false },
    canClearSpace: { type: Boolean, default: true },
    includeOwnedByMe: { type: Boolean, default: true },
    spaceId: { required: false, description: 'Only show clients owned by me, or shared in provided space' },
    clearOnSelect: { type: Boolean, default: true, description: 'Clean the options list when they select a client' },
    touch: { type: Number, default: 10 }
  },
  data: function data() {
    return {
      selected: {},
      searchString: '',
      debouncedSearchString: '',
      timeout: null,
      limit: 10,
      page: 10,
      hideList: false,
      showOnlyNotInvoiced: true,
      pageSize: __WEBPACK_IMPORTED_MODULE_1__store_constants__["O" /* CLIENT_PAGE_SIZE */],
      clientLimit: __WEBPACK_IMPORTED_MODULE_1__store_constants__["P" /* CLIENT_ACTIVE_LIMIT */],
      views: [{ title: 'With appointments' }, { title: 'With invoiceable appointments' }]
    };
  },
  mounted: function mounted() {
    if (this.initialText) {
      this.searchString = this.initialText;
    }
  },

  methods: {
    clientSelected: function clientSelected(client) {
      this.$emit('relationshipselected', client);
      var user = client.client;
      this.$emit('clientselected', user);
      if (this.clearOnSelect && user) {
        this.searchString = user.first_name + ' ' + user.last_name;
      }
      this.selected = client;
      var vm = this;
      setTimeout(function () {
        if (vm.clearOnSelect) {
          vm.hideList = true;
        }
      }, 100);
    },
    newClient: function newClient() {
      this.$emit('componentchanged', 'ClientCreate');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getSpaceById']), {
    prependIcon: function prependIcon() {
      if (this.withCreate === true) {
        return 'person_add';
      }
      return '';
    },
    hintText: function hintText() {
      if (this.searchString && this.filteredClients.length === 0) {
        return 'Press enter to continue search on the server';
      }
      return 'Search on name, email, phone, nickname or custom_id';
    },
    showList: function showList() {
      if (this.hideList === true) {
        return false;
      }
      if (!this.showListInitially) {
        return this.searchString && this.searchString.length > 0;
      }
      return true;
    },
    spaceName: function spaceName() {
      if (this.spaceId) {
        var space = this.getSpaceById(this.spaceId);
        if (space && space.title) {
          return space.title;
        }
      }
    },
    clients: function clients() {
      return this.$store.getters.clients;
    },
    clientsRequest: function clientsRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_1__store_constants__["d" /* LIST_CLIENTS_REQ */], true);
    },
    searchRequest: function searchRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_1__store_constants__["Q" /* SEARCH_CLIENTS_REQ */], true);
    },
    clientsRequestStatus: function clientsRequestStatus() {
      return this.clientsRequest.status;
    },
    filteredClients: function filteredClients() {
      var _this = this;

      var clients = this.clients;
      var meId = this.meId;

      if (this.spaceId) {
        clients = clients.filter(function (rel) {
          if (_this.includeOwnedByMe) {
            var ownedByMe = parseInt(rel.practitioner) === meId;
            if (ownedByMe) {
              return true;
            }
          }
          var spaceId = parseInt(_this.spaceId);
          return rel.spaces.indexOf(spaceId) >= 0;
        });
      }

      var search = this.debouncedSearchString;
      if (search && search.length > 0) {
        clients = clients.filter(function (clientRel) {
          if (clientRel.client) {
            var client = clientRel.client;
            var index = clientRel.id + ' ' + client.id + ' ' + client.first_name + ' ' + client.last_name + ' ' + client.email + ' ' + client.phone_number + ' ' + client.custom_id + ' ' + client.nickname;
            return index.toLowerCase().indexOf(search.toLowerCase()) !== -1;
          }
        });
      }
      return clients.slice(0, this.limit);
    },
    quicklist: function quicklist() {
      var clients = this.$store.getters.clientsInRange.clients;
      var apptLookup = this.$store.getters.clientsInRange.appointmentsByClient;
      if (this.showOnlyNotInvoiced) {
        clients = clients.filter(function (clientId) {
          var appts = apptLookup[clientId];
          var statusCount = appts.filter(function (appt) {
            return ['N', 'C'].indexOf(appt.status) >= 0;
          }).length;
          if (statusCount > 0) {
            return clientId;
          }
        });
      }
      return clients;
    }
  }),
  watch: {
    touch: function touch() {
      this.searchString = '';
    },
    searchString: function searchString() {
      this.hideList = false;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      var vm = this;
      this.timeout = window.setTimeout(function () {
        vm.debouncedSearchString = vm.searchString;
      }, 500);
    },
    initialText: function initialText() {
      if (this.initialText) {
        this.searchString = this.initialText;
      }
    },
    clientsRequestStatus: function clientsRequestStatus() {
      if (this.clientsRequestStatus === 200) {
        this.$store.commit('addManyClients', this.clientsRequest.results);
      }
    }
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_WhatsAppBtn_vue__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_WhatsAppBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_WhatsAppBtn_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientListItem',
  components: { SpaceFaces: __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces___default.a, PractitionerFaces: __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces___default.a, WhatsAppBtn: __WEBPACK_IMPORTED_MODULE_2__components_ui_WhatsAppBtn_vue___default.a },
  props: {
    client: { type: Object, default: function _default() {
        return {};
      } },
    spaces: { type: Array, required: false },
    relationshipId: { type: Number, required: true },
    owner: { required: false },
    withEdit: { type: Boolean, default: false },
    withDetails: { type: Boolean, default: true },
    withAction: { type: Boolean, default: true },
    withDivider: { type: Boolean, default: true },
    withGravatar: { type: Boolean, default: false },
    withWhatsApp: { type: Boolean, default: false },
    showSpaces: { type: Boolean, default: false }
  },
  computed: {
    avatar: function avatar() {
      if (this.client && this.client.profile && this.client.profile_picture) {
        return this.client.profile_picture;
      }
      return this.client.first_name.substr(0, 1);
    },
    fullName: function fullName() {
      return this.formatFullName(this.client);
    }
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_IcdPicker__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_IcdPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_IcdPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pickers_ProcessCodePicker__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pickers_ProcessCodePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pickers_ProcessCodePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_PractitionerPicker_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_PractitionerPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pickers_PractitionerPicker_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientTreatment',
  components: { IcdPicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_IcdPicker___default.a, ProcessCodePicker: __WEBPACK_IMPORTED_MODULE_2__components_pickers_ProcessCodePicker___default.a, PractitionerPicker: __WEBPACK_IMPORTED_MODULE_3__components_pickers_PractitionerPicker_vue___default.a },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    currency: { type: String },
    touch: { type: Number, default: 0 },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      treatmentlog: {},
      processSearchString: '',
      codeSearchString: '',
      initial: {
        icd10: '',
        process: '',
        price: 0,
        notes: '',
        is_current: true,
        automatically_add_to_appointments: false
      },
      dialogs: {
        icd10: false,
        process: false,
        startdate: false,
        stopdate: false
      },
      practitioner: {}
    };
  },
  mounted: function mounted() {
    this.treatmentlog = this.initial;
    if (!this.treatmentlog.start_date) {
      this.treatmentlog.start_date = this.luxonDateformat(null, 'yyyy-MM-dd');
    }
    if (this.me) {
      this.practitioner = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.me));
    }
    if (!this.currency) {
      this.currency = this.defaultCurrency;
    }
  },

  watch: {
    startdate: function startdate() {
      this.dialogs.startdate = false;
    },
    stopdate: function stopdate() {
      this.dialogs.stopdate = false;
    },
    isCurrentDiagnosis: function isCurrentDiagnosis() {
      if (this.isCurrentDiagnosis === false) {
        this.treatmentlog.automatically_add_to_appointments = false;
      }
    },
    touch: function touch() {
      this.treatmentlog = this.initial;
    },

    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.treatmentlog = this.value;
        }
      }
    }
  },
  methods: {
    showICDPicker: function showICDPicker() {
      this.dialogs.icd10 = true;
      this.codeSearchString = this.treatmentlog.icd10;
    },
    setIcdCode: function setIcdCode(code) {
      this.treatmentlog.icd10 = code.name;
      this.dialogs.icd10 = false;
    },
    showProcessPicker: function showProcessPicker() {
      this.dialogs.process = true;
      this.processSearchString = this.treatmentlog.process;
    },
    setProcessCode: function setProcessCode(code) {
      this.treatmentlog.process = code.name;
      if (code.discovery_rate) {
        this.treatmentlog.price = code.discovery_rate;
      }
      if (code.price) {
        this.treatmentlog.price = code.price;
      }
      this.dialogs.process = false;
    }
  },
  computed: {
    startdate: function startdate() {
      return this.treatmentlog.start_date;
    },
    stopdate: function stopdate() {
      return this.treatmentlog.stop_date;
    },
    isCurrentDiagnosis: function isCurrentDiagnosis() {
      return this.treatmentlog.is_current;
    },
    isOwner: function isOwner() {
      var practitionerId = this.getObjectPath(this.treatmentlog, 'practitioner');
      return practitionerId === this.meId;
    },
    logId: function logId() {
      if (this.treatmentlog && this.treatmentlog.id) {
        return this.treatmentlog.id;
      }
      return null;
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Add a treatment log',
        fields: {
          labels: {
            current: 'Is current diagnosis',
            auto: 'Automatically add to new appointmentments',
            started: 'Start date',
            end_date: 'End date'
          },
          hints: {
            current: 'Indicates that this is current diagnosis and treatment for this patient',
            auto: 'When you create new appointments for this client, we will automatically add these codes',
            started: 'The date when you started this treatment plan for this client',
            end_date: 'The date when this path of treatment finishes'
          }
        },
        subtitles: {
          notes: 'Notes',
          dates: 'Treatment dates'
        },
        notices: {
          finishedisdisabled: 'Cannot set finished date for current treatment logs'
        }
      }
    }
  }
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_client_ClientListItem__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_client_ClientListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_client_ClientListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ServerErrors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ServerErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ServerErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PhoneNumberInput__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PhoneNumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PhoneNumberInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_SpacePicker__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_SpacePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pickers_SpacePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ui_HelpPopover_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ui_HelpPopover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ui_HelpPopover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libphonenumber_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(3);













var CREATE_CLIENT_WINDOW = 0;
var CLIENT_SUCCESS_WINDOW = 1;

/* harmony default export */ __webpack_exports__["default"] = ({
  parse: __WEBPACK_IMPORTED_MODULE_8_libphonenumber_js__["c" /* parse */],
  format: __WEBPACK_IMPORTED_MODULE_8_libphonenumber_js__["b" /* format */],
  isValidNumber: __WEBPACK_IMPORTED_MODULE_8_libphonenumber_js__["d" /* isValidNumber */],
  name: 'CreateClient',
  components: {
    ClientListItem: __WEBPACK_IMPORTED_MODULE_3__components_client_ClientListItem___default.a,
    ServerErrors: __WEBPACK_IMPORTED_MODULE_4__components_ServerErrors___default.a,
    PhoneNumberInput: __WEBPACK_IMPORTED_MODULE_5__components_PhoneNumberInput___default.a,
    SpacePicker: __WEBPACK_IMPORTED_MODULE_6__components_pickers_SpacePicker___default.a,

    HelpPopover: __WEBPACK_IMPORTED_MODULE_7__components_ui_HelpPopover_vue___default.a
  },
  props: {
    withHeader: { type: Boolean, default: true },
    withClose: { type: Boolean, default: false },
    withBack: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    backText: { type: String, default: 'Cancel' },
    context: { type: String },
    initialClient: { type: Object, required: false },
    relationshipId: { default: -1 },
    touch: { type: Number, default: 1 },
    title: { type: String, default: 'Create a new client' }
  },
  data: function data() {
    var _this = this;

    var vm = this;
    return {
      rules: __WEBPACK_IMPORTED_MODULE_2__store_constants__["R" /* RULES */],
      reqId: 'create-client-request',
      showMatchingClients: false,
      updateAppointments: true,
      contactSelectedPhone: null,
      contactSelectedEmail: null,
      savedContact: null,
      showContactClient: false,
      isValidPhoneNumber: false,
      showExtra: false,
      valid: false,
      sharing: [],
      client: {
        full_name: '',
        email: '',
        phone_number: '',
        custom_id: '',
        nickname: '',
        id: -1,
        spaces: [],
        context: 'SPACE'
      },
      contactClient: {
        name: {},
        phoneNumbers: [],
        emails: []
      },
      activeWindow: CREATE_CLIENT_WINDOW,
      showSuccess: false,
      actions: [{
        icon: 'arrow_forward',
        title: 'Go to client page',
        onclick: function onclick(client) {
          _this.$emit('close');
          _this.gotoClient(client);
        }
      }, {
        icon: 'info',
        title: 'Add more information',
        subtitle: 'Medical aid details, billing address etc',
        onclick: function onclick(client) {
          vm.launchCustomerDetailsDialog(client.id);
        }
      }, {
        icon: 'alarm_add',
        title: 'Create appointment',
        subtitle: 'Create an appointment for this client',
        onclick: function onclick(client) {
          var options = { relationship: client };
          vm.launchCreateAppointment({ options: options });
        }
      }, {
        icon: 'add',
        title: 'Add another',
        subtitle: 'Add another client',
        onclick: function onclick(client) {
          vm.clear();
          vm.activeWindow = CREATE_CLIENT_WINDOW;
          vm.savedContact = null;
        }
      }, {
        id: 'done',
        icon: 'check',
        title: 'Done',
        subtitle: 'Get back to what you were doing before!',
        onclick: function onclick(client) {
          vm.$emit('close');
        }
      }]
    };
  },
  mounted: function mounted() {
    if (this.initialClient) {
      this.fromClientObject(this.initialClient);
    }
  },

  watch: {
    touch: function touch() {
      this.clear();
      this.activeWindow = CREATE_CLIENT_WINDOW;
    },
    clientEmail: function clientEmail() {
      if (this.client && !this.isRealEmail(this.clientEmail)) {
        this.client.email = '';
      }
    },
    requestLoading: function requestLoading() {
      this.$emit('update:loading', this.requestLoading);
    },
    createRequestStatus: function createRequestStatus() {
      if (this.createRequestStatus === 201) {
        var clientData = this.createRequest.result.data;
        this.$store.commit('addClient', clientData);
        this.$emit('client:created', clientData);
        this.notify('New client created.', 'success');
        this.clear();
        this.savedContact = clientData;
        this.activeWindow = CLIENT_SUCCESS_WINDOW;
      }
      if (this.createRequestStatus === 200) {
        var _clientData = this.createRequest.result.data;
        console.log('req:200', _clientData);
        this.$store.commit('addClient', _clientData);

        this.$emit('client:updated', _clientData);
        this.notify('Client updated.', 'success');
        this.getAppointmentsInRange();
      }
    },
    initialClientId: function initialClientId() {
      console.log('initial', this.initialClientId);
      if (this.initialClient) {
        this.fromClientObject(this.initialClient);
      }
    }
  },
  computed: {
    initialClientId: function initialClientId() {
      if (this.initialClient) {
        return this.initialClient.id;
      }
    },
    hasContacts: function hasContacts() {
      return navigator && navigator.contacts;
    },
    sharedSpaceIds: function sharedSpaceIds() {
      if (this.client && this.client.spaces && this.client.spaces.length > 0) {
        return this.client.spaces.join(',');
      }
      return [];
    },
    btnTxt: function btnTxt() {
      if (this.editMode) {
        return 'Save';
      }
      return 'Create';
    },
    dirty: function dirty() {
      var initialClientData = this.initialClient.email + '.' + this.initialClient.phone_number;
      var clientData = this.client.email + '.' + this.client.phone_number;
      return initialClientData !== clientData;
    },
    requestLoading: function requestLoading() {
      if (this.createRequest) {
        return this.createRequest.loading;
      }
      return false;
    },
    editMode: function editMode() {
      return this.relationshipId !== -1;
    },
    createRequest: function createRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    fullPhoneNumber: function fullPhoneNumber() {
      return '+' + this.client.phone_number;
    },
    parsedPhoneNumber: function parsedPhoneNumber() {
      var n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_libphonenumber_js__["c" /* parse */])(this.fullPhoneNumber);
      return n;
    },
    formattedPhoneNumber: function formattedPhoneNumber() {
      if (this.isValidPhoneNumber === true) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_libphonenumber_js__["b" /* format */])(this.parsedPhoneNumber, 'International_plaintext');
      }
    },
    createRequestStatus: function createRequestStatus() {
      return this.createRequest.status;
    },
    clientEmail: function clientEmail() {
      if (this.client) {
        return this.client.email;
      }
    },
    clientFormatted: function clientFormatted() {
      var data = {};
      data['phone_number'] = this.contactSelectedPhone;
      data['email'] = this.client.email;
      data['full_name'] = this.client.full_name;
      data['nickname'] = this.client.nickname;
      data['custom_id'] = this.client.custom_id;
      data['first_name'] = this.firstName;
      data['last_name'] = this.lastName;
      data['id'] = this.client.id;
      data['spaces'] = this.sharedSpaceIds;
      data['context'] = 'SPACE';
      data['with_blank_user'] = true;
      if (this.updateAppointments) {
        data['update_appointments'] = true;
      }
      return data;
    },
    validContextSharing: function validContextSharing() {
      if (this.client.context === 'SPACE') {
        return this.sharedSpaceIds && this.sharedSpaceIds.length > 0;
      }
      return true;
    },
    clientIsValid: function clientIsValid() {
      return this.validContextSharing && this.clientFormatted.full_name;
    },
    singleErrorMessage: function singleErrorMessage() {
      if (!this.validContextSharing) {
        return 'You must share with at least 1 space';
      }
      if (!this.clientFormatted.full_name) {
        return 'Full name (or at least a first name!) is required';
      }
    },
    hasSomeContactDetails: function hasSomeContactDetails() {
      return this.clientFormatted.email || this.clientFormatted.phone_number;
    },
    firstName: function firstName() {
      if (this.client.full_name) {
        return this.client.full_name.split(' ', 1).pop();
      }
    },
    lastName: function lastName() {
      if (this.client.full_name) {
        return this.client.full_name.split(' ').splice(1).join(' ');
      }
    },
    allClients: function allClients() {
      return this.$store.getters.clients;
    },
    matchingClients: function matchingClients() {
      var vm = this;
      var clients = this.allClients;
      if (clients) {
        return clients.filter(function (client) {
          var item = client.client;
          if (item.phone_number && vm.client.phone_number && vm.client.phone_number.length > 5 && item.phone_number.indexOf(vm.client.phone_number) !== -1) {
            return client;
          }
          if (item.first_name && vm.client.full_name && vm.client.full_name.length > 2 && item.first_name.toLowerCase().indexOf(vm.client.full_name.toLowerCase()) !== -1) {
            return client;
          }
          if (item.last_name && vm.client.full_name && vm.client.full_name.length > 2 && item.last_name.toLowerCase().indexOf(vm.client.full_name.toLowerCase()) !== -1) {
            return client;
          }
          if (item.email && vm.client.email && vm.client.email.length > 3 && item.email.toLowerCase().indexOf(vm.client.email) !== -1) {
            return client;
          }
        });
      }
      return [];
    }
  },
  methods: {
    setClientPhone: function setClientPhone(number) {
      this.client.phone_number = number;
    },
    setValidPhoneNumber: function setValidPhoneNumber(isValid) {
      this.isValidPhoneNumber = isValid;
    },
    setSelectedNumber: function setSelectedNumber(number) {
      this.contactSelectedPhone = '';

      var vm = this;
      setTimeout(function () {
        vm.contactSelectedPhone = number;
      }, 10);
    },
    pickContact: function pickContact() {
      var vm = this;
      vm.clear();
      vm.showContactClient = false;
      vm.contactClient = {
        name: null,
        emails: [],
        phoneNumbers: []
      };
      navigator.contacts.pickContact(function (contact) {
        vm.contactClient.name = contact.name;
        if (contact.name) {
          vm.client.full_name = contact.name.formatted;
        }

        if (contact.phoneNumbers && contact.phoneNumbers.length > 0) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(contact.phoneNumbers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var number = _step.value;

              vm.contactClient.phoneNumbers.push(number.value);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          vm.contactSelectedPhone = vm.contactClient.phoneNumbers[0];
        }
        if (contact.emails && contact.emails.length > 0) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(contact.emails), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var email = _step2.value;

              vm.contactClient.emails.push(email.value);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          vm.client.email = vm.contactClient.emails[0];
        }

        vm.showContactClient = true;
      }, function (err) {
        console.log('Error: ' + err);
      });
    },
    fromClientObject: function fromClientObject(clientObj) {
      if (this.client && clientObj) {
        console.log('fromclientobj', clientObj);
        this.client.full_name = clientObj.first_name + ' ' + clientObj.last_name;
        this.contactSelectedPhone = clientObj.phone_number;
        if (clientObj.phone_number && clientObj.phone_number.startsWith('+')) {
          this.client.phone_number = this.client.phone_number.substr(1);
        }
        this.client.email = clientObj.email;
        this.client.custom_id = clientObj.custom_id;
        this.client.nickname = clientObj.nickname;
        if (clientObj.context) {
          this.client.context = clientObj.context;
        }
        if (this.context) {
          __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(this.client, 'context', this.context);
        }
        if (clientObj.nickname || clientObj.custom_id) {
          this.showExtra = true;
        }
        this.client.spaces = clientObj.spaces;
      }
    },
    clear: function clear() {
      this.client.full_name = '';
      this.contactSelectedPhone = '';
      this.client.email = '';
      this.client.custom_id = '';
      this.client.nickname = '';
      this.client.spaces = [];
    },
    save: function save() {
      if (this.requestLoading) {
        return false;
      }
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.clientFormatted);
      if (this.editMode) {
        this.$appointmentguru.resource('practitioner.clients').id(this.reqId).save(this.relationshipId, data);
      } else {
        this.$appointmentguru.resource('practitioner.clients.new').id(this.reqId).create(data);
      }
    }
  },
  i18n: {
    messages: {
      en: {}
    }
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HistoricalUsage',
  data: function data() {
    return {
      reqId: 'get-code-history',
      searchString: ''
    };
  },

  props: {
    clientId: { required: true },
    relationshipId: { required: true }
  },
  methods: {
    getCodes: function getCodes() {
      var suffix = this.relationshipId + '/codes';
      this.$appointmentguru.resource('practitioner.clients').id(this.reqId).get(suffix);
    },
    isNewDate: function isNewDate(log, index, logs) {
      if (index === 0) {
        return true;
      }
      var last = logs[index - 1];
      return log[this.orderByValue] !== last[this.orderByValue];
    }
  },
  watch: {
    clientId: {
      immediate: true,
      handler: function handler() {
        if (this.relationshipId) {
          this.getCodes();
        }
      }
    }
  },
  computed: {
    orderByText: function orderByText() {
      if (this.orderByLastUsed) {
        return this.$t('lastused');
      }
      return this.$t('firstused');
    },
    orderByValue: function orderByValue() {
      if (this.orderByLastUsed) {
        return 'last_used';
      }
      return 'first_used';
    },
    mostRecentAppointmentDate: function mostRecentAppointmentDate() {
      if (this.sortedHistoricalTreatmentLogs && this.sortedHistoricalTreatmentLogs.length > 0) {
        var dt = this.sortedHistoricalTreatmentLogs[0].last_used;
        return this.luxonDateformat(dt, 'ccc d MMM yyyy');
      }
    },
    oldestAppointmentDate: function oldestAppointmentDate() {
      if (this.sortedHistoricalTreatmentLogs && this.sortedHistoricalTreatmentLogs.length > 0) {
        var codes = this.sortedHistoricalTreatmentLogs;
        var dt = codes[codes.length - 1].last_used;
        return this.luxonDateformat(dt, 'ccc d MMM yyyy');
      }
    },
    treatmentLogsRequest: function treatmentLogsRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    historicalTreatmentLogs: function historicalTreatmentLogs() {
      if (this.treatmentLogsRequest.status <= 200) {
        return this.getObjectPath(this.treatmentLogsRequest, 'result.data', []);
      }
      return [];
    },
    sortedHistoricalTreatmentLogs: function sortedHistoricalTreatmentLogs() {
      if (!this.historicalTreatmentLogs) {
        return [];
      }
      var order = this.orderByValue || 'last_used';
      return this.historicalTreatmentLogs.sort(function (a, b) {
        if (a[order] === b[order]) {
          return 0;
        }
        if (a[order] > b[order]) {
          return -1;
        }
        return 1;
      });
    },
    filteredHistoricalTreatmentLogs: function filteredHistoricalTreatmentLogs() {
      var _this = this;

      var sorted = this.sortedHistoricalTreatmentLogs;
      if (this.searchString && this.searchString.length > 0) {
        return sorted.filter(function (log) {
          if (log.code) {
            return log.code.toLowerCase().indexOf(_this.searchString.toLowerCase()) > -1;
          }
        });
      }
      return sorted;
    }
  },
  i18n: {
    messages: {
      en: {
        timesUsed: 'Never used | Used once | Used {count} times',
        zeroresults: 'No codes found on appointments for this client',
        zerosearchresults: 'Your search returned no results',
        lastused: 'last used',
        firstused: 'first used',
        logs: {
          historical: 'Codes previously used',
          historicalsubtitle: '(sorted by last time used)',
          count: 'Never used|Used once|Used twice|Used {n} times',
          summary: '{n} codes used | {n} code used since {from} | {n} codes used since {from}',
          searchinfo: 'Searching for {string}',
          lastseen: 'Last seen: {date}'
        }
      }
    }
  }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientTreatment_vue__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientTreatment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ClientTreatment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_medicalaid_TreatmentLogListItem_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_medicalaid_TreatmentLogListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_medicalaid_TreatmentLogListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TreatmentLogs',
  components: { ClientTreatment: __WEBPACK_IMPORTED_MODULE_2__ClientTreatment_vue___default.a, TreatmentLogListItem: __WEBPACK_IMPORTED_MODULE_3__components_medicalaid_TreatmentLogListItem_vue___default.a },
  props: {
    relationshipId: { required: true }
  },
  data: function data() {
    return {
      resource: 'practitioner.v2.clients.treatment',
      requests: {
        change: 'change-treatment-log',
        get: 'get-treatment-log'
      },
      touchers: {
        editform: 1
      },
      dialogs: {
        add: false
      },
      selectedLog: {}
    };
  },

  watch: {
    relationshipId: {
      immediate: true,
      handler: function handler() {
        this.get();
      }
    },
    touch: function touch() {
      this.get();
    },
    changeLogsRequestStatus: function changeLogsRequestStatus() {
      if (this.changeLogsRequestStatus === 201 || this.changeLogsRequestStatus === 200) {
        this.get();
        this.touchers.editform++;
        this.dialogs.add = false;
      }
      if (this.changeLogsRequestStatus === 204) {
        this.get();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getPractitionerById']), {
    treatmentLogs: function treatmentLogs() {
      return this.getObjectPath(this.treatmentLogsRequest, 'result.data.results', []);
    },
    treatmentLogsRequest: function treatmentLogsRequest() {
      return this.$store.getters.getRequestById(this.requests.get, true);
    },
    changeLogsRequest: function changeLogsRequest() {
      return this.$store.getters.getRequestById(this.requests.change, true);
    },
    changeLogsRequestStatus: function changeLogsRequestStatus() {
      return this.changeLogsRequest.status;
    }
  }),
  methods: {
    get: function get() {
      var params = {
        'relationship_id': this.relationshipId
      };
      this.$appointmentguru.resource(this.resource).id(this.requests.get).list(params);
    },
    isNewPractitioner: function isNewPractitioner(log, index, treatmentLogs) {
      if (index === 0) {
        return true;
      }
      var lastLog = treatmentLogs[index - 1];
      if (log.practitioner === lastLog.practitioner) {
        return false;
      }
      return true;
    },
    save: function save(log) {
      log.relationship = this.relationshipId;
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(log);
      if (log.id) {
        this.$appointmentguru.resource(this.resource).id(this.requests.change).save(log.id, data);
      } else {
        this.$appointmentguru.resource(this.resource).id(this.requests.change).create(data);
      }
    },
    dodelete: function dodelete(log) {
      this.$appointmentguru.resource(this.resource).id(this.requests.change).delete(log.id);
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Diagnosis and treatment history',
        timesUsed: 'Never used | Used once | Used {count} times',
        buttons: {
          add: 'Add',
          addwithdescription: 'Add an item'
        },
        tabs: {
          usage: 'Code usage'
        },
        zerocurrentresults: 'No treatment logs found',
        logs: {
          title: 'Diagnosis and treatment history',
          current: 'Current diagnosis and treatment',
          historical: 'Codes previously used',
          historicalsubtitle: '(sorted by last time used)',
          count: 'Never used|Used once|Used twice|Used {n} times',
          summary: '{n} codes used | {n} code used since {from} | {n} codes used since {from}',
          searchinfo: 'Searching for {string}',
          lastseen: 'Last seen: {date}'
        },
        help: 'Treatment logs help you keep track of diagnosis and treatments for a patient over time. You can also use them to speed up your invoicing by automatically adding current treatment codes to new appointments for this patient'
      }
    }
  }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pickers_StatusPicker_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pickers_StatusPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pickers_StatusPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_Tombstone__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_Tombstone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_Tombstone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientAppointments',
  components: {
    AppointmentList: __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue___default.a,
    StatusPicker: __WEBPACK_IMPORTED_MODULE_2__components_pickers_StatusPicker_vue___default.a,
    Tombstone: __WEBPACK_IMPORTED_MODULE_3__components_app_Tombstone___default.a
  },
  props: {
    appointments: { type: Array, default: function _default() {
        return [];
      } },

    relationship: { type: Object, required: false }
  },
  data: function data() {
    return {
      selected: [],
      selectedPractitioners: [],
      statuses: [],
      params: {},
      initted: false,
      fetchTrigger: 0,
      activeTab: 0,
      loading: false,
      pageSize: 5,
      request: {}
    };
  },

  watch: {
    relationshipId: {
      immediate: true,
      handler: function handler() {
        this.updateParams();
      }
    },
    watchString: function watchString() {
      this.fetchTrigger++;
    }
  },
  methods: {
    updateParams: function updateParams() {
      if (this.activeTab === 0) {
        this.setPreviousParams();
      }
      if (this.activeTab === 1) {
        this.setUpcomingParams();
      }
    },
    setRequest: function setRequest(req) {
      this.request = req;
    },
    setSelectedPractitioner: function setSelectedPractitioner(pId) {
      var selectedIndex = this.selectedPractitioners.indexOf(pId);
      if (selectedIndex > -1) {
        this.selectedPractitioners.splice(selectedIndex, 1);
      } else {
        this.selectedPractitioners.push(pId);
      }
      if (this.selectedPractitioners && this.selectedPractitioners.length > 0) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.params, 'practitioner_id-in', this.selectedPractitioners.join(','));
      } else {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].delete(this.params, 'practitioner_id-in');
        this.fetchTrigger++;
      }
    },
    isSelectedPractitioner: function isSelectedPractitioner(pId) {
      var selectedIndex = this.selectedPractitioners.indexOf(pId);
      if (selectedIndex > -1) {
        return true;
      }
      return false;
    },
    setPreviousParams: function setPreviousParams() {
      var p = {
        relationships: this.relationshipId,
        before_utc: this.todaysDate,
        ordering: '-start_time',
        page_size: this.pageSize
      };
      if (this.statuses && this.statuses.length > 0) {
        p['status-in'] = this.statuses.join(',');
      }
      this.params = p;
    },
    setUpcomingParams: function setUpcomingParams() {
      this.params = {
        relationships: this.relationshipId,
        after_utc: this.todaysDate,
        ordering: 'start_time',
        page_size: this.pageSize
      };
    }
  },
  computed: {
    relationshipId: function relationshipId() {
      if (this.relationship && this.relationship.id) {
        return this.relationship.id;
      }
      return null;
    },
    todaysDate: function todaysDate() {
      return this.dateformat(null, 'YYYY-MM-DD');
    },
    facetCount: function facetCount() {
      return this.getObjectPath(this.request, 'result.facets', { stastus: {}, practitioner: {} });
    },
    title: function title() {
      if (this.activeTab === 0) {
        return 'Appointments before today (' + this.todaysDate + ') - most recent first';
      }
      if (this.activeTab === 1) {
        return 'Appointments after today (' + this.todaysDate + ') - newest first';
      }
    },
    practitioners: function practitioners() {
      var _this = this;

      var facets = this.getObjectPath(this.facetCount, 'practitioner', {});
      var ids = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(facets);
      var ps = [];
      ids.forEach(function (pId) {
        var cnt = facets[pId];
        var p = _this.$store.getters.getPractitionerById(pId);
        if (p) {
          var img = _this.getProfilePicture(p);
          var item = {
            id: pId,
            count: cnt,
            full_name: p.full_name,
            img: img
          };
          ps.push(item);
        }
      });
      return ps;
    },
    watchString: function watchString() {
      return this.globalPaymentTouch.touch + this.globalAppointmentQuickCreate.touch + this.globalInvoiceQuickCreate.touch;
    },
    globalPaymentTouch: function globalPaymentTouch() {
      return this.$store.getters.getGlobalDialogEvent('Payment');
    },
    globalAppointmentQuickCreate: function globalAppointmentQuickCreate() {
      return this.$store.getters.getGlobalDialogEvent('AppointmentQuickCreate');
    },
    globalInvoiceQuickCreate: function globalInvoiceQuickCreate() {
      return this.$store.getters.getGlobalDialogEvent('InvoiceQuickCreate');
    }
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportForm',
  props: {
    reportName: { type: String },
    relationshipId: { required: true }
  },
  data: function data() {
    return {
      title: null,
      fromDate: null,
      toDate: null,
      withDates: true,
      withTitle: false
    };
  },

  watch: {
    reportName: {
      immediate: true,
      handler: function handler() {
        if (this.reportName === 'account') {
          this.withTitle = true;
          this.title = 'Account summary';
        } else {
          this.withTitle = false;
        }
      }
    }
  },
  computed: {
    reportUrl: function reportUrl() {
      var path = '/reports/' + this.reportName + '/' + this.relationshipId + '/';
      var url = this.$appointmentguru.baseUrl + path;
      var params = [];
      if (this.fromDate && this.toDate) {
        params.push('start=' + this.fromDate + '-01');
        params.push('end=' + this.toDate + '-25');
      }
      if (this.title) {
        params.push('report_title=' + this.title);
      }
      if (params.length > 0) {
        var str = params.join('&');
        url = url + '?' + str;
      }
      return url;
    }
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_FormList_vue__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_FormList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_lists_FormList_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShareForm',
  components: { FormList: __WEBPACK_IMPORTED_MODULE_0__components_lists_FormList_vue___default.a },
  props: {
    relationshipId: { required: true }
  },
  data: function data() {
    return {
      showShare: false,
      menu: false,
      selectedForm: null,
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/forms',
        params: { is_linked: 'true' },
        result: []
      }
    };
  },

  watch: {
    menu: function menu() {
      if (this.menu === true) {
        this.get();
      }
    }
  },
  computed: {
    forms: function forms() {
      return this.request.result;
    },
    links: function links() {
      var links = [];
      if (this.selectedForm) {
        var linkedForm = this.selectedForm.linked_form;
        if (linkedForm) {
          links.push({
            title: linkedForm.title,
            text: linkedForm.description,

            url: this.selectedForm.url + '?relationship_id=' + this.relationshipId
          });
        }
      }
      return links;
    }
  },
  methods: {
    get: function get() {
      return this.$request('get', this.request);
    },
    setSelectedForm: function setSelectedForm(form) {
      this.selectedForm = form;
      var options = { links: this.links };
      this.launchShareDialog(options);
    }
  }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunicationWatcher__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunicationWatcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunicationWatcher__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BatchIdList',
  components: { CommunicationWatcher: __WEBPACK_IMPORTED_MODULE_0__CommunicationWatcher___default.a },
  props: {
    batchId: { required: true },
    touch: { type: Number, default: 0 },
    waitForSendTimeout: { type: Number, defaut: 10000 }
  },
  computed: {
    messages: function messages() {
      return this.$store.getters.getCommsByBatchId(this.batchId);
    }
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommunicationWatcher',
  props: {
    messageId: { required: true }
  },
  computed: {
    comm: function comm() {
      return this.$store.getters.getCommunication(this.messageId);
    },
    isFailure: function isFailure() {
      return this.status.toLowerCase() === 'failed';
    },
    status: function status() {
      if (this.comm) {
        if (this.comm.communicationstatus && this.comm.communicationstatus.length > 0) {
          var stat = this.comm.communicationstatus[this.comm.communicationstatus.length - 1];
          if (stat) {
            return stat.status;
          }
        }
        return 'sent';
      }
    }
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_RelationshipPicker__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_RelationshipPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_RelationshipPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pickers_StatusPicker__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pickers_StatusPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pickers_StatusPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_DateRangePicker__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_DateRangePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pickers_DateRangePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_constants__ = __webpack_require__(2);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentFilter',
  components: {
    RelationshipPicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_RelationshipPicker___default.a,
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_3__components_pickers_DateRangePicker___default.a,
    StatusPicker: __WEBPACK_IMPORTED_MODULE_2__components_pickers_StatusPicker___default.a
  },
  props: {
    title: { type: String, default: 'Filters' },
    facets: { type: Object },
    numResults: { type: Number },
    pageSize: { type: Number, default: 20 },
    touch: { type: Number, default: 0 },
    practitionerId: { type: Number },
    relationship: { type: Object },
    initialRelationship: { type: Object },
    relationshipStatuses: { type: Array, default: function _default() {
        return [];
      } },
    multipleRelationships: { type: Boolean, default: true },
    attrs: { type: Object, default: function _default() {} },
    withIcon: { type: Boolean, default: true },
    requireDaterange: { type: Boolean, default: false },
    clearDateRange: { type: Boolean, default: false },
    mini: { type: Boolean, default: false },
    withClose: { type: Boolean, default: false },
    withThemeToggle: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      datepickervisible: false,
      selectedView: null,
      selectedPractitioners: [],
      selectedRelationships: [],
      selectedSpaces: [],
      selectedStatuses: [],
      selectedPageSize: 20,
      pageSizes: [5, 10, 20, 30, 40, 50],

      disableDate: false,
      hasCodes: null,
      statuses: __WEBPACK_IMPORTED_MODULE_6__store_constants__["m" /* STATUSES */],
      dark: false
    };
  },
  mounted: function mounted() {
    this.selectedPageSize = this.pageSize;
    this.reset();
  },

  watch: {
    filters: {
      deep: true,
      handler: function handler() {
        this.$emit('input', this.filters);
      }
    },
    selectedRelationships: function selectedRelationships() {
      if (!this.multipleRelationships) {
        this.$emit('update:relationship', this.selectedRelationships);
      }
    },
    touch: function touch() {
      this.reset();
    },
    pageSize: function pageSize() {
      if (this.pageSize) {
        this.selectedPageSize = this.pageSize;
      }
    },
    selectedPageSize: function selectedPageSize() {
      if (this.selectedPageSize) {
        this.$emit('update:pageSize', parseInt(this.selectedPageSize));
      }
    }
  },
  methods: {
    getPractitionerLabel: function getPractitionerLabel(practitioner, facet) {
      var count = '0';
      var pk = practitioner.id;
      if (facet && pk in facet) {
        count = facet[pk];
      }
      if (practitioner && practitioner.id) {
        return practitioner.full_name + ' (' + count + ')';
      }
      return 'Not set (' + count + ')';
    },
    getSpaceLabel: function getSpaceLabel(space, facet) {
      var count = '0';
      var pk = space.id;
      if (facet && pk in facet) {
        count = facet[pk];
      }
      if (space && space.title) {
        return space.title + ' (' + count + ')';
      }
      return 'Not set (' + count + ')';
    },
    getStatusLabel: function getStatusLabel(code, data, facet) {
      var title = data.title;
      var count = '0';
      if (facet && code in facet) {
        count = facet[code];
      }
      return title + ' (' + count + ')';
    },
    setCount: function setCount(cnt) {
      this.$emit('count', cnt);
    },
    reset: function reset() {
      if (this.clearDateRange === true) {
        this.disableDate = true;
      }
      var today = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local();
      if (!this.dateRange.from) {
        if (this.activeDateRange && this.activeDateRange.from) {
          this.dateRange.from = this.activeDateRange.from;
        } else {
          this.dateRange.from = today.startOf('month').toISODate();
        }
      }
      if (!this.dateRange.to) {
        if (this.activeDateRange && this.activeDateRange.to) {
          this.dateRange.to = this.activeDateRange.to;
        } else {
          this.dateRange.to = today.endOf('month').toISODate();
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getPractitionerById', 'getSpaceById', 'getColleagues', 'spaces', 'activeDateRange']), {
    relationshipId: function relationshipId() {
      if (this.relationship && this.relationship.id) {
        return this.relationship.id;
      }
      return null;
    },

    dateRange: {
      get: function get() {
        return this.activeDateRange;
      },
      set: function set(val) {
        if (val.to && val.from) {
          this.$store.commit('SET_ACTIVE_DATE_RANGE', [val.from, val.to]);
        }
      }
    },
    filters: function filters() {
      var data = {};
      if (this.selectedView) {
        data = this.selectedView.params;
      }
      if (this.disableDate !== true) {
        if (this.dateRange.from) {
          data['after_utc'] = this.dateRange.from;
        }
        if (this.dateRange.to) {
          data['before_utc'] = this.dateRange.to;
        }
      }
      if (this.selectedPractitioners && this.selectedPractitioners.length > 0) {
        data['practitioner_id-in'] = this.selectedPractitioners.join(',');
      }
      if (this.selectedStatuses && this.selectedStatuses.length > 0) {
        data.statuses = this.selectedStatuses;
      }
      if (this.selectedSpaces && this.selectedSpaces.length > 0) {
        data['space_id-in'] = this.selectedSpaces.join(',');
      }
      if (this.selectedRelationships && this.selectedRelationships.length > 0) {
        var relIds = this.selectedRelationships.map(function (rel) {
          return rel.id;
        }).join(',');
        data['relationships-in'] = relIds;
      }
      if (this.practitionerId) {
        data['practitioner_id'] = this.practitionerId;
      }
      if (this.relationshipId) {
        data['relationships'] = this.relationshipId;
      }
      if (this.hasCodes !== null) {
        data['has-codes'] = this.hasCodes;
      }
      if (this.selectedPageSize) {
        data['page_size'] = this.selectedPageSize;
      }

      this.$emit('input', data);
      return data;
    },
    views: function views() {
      return [{
        title: 'Invoiceable',
        subtitle: 'Appointments which have not yet been invoiced',
        params: {
          statuses: ['N', 'C']
        }
      }, {
        title: 'Invoiced but not paid',
        subtitle: 'Appointments which have been invoiced, but not yet been paid',
        params: {}
      }, {
        title: 'Marked ready for invoicing',
        subtitle: 'Appointment which have explicitly been marked as ready to invoice',
        params: {}
      }, {
        title: 'Not marked ready for invoicing',
        subtitle: 'vice versa',
        params: {}
      }, {
        title: 'Needs coding',
        subtitle: 'Appointments which do not have ICD-10 codes',
        params: {}
      }, {
        title: 'Cancelled appointments',
        subtitle: 'Appointments which have been cancelled'
      }];
    }
  })
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mustache__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_SpacePicker__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_SpacePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pickers_SpacePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mergetags__ = __webpack_require__(545);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommunicationTemplateForm',
  props: {
    value: { type: Object },
    contextType: { type: String, required: true },
    withBack: { type: Boolean, default: true }
  },
  components: { HelpPopover: __WEBPACK_IMPORTED_MODULE_5__components_ui_HelpPopover___default.a, SpacePicker: __WEBPACK_IMPORTED_MODULE_6__components_pickers_SpacePicker___default.a },
  data: function data() {
    return {
      reqId: 'save-communication-template',
      activeTab: 0,
      spaceToucher: 1,
      isDirty: false,
      showSettings: false,
      selectedMergeTag: null,
      merge_tags: __WEBPACK_IMPORTED_MODULE_8__mergetags__["a" /* MERGE_TAGS */],
      mergeTagsMoreInfo: false,
      settings: {
        customPractitionerId: null
      },
      transports: ['sms', 'email'],
      lastFocussed: 'short-message-textarea',
      textfieldLookup: {
        'short-message-textarea': 'short_message',
        'email-subject': 'subject',
        'email-content': 'message'
      },

      exampleObjects: {
        'Appointment': {
          title: 'Jane Soap',
          currency: 'ZAR',
          price: '100.00',
          starttime_formatted: {
            zoned_date_formatted: 'Fri 20 Sep 2019',
            zoned_time_formatted: '11:30 am'
          }
        }
      },
      exampleContext: {
        sender: {
          first_name: 'Jane',
          last_name: 'Soap',
          full_name: 'Jane Soap',
          email: 'jane@spap.com',
          phone_number: '+278312345678'
        },
        recipient: {
          first_name: 'Joe',
          last_name: 'Soap',
          full_name: 'Joe Soap',
          email: 'joe@spap.com',
          phone_number: '+278312345678'
        }
      },
      template: {
        allow_ad_hoc_sending: false,
        is_active: true,
        subject: '',
        short_message: '',
        message: ''
      }
    };
  },

  watch: {
    payloadString: function payloadString() {
      this.isDirty = true;
      this.spaceToucher++;
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus > 0) {
        if (this.requestStatus < 300) {
          this.isDirty = false;
        }
      }
    },
    value: function value() {
      if (this.value) {
        this.template = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.value));
      } else {
        if (this.template && this.template.id) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.template, 'name', '');
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.template, 'description', '');
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.template, 'subject', '');
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.template, 'short_message', '');
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.template, 'message', '');
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.template, 'allow_ad_hoc_sending', false);
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.template, 'is_active', true);
        }
      }
    }
  },
  computed: {
    parsedMessage: function parsedMessage() {
      return this.parse(this.template.message, true);
    },
    parsedShortMessage: function parsedShortMessage() {
      return this.parse(this.template.short_message, false);
    },
    parsedSubject: function parsedSubject() {
      return this.parse(this.template.subject, false);
    },
    isEditMode: function isEditMode() {
      return 'id' in this.template;
    },
    isAdmin: function isAdmin() {
      return this.me.is_admin;
    },
    errors: function errors() {
      return [];
    },
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId);
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    payloadString: function payloadString() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.payload);
    },
    payload: function payload() {
      var payload = {
        is_active: true,
        owner: this.template.owner,
        allow_ad_hoc_sending: this.template.allow_ad_hoc_sending,
        name: this.template.name,
        description: this.template.description,

        slug: this.template.slug,
        preferred_transport: this.template.preferred_transport,
        spaces: this.template.spaces,
        subject: this.template.subject,
        short_message: this.template.short_message,
        message: this.template.message,
        shared: this.template.shared
      };
      if (!this.isAdmin) {
        payload['owner'] = this.me.id;
      }
      return payload;
    }
  },
  methods: {
    insertVariable: function insertVariable(item) {
      if (!this.lastFocussed) {
        window.alert('Not sure which textfield you want to put this variable in. It is possible you browser doesn\'t support this feature');
      }
      var el = document.getElementById(this.lastFocussed);
      var insertable = '{{' + item.key + '}}';
      el.setRangeText(insertable);
      var key = this.textfieldLookup[this.lastFocussed];
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.template, key, el.value);
    },
    setLastFocussed: function setLastFocussed(field) {
      this.lastFocussed = field;
      if (!field) {
        if (this.activeTab === 0) {
          this.lastFocussed = 'short-message-textarea';
        }
        if (this.activeTab === 1) {
          this.lastFocussed = 'email-content';
        }
      }
    },
    parse: function parse(message) {
      var withMarkdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (withMarkdown) {
        message = __WEBPACK_IMPORTED_MODULE_3_marked___default()(message, { sanitize: true });
      }
      try {
        var context = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.exampleContext, this.exampleObjects[this.contextType]);
        return __WEBPACK_IMPORTED_MODULE_4_mustache___default.a.render(message, context);
      } catch (err) {
        this.errorMessage = 'There is an error in your template';
        return 'Error. Unable to parse template';
      }
    },
    sendExample: function sendExample() {
      var url = this.$communicationguru.baseUrl + '/templates/' + this.template.id + '/send_example/';
      var headers = this.$communicationguru.headers;
      console.log(headers);
      var options = { url: url, headers: headers, method: 'post' };
      __WEBPACK_IMPORTED_MODULE_7_axios___default()(options).then(function (res) {
        window.alert('Test message sent.');
      }).catch(function (res) {
        window.alert('Error sending message');
      });
    },
    save: function save() {
      var req = this.$communicationguru.resource('template').id(this.reqId);
      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.payload);
      if (this.template.id) {
        req.save(this.template.id, data);
      } else {
        req.create(data);
      }
    }
  },
  i18n: {
    messages: {
      en: {
        titles: {
          preview: {
            main: 'Preview',
            email: 'Example email',
            shortmessage: 'Example short message'
          },
          preferences: 'Preferences',
          variables: 'Merge tags'
        },
        tabs: {
          short: 'Short messages',
          long: 'Email'
        },
        forms: {
          email: {
            subject: 'Message subject',
            content: 'Message content'
          },
          shortmessage: {
            label: 'Text for short messages',
            hint: 'The text that will be used for SMSes and in-app notifications'
          }
        },
        info: {
          merge_tags_title: 'What is a merge tag?',
          merge_tags: 'Merge tags let you insert content into your messages from objects like appointments and invoices.',
          merge_tags_example: 'For example, you might use a merge tag to provide the start time of an appointment in your message.'
        }
      }
    }
  }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DeleteRecurringAppointment',

  props: {
    value: { type: Object, required: true }
  },
  data: function data() {
    return {
      successfullyDeleted: false,
      appointment: {},
      futureOnly: true,
      loading: false,
      deleteResult: {}
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
        }
      }
    }
  },
  methods: {
    performDelete: function performDelete() {
      var _this = this;

      this.loading = true;
      var params = { future_only: this.futureOnly };
      this.performAction(this.$appointmentguru, 'practitioner', 'appointments', this.appointment.id, 'delete_recurring', params).then(function (res) {
        _this.loading = false;
        _this.deleteResult = res.data;
        _this.successfullyDeleted = true;
      }).catch(function () {
        window.alert('An error occurred when trying to delete appointments');
        _this.loading = false;
      });
    }
  },
  computed: {
    deleteHintText: function deleteHintText() {
      if (this.futureOnly) {
        return 'Will delete this appointment and any appointments that start after it in the series';
      } else {
        return 'Will delete all appointments in the series';
      }
    }
  },
  i18n: {
    messages: {
      en: {},
      es: {}
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);





var URL = 'https://ms-2e5226d4aade-156.saas.meili.dev';
var KEY = 'e4772fdf7f9010f072cb98c391348e53d7b81ebf';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ICDInput',
  props: {
    value: { type: String },
    hint: { type: String, required: false },
    label: { type: String, required: false },
    persistentHint: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      icd10: '',
      search: '',
      timeout: null,
      timeoutInterval: 500,
      results: [],
      selected: [],
      resultsToShow: 20,
      searchsheet: false
    };
  },
  mounted: function mounted() {
    this.icd10 = this.value;
  },

  watch: {
    icd10: function icd10() {
      this.$emit('input', this.icd10);
    },
    search: function search() {
      this.debounceSearch();
    },
    searchsheet: function searchsheet() {
      if (this.searchsheet === true) {
        setTimeout(function () {
          document.getElementById('icd-10-search').focus();
        }, 500);
      }
    }
  },
  computed: {
    selectedFormatted: function selectedFormatted() {
      if (this.selected && this.selected.length > 0) {
        return this.selected.join(' / ');
      }
    },
    headers: function headers() {
      return {
        'Content-Type': 'application/json;charset=utf-8',

        'X-MEILI-API-KEY': KEY
      };
    },
    query: function query() {
      return {
        q: this.search,
        matches: true,
        limit: this.resultsToShow,
        attributesToHighlight: ['name', 'description']
      };
    },
    searchSummary: function searchSummary() {
      var res = this.results;
      if (res && res.hits) {
        return 'Showing ' + res.hits.length + ' of ' + res.nbHits + ' results for \'' + this.search + '\' in ' + res.processingTimeMs + ' ms.';
      }
      return null;
    }
  },
  methods: {
    showSearch: function showSearch() {
      if (this.icd10) {
        this.search = this.icd10;
      }
      this.searchsheet = true;
      this.debounceSearch();
    },
    setSelected: function setSelected(res) {
      if (res) {
        var index = this.selected.indexOf(res.name);
        if (index === -1) {
          this.selected.push(res.name);
        } else {
          this.selected.splice(index, 1);
        }
      }
    },
    debounceSearch: function debounceSearch() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(this.doSearch, this.timeoutInterval);
    },
    doSearch: function doSearch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var options, url, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.timeout = null;
                options = {
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.query),
                  method: 'post',
                  headers: _this.headers
                };
                url = URL + '/indexes/codes/search';
                _context.next = 5;
                return fetch(url, options);

              case 5:
                res = _context.sent;
                _context.next = 8;
                return res.json();

              case 8:
                _this.results = _context.sent;

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    completeSearch: function completeSearch() {
      this.icd10 = this.selectedFormatted;
      this.searchsheet = false;
      this.selected = [];
      this.search = '';
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_DeleteRecurringAppointmentForm__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_DeleteRecurringAppointmentForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_forms_DeleteRecurringAppointmentForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_RescheduleRecurringAppointmentForm__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_RescheduleRecurringAppointmentForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_forms_RescheduleRecurringAppointmentForm__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecurringAppointmentForm',
  components: {
    DeleteRecurringAppointmentForm: __WEBPACK_IMPORTED_MODULE_0__components_forms_DeleteRecurringAppointmentForm___default.a,
    RescheduleRecurringAppointmentForm: __WEBPACK_IMPORTED_MODULE_1__components_forms_RescheduleRecurringAppointmentForm___default.a
  },
  props: {
    value: { type: Object, required: true },
    flat: { type: Boolean, default: true },
    dark: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      appointment: {},
      futureOnly: true,
      showDeleteDialog: false,
      showRescheduleDialog: false
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
        }
      }
    }
  },
  methods: {
    performDelete: function performDelete() {}
  },
  computed: {
    deleteHintText: function deleteHintText() {
      if (this.futureOnly) {
        return 'Will only delete this appointment and the appointments that start after this appointment in the series';
      } else {
        return 'Will delete all appointments in the series';
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'This appointment is part of a recurring sequence of appointments',
        buttons: {
          delete: 'Delete series ..',
          reschedule: 'Reschedule series ..'
        }
      },
      es: {}
    }
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RescheduleRecurringAppointmentForm',
  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default.a },
  props: {
    value: { type: Object, required: true }
  },
  data: function data() {
    return {
      success: false,
      appointment: {},
      futureOnly: true,
      loading: false,
      days: 0,
      hours: 0,
      minutes: 0,
      result: {}
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
        }
      }
    },
    hours: function hours() {
      if (Math.abs(this.hours) > 24) {
        if (this.hours > 0) {
          this.hours = 24;
        } else {
          this.hours = -24;
        }
      }
    },
    minutes: function minutes() {
      if (Math.abs(this.minutes) > 60) {
        if (this.minutes > 0) {
          this.minutes = 60;
        } else {
          this.minutes = -60;
        }
      }
    }
  },
  computed: {
    rescheduleHintText: function rescheduleHintText() {
      if (this.futureOnly) {
        return 'Will reschedule this appointment and any appointments that start after it in the series';
      } else {
        return 'Will reschedule all appointments in the series';
      }
    }
  },
  methods: {
    performReschedule: function performReschedule() {
      var _this = this;

      this.loading = true;
      var params = {
        days: this.days,
        hours: this.hours,
        minutes: this.minutes,
        future_only: this.futureOnly
      };
      this.performAction(this.$appointmentguru, 'practitioner', 'appointments', this.appointment.id, 'reschedule_recurring', params).then(function (res) {
        _this.loading = false;
        _this.result = res.data;
        _this.success = true;
        _this.$emit('rescheduled', res.data);
      }).catch(function () {
        window.alert('An error occurred when trying to reschedule appointments');
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceStatementForm',
  props: {
    relationshipId: { required: true },
    invoices: { type: Array, required: true }
  },
  data: function data() {
    return {
      showNotes: false,
      notes: null,
      openingBalance: 0,
      date: null,
      date_modal: false,
      due_date: null,
      due_date_modal: false,
      createReqId: 'create-invoice-request',
      requests: {
        create: {
          service: 'invoiceguru',
          path: '/statements/',
          method: 'post',
          status: 0,
          params: {},
          data: {},
          response: {}
        }
      }
    };
  },

  computed: {
    currency: function currency() {
      return this.$store.getters.settings.currency;
    },
    invoiceTotal: function invoiceTotal() {
      return this.invoices.reduce(function (total, currentValue, currentIndex, arr) {
        var item = arr[currentIndex];
        total += parseFloat(item.invoice_amount);
        return total;
      }, 0);
    },
    noInvoices: function noInvoices() {
      return !this.invoices || this.invoices.length === 0;
    },
    paymentsTotal: function paymentsTotal() {
      return this.invoices.reduce(function (total, currentValue, currentIndex, arr) {
        var item = arr[currentIndex];
        total += parseFloat(item.amount_paid);
        return total;
      }, 0);
    },
    grandTotal: function grandTotal() {
      var opening = parseFloat(this.openingBalance);
      if (isNaN(opening)) {
        opening = 0;
      }
      return this.invoiceTotal - this.paymentsTotal + opening;
    },
    groupedStatements: function groupedStatements() {
      var res = {};
      this.invoices.forEach(function (invoice) {
        var relationshipId = invoice.relationship_id;
        if (!(relationshipId in res)) {
          res[relationshipId] = [];
        }
        res[relationshipId].push(invoice);
      });
      return res;
    },
    invoiceIds: function invoiceIds() {
      return this.invoices.map(function (invoice) {
        return invoice.id;
      });
    },
    payload: function payload() {
      return {
        relationship_id: this.relationshipId,
        invoices: this.invoiceIds.join(','),
        notes: this.notes,
        opening_balance: this.openingBalance,
        date: this.date,
        due_date: this.due_date
      };
    },
    statementRequest: function statementRequest() {
      return this.$store.getters.getRequestById(this.createReqId, true);
    },
    statementRequestStatus: function statementRequestStatus() {
      return this.statementRequest.status;
    },
    createdStatement: function createdStatement() {
      return this.getObjectPath(this.statementRequest, 'result.data');
    }
  },
  watch: {
    statementRequestStatus: function statementRequestStatus() {
      if (this.statementRequestStatus === 201) {
        this.$emit('success', this.createdStatement);
      }
    },
    invoices: function invoices() {
      this.date = null;
      this.due_date = null;
    },
    date: function date() {
      this.date_modal = false;
    },
    due_date: function due_date() {
      this.due_date_modal = false;
    }
  },
  methods: {
    create: function create() {
      this.requests.create.data = this.payload;
      this.$invoiceguru.resource('statements').id(this.createReqId).create(this.requests.create.data);
    }
  },
  i18n: {
    messages: {
      en: {
        inputs: {
          opening: {
            label: 'Opening balance',
            hint: 'This is the opening balance for the statement, and will be added to the total cost of the invoices included.'
          }
        },
        subtitles: {
          invoices: 'Invoices included in this statement',
          payments: 'Paid',
          invoiced: 'Invoiced',
          due: 'Due',
          opening: 'Opening balance',
          total: 'Closing balance',
          notes: 'Notes'
        },
        buttons: {
          create: 'Create Statement',
          preview: 'Preview',
          note: 'Add a note'
        }
      }
    }
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_unibox_SendTemplate__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_unibox_SendTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_unibox_SendTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_communications_BatchIdList__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_communications_BatchIdList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_communications_BatchIdList__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SendStatement',
  components: { SendTemplate: __WEBPACK_IMPORTED_MODULE_0__components_unibox_SendTemplate___default.a, BatchIdList: __WEBPACK_IMPORTED_MODULE_1__components_communications_BatchIdList___default.a },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      step: 0,
      statement: {},
      sendStatementTo: [],
      toucher: null,
      sender: null,
      batchId: 123,
      sending: false,
      errorMessage: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.statement = this.value;
        }
        this.reset();
      }
    },
    touch: function touch() {
      this.toucher++;
      this.reset();
    }
  },
  computed: {
    me: function me() {
      return this.$store.getters.me;
    },
    canSend: function canSend() {
      return this.sendStatementTo && this.sendStatementTo.length > 0;
    },
    statementClients: function statementClients() {
      if (this.statement && this.statement.relationship_id) {
        var relationship = this.getRelationById(this.statement.relationship_id);
        if (relationship) {
          return [relationship];
        }
      }
      return [];
    }
  },
  methods: {
    reset: function reset() {
      this.step = 0;
    },
    send: function send() {
      var _this = this;

      var params = {
        'sender': this.sender,
        'template': 'STATEMENT',
        'recipients': this.sendStatementTo
      };
      this.sending = true;
      this.errorMessage = false;
      this.$invoiceguru.performAction('statements', 'send', this.statement.id, params).then(function (response) {
        _this.batchId = response.data.batch_id;
        _this.sending = false;
        _this.step = 1;
      }).catch(function (err) {
        console.err(err);
        _this.errorMessage = 'An unexpected error occurred trying to send this statement. If this problem persists, please contact support@appointmentguru.co';
        _this.sending = false;
      });
    },
    setSender: function setSender(sender) {
      this.sender = sender;
    },
    setRecipients: function setRecipients(recipients) {
      this.sendStatementTo = recipients;
    }
  }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatementSuccess',
  props: {
    statement: { type: Object, default: function _default() {
        return {};
      } }
  },
  i18n: {
    messages: {
      en: {
        title: 'Statement created',
        subtitles: {
          nextsteps: 'Next steps'
        },
        buttons: {
          send: 'Send',
          view: 'View',
          done: 'Done'
        }
      }
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateStatementForm__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateStatementForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CreateStatementForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Success__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SendStatement__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SendStatement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SendStatement__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateStatementWizard',
  components: {
    CreateStatementForm: __WEBPACK_IMPORTED_MODULE_0__CreateStatementForm___default.a,
    StatementSuccess: __WEBPACK_IMPORTED_MODULE_1__Success___default.a,
    SendStatement: __WEBPACK_IMPORTED_MODULE_2__SendStatement___default.a
  },
  props: {
    relationshipId: { required: false },
    invoices: { type: Array, required: true },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      step: 0,
      newstatement: null,
      touchSender: 0
    };
  },
  mounted: function mounted() {
    if (!this.invoices) {
      this.invoices = [];
    }
  },

  watch: {
    invoices: function invoices() {
      this.step = 0;
    },
    touch: function touch() {
      this.step = 0;
    },
    step: function step() {
      this.touchSender++;
    }
  },
  methods: {
    statementCreated: function statementCreated(statement) {
      this.step = 1;
      this.newstatement = statement;
    }
  },
  computed: {
    selectedStatmentClients: function selectedStatmentClients() {
      if (this.newstatement && this.newstatement.relationship_id) {
        var relationship = this.getRelationById(this.newstatement.relationship_id);
        if (relationship) {
          return [relationship];
        }
      }
      return [];
    }
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_OnlineMeetingCard__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_OnlineMeetingCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_cards_OnlineMeetingCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(544);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* default */]],
  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem___default.a, OnlineMeetingCard: __WEBPACK_IMPORTED_MODULE_0__components_cards_OnlineMeetingCard___default.a },
  name: 'MakeAppointmentOnline',
  props: {
    appointment: { type: Object, required: true }
  },
  data: function data() {
    return {
      loading: false,
      zoommeeting: null,
      isEnabled: true,
      activeTab: 0
    };
  },

  watch: {
    appointment: {
      immediate: true,
      handler: function handler() {
        if (this.appointment) {
          this.zoommeeting = null;
        }
      }
    }
  },
  methods: {
    makeOnline: function makeOnline() {
      var _this = this;

      var appointments = this.appointment.id.toString();
      var data = {
        appointments: appointments,
        practitioner_id: this.me.id
      };
      this.loading = true;
      this.performAction(this.$appointmentguru, 'practitioner', 'appointments', false, 'bulk_make_online', data).then(function (result) {
        _this.loading = false;
        if (result && result.data && result.data.results && result.data.results.length === 1) {
          _this.zoommeeting = result.data.results[0];
          _this.appointment.zoom_join_url = _this.zoommeeting.zoom_join_url;
          _this.appointment.zoom_meeting_password = _this.zoommeeting.zoom_meeting_password;
          _this.appointment.is_online = true;
        }
      }).catch(function (result) {
        _this.loading = false;
      });
    }
  },
  computed: {
    onlineRequest: function onlineRequest() {},
    integrationIsConnected: function integrationIsConnected() {
      return this.integration && this.integration.is_connected;
    }
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ServerErrors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ServerErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ServerErrors__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ManualOnlineMeetingForm',
  components: { ServerErrors: __WEBPACK_IMPORTED_MODULE_1__components_ServerErrors___default.a },
  props: {
    value: { type: Object, required: true }
  },
  data: function data() {
    return {
      appointment: {
        id: null,
        meeting_url: '',
        zoom_meeting_password: ''
      },
      actionRequest: {
        status: 0,
        result: {}
      }
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.appointment = this.value;
        }
      }
    }
  },
  computed: {
    practitionerId: function practitionerId() {
      if (this.appointment) {
        return this.getObjectPath(this.appointment, 'practitioner.id', this.appointment.practitioner);
      }
    },
    payload: function payload() {
      return {
        appointments: this.appointment.id.toString(),
        practitioner_id: this.practitionerId,
        manually_set: true,
        meeting_url: this.appointment.zoom_join_url,
        meeting_password: this.appointment.zoom_meeting_password
      };
    }
  },
  methods: {
    save: function save() {
      this.action(this.$appointmentguru, 'practitioner', 'appointments', null, 'bulk_make_online', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.payload), this.actionRequest);
    }
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marked__);








var URL = 'https://ms-fcc589b57cf6-156.saas-nyc.meili.dev';
var KEY = 'f63f5d0cfa4a742401f88a450eaa01e5f054554cf9324a2e7453cb91cc5d0bcc';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContextualHelp',

  props: {
    context: { type: String },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      step: 0,
      search: null,
      results: [],
      articleWindows: [],
      fecthedArticle: null,
      pageNumber: 1,
      size: 5,
      timeout: null,
      selectedArticle: null,
      selectedVideo: false
    };
  },
  mounted: function mounted() {
    this.doSearch();
  },

  computed: {
    headers: function headers() {
      return {
        'Content-Type': 'application/json;charset=utf-8',

        'X-MEILI-API-KEY': KEY
      };
    },
    query: function query() {
      return {
        q: this.search,
        matches: true,
        attributesToHighlight: ['title', 'summary', 'content']
      };
    },
    pageCount: function pageCount() {
      if (this.results.hits != null) {
        return Math.ceil(this.results.hits.length / this.size);
      } else {
        return 0;
      }
    },
    paginatedData: function paginatedData() {
      if (this.results.hits) {
        return this.results.hits.slice(this.pageNumber * this.size - this.size, this.pageNumber * this.size - this.size + this.size);
      }
    },
    selectedSummary: function selectedSummary() {
      __WEBPACK_IMPORTED_MODULE_4_marked___default.a.setOptions({ sanitize: true });
      var content = this.getObjectPath(this.selectedArticle, 'summary', '');
      if (content) {
        return __WEBPACK_IMPORTED_MODULE_4_marked___default()(content);
      }
      return content;
    },
    selectedContent: function selectedContent() {
      __WEBPACK_IMPORTED_MODULE_4_marked___default.a.setOptions({ sanitize: true });
      var content = this.getObjectPath(this.selectedArticle, 'content', '');
      if (content) {
        return __WEBPACK_IMPORTED_MODULE_4_marked___default()(content);
      }
      return content;
    },
    selectedEmbed: function selectedEmbed() {
      return this.getObjectPath(this.selectedArticle, 'video_embed_url', null);
    }
  },
  watch: {
    search: function search() {
      this.step = 0;
    }
  },
  methods: {
    debounceExpensiveMethod: function debounceExpensiveMethod() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(this.doSearch, 1000);
    },
    doSearch: function doSearch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var options, url, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = {
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.query),
                  method: 'post',
                  headers: _this.headers
                };
                url = URL + '/indexes/articles/search';
                _context.next = 4;
                return fetch(url, options);

              case 4:
                res = _context.sent;
                _context.next = 7;
                return res.json();

              case 7:
                _this.results = _context.sent;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showDetails: function showDetails(result) {
      this.$set(result, 'detailsVisibility', !result.detailsVisibility);
    },
    articleRequest: function articleRequest(articleUrl) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var options, url, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = {
                  method: 'get'
                };
                url = articleUrl;
                _context2.next = 4;
                return fetch(url, options);

              case 4:
                res = _context2.sent;
                _context2.next = 7;
                return res.json();

              case 7:
                _this2.results = _context2.sent;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchArticle: function fetchArticle(result) {
      console.log('Fetching Article ' + result.id);
      this.$set(result, 'articleVisibility', !result.articleVisibility);
      this.articleRequest('https://help.appointmentguru.co/' + result._formatted.slug);
    },
    setSelectedArticle: function setSelectedArticle(result) {
      this.selectedArticle = result;
      this.step++;
    },
    nextPage: function nextPage(page) {
      this.pageNumber = page;
    },
    extractString: function extractString(obj) {
      var seen = [];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj, function (key, val) {
        if (val != null && (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(val)) === 'object') {
          if (seen.indexOf(val) >= 0) {
            return;
          }
          seen.push(val);
        }
        return val;
      });
    },
    formatSummary: function formatSummary(text) {
      __WEBPACK_IMPORTED_MODULE_4_marked___default.a.setOptions({ sanitize: true });
      return __WEBPACK_IMPORTED_MODULE_4_marked___default()(text);
    }
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionMenu__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cards_AppointmentCard__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cards_AppointmentCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cards_AppointmentCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_client_ClientDetails__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_client_ClientDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_client_ClientDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_Welcome__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_home_Welcome__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeDetail',
  components: { ClientDetails: __WEBPACK_IMPORTED_MODULE_3__components_client_ClientDetails___default.a,
    AppointmentListItem: __WEBPACK_IMPORTED_MODULE_1__components_appointment_AppointmentListItem___default.a,
    AppointmentCard: __WEBPACK_IMPORTED_MODULE_2__components_cards_AppointmentCard___default.a,
    AppointmentActionMenu: __WEBPACK_IMPORTED_MODULE_0__components_appointment_actions_ActionMenu___default.a,
    Welcome: __WEBPACK_IMPORTED_MODULE_4__components_home_Welcome___default.a
  },
  props: {
    appointment: { type: Object, required: false },
    homepage: { type: Object, required: true },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return { activeTab: 0 };
  },

  computed: {
    client: function client() {
      var vm = this;
      return this.$store.getters.clients.find(function (client) {
        var clientId = vm.getObjectPath(client, 'client.id');
        if (clientId && vm.appointment.client) {
          return clientId.toString() === vm.appointment.client.toString();
        }
      });
    }
  },
  methods: {
    bubble: function bubble(data) {
      this.$emit('chart:appointments:clicked', data);
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Welcome',
  components: { ApexChart: __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default.a },
  props: {
    value: { type: Object },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      mainchartId: 'count',
      chartType: 'bar',
      STATUSES: __WEBPACK_IMPORTED_MODULE_4__store_constants__["m" /* STATUSES */],
      setupProgress: 40,
      configureTodos: [{
        id: 'profession',
        title: 'Enter a profession',
        subtitle: 'Important information for people making appointments with you',
        status: 'todo' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['settings']), {
    dateRangeFormatted: function dateRangeFormatted() {
      if (this.value) {
        var range = this.getObjectPath(this.value, 'charts.range', {});
        return range.from + ' - ' + range.to;
      }
      return '';
    },
    appointmentCount: function appointmentCount() {
      return this.countChart.reduce(function (total, item, index) {
        return total + item.y;
      }, 0);
    },
    appointmentValue: function appointmentValue() {
      return this.valueChart.reduce(function (total, item, index) {
        return total + item.y;
      }, 0);
    },
    mainChart: function mainChart() {
      if (this.mainchartId === 'value') {
        return {
          name: 'Appointment value',
          data: this.valueChart
        };
      } else {
        return {
          name: 'Appointments',
          data: this.countChart
        };
      }
    },
    valueChart: function valueChart() {
      if (this.value) {
        return this.getObjectPath(this.value, 'charts.appointments.value', []);
      }
      return [];
    },
    countChart: function countChart() {
      if (this.value) {
        return this.getObjectPath(this.value, 'charts.appointments.count', []);
      }
      return [];
    },
    breakdownChart: function breakdownChart() {
      if (this.value) {
        return this.getObjectPath(this.value, 'charts.status_breakdown.count', {});
      }
      return {};
    },
    options: function options() {
      var _this = this;

      return {
        chart: {
          id: 'homepage-welcome',
          toolbar: { show: false },
          events: {
            click: function click(event, chartContext, config) {
              var dataIndex = config.dataPointIndex;
              var point = _this.series[0].data[dataIndex];
              _this.$emit('chart:appointments:clicked', point);
            }
          }
        },
        yaxis: {
          labels: { show: false }
        },
        xaxis: {
          labels: { show: false },
          type: 'datetime'
        },
        annotations: {
          xaxis: [{ x: new Date().getTime() }]
        }
      };
    },
    series: function series() {
      return [this.mainChart];
    },
    breakdownSeries: function breakdownSeries() {
      var values = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.breakdownChart);
      if (values.length > 0) {
        var ordered = values.sort(function (a, b) {
          return b - a;
        });
        var max = ordered[0];
        var multiplier = 100 / max;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.breakdownChart).map(function (item) {
          return Math.round(item * multiplier);
        });
      }
      return [];
    },
    breakdownLabels: function breakdownLabels() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.breakdownChart);
    },
    breakdownColors: function breakdownColors() {
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.breakdownChart);
      return keys.map(function (key) {
        if (key in __WEBPACK_IMPORTED_MODULE_4__store_constants__["m" /* STATUSES */]) {
          return __WEBPACK_IMPORTED_MODULE_4__store_constants__["m" /* STATUSES */][key].bright;
        }
        return '#1ab7ea';
      });
    },
    statusBreakdown: function statusBreakdown() {
      var vm = this;
      return {
        series: this.breakdownSeries,
        chartOptions: {
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: 0,
              endAngle: 270,
              hollow: {
                margin: 5,
                size: '30%',
                background: 'transparent',
                image: undefined
              },
              dataLabels: {
                name: {
                  fontSize: '16px'
                },
                value: {
                  fontSize: '12px',
                  offsetY: 0
                },
                total: {
                  show: true,
                  label: 'Total',
                  formatter: function formatter(w) {
                    return vm.appointmentCount;
                  }
                }
              }
            }
          },
          colors: this.breakdownColors,
          labels: this.breakdownLabels,
          legend: {
            show: true,
            floating: true,
            fontSize: '10px',
            position: 'left',
            offsetX: 10,
            offsetY: 0,
            labels: {
              useSeriesColors: true
            },
            markers: {
              size: 0
            },
            formatter: function formatter(seriesName, opts) {
              if (seriesName in __WEBPACK_IMPORTED_MODULE_4__store_constants__["m" /* STATUSES */]) {
                var value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(vm.breakdownChart)[opts.seriesIndex];
                return __WEBPACK_IMPORTED_MODULE_4__store_constants__["m" /* STATUSES */][seriesName].title + ': ' + value;
              }
              return seriesName;
            },
            itemMargin: {
              horizontal: 1
            }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                show: false
              }
            }
          }]
        }
      };
    }
  }),
  i18n: {
    messages: {
      en: {
        mainchart: {
          titles: {
            value: 'Appointment value',
            count: 'Number of appointments'
          }
        },
        metrics: {
          titles: {
            count: 'Appointments',
            value: 'Value'
          },
          subtitles: {
            value: 'Total price of appointments'
          }
        }
      }
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_CommunicationListItem__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_CommunicationListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_listitems_CommunicationListItem__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceCommunications',
  components: { CommunicationListItem: __WEBPACK_IMPORTED_MODULE_0__components_listitems_CommunicationListItem___default.a },
  props: {
    invoiceId: { required: true },
    touch: { type: Number, default: 0 },
    reqId: { type: String, default: 'communication-invoice-id' }
  },
  watch: {
    invoiceId: {
      immediate: true,
      handler: function handler() {
        this.fetch();
      }
    },
    touch: function touch() {
      this.fetch();
    }
  },
  computed: {
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    communications: function communications() {
      return this.getObjectPath(this.request, 'result.data.results', []);
    }
  },
  methods: {
    fetch: function fetch() {
      var params = {
        objects_invoice: this.invoiceId
      };
      this.$communicationguru.resource('communication').id(this.reqId).list(params);
    }
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_DatePickerDialog__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_DatePickerDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_DatePickerDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceDetail',
  components: { DatePickerDialog: __WEBPACK_IMPORTED_MODULE_0__components_pickers_DatePickerDialog___default.a },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      api: this.$invoiceguru,
      resource: 'invoices',
      enriching: false,
      invoice: {},
      dirty: false,
      enrichReqId: 'enrich-invoice-request'
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.invoice = this.value;
    }
  },

  watch: {
    value: function value() {
      if (this.value) {
        this.invoice = this.value;
      }
    },
    invoice: function invoice() {
      this.dirty = true;
      this.$emit('input', this.invoice);
    }
  },
  computed: {
    spaceSettings: function spaceSettings() {
      if (this.spaceId) {
        return __WEBPACK_IMPORTED_MODULE_1__store_constants_js__["a" /* LINKS */].SETTINGS + '#/settings/spaces/' + this.spaceId;
      }
    },
    invoiceId: function invoiceId() {
      if (this.invoice) {
        return this.invoice.id;
      }
    },
    spaceId: function spaceId() {
      return this.getObjectPath(this.invoice, 'space_id');
    },
    practitioner: function practitioner() {
      if (this.invoice) {
        return this.getObjectPath(this.invoice, 'practitioner_data', {});
      }
      return {};
    },
    appointmentIds: function appointmentIds() {
      return this.invoice.appointments.join(',');
    }
  },
  methods: {
    deleteInvoice: function deleteInvoice(id) {
      this.api.resource(this.resource).delete(id);
    },
    enrich: function enrich(appointmentIds) {
      if (appointmentIds) {
        this.invoice.appointments = appointmentIds;
      }
      var vm = this;
      var base = this.$invoiceguru.baseUrl;
      var headers = this.$invoiceguru.headers;
      var url = base + '/invoices/' + this.invoice.id + '/enrich/';
      var params = {
        'appointments': this.appointmentIds
      };
      vm.enriching = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, params, { headers: headers }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(vm.invoice, response.data);
        vm.$emit('input', response.data);
        vm.$emit('refresh');
        vm.enriching = false;
      }).catch(function () {
        vm.enriching = false;
      });

      this.$store.dispatch('HIDE_SPACE', 'globalDialog');
    }
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceFilter',
  props: {
    title: { type: String, default: 'filter results' },
    facets: { type: Object, default: function _default() {
        return {};
      } },
    params: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      selectedPractitioners: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getPractitionerById', 'getSpaceById']), {
    practitionerIds: function practitionerIds() {
      if (this.facets && this.facets.practitioner_id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.facets.practitioner_id);
      }
      return [];
    },
    computedParams: function computedParams() {
      var params = {};
      if (this.selectedPractitioners && this.selectedPractitioners.length > 0) {
        params['practitioner_id-in'] = this.selectedPractitioners.join(',');
      }
      return params;
    }
  }),
  watch: {
    selectedPractitioners: function selectedPractitioners() {
      this.$emit('update:params', this.computedParams);
    }
  },
  methods: {
    getPractitionerLabel: function getPractitionerLabel(practitionerId, count) {
      var p = this.getPractitionerById(practitionerId);
      if (p && p.id) {
        return p.full_name + ' (' + count + ')';
      }
      return practitionerId + ' (' + count + ')';
    }
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_invoice_InvoiceListItem__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_invoice_InvoiceListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_invoice_InvoiceListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoicePayments__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoicePayments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoicePayments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceList',
  components: { InvoiceListItem: __WEBPACK_IMPORTED_MODULE_0__components_invoice_InvoiceListItem___default.a, AppointmentList: __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue___default.a, InvoicePayments: __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoicePayments___default.a, HelpPopover: __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover_vue___default.a },
  props: {
    invoices: { type: Array, default: function _default() {
        return [];
      } },
    selectedInvoiceIds: { type: Array, default: function _default() {
        return [];
      } },
    actions: { type: Array, default: function _default() {
        return [];
      } },
    loading: { default: true },
    withStatus: { type: Boolean, default: false },
    withStatusBorder: { type: Boolean, default: false },
    primaryAction: { type: Object },
    colVizExpansion: {}
  },
  data: function data() {
    return {
      selectedInvoice: null,
      bottomsheet: false,
      sheetWindow: 0,
      requests: {
        enrich: {
          resource: 'invoiceguru.invoices',
          resourceId: null,
          method: 'post',
          extra: 'enrich'
        }
      }
    };
  },

  computed: {
    isXs: function isXs() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
    statusColor: function statusColor() {
      if (this.selectedInvoice) {
        if (this.selectedInvoice.status === 'paid') {
          return 'success';
        }
        if (this.selectedInvoice.status === 'sent') {
          return 'primary';
        }
      }
      return 'blue-grey lighten-4';
    },
    viewUrl: function viewUrl() {
      if (this.selectedInvoice && this.selectedInvoice.get_view_url) {
        var base = this.$invoiceguru.baseUrl;
        return '' + base + this.selectedInvoice.get_view_url;
      }
      return null;
    }
  },
  methods: {
    isSelected: function isSelected(invoice) {
      if (!this.selectedInvoiceIds) {
        return false;
      }
      return this.selectedInvoiceIds.indexOf(invoice.id) !== -1;
    },
    closeBottomSheet: function closeBottomSheet() {
      this.bottomsheet = false;
    },
    setSelectedInvoice: function setSelectedInvoice(invoice) {
      var _this = this;

      this.selectedInvoice = invoice;
      this.bottomsheet = false;
      window.setTimeout(function () {
        _this.bottomsheet = true;
        _this.sheetWindow = 0;
      }, 100);
    },
    getAmountDue: function getAmountDue(invoice) {
      var due = invoice.total_due;
      if (invoice.status === 'paid') {
        if (invoice.total_due > 0) {
          due = 0;
        }
      } else {
        var calcDue = invoice.invoice_amount - invoice.amount_paid;
        if (parseFloat(calcDue) !== parseFloat(due)) {
          due = calcDue;
        }
      }
      return this.formatCurrency(invoice.currency, due);
    },
    refreshInvoice: function refreshInvoice() {
      this.requests.enrich.resourceId = this.selectedInvoice.id;
      var appointments = this.selectedInvoice.appointments.join(',');
      this.requests.enrich.data = { appointments: appointments };
      this.$request('save', this.requests.enrich);
    }
  }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_PractitionerFaces_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_PractitionerFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_lists_PractitionerFaces_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_SpaceFaces_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_SpaceFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_SpaceFaces_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceListItem',
  components: { PractitionerFaces: __WEBPACK_IMPORTED_MODULE_0__components_lists_PractitionerFaces_vue___default.a, SpaceFaces: __WEBPACK_IMPORTED_MODULE_1__components_lists_SpaceFaces_vue___default.a },
  props: {
    invoice: { type: Object, default: function _default() {
        return {};
      } },
    withStatus: { type: Boolean, default: false },
    withStatusBorder: { type: Boolean, default: false }
  },
  computed: {
    statusColor: function statusColor() {
      if (this.invoice) {
        if (this.invoice.status === 'paid') {
          return 'success';
        }
        if (this.invoice.status === 'sent') {
          return 'info';
        }
      }
      return 'blue-grey lighten-4';
    },
    statusBorder: function statusBorder() {
      if (this.invoice && this.withStatusBorder) {
        var color = '#9E9E9E';
        if (this.invoice.status === 'paid') {
          color = '#4caf50';
        }
        if (this.invoice.status === 'sent') {
          color = '#2196f3';
        }
        return 'border-left:solid 5px ' + color + ';';
      }
      return null;
    }
  },
  i18n: {
    messages: {
      en: {
        date: 'Date',
        dueDate: 'Due',
        invoiceDate: 'Date',
        total: 'Total',
        payments: 'Paid'
      }
    }
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_statement__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_statement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_statement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_statement_js__ = __webpack_require__(215);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoicePayments',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_statement_js__["a" /* default */]],
  components: { Statement: __WEBPACK_IMPORTED_MODULE_0__components_statement___default.a },
  props: {
    invoice: { type: Object },
    transactions: { type: Array, default: function _default() {
        return [];
      } }
  },

  watch: {
    invoice: {
      immediate: true,
      handler: function handler() {
        this.getStatement();
      }
    }
  },
  computed: {
    invoiceClient: function invoiceClient() {
      return this.getClientById(this.invoice.customer_id);
    },
    appointmentIds: function appointmentIds() {
      if (this.invoice && this.invoice.appointments) {
        return this.invoice.appointments;
      }
      return [];
    },
    statement: function statement() {
      return this.getObjectPath(this.statementRequest, 'result', {});
    }
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceVersions',
  props: {
    invoice: { type: Object, required: true },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      loading: false,
      versions: []
    };
  },

  methods: {
    getVersions: function getVersions() {
      var url = this.$invoiceguru.baseUrl + '/invoices/' + this.invoice.id + '/files/';
      var options = this.$invoiceguru.getOptions();
      var vm = this;
      vm.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, options).then(function (data) {
        vm.versions = data.data.versions;
      }).finally(function () {
        vm.loading = false;
      });
    }
  },
  watch: {
    touch: {
      immediate: true,
      handler: function handler() {
        this.getVersions();
      }
    }
  },
  i18n: {
    messages: {
      en: {
        subheaders: {
          current: 'Current version',
          older: 'Older versions',
          archived: 'Archived versions'
        }
      }
    }
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoicePreview',
  props: {
    invoice: { type: Object }
  }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_communications_CommunicationWatcher__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_communications_CommunicationWatcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_communications_CommunicationWatcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceListItem__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceListItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SendInvoice',
  components: { CommunicationWatcher: __WEBPACK_IMPORTED_MODULE_1__components_communications_CommunicationWatcher___default.a, InvoiceListItem: __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceListItem___default.a },
  props: {
    invoice: { type: Object, default: function _default() {
        return {};
      } },
    client: { type: Object, default: function _default() {
        return { client: {} };
      } },
    withClose: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      window: 1,
      loading: false,
      showCustomMessage: false,
      customMessage: null,
      messageIdsToWatch: [],
      sendAsSMS: false,
      sendToMe: false,
      sendToCustomer: false,
      showMedicalAidPicker: false,
      selectedMedicalAid: null,
      requestStatus: 0,
      successMessage: false,
      sendSMSReqId: 'send-invoice-sms-request',
      freeFormEmail: null,
      failedMessages: [],
      requests: {
        contact: {
          resource: 'ag.spaces.relationships'
        }
      },
      response: {
        messages: [{
          ok: true,
          response: {
            id: 81341,
            preferred_transport: 'email',
            recipient_emails: ['info@38.co.za', 'christo@appointmentguru.co']
          }
        }, {
          ok: true,
          response: {
            id: 81342,
            preferred_transport: 'sms',
            recipient_phone_number: ['+27832566533']
          }
        }]
      },
      rules: {
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Please provide a valid email address.';
        }
      }
    };
  },
  mounted: function mounted() {
    if (this.clientId && this.clientId > 0) {
      var client = this.setClientFromId(this.clientId);
      if (client !== -1) {
        this.client = client;
      }
    }
  },

  methods: {
    reset: function reset() {
      this.window = 0;
      this.sendToCustomer = false;
      this.sendAsSMS = false;
      this.sendToMe = false;
      this.freeFormEmail = '';
      this.customMessage = null;
      this.messageIdsToWatch = [];
    },
    refreshContact: function refreshContact() {
      this.requests.contact.resourceId = this.relationshipId;
      this.$request('get', this.requests.contact);
    },
    send: function send() {
      var _this = this;

      var baseurl = "https://invoiceguru-v2.appointmentguru.co";
      var url = baseurl + '/invoices/' + this.invoice.id + '/send2/';
      var data = {
        to_email: this.emails
      };
      if (this.customMessage) {
        data['custom_message'] = this.customMessage;
      }
      this.loading = true;
      this.messageIdsToWatch = [];
      this.failedMessages = [];
      this.window = 1;
      var token = this.$store.getters.token;
      var headers = {
        'authorization': 'bearer ' + token
      };
      this.requestStatus = 'sending';
      this.successMessage = false;
      var options = {
        headers: headers
      };
      if (this.sendAsSMS && this.client && this.normalizedClient && this.normalizedClient.phone_number) {
        data['to_phone'] = this.normalizedClient.phone_number;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, data, options).then(function (response) {
        _this.requestStatus = 'sent';
        _this.$emit('sent', _this.invoice);
        _this.successMessage = 'Sent \u2713';
        _this.loading = false;

        _this.response = response;
        var communications = _this.getObjectPath(_this.response, 'data.messages', []);
        communications.forEach(function (comm) {
          if (comm.ok) {
            _this.messageIdsToWatch.push(comm.response.id);
            _this.$store.commit('addCommunication', comm.response);
          } else {
            _this.failedMessages.push(comm.response);
          }
        });
      }).catch(function (err) {
        _this.response = err;
        _this.requestStatus = 'error';
        _this.errorMessage = 'Unable to send message. Please try again';
        _this.loading = true;
        console.log(err);
      });
    }
  },
  watch: {
    selectedMedicalAid: function selectedMedicalAid() {
      this.freeFormEmail = this.selectedMedicalAid.email;
      this.showMedicalAidPicker = false;
    },

    invoice: {
      immediate: true,
      handler: function handler() {
        this.reset();
      }
    },
    refreshContactRequestStatus: function refreshContactRequestStatus() {
      if (this.requests.contact.status === 200) {
        var cli = this.getObjectPath(this.requests, 'contact.result');
        if (cli) {
          this.$emit('update:client', cli.client);
        }
      }
    }
  },
  computed: {
    emailList: function emailList() {
      var emails = [];
      if (this.sendToMe && this.me) {
        emails.push(this.me.email);
      }
      if (this.sendToCustomer && this.client && this.normalizedClient) {
        emails.push(this.normalizedClient.email);
      }
      if (this.freeFormEmail && this.rules.email(this.freeFormEmail) === true) {
        emails.push(this.freeFormEmail);
      }
      return emails;
    },
    hasPhoneNumber: function hasPhoneNumber() {
      return this.getObjectPath(this.normalizedClient, 'phone_number');
    },
    hasValidEmail: function hasValidEmail() {
      if (this.normalizedClient) {
        return this.isRealEmail(this.normalizedClient.email);
      }
      return false;
    },
    whatsapplink: function whatsapplink() {
      if (this.normalizedClient) {
        if (this.normalizedClient.phone_number) {
          var number = this.normalizedClient.phone_number.replace('+', '');
          var msg = 'Hi ' + this.normalizedClient.first_name + '%0AHere\'s your invoice:%0A' + this.invoiceUrl + '%0AThanks!';
          return 'https://wa.me/' + number + '?text=' + msg;
        }
      }
      return false;
    },
    emails: function emails() {
      var emails = this.emailList;
      return emails.join(',');
    },
    invoiceUrl: function invoiceUrl() {
      if (this.invoice && this.invoice.id) {
        return this.$invoiceguru.baseUrl + '/invoice/' + this.invoice.id + '/?key=' + this.invoice.password;
      }
    },
    me: function me() {
      return this.$store.getters.me;
    },
    recipientsExist: function recipientsExist() {
      var emailsExist = this.emails && this.emails.length > 3;
      return emailsExist || this.sendAsSMS;
    },
    sendToMeHint: function sendToMeHint() {
      if (this.me) {
        return '(' + this.me.email + ')';
      }
    },
    sendAsSMSHint: function sendAsSMSHint() {
      if (this.hasPhoneNumber) {
        return '(' + this.normalizedClient.phone_number + ')';
      } else {
        return 'No phone number for this client';
      }
    },
    sendToCustomerHint: function sendToCustomerHint() {
      if (this.hasValidEmail) {
        return '(' + this.normalizedClient.email + ')';
      } else {
        return 'No valid email address found for this client';
      }
    },
    relationshipId: function relationshipId() {
      var relId = null;
      relId = this.getObjectPath(this.invoice, 'relationship_id');
      if (!relId) {
        var userId = this.getObjectPath(this.invoice, 'customer_id');
        if (userId) {
          var rel = this.getRelationByClientId(userId);
          if (rel) {
            relId = rel.id;
          }
        }
      }
      return relId;
    },
    refreshContactRequestStatus: function refreshContactRequestStatus() {
      return this.requests.contact.status;
    }
  }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_BulkAddCodes__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_BulkAddCodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_BulkAddCodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceMasterDetail',
  components: { BulkAddCodes: __WEBPACK_IMPORTED_MODULE_0__components_appointment_BulkAddCodes___default.a, HelpPopover: __WEBPACK_IMPORTED_MODULE_1__components_ui_HelpPopover___default.a },
  props: {
    appointments: { type: Array, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      exandr: [],
      codeMode: 'new',
      bulkReqId: 'appointment-bulk-request-invoiceable',
      bulkReqIdData: 'appointment-bulk-request-update',
      selected: [],
      searchString: null,
      appointmentData: {
        invoice_title: '',
        invoice_description: ''
      }
    };
  },

  watch: {
    markInvoiceableRequestStatus: function markInvoiceableRequestStatus() {
      if (this.markInvoiceableRequestStatus === 200) {
        this.selected = [];
        this.getAppointmentsInRange();
      }
    },
    invoiceDataRequestStatus: function invoiceDataRequestStatus() {},
    totalAppointments: function totalAppointments() {
      this.selected = [];
    }
  },
  computed: {
    markInvoiceableRequest: function markInvoiceableRequest() {
      return this.$store.getters.getRequestById(this.bulkReqId, true);
    },
    markInvoiceableRequestStatus: function markInvoiceableRequestStatus() {
      return this.markInvoiceableRequest.status;
    },
    invoiceDataRequest: function invoiceDataRequest() {
      return this.$store.getters.getRequestById(this.bulkReqIdData, true);
    },
    invoiceDataRequestStatus: function invoiceDataRequestStatus() {
      return this.invoiceDataRequest.status;
    },
    showSuccessNotification: function showSuccessNotification() {
      return this.invoiceDataRequestStatus === 200;
    },
    filteredAppointments: function filteredAppointments() {
      var _this = this;

      if (this.searchString) {
        return this.appointments.filter(function (appt) {
          var index = '{appt.title} ' + appt.invoice_title + ' ' + appt.full_name;
          var containsString = index.toLowerCase().indexOf(_this.searchString.toLowerCase()) > -1;
          return containsString;
        });
      }
      return this.appointments;
    },
    totalAppointments: function totalAppointments() {
      if (this.appointments) {
        return this.appointments.length;
      }
      return 0;
    }
  },
  methods: {
    save: function save() {
      var ids = this.selected.join(',');
      var payload = this.appointmentData;
      this.$appointmentguru.resource('appointment.bulk').id(this.bulkReqIdData).save(ids, payload);
    },
    markInvoiceable: function markInvoiceable() {
      var ids = this.selected.join(',');
      var payload = { invoiceable: true };
      this.$appointmentguru.resource('appointment.bulk').id(this.bulkReqId).save(ids, payload);
    }
  },
  i18n: {
    messages: {
      en: {
        help: {
          title: 'These appointments are not marked as invoiceable',
          text: 'Appointments not marked as invoiceable might need some extra information. You may want to add ICD10 codes etc. On this page you can update multiple appointments at once.'
        }
      }
    }
  }
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_StatusPicker__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_StatusPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_StatusPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_manage_create_confirm_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_manage_create_confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_manage_create_confirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_invoice_InvoiceList_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_invoice_InvoiceList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_invoice_InvoiceList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InvoiceableClientList_vue__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InvoiceableClientList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InvoiceableClientList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_actions_AppointmentAction_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_actions_AppointmentAction_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_actions_AppointmentAction_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceableClients',
  components: {
    StatusPicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_StatusPicker___default.a,
    HelpPopover: __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover___default.a,
    ConfirmInvoice: __WEBPACK_IMPORTED_MODULE_2__components_invoice_manage_create_confirm_vue___default.a,

    InvoiceList: __WEBPACK_IMPORTED_MODULE_3__components_invoice_InvoiceList_vue___default.a,
    AppointmentAction: __WEBPACK_IMPORTED_MODULE_5__components_actions_AppointmentAction_vue___default.a,
    InvoiceableClientList: __WEBPACK_IMPORTED_MODULE_4__InvoiceableClientList_vue___default.a
  },
  props: {
    data: { type: Array, default: function _default() {
        return [];
      } },
    actions: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      confirmationTouch: 0,
      showInfo: false,
      page_size: 20,
      selectedLabels: ['N', 'C'],
      selectedRelationship: null,
      selectedAppointments: [],
      actionTouch: 0,
      touch: 0,
      requests: {
        invoices: {
          resource: 'invoiceguru.invoices',
          params: {
            ordering: '-id',
            page_size: 10
          }
        }
      },
      filters: { statuses: 'N,C' }
    };
  },
  mounted: function mounted() {
    this.getInvoices();
  },

  watch: {
    activeDateRange: function activeDateRange() {
      this.selectedRelationship = null;
    }
  },
  computed: {
    relationship: function relationship() {
      if (this.selectedRelationship) {
        return this.getRelationById(this.selectedRelationship.relationship_id);
      }
      return null;
    },
    recentInvoices: function recentInvoices() {
      return this.getObjectPath(this.requests.invoices, 'result.results', []);
    },
    invoicesInProgress: function invoicesInProgress() {
      var customersInProgress = {};
      this.data.forEach(function (inv) {
        if (inv.status.toLowerCase() === 'new') {
          customersInProgress[inv.customer_id] = inv;
        }
      });
      return customersInProgress;
    },
    dateRange: function dateRange() {
      return {
        fromDateIso: this.activeDateRange.from,
        fromDate: this.dateformat(this.activeDateRange.from),
        toDateIso: this.activeDateRange.to,
        toDate: this.dateformat(this.activeDateRange.to)
      };
    },
    activeDateRange: function activeDateRange() {
      return this.$store.getters.activeDateRange;
    },
    events: function events() {
      var vm = this;
      var events = {
        'primarycta': function primarycta(invoice) {
          vm.$emit('primarycta', invoice);
        }
      };
      this.actions.forEach(function (action) {
        events[action.action] = function (invoice) {
          vm.$emit(action.action, invoice);
        };
      });
      return events;
    }
  },
  methods: {
    invoiceCreated: function invoiceCreated(invoice) {},
    hasInvoicesInProgress: function hasInvoicesInProgress(clientId) {
      if (this.invoicesInProgress && this.invoicesInProgress[clientId]) {
        return true;
      }
      return false;
    },
    setRelationship: function setRelationship(rel) {
      rel.id = rel.relationship_id;
      this.selectedRelationship = rel;
    },
    setFilters: function setFilters(params) {
      if (params.statuses && Array.isArray(params.statuses)) {
        params.statuses = params.statuses.join(',');
      }
      if (params.after) {
        params.after_utc = params.after;
      }
      if (params.before) {
        params.before_utc = params.before;
      }

      this.filters = params;
    },
    setSelectedRelationship: function setSelectedRelationship(rel) {
      if (this.$vuetify.breakpoint.xsOnly) {
        var options = {
          relationshipId: rel.relationship_id,
          touchClear: Math.random(),
          initialDateRange: this.activeDateRange
        };
        this.launchInvoiceDialog(options);
      } else {
        this.selectedRelationship = rel;
        this.confirmationTouch++;
      }
    },
    selectNext: function selectNext() {
      if (this.invoiceableClients && this.invoiceableClients.length > 0) {
        this.setSelectedRelationship(this.invoiceableClients[0]);
      }
    },
    getInvoices: function getInvoices() {
      this.$request('get', this.requests.invoices);
    },
    getClasses: function getClasses(rel) {
      var prog = 'in-progress-' + this.hasInvoicesInProgress(rel.client_id);
      var isSelected = false;
      if (this.selectedRelationship && this.selectedRelationship.relationship_id === rel.relationship_id) {
        isSelected = true;
      }
      var selected = 'selected-' + isSelected;
      return [prog, selected];
    }
  },
  i18n: {
    messages: {
      en: {
        btn: {
          createInvoice: 'Invoice'
        },
        title: {
          summary: '{fromDate} - {toDate}'
        },
        page: {
          title: 'Invoiceable clients',
          subheading: 'Here is a list of clients who you\'ve seen between {fromDate} and {toDate}',
          noresults: '🎉 You\'ve invoiced all your clients!',
          info: 'This view shows you clients who have appointments that may need invoicing',
          resultsshowing: 'Currently showing clients with appointments between {fromDate} and {toDate}',
          withstatuses: 'With the following statuses'
        },
        list: {
          appointments: 'appointment | appointments'
        }
      }
    }
  }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_StatusPicker_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_StatusPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_StatusPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceableClients',
  props: {
    touch: { type: Number, default: 0 }
  },
  components: {
    StatusPicker: __WEBPACK_IMPORTED_MODULE_0__components_pickers_StatusPicker_vue___default.a
  },
  data: function data() {
    return {
      request: {
        resource: 'ag.spaces.relationships',
        extra: 'invoiceable'
      },
      statuses: __WEBPACK_IMPORTED_MODULE_1__store_constants__["m" /* STATUSES */],
      selectedStatuses: ['N', 'C'],
      selectedClient: null

    };
  },
  mounted: function mounted() {
    this.getClients();
  },

  watch: {
    params: {
      immediate: true,
      handler: function handler() {
        this.getClients();
        this.$emit('update:params', this.params);
      }
    },
    filters: {
      deep: true,
      handler: function handler() {
        this.$emit('input', this.filters);
      }
    },
    touch: function touch() {
      this.getClients();
    }
  },
  computed: {
    invoiceableClients: function invoiceableClients() {
      return this.getObjectPath(this.request, 'result.results', []);
    },
    selectedClientId: function selectedClientId() {
      if (this.selectedClient) {
        return this.selectedClient.id;
      }
      return null;
    },
    params: function params() {
      return {
        after: this.activeDateRange.from,
        before: this.activeDateRange.to,
        statuses: this.selectedStatuses
      };
    },
    activeDateRange: function activeDateRange() {
      return this.$store.getters.activeDateRange;
    },
    filters: function filters() {
      var data = {};
      if (this.selectedStatuses && this.selectedStatuses.length > 0) {
        data.statuses = this.selectedStatuses;
      }
      this.$emit('input', data);
      return data;
    }
  },
  methods: {
    getClients: function getClients() {
      this.request.params = this.params;
      this.$request('get', this.request);
    },
    clientClicked: function clientClicked(client) {
      this.selectedClient = client;
      this.$emit('selected', client);
    }
  },
  i18n: {
    messages: {
      en: {
        btn: {
          createInvoice: 'Invoice'
        },
        title: {
          summary: '{fromDate} - {toDate}'
        },
        page: {
          title: 'Invoiceable clients',
          subheading: 'Clients with appointments between {after} and {before}',
          noresults: '🎉 You\'ve invoiced all your clients!',
          info: 'This view shows you clients who have appointments that may need invoicing',
          resultsshowing: 'Currently showing clients with appointments between {fromDate} and {toDate}',
          withstatuses: 'With the following statuses'
        },
        list: {
          appointments: 'appointment | appointments'
        }
      }
    }
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Kanban',
  props: {
    cols: { type: Array, default: function _default() {
        return [];
      } },
    data: { type: Array, default: function _default() {
        return {};
      } },
    withSearch: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      visible: {},
      showSearch: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.cols.forEach(function (col) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this.visible, col.value, true);
    });
  },

  methods: {
    getItems: function getItems(lookup) {
      return this.$store.getters.getInvoicesByStatus(lookup);
    },
    toggleCol: function toggleCol(col) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.visible, col.value, !this.visible[col.value]);
    }
  },
  computed: {
    classWidth: function classWidth() {
      var classes = ['xs' + 12 / this.cols.length];
      if (this.$vuetify.breakpoint.xs) {
        classes.push('pa-0');
      }
      return classes;
    }
  }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Kanban__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Kanban___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Kanban__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OverdueKanban',
  components: { InvoiceList: __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList___default.a, Kanban: __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Kanban___default.a },
  props: {
    data: { type: Array, default: function _default() {
        return {};
      } },
    actions: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      reqId: 'invoices-overdue-request',
      visible: {},
      cols: [{ text: '0-30', value: 'thirty', color: '' }, { text: '30-60', value: 'sixty', color: 'amber lighten-4' }, { text: '90', value: 'ninety', color: 'red lighten-4' }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchOverdue();
    this.cols.forEach(function (col) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this.visible, col.value, true);
    });
  },

  computed: {
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    report: function report() {
      var response = this.getObjectPath(this.request, 'result.data', false);
      if (response === false) {
        return {
          'thirty': [], 'sixty': [], 'ninety': []
        };
      }
      return response;
    },
    totals: function totals() {
      return {
        'thirty': this.report['thirty'].reduce(function (total, item) {
          return parseFloat(item.invoice_amount) + total;
        }, 0),
        'sixty': this.report['sixty'].reduce(function (total, item) {
          return parseFloat(item.invoice_amount) + total;
        }, 0),
        'ninety': this.report['ninety'].reduce(function (total, item) {
          return parseFloat(item.invoice_amount) + total;
        }, 0)
      };
    },
    events: function events() {
      var vm = this;
      var events = {
        'primarycta': function primarycta(invoice) {
          vm.$emit('primarycta', invoice);
        }
      };
      this.actions.forEach(function (action) {
        events[action.action] = function (invoice) {
          vm.$emit(action.action, invoice);
        };
      });
      return events;
    }
  },
  methods: {
    fetchOverdue: function fetchOverdue() {
      return this.$invoiceguru.resource('overdue').id(this.reqId).list();
    },
    toggleCol: function toggleCol(col) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.visible, col.value, !this.visible[col.value]);
    }
  }
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Kanban__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Kanban___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Kanban__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgressKanban',
  components: { InvoiceList: __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceList___default.a, Kanban: __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Kanban___default.a },
  props: {
    data: { type: Array, default: function _default() {
        return {};
      } },
    actions: { type: Array, default: function _default() {
        return [];
      } },
    searchString: { type: String, required: false }
  },
  data: function data() {
    return {
      visibleItemCount: 10,
      pageSize: 10,
      cols: [{
        text: 'In progress',
        value: 'new',
        summary: this.calculateTotal
      }, { text: 'Sent', value: 'sent', summary: this.calculateTotal }, { text: 'Paid', value: 'paid', summary: this.calculateTotal }]
    };
  },

  methods: {
    calculateTotal: function calculateTotal(items) {
      var total = items.reduce(function (total, item) {
        return parseFloat(item.invoice_amount) + total;
      }, 0);
      if (total > 0) {
        var currency = items[0].currency;
        return this.formatCurrency(currency, total);
      }
      return false;
    },
    filteredItems: function filteredItems(col) {
      var _this = this;

      var items = this.$store.getters.getInvoicesByStatus(col);
      if (this.searchString) {
        items = items.filter(function (item) {
          var index = (item.title + ' ' + item.date + ' ' + item.invoice_amount + ' ' + item.id).toLowerCase();
          return index.indexOf(_this.searchString.toLowerCase()) >= 0;
        });
      }
      var visible = items.slice(0, this.visibleItemCount);
      return visible;
    }
  },
  computed: {
    invoicesRequest: function invoicesRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_0__store_constants__["e" /* LIST_INVOICES_IN_RANGE_REQ */], true);
    },
    totalItems: function totalItems() {
      return this.getObjectPath(this.invoicesRequest, 'result.data.count', 0);
    },
    allinvoices: function allinvoices() {
      return this.getObjectPath(this.invoicesRequest, 'result.data.results', []);
    },
    items: function items() {
      return {
        new: this.$store.getters.getInvoicesByStatus('new'),
        sent: this.$store.getters.getInvoicesByStatus('sent'),
        paid: this.$store.getters.getInvoicesByStatus('paid')
      };
    },
    visibleItems: function visibleItems() {
      return {
        new: this.filteredItems('new'),
        sent: this.filteredItems('sent'),
        paid: this.filteredItems('paid')
      };
    },
    events: function events() {
      var vm = this;
      var events = {
        'primarycta': function primarycta(invoice) {
          vm.$emit('primarycta', invoice);
        }
      };
      this.actions.forEach(function (action) {
        events[action.action] = function (invoice) {
          vm.$emit(action.action, invoice);
        };
      });
      return events;
    }
  }
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceTable',
  props: {
    title: { type: String },
    loading: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false },
    data: { type: Array, default: function _default() {
        return [];
      } },
    headers: { type: Array, default: function _default() {
        return [];
      } },
    actions: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      selected: [],
      search: ''
    };
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceFilter_vue__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceFilter_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceToolbar',
  components: { InvoiceFilter: __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceFilter_vue___default.a },
  props: {
    title: { type: String },
    withSearch: { type: Boolean, default: false },
    useDateDue: { type: Boolean, default: false },
    page: { type: Number, default: 1 }
  },
  data: function data() {
    return {
      localUseDateDue: false,
      showFilters: false,
      serverSearch: true,
      activetab: '',
      searchString: '',
      debouncedSearchString: '',
      timeout: null,
      loadingReqId: __WEBPACK_IMPORTED_MODULE_0__store_constants__["e" /* LIST_INVOICES_IN_RANGE_REQ */],
      params: {}
    };
  },
  mounted: function mounted() {
    this.localUseDateDue = this.useDateDue;
  },

  computed: {
    activeDateRange: function activeDateRange() {
      return this.$store.getters.activeDateRange;
    },
    formattedDateRange: function formattedDateRange() {
      return {
        fromDate: this.dateformat(this.activeDateRange.from, 'Do MMM'),
        toDate: this.dateformat(this.activeDateRange.to, 'Do MMM YYYY')
      };
    },
    invoicesRequest: function invoicesRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_0__store_constants__["e" /* LIST_INVOICES_IN_RANGE_REQ */], true);
    },
    totalItems: function totalItems() {
      return this.getObjectPath(this.invoicesRequest, 'result.data.count', 0);
    },
    totalPages: function totalPages() {
      var pagesize = this.invoices.length;
      if (pagesize === 0) {
        return 1;
      }
      return Math.ceil(this.totalItems / pagesize);
    },
    summaryParams: function summaryParams() {
      var data = this.formattedDateRange;
      data['total'] = this.totalItems;
      return data;
    },
    facets: function facets() {
      return this.getObjectPath(this.invoicesRequest, 'result.data.facets', {});
    },
    invoices: function invoices() {
      return this.getObjectPath(this.invoicesRequest, 'result.data.results', []);
    },
    showServerSearch: function showServerSearch() {
      return this.searchString && this.searchString.length > 2;
    },
    dateTypeString: function dateTypeString() {
      if (this.localUseDateDue) {
        return 'Search using due date';
      }
      return 'Search using invoice date';
    }
  },
  watch: {
    params: function params() {
      this.loadInvoices('due', this.params);
    },
    showServerSearch: function showServerSearch() {
      if (!this.showServerSearch) {
        this.serverSearch = false;
      }
    },
    serverSearch: function serverSearch() {
      if (this.serverSearch === true) {
        this.searchOnServer;
      } else {
        this.searchString = null;
        this.loadInvoices();
        this.debouncedSearch();
      }
    },
    localUseDateDue: function localUseDateDue() {
      console.log(this.localUseDateDue);
      this.$emit('update:useDateDue', this.localUseDateDue);
    }
  },
  methods: {
    debouncedSearch: function debouncedSearch() {
      var _this = this;

      if (this.serverSearch) {
        return;
      }
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.$emit('search', _this.searchString);
      }, 300);
    },
    searchOnServer: function searchOnServer() {
      this.$emit('search', null);
      this.loadInvoices('due', { search: this.searchString });
    }
  },
  i18n: {
    messages: {
      en: {
        title: {
          summary: '{fromDate} to {toDate}'
        },
        bulk: {
          appointmentsTodo: 'Appointment maintenance',
          invoiceable: 'Invoiceable clients',
          status: 'Filter By Status'
        }
      }
    }
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_DateRangePicker__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_DateRangePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_DateRangePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listitems_PaymentListItem_vue__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listitems_PaymentListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__listitems_PaymentListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TransactionsTable',
  components: { PaymentListItem: __WEBPACK_IMPORTED_MODULE_2__listitems_PaymentListItem_vue___default.a, DateRangePicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_DateRangePicker___default.a },
  props: {
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      search: '',
      page: 1,
      pageSize: 20,
      searchwithdaterange: true,
      activesearch: null,
      requests: {
        get: {
          resource: 'invoiceguru.transactions',
          params: {
            type: 'Payment'
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.get();
  },

  watch: {
    globalActiveDateRangeFormatted: function globalActiveDateRangeFormatted() {
      this.get();
    },
    page: function page() {
      this.get();
    },
    searchwithdaterange: function searchwithdaterange() {
      this.doSearch();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['activeDateRange']), {
    transactions: function transactions() {
      return this.getObjectPath(this.requests.get, 'result.results', []);
    },
    numTransactions: function numTransactions() {
      return this.getObjectPath(this.requests.get, 'result.count', 0);
    },
    numPages: function numPages() {
      if (this.pageSize === 0) {
        return 0;
      }
      return Math.ceil(this.numTransactions / this.pageSize);
    }
  }),
  methods: {
    applyFilters: function applyFilters() {
      var params = {
        page_size: this.pageSize,
        page: this.page
      };
      if (this.activeDateRange.from) {
        params['after_utc'] = this.activeDateRange.from;
      }
      if (this.activeDateRange.to) {
        params['before_utc'] = this.activeDateRange.to;
      }
      this.requests.get.params = params;
    },
    clearSearch: function clearSearch() {
      this.activesearch = '';
      this.get();
    },
    doSearch: function doSearch() {
      this.page = 1;
      var params = {
        page_size: this.pageSize,
        page: this.page
      };
      if (this.searchwithdaterange) {
        if (this.activeDateRange.from) {
          params['after_utc'] = this.activeDateRange.from;
        }
        if (this.activeDateRange.to) {
          params['before_utc'] = this.activeDateRange.to;
        }
      }
      params['search'] = this.search;
      this.activesearch = this.search;
      this.requests.get.params = params;
      this.$request('get', this.requests.get);
    },
    get: function get() {
      this.applyFilters();
      this.$request('get', this.requests.get);
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Payments'
      }
    }
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceBillingDetails',
  props: {
    request: { type: Object, required: true },
    expanded: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      showSuggestions: false,
      selectedSpaceSettings: 0,
      localExpanded: false
    };
  },
  mounted: function mounted() {
    if (this.expanded === true) {
      this.localExpanded = true;
    }
  },

  methods: {
    configureSettings: function configureSettings() {
      var spaceId = this.spaceIds[0];
      var settings = this.settings;
      var options = { spaceId: spaceId, settings: settings };
      this.launchInvoiceSettingsDialog(options);
    },
    get: function get() {
      console.log('getting');
      this.$request('get', this.request);
    }
  },
  watch: {
    settings: function settings() {
      this.$emit('update:settings', this.settings);
    },
    invoiceSettingsChanged: function invoiceSettingsChanged() {
      this.get();
    }
  },
  computed: {
    invoiceSettingsChanged: function invoiceSettingsChanged() {
      return this.getObjectPath(this.$store.state.application, 'globalEventInformation.InvoiceSettings.touch');
    },
    resizedLogoPicture: function resizedLogoPicture() {
      if (this.settings && this.settings.logo_picture) {
        return this.imageKitUrl(this.settings.logo_picture, 'n-avatar_md');
      }
      return null;
    },
    settings: function settings() {
      var space = this.getObjectPath(this.request, 'result.invoice.settings.space', null);
      if (space) {
        return space;
      }
      var spaces = this.getObjectPath(this.request, 'result.invoice.settings.spaces', []);
      if (spaces && spaces.length > this.selectedSpaceSettings) {
        return spaces[this.selectedSpaceSettings];
      }
      return null;
    },
    spaces: function spaces() {
      return this.getObjectPath(this.request, 'result.invoice.settings.spaces', []);
    },
    appointments: function appointments() {
      return this.getObjectPath(this.request, 'result.results', []);
    },
    spaceIds: function spaceIds() {
      return this.appointments.map(function (appt) {
        return appt.service_id;
      });
    },
    progressColor: function progressColor() {
      if (this.requiredProgress < 100) {
        return 'error lighten-2';
      }
      if (this.recommendedProgress === 100) {
        return 'success';
      }
      return 'warning';
    },
    progressIcon: function progressIcon() {
      if (this.requiredProgress < 100) {
        return 'error';
      }
      if (this.recommendedProgress === 100) {
        return 'check';
      }
      return 'warning';
    },
    progressPercent: function progressPercent() {
      if (this.requiredProgress < 100) {
        return this.requiredProgress;
      }
      if (this.recommendedProgress < 100) {
        return this.recommendedProgress;
      }
      return 100;
    },
    requiredProgress: function requiredProgress() {
      var requiredSteps = this.todoProgress.filter(function (item) {
        return item.required;
      });
      var completedSteps = requiredSteps.filter(function (item) {
        return item.complete;
      });
      if (requiredSteps.length === 0) {
        return 100;
      }
      return completedSteps.length / requiredSteps.length * 100;
    },
    recommendedProgress: function recommendedProgress() {
      var steps = this.todoProgress.filter(function (item) {
        return item.required === false;
      });
      var completed = steps.filter(function (item) {
        return item.complete;
      });
      if (steps.length === 0) {
        return 100;
      }
      return completed.length / steps.length * 100;
    },
    todoProgress: function todoProgress() {
      if (!this.settings) {
        return [];
      }
      var items = [{
        title: 'Billing address',
        complete: this.settings.billing_address !== null,
        required: true
      }, {
        title: 'Banking details',
        complete: this.settings.banking_details !== null,
        required: true
      }, {
        title: 'Logo',
        complete: this.settings.logo_picture !== null,
        required: false
      }, {
        title: 'Invoice notes',
        complete: this.settings.invoice_notes !== null,
        required: false
      }, {
        title: 'Receipt notes',
        complete: this.settings.receipt_notes !== null,
        required: false
      }];
      if (this.settings.integrate_medical_aid === true) {
        items = [{
          title: 'Practice name',
          text: 'The name of your business as you would like it to show on invoices',
          complete: this.settings.practice_name !== null,
          required: true
        }, {
          title: 'Practice number',
          text: 'The registration number for your practice. Required for medical practices',
          complete: this.settings.practice_number !== null,
          required: true
        }].concat(items);
      }
      return items;
    }
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_medicalaid_ObjectForm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_medicalaid_ObjectForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_medicalaid_ObjectForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_settings_media_Uploader__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_settings_media_Uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_settings_media_Uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceSettings',
  components: { ObjectForm: __WEBPACK_IMPORTED_MODULE_1__components_medicalaid_ObjectForm___default.a, Uploader: __WEBPACK_IMPORTED_MODULE_2__components_pages_settings_media_Uploader___default.a },
  props: {
    value: { required: true },
    spaceId: { required: true },

    withClose: { type: Boolean, default: true },
    closeOnSave: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      isValid: false,
      uploadLogo: false,
      settings: {
        override_practitioner_settings: true
      },
      snackbar: false,
      color: null,
      resultMessage: null,
      logoPicture: null,
      getReq: {
        resource: 'ag.spaces.settings'
      },
      saveReq: {
        resource: 'ag.spaces.settings'
      },
      fields: ['practice_name', 'practice_number', 'banking_details', 'billing_address', 'invoice_notes', 'receipt_notes', 'include_booking_info', 'integrate_medical_aid'],
      config: {
        'practice_name': {
          hint: 'Practice or business name as you would like to display it on your invoice',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'practice_number': {
          hint: '(if relevant) - your registered practice number',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'banking_details': {
          type: 'vtextarea',
          hint: 'Added to your invoices so that people know how to pay you',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'billing_address': {
          type: 'vtextarea',
          flexAttrs: { sm6: true }
        },
        'invoice_notes': {
          hint: 'These will automatically be added to all invoices',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'receipt_notes': {
          hint: 'This will automatically be added to all receipts',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'statement_notes': {
          hint: 'This will automatically be added to all statements',
          persistentHint: true,
          flexAttrs: { sm6: true }
        }
      }
    };
  },
  mounted: function mounted() {
    if (!this.settings || this.settings.id) {
      this.get();
    }
  },

  watch: {
    touch: function touch() {
      this.get();
    },

    value: {
      immediate: true,
      handler: function handler() {
        this.setSettings(this.value);
      }
    },
    getRequestStatus: function getRequestStatus() {
      if (this.getRequestStatus === 200) {
        var settings = this.getObjectPath(this.getReq, 'result', {});
        this.setSettings(settings);
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200) {
        var settings = this.getObjectPath(this.saveReq, 'result', {});
        this.setSettings(settings);
        this.$emit('success', settings);
      }
    }
  },
  computed: {
    settingsId: function settingsId() {
      return this.getObjectPath(this.settings, 'id');
    },
    getRequestStatus: function getRequestStatus() {
      return this.getReq.status;
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.saveReq.status;
    },
    logoUploadPath: function logoUploadPath() {
      return '/api/v3/spaces/' + this.spaceId + '/settings/' + this.settingsId + '/';
    },
    resizedLogoPicture: function resizedLogoPicture() {
      if (this.logoPicture) {
        return this.imageKitUrl(this.logoPicture, 'n-avatar_md');
      }
      return null;
    }
  },
  methods: {
    setValid: function setValid(isValid) {
      this.isValid = isValid;
    },
    setSettings: function setSettings(data) {
      var _this = this;

      if (data) {
        if (data.id) {
          this.settings.id = data.id;
        }
        if (data.logo_picture) {
          this.logoPicture = data.logo_picture;
        }
        this.fields.forEach(function (field) {
          var value = data[field];
          if (!value) {
            value = null;
          }
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(_this.settings, field, value);
        });
      }
    },
    get: function get() {
      if (this.settingsId) {
        this.getReq.kwargs = { spaceId: this.spaceId };
        this.getReq.resourceId = this.settingsId;
        this.$request('get', this.getReq);
      }
    },
    save: function save() {
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.settings);
      this.saveReq.data = data;
      this.saveReq.kwargs = { spaceId: this.spaceId };
      this.saveReq.resourceId = this.settings.id;
      this.$request('save', this.saveReq);
    }
  }
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_ReadOnlyStatementList_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_ReadOnlyStatementList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_ReadOnlyStatementList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_manage_create_encrypt_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_manage_create_encrypt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_manage_create_encrypt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__success__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_client_ClientCard__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_client_ClientCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_client_ClientCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InvoiceBillingDetails_vue__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InvoiceBillingDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InvoiceBillingDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_PaymentMethodPicker_vue__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_PaymentMethodPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pickers_PaymentMethodPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(3);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmInvoice',
  components: {
    InvoiceBillingDetails: __WEBPACK_IMPORTED_MODULE_5__InvoiceBillingDetails_vue___default.a,
    ReadOnlyStatementList: __WEBPACK_IMPORTED_MODULE_1__components_lists_ReadOnlyStatementList_vue___default.a,
    ClientCard: __WEBPACK_IMPORTED_MODULE_4__components_client_ClientCard___default.a,
    InvoiceSuccess: __WEBPACK_IMPORTED_MODULE_3__success___default.a,
    EncryptInvoice: __WEBPACK_IMPORTED_MODULE_2__components_invoice_manage_create_encrypt_vue___default.a,
    PaymentMethodPicker: __WEBPACK_IMPORTED_MODULE_6__components_pickers_PaymentMethodPicker_vue___default.a
  },
  props: {
    title: { type: String },
    value: { type: Object, default: function _default() {} },
    relationship: { type: Object, default: function _default() {} },
    appointments: { type: Array, default: function _default() {
        return [];
      } },
    touch: { type: Number, default: 0 },
    withEdit: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      ready: false,
      success: false,
      finaldue: 0,
      markPaid: false,
      paymentMethod: null,
      editAppointmentDialog: false,
      selectedAppointment: null,
      invoice: {
        title: null,
        due_date: null,
        date: null,
        appointments: [],
        appointment_data: []
      },
      spaceSettings: {},
      statementRequest: {},
      req: {
        resource: 'invoiceguru.invoices'
      },
      requests: {
        relationship: { resource: 'ag.spaces.relationships' },
        appt: { resource: 'ag.practitioner.appointments' }
      },
      rel: {},
      password: null,
      passwordHint: null,
      showDatepicker: false,
      showDueDatepicker: false
    };
  },
  mounted: function mounted() {
    var vm = this;
    window.setTimeout(function () {
      vm.ready = true;
    }, 5000);
  },

  watch: {
    computedTitle: function computedTitle() {
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(this.invoice, 'title', this.computedTitle);
    },
    latestDate: function latestDate() {
      if (this.latestDate > this.invoice.date) {
        this.invoice.due_date = this.latestDate;
      }
    },
    invoiceDate: function invoiceDate() {
      if (this.invoiceDate > this.invoice.due_date) {
        this.invoice.due_date = this.invoiceDate;
      }
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 201) {
        this.success = true;
        this.$emit('success', this.remoteInvoice);
      }
    },
    touch: function touch() {
      this.reset();
    },
    loading: function loading() {
      if (this.loading === true) {
        this.ready = false;
      }
      if (this.loading === false) {
        var vm = this;
        window.setTimeout(function () {
          vm.ready = true;
        }, 1500);
      }
    }
  },
  methods: {
    reset: function reset() {
      this.invoice = {
        title: null,
        due_date: null,
        date: null,
        appointments: [],
        appointment_data: []
      };
      this.password = null;
      this.passwordHint = null;
      if ('space_id' in this.invoice) {
        delete this.invoice.space_id;
      }
      this.success = false;
    },
    create: function create() {
      var payload = this.computedInvoice;
      this.$emit('creating', payload);
      this.req.data = payload;
      this.$request('save', this.req);
    },
    editInvoiceDetails: function editInvoiceDetails(appointment) {
      this.selectedAppointment = appointment;
      this.editAppointmentDialog = true;
    },
    removeAppointment: function removeAppointment(appointment) {},
    setSpaceSettings: function setSpaceSettings(settings) {
      if (settings && settings.service_id) {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(this.invoice, 'space_id', settings.service_id);
      }
    },
    setRelationship: function setRelationship(rel) {
      this.rel = rel;
    },
    fetchMeta: function fetchMeta() {
      if (this.relationshipId) {
        this.requests.relationship.resourceId = this.relationshipId;
        return this.$request('get', this.requests.relationship);
      }
      if (this.sortedAppointmentIds && this.sortedAppointmentIds.length > 0) {
        this.requests.appt.resourceId = this.sortedAppointmentIds[0];
        return this.$request('get', this.requests.appt);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['getPractitionerById']), {
    spaceIds: function spaceIds() {
      var ids = [];
      var space = this.getObjectPath(this.statementRequest, 'result.invoice.settings.space');
      var spaces = this.getObjectPath(this.statementRequest, 'result.invoice.settings.spaces');
      if (space) {
        ids.push(space);
      }
      if (spaces && spaces.length > 0) {
        ids = ids.concat(spaces);
      }
      if (ids && ids.length > 0) {
        return ids.map(function (space) {
          return space.service_id;
        });
      }
      return ids;
    },
    loading: function loading() {
      if (this.req.loading === true) {
        return true;
      }
      if (this.statementRequest.loading === true) {
        return true;
      }
      return false;
    },
    selectedSpaceId: function selectedSpaceId() {
      return this.getObjectPath(this.spaceSettings, 'service_id');
    },
    fullname: function fullname() {
      if (this.relationship && this.relationship.id) {
        return this.formatFullName(this.relationship);
      } else {
        return this.formatFullName(this.rel);
      }
    },
    computedTitle: function computedTitle() {
      var name = this.formatFullName(this.relationship);
      if (this.invoice && this.invoice.date) {
        name = this.fullname + ' - ' + this.invoice.date;
      }
      return name;
    },
    sortedAppointments: function sortedAppointments() {
      if (this.appointments && this.appointments.length > 0) {
        return this.appointments.sort(function (a, b) {
          if (a.start_time > b.start_time) {
            return 1;
          }
          if (a.start_time < b.start_time) {
            return -1;
          }
          return 0;
        });
      }
      return [];
    },
    hasCreateInvoicePermissions: function hasCreateInvoicePermissions() {
      if (this.req.loading) {
        return true;
      }

      if (this.spaceIds && this.spaceIds.length > 0) {
        return this.permissionsCanCreateInvoiceMethod(this.spaceIds, this.appointments);
      }
      return true;
    },
    requestStatus: function requestStatus() {
      return this.req.status;
    },
    passwordWatchString: function passwordWatchString() {
      return this.password + this.passwordHint;
    },
    relIdNumber: function relIdNumber() {
      return this.getObjectPath(this.rel, 'record.medical_aid.patient_id_number');
    },
    relEmail: function relEmail() {
      var email = this.getObjectPath(this.rel, 'client.email');
      if (this.isRealEmail(email)) {
        return email;
      }
      return null;
    },
    relPhone: function relPhone() {
      return this.getObjectPath(this.rel, 'client.phone_number');
    },
    invoiceDate: function invoiceDate() {
      return this.invoice.date;
    },
    sortedAppointmentIds: function sortedAppointmentIds() {
      return this.sortedAppointments.map(function (a) {
        return a.id;
      });
    },
    practitionerId: function practitionerId() {
      return this.meId;
    },
    relationshipId: function relationshipId() {
      var relId = this.getObjectPath(this.relationship, 'id', null);
      if (!relId && this.clientId) {
        var rel = this.getRelationByClientId(this.clientId);
        if (rel && rel.id) {
          return rel.id;
        }
      }
      if (this.appointments && this.appointments.length > 0) {
        var appt = this.appointments[0];
        if (appt && appt.computed_relationship_id) {
          return appt.computed_relationship_id;
        }
      }
      return relId;
    },
    remoteClientId: function remoteClientId() {
      var id = this.getObjectPath(this.requests, 'relationship.result.client.id', null);
      if (!id) {
        id = this.getObjectPath(this.requests, 'appt.result.client.id', null);
      }
      return id;
    },
    clientId: function clientId() {
      var id = this.getObjectPath(this.rel, 'client.id', null);
      if (id) {
        return id;
      }
      id = this.getObjectPath(this.relationship, 'user_id', null);
      if (id) {
        return id;
      }
      if (this.remoteClientId) {
        return this.remoteClientId;
      }
      return null;
    },
    metaIsValid: function metaIsValid() {
      if (this.clientId) {
        return true;
      }
      return false;
    },
    remoteInvoice: function remoteInvoice() {
      return this.getObjectPath(this.req, 'result', {});
    },
    computedInvoice: function computedInvoice() {
      if (!this.invoice.date) {
        this.invoice.date = __WEBPACK_IMPORTED_MODULE_7_luxon__["DateTime"].local().toISODate();
      }
      if (!this.invoice.due_date) {
        this.invoice.due_date = this.latestDate;
      }
      if (!this.invoice.title) {
        this.invoice.title = this.computedTitle;
      }
      var data = {
        appointments: this.sortedAppointmentIds,
        appointment_data: this.sortedAppointments,
        relationship_id: this.relationshipId,
        practitioner_id: this.practitionerId,
        customer_id: this.clientId,
        title: this.invoice.title,
        date: this.invoice.date,
        due_date: this.invoice.due_date,
        invoice_period_from: this.firstDate,
        invoice_period_to: this.latestDate
      };
      if (this.selectedSpaceId) {
        data['space_id'] = this.selectedSpaceId;
      }
      if (this.password) {
        data.encrypt_password = this.password;
        if (this.passwordHint) {
          data.encrypt_password_hint = this.passwordHint;
        }
      }
      if (this.finaldue > 0 && this.markPaid === true) {
        data.status = 'paid';
        if (this.paymentMethod) {
          data.payment_method = this.paymentMethod;
        }
      }
      return data;
    },
    firstDate: function firstDate() {
      if (this.hasAppointments) {
        return __WEBPACK_IMPORTED_MODULE_7_luxon__["DateTime"].fromISO(this.sortedAppointments[0].start_time).toISODate();
      }
      return null;
    },
    latestDate: function latestDate() {
      if (this.hasAppointments) {
        var lastAppt = this.sortedAppointments[this.sortedAppointments.length - 1];
        return __WEBPACK_IMPORTED_MODULE_7_luxon__["DateTime"].fromISO(lastAppt.start_time).toISODate();
      }
      return null;
    },
    numAppointments: function numAppointments() {
      if (this.hasAppointments) {
        return this.sortedAppointments.length;
      }
      return 0;
    },
    hasAppointments: function hasAppointments() {
      if (this.sortedAppointments && this.sortedAppointments.length > 0) {
        return true;
      }
      return false;
    },
    total: function total() {
      if (this.invoice && this.invoice.appointment_data) {
        return this.invoice.appointment_data.reduce(function (total, appt) {
          return total + parseFloat(appt.price);
        }, 0);
      }
      return 0;
    }
  }),
  i18n: {
    messages: {
      en: {
        numAppointments: '{count} appointment|{count} appointments'
      }
    }
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Encrypt',
  props: {
    password: { type: String, required: false },
    passwordHint: { type: String, required: false },
    relationship: { type: Object, required: false }
  },
  data: function data() {
    return {
      localpassword: null,
      localpasswordHint: null
    };
  },

  watch: {
    password: {
      immediate: true,
      handler: function handler() {
        this.localpassword = this.password;
      }
    },
    passwordHint: {
      immediate: true,
      handler: function handler() {
        this.localpasswordHint = this.passwordHint;
      }
    },
    localpassword: function localpassword() {
      this.$emit('update:password', this.localpassword);
    },
    localpasswordHint: function localpasswordHint() {
      this.$emit('update:passwordHint', this.localpasswordHint);
    }
  },
  computed: {
    relIdNumber: function relIdNumber() {
      return this.getObjectPath(this.relationship, 'record.medical_aid.patient_id_number');
    },
    relEmail: function relEmail() {
      var email = this.getObjectPath(this.relationship, 'client.email');
      if (this.isRealEmail(email)) {
        return email;
      }
      email = this.getObjectPath(this.relationship, 'email');
      if (this.isRealEmail(email)) {
        return email;
      }
      return null;
    },
    relPhone: function relPhone() {
      var ph = this.getObjectPath(this.relationship, 'client.phone_number');
      if (ph) {
        return ph;
      }
      ph = this.getObjectPath(this.relationship, 'phone_number');
      if (ph) {
        return ph;
      }
      return null;
    }
  }
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_invoice__ = __webpack_require__(94);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceSuccess',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_invoice__["a" /* default */]],
  props: {
    value: { type: Object },
    withNextSteps: { type: Boolean, default: false }
  },
  data: function data() {
    var _this = this;

    var vm = this;
    return {
      actions: [{
        title: 'Send',
        icon: 'send',
        onclick: function onclick(invoice) {
          vm.invoiceEvents.send(invoice);
        }
      }, {
        title: 'Share',
        icon: 'share',
        onclick: function onclick(invoice) {
          vm.invoiceEvents.share(invoice);
        }
      }, {
        title: 'View',
        icon: 'open_in_new',
        onclick: function onclick(invoice) {
          var url = _this.$invoiceguru.baseUrl + '/' + invoice.get_view_url;

          window.open(url, '_blank');
        }
      }, {
        title: 'Edit',
        icon: 'edit',
        onclick: function onclick(invoice) {
          _this.$emit('done');
          _this.$router.push({ path: '/invoices/' + invoice.id });
          _this.$store.dispatch('HIDE_SPACE', 'globalDialog');
        }
      }, {
        title: 'Add another',
        subtitle: 'Create another invoice',
        icon: 'add',
        onclick: function onclick(invoice) {
          _this.$emit('next');
        }
      }, {
        title: 'Done',
        subtitle: 'Return to what you were doing',
        icon: 'done',
        onclick: function onclick(invoice) {
          _this.$emit('done');
          _this.$store.dispatch('HIDE_SPACE', 'globalDialog');
        }
      }]
    };
  }
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MobileStepLayout',
  props: {
    steps: { type: Array, default: function _default() {
        return [{ id: 0 }, { id: 1 }, { id: 2 }];
      } },
    step: { type: Number, default: 0 }
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeRelationships',
  props: {
    steps: { type: Array, default: function _default() {
        return [{ id: 0 }, { id: 1 }, { id: 2 }];
      } },
    initialStep: { type: Number, default: 0 }
  }
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var EMAIL_BACKEND = 'services.backends.email.EmailBackend';
var SMS_BACKEND = 'services.backends.zoomconnect.ZoomSMSBackend';
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommunicationListItem',
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    transport: function transport() {
      if (this.item.backend_used === EMAIL_BACKEND) {
        return 'email';
      }
      if (this.item.backend_used === SMS_BACKEND) {
        return 'sms';
      }
    },
    title: function title() {
      if (this.item.backend_used === EMAIL_BACKEND) {
        return this.item.subject;
      }
      if (this.item.backend_used === SMS_BACKEND) {
        return this.item.short_message;
      }
      return this.item.subject;
    },
    subtitle: function subtitle() {
      return this.item.message;
    }
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaymentListItem',
  components: { AppointmentListItem: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem_vue___default.a },
  props: {
    item: { type: Object, required: true }
  },
  data: function data() {
    return {
      dialogs: {
        appt: false
      },
      requests: {
        appt: {
          resource: 'ag.practitioner.appointments'
        }
      }
    };
  },

  computed: {
    amountFormatted: function amountFormatted() {
      return this.formatCurrency(this.item.currency, this.item.amount);
    },
    relationship: function relationship() {
      if (this.item && this.item.relationship_id) {
        return this.getRelationById(this.item.relationship_id);
      }
      if (this.item && this.item.customer_id) {
        return this.getRelationByClientId(this.item.customer_id);
      }
    },
    appointments: function appointments() {
      return this.item.appointments || [];
    },
    remoteAppts: function remoteAppts() {
      return this.getObjectPath(this.requests.appt, 'result.results', []);
    },
    fullName: function fullName() {
      var firstName = this.getObjectPath(this.relationship, 'client.first_name');
      var lastName = this.getObjectPath(this.relationship, 'client.last_name');
      return firstName + ' ' + lastName;
    }
  },
  methods: {
    getAppts: function getAppts() {
      this.requests.appt.params = {
        'id-in': this.appointments.join(',')
      };
      this.$request('get', this.requests.appt);
    },
    showAppointments: function showAppointments() {
      this.getAppts();
      this.dialogs.appt = true;
    }
  }
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PractitionerListItem',
  props: {
    item: { type: Object, required: true },
    withAvatar: { type: Boolean, default: true }
  },
  computed: {
    profilePicture: function profilePicture() {
      if (this.item) {
        if (this.item && this.item.profile_picture) {
          var _profile = this.item.profile_picture;
          return this.imageKitUrl(_profile, 'n-avatar_md');
        }
        if (this.item.practitioner_media && this.item.practitioner_media.profile) {
          var _profile2 = this.item.practitioner_media.profile;
          return this.imageKitUrl(_profile2, 'n-avatar_md');
        }
        var profile = this.getObjectPath(this.item, 'profile.profile_picture', null);
        if (profile) {
          return this.imageKitUrl(profile, 'n-avatar_md');
        }
      }
      return null;
    },
    fullname: function fullname() {
      if (this.item) {
        var p = this.item;
        if (p.full_name) {
          return p.full_name;
        }
        if (p.practitioner_name) {
          return p.practitioner_name;
        }
        if (p.user && p.user.id) {
          return p.user.first_name + ' ' + p.user.last_name;
        }
        if (p.first_name) {
          return p.first_name + ' ' + p.last_name;
        }
      }
      return null;
    },
    profession: function profession() {
      if (this.item.profession) {
        return this.item.profession;
      }
      if (this.item.practitioner_profession) {
        return this.item.practitioner_profession;
      }
      var profession = this.getObjectPath(this.item, 'profile.profession.name', null);
      if (profession) {
        return profession;
      }
    }
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatementListItem',
  props: {
    value: { type: Object, required: true }
  },
  data: function data() {
    return {
      statement: {},
      delReqId: 'delete-statement-request',
      showDeleteConfirmation: false,
      loading: false,
      isDeleting: false
    };
  },
  mounted: function mounted() {
    this.statement = this.value;
  },

  methods: {
    dodelete: function dodelete(statementId) {
      this.loading = true;
      this.isDeleting = true;
      return this.$invoiceguru.resource('statements').id(this.delReqId).delete(statementId);
    }
  },
  watch: {
    deleteStatementRequestStatus: function deleteStatementRequestStatus() {
      if (this.deleteStatementRequestStatus === 204) {
        if (this.loading === true) {
          this.$emit('deleted', this.statement);
        }
        this.loading = false;
      }
      if (this.deleteStatementRequestStatus >= 300) {
        window.alert('Unable to delete statement. Please try again');
        this.isDeleting = false;
        this.loading = false;
      }
    }
  },
  computed: {
    deleteStatementRequest: function deleteStatementRequest() {
      return this.$store.getters.getRequestById(this.delReqId, true);
    },
    deleteStatementRequestStatus: function deleteStatementRequestStatus() {
      return this.deleteStatementRequest.status;
    }
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_FormSubmissionCard__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_FormSubmissionCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cards_FormSubmissionCard__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubmissionListItem',
  components: { FormSubmissionCard: __WEBPACK_IMPORTED_MODULE_1__components_cards_FormSubmissionCard___default.a },
  props: {
    item: { type: Object, default: function _default() {
        return {};
      } },
    expand: { type: Boolean, default: false },
    withActions: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      active: false,
      selected: false
    };
  },

  computed: {
    submission: function submission() {
      return this.item;
    },
    relationship: function relationship() {
      return this.getObjectPath(this.submission, 'linked_submission.relationship', {});
    },
    pdfLink: function pdfLink() {
      return 'https://www.jotform.com/pdf-submission/' + this.submission.id;
    },
    inboxLink: function inboxLink() {
      return 'https://www.jotform.com/inbox/' + this.submission.form_id + '/' + this.submission.id;
    },
    actions: function actions() {
      var _this = this;

      return [{
        title: 'Show client',
        attrs: {},
        onClick: function onClick(action) {
          if (_this.relationship) {
            _this.gotoRelationship(_this.relationship.id, 1);
          }
        },
        isDisabled: function isDisabled() {
          if (_this.relationship && _this.relationship.id) {
            return false;
          }
          return true;
        }
      }, {
        title: 'Assign to client',
        onClick: function onClick() {
          _this.$emit('assign_client', _this.submission);
        },
        isDisabled: function isDisabled() {
          if (_this.relationship && _this.relationship.id) {
            return true;
          }
          return false;
        }
      }, {
        title: 'Download PDF',
        attrs: {
          href: this.pdfLink,
          target: '_blank'
        }
      }, {
        title: 'Open in JotForm inbox',
        attrs: {
          href: this.inboxLink,
          target: '_blank'
        }
      }];
    }
  },
  watch: {
    expand: {
      immediate: true,
      handler: function handler() {
        if (this.expand) {
          this.active = true;
        } else {
          this.active = false;
        }
      }
    }
  },
  methods: {
    noop: function noop() {},
    getPotentialName: function getPotentialName(answers) {
      var firstNameOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!answers) {
        return null;
      }
      answers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(answers);

      var fullname = answers.find(function (answer) {
        if (answer.name === 'fullname') {
          return answer;
        }
      });

      try {
        if (fullname) {
          return fullname.prettyFormat;
        }
      } catch (err) {
        console.log(err);
      }

      var firstName = answers.find(function (answer) {
        if (answer.name === 'first_name') {
          return answer;
        }
        if (answer.name === 'firstName') {
          return answer;
        }
        if (answer.name === 'name') {
          return answer;
        }
        if (answer.name === 'patient_first_name') {
          return answer;
        }
      });
      if (firstNameOnly) {
        if (firstName) {
          return firstName.answer;
        }
        return '';
      }
      var lastName = answers.find(function (answer) {
        if (answer.name === 'last_name') {
          return answer;
        }
        if (answer.name === 'lastName') {
          return answer;
        }
        if (answer.name === 'surname') {
          return answer;
        }
        if (answer.name === 'patient_last_name') {
          return answer;
        }
      });
      fullname = '';
      if (firstName) {
        fullname = firstName.answer;
      }
      if (lastName) {
        fullname += ' ' + lastName.answer;
      }
      return fullname;
    }
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_AppointmentBottomSheet_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_AppointmentBottomSheet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_AppointmentBottomSheet_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AppointmentListItem: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default.a,
    AppointmentBottomSheet: __WEBPACK_IMPORTED_MODULE_1__components_appointment_actions_AppointmentBottomSheet_vue___default.a
  },
  props: {
    title: { type: String, default: 'Appointments' },
    selected: { type: Array, default: function _default() {
        return [];
      } },
    params: { type: Object, default: function _default() {} },
    facets: { type: String },
    ordering: { type: String },
    views: { type: Array, default: function _default() {
        return [];
      } },
    dense: { type: Boolean, default: false },
    cards: { type: Boolean, default: false },
    noResultsText: { type: String, default: 'No appointments found' },
    loading: { type: Boolean, default: false },
    withSelectAll: { type: Boolean, default: false },
    withPrice: { type: Boolean, default: true },
    withActions: { type: Boolean, default: true },
    withAdd: { type: Boolean, default: false },
    withAction: { type: Boolean, default: false },
    withSearch: { type: Boolean, default: false },
    withSubheaders: { type: Boolean, default: false },
    groupByName: { type: Boolean, default: false },
    groupByMonth: { type: Boolean, default: false },
    listAttrs: { type: Object, default: function _default() {} },
    disabled: { type: Boolean, default: false },
    pageSize: { type: Number, default: 20 },
    attrs: { type: Object, default: function _default() {} },
    multiple: { type: Boolean, default: true },
    touch: { type: Number, default: 0 }
  },
  name: 'AppointmentList',
  data: function data() {
    return {
      page: 1,
      selectAll: false,
      localSelected: [],
      request: {
        resource: 'ag.practitioner.appointments',
        loading: false
      },
      timeout: null,
      selectedAppointment: null,
      selectedView: {},
      initted: false,
      showBottomSheet: false
    };
  },
  mounted: function mounted() {
    this.debounceExpensiveMethod();
    if (this.views && this.views.length > 0) {
      this.selectedView = this.views[0];
    }
  },

  watch: {
    params: function params() {
      this.page = 1;
      this.selectAll = false;
      this.debounceExpensiveMethod();
    },
    touch: function touch() {
      this.page = 1;
      this.selectAll = false;
      this.debounceExpensiveMethod();
    },
    globalappdialogwatcher: function globalappdialogwatcher() {
      this.debounceExpensiveMethod();
    },
    selectAll: function selectAll() {
      if (this.selectAll === true) {
        var copy = this.filteredAppointments.slice();

        this.$emit('update:selected', copy);
      } else {
        this.$emit('update:selected', []);
      }
    },

    selectedView: {
      deep: true,
      handler: function handler() {
        this.$emit('update:params', this.selectedView.params);
      }
    },
    selected: {
      immediate: true,
      handler: function handler() {
        if (this.selected) {
          this.localSelected = this.selected;
          if (this.multiple) {
            this.globalSelectedAppointments = this.selected;
          }
        }
      }
    },
    localSelected: function localSelected() {
      this.$emit('update:selected', this.selected);
    },
    numGloballySelectedAppointments: function numGloballySelectedAppointments() {
      if (this.numGloballySelectedAppointments === 0) {
        this.$emit('update:selected', []);
      }
    },
    page: function page() {
      this.$emit('update:selected', []);
      this.localSelected = [];
      this.globalSelectedAppointments = [];
      this.debounceExpensiveMethod();
    },
    numResults: function numResults() {
      this.$emit('count', this.numResults);
    },
    requestStatus: function requestStatus() {
      this.$emit('update:request', this.request);
      if (this.requestStatus > 0) {
        this.timeout = null;
        this.initted = true;
      }
    },
    requestLoading: function requestLoading() {
      this.$emit('update:loading', this.requestLoading);
    }
  },
  methods: {
    showOptions: function showOptions(appt) {
      var _this = this;

      this.selectedAppointment = appt;
      this.showBottomSheet = false;
      window.setTimeout(function () {
        _this.showBottomSheet = true;
      }, 100);
    },
    debounceExpensiveMethod: function debounceExpensiveMethod() {
      this.request.loading = true;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(this.fetch, 1000);
    },
    fetch: function fetch() {
      this.$emit('update:selected', []);
      this.request.params = {};
      if (this.params) {
        this.request.params = this.params;
      }
      this.request.params['page'] = this.page;
      if (this.facets) {
        this.request.params.facets = this.facets;
      }
      if (this.ordering) {
        this.request.params.ordering = this.ordering;
      }
      this.$request('get', this.request);
    },
    isSelected: function isSelected(appointment) {
      return this.selected.find(function (selected) {
        return selected.id === appointment.id;
      });
    },
    appointmentSelected: function appointmentSelected(appointment) {
      if (this.disabled) {
        return;
      }
      this.selectedItem = appointment;
      if (!this.selected) {
        return [];
      }
      var selectedIndex = this.selected.findIndex(function (selected) {
        return selected.id === appointment.id;
      });
      if (selectedIndex >= 0) {
        this.localSelected.splice(selectedIndex, 1);
      } else {
        this.localSelected.push(appointment);
      }
      this.$emit('input', this.selectedItem);
    },
    isNewCategory: function isNewCategory(index, arr, key) {
      if (index === 0) {
        return true;
      }
      if (arr[index - 1][key] !== arr[index][key]) {
        return true;
      }
      return false;
    }
  },
  computed: {
    numGloballySelectedAppointments: function numGloballySelectedAppointments() {
      if (this.globalSelectedAppointments && this.globalSelectedAppointments.length > 0) {
        return this.globalSelectedAppointments.length;
      }
      return 0;
    },
    appointments: function appointments() {
      return this.getObjectPath(this.request, 'result.results', []);
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    requestLoading: function requestLoading() {
      return this.request.loading;
    },
    numResults: function numResults() {
      return this.getObjectPath(this.request, 'result.count', null);
    },
    totalPages: function totalPages() {
      if (this.pageSize && this.numResults) {
        return Math.ceil(this.numResults / this.pageSize);
      }
      return 1;
    },
    filteredAppointments: function filteredAppointments() {
      var _this2 = this;

      var appointments = this.appointments;
      if (this.client && this.client.id) {
        return appointments.filter(function (appt) {
          var clientId = appt.client;
          if (clientId.id) {
            clientId = clientId.id;
          }
          return clientId.toString() === _this2.client.id.toString();
        });
      }
      return appointments;
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BirthdayBar',
  data: function data() {
    return {
      request: {
        resource: 'ag.spaces',
        extra: 'birthdays'
      },
      month: null
    };
  },

  computed: {
    birthdays: function birthdays() {
      return this.getObjectPath(this.request, 'result.results', []);
    },
    birthdaysToday: function birthdaysToday() {
      var _this = this;

      var vm = this;
      return this.birthdays.filter(function (person) {
        var bdateString = _this.getObjectPath(person, 'patient.date_of_birth');
        return vm.isToday(bdateString);
      });
    }
  },
  methods: {
    get: function get() {
      this.$request('get', this.request);
    },
    isToday: function isToday(dateString) {
      var today = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local().toFormat('d LLL');
      var bday = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(dateString).toFormat('d LLL');
      return today === bday;
    },
    getString: function getString(dateString) {
      var today = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local();
      var bday = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(dateString);
      var bdayFormatted = bday.toFormat('LL dd');
      var bdayFormattedForHumans = bday.toFormat('d LLL');
      var todayFormatted = today.toFormat('LL dd');
      var age = Math.round(today.diff(bday, 'years').years);
      if (bdayFormatted === todayFormatted) {
        return 'Turns ' + age + ' today';
      }
      if (bdayFormatted < todayFormatted) {
        return 'Turned ' + age + ' on ' + bdayFormattedForHumans;
      }
      if (bdayFormatted > todayFormatted) {
        return 'Turns ' + age + ' on ' + bdayFormattedForHumans;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        titles: {
          today: 'Birthdays today',
          month: 'Birthdays this month'
        },
        nothing: {
          today: 'No birthdays today',
          thismonth: 'No birthdays this month'
        }
      },
      es: {}
    }
  }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_listitems_CommunicationListItem__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_listitems_CommunicationListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_listitems_CommunicationListItem__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommunicationList',
  components: { CommunicationListItem: __WEBPACK_IMPORTED_MODULE_1__components_listitems_CommunicationListItem___default.a },
  props: {
    contextType: { type: String },
    params: { type: Object, default: function _default() {
        return {};
      } },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      page: 1,
      reqId: 'get-messages'
    };
  },
  mounted: function mounted() {
    this.fetch();
  },

  watch: {
    paramsString: function paramsString() {
      this.fetch();
    },
    touch: function touch() {
      this.fetch();
    },
    loading: function loading() {
      this.$emit('loading', this.loading);
    }
  },
  computed: {
    paramsString: function paramsString() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.params);
    },
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId);
    },
    loading: function loading() {
      return this.$store.getters.getRequestById(this.reqId).loading;
    },
    messages: function messages() {
      var messages = this.getObjectPath(this.request, 'result.data.results', []);
      if (messages && messages.length > 0) {
        this.$store.commit('addManyCommunications', messages);
      }
      return messages;
    }
  },
  methods: {
    fetch: function fetch() {
      this.$communicationguru.resource('communication').id(this.reqId).list(this.params);
    }
  },
  i18n: {
    messages: {
      en: {
        nomessages: 'No messages found'
      },
      es: {}
    }
  }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommunicationTemplateList',
  props: {
    title: { type: String, required: false },
    context: { type: String, required: false }
  },
  components: { SpaceFaces: __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces___default.a },
  data: function data() {
    return {
      searchString: '',
      reqId: 'get-communication-templates'
    };
  },
  mounted: function mounted() {
    this.fetch();
  },

  computed: {
    showNew: function showNew() {
      var userId = this.getObjectPath(this.$store.getters.me, 'profile.user');
      return [1, 125, 412].indexOf(userId) >= 0;
    },
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId);
    },
    templates: function templates() {
      return this.getObjectPath(this.request, 'result.data.results', []);
    },
    filteredTemplates: function filteredTemplates() {
      var _this = this;

      var items = this.templates;
      if (this.context) {
        items = this.templates.filter(function (item) {
          var categories = item.categories;
          if (categories && categories.length > 0) {
            return categories.find(function (cat) {
              var match = cat.name === _this.context;
              if (match) {
                return cat;
              }
            });
          }
        });
      }
      if (this.searchString && this.searchString.length > 0) {
        items = items.filter(function (item) {
          return item.name.toLowerCase().indexOf(_this.searchString.toLowerCase()) >= 0;
        });
      }
      return items;
    }
  },
  methods: {
    fetch: function fetch() {
      var params = {};
      if (this.context) {
        params['category'] = this.context;
      }
      this.$communicationguru.resource('template').id(this.reqId).list(this.params);
      this.$communicationguru.resource('template.context').id(this.reqId + '-context').list();
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Message templates'
      }
    }
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FormList',
  props: {
    relationshipId: { required: true }
  },
  data: function data() {
    return {
      selectedForm: null,
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/forms',
        params: { is_linked: 'true' },
        result: []
      }
    };
  },

  watch: {
    relationshipId: {
      immediate: true,
      handler: function handler() {
        this.get();
      }
    }
  },
  computed: {
    forms: function forms() {
      return this.request.result;
    }
  },
  methods: {
    get: function get() {
      return this.$request('get', this.request);
    }
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    practitionerIds: { type: Array },
    size: { type: Number, default: 28 },
    withAdd: { type: Boolean, default: false },
    tooltipPrefix: { type: String }
  },
  name: 'PractitionerFaces',
  data: function data() {
    return {
      showPicker: false
    };
  },

  methods: {
    getTitle: function getTitle(practitioner) {
      if (!practitioner) {
        return '';
      }
      if (this.tooltipPrefix) {
        return this.tooltipPrefix + ' ' + practitioner.full_name;
      }
      return practitioner.full_name;
    },
    avatarUrl: function avatarUrl(practitioner) {
      var url = this.getObjectPath(practitioner, 'profile_picture');
      return this.imageKitUrl(url, 'n-avatar');
    }
  },
  computed: {
    practitioners: function practitioners() {
      var _this = this;

      return this.practitionerIds.map(function (practitionerId) {
        return _this.$store.getters.getPractitionerById(practitionerId);
      });
    }
  }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_statement_js__ = __webpack_require__(215);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReadOnlyStatementList',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_statement_js__["a" /* default */]],
  components: {
    AppointmentListItem: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentListItem___default.a
  },
  props: {
    value: { type: Object, required: false },
    appointmentIds: { type: Array, default: function _default() {
        return [];
      } },
    due: { type: Number },
    withTotals: { type: Boolean, default: true },
    withEdit: { type: Boolean, default: false },
    initiallyCollapsed: { type: Boolean, default: false },
    debounce: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      editInvoiceDialog: false,
      paidInFull: false,
      collapsed: false,
      selectedAppointment: null
    };
  },
  mounted: function mounted() {
    this.collapsed = this.initiallyCollapsed;
  },

  watch: {
    appointmentIds: {
      immediate: true,
      handler: function handler() {
        if (this.debounce) {
          this.debouncedGetStatement();
        } else {
          this.getStatement();
        }
      }
    },
    touch: function touch() {
      this.getStatement();
    },

    totalDue: {
      immediate: true,
      handler: function handler() {
        this.$emit('update:due', this.totalDue);
      }
    },
    currency: {
      immediate: true,
      handler: function handler() {
        this.$emit('update:currency', this.currency);
      }
    },
    relationships: {
      immediate: true,
      handler: function handler() {
        var rels = this.relationships;
        if (!Array.isArray(rels)) {
          rels = [this.relationships];
        }
        this.$emit('update:relationships', rels);
      }
    },
    paidInFull: function paidInFull() {
      this.$emit('paidInFull', this.paidInFull);
    },
    statementRequestStatus: function statementRequestStatus() {
      if (this.statementRequestStatus === 200) {
        this.$emit('input', this.statementRequest);
      }
    },
    statementLoading: function statementLoading() {
      this.$emit('update:loading', this.statementLoading);
    }
  },
  computed: {
    statementRequestStatus: function statementRequestStatus() {
      return this.statementRequest.status;
    },
    statementLoading: function statementLoading() {
      return this.statementRequest.loading;
    },
    grandTotal: function grandTotal() {
      return this.getObjectPath(this.statementRequest, 'result.meta.grand_total', null);
    },
    appointmentPrice: function appointmentPrice() {
      return this.getObjectPath(this.statementRequest, 'result.meta.appointment_unit_price', null);
    },
    totalDue: function totalDue() {
      return this.getObjectPath(this.statementRequest, 'result.meta.outstanding', null);
    },
    productSales: function productSales() {
      return this.getObjectPath(this.statementRequest, 'result.meta.products_total_price', null);
    },
    discounts: function discounts() {
      return this.getObjectPath(this.statementRequest, 'result.meta.discounts', null);
    },
    totalPaid: function totalPaid() {
      return this.getObjectPath(this.statementRequest, 'result.meta.payments_received', null);
    },
    relationships: function relationships() {
      return this.getObjectPath(this.statementRequest, 'result.relationship', []);
    },
    numAppointments: function numAppointments() {
      if (this.appointmentIds) {
        return this.appointmentIds.length;
      }
      return 0;
    }
  },
  i18n: {
    messages: {
      en: {
        appointmentsselected: '{count} appointment selected|{count} appointments selected'
      }
    }
  }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    spaceIds: { type: Array },
    spaces: { type: Array },
    size: { type: Number, default: 28 },
    tooltipPrefix: { type: String }
  },
  name: 'SpaceFaces',
  components: { SpacePicker: __WEBPACK_IMPORTED_MODULE_0__components_pickers_SpacePicker___default.a },
  data: function data() {
    return {
      fab: false,
      editspaces: false
    };
  },

  methods: {
    getTitle: function getTitle(space) {
      if (!space) {
        return '';
      }
      if (this.tooltipPrefix) {
        return this.tooltipPrefix + ' ' + space.title;
      }
      return space.title;
    }
  },
  computed: {
    allSpaces: function allSpaces() {
      return this.$store.getters.spaces;
    },
    selectedSpaces: function selectedSpaces() {
      var _this = this;

      if (this.spaces) {
        return this.spaces;
      }
      if (this.spaceIds) {
        return this.allSpaces.filter(function (space) {
          var stringSearch = _this.spaceIds.indexOf(space.id.toString()) >= 0;
          var intSearch = _this.spaceIds.indexOf(parseInt(space.id)) >= 0;
          return stringSearch || intSearch;
        });
      }
    }
  }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_Statement_SendStatement__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_Statement_SendStatement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_forms_Statement_SendStatement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_communications_BatchIdList__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_communications_BatchIdList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_communications_BatchIdList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listitems_StatementListItem__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listitems_StatementListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_listitems_StatementListItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatementList',
  props: {
    relationshipId: { required: false },
    touch: { type: Number, default: 0 }
  },
  components: { SendStatement: __WEBPACK_IMPORTED_MODULE_0__components_forms_Statement_SendStatement___default.a, StatementListItem: __WEBPACK_IMPORTED_MODULE_2__components_listitems_StatementListItem___default.a, BatchIdList: __WEBPACK_IMPORTED_MODULE_1__components_communications_BatchIdList___default.a },
  data: function data() {
    return {
      reqId: 'get-statement-request',
      showSendDialog: false,
      showDeleteConfirmation: false,
      selectedStatement: null,
      sendTouch: 1
    };
  },

  computed: {
    me: function me() {
      return this.$store.getters.me;
    },
    statementRequest: function statementRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    statements: function statements() {
      return this.getObjectPath(this.statementRequest, 'result.data.results', []);
    }
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler: function handler() {
        this.get();
      }
    },
    touch: function touch() {
      this.get();
    },
    showSendDialog: function showSendDialog() {
      if (this.showSendDialog === true) {
        this.sendTouch++;
      }
    },
    deleteStatementRequestStatus: function deleteStatementRequestStatus() {
      if (this.deleteStatementRequestStatus === 204) {
        this.get();
      }
    }
  },
  methods: {
    get: function get() {
      var params = {};
      if (this.relationshipId) {
        params.relationship_id = this.relationshipId;
      }
      return this.$invoiceguru.resource('statements').id(this.reqId).list(params);
    },
    initSend: function initSend(statement) {
      this.selectedStatement = statement;
      this.showSendDialog = true;
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Statements',
        dialogs: {
          titles: {
            send: 'Send'
          }
        },
        nostatements: {
          title: 'No statements found for this client',
          content: 'To create a statement, click on the invoices tab, click on the invoices you\'d like to add to the statement and then click on "+ STATEMENT"'
        }
      }
    }
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_FormSubmissionCard_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_FormSubmissionCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_cards_FormSubmissionCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_Integrations_JotForm_AssignSubmission_vue__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_Integrations_JotForm_AssignSubmission_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pages_Integrations_JotForm_AssignSubmission_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_forms_ShareForm_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_forms_ShareForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_forms_ShareForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_RequestStatus__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientForms',
  components: {
    FormSubmissionCard: __WEBPACK_IMPORTED_MODULE_0__components_cards_FormSubmissionCard_vue___default.a,
    ShareForm: __WEBPACK_IMPORTED_MODULE_2__components_client_forms_ShareForm_vue___default.a,
    AssignSubmission: __WEBPACK_IMPORTED_MODULE_1__components_pages_Integrations_JotForm_AssignSubmission_vue___default.a,
    RequestStatus: __WEBPACK_IMPORTED_MODULE_3__components_ui_RequestStatus___default.a
  },
  props: {
    relationshipId: { required: true }
  },
  data: function data() {
    return {
      request: {
        resource: 'ag.spaces.relationships',
        extra: 'submissions',
        data: {}
      },
      syncRequest: {
        resource: 'ag.integrations',
        extra: 'jotform/assign_submission'
      },
      confirmSync: false,
      showSubmissionPicker: false,
      showShare: false,
      submissiondetaildialog: false,
      selectedSubmission: null
    };
  },

  watch: {
    relationshipId: {
      immediate: true,
      handler: function handler() {
        if (this.relationshipId) {
          this.getSubmissions();
        }
      }
    }
  },
  computed: {
    integration: function integration() {
      return this.$store.getters.getIntegration('JotForm');
    },
    submissions: function submissions() {
      return this.request.result;
    }
  },
  methods: {
    noop: function noop() {},
    sync: function sync(submission) {
      this.syncRequest.method = 'post';
      this.syncRequest.data = {
        relationship_id: this.relationshipId,
        submission_id: submission.submission_id,
        form_id: submission.form.id
      };
      this.$request('save', this.syncRequest);
    },
    getSubmissions: function getSubmissions() {
      this.request.resourceId = this.relationshipId;
      this.$request('get', this.request);
    }
  }
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ObjectForm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ObjectForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ObjectForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ObjectListView__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ObjectListView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ObjectListView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_MedicalAidPicker__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_MedicalAidPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pickers_MedicalAidPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MedicalAidDetails',
  components: { ObjectListView: __WEBPACK_IMPORTED_MODULE_2__ObjectListView___default.a, ObjectForm: __WEBPACK_IMPORTED_MODULE_1__ObjectForm___default.a, MedicalAidPicker: __WEBPACK_IMPORTED_MODULE_3__components_pickers_MedicalAidPicker___default.a },
  props: {
    value: { type: Object },
    patientData: { type: Object },
    touch: { type: Number, default: 0 },
    usePatientInformation: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      cachedMedicalaid: {},
      usePatientDataBtnClicked: false,
      medicalaid: {},
      formsets: {
        patient: ['patient_first_name', 'patient_last_name', 'patient_id_number'],
        medical_aid: ['name', 'scheme', 'number', 'is_dependent'],
        medical_aid_config: {
          'name': {
            hint: 'Medical aid name. e.g. Discovery Health',
            persistentHint: true
          },
          'number': {
            hint: 'Medical aid number. e.g. 122345677',
            persistentHint: true
          }
        },
        main_member: ['member_first_name', 'member_last_name', 'member_id_number']
      },
      quickpicks: ['Discovery Health', 'Momentum Health', 'MediHelp', 'GEMS', 'Bankmed', 'Bonitas', 'CAMAF', 'Profmed']
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.medicalaid = this.value;
    }
  },

  computed: {
    isMainMember: function isMainMember() {
      return this.medicalaid.is_dependent === false;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.medicalaid = this.value;
        }
      }
    },
    medicalaid: function medicalaid() {
      this.$emit('input', this.medicalaid);
    },
    patientData: function patientData() {
      if (this.usePatientInformation === true) {
        this.setPatientInformation(this.patientData);
      }
    },
    usePatientInformation: function usePatientInformation() {
      if (this.usePatientInformation === true) {
        this.setPatientInformation(this.patientData);
      }
    },
    touch: function touch() {
      this.usePatientDataBtnClicked = false;
      if (this.value) {
        this.medicalaid = this.value;
      }
    }
  },
  methods: {
    undoSetPatientInformation: function undoSetPatientInformation() {
      var data = this.cachedMedicalaid;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.medicalaid, 'patient_first_name', data.patient_first_name);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.medicalaid, 'patient_last_name', data.patient_last_name);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.medicalaid, 'patient_id_number', data.patient_id_number);
      this.usePatientDataBtnClicked = false;
    },
    setPatientInformation: function setPatientInformation(data) {
      var overwrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (overwrite === true) {
        this.cachedMedicalaid = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.medicalaid));
        this.usePatientDataBtnClicked = true;
      }
      if (data) {
        if (data.first_name) {
          if (overwrite || !this.medicalaid.patient_first_name) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.medicalaid, 'patient_first_name', data.first_name);
          }
        }
        if (data.last_name) {
          if (overwrite || !this.medicalaid.patient_last_name) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.medicalaid, 'patient_last_name', data.last_name);
          }
        }
        if (data.id_number) {
          if (overwrite || !this.medicalaid.patient_id_number) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.medicalaid, 'patient_id_number', data.id_number);
          }
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        titles: {
          accountperson: 'Person responsible for account',
          patientinfo: 'Patient information',
          medicalaid: 'Medical aid details'
        },
        buttons: {
          undo: 'Undo',
          usecontactinfo: 'use contact info'
        }
      }
    }
  }
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ObjectForm',
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    errors: { type: Object, default: function _default() {
        return {};
      } },
    fields: { type: Array },
    fieldConfigs: { type: Object, default: function _default() {
        return {};
      } },
    ignoredFields: { type: Array },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      valid: false,
      data: {}
    };
  },
  mounted: function mounted() {
    this.data = this.value || {};
    this.$emit('valid', this.valid);
  },

  computed: {
    displayFields: function displayFields() {
      var _this = this;

      var all = [];
      if (this.data) {
        all = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.data);
        if (this.fields) {
          all = this.fields;
        }
        if (this.ignoredFields) {
          all = all.filter(function (field) {
            return _this.ignoredFields.indexOf(field) === -1;
          });
        }
      } else {
        console.log('data is not', this.data);
      }
      return all;
    }
  },
  methods: {
    hasErrors: function hasErrors(field) {
      if (this.errors) {
        return field in this.errors;
      }
      return false;
    },
    getErrors: function getErrors(fieldName) {
      if (fieldName in this.errors) {
        return this.errors[fieldName];
      }
      return [];
    },
    getWrapperAttrs: function getWrapperAttrs(fieldName) {
      if (this.fieldConfigs && fieldName in this.fieldConfigs) {
        return this.fieldConfigs[fieldName].flexAttrs || {};
      }
      return {};
    }
  },
  watch: {
    data: function data() {
      this.$emit('input', this.data);
    },

    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.data = this.value;
        }
      }
    },
    touch: function touch() {
      if (this.value) {
        this.data = this.value;
      }
    },
    valid: function valid() {
      this.$emit('valid', this.valid);
    }
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ObjectListView',
  props: {
    title: { type: String },
    value: { type: Object, default: function _default() {
        return {};
      } },
    fields: { type: Array },
    ignoredFields: { type: Array }
  },
  computed: {
    displayFields: function displayFields() {
      var _this = this;

      var all = [];
      if (this.value) {
        all = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.value);
        if (this.fields) {
          all = all.filter(function (field) {
            return _this.fields.indexOf(field) !== -1;
          });
        }
        if (this.ignoredFields) {
          all = all.filter(function (field) {
            return _this.ignoredFields.indexOf(field) === -1;
          });
        }
      }
      return all;
    }
  }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientContactDetails__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientContactDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_ClientContactDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MedicalAidDetails__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MedicalAidDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MedicalAidDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Referrers__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Referrers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Referrers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientForms__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientForms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ClientForms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Person__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_Tombstone__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_Tombstone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_app_Tombstone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ui_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ui_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ui_RequestStatus__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PatientInformationForm',
  components: { Tombstone: __WEBPACK_IMPORTED_MODULE_6__components_app_Tombstone___default.a, RequestStatus: __WEBPACK_IMPORTED_MODULE_7__components_ui_RequestStatus___default.a },
  props: {
    value: { type: Object },
    relationshipId: { required: true },
    touch: { type: Number, default: 0 },
    fetch: { type: Boolean, default: false },
    withDone: { type: Boolean, default: false },
    activeTab: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      tab: 0,
      closeOnSave: false,
      reqId: 'get-client',
      saveReqId: 'save-client',
      color: 'orange',
      relationship: {},
      loading: false,
      record: { patient: {}, medicalaid: {} }
    };
  },
  mounted: function mounted() {
    if (this.fetch) {
      this.get();
    }
    if (this.activeTab !== null) {
      this.tab = this.activeTab;
    }
  },

  watch: {
    value: function value() {
      if (this.value) {
        this.record = this.value;
      }
    },
    relationshipId: function relationshipId() {
      this.get();
    },
    touch: function touch() {
      this.get();
    },
    activeTab: function activeTab() {
      this.tab = this.activeTab;
    },
    getRequestStatus: function getRequestStatus() {
      if (this.getRequestStatus === 200) {
        this.record = this.remoteRecord;
        this.relationship = this.remoteRelationship;
        this.$store.commit('addClientDetail', this.relationship);
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200 && this.closeOnSave === true) {
        this.$emit('close');
      }
    }
  },
  methods: {
    get: function get() {
      if (this.relationshipId) {
        this.$appointmentguru.resource('practitioner.v3.relationships').id(this.reqId).get(this.relationshipId);
      } else {
        console.error('Could not fetch relationship. Relationship is null');
      }
    },
    setTab: function setTab(index) {
      console.log(index);
      this.tab = index;
    },
    save: function save() {
      var data = this.record;
      if (data) {
        if (this.accountPersonIsPatient === true) {
          data['account_person_id'] = this.record.patient.id;
          delete data['account_person'];
        }
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
        this.$medicalaidguru.resource('record.v2').id(this.saveReqId).save(this.record.id, data);
      }
    }
  },
  computed: {
    activePage: function activePage() {
      return this.pages[this.tab];
    },
    getRequest: function getRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    getRequestStatus: function getRequestStatus() {
      return this.getRequest.status;
    },
    saveRequest: function saveRequest() {
      return this.$store.getters.getRequestById(this.saveReqId, true);
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.saveRequest.status;
    },
    remoteRelationship: function remoteRelationship() {
      return this.getObjectPath(this.getRequest, 'result.data', {});
    },
    remoteClient: function remoteClient() {
      return this.getObjectPath(this.getRequest, 'result.data.client', {});
    },
    remoteRecord: function remoteRecord() {
      return this.getObjectPath(this.getRequest, 'result.data.record', {});
    },
    pages: function pages() {
      return [{
        title: 'Contact details',
        component: __WEBPACK_IMPORTED_MODULE_1__components_client_ClientContactDetails___default.a,
        withSaveButton: false,
        attrs: {
          value: this.relationship,
          withFetch: false,
          withEdit: true,
          editOnly: true,
          relationshipId: this.relationshipId
        }
      }, {
        title: 'Medical Aid',
        component: __WEBPACK_IMPORTED_MODULE_2__MedicalAidDetails___default.a,
        withSaveButton: true,
        attrs: {
          value: this.medicalaid,
          patientData: this.remoteClient
        }
      }, {
        title: 'More information',
        withSaveButton: true,
        component: __WEBPACK_IMPORTED_MODULE_5__Person___default.a,
        attrs: {
          value: this.patient,
          withTitle: false
        }
      }, {
        title: 'Forms',
        component: __WEBPACK_IMPORTED_MODULE_4__ClientForms___default.a,
        withSaveButton: false,
        attrs: {
          relationshipId: this.relationshipId
        }
      }, {
        title: 'Referrers',
        component: __WEBPACK_IMPORTED_MODULE_3__Referrers___default.a,
        withSaveButton: false,
        attrs: {
          record: this.record
        }
      }];
    },
    medicalaid: function medicalaid() {
      return this.getObjectPath(this.record, 'medical_aid', {});
    },
    patient: function patient() {
      return this.getObjectPath(this.record, 'patient', {});
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    calculatedClasses: function calculatedClasses() {
      if (this.isMobile) {
        return 'mx-0';
      } else {
        return 'mx-4';
      }
    }
  }
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_ObjectForm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_ObjectForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_medicalaid_ObjectForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_BirthdayPicker__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_BirthdayPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_BirthdayPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PhoneNumberInput__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PhoneNumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PhoneNumberInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_medicalaid_PersonList__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_medicalaid_PersonList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_medicalaid_PersonList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);











var MIN_FIELDS = ['date_of_birth', 'billing_address', 'notes'];
var ALL_FIELDS = MIN_FIELDS.concat(['title', 'initials', 'home_phone', 'work_phone', 'passport_number']);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PersonForm',
  components: { ObjectForm: __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_ObjectForm___default.a, BirthdayPicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_BirthdayPicker___default.a, PersonList: __WEBPACK_IMPORTED_MODULE_3__components_medicalaid_PersonList___default.a, PhoneNumberInput: __WEBPACK_IMPORTED_MODULE_2__components_PhoneNumberInput___default.a },
  props: {
    value: { type: Object },
    errors: { type: Object, required: false, default: function _default() {
        return {};
      } },
    withTitle: { type: Boolean, default: true },
    withSearch: { type: Boolean, default: false },
    customFields: { type: Array }
  },
  data: function data() {
    return {
      person: {},
      showAllFields: false,
      titles: __WEBPACK_IMPORTED_MODULE_4__store_constants__["N" /* TITLES */],
      showBdayPicker: false
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.person = this.value;
        }
      }
    },
    person: function person() {
      if (this.person) {
        this.$emit('input', this.person);
      }
    },
    errors: function errors() {
      this.showAllFields = true;
    }
  },
  methods: {
    hasErrors: function hasErrors(field) {
      if (this.errors) {
        return field in this.errors;
      }
      return false;
    },
    getErrors: function getErrors(fieldName) {
      if (fieldName in this.errors) {
        return this.errors[fieldName];
      }
      return [];
    }
  },
  computed: {
    fields: function fields() {
      if (this.customFields) {
        return this.customFields;
      }
      if (this.showAllFields) {
        return ALL_FIELDS;
      }
      return MIN_FIELDS;
    },
    birthdayHint: function birthdayHint() {
      var birthDate = this.getObjectPath(this.person, 'date_of_birth', null);
      if (birthDate) {
        var yrs = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.duration(__WEBPACK_IMPORTED_MODULE_5_moment___default()() - __WEBPACK_IMPORTED_MODULE_5_moment___default()(birthDate)).asYears();
        return 'Exactly ' + yrs + ' years young';
      }
      return 'in the format: YYYY-MM-DD';
    }
  },
  i18n: {
    messages: {
      en: {
        buttons: {
          showmore: 'Show more fields',
          showless: 'Show fewer fields'
        }
      }
    }
  }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PersonListItem__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PersonListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PersonListItem__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PersonList',
  components: { PersonListItem: __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_PersonListItem___default.a },
  props: {
    searchText: { type: String, default: '' },
    people: { type: Array, default: function _default() {
        return [];
      } },
    withEdit: { type: Boolean, default: false },
    request: { type: Object }
  },
  data: function data() {
    return {};
  },

  computed: {
    filteredPeople: function filteredPeople() {
      var _this = this;

      if (!this.people) {
        return [];
      }
      if (this.searchText && this.searchText.length > 1) {
        return this.people.filter(function (item) {
          var index = (item.title + ' ' + item.first_name + ' ' + item.last_name + ' ' + item.email + ' ' + item.cell_phone + ' ' + item.nickname).toLowerCase();
          return index.indexOf(_this.searchText) !== -1;
        });
      }
      return this.people;
    }
  },
  i18n: {
    messages: {
      en: {
        notices: {
          searching: 'Searching on the server ..',
          noresults: 'No contacts found that match your query'
        }
      }
    }
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PersonListItem',
  props: {
    person: { type: Object },
    compact: { type: Boolean, default: false },
    withEdit: { type: Boolean, default: false }
  }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_ReferralPicker__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_ReferralPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_ReferralPicker__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Referrers',
  components: { ReferralPicker: __WEBPACK_IMPORTED_MODULE_0__components_pickers_ReferralPicker___default.a },
  props: {
    record: { type: Object, required: true }
  },
  data: function data() {
    return {
      pickerTouch: 0,
      showReferralPicker: false,
      showRemoveConfirmation: false,
      requests: {
        add: 'record-referrer-add-req',
        edit: 'record-referrer-edit-req',
        get: 'record-get-request',
        remove: 'record-referrer-remove-req'
      },
      markedForDelete: {}
    };
  },

  computed: {
    getRequest: function getRequest() {
      return this.$store.getters.getRequestById(this.requests.get, true);
    },
    addRequest: function addRequest() {
      return this.$store.getters.getRequestById(this.requests.add, true);
    },
    addRequestStatus: function addRequestStatus() {
      return this.addRequest.status;
    },
    removeRequest: function removeRequest() {
      return this.$store.getters.getRequestById(this.requests.remove, true);
    },
    removeRequestStatus: function removeRequestStatus() {
      return this.removeRequest.status;
    },
    editRequest: function editRequest() {
      return this.$store.getters.getRequestById(this.requests.edit, true);
    },
    editRequestStatus: function editRequestStatus() {
      return this.editRequest.status;
    },
    loading: function loading() {
      return this.addRequest.loading || this.removeRequest.loading || this.getRequest.loading || this.editRequest.loading;
    }
  },
  watch: {
    addRequestStatus: function addRequestStatus() {
      if (this.addRequestStatus === 201) {
        this.$emit('reload');
      }
    },
    editRequestStatus: function editRequestStatus() {
      if (this.editRequestStatus === 200) {
        this.$emit('reload');
      }
    },
    removeRequestStatus: function removeRequestStatus() {
      if (this.removeRequestStatus === 204) {
        this.$emit('reload');
        this.showRemoveConfirmation = false;
      }
    },
    showReferralPicker: function showReferralPicker() {
      if (this.showReferralPicker === true) {
        this.pickerTouch++;
      }
    }
  },
  methods: {
    addReferrer: function addReferrer(therapist) {
      var data = {
        record: this.record.id,
        therapist: therapist.id,
        is_current_referrer: true
      };
      this.$medicalaidguru.resource('referrer').id(this.requests.add).create(data);
    },
    removeReferrer: function removeReferrer(referrerId) {
      this.$medicalaidguru.resource('referrer').id(this.requests.remove).delete(referrerId);
    },
    changeCurrent: function changeCurrent(referrer) {
      var data = {
        is_current_referrer: !referrer.is_current_referrer
      };
      this.$medicalaidguru.resource('referrer').id(this.requests.edit).save(referrer.id, data);
    }
  },
  i18n: {
    messages: {
      en: {
        added: 'Added',
        current: 'current',
        buttons: {
          remove: 'Remove'
        },
        dialogs: {
          confirmremove: {
            title: 'Confirm removal',
            notes: {
              p1: 'This will NOT delete the referrer from your database, only unlink it from this record.',
              p2: 'If you would like to keep a history of previous referrers for this record, rather choose: "Not current user"'
            }
          }
        }
      }
    }
  }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TreatmentLogListItem',
  components: {
    PractitionerFaces: __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces_vue___default.a
  },
  props: {
    item: { type: Object, default: function _default() {
        return {};
      } },
    withDelete: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      dialogs: {
        delete: false
      }
    };
  },

  computed: {
    isCurrent: function isCurrent() {
      var now = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local();
      if (this.item.start_date) {
        var start = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(this.item.start_date);
        if (this.item.stop_date) {
          var stop = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(this.item.stop_date);
          return now >= start && now <= stop;
        } else {
          return now >= start;
        }
      }
      return false;
    },
    isOwner: function isOwner() {
      if (this.item.practitioner === this.me.id) {
        return true;
      }
      return false;
    }
  },
  i18n: {
    messages: {
      en: {
        info: {
          auto_on: 'This code will automatically be added to new appointments for this client',
          auto_off: 'This code will NOT automatically be added to new appointments for this client'
        },
        delete: {
          confirm: 'Are you sure you want to remove this item from current treatment and diagnosis?'
        }
      }
    }
  }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentDetail__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentDetail__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentPage',
  components: { AppointmentDetail: __WEBPACK_IMPORTED_MODULE_0__components_appointment_AppointmentDetail___default.a },
  computed: {
    appointmentId: function appointmentId() {
      return this.$route.params.id;
    },
    appointment: function appointment() {
      var vm = this;
      return this.$store.getters.appointments.find(function (appt) {
        return appt.id.toString() === vm.appointmentId;
      });
    }
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_invoice_manage_create_confirm__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_invoice_manage_create_confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_invoice_manage_create_confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_AppointmentPicker_index_vue__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_AppointmentPicker_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_AppointmentPicker_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_appointments__ = __webpack_require__(93);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentsPage',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_appointments__["a" /* default */]],
  components: { ConfirmInvoice: __WEBPACK_IMPORTED_MODULE_0__components_invoice_manage_create_confirm___default.a, AppointmentPicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_AppointmentPicker_index_vue___default.a },
  data: function data() {
    return {
      appointments: [],
      fullscreen: false
    };
  }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BillingPage',
  mounted: function mounted() {
    this.$subscriptionguru.resource('transaction').id(this.requests.transactions).list();
    var params = { ordering: 'scheduled_date', status: 'new' };
    this.$subscriptionguru.resource('scheduledpayment').id(this.requests.payments).list(params);
  },
  data: function data() {
    return {
      requests: {
        transactions: 'transaction-list-req',
        payments: 'payments-upcoming-list-req'
      }
    };
  },

  methods: {
    transactoinUrl: function transactoinUrl(id, tId) {
      return 'https://subscriptionguru.appointmentguru.co/transaction/' + id + '/?key=' + tId;
    }
  },
  computed: {
    transactionRequest: function transactionRequest() {
      return this.$store.getters.getRequestById(this.requests.transactions, true);
    },
    upcomingPaymentsRequest: function upcomingPaymentsRequest() {
      return this.$store.getters.getRequestById(this.requests.payments, true);
    },
    transactions: function transactions() {
      return this.getObjectPath(this.transactionRequest, 'result.data.results', []);
    },
    nextPayment: function nextPayment() {
      var payments = this.getObjectPath(this.upcomingPaymentsRequest, 'result.data.results', []);
      if (payments.length > 0) {
        return payments[0];
      }
    },
    freeTrialDays: function freeTrialDays() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.freeTrial.expires).from();
    },
    freeTrial: function freeTrial() {
      return {
        isActive: true,
        expires: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(6, 'days')
      };
    }
  }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_calendar_PractitionerDayView__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_calendar_PractitionerDayView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_calendar_PractitionerDayView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_calendar_CalendarSettings__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_calendar_CalendarSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_calendar_CalendarSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_calendar_CalendarMixins__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pickers_CalendarTabs__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pickers_CalendarTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pickers_CalendarTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_constants__ = __webpack_require__(2);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CalendarPage',
  components: {
    PractitionerDayView: __WEBPACK_IMPORTED_MODULE_2__components_calendar_PractitionerDayView___default.a,
    CalendarSettings: __WEBPACK_IMPORTED_MODULE_3__components_calendar_CalendarSettings___default.a,
    CalendarTabs: __WEBPACK_IMPORTED_MODULE_5__components_pickers_CalendarTabs___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_requests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_calendar_CalendarMixins__["a" /* default */]],
  data: function data() {
    return {
      reqId: Math.random().toString().split('.')[1],
      selectedDate: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD'),
      selectedEvent: {},
      selectedEvents: {},
      practitioner: null,
      dayWidth: 40,
      settings: {
        density: 1,
        numDays: null
      },
      facets: {
        spaces: {},
        products: {}
      },
      selectedSpace: null,
      bottomsheet: false,
      settingsDialog: false,
      showCalendar: false,
      datePickerType: 'date',
      nonPersistedEvents: [],
      requests: [__WEBPACK_IMPORTED_MODULE_9__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */]],
      flatpickerDateOptions: {
        inline: true,
        altInput: true,
        altFormat: 'D j M'
      },
      calendars: []
    };
  },
  mounted: function mounted() {
    if (window.localStorage && window.localStorage.getItem('ag.calendar.settings')) {
      var settings = JSON.parse(window.localStorage.getItem('ag.calendar.settings'));
      this.settings = settings;
    }
    if (!this.practitioner) {
      this.practitioner = this.me;
    }
    this.refresh();
  },

  watch: {
    appointmentsRequestStatus: function appointmentsRequestStatus() {
      if (this.saveAppointmentRequestStatus === 200) {
        this.refreshing = false;
      }
    },
    saveAppointmentRequestStatus: function saveAppointmentRequestStatus() {
      if (this.saveAppointmentRequestStatus === 201) {
        this.quickCreateDialog = false;
      }
    },
    globalActiveDate: function globalActiveDate() {
      if (this.globalActiveDate) {
        this.selectedDate = this.globalActiveDate;
      }
    },
    globalCalendarDate: function globalCalendarDate() {
      if (this.globalCalendarDate) {
        this.selectedDate = this.globalCalendarDate;
      }
    },
    watchString: function watchString() {
      this.refresh();
    },
    selectedDate: function selectedDate() {
      this.showCalendar = false;

      var startDate = this.monthDates[0];
      if (__WEBPACK_IMPORTED_MODULE_6_moment___default()(startDate).isAfter(__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.daysToShow[0]))) {
        startDate = this.daysToShow[0];
      }

      var endDate = this.monthDates[this.monthDates.length - 1];
      var lastDayToShow = this.daysToShow[this.daysToShow.length - 1];
      if (__WEBPACK_IMPORTED_MODULE_6_moment___default()(endDate).isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(lastDayToShow))) {
        endDate = lastDayToShow;
      }
      endDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(endDate).add(1, 'days').format('YYYY-MM-DD');
      var afterUTC = this.getObjectPath(this.appointmentsRequest, 'params.after_utc');
      var beforeUTC = this.getObjectPath(this.appointmentsRequest, 'params.before_utc');

      var rangeParamsAreDifferent = afterUTC !== startDate || beforeUTC !== endDate;
      if (this.appointmentsRequest && this.appointmentsRequest.params && rangeParamsAreDifferent) {}

      var dayLeft = (__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate).date() + 1) * this.dayWidth;
      var el = document.getElementById('week-view');
      el.scrollLeft = dayLeft - el.clientWidth / 2;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['globalCalendarDate']), {
    now: function now() {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()();
    },
    watchString: function watchString() {
      var practitionerId = this.getObjectPath(this, 'practitioner.id');
      return practitionerId + '-' + this.visibleDates;
    },
    isMyCalendar: function isMyCalendar() {
      if (this.practitioner && this.practitioner.id && this.practitioner.id === this.me.id) {
        return true;
      } else {
        return false;
      }
    },
    nextMonth: function nextMonth() {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate).add(1, 'months');
    },
    lastMonth: function lastMonth() {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate).subtract(1, 'months');
    },
    globalActiveDate: function globalActiveDate() {
      if (this.$store.getters.settings) {
        return this.$store.getters.settings.activeDate;
      }
    },
    visibleDates: function visibleDates() {
      if (this.daysToShow) {
        return [this.daysToShow[0], this.daysToShow[this.daysToShow.length - 1]];
      }
      return [];
    },
    route: function route() {
      return this.$route.path;
    },
    appointmentsRequest: function appointmentsRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_9__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */]);
    },
    appointmentsRequestStatus: function appointmentsRequestStatus() {
      return this.appointmentsRequest.status;
    },
    saveAppointmentRequest: function saveAppointmentRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    saveAppointmentRequestStatus: function saveAppointmentRequestStatus() {
      return this.saveAppointmentRequest.status;
    },
    daysToShow: function daysToShow() {
      if (this.$vuetify.breakpoint.xs) {
        return [this.selectedDate];
      }
      var yesterday = __WEBPACK_IMPORTED_MODULE_6_moment___default()(__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate).subtract(1, 'days'));
      var numDays = 5;
      if (this.$vuetify.breakpoint.lgAndUp) {
        numDays = 7;
      }

      if (this.settings.numDays) {
        numDays = this.settings.numDays;
      }
      var days = [];
      for (var x = 0; x < numDays; x++) {
        days.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(yesterday).add(x, 'days').format('YYYY-MM-DD'));
      }
      return days;
    },
    monthDates: function monthDates() {
      var days = [];
      var dt = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate);
      var monthEnd = __WEBPACK_IMPORTED_MODULE_6_moment___default()(dt.endOf('month'));

      var currentDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(dt.startOf('month'));
      while (currentDate.isSameOrBefore(monthEnd)) {
        var day = currentDate.format('YYYY-MM-DD');
        days.push(day);
        currentDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(currentDate).add(1, 'days');
      }
      return days;
    }
  }),
  methods: {
    doShowCalendar: function doShowCalendar() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'date';

      this.showCalendar = visible;
      this.datePickerType = type;
    },
    setDate: function setDate(dt) {
      this.selectedDate = dt;
      console.log(this.selectedDate, dt);
    },
    setFacets: function setFacets(facets) {
      this.facets = facets;
    },
    setSelectedSpace: function setSelectedSpace(spaceId) {
      this.selectedSpace = spaceId;
    },
    setMultiSelect: function setMultiSelect(event) {
      if (event && event.id) {
        var selected = true;
        if (event.selected === true) {
          selected = false;
        }
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(event, 'selected', selected);
        if (event.id in this.selectedEvents) {
          delete this.selectedEvents[event.id];
        } else {
          this.selectedEvents[event.id] = event;
        }
      }
    },
    slotSelected: function slotSelected(event) {
      var _this = this;

      var vm = this;
      if (!this.practitioner) {
        this.practitioner = this.me;
      }
      setTimeout(function () {
        vm.$store.commit(__WEBPACK_IMPORTED_MODULE_9__store_constants__["j" /* SET_SETTING */], ['startTime', event.start_time]);
        vm.$store.commit(__WEBPACK_IMPORTED_MODULE_9__store_constants__["j" /* SET_SETTING */], ['activePractitioner', _this.practitioner]);
      }, 1000);
      this.openGlobalDialog(true, 'QuickCreate');
    },
    timeStringToMoment: function timeStringToMoment(timeString) {
      if (!timeString) {
        console.warn('string passed to timeStringToMoment is null');
        return __WEBPACK_IMPORTED_MODULE_6_moment___default()();
      }
      if (timeString.length === 4) {
        timeString = '0' + timeString;
      }
      var dt = this.selectedDate;
      if (!this.selectedDate) {
        dt = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
      }
      var dateString = dt + ' ' + timeString;
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(dateString);
    },
    changeMonth: function changeMonth(count) {
      var dt = null;
      if (count > 0) {
        console.log('add');
        dt = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate).add(count, 'months');
      } else {
        var positive = count * -1;
        dt = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate).subtract(positive, 'months');
      }
      this.selectedDate = dt.startOf('month').format('YYYY-MM-DD');
      var end = dt.endOf('month');
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__store_constants__["v" /* SET_ACTIVE_DATE_RANGE */], [this.selectedDate, end]);
    },
    gotoToday: function gotoToday() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
    },
    dateMath: function dateMath(change, period) {
      if (change > 0) {
        this.selectedDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate).add(change, period).format('YYYY-MM-DD');
        var el = document.getElementById('week-view');
        el.scrollLeft = el.scrollLeft + this.dayWidth;
      }
      if (change < 0) {
        change = change * -1;
        this.selectedDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedDate).subtract(change, period).format('YYYY-MM-DD');
        var _el = document.getElementById('week-view');
        _el.scrollLeft = _el.scrollLeft - this.dayWidth;
      }
    },
    isToday: function isToday(day) {
      return day === __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
    },
    isActive: function isActive(day) {
      return day === this.selectedDate;
    },
    isVisible: function isVisible(day) {
      return this.daysToShow.indexOf(day) !== -1;
    },
    appointmentCount: function appointmentCount(day) {
      return this.$store.getters.activeAppointments.filter(function (item) {
        var appDay = __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.start_time).format('YYYY-MM-DD');
        if (item.status === 'B') {
          return false;
        }
        return appDay === day.format('YYYY-MM-DD');
      }).length;
    },
    showQuickCreate: function showQuickCreate(event) {
      this.selectedEvent = event;
      this.quickCreateDialog = true;
    },
    deleteEvent: function deleteEvent(event) {
      this.nonPersistedEvents = this.nonPersistedEvents.filter(function (evt) {
        return evt.id !== event.id;
      });
    },
    eventClicked: function eventClicked(event) {
      this.bottomsheet = true;
    },
    refresh: function refresh(initial) {
      if (initial === true) {
        return false;
      }
      var start = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.daysToShow[0]).format('YYYY-MM-DD');
      var end = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.daysToShow[this.daysToShow.length - 1]).format('YYYY-MM-DD');
      if (!end) {
        end = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.monthDates[this.monthDates.length - 1]);
      }

      this.setGlobalActiveDateRange(start, end);

      this.getPractitionerCalendar();
    },
    testRemove: function testRemove() {
      this.$store.commit('removeAppointment', 169789);
    },
    testAddAppt: function testAddAppt() {
      var appt = {
        'id': 169789,
        'start_time': '2021-06-05T10:00:00Z',
        'tags': null,
        'end_time': '2021-06-05T10:50:00Z',
        'title': 'Test event',
        'full_name': 'Test event',
        'client': 44385,
        'practitioner_name': 'Sarah Smith',
        'practitioner': 412,
        'space': 271,
        'service_name': 'Eatwell Dieticians',
        'space_color': 'purple',
        'product': 506,
        'product_name': 'Consultation',
        'product_color': 'green',
        'address_name': 'Eatwell Dieticians, Pretoria',
        'is_recurring': true,
        'status': 'N',
        'status_formatted': 'New',
        'currency': 'ZAR',
        'price': '368.20',
        'notes': null,
        'is_online': false,
        'invoice_description': 'Treated by: Sarah Smith (DT12345678) at Eatwell Dieticians',
        'invoice_title': null,
        'invoiceable': false,
        'done': false,
        'dt': '2021-06-05',
        'start': '12:00',
        'end': '12:50',
        'duration': 50
      };
      this.$store.commit('addAppointments', [appt]);
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_ClientDetails__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_ClientDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_client_ClientDetails__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientPage',
  components: { ClientDetails: __WEBPACK_IMPORTED_MODULE_0__components_client_ClientDetails___default.a },
  data: function data() {
    return {
      clientNotFound: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var vm = this;
    window.setTimeout(function () {
      if (!_this.clientId) {
        vm.clientNotFound = true;
      }
    }, 5000);
  },

  watch: {
    relationshipId: {
      immediate: true,
      handler: function handler() {
        if (!this.client || !this.client.id) {
          this.searchClients(this.relationshipId);
        }
      }
    },
    userId: {
      immediate: true,
      handler: function handler() {
        if (!this.client || !this.client.id) {
          this.searchClients(this.userId);
        }
      }
    },
    clientId: function clientId() {
      if (!this.clientId) {
        var vm = this;
        window.setTimeout(function () {
          vm.clientNotFound = true;
        }, 1500);
      } else {
        this.clientNotFound = false;
      }
    }
  },
  computed: {
    loading: function loading() {
      if (this.getClientSearchReq.loading === true) {
        return true;
      }
      return false;
    },
    relationshipId: function relationshipId() {
      return this.$route.params.relationshipId;
    },
    userId: function userId() {
      return this.$route.params.id;
    },
    clientId: function clientId() {
      return this.getObjectPath(this.client, 'id');
    },
    client: function client() {
      var vm = this;
      var userId = vm.$route.params.id;
      var relationshipId = this.relationshipId;
      if (relationshipId) {
        return this.getRelationById(relationshipId);
      }
      if (userId) {
        return this.getRelationByClientId(userId);
      }
    }
  },
  methods: {
    get: function get() {
      if (this.relationshipId) {
        this.searchClients(this.relationshipId);
      } else {
        return this.searchClients(this.userId);
      }
    }
  }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientActionMenu__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientActionMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_ClientActionMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_lists_BirthdayBar__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_lists_BirthdayBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_lists_BirthdayBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_constants__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientHome',
  components: { ClientListItem: __WEBPACK_IMPORTED_MODULE_1__components_client_ClientListItem___default.a, ClientActionMenu: __WEBPACK_IMPORTED_MODULE_2__components_client_ClientActionMenu___default.a, BirthdayBar: __WEBPACK_IMPORTED_MODULE_3__components_lists_BirthdayBar___default.a },
  data: function data() {
    return {
      displayLimit: 20,
      appointmentsByClient: {},
      requests: {
        appointmentInRange: __WEBPACK_IMPORTED_MODULE_4__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */]
      },
      downloading: false
    };
  },
  mounted: function mounted() {
    this.getActiveClients();
  },

  methods: {
    addPriceDetails: function addPriceDetails(li, appt) {
      if (appt.price) {
        var price = parseFloat(appt.price);
        if (appt.status === 'P') {
          li.totalPaid += price;
        } else {
          li.totalOwed += price;
        }
      }
    },
    download: function download() {
      var _this = this;

      this.downloading = true;
      var path = '/api/v3/practitioner/practitioners/export_clients/';
      var base = this.$appointmentguru.baseUrl;
      var headers = this.$appointmentguru.headers;
      var url = '' + base + path;
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: url,
        headers: headers,
        method: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        _this.downloading = false;
        link.href = url;
        link.setAttribute('download', 'client-list.csv');
        document.body.appendChild(link);
        link.click();
      }).catch(function () {
        window.alert('There was a problem tying to create your download');
        _this.downloading = false;
      });
    },
    gotoClient: function gotoClient(clientId) {
      var rel = this.getRelationByClientId(clientId);
      var path = '/clients/' + clientId;
      if (rel && rel.id) {
        path = '/clients/r/' + rel.id;
      }
      this.$router.push(path);
    }
  },
  computed: {
    visibleClients: function visibleClients() {
      return this.clientsInRange.slice(0, this.displayLimit);
    },
    clientsInRange: function clientsInRange() {
      var clients = [];
      var vm = this;
      vm.appointmentsByClient = {};

      this.appointments.map(function (appt) {
        if (clients.indexOf(appt.client) === -1) {
          clients.push(appt.client);
        }
        try {
          vm.appointmentsByClient[appt.client].push(appt);
          vm.addPriceDetails(vm.appointmentsByClient[appt.client], appt);
        } catch (e) {
          vm.appointmentsByClient[appt.client] = [];
          vm.appointmentsByClient[appt.client].push(appt);
          vm.appointmentsByClient[appt.client].totalOwed = 0;
          vm.appointmentsByClient[appt.client].totalPaid = 0;
          vm.addPriceDetails(vm.appointmentsByClient[appt.client], appt);
        }
      });
      return clients;
    },
    getClientsRequest: function getClientsRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_4__store_constants__["d" /* LIST_CLIENTS_REQ */], true);
    },
    appointments: function appointments() {
      return this.$store.getters.activeAppointments;
    }
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageToolbar__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_ClientHome__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_ClientHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_ClientHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_client_ClientDetails__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_client_ClientDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_client_ClientDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_client_ClientList__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_client_ClientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_client_ClientList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_client_Create__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_client_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_client_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientsPage',

  components: { ClientListItem: __WEBPACK_IMPORTED_MODULE_2__components_client_ClientListItem___default.a, ClientDetails: __WEBPACK_IMPORTED_MODULE_4__components_client_ClientDetails___default.a, Create: __WEBPACK_IMPORTED_MODULE_6__components_client_Create___default.a, PageToolbar: __WEBPACK_IMPORTED_MODULE_1__components_PageToolbar___default.a, ClientHome: __WEBPACK_IMPORTED_MODULE_3__components_pages_ClientHome___default.a, ClientList: __WEBPACK_IMPORTED_MODULE_5__components_client_ClientList___default.a },
  data: function data() {
    return {
      reqId: __WEBPACK_IMPORTED_MODULE_7__store_constants__["d" /* LIST_CLIENTS_REQ */],
      selectedClient: {},
      selectedSpaceId: null,
      searchString: '',
      create: true,
      maxItems: 30,
      page: 10
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['spaces']), {
    clients: function clients() {
      return this.$store.getters.clients;
    },
    filteredClients: function filteredClients() {
      var clients = this.clients;
      var vm = this;
      if (vm.searchString && vm.searchString.length > 0) {
        clients = clients.filter(function (clientRel) {
          if (clientRel.client) {
            var client = clientRel.client;
            var index = client.first_name + ' ' + client.last_name + ' ' + client.email + ' ' + client.phone_number;
            return index.toLowerCase().indexOf(vm.searchString.toLowerCase()) !== -1;
          }
        });
      }
      clients = clients.slice(0, this.maxItems);
      return clients;
    }
  }),
  methods: {
    homeClicked: function homeClicked() {
      this.selectedClient = {};
      var width = document.defaultView.innerWidth;
      if (width < __WEBPACK_IMPORTED_MODULE_7__store_constants__["u" /* SMALL_BREAKPOINT */]) {
        this.$router.push('/clients/home');
      }
    },
    clientClicked: function clientClicked(client) {
      this.selectedClient = client;
      var width = document.defaultView.innerWidth;
      if (width < __WEBPACK_IMPORTED_MODULE_7__store_constants__["u" /* SMALL_BREAKPOINT */]) {
        this.$router.push('/clients/r/' + client.id);
      }
    },
    firstLetter: function firstLetter(message) {
      if (message) {
        return message.substr(0, 1);
      }
    },
    reload: function reload() {
      this.getClients();
    },
    addFilter: function addFilter(space) {
      if (this.selectedSpaceId === space.id) {
        this.selectedSpaceId = null;
      } else {
        this.selectedSpaceId = space.id;
      }
    }
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_appointments__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statement__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_statement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ActiveClients__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ActiveClients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_ActiveClients__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FinancialsPage',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_appointments__["a" /* default */]],
  components: {
    Statement: __WEBPACK_IMPORTED_MODULE_1__components_statement___default.a,
    ActiveClients: __WEBPACK_IMPORTED_MODULE_2__components_client_ActiveClients___default.a
  },
  data: function data() {
    return {
      drawer: true,
      actionItems: ['appointment_codes', 'show_payment'],
      statusFilters: [],
      excludeFilters: [],
      appointment: {},
      selectedAppointments: [],
      selectedClient: {},
      activeIndex: -1,
      statementRequestId: 'statement-detail-request'
    };
  },

  computed: {
    activeClientParams: function activeClientParams() {},
    statementRequest: function statementRequest() {
      return this.$store.getters.getRequestById(this.statementRequestId, true);
    },
    statement: function statement() {
      return this.getObjectPath(this.statementRequest, 'result.data', {});
    },
    baseParams: function baseParams() {
      return {
        from_date: this.globalActiveDateRange.from,
        to_date: this.globalActiveDateRange.to
      };
    },
    menuItems: function menuItems() {
      return this.getAppointmentActionItemsByKeyList(this.actionItems);
    }
  },
  watch: {
    activeIndex: function activeIndex() {
      this.getStatement();
    },
    globalActiveDateRangeFormatted: function globalActiveDateRangeFormatted() {
      this.getStatement();
    }
  },
  methods: {
    setSelectedClient: function setSelectedClient(relationship, index) {
      this.selectedClient = relationship;
      this.activeIndex = index;
      if (this.$vuetify.breakpoint.xs) {
        this.drawer = false;
      }
    },
    getStatement: function getStatement(params) {
      if (!params) {
        params = this.baseParams;
      }
      this.selectedAppointments = [];
      this.$appointmentguru.resource('v3.statement').id(this.statementRequestId).get(this.selectedClient.client.id, params);
    },
    actionClicked: function actionClicked(action, appointment) {
      appointment.client = this.selectedClient;
      this.appointment = appointment;
      action.onclick(appointment);
    },
    updateSelectedAppointments: function updateSelectedAppointments(selected) {
      this.selectedAppointments = selected;
    }
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Detail__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_calendar_Schedule__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_calendar_Schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_calendar_Schedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lists_BirthdayBar__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lists_BirthdayBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_lists_BirthdayBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_constants__ = __webpack_require__(2);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomePage',
  components: { Schedule: __WEBPACK_IMPORTED_MODULE_3__components_calendar_Schedule___default.a, HomeDetail: __WEBPACK_IMPORTED_MODULE_2__components_home_Detail___default.a, BirthdayBar: __WEBPACK_IMPORTED_MODULE_4__components_lists_BirthdayBar___default.a },
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
      ready: false,
      viewHomePage: true,
      activeClient: null,
      currentAppointment: null,

      date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),
      reqIds: {
        list: 'homepage-list-request'
      }
    };
  },
  mounted: function mounted() {
    this.refresh();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['me', 'isLoggedIn']), {
    showScheduleBlock: function showScheduleBlock() {
      if (this.appPlatform === 'ios' && this.$vuetify.breakpoint.sm) {
        return false;
      }
      return true;
    },
    appointmentsRequest: function appointmentsRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_6__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */], true);
    },
    appointmentsRequestModified: function appointmentsRequestModified() {
      return this.appointmentsRequest.modified;
    },
    scheduleRequest: function scheduleRequest() {
      var result = this.$store.getters.getRequestById(this.reqIds.list, true);
      return result;
    },
    homepage: function homepage() {
      return this.getObjectPath(this.scheduleRequest, 'result.data', {});
    }
  }),
  watch: {
    '$route': 'refresh',
    date: function date() {
      this.getSchedule();
    },
    appointmentsRequestModified: function appointmentsRequestModified() {
      this.getSchedule();
    },
    currentAppointment: function currentAppointment() {
      var activeClientId = null;
      if (this.activeClient) {
        activeClientId = this.activeClient.id;
      }
      if (this.currentAppointment && this.currentAppointment.client && this.currentAppointment.client !== activeClientId) {
        this.activeClient = {
          id: this.currentAppointment.client,
          client: {}
        };
      }
    }
  },
  methods: {
    refresh: function refresh() {
      this.getSchedule();
    },
    getSchedule: function getSchedule() {
      var params = { date: this.date };
      this.$appointmentguru.resource('home').id(this.reqIds.list).list(params);
    },
    getAppointment: function getAppointment(appointmentId) {
      this.$appointmentguru.resource('home').id(this.reqIds.detail).get(appointmentId);
    },
    setCurrentAppointment: function setCurrentAppointment(appointment) {
      this.viewHomePage = false;
      this.currentAppointment = appointment;

      if (this.$vuetify.breakpoint.xsOnly) {}
    },
    setCurrentAppointmentById: function setCurrentAppointmentById(appointmentId) {
      this.viewHomePage = false;
      this.getAppointment(appointmentId);
      if (this.$vuetify.breakpoint.xsOnly) {
        this.listSpaceIndex = 1;
      }
    },
    chartClicked: function chartClicked(point) {
      if (point && point.x) {
        this.setDate(point.x);
      }
    },
    setDate: function setDate(date) {
      this.date = date;
    },
    changeDate: function changeDate(count) {
      this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).add(count, 'days').format('YYYY-MM-DD');
    },
    gotoToday: function gotoToday() {
      this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
    }
  },
  i18n: {
    messages: {
      en: {
        cards: {
          schedule: {
            title: ''
          }
        }
      }
    }
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IntegrationsList',
  data: function data() {
    return {
      integrations: [],
      requests: {
        list: {
          resource: 'ag.integrations',
          extra: 'list'
        }
      }
    };
  },
  mounted: function mounted() {
    this.getIntegrations();
  },

  methods: {
    isInstalled: function isInstalled(integration) {
      if (this.installed) {
        return this.installed.find(function (item) {
          return item.title === integration.title;
        });
      }
      return false;
    },
    getIntegrations: function getIntegrations() {
      this.$request('get', this.requests.list);
    }
  },
  computed: {
    visibleIntegrations: function visibleIntegrations() {
      var integrations = this.getObjectPath(this.requests.list, 'result', []);
      return integrations.filter(function (integration) {
        return integration.visible;
      });
    },
    installed: function installed() {
      var lookups = this.$store.getters.lookups;
      return this.getObjectPath(lookups, 'integrations', []);
    }
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_SubmissionListItem__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_SubmissionListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_listitems_SubmissionListItem__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignSubmission',
  components: { SubmissionListItem: __WEBPACK_IMPORTED_MODULE_0__components_listitems_SubmissionListItem___default.a },
  props: {
    relationshipId: { required: true },
    title: { type: String, default: 'Choose a submission to link' }
  },
  data: function data() {
    return {
      window: 0,
      requests: {
        get: {
          resource: 'ag.integrations',
          params: { unlinked: true },
          extra: 'jotform/submissions'
        },
        assign: {
          resource: 'ag.integrations',
          extra: 'jotform/assign_submission'
        }
      }
    };
  },
  mounted: function mounted() {
    this.get();
  },

  computed: {
    submissions: function submissions() {
      return this.getObjectPath(this.requests.get, 'result', []);
    }
  },
  methods: {
    get: function get() {
      this.$request('get', this.requests.get);
    },
    assign: function assign(submission) {
      this.requests.assign.data = {
        relationship_id: this.relationshipId,
        submission_id: submission.submission_id,
        form_id: submission.form
      };
      this.requests.assign.method = 'post';
      this.$request('save', this.requests.assign);
    },
    assignSuccess: function assignSuccess(result) {
      this.get();
      this.$emit('ok', result);
    }
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_RequestStatus__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MailchimpChip',
  props: {
    email: { type: String, required: true },
    relationshipId: { required: true },
    menuAttrs: { type: Object, required: false, default: function _default() {} }
  },
  components: { RequestStatus: __WEBPACK_IMPORTED_MODULE_0__components_ui_RequestStatus___default.a },
  data: function data() {
    return {
      visible: false,
      requests: {
        get: {
          resource: 'ag.integrations',
          extra: 'mailchimp/member',
          result: {}
        },
        save: {
          resource: 'ag.integrations',
          extra: 'mailchimp/member',
          result: {}
        }
      }
    };
  },

  watch: {
    visible: function visible() {
      if (this.visible) {
        this.get();
      }
    },
    saveStatus: function saveStatus() {
      if (this.saveStatus === 200) {
        this.get();
      }
    }
  },
  methods: {
    get: function get() {
      this.requests.get.params = { email: this.email };
      this.$request('get', this.requests.get);
    },
    save: function save() {
      this.requests.save.data = {
        relationship_id: this.relationshipId,
        mailchimp_id: this.member.id
      };
      console.log(this.requests.save.data);
      this.$request('save', this.requests.save);
    },
    asPercent: function asPercent(val) {
      if (val) {
        return Math.round(val * 100);
      }
      return 0;
    }
  },
  computed: {
    member: function member() {
      return this.requests.get.result;
    },
    saveStatus: function saveStatus() {
      return this.requests.save.status;
    },
    mailchimpURL: function mailchimpURL() {
      if (this.member && this.member._links && this.member._links.length > 0) {
        var url = this.member._links[0].targetSchema;
        var urlBits = url.split('/schema/');
        var path = '/lists/members/view?id=';
        if (urlBits.length > 0) {
          var base = urlBits[0].replace('.api.', '.admin.');
          return '' + base + path + this.member.web_id;
        }
      }
    }
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdherenceProgress',
  props: {
    value: { required: true, type: Number }
  },
  computed: {
    percent: function percent() {
      if (this.value) {
        return Math.round(this.value);
      }
      return 0;
    }
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignProgram',
  props: {
    physitrackClientId: { required: true },
    value: { type: Object, required: true },
    hasActiveProgram: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      search: '',
      assignDialog: false,
      showdatepicker: false,
      today: null,
      selectedTemplate: {},
      timeout: null,
      requests: {
        templates: {
          resource: 'ag.integrations',
          extra: 'physitrack/templates',
          result: {}
        },
        assign: {
          resource: 'ag.integrations',
          extra: 'physitrack/program',
          result: {}
        }
      },
      program: {
        'client_id': null,
        'template_id': null,
        'start_date': null,
        'num_weeks': 2,
        'track_adherence': true,
        'track_pain_levels': true,
        'skip_access_code': false
      }
    };
  },
  mounted: function mounted() {
    this.today = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local().toISODate();
    this.program.start_date = this.today;
    this.program.client_id = this.physitrackClientId;
    this.getTemplates();
  },

  watch: {
    selectedTemplate: function selectedTemplate() {
      if (this.selectedTemplate) {
        this.program.template_id = this.selectedTemplate.id;
      }
    },
    physitrackClientId: function physitrackClientId() {
      this.program.client_id = this.physitrackClientId;
    },
    assignStatus: function assignStatus() {
      if (this.assignStatus === 201) {
        this.$emit('assigned', this.requests.assign.result);
      }
    },
    assignDate: function assignDate() {
      this.showdatepicker = false;
    }
  },
  computed: {
    templates: function templates() {
      return this.getObjectPath(this.requests, 'templates.result.templates', []);
    },
    assignStatus: function assignStatus() {
      return this.requests.assign.status;
    },
    assignDate: function assignDate() {
      return this.program.start_date;
    }
  },
  methods: {
    debounceTemplates: function debounceTemplates() {
      if (this.search && this.search.length > 0) {
        if (this.timeout) {
          window.clearTimeout(this.timeout);
        }
        this.timeout = window.setTimeout(this.getTemplates, 1000);
      }
    },
    getTemplates: function getTemplates() {
      this.requests.templates.params = { search: this.search };
      this.$request('get', this.requests.templates);
    },
    assign: function assign() {
      this.requests.assign.data = this.program;
      this.$request('save', this.requests.assign);
    },
    selectedClass: function selectedClass(template, selected) {
      if (template.id === selected.id) {
        return 'blue lighten-5';
      }
    }
  }
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdherenceProgress_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdherenceProgress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AdherenceProgress_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExerciseListItem',
  components: { AdherenceProgress: __WEBPACK_IMPORTED_MODULE_0__AdherenceProgress_vue___default.a },
  props: {
    value: { type: Object, required: true }
  },
  data: function data() {
    return {
      exercise: {},
      fields: ['reps', 'rpe', 'sets', 'hold', 'thr', 'weight']
    };
  },

  methods: {
    getField: function getField(field) {
      if (field in this.value && this.value[field]) {
        return this.value[field];
      }
      return null;
    },
    getAdherence: function getAdherence(field) {
      var assignedField = field + '_assigned';
      var completedField = field + '_completed';
      if (assignedField in this.value && completedField in this.value) {
        return this.value[completedField] + '/' + this.value[assignedField];
      }
      return null;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.exercise = this.value;
        }
      }
    }
  }
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PhysiMessages',
  props: {
    physitrackClientId: { required: true },
    messages: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      message: '',
      sendRequest: {
        resource: 'ag.integrations',
        extra: 'physitrack/sendmessage'
      },
      newMessages: []
    };
  },

  watch: {
    sendStatus: function sendStatus() {
      if (this.sendStatus === 201) {
        this.$emit('new');
      }
    },
    messages: function messages() {
      this.newMessages = [];
    }
  },
  computed: {
    allMessages: function allMessages() {
      return this.messages.concat(this.newMessages);
    },
    sendStatus: function sendStatus() {
      return this.sendRequest.status;
    },
    sendErrors: function sendErrors() {
      if (this.sendStatus === 422) {
        console.log(this.sendRequest.errors);
        return this.getObjectPath(this.sendRequest, 'errors.errors', []);
      }
      return [];
    }
  },
  methods: {
    t: function t() {
      this.$emit('new');
    },
    send: function send(e) {
      if (e && e.shiftKey === true) {
        return null;
      }
      var message = {
        sender_type: 'practitioner',
        body: this.message,
        persisted: false
      };
      this.newMessages.push(message);
      this.sendRequest.data = {
        client_id: this.physitrackClientId,
        message: this.message
      };
      this.$request('save', this.sendRequest);
    }
  }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PhysitrackClientListItem',
  props: {
    value: { type: Object, required: true }
  }
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhysitrackClientListItem_vue__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhysitrackClientListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PhysitrackClientListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Programs_vue__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Programs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Programs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_RequestStatus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_RequestStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_RequestStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PhysitrackEmbed',
  components: { Programs: __WEBPACK_IMPORTED_MODULE_1__Programs_vue___default.a, PhysitrackClientListItem: __WEBPACK_IMPORTED_MODULE_0__PhysitrackClientListItem_vue___default.a, RequestStatus: __WEBPACK_IMPORTED_MODULE_2__components_ui_RequestStatus_vue___default.a },
  props: {
    relationshipId: { required: true }
  },
  data: function data() {
    return {
      isValid: false,
      search: '',
      visible: false,
      physiTouch: 0,
      lastName: '',
      date_of_birth: '',
      searchTimeout: false,
      rules: {
        required: function required(value) {
          return !!value || 'Please provide a date of birth';
        },
        validDate: function validDate(value) {
          var res = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, 'YYYY-MM-DD', true).isValid();
          if (!res) {
            return 'Enter a date in the format YYYY-MM-DD';
          }
          return res;
        }
      },
      requests: {
        get: {
          resource: 'ag.integrations',
          extra: 'physitrack/client',
          result: {}
        },
        clients: {
          resource: 'ag.integrations',
          extra: 'physitrack/clients',
          result: {}
        },
        create: {
          resource: 'ag.integrations',
          extra: 'physitrack/client'
        },
        link: {
          resource: 'ag.integrations',
          extra: 'physitrack/link'
        }
      },
      physitrackClient: {}
    };
  },

  watch: {
    dob: function dob() {
      this.date_of_birth = this.dob;
    },
    visible: function visible() {
      if (this.visible) {
        this.requests.get.result = {};
        this.physitrackClient = {};
        this.get();
      }
    },
    getStatus: function getStatus() {
      if (this.getStatus === 200) {
        if (this.clientlist.length > 0) {
          this.physitrackClient = this.clientlist[0];
        }
      }
      var isNewClient = this.getStatus === 404;
      if (isNewClient) {
        this.getClients(this.lastName);
      }
    },
    createStatus: function createStatus() {
      if (this.getStatus >= 200) {
        if (this.newclient && this.newclient.id) {
          this.physitrackClient = this.newclient;
        }
      }
    },
    linkStatus: function linkStatus() {
      if (this.linkStatus >= 200) {
        if (this.linkedclient && this.linkedclient.id) {
          this.physitrackClient = this.linkedclient;
        }
      }
    },

    relationshipLastName: {
      immediate: true,
      handler: function handler() {
        this.lastName = this.relationshipLastName;
      }
    }
  },
  computed: {
    getStatus: function getStatus() {
      return this.requests.get.status;
    },
    createStatus: function createStatus() {
      return this.requests.create.status;
    },
    linkStatus: function linkStatus() {
      return this.requests.link.status;
    },
    clientlist: function clientlist() {
      return this.getObjectPath(this.requests, 'get.result.clients', []);
    },
    newclient: function newclient() {
      return this.getObjectPath(this.requests, 'create.result', {});
    },
    linkedclient: function linkedclient() {
      return this.getObjectPath(this.requests, 'link.result', {});
    },
    physitrackClientId: function physitrackClientId() {
      if (this.physitrackClient && this.physitrackClient.id) {
        return this.physitrackClient.id;
      }
      return null;
    },
    relationship: function relationship() {
      var req = this.$store.getters.getRequestById('get-relationship-request', true);
      return this.getObjectPath(req, 'result.data', {});
    },
    relationshipFirstName: function relationshipFirstName() {
      return this.getObjectPath(this.relationship, 'client.first_name', false);
    },
    relationshipLastName: function relationshipLastName() {
      return this.getObjectPath(this.relationship, 'client.last_name', false);
    },
    dob: function dob() {
      return this.getObjectPath(this.relationship, 'record.patient.date_of_birth', false);
    },
    clients: function clients() {
      return this.getObjectPath(this.requests, 'clients.result.clients', []);
    },
    createClientErrors: function createClientErrors() {
      return this.getObjectPath(this.requests.create, 'error', {});
    }
  },
  methods: {
    get: function get() {
      this.requests.get.params = { relationship_id: this.relationshipId };
      this.$request('get', this.requests.get);
    },
    getClients: function getClients(lastName) {
      if (!lastName) {
        lastName = this.lastName;
      }
      this.requests.clients.params = { last_name: lastName };
      this.$request('get', this.requests.clients);
    },
    create: function create() {
      this.requests.create.data = {
        relationship: this.relationshipId,
        date_of_birth: this.date_of_birth
      };
      this.$request('save', this.requests.create);
    },
    debounceSearch: function debounceSearch() {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.requests.clients, 'status', 0);
      if (this.searchTimeout) {
        window.clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = window.setTimeout(this.getClients, 1000);
    },
    link: function link(physitrackId) {
      this.requests.link.data = {
        relationship_id: this.relationshipId,
        physitrack_id: physitrackId
      };
      this.$request('save', this.requests.link);
    }
  }
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_Tombstone__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_Tombstone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_app_Tombstone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExerciseListItem_vue__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExerciseListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ExerciseListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdherenceProgress_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdherenceProgress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AdherenceProgress_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Messages_vue__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Messages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Messages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_CopyTextField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_CopyTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_CopyTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Program',
  components: { CopyTextField: __WEBPACK_IMPORTED_MODULE_5__components_ui_CopyTextField___default.a, ExerciseListItem: __WEBPACK_IMPORTED_MODULE_2__ExerciseListItem_vue___default.a, AdherenceProgress: __WEBPACK_IMPORTED_MODULE_3__AdherenceProgress_vue___default.a, Messages: __WEBPACK_IMPORTED_MODULE_4__Messages_vue___default.a, Tombstone: __WEBPACK_IMPORTED_MODULE_1__components_app_Tombstone___default.a },
  props: {
    value: { type: Object, required: true },
    physitrackClientId: { required: true },
    dateOfBirth: { required: true }
  },
  data: function data() {
    return {
      program: {},
      activeTab: 0,
      selectedDate: null,
      downloading: false,
      requests: {
        send: {
          resource: 'ag.integrations',
          extra: 'physitrack/program',
          result: {},
          status: 0
        },
        exercises: {
          resource: 'ag.integrations',
          extra: 'physitrack/program_exercises',
          result: {}
        },
        adherence: {
          resource: 'ag.integrations',
          extra: 'physitrack/adherence',
          result: {}
        },
        messages: {
          resource: 'ag.integrations',
          extra: 'physitrack/messages',
          result: {}
        }
      }
    };
  },
  mounted: function mounted() {
    this.selectedDate = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local().toISODate();
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.program = this.value;
        }
      }
    },
    activeTab: function activeTab() {
      if (this.activeTab === 1) {
        this.getExercises();
      }
      if (this.activeTab === 2) {
        this.getAdherence();
      }
      if (this.activeTab === 3) {
        this.getMessages();
      }
    }
  },
  methods: {
    getAdherence: function getAdherence() {
      this.requests.adherence.params = this.programParams;
      this.$request('get', this.requests.adherence);
    },
    getExercises: function getExercises() {
      this.requests.exercises.params = this.programParams;
      this.$request('get', this.requests.exercises);
    },
    getMessages: function getMessages() {
      this.requests.messages.params = this.programParams;
      this.$request('get', this.requests.messages);
    },
    send: function send(accessCode) {
      this.requests.send.params = {
        client_id: this.physitrackClientId,
        access_code: accessCode,
        suffix: 'resend'
      };
      this.$request('get', this.requests.send);
    },
    download: function download(accessCode) {
      var _this = this;

      var path = '/api/v2/practitioner/integrations/physitrack/program/';
      var url = '' + this.$appointmentguru.baseUrl + path;
      var method = 'GET';
      var headers = this.$appointmentguru.headers;
      var params = {
        client_id: this.physitrackClientId,
        access_code: accessCode,
        pdf: true
      };
      headers['Content-Type'] = 'application/pdf';

      this.downloading = true;
      __WEBPACK_IMPORTED_MODULE_6_axios___default()({ url: url, method: method, params: params, headers: headers, responseType: 'arraybuffer' }).then(function (response) {
        console.log(response.data);
        var url = window.URL.createObjectURL(new Blob([response.data], { 'type': 'application/pdf' }));

        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'program.pdf');
        document.body.appendChild(link);
        link.click();
        _this.downloading = false;
      }).catch(function (err) {
        console.error(err);
        window.alert('Unable to download pdf, please try again later');
      });
    }
  },
  computed: {
    progress: function progress() {
      return this.getObjectPath(this.requests.adherence, 'result', []);
    },
    exercises: function exercises() {
      return this.getObjectPath(this.requests.exercises, 'result.exercises', []);
    },
    messages: function messages() {
      return this.getObjectPath(this.requests.messages, 'result.messages', []);
    },
    programUrl: function programUrl() {
      if (this.program) {
        return 'https://uk.physiapp.com/access/' + this.program.access_code;
      }
      return null;
    },
    programParams: function programParams() {
      return {
        client_id: this.physitrackClientId,
        access_code: this.program.access_code
      };
    },
    progressDetail: function progressDetail() {
      var _this2 = this;

      if (this.progress && this.progress.days) {
        return this.progress.days.find(function (day) {
          return day.date.startsWith(_this2.selectedDate);
        });
      }
    }
  }
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgramList',
  props: {
    programs: { type: Array, default: function _default() {
        return [];
      } },
    title: { type: String }
  }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssignProgram_vue__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssignProgram_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AssignProgram_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProgramList_vue__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProgramList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProgramList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Program_vue__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Program_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Program_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Programs',
  components: { AssignProgram: __WEBPACK_IMPORTED_MODULE_1__AssignProgram_vue___default.a, ProgramList: __WEBPACK_IMPORTED_MODULE_2__ProgramList_vue___default.a, Program: __WEBPACK_IMPORTED_MODULE_3__Program_vue___default.a },
  props: {
    value: { type: Object, required: true },
    physitrackClientId: { required: true },
    relationshipId: { required: true }
  },
  data: function data() {
    return {
      window: 0,
      search: '',
      assignTouch: 0,
      selectedProgram: {},
      requests: {
        get: {
          resource: 'ag.integrations',
          extra: 'physitrack/programs',
          result: {}
        }
      },
      physitrackClient: {}
    };
  },

  watch: {
    physitrackClientId: {
      immediate: true,
      handler: function handler() {
        this.get();
      }
    },
    value: function value() {
      if (this.value) {
        this.physitrackClient = this.value;
      }
    },
    window: function window() {
      if (this.window === 0) {
        this.get();
      }
    }
  },
  computed: {
    programs: function programs() {
      return this.getObjectPath(this.requests, 'get.result.programs', []);
    },
    yearOfBirth: function yearOfBirth() {
      return this.getObjectPath(this.value, 'year_of_birth');
    },
    physitrackIntegration: function physitrackIntegration() {
      return this.$store.getters.getIntegration('Physitrack');
    },
    physitrackBaseUrl: function physitrackBaseUrl() {
      return this.getObjectPath(this.requests.get, 'result.base');
    },
    clientLink: function clientLink() {
      return this.physitrackBaseUrl + '/clients/' + this.physitrackClientId + '/';
    },
    hasActivePrograms: function hasActivePrograms() {
      if (this.currentlyActivePrograms && this.currentlyActivePrograms.length > 0) {
        return true;
      }
      return false;
    },
    currentlyActivePrograms: function currentlyActivePrograms() {
      return this.programs.filter(function (program) {
        var now = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local();

        var endDate = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(program.end_date);
        return endDate > now;
      });
    },
    previousPrograms: function previousPrograms() {
      return this.programs.filter(function (program) {
        var now = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local();
        var endDate = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(program.end_date);
        return now >= endDate;
      });
    }
  },
  methods: {
    programAssigned: function programAssigned(program) {
      this.window = 0;
      this.get();
    },
    get: function get() {
      if (this.physitrackClientId) {
        this.requests.get.params = { client_id: this.physitrackClientId };
        this.$request('get', this.requests.get);
      }
    },
    setActiveProgram: function setActiveProgram(program) {
      this.selectedProgram = program;
    }
  }
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_RequestStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);







var LINKS = {
  REFERRAL: 'https://referral.yoco.com/32Tzfb',
  PAYMENT_LINK: 'https://portal.yoco.co.za/online/settings'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'YocoIntegration',
  components: { RequestStatus: __WEBPACK_IMPORTED_MODULE_1__components_ui_RequestStatus___default.a },
  props: {
    spaceId: { required: false }
  },
  data: function data() {
    return {
      LINKS: LINKS,
      isValid: false,
      link: '',
      secret: '',
      uninstalldialog: false,
      invoices: true,
      appointments: true,
      prepayments: false,
      only_invoiceable: true,
      yocoBase: 'https://pay.yoco.com/',
      successMessage: 'Configuration loaded',
      request: {
        resource: 'ag.integrations',
        extra: 'yoco/configure',
        data: {
          payment_invoices_visible: true,
          payment_appointments_visible: false,
          payment_appointments_prepayments: false,
          payment_appointments_only_if_invoiceable: false
        }
      }
    };
  },

  watch: {
    spaceId: {
      immediate: true,
      handler: function handler() {
        if (this.spaceId) {
          this.request.params = { space: this.spaceId };
        } else {
          this.request.params = {};
        }
        this.get();
      }
    },
    link: function link() {
      if (this.link.startsWith(this.yocoBase)) {
        this.link = this.link.replace(this.yocoBase, '');
      }
    },
    appointments: function appointments() {
      if (this.appointments === false) {
        this.prepayments = false;
        this.only_invoiceable = false;
      }
    },
    config: function config() {
      if (this.config && this.config.link) {
        this.link = this.config.link;
      }
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        if (this.config) {
          this.request.data = this.config;
        }
      }
      if (this.requestStatus === 204) {
        this.request.data = {};
        this.link = '';
        var vm = this;
        window.setTimeout(function () {
          vm.uninstalldialog = false;
        }, 1000);
      }
      if (this.requestStatus === 404) {
        this.link = '';
      }
    },
    showOnAppointments: function showOnAppointments() {
      if (this.showOnAppointments === false) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.request.data, 'payment_appointments_only_if_invoiceable', false);
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.request.data, 'payment_appointments_prepayments', false);
      }
    }
  },
  methods: {
    get: function get() {
      this.successMessage = 'Configuration successully loaded';
      this.$request('get', this.request);
    },
    save: function save() {
      this.successMessage = 'Configuration saved';
      this.request.data['link'] = this.yocoBase + this.link;
      if (this.spaceId) {
        this.request.data['space'] = this.spaceId;
      }
      this.$request('save', this.request);
    },
    uninstall: function uninstall() {
      this.request.data = {};
      this.$request('delete', this.request);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getSpaceById']), {
    space: function space() {
      if (this.spaceId) {
        return this.getSpaceById(this.spaceId);
      }
      return null;
    },
    config: function config() {
      return this.getObjectPath(this.request, 'result.settings', {});
    },
    isInstalled: function isInstalled() {
      if (this.config && this.config.link) {
        return true;
      }
      return false;
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    showOnAppointments: function showOnAppointments() {
      return this.request.data.payment_appointments_visible;
    }
  })
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceDetail__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceVersions__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceVersions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceVersions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_invoice_InvoicePayments__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_invoice_InvoicePayments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_invoice_InvoicePayments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_invoice_InvoiceCommunications__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_invoice_InvoiceCommunications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_invoice_InvoiceCommunications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_invoice_manage_create_encrypt_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_invoice_manage_create_encrypt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_invoice_manage_create_encrypt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceDetailPage',
  components: {
    InvoiceDetail: __WEBPACK_IMPORTED_MODULE_1__components_invoice_InvoiceDetail___default.a,
    InvoicePayments: __WEBPACK_IMPORTED_MODULE_3__components_invoice_InvoicePayments___default.a,
    InvoiceVersions: __WEBPACK_IMPORTED_MODULE_2__components_invoice_InvoiceVersions___default.a,
    InvoiceCommunications: __WEBPACK_IMPORTED_MODULE_4__components_invoice_InvoiceCommunications___default.a,
    HelpPopover: __WEBPACK_IMPORTED_MODULE_6__components_ui_HelpPopover___default.a,
    EncryptInvoice: __WEBPACK_IMPORTED_MODULE_5__components_invoice_manage_create_encrypt_vue___default.a
  },
  data: function data() {
    return {
      reqId: 'req-invoice-' + this.invoiceId,
      saveReqId: 'invoice-save-request',
      commsreqid: 'communication-invoice-id',
      showEncrypt: false,
      showAlert: true,
      activeTab: null,
      invoice: {},
      versionTouch: 1,
      statementTouch: 1,
      commsTouch: 1
    };
  },
  mounted: function mounted() {
    this.getInvoice();
  },

  watch: {
    invoiceId: function invoiceId() {
      this.getInvoice();
    },
    invoiceResult: function invoiceResult() {
      console.log(this.invoiceResult);
      this.invoice = this.invoiceResult;
    },
    invoiceSaveRequestStatus: function invoiceSaveRequestStatus() {
      if (this.invoiceSaveRequestStatus === 200) {
        this.showEncrypt = false;
      }
    }
  },
  computed: {
    invoiceId: function invoiceId() {
      return this.$route.params.id;
    },
    invoiceGetRequest: function invoiceGetRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    invoiceSaveRequest: function invoiceSaveRequest() {
      return this.$store.getters.getRequestById(this.saveReqId, true);
    },
    invoiceSaveRequestStatus: function invoiceSaveRequestStatus() {
      return this.invoiceSaveRequest.status;
    },
    invoiceCommsRequest: function invoiceCommsRequest() {
      return this.$store.getters.getRequestById(this.commsreqid, true);
    },
    invoiceResult: function invoiceResult() {
      return this.getObjectPath(this.invoiceGetRequest, 'result.data', {});
    },
    invoiceUrl: function invoiceUrl() {
      if (this.invoice) {
        return this.$invoiceguru.baseUrl + '/' + this.invoice.get_view_url;
      }
    },
    client: function client() {
      if (this.invoice) {
        return this.getClientById(this.invoice.customer_id);
      }
    }
  },
  methods: {
    getInvoice: function getInvoice() {
      if (this.invoiceId) {
        this.$invoiceguru.resource('invoices').id(this.reqId).get(this.invoiceId);
      }
    },
    savePassword: function savePassword() {
      var data = {
        encrypt_password: this.invoice.encrypt_password,
        encrypt_password_hint: this.invoice.encrypt_password_hint
      };
      this.$invoiceguru.resource('invoices').id(this.saveReqId).save(this.invoice.id, data);
    },
    save: function save() {
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.invoice);
      this.$invoiceguru.resource('invoices').id(this.saveReqId).save(this.invoice.id, data);
    },
    openInNew: function openInNew() {
      window.open(this.invoiceUrl, '_blank');
    },
    reloadIframe: function reloadIframe() {
      var iframe = document.getElementById('invoice-preview');
      iframe.contentWindow.location = this.invoiceUrl;
    },
    upgradeInvoice: function upgradeInvoice() {
      var url = this.$invoiceguru.baseUrl + '/invoices/' + this.invoiceId + '/upgrade/';
      var options = this.$invoiceguru.getOptions();
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url, options).then(function () {
        vm.getInvoice();
      });
    }
  },
  i18n: {
    messages: {
      en: {
        tabs: {
          edit: 'Edit',
          statement: 'Statement',
          versions: 'Versions',
          communications: 'Communications',
          rawData: 'Raw data'
        }
      }
    }
  }
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_layout_Toolbar__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoice_layout_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_invoice_layout_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Table__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_invoice_layout_ProgressKanban__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_invoice_layout_ProgressKanban___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_invoice_layout_ProgressKanban__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_invoice_layout_Invoiceable_Index_vue__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_invoice_layout_Invoiceable_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_invoice_layout_Invoiceable_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_invoice_layout_AppointmentsTodo__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_invoice_layout_AppointmentsTodo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_invoice_layout_AppointmentsTodo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_invoice_layout_OverdueKanban__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_invoice_layout_OverdueKanban___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_invoice_layout_OverdueKanban__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_invoice_layout_Transactions__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_invoice_layout_Transactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_invoice_layout_Transactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_invoice_Preview__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_invoice_Preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_invoice_Preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_invoice_SendInvoice__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_invoice_SendInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_invoice_SendInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_invoice__ = __webpack_require__(94);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiesPage',
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_invoice__["a" /* default */]],
  components: {
    InvoicesToolbar: __WEBPACK_IMPORTED_MODULE_1__components_invoice_layout_Toolbar___default.a,

    InvoiceTable: __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Table___default.a,
    ProgressKanban: __WEBPACK_IMPORTED_MODULE_3__components_invoice_layout_ProgressKanban___default.a,
    InvoicableGallery: __WEBPACK_IMPORTED_MODULE_4__components_invoice_layout_Invoiceable_Index_vue___default.a,
    AppointmentsTodo: __WEBPACK_IMPORTED_MODULE_5__components_invoice_layout_AppointmentsTodo___default.a,
    Transactions: __WEBPACK_IMPORTED_MODULE_7__components_invoice_layout_Transactions___default.a,

    OverdueKanban: __WEBPACK_IMPORTED_MODULE_6__components_invoice_layout_OverdueKanban___default.a,

    SendInvoice: __WEBPACK_IMPORTED_MODULE_9__components_invoice_SendInvoice___default.a,
    InvoicePreview: __WEBPACK_IMPORTED_MODULE_8__components_invoice_Preview___default.a
  },
  data: function data() {
    return {
      page: 1,
      activeMainComponent: 'kanban',
      activeSecondaryComponent: false,
      showConfirmDeleteDialog: false,
      api: this.$invoiceguru,
      resource: 'invoices',
      searchString: '',
      useDateDue: false,
      reqId: __WEBPACK_IMPORTED_MODULE_0__store_constants__["e" /* LIST_INVOICES_IN_RANGE_REQ */],
      transactionReqId: __WEBPACK_IMPORTED_MODULE_0__store_constants__["p" /* LIST_TRANSACTIONS_IN_RANGE_REQ */],
      savePaymentReqId: __WEBPACK_IMPORTED_MODULE_0__store_constants__["q" /* SAVE_PAYMENT_REQ */],
      saveInvoiceReqId: __WEBPACK_IMPORTED_MODULE_0__store_constants__["b" /* SAVE_INVOICE_REQ */],
      selectedClient: { client: {} },
      selectedClientId: null,
      selectedObject: {},
      quickCreateStep: 1,
      invoice: {},
      headers: [{ 'text': 'ID', value: 'id' }, { 'text': 'Title', value: 'title' }, { 'text': 'Date', value: 'date' }, { 'text': 'Due date', value: 'due_date' }, { 'text': 'Status', value: 'status' }, { 'text': 'Amount', value: 'invoice_amount' }],
      requests: {
        delete: __WEBPACK_IMPORTED_MODULE_0__store_constants__["n" /* DELETE_INVOICE_REQ */]
      },
      invoiceForSending: {}
    };
  },
  mounted: function mounted() {
    this.refresh();
  },

  watch: {
    deleteInvoiceRequestStatus: function deleteInvoiceRequestStatus() {
      if (this.deleteInvoiceRequestStatus === 204) {
        this.refresh();
      }
    },
    paymentSavedRequestStatus: function paymentSavedRequestStatus() {
      if (this.paymentSavedRequestStatus === 201) {
        this.refresh();
      }
    },
    globalActiveDateRangeFormatted: function globalActiveDateRangeFormatted() {
      this.refresh();
    },
    invoice: function invoice() {
      this.selectedClientId = this.invoice.customer_id;
    },
    selectedClientId: function selectedClientId() {
      if (this.selectedClientId) {
        var client = this.setClientFromId(this.selectedClientId);
        if (client !== -1) {
          this.selectedClient = client;
        }
      }
    },
    dateType: function dateType() {
      this.refresh();
    },
    page: function page() {
      this.refresh();
    },
    activeMainComponent: function activeMainComponent() {
      this.searchString = '';
    }
  },
  computed: {
    title: function title() {
      return this.dateformat(this.activeDateRange.from) + ' - ' + this.dateformat(this.activeDateRange.to);
    },
    mainComponent: function mainComponent() {
      var datas = {
        table: __WEBPACK_IMPORTED_MODULE_2__components_invoice_layout_Table___default.a,
        kanban: __WEBPACK_IMPORTED_MODULE_3__components_invoice_layout_ProgressKanban___default.a,
        gallery: __WEBPACK_IMPORTED_MODULE_4__components_invoice_layout_Invoiceable_Index_vue___default.a,
        masterDetail: __WEBPACK_IMPORTED_MODULE_5__components_invoice_layout_AppointmentsTodo___default.a,
        transactions: __WEBPACK_IMPORTED_MODULE_7__components_invoice_layout_Transactions___default.a,

        overdueReport: __WEBPACK_IMPORTED_MODULE_6__components_invoice_layout_OverdueKanban___default.a
      };
      return datas[this.activeMainComponent];
    },
    secondaryComponent: function secondaryComponent() {
      var datas = {
        view: __WEBPACK_IMPORTED_MODULE_8__components_invoice_Preview___default.a,
        send: __WEBPACK_IMPORTED_MODULE_9__components_invoice_SendInvoice___default.a
      };
      return datas[this.activeSecondaryComponent];
    },
    mainComponentClasses: function mainComponentClasses() {
      var classes = [];
      if (this.activeSecondaryComponent) {
        classes = ['xs12', 'sm8'];
      } else {
        classes = ['xs12'];
      }
      if (this.$vuetify.breakpoint.xs) {
        classes.push('pt-0');
      }
      return classes;
    },
    me: function me() {
      return this.$store.getters.me;
    },
    dateType: function dateType() {
      if (this.useDateDue) {
        return 'due';
      }
      return 'date';
    },
    invoicesRequest: function invoicesRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    transactionsRequest: function transactionsRequest() {
      return this.$store.getters.getRequestById(this.transactionReqId, true);
    },
    paymentSavedRequest: function paymentSavedRequest() {
      return this.$store.getters.getRequestById(this.savePaymentReqId, true);
    },
    paymentSavedRequestStatus: function paymentSavedRequestStatus() {
      return this.paymentSavedRequest.status;
    },
    deleteInvoiceRequest: function deleteInvoiceRequest() {
      return this.$store.getters.getRequestById(this.requests.delete, true);
    },
    deleteInvoiceRequestStatus: function deleteInvoiceRequestStatus() {
      return this.deleteInvoiceRequest.status;
    },
    invoiceable: function invoiceable() {
      return this.$store.getters.clientsInRange;
    },
    appointmentsNeedingAttention: function appointmentsNeedingAttention() {
      return this.$store.getters.appointmentsNeedingAttention;
    },
    activeAppointments: function activeAppointments() {
      return this.$store.getters.activeAppointments;
    },
    newInvoices: function newInvoices() {
      return this.$store.getters.getInvoicesByStatus('new');
    },
    sentInvoices: function sentInvoices() {
      return this.$store.getters.getInvoicesByStatus('sent');
    },
    paidInvoices: function paidInvoices() {
      return this.$store.getters.getInvoicesByStatus('paid');
    },
    transactions: function transactions() {
      return this.getObjectPath(this.transactionsRequest, 'result.data.results', []);
    },
    activeDateRange: function activeDateRange() {
      return this.$store.getters.activeDateRange;
    },
    filteredInvoices: function filteredInvoices() {
      var _this = this;

      if (this.searchString && this.searchString.length > 1) {
        return this.invoices.filter(function (invoice) {
          var index = ('' + invoice.id + invoice.title).toLowerCase();
          return index.indexOf(_this.searchString.toLowerCase()) !== -1;
        });
      }
      return this.invoices;
    },
    invoices: function invoices() {
      return this.getObjectPath(this.invoicesRequest, 'result.data.results', []);
    },
    alreadyInvoiced: function alreadyInvoiced() {
      return this.invoices.map(function (invoice) {
        return invoice.customer_id;
      });
    }
  },
  methods: {
    gotoInvoice: function gotoInvoice(invoice) {
      this.gotoPath('/invoices/' + invoice.id);
    },
    gotoCustomer: function gotoCustomer(invoice) {
      if (invoice && invoice.relationship_id) {
        this.gotoPath('/clients/r/' + invoice.relationship_id);
      } else {
        this.gotoPath('/clients/' + invoice.customer_id);
      }
    },
    setSearch: function setSearch(search) {
      this.searchString = search;
    },
    showPaymentDialog: function showPaymentDialog(invoice) {
      var amount = this.formatCurrency(invoice.currency, invoice.invoice_amount);
      var options = {
        title: 'Pay ' + amount + ' with SnapScan',
        snapUrl: invoice.get_snapscan_url,
        snapImg: invoice.get_snapscan_qr
      };
      this.launchSnapDialog(options);
    },
    setMainComponent: function setMainComponent(val) {
      this.activeMainComponent = val;
    },
    setSecondaryComponent: function setSecondaryComponent(val) {
      this.activeSecondaryComponent = val;
    },
    gotoSend: function gotoSend(invoice) {
      this.invoice = invoice;
      var client = this.setClientFromId(this.invoice.customer_id);
      this.launchSendInvoiceDialog({ invoice: invoice, client: client, withClose: false });
    },
    sendtomedicalaid: function sendtomedicalaid(invoice) {
      this.invoice = invoice;

      this.launchSendToMedicalAidDialog({
        invoice: invoice,
        withCancel: true
      });
    },
    setPreview: function setPreview(invoice) {
      this.invoice = invoice;
      this.setSecondaryComponent('view');
    },
    refresh: function refresh() {
      var params = { page: this.page };
      this.loadInvoices(this.dateType, params);
    },
    clientSelected: function clientSelected(client) {
      this.invoiceForSending = {};
      this.selectedClientId = client.id;
      this.selectedClient = client;
      this.quickCreateStep = 1;
    },
    showSendAlert: function showSendAlert(invoice) {
      this.invoiceForSending = invoice;
      this.selectedClient = this.getClientById(parseInt(invoice.customer_id));
      this.selectedClientId = this.selectedClient.id;
    },
    prepareToDelete: function prepareToDelete(invoice) {
      this.invoice = invoice;
      this.showConfirmDeleteDialog = true;
    },
    deleteInvoice: function deleteInvoice(invoice) {
      var id = invoice.id;
      this.api.resource(this.resource).id(this.requests.delete).delete(id);

      this.showConfirmDeleteDialog = false;
    },
    invoiceCreated: function invoiceCreated(invoice) {
      this.invoiceForSending = invoice;
      this.refresh();
    },
    openInNew: function openInNew(invoice) {
      if (invoice && invoice.id) {
        var base = this.$invoiceguru.baseUrl;
        var path = invoice.get_view_url;
        if (!path) {
          path = '/invoice/view/' + invoice.id + '/?key=' + invoice.password;
        }
        var url = base + path;
        window.open(url, '_blank');
      }
    },
    addPayment: function addPayment(invoice) {
      this.invoiceEvents['addpayment'](invoice);
    },
    markAsPaid: function markAsPaid(invoice) {
      var _this2 = this;

      this.$invoiceguru.markAsPaid(invoice).then(function (response) {
        _this2.refresh();
      }).catch(function (err) {
        window.alert('There was an error updating this invoice');
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);






var STATE = {
  INIT: 0,
  LOGGEDIN: 1,
  LOGIN: 2
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoginPage',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_requests__["a" /* default */]],
  props: {
    withInit: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      step: 0,
      statusMessage: 'Waking the Guru',
      status: 0,
      states: STATE,
      email: '',
      username: '',
      password: '',
      code: '',
      label: 'tests',
      loginResult: {},
      showcode: false,
      alreadyLoggedIn: false,
      requests: {
        start: {
          resource: 'auth.session'
        },
        requestOTP: {
          resource: 'ag.auth'
        },
        login: {
          resource: 'auth.login'
        }
      }
    };
  },
  mounted: function mounted() {
    if (!this.withInit) {
      this.status = STATE.LOGIN;
      return null;
    }
    this.status = STATE.INIT;
    this.start();
  },

  watch: {
    startStatus: function startStatus() {
      if (this.startStatus === 0) {
        return null;
      }
      if (this.startStatus === 200) {
        var payload = this.requests.start.result;
        this.status = STATE.INIT;
        this.statusMessage = 'Logging you in';
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_constants__["i" /* LOGIN */], payload);
        this.getMe();
      } else if (this.startStatus > 299) {
        this.status = STATE.LOGIN;
      }
    },
    getMeReqStatus: function getMeReqStatus() {
      if (this.getMeReqStatus === 200) {
        this.state = STATE.LOGGEDIN;
        this.statusMessage = 'Hi ' + this.$store.getters.me.first_name + '!';
        this.$emit('loggedin');
        this.redirect();
      }
      if (this.getMeReqStatus === 401) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_constants__["h" /* LOGOUT */]);
      }
      if (this.getMeReqStatus > 200) {
        this.status = STATE.LOGIN;
      }
    },
    loginStatus: function loginStatus() {
      if (this.loginStatus === 200) {
        this.status = STATE.INIT;
        this.statusMessage = 'Logged in. Loading profile';
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_constants__["i" /* LOGIN */], this.requests.login.result);
        this.getMe();
        this.redirect();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['token', 'refreshToken']), {
    loading: function loading() {
      return this.requests.login.loading;
    },
    showLoginMessage: function showLoginMessage() {
      return this.loginResult.response && this.loginResult.response.data && this.loginResult.response.data.message;
    },
    loginPayload: function loginPayload() {
      var data = {
        client_id: this.$env.CLIENT_ID,
        client_secret: this.$env.CLIENT_SECRET
      };
      if (this.step === 0) {
        data.username = this.username;
        data.password = this.password;
      }
      if (this.step === 1) {
        data.email = this.email;
        data.otp = this.code;
      }
      return data;
    },
    otpPayload: function otpPayload() {
      return {
        client_id: this.$env.CLIENT_ID,
        client_secret: this.$env.CLIENT_SECRET,
        email: this.email,
        otp: this.otp
      };
    },
    passwordPayload: function passwordPayload() {
      return {
        password: this.password
      };
    },
    loginStatus: function loginStatus() {
      return this.requests.login.status;
    },
    startStatus: function startStatus() {
      return this.requests.start.status;
    }
  }),
  methods: {
    start: function start() {
      var token = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$cookies.get(__WEBPACK_IMPORTED_MODULE_2__store_constants__["G" /* KONG_TOKEN_KEY */]);
      var data = {
        client_id: this.$env.CLIENT_ID,
        client_secret: this.$env.CLIENT_SECRET
      };
      if (token) {
        data.token = token;
      }
      this.requests.start.data = data;
      this.$request('save', this.requests.start);
    },
    prepareLinkPage: function prepareLinkPage() {
      this.step = 1;
      this.code = '';
      this.requests.login.status = 0;
      if (!this.email) {
        this.email = this.username;
      }
    },
    sendOTP: function sendOTP() {
      this.requests.requestOTP.data = {
        email: this.email,
        method: 'email'
      };
      this.requests.requestOTP.extra = 'forgot-password';
      this.$request('save', this.requests.requestOTP);
    },
    login: function login() {
      this.requests.login.data = this.loginPayload;
      this.requests.requestOTP.extra = 'forgot-password';
      this.$request('save', this.requests.login);
    },
    redirect: function redirect() {
      var vm = this;
      setTimeout(function () {
        var redirect = vm.$store.getters.loginRedirect;
        if (!redirect) {
          return '/';
        }
        vm.$router.push(redirect);
      }, 500);
    }
  }
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportsPage'
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_settings_Profile__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_settings_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pages_settings_Profile__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SettingsPage',
  components: {
    Profile: __WEBPACK_IMPORTED_MODULE_0__components_pages_settings_Profile___default.a
  },
  data: function data() {
    return {
      expanded: {
        profile: true
      },
      items: [1, 2, 3, 4, 5]
    };
  },

  computed: {
    token: function token() {
      return this.$store.getters.token;
    },
    currentPage: function currentPage() {
      return this.$route.name;
    }
  }
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dompurify__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dompurify__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommunicationCard',

  props: {
    id: { required: true },
    initialData: { type: Object, default: function _default() {
        return {};
      } },
    withFetch: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      reqId: 'get-communication',
      comm: {}
    };
  },
  mounted: function mounted() {
    if (this.initialData) {
      this.comm = this.initialData;
    }
  },

  watch: {
    id: {
      immediate: true,
      handler: function handler() {
        this.fetch();
      }
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        this.comm = this.serverComm;
      }
    }
  },
  computed: {
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId);
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    serverComm: function serverComm() {
      return this.getObjectPath(this.request, 'result.data', {});
    },
    parsedMessage: function parsedMessage() {
      if (this.comm && this.comm.message) {
        return __WEBPACK_IMPORTED_MODULE_0_dompurify__["sanitize"](this.comm.message, { USE_PROFILES: { html: true } });
      }
      return '';
    }
  },
  methods: {
    fetch: function fetch() {
      if (this.id) {
        this.$communicationguru.resource('communication').id(this.reqId).get(this.id);
      }
    }
  }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_ClientList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Compose',
  components: { ClientList: __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList_vue___default.a },
  data: function data() {
    return {
      activeTab: 0,
      selectedRelationship: {},
      subject: '',
      message: '',
      shortMessage: '',
      request: {
        resource: 'unibox.comms',
        extra: 'send'
      }
    };
  },

  methods: {
    send: function send() {
      this.request.data = this.payload;
      this.$request('save', this.request);
    },
    setRelationship: function setRelationship(rel) {
      this.selectedRelationship = rel;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['me']), {
    recipientId: function recipientId() {
      return this.getObjectPath(this.selectedRelationship, 'id');
    },
    messageType: function messageType() {
      if (this.activeTab === 0) {
        return 'SMS';
      }
      if (this.activeTab === 1) {
        return 'Email';
      }
    },
    sender: function sender() {
      return {
        id: this.me.id,
        first_name: this.me.first_name,
        last_name: this.me.last_name,
        email: this.me.email,
        phone_number: this.me.phone_number
      };
    },
    recipient: function recipient() {
      var rel = this.selectedRelationship;
      if (this.recipientId) {
        var client = rel.client;
        if (client && client.id) {
          var email = client.email;
          var phone = client.phone_number;
          return {
            id: rel.id,
            first_name: client.first_name,
            last_name: client.last_name,
            full_name: client.first_name + ' ' + client.last_name,
            email: email,
            phone_number: phone
          };
        }
      }
    },
    payload: function payload() {
      var data = {
        recipient: this.recipient,
        sender: this.sender,
        message: this.shortMessage,
        preferred_transport: this.messageType
      };
      if (this.messageType === 'Email') {
        data['subject'] = this.subject;
        data['message'] = this.message;
      }
      return data;
    }
  })
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_CommunicationListItem_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_CommunicationListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_listitems_CommunicationListItem_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommunicationInboxPage',
  components: { CommunicationListItem: __WEBPACK_IMPORTED_MODULE_0__components_listitems_CommunicationListItem_vue___default.a },
  props: {
    messages: { type: Array, default: function _default() {
        return [];
      } }
  },
  methods: {
    isNewDate: function isNewDate(item, index) {
      if (index === 0) {
        return true;
      }
      var oldDate = new Date(this.messages[index - 1].created_date).toDateString();
      var newDate = new Date(item.created_date).toDateString();
      return oldDate !== newDate;
    }
  }
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunicationCard__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunicationCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunicationCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Compose_vue__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Compose_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Compose_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Inbox__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Inbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Inbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_CommunicationTemplateForm__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_CommunicationTemplateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_forms_CommunicationTemplateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lists_CommunicationTemplateList__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lists_CommunicationTemplateList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_lists_CommunicationTemplateList__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommunicationsPage',
  components: { CommunicationCard: __WEBPACK_IMPORTED_MODULE_0__CommunicationCard___default.a, Inbox: __WEBPACK_IMPORTED_MODULE_2__Inbox___default.a, CommunicationTemplateForm: __WEBPACK_IMPORTED_MODULE_3__components_forms_CommunicationTemplateForm___default.a, CommunicationTemplateList: __WEBPACK_IMPORTED_MODULE_4__components_lists_CommunicationTemplateList___default.a, Compose: __WEBPACK_IMPORTED_MODULE_1__Compose_vue___default.a },
  data: function data() {
    return {
      reqId: 'get-messages',
      activeTab: 0,
      templatePage: 0,
      selectedTemplate: null,
      selectedTemplateSlug: null,
      search: null,
      showDetail: false,
      failed: false,
      page: 1,
      pagesVisible: 7,
      showCompose: 0,
      selected: null
    };
  },
  mounted: function mounted() {
    this.fetch();
  },

  computed: {
    mainClasses: function mainClasses() {
      if (this.selected) {
        return ['xs12', 'sm7', 'lg8', 'pr-0'];
      }
      return ['xs-12'];
    },
    response: function response() {
      return this.$store.getters.getRequestById(this.reqId);
    },
    totalResults: function totalResults() {
      return this.getObjectPath(this.response, 'result.data.count', 0);
    },
    numPages: function numPages() {
      if (this.totalResults === 0) {
        return 0;
      }
      return Math.ceil(parseInt(this.totalResults) / this.messages.length);
    },
    messages: function messages() {
      var messages = this.getObjectPath(this.response, 'result.data.results', []);
      if (messages && messages.length > 0) {}
      return messages;
    }
  },
  watch: {
    failed: function failed() {
      this.page = 1;
      this.fetch();
    },
    page: function page() {
      this.fetch();
    }
  },
  methods: {
    dosearch: function dosearch() {
      var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.page = 1;
      window.setTimeout(this.fetch, wait);
    },
    setSelected: function setSelected(message) {
      this.selected = message;
      this.showDetail = true;
    },
    setSelectedCommunicationTemplate: function setSelectedCommunicationTemplate(template) {
      if (template) {
        this.selectedTemplate = template;
        this.selectedTemplateSlug = template.slug;
      } else {
        this.selectedTemplate = null;
        this.selectedTemplateSlug = null;
      }
      this.templatePage = 1;
    },
    fetch: function fetch() {
      var params = {
        page: this.page
      };
      if (this.failed) {
        params['status'] = 'failed';
      }
      if (this.search && this.search.length > 0) {
        params['search'] = this.search;
      }
      this.$communicationguru.resource('communication').id(this.reqId).list(params);
    }
  },
  i18n: {
    messages: {
      en: {
        tabs: {
          inbox: 'Inbox',
          communicationtemplates: 'Templates'
        },
        comms: {
          title: 'Message templates'
        }
      }
    }
  }
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_guides_getstarted_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_AppointmentListItem_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appointment_AppointmentListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_appointment_AppointmentListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_ActionMenu__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_ActionMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_ActionMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_invoice_InvoiceList_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_invoice_InvoiceList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_invoice_InvoiceList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_invoice_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GetStarted',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__data_guides_getstarted_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_invoice_js__["a" /* default */]],
  components: {
    AppointmentListItem: __WEBPACK_IMPORTED_MODULE_2__components_appointment_AppointmentListItem_vue___default.a,
    AppointmentActionMenu: __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_ActionMenu___default.a,
    InvoiceList: __WEBPACK_IMPORTED_MODULE_4__components_invoice_InvoiceList_vue___default.a
  },
  data: function data() {
    return {
      step: 0,
      level: 'basic',
      showInstructions: false,
      showMenu: false,
      showScan: true,
      showTour: 0,
      showFindGuides: false,
      selectedItem: null
    };
  },
  mounted: function mounted() {
    var vm = this;
    window.setTimeout(function () {
      vm.showFindGuides = true;
    }, 1000);
  },

  methods: {
    setStep: function setStep(item) {
      this.selectedItem = item;
      this.showInstructions = true;
    }
  },
  watch: {
    showInstructions: function showInstructions() {
      if (this.showInstructions === false) {
        if (this.selectedItem && this.selectedItem.id === 'create_appointment') {
          this.showMenu = true;
        }
      }
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.selectedItem, 'done', true);
      this.step++;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['appointments', 'invoices']), {
    lastAppointment: function lastAppointment() {
      if (this.appointments && this.appointments.length > 0) {
        return this.appointments[this.appointments.length - 1];
      }
      return null;
    },
    lastInvoice: function lastInvoice() {
      if (this.invoices && this.invoices.length > 0) {
        return this.invoices[this.invoices.length - 1];
      }
      return null;
    },
    numAppointments: function numAppointments() {
      if (this.appointments) {
        return this.appointments.length;
      }
      return 0;
    },
    numInvoices: function numInvoices() {
      if (this.invoices) {
        return this.invoices.length;
      }
      return 0;
    },
    tour: function tour() {
      return [{
        selector: '#global-link-calendar',
        title: 'Calendar',
        description: 'Your calendar shows your appointments in a calendar view - it\'s the best place to view, create and manage your appointments',
        attrs: {
          nudgeBottom: 15,
          bottom: true,
          offsetY: true
        }
      }, {
        selector: '#global-link-clients',
        title: 'Clients',
        description: '...',
        attrs: {
          nudgeBottom: 15,
          bottom: true,
          offsetY: true
        }
      }];
    }
  })
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CopyTextField_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CopyTextField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CopyTextField_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CalendarFeed',
  components: { CopyTextField: __WEBPACK_IMPORTED_MODULE_0__components_ui_CopyTextField_vue___default.a },
  computed: {
    me: function me() {
      return this.$store.getters.me;
    },
    feedUrl: function feedUrl() {
      var token = this.me.channel.replace('practitioner-', '');
      return 'https://appt.guru/ical/practitioner/' + token + '/';
    },
    installer: function installer() {
      return window.guruinstaller;
    }
  },
  methods: {
    installMobile: function installMobile() {
      if (window.guruinstaller && window.guruinstaller.prompt) {
        window.guruinstaller.prompt();
      } else {
        this.showInstallInstructions = true;
      }
    }
  }
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EarnPage',
  components: { HelpPopover: __WEBPACK_IMPORTED_MODULE_3__components_ui_HelpPopover___default.a },
  data: function data() {
    return {
      freeDays: 31,
      defaultCopyLinkText: this.$t('subtitle'),
      copyLinkText: '',
      funnel: null,
      loadingFunnel: false
    };
  },
  mounted: function mounted() {
    this.copyLinkText = this.defaultCopyLinkText;
    this.getFunnel();
  },

  computed: {
    referralLink: function referralLink() {
      return 'http://appointmentguru.co/?utm_campaign=' + this.me.profile.referral_key + '&utm_medium=referral';
    },
    me: function me() {
      return this.$store.getters.me;
    },
    credits: function credits() {
      var earned = parseFloat(this.getObjectPath(this.me, 'profile.credits_earned', 0));
      var used = parseFloat(this.getObjectPath(this.me, 'profile.credits_used', 0));
      var available = parseFloat(earned - used);
      return { earned: earned, used: used, available: available };
    }
  },
  methods: {
    getFunnel: function getFunnel() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, options, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadingFunnel = true;
                url = _this.$appointmentguru.baseUrl + '/api/practitioners/' + _this.$store.getters.me.id + '/campaign_funnel/?since=2020-01-01';
                options = {
                  url: url,
                  headers: _this.$appointmentguru.headers,
                  method: 'get'
                };
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default()(options);

              case 5:
                res = _context.sent;

                if (res.status === 200) {
                  _this.funnel = res.data;
                  _this.loadingFunnel = false;
                } else {
                  _this.loadingFunnel = false;
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    copyToClipboard: function copyToClipboard() {
      var _this2 = this;

      var el = document.createElement('textarea');
      el.value = this.referralLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.copyLinkText = 'Copied to clipboard';
      window.setTimeout(function () {
        _this2.copyLinkText = _this2.defaultCopyLinkText;
      }, 4000);
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Refer a friend',
        subtitle: 'Get R300 credited to your AppointmentGuru account each time someone you referred becomes a paying AppointmentGuru customer',
        link: {
          overline: 'Your referral link'
        },
        subtitles: {
          referred: 'Referred',
          ontrial: 'On trial',
          converted: 'Upgraded',
          creditbalance: 'Your credit balance'
        },
        credits: {
          helptext: 'Credits will be applied to your account whenever someone you have referred becomes a paying AppointmentGuru customer. Credit will be used automatically on your next billing cycle. The number below is the outstanding credit due to you.'
        },
        stats: {
          title: 'Referral Stats'
        }
      },
      es: {}
    }
  }
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnsplashSearch__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnsplashSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UnsplashSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_CopyTextField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_CopyTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_CopyTextField__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Online',
  components: { UnsplashSearch: __WEBPACK_IMPORTED_MODULE_0__UnsplashSearch___default.a, CopyTextField: __WEBPACK_IMPORTED_MODULE_1__components_ui_CopyTextField___default.a },
  data: function data() {
    return {
      resource: 'practitioner.me.profile',
      reqId: 'practitioner-settings-update',
      webEnabled: false,
      appEnabled: false,
      showembedcode: false,
      newsubdomain: '',
      actionRequest: {
        loading: false, status: 0, data: {}
      }
    };
  },

  methods: {
    save: function save() {
      var payload = {
        is_website_published: this.webEnabled,
        is_visible_in_app: this.appEnabled
      };
      this.$appointmentguru.resource(this.resource).id(this.reqId).save(this.me.id, payload);
    },
    setSubdomain: function setSubdomain() {
      this.action(this.$appointmentguru, 'practitioner', 'practitioners', this.me.id, 'set_subdomain', { sub_domain: this.newsubdomain }, this.actionRequest);
    }
  },
  computed: {
    me: function me() {
      return this.$store.getters.me;
    },
    webPublished: function webPublished() {
      return this.me.profile.is_website_published;
    },
    appLive: function appLive() {
      return this.me.profile.is_website_published;
    },
    subdomainSuccessMessage: function subdomainSuccessMessage() {
      if (this.actionRequest.status === 200) {
        return ['Successfully updated your URL'];
      }
      return [];
    },
    subdomainErrorMessage: function subdomainErrorMessage() {
      if (this.actionRequest.status > 399) {
        if (this.actionRequest.result.sub_domain) {
          return this.actionRequest.result.sub_domain;
        }
      }
      return [];
    },

    subdomain: {
      get: function get() {
        return this.getObjectPath(this.me, 'profile.sub_domain', null);
      },
      set: function set(val) {
        this.newsubdomain = val;
      }
    },
    website: function website() {
      if (this.subdomain) {
        return 'http://appt.guru/' + this.subdomain + '/';
      }
      return '';
    },
    bookingwidget: function bookingwidget() {
      return 'https://widget.appt.guru/?practitioner=' + this.meId;
    },
    saveRequest: function saveRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.saveRequest.status;
    },
    actionRequestStatus: function actionRequestStatus() {
      return this.actionRequest.status;
    },
    embedCode: function embedCode() {
      return '<iframe\n   src="' + this.bookingwidget + '\u201D\n   style="border: 0px;box-shadow: 0 1px 3px rgba(0,0,0,.2),0 1px 1px rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)!important;"\n   width="100%" height="400px" >\n</iframe>';
    }
  },
  mounted: function mounted() {
    this.webEnabled = this.me.profile.is_website_published;
    this.appEnabled = this.me.profile.is_visible_in_app;
  },

  watch: {
    webPublished: function webPublished() {
      this.webEnabled = this.me.profile.is_website_published;
    },
    appLive: function appLive() {
      this.appEnabled = this.me.profile.is_visible_in_app;
    },
    webEnabled: function webEnabled() {
      this.save();
    },
    appEnabled: function appEnabled() {
      this.save();
    },
    actionRequestStatus: function actionRequestStatus() {
      if (this.actionRequestStatus === 200) {
        this.getMe();
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200) {
        this.getMe();
      }
    }
  }
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ServerErrors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ServerErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ServerErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_requests__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_settings_media_Uploader_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_settings_media_Uploader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_settings_media_Uploader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_ImageSearch__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_ImageSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ui_ImageSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pickers_ProfessionPicker_vue__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pickers_ProfessionPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pickers_ProfessionPicker_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Profile',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_requests__["a" /* default */]],
  components: { ServerErrors: __WEBPACK_IMPORTED_MODULE_3__components_ServerErrors___default.a, Uploader: __WEBPACK_IMPORTED_MODULE_5__components_pages_settings_media_Uploader_vue___default.a, ImageSearch: __WEBPACK_IMPORTED_MODULE_6__components_ui_ImageSearch___default.a, ProfessionPicker: __WEBPACK_IMPORTED_MODULE_7__components_pickers_ProfessionPicker_vue___default.a },
  data: function data() {
    return {
      password: null,
      passwordVisible: false,
      backgroundDialog: false,
      logoDialog: false,
      enableEarlyAccess: false,
      changePassReqId: 'practitioner-password-change',
      requests: {
        me: { resource: 'ag.user', errors: {} },
        profile: { resource: 'ag.practitioner.me.profile', errors: {} }
      }
    };
  },
  mounted: function mounted() {
    if (this.$cookies.get('nf_ab') === 'next') {
      this.enableEarlyAccess = true;
    }
    if (this.me && this.me.profile) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.me.profile)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.profile, key, this.me.profile[key]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },

  watch: {
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200) {
        this.getMe();
      }
    }
  },
  methods: {
    getPayload: function getPayload(form, obj) {
      var keys = form.map(function (field) {
        return field.model;
      });
      var payload = {};
      keys.forEach(function (key) {
        payload[key] = obj[key];
      });
      return payload;
    },
    saveMe: function saveMe() {
      this.requests.me.data = this.getPayload(this.contactsForm, this.me);
      this.requests.me.resourceId = this.meId;
      this.$request('save', this.requests.me);
    },
    getErrors: function getErrors(req, field) {
      return this.getObjectPath(req, 'errors.' + field, []);
    },
    saveExtras: function saveExtras() {
      var professionId = this.getObjectPath(this.profile, 'profession.id');
      this.requests.profile.data = this.getPayload(this.extrasForm, this.profile);
      this.requests.profile.data.profession = professionId;
      this.requests.profile.resourceId = this.meId;
      this.$request('save', this.requests.profile);
    },
    saveSocials: function saveSocials() {
      this.requests.profile.data = this.getPayload(this.socialsForm, this.profile);
      this.requests.profile.resourceId = this.meId;
      this.$request('save', this.requests.profile);
    },
    saveBackground: function saveBackground() {
      this.requests.profile.data = { background_picture: this.profile.background_picture };
      this.requests.profile.resourceId = this.meId;
      this.$request('save', this.requests.profile);
      this.backgroundDialog = false;
    },
    changePassword: function changePassword() {
      var options = {
        id: this.changePassReqId,
        data: {
          password: this.password
        }
      };
      this.$appointmentguru.endpoint('auth-set-password', options);
    },
    toggleEarlyAccess: function toggleEarlyAccess() {
      if (this.enableEarlyAccess === true) {
        this.$cookies.set('nf_ab', 'next', '30d');
        var withRefresh = window.confirm('You have opted into early access. Would you like to refresh the app to load the new version now?');
        if (withRefresh) {
          window.location.reload();
        }
      } else {
        this.$cookies.remove('nf_ab');
      }
    }
  },
  computed: {
    me: function me() {
      return this.$store.getters.me;
    },
    profile: function profile() {
      return this.getObjectPath(this.me, 'profile', {});
    },
    profilePath: function profilePath() {
      return '/api/v2/practitioner/me/profile/' + this.meId + '/';
    },
    changePasswordReq: function changePasswordReq() {
      return this.$store.getters.getRequestById(this.changePassReqId, true);
    },
    backgroundPicture: function backgroundPicture() {
      var bg = this.getObjectPath(this.profile, 'background_picture');
      if (!bg) {
        bg = 'https://images.unsplash.com/photo-1530543787849-128d94430c6b?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80';
      }
      return bg;
    },
    contactsForm: function contactsForm() {
      return [{
        label: 'First name',
        model: 'first_name',
        flexClass: 'xs6'
      }, {
        label: 'Last name',
        model: 'last_name',
        flexClass: 'xs6'
      }, {
        label: 'Email',
        model: 'email',
        flexClass: 'xs6'
      }, {
        label: 'Phone number',
        model: 'phone_number',
        hint: 'A valid phone number starting with the country code. e.g.: +27831111111',
        flexClass: 'xs6'
      }];
    },
    extrasForm: function extrasForm() {
      return [{
        label: 'Registration number',
        model: 'registration_number',
        hint: 'Your personal professional registration number. For example, a BK number.'
      }, {
        label: 'Description',
        model: 'description',
        hint: 'A short professional bio'
      }, {
        label: 'Timezone',
        model: 'timezone',
        hint: 'The timezone in which you work'
      }, {
        label: 'Grant customer support access to my account',
        type: 'checkbox',
        model: 'allow_become',
        hint: 'Allow AppointmentGuru customer support access to your account so that they can perform actions on your behalf'
      }];
    },
    socialsForm: function socialsForm() {
      return [{
        label: 'Facebook page',
        model: 'facebook',
        hint: 'The url to your Facebook page'
      }, {
        label: 'Linkedin',
        model: 'linkedin',
        hint: 'The url to your linkedin page'
      }, {
        label: 'Instagram',
        model: 'instagram',
        hint: 'The url to your instagram account'
      }, {
        label: 'Twitter',
        model: 'twitter',
        hint: 'The url to your twitter profile'
      }];
    }
  }
});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnsplashSearch',
  data: function data() {
    return {
      snackbar: false,
      activeImg: false,
      loading: false,
      resource: 'practitioner.me.profile',
      reqId: 'practitioner-settings-update',
      searchString: 'wellness',
      searchResponse: {}
    };
  },
  mounted: function mounted() {
    this.search();
  },

  computed: {
    images: function images() {
      return this.getObjectPath(this.searchResponse, 'data.results', []);
    },
    perPage: function perPage() {
      return 24;
    },
    saveRequest: function saveRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.saveRequest.status;
    },
    me: function me() {
      return this.$store.getters.me;
    }
  },
  watch: {
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200) {
        this.snackbar = true;
        this.saving = false;
        this.activeImg = 0;
      }
    }
  },
  methods: {
    search: function search() {
      var payload = {
        headers: {
          Authorization: 'Client-ID e844ef6b655e466ae6355a7ad45e990ca3f96928ad4fa9dc1e6a3939592a3039'
        }
      };
      var vm = this;
      vm.loading = true;
      var url = 'https://api.unsplash.com/search/photos?query=' + this.searchString + '&orientation=landscape&per_page=' + this.perPage;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, payload).then(function (data) {
        vm.searchResponse = data;
        vm.loading = false;
      });
    },
    save: function save(img) {
      this.activeImg = img.id;
      this.saving = true;
      var url = this.getObjectPath(img, 'urls.regular', null);
      if (url) {
        var payload = {
          background_picture: url.replace('https:', '')
        };
        this.$appointmentguru.resource(this.resource).id(this.reqId).save(this.me.id, payload);
      }
    }
  }
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_InlineLocationPicker_vue__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_InlineLocationPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_InlineLocationPicker_vue__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentTypes',
  components: {},
  props: {
    service: { type: Object },
    withTitle: { type: Boolean, default: true },
    withCancel: { type: Boolean, default: false },
    errors: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      valid: false,
      reqId: 'products-update-save-request',
      product: {
        locations: []
      }
    };
  },

  computed: {
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    me: function me() {
      return this.$store.getters.me;
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    currency: function currency() {
      return this.defaultCurrency;
    },
    isValid: function isValid() {
      return this.valid && this.product && this.product.locations && this.product.locations.length > 0;
    },
    nextRequired: function nextRequired() {
      if (this.isValid) {
        return null;
      }
      if (!this.product.title) {
        return 'Product needs a name';
      }
      if (!this.product.duration) {
        return 'How long?';
      }
      if (!this.product.price) {
        return 'How much?';
      }
      if (this.product.locations && this.product.locations.length === 0) {
        return 'Where?';
      }
      return null;
    },
    fields: function fields() {
      var _this = this;

      return [{
        text: 'Name',
        value: 'title',
        hint: 'e.g.: Initial consultation, follow-up consultation, 45 minute therapy session',
        containerAttrs: { xs12: true }
      }, {
        text: 'Duration',
        value: 'duration',
        hint: 'How long is this appointment type (in minutes)',
        attrs: {
          suffix: 'mins',
          type: 'number'
        },
        containerAttrs: { xs6: true, class: 'pr-2' }
      }, {
        text: 'Price',
        value: 'price',
        hint: 'We\'ll use this to set the default price. You can edit the price on individual appointments',
        attrs: {
          type: 'number',
          prefix: this.currency
        },
        containerAttrs: { xs6: true, class: 'pl-2' }
      }, {
        text: 'Location',
        value: 'locations',
        multiple: true,
        attrs: {
          spaceId: this.service.id,
          label: 'Locations',
          hint: 'From which locations is this appointment type available?'
        },
        events: {
          add: function add() {
            _this.$emit('add:location');
          }
        },
        component: __WEBPACK_IMPORTED_MODULE_0__components_pickers_InlineLocationPicker_vue___default.a,
        containerAttrs: { xs12: true, class: 'pl-2' }
      }];
    }
  },
  watch: {
    requestStatus: function requestStatus() {
      if (this.requestStatus === 201) {
        this.clear();
        this.$emit('created', this.requestStatus.result);
      }
    }
  },
  methods: {
    clear: function clear() {
      var vm = this;
      this.fields.forEach(function (element) {
        vm.product[element.value] = null;
      });
    }
  }
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationAssign',
  props: {
    location: { type: Object },
    space: { type: Object }
  },
  data: function data() {
    return {
      selected: [],
      setproducts: {
        resource: 'ag.addresses',
        extra: 'actions/set_products',
        method: 'post'
      }
    };
  },

  watch: {
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        this.$emit('saved', this.setproducts.result);
      }
    },

    locationId: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        this.selected = this.products.filter(function (product) {
          return product.locations.indexOf(_this.locationId) > -1;
        }).map(function (product) {
          return product.id;
        });
      }
    }
  },
  computed: {
    locationId: function locationId() {
      return this.getObjectPath(this.location, 'id');
    },
    products: function products() {
      return this.getObjectPath(this.space, 'products', []);
    },
    requestStatus: function requestStatus() {
      return this.setproducts.status;
    }
  },
  methods: {
    save: function save() {
      this.setproducts.resourceId = this.locationId;
      this.setproducts.data = {
        new_space: this.space.id,
        set_products: this.selected.join(',')
      };
      this.$request('save', this.setproducts);
    }
  }
});

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LocationEdit_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LocationEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LocationEdit_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationCreate',
  components: { LocationEdit: __WEBPACK_IMPORTED_MODULE_0__LocationEdit_vue___default.a },
  props: {
    spaceId: { required: true },
    withClose: { type: Boolean, default: true },
    touch: { required: false }
  },
  data: function data() {
    return {
      window: 0,
      location: { id: null, name: '' },
      req: { resource: 'ag.spaces.addresses' }
    };
  },

  watch: {
    createStatus: function createStatus() {
      if (this.createStatus === 201) {
        this.location = this.req.result;
        this.window++;
        this.$emit('created', this.req.result);
      }
    },
    touch: function touch() {
      this.clear();
    }
  },
  computed: {
    payload: function payload() {
      return {
        name: this.location.name,
        space: this.spaceId
      };
    },
    createStatus: function createStatus() {
      return this.req.status;
    }
  },
  methods: {
    clear: function clear() {
      this.location = { name: '' };
      this.window = 0;
    },
    create: function create() {
      this.req.data = this.payload;
      this.req.kwargs = { spaceId: this.spaceId };
      this.$request('save', this.req);
    },
    bubbleClose: function bubbleClose() {
      if (this.location && this.location.latitude) {
        this.$emit('close');
      } else {
        window.alert('Please find your location using Google maps before exiting');
      }
    }
  }
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_AddressPicker__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_AddressPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pickers_AddressPicker__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationView',
  components: { AddressPicker: __WEBPACK_IMPORTED_MODULE_0__components_pickers_AddressPicker___default.a },
  props: {
    location: { type: Object, default: function _default() {
        return { address: {} };
      } },
    title: { type: String }
  },
  data: function data() {
    return {
      place: {},
      showDetails: false,
      showDeleteConfirmation: false,
      confirmDelete: null,
      reqId: 'update-service-request',
      address: {
        id: 0,
        name: '',
        address: '',
        latitude: '',
        longitude: '',
        place_data: {},
        place_id: ''
      }
    };
  },
  mounted: function mounted() {
    this.reloadData();
  },

  watch: {
    place: function place() {
      if (this.place) {
        this.showDetails = true;
        if (!this.address.name) {
          this.address.name = this.place.name;
        }
        this.address.address = this.place.formatted_address;
        this.address.place_id = this.place.id;
        this.address.place_data = this.place;
        if (this.place.geometry && this.place.geometry.location) {
          this.address.latitude = this.place.geometry.location.lat();
          this.address.longitude = this.place.geometry.location.lng();
        }
      }
    },
    location: function location() {
      this.reloadData();
    }
  },
  computed: {
    hideDetails: function hideDetails() {
      return this.location && this.location.address && this.location.address !== '{}' && this.location.address !== '';
    },
    extraInfoNotes: function extraInfoNotes() {
      if (this.address.is_online) {
        return 'Any extra information people might need in order connect with you (optional)';
      } else {
        return 'Any extra information people might need in order find this location (optional)';
      }
    },
    updateRequest: function updateRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    errors: function errors() {
      var data = {
        'address': [],
        'latitude': [],
        'longitude': []
      };
      if (this.updateRequest.status === 400) {
        data = this.getObjectPath(this.updateRequest, 'result.data', data);
      }
      if (this.updateRequest.status > 499) {
        data['general'] = 'The remote server did not respond correctly. Please try again or contact support if the problem persists';
      }
      return data;
    }
  },
  methods: {
    reloadData: function reloadData() {
      if (this.location) {
        this.address = this.location;
        this.place = this.location.place_data;

        this.showDetails = !this.hideDetails;
      }
    }
  }
});

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationView',
  props: {
    location: { type: Object, default: function _default() {
        return { address: {} };
      } }
  },
  methods: {
    mapUrl: function mapUrl(addr) {
      var lat = addr.latitude;
      var lng = addr.longitude;
      return 'https://maps.googleapis.com/maps/api/staticmap?center=' + lat + ',' + lng + '&zoom=14&size=640x180&scale=2&markers=color:blue%7C' + lat + ',' + lng + '&key=AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY';
    }
  }
});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_SpacePicker_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_SpacePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_SpacePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MoveLocation',
  components: {
    SpacePicker: __WEBPACK_IMPORTED_MODULE_1__components_pickers_SpacePicker_vue___default.a
  },
  props: {
    value: { type: Object },
    fromSpace: { type: Object, required: true },
    withClose: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      action: 'move',
      window: 0,
      selectedSpace: null,
      moveProducts: [],
      assignProducts: [],
      selectedLocation: null,
      attrs: {
        returnObject: true
      },
      requests: {
        move: {
          resource: 'ag.spaces.practitioner',
          extra: 'actions/transfer_location',
          method: 'post'
        },
        setproducts: {
          resource: 'ag.addresses',
          extra: 'actions/set_products',
          method: 'post'
        }
      }
    };
  },

  methods: {
    getProducts: function getProducts(productIds) {
      var _this = this;

      if (!productIds) {
        return [];
      }

      return productIds.map(function (id) {
        return _this.getProductById(id);
      }).filter(function (product) {
        if (product) {
          return !product.archived;
        }
        return false;
      }).sort(function (a, b) {
        if (a.owner < b.owner) {
          return -1;
        }
        return 1;
      });
    },
    getLabel: function getLabel(product) {
      var label = product.title;
      if (product.owner) {
        var p = this.getPractitionerById(product.owner);
        if (p) {
          label = label + ' with ' + p.full_name;
        }
      }
      return label;
    },
    move: function move() {
      var data = {
        location: this.selectedLocation.id,
        new_space: this.toSpace.id
      };
      this.requests.move.data = data;
      this.requests.move.resourceId = this.fromSpace.id;
      this.$request('save', this.requests.move);
    },
    setProducts: function setProducts() {
      this.requests.setproducts.data = this.payload;
      this.requests.setproducts.resourceId = this.selectedLocation.id;
      this.$request('save', this.requests.setproducts);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        this.selectedLocation = this.value;
      }
    },
    moveRequestStatus: function moveRequestStatus() {
      if (this.moveRequestStatus === 200) {
        this.$emit('moved');
        this.window++;
      }
    },
    setProductStatus: function setProductStatus() {
      if (this.setProductStatus === 200) {
        this.$emit('setproducts');
        this.$emit('close');
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['spaces', 'getLocations', 'getSpaceById', 'getProductById', 'getPractitionerById']), {
    moveRequestStatus: function moveRequestStatus() {
      return this.requests.move.status;
    },
    setProductStatus: function setProductStatus() {
      return this.requests.setproducts.status;
    },
    title: function title() {
      if (this.selectedLocation) {
        var msg = 'Move location <b>' + this.selectedLocation.name + '</b>';
        if (this.toSpace) {
          msg += ' to <b>' + this.toSpace.title + '</b>';
        }
        return msg;
      }
    },
    payload: function payload() {
      var data = {};
      if (this.fromSpace && this.toSpace) {
        data = {
          old_space: this.fromSpace.id,
          new_space: this.toSpace.id
        };
        var assign = this.assignProducts;
        if (assign && assign.length > 0) {
          data['assign_products'] = assign.join(',');
        }
        var move = this.moveProducts;
        if (move && move.length > 0) {
          var key = 'move_products';
          if (this.action === 'copy') {
            key = 'copy_products';
          }
          data[key] = move.join(',');
        }
      }
      return data;
    },
    toSpace: function toSpace() {
      return this.selectedSpace;
    }
  })
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimeRangePicker__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimeRangePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TimeRangePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OperatingHours',
  components: { TimeRangePicker: __WEBPACK_IMPORTED_MODULE_1__TimeRangePicker___default.a },
  props: {
    value: { type: Object, default: function _default() {
        return {};
      } },
    autosave: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      rangePickerDialog: false,
      reqId: 'hrs-update-request',
      dow: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      dowLookup: ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'],
      activeStartTime: '09:00',
      activeEndTime: '09:00',
      activeRange: null,
      activeDay: null,
      editmode: false,
      originalEditRange: null,
      defaultMinStartTime: '01:00',
      minStartTime: '01:00',
      hours: {}
    };
  },
  mounted: function mounted() {
    this.hours = this.value;
  },

  watch: {
    value: function value() {
      this.hours = this.value;
    },
    hours: function hours() {
      this.$emit('input', this.hours);
    },
    watchString: function watchString() {
      if (this.autosave) {
        this.saveHours();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getSpaceById', 'getPractitionerById']), {
    space: function space() {
      return this.getSpaceById(this.hours.space);
    },
    practitioner: function practitioner() {
      return this.getPractitionerById(this.hours.practitioner_id);
    },
    servicesSaveHrsRequest: function servicesSaveHrsRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    watchString: function watchString() {
      var hours = this.hours;
      return '' + hours.mon + hours.tues + hours.wed + hours.thurs + hours.fri + hours.sat + hours.sun;
    }
  }),
  methods: {
    showAddHours: function showAddHours(dayKey) {
      this.activeDay = dayKey;
      this.editmode = false;
      this.rangePickerDialog = true;
      var hrs = this.hours[dayKey];
      if (hrs) {
        var lastRange = hrs.split('|').pop();
        var lastTime = lastRange.split('-').pop();
        this.activeStartTime = lastTime;
        this.minStartTime = lastTime;
      }
    },
    setHours: function setHours(dayKey, rangeString) {
      this.activeDay = dayKey;
      this.originalEditRange = rangeString;
      this.rangePickerDialog = true;
      this.editmode = true;
      if (rangeString) {
        this.activeStartTime = rangeString.split('-')[0];
        this.activeEndTime = rangeString.split('-')[1];
        this.minStartTime = this.defaultMinStartTime;
      }
    },
    getHours: function getHours(index) {
      try {
        return this.hours[this.dowLookup[index]].split('|');
      } catch (error) {
        return [];
      }
    },
    editHours: function editHours(dayKey, original, newHours) {
      this.hours[dayKey] = this.hours[dayKey].replace(original, newHours);
      this.rangePickerDialog = false;
    },
    addHours: function addHours(dayKey, formattedRange) {
      var hrs = this.hours[dayKey];
      if (hrs.length > 1) {
        this.hours[dayKey] = hrs + '|' + formattedRange;
      } else {
        this.hours[dayKey] = formattedRange;
      }
      this.rangePickerDialog = false;
    },
    deleteHours: function deleteHours(dayKey, hourString) {
      var hrs = this.hours[dayKey];
      hrs = hrs.replace('|' + hourString + '|', '');
      hrs = hrs.replace('|' + hourString, '');
      hrs = hrs.replace('' + hourString, '');
      this.hours[dayKey] = hrs;
    },
    saveHours: function saveHours() {
      var data = {
        'id': this.hours.id,
        'mon': this.hours.mon,
        'tues': this.hours.tues,
        'wed': this.hours.wed,
        'thurs': this.hours.thurs,
        'fri': this.hours.fri,
        'sat': this.hours.sat,
        'sun': this.hours.sun
      };


      this.$appointmentguru.resource('practitioner.services.hours').id(this.reqId).save(data.id, data);
    }
  }
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OperatingHours__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OperatingHours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OperatingHours__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OperatingHoursView',
  components: { OperatingHours: __WEBPACK_IMPORTED_MODULE_0__OperatingHours___default.a },
  props: {
    hours: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      edit: false
    };
  },

  methods: {
    format: function format(hrs) {
      if (!hrs || hrs === '') {
        return 'Not available for bookings';
      }
      return hrs.replace(/\|/g, ', ');
    }
  }
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CrudTable_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listitems_PractitionerListItem_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listitems_PractitionerListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_listitems_PractitionerListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_BackgroundSelector_vue__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_BackgroundSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_BackgroundSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_TextEditor_vue__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_TextEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ui_TextEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_CopyTextField_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_CopyTextField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_CopyTextField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_LocationPicker_vue__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pickers_LocationPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pickers_LocationPicker_vue__);










var ProductFields = ['title', 'is_online', 'duration', 'price', 'order', 'booking_notice_in_minutes', 'background_picture', 'description', 'notes', 'private', 'comes_to_you', 'locations'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductEdit',
  components: { CrudTable: __WEBPACK_IMPORTED_MODULE_1__components_CrudTable_vue___default.a, PractitionerListItem: __WEBPACK_IMPORTED_MODULE_2__components_listitems_PractitionerListItem_vue___default.a, CopyTextField: __WEBPACK_IMPORTED_MODULE_5__components_ui_CopyTextField_vue___default.a },
  props: {
    value: { type: Object, required: true }
  },
  data: function data() {
    return {
      showArchived: false,
      selectedPractitionerId: null,
      requestAction: 'saved',
      requests: {
        service: {
          products: 'products-update-save-request'
        }
      }
    };
  },
  mounted: function mounted() {
    if (!this.selectedPractitionerId) {
      this.selectedPractitionerId = this.meId;
    }
  },

  methods: {
    extractFields: function extractFields(fields, data) {
      var payload = {};
      fields.forEach(function (field) {
        payload[field] = data[field];
      });
      if (!payload.background_picture || payload.background_picture === '' || payload.background_picture === '{}') {
        delete payload.background_picture;
      }
      return payload;
    },
    practitionerFullName: function practitionerFullName(practitionerId) {
      var practitioner = this.$store.getters.getPractitionerById(practitionerId);
      if (practitioner) {
        return practitioner.full_name;
      }
      return practitionerId;
    },
    addProduct: function addProduct(data) {
      this.requestAction = 'added';
      var payload = this.extractFields(ProductFields, data);
      payload.service = this.serviceId;
      payload.practitioner = this.selectedPractitionerId;
      if (payload.locations === '') {
        payload.locations = [];
      }

      if (!Array.isArray(payload.locations)) {
        payload.locations = [payload.locations];
      }
      if (payload.is_online === '') {
        payload.is_online = false;
      }
      if (payload.private === '') {
        payload.private = false;
      }
      if (payload.comes_to_you === '') {
        payload.comes_to_you = false;
      }
      if (payload.background_picture === '' || payload.background_picture === '{}') {
        delete payload.background_picture;
      }
      payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
      this.$appointmentguru.resource('practitioner.services.products').id(this.requests.service.products).create(payload);
    },
    editProduct: function editProduct(data) {
      this.requestAction = 'saved';
      var payload = this.extractFields(ProductFields, data);
      this.$appointmentguru.resource('practitioner.services.products').id(this.requests.service.products).save(data.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
    },
    deleteProduct: function deleteProduct(data) {
      this.requestAction = 'deleted';

      this.$appointmentguru.resource('practitioner.services.products').id(this.requests.service.products).delete(data.id);
    },
    requestOK: function requestOK(result) {
      this.$emit(this.requestAction, result);
    },
    itemsChanged: function itemsChanged(items) {
      this.products = items;
    }
  },
  computed: {
    service: function service() {
      return this.value;
    },
    serviceId: function serviceId() {
      return this.getObjectPath(this.service, 'id');
    },
    members: function members() {
      return this.getObjectPath(this.service, 'practitioners', []);
    },
    filteredProducts: function filteredProducts() {
      var _this = this;

      if (this.service && this.service.products) {
        return this.service.products.filter(function (p) {
          if (!_this.showArchived && p.archived) {
            return false;
          }
          return p.practitioner === _this.selectedPractitionerId;
        });
      }
      return [];
    },
    selectedPractitioner: function selectedPractitioner() {
      return this.$store.getters.getPractitionerById(this.selectedPractitionerId);
    },
    servicesSaveProductRequest: function servicesSaveProductRequest() {
      return this.$store.getters.getRequestById(this.requests.service.products, true);
    },
    servicesSaveRequestStatus: function servicesSaveRequestStatus() {
      return this.servicesSaveRequest.status;
    },
    productHeaders: function productHeaders() {
      var currency = this.defaultCurrency;
      return [{
        text: 'Background',
        value: 'background_picture',
        component: __WEBPACK_IMPORTED_MODULE_3__components_ui_BackgroundSelector_vue___default.a,
        displayInTable: false,
        flex: { xs12: true, sm12: true }
      }, { text: 'Name', value: 'title', hint: 'e.g.: Initial consultation, follow-up consultation, 45 minute therapy session' }, {
        text: 'Duration',
        value: 'duration',
        flex: { xs12: true, sm6: true },
        hint: 'How long is this appointment type (in minutes)',
        suffix: 'mins',
        type: 'number'
      }, {
        text: 'Price',
        value: 'price',
        prefix: currency,
        type: 'number',
        flex: { xs12: true, sm6: true },
        hint: 'This is the default price for this appointment and will be set when the appointment is created. You can change the price later, and it will be adjusted automatically if you add ICD10 codes'
      }, {
        text: 'Order',
        value: 'order',
        type: 'number',
        flex: { xs12: true, sm6: true },
        displayInTable: false,
        hint: 'The order in which this should appear on your website and booking forms'
      }, {
        text: 'Booking notice',
        value: 'booking_notice_in_minutes',
        component: 'vselect',
        attrs: {
          items: [{ text: 'Same day', value: 0 }, { text: 'Next day', value: 1440 }, { text: '2 day', value: 2880 }]
        },
        hint: 'How much notice do you require for bookings placed online',
        flex: { xs12: true, sm6: true }
      }, {
        text: 'Locations',
        value: 'locations',
        component: __WEBPACK_IMPORTED_MODULE_6__components_pickers_LocationPicker_vue___default.a,
        attrs: {
          spaceId: this.serviceId,
          hint: 'At which locations is this appointment type available?',
          required: true
        }
      }, { component: 'vdivider', value: 'div-after-locations' }, {
        text: 'Description',
        value: 'description',
        type: 'text',
        flex: { xs12: true, sm6: true },
        attrs: {
          label: 'Description',
          initialAttrs: {
            hint: 'The description will show on your booking page. You can also use it in your notificiations: <code>{appointment.product.description}</code>'
          }
        },
        component: __WEBPACK_IMPORTED_MODULE_4__components_ui_TextEditor_vue___default.a,
        displayInTable: false
      }, {
        text: 'Notes',
        value: 'notes',
        type: 'text',
        component: __WEBPACK_IMPORTED_MODULE_4__components_ui_TextEditor_vue___default.a,
        attrs: {
          label: 'Notes',
          initialAttrs: {
            hint: 'Use notes to provide extra information about this appintment. e.g.: What to wear, what to expect, how to prepare. Ideal for adding extra information to your notifications <code>{appointment.product.notes}</code>'
          }
        },
        flex: { xs12: true, sm6: true },
        displayInTable: false
      }, {
        text: 'Online',
        value: 'is_online',
        type: 'boolean',
        flex: { xs12: true, sm6: true },
        component: 'vcheckbox',
        hint: 'Check this if this is a virtual appointment that occurs online (e.g.: with Zoom)'
      }, {
        text: 'Flexible location',
        flex: { xs12: true, sm6: true },
        value: 'comes_to_you',
        type: 'boolean',
        component: 'vcheckbox',
        hint: 'Check this if the location for this appontment can vary. For example: a house call or a meeting in a coffee shop'
      }, {
        text: 'Private',
        value: 'private',
        type: 'boolean',
        component: 'vcheckbox',
        hint: 'Private appointments do not show up on your website or booking page, but you can send a direct booking link to a customer'
      }];
    }
  }
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpaceSettings_vue__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpaceSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SpaceSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_ProductSheet_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_ProductSheet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_ProductSheet_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductWizard',
  components: {
    SpaceSettings: __WEBPACK_IMPORTED_MODULE_0__SpaceSettings_vue___default.a,
    ProductSheet: __WEBPACK_IMPORTED_MODULE_1__components_pickers_ProductSheet_vue___default.a
  },
  data: function data() {
    return {
      gotoSpace: null,
      showProductSheet: false,
      newspacedialog: false,
      newspaceloading: false,
      spacetitle: null,
      requests: {
        practitioner: 'practitioner-get-request',
        service: {
          new: 'new-service-request',
          list: {
            resource: 'ag.spaces.practitioner.v2'
          }
        }
      }
    };
  },

  watch: {
    servicesRequestStatus: function servicesRequestStatus() {
      var _this = this;

      console.log(this.servicesRequestStatus);
      if (this.servicesRequestStatus === 200) {
        if (this.gotoSpace) {
          window.setTimeout(function () {
            var anchor = '#space-' + _this.gotoSpace;
            _this.$vuetify.goTo(anchor);
            _this.gotoSpace = null;
          }, 500);
        }
      }
    }
  },
  computed: {
    servicesRequest: function servicesRequest() {
      return this.requests.service.list;
    },
    servicesRequestStatus: function servicesRequestStatus() {
      return this.servicesRequest.status;
    },
    services: function services() {
      return this.getObjectPath(this.requests.service.list, 'result.results', []);
    },
    servicesNewRequest: function servicesNewRequest() {
      return this.$store.getters.getRequestById(this.requests.service.new, true);
    }
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    reload: function reload() {
      this.$request('get', this.requests.service.list);
      this.refreshGlobalSettings();
    },
    newService: function newService() {
      var options = { id: this.requests.service.new };
      options.data = { name: this.spacetitle };
      this.$appointmentguru.endpoint('location.touch', options);
    },
    newSpaceCreated: function newSpaceCreated(result) {
      this.reload();
      this.newspacedialog = false;

      var id = this.getObjectPath(result, 'result.data.id');
      if (id) {
        this.gotoSpace = id;
      }
    },
    logout: function logout() {
      this.$store.dispatch('LOGOUT');
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationView__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LocationView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationEdit__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LocationEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MoveLocation_vue__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MoveLocation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MoveLocation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationCreate_vue__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LocationCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationAssign_vue__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationAssign_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LocationAssign_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductEdit_vue__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ProductEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_invoice_manage_InvoiceSettings_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_invoice_manage_InvoiceSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_invoice_manage_InvoiceSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_settings_media_Uploader_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_settings_media_Uploader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_settings_media_Uploader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ui_ImageSearch__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ui_ImageSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ui_ImageSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_Integrations_Yoco_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_Integrations_Yoco_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_Integrations_Yoco_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OperatingHoursView_vue__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OperatingHoursView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__OperatingHoursView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_RequestStatus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_RequestStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_RequestStatus_vue__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpaceSettings',
  components: {
    LocationView: __WEBPACK_IMPORTED_MODULE_1__LocationView___default.a,
    LocationEdit: __WEBPACK_IMPORTED_MODULE_2__LocationEdit___default.a,
    MoveLocation: __WEBPACK_IMPORTED_MODULE_3__MoveLocation_vue___default.a,
    LocationCreate: __WEBPACK_IMPORTED_MODULE_4__LocationCreate_vue___default.a,
    LocationAssign: __WEBPACK_IMPORTED_MODULE_5__LocationAssign_vue___default.a,
    ProductEdit: __WEBPACK_IMPORTED_MODULE_6__ProductEdit_vue___default.a,
    InvoiceSettings: __WEBPACK_IMPORTED_MODULE_7__components_invoice_manage_InvoiceSettings_vue___default.a,
    Yoco: __WEBPACK_IMPORTED_MODULE_10__components_pages_Integrations_Yoco_vue___default.a,
    OperatingHoursView: __WEBPACK_IMPORTED_MODULE_12__OperatingHoursView_vue___default.a,
    ImageSearch: __WEBPACK_IMPORTED_MODULE_9__components_ui_ImageSearch___default.a,
    Uploader: __WEBPACK_IMPORTED_MODULE_8__components_pages_settings_media_Uploader_vue___default.a,
    RequestStatus: __WEBPACK_IMPORTED_MODULE_13__ui_RequestStatus_vue___default.a
  },
  props: {
    value: { type: Object, required: true },
    initiallyExpanded: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      expand: false,
      edittitle: false,
      logoDialog: false,
      backgroundDialog: false,
      invoicesettingsDialog: false,
      configureYocoDialog: false,
      showDeleteLocation: false,
      showDeleteConfirmation: false,
      showCreateLocation: false,
      showMoveLocation: false,
      showAssignLocation: false,
      activeIndex: 0,
      selectedSpace: null,
      selectedAddress: null,
      locationComponent: 'LocationView',
      hoursComponent: 'OperatingHoursView',
      requests: {
        practitioner: 'practitioner-get-request',
        space: { resource: 'ag.spaces.practitioner' },
        address: { resource: 'ag.addresses' },
        service: {
          list: 'list-service-request',
          new: 'new-service-request',
          update: 'update-service-request',
          archive: 'archive-service-request',

          products: 'produts-update-save-request',
          settings: { resource: 'ag.spaces.settings' }
        }
      },
      invoicesettingfields: ['banking_details', 'billing_address', 'invoice_notes', 'receipt_notes'],
      selectedPractitionerId: null
    };
  },
  mounted: function mounted() {
    if (this.initiallyExpanded) {
      this.expand = true;
    }
  },

  methods: {
    saveBackground: function saveBackground() {
      var data = { background_picture: this.settings.background_picture };
      this.saveSettings(data);
      this.backgroundDialog = false;
    },
    saveTitle: function saveTitle() {
      var data = { title: this.service.title };
      this.saveSpace(data);
    },
    archiveSpace: function archiveSpace() {
      this.$appointmentguru.resource('practitioner.services').id(this.requests.service.archive).delete(this.serviceId);
    },
    spaceArchived: function spaceArchived() {
      this.$vuetify.goTo(1);
      this.$emit('reload');
    },
    saveAddress: function saveAddress(data) {
      var fields = ['name', 'address', 'latitude', 'longitude', 'place_data'];
      var payload = {};
      fields.forEach(function (field) {
        payload[field] = data[field];
      });

      this.$appointmentguru.resource('practitioner.services.address').id(this.requests.service.update).save(data.id, payload);
    },
    deleteAddress: function deleteAddress(addressId) {
      this.requests.address.resourceId = addressId;
      this.$request('delete', this.requests.address);
    },
    saveSpace: function saveSpace(data) {
      this.requests.space.resourceId = this.serviceId;
      this.requests.space.data = data;
      this.$request('save', this.requests.space);
    },
    saveSettings: function saveSettings(data) {
      this.requests.service.settings.resourceId = this.settingsId;
      this.requests.service.settings.kwargs = { spaceId: this.serviceId };
      this.requests.service.settings.data = data;
      this.$request('save', this.requests.service.settings);
    },
    reload: function reload() {
      this.$emit('reload');
    },
    showLocationDiaog: function showLocationDiaog(space, address, action) {
      this.selectedSpace = space;
      this.selectedAddress = address;
      if (action === 'move') {
        this.showMoveLocation = true;
      }
      if (action === 'assign') {
        this.showAssignLocation = true;
      }
      if (action === 'delete') {
        this.showDeleteLocation = true;
      }
    }
  },
  watch: {
    members: {
      immediate: true,
      handler: function handler() {
        if (this.members && this.members.length > 0) {
          this.selectedPractitionerId = this.members[0].id;
        } else {
          this.selectedPractitionerId = this.meId;
        }
      }
    },
    showMoveLocation: function showMoveLocation() {
      if (this.showMoveLocation === false) {
        this.$emit('reload');
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapGetters */])(['getPractitionerById', 'getIntegration']), {
    service: function service() {
      return this.value;
    },
    serviceId: function serviceId() {
      return this.getObjectPath(this.service, 'id', null);
    },
    spaceId: function spaceId() {
      return this.serviceId;
    },
    members: function members() {
      return this.getObjectPath(this.service, 'practitioners', null);
    },
    integrations: function integrations() {
      return this.getObjectPath(this.service, 'integrations', []);
    },
    settings: function settings() {
      return this.getObjectPath(this.service, 'settings', {});
    },
    settingsId: function settingsId() {
      return this.getObjectPath(this.settings, 'id', null);
    },
    yocoIntegration: function yocoIntegration() {
      return this.integrations.find(function (i) {
        return i.title === 'Yoco';
      });
    },
    yocoIntegrationLink: function yocoIntegrationLink() {
      return this.getObjectPath(this.yocoIntegration, 'settings.link');
    },
    logoUploadPath: function logoUploadPath() {
      return '/api/v3/spaces/' + this.service.id + '/settings/' + this.settings.id + '/';
    },
    practitionerRequest: function practitionerRequest() {
      return this.$store.getters.getRequestById(this.requests.practitioner, true);
    },
    servicesSaveRequest: function servicesSaveRequest() {
      return this.$store.getters.getRequestById(this.requests.service.update, true);
    },
    servicesArchiveRequest: function servicesArchiveRequest() {
      return this.$store.getters.getRequestById(this.requests.service.archive, true);
    },
    servicesSaveProductRequest: function servicesSaveProductRequest() {
      return this.$store.getters.getRequestById(this.requests.service.products, true);
    },
    servicesSaveRequestStatus: function servicesSaveRequestStatus() {
      return this.servicesSaveRequest.status;
    },
    servicesArchiveRequestStatus: function servicesArchiveRequestStatus() {
      return this.servicesArchiveRequest.status;
    },
    servicesSaveHrsRequestStatus: function servicesSaveHrsRequestStatus() {
      return this.servicesSaveHrsRequest.status;
    },
    servicesSaveProductRequestStatus: function servicesSaveProductRequestStatus() {
      return this.servicesSaveProductRequest.status;
    },
    practitioner: function practitioner() {
      return this.$store.getters.me;
    },
    numServices: function numServices() {
      if (this.service) {
        return this.services.length;
      }
      return 0;
    }
  })
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
  name: 'OperatingHours',
  props: {
    minStartTime: { type: String, default: '01:00' },
    initialStartTime: { type: String, default: null, required: false },
    initialEndTime: { type: String, default: null, required: false },
    initialPeriodInMins: { type: Number, default: 30, required: false },
    periodInMins: { type: Number, default: 15, required: false },
    value: { type: String, default: '' }
  },
  data: function data() {
    return {
      startTime: null,
      endTime: null
    };
  },

  methods: {
    toMoment: function toMoment(timeString) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()('2017-11-20 ' + timeString);
    },
    hourSlots: function hourSlots(min, max, periodInMins) {
      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()('2017-11-20 ' + min);
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()('2017-11-20 ' + max);
      var time = start;
      var times = [time.format('HH:mm')];
      if (time && end && periodInMins && periodInMins > 0 && time.isBefore(end)) {
        while (time.isBefore(end)) {
          time = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time.add(periodInMins, 'minutes'));
          times.push(time.format('HH:mm'));
        }
      }
      return times;
    }
  },
  computed: {
    timeRange: function timeRange() {
      if (this.startTime && this.endTime) {
        return this.startTime + '-' + this.endTime;
      }
      return null;
    }
  },
  watch: {
    timeRange: function timeRange() {
      if (this.timeRange) {
        this.$emit('input', this.timeRange);
      }
    },
    initialStartTime: function initialStartTime() {
      this.startTime = this.initialStartTime;
    },
    initialEndTime: function initialEndTime() {
      this.endTime = this.initialEndTime;
    },
    initialPeriodInMins: function initialPeriodInMins() {
      this.periodInMins = this.initialPeriodInMins;
    },
    startTime: function startTime() {
      var startMoment = this.toMoment(this.startTime);
      var endMoment = this.toMoment(this.endTime);
      if (startMoment.isSameOrAfter(endMoment)) {
        this.endTime = this.startTime;
      }
    }
  }
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Uploader',
  props: {
    title: { type: String, default: 'Drag and Drop files here' },
    subtitle: { type: String },
    uploadPath: { type: String, required: false },
    filename: { type: String, default: 'file' }
  },
  data: function data() {
    return {
      hovering: false,
      id: Math.random().toString().split('.')[1],
      file: null,
      images: [],
      uploading: false,
      uploadSuccess: false
    };
  },

  methods: {
    l: function l(name) {
      console.log(name);
    },
    setHover: function setHover(onOff) {
      this.hovering = onOff;
    },
    previewFile: function previewFile(file) {
      var reader = new FileReader();
      var vm = this;
      reader.readAsDataURL(file);
      vm.images = [];
      vm.file = file;
      reader.onloadend = function () {
        vm.images.push(reader.result);
      };
    },
    drop: function drop(e) {
      var dt = e.dataTransfer;
      var files = dt.files;
      this.handleFiles(files);
      this.hovering = false;
    },
    filesSelected: function filesSelected(e) {
      this.handleFiles(e.currentTarget.files);
    },
    handleFiles: function handleFiles(files) {
      files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files));
      files.forEach(this.previewFile);
    },
    uploadFile: function uploadFile() {
      var file = this.file;
      var formData = new FormData();
      var vm = this;
      formData.append(this.filename, file);
      var base = "https://v2.appointmentguru.co";
      var url = base + '/api/v2/practitioner/me/profile/' + this.me.id + '/';
      if (this.uploadPath) {
        url = '' + base + this.uploadPath;
      }
      console.log(url);

      vm.uploading = true;

      var config = {
        headers: {
          'authorization': 'Bearer ' + vm.$store.getters.token
        }
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(url, formData, config).then(function (data) {
        vm.$emit('uploadsuccess', data);
        vm.uploading = false;
        vm.uploadSuccess = true;
      }).catch(function () {
        vm.$emit('uploadfailure');
        vm.uploading = false;
        vm.uploadSuccess = false;
      });
    }
  },
  computed: {
    classList: function classList() {
      if (this.hovering) {
        return ['highlight'];
      }
    },
    me: function me() {
      return this.$store.getters.me;
    }
  }
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddressPicker',
  data: function data() {
    return {
      inited: false,
      location: {},
      addressString: null,
      loading: true,
      failed: false
    };
  },

  props: {
    apiKey: { type: String, required: false, default: 'AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY' },
    id: {
      type: String,
      default: function _default() {
        return Math.random().toString().split('.')[1];
      }
    },
    value: { type: Object, default: function _default() {
        return {};
      } },
    withSummary: { type: Boolean, default: false }
  },
  mounted: function mounted() {
    this.createGoogleMaps().then(this.initAutoComplete, this.googleMapsFailedToLoad);
  },

  computed: {
    geometry: function geometry() {
      return this.getObjectPath(this.location, 'geometry.location', null);
    },
    lat: function lat() {
      if (this.geometry) {
        return this.geometry.lat();
      }
      return null;
    },
    lng: function lng() {
      if (this.geometry) {
        return this.geometry.lng();
      }
      return null;
    }
  },
  methods: {
    start: function start() {
      if (!this.inited) {
        this.initAutoComplete();
      }
    },
    initAutoComplete: function initAutoComplete() {
      var el = document.getElementById(this.id);
      this.autocomplete = new google.maps.places.Autocomplete(el);
      this.autocomplete.addListener('place_changed', this.addressChanged);
      this.geolocate();
      this.loading = false;
      this.$emit('autocompleteinited', this.autocomplete);
      this.inited = true;
    },
    googleMapsFailedToLoad: function googleMapsFailedToLoad(result) {
      console.log(result);
      this.failed = true;
      this.$emit('gmapserror', result);
      console.warn('Could not load google maps');
    },
    createGoogleMaps: function createGoogleMaps() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var gmapsId = 'google-maps-api';
        if (!document.getElementById(gmapsId)) {
          var gmap = document.createElement('script');
          gmap.src = 'https://maps.googleapis.com/maps/api/js?key=' + _this.apiKey + '&libraries=places';
          gmap.type = 'text/javascript';
          gmap.id = gmapsId;
          gmap.onload = resolve;
          gmap.onerror = reject;
          document.body.appendChild(gmap);
        }
      });
    },
    geolocate: function geolocate() {
      var vm = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          });
          if (vm.autocomplete) {
            vm.autocomplete.setBounds(circle.getBounds());
          }
          vm.$emit('geolocationset', circle.getBounds());
        });
      }
    },
    addressChanged: function addressChanged() {
      this.location = this.autocomplete.getPlace();
      this.$emit('input', this.location);
    }
  }
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_filters_AppointmentFilters_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_filters_AppointmentFilters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_filters_AppointmentFilters_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentPicker',
  components: {
    AppointmentList: __WEBPACK_IMPORTED_MODULE_1__components_lists_AppointmentList_vue___default.a,
    AppointmentFilters: __WEBPACK_IMPORTED_MODULE_0__components_filters_AppointmentFilters_vue___default.a
  },
  props: {
    value: { required: false },
    relationship: { type: Object },
    initialWindow: { type: Number, default: 0 },
    fetchTrigger: { type: Number, default: 0 },
    ordering: { type: String, default: 'client_id,relationships,practitioner_id,-start_time' },
    clearDateRange: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    initialPageSize: { type: Number, default: 20 },
    withFullscreen: { type: Boolean, default: false },
    withRelationshipQuickPick: { type: Boolean, default: false },
    fullscreen: { type: Boolean, default: false },
    withPrice: { type: Boolean, default: false },
    withSelectAction: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    mini: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      window: 0,
      datepickervisible: false,
      selectedItem: null,
      appointments: [],
      selected: [],
      numResults: null,
      pageSize: 20,
      client: {},
      request: { status: 0 },
      filters: {}
    };
  },

  watch: {
    selected: function selected() {
      this.$emit('input', this.selected);
    },
    relationshipId: function relationshipId() {
      if (this.relationshipId && this.initialWindow > 0) {
        this.window = this.initialWindow;
      }
    },
    requestStatus: function requestStatus() {
      if (this.requestStatus > 0) {
        this.$emit('ready');
      }
    },
    fetchTrigger: function fetchTrigger() {
      this.get();
    }
  },
  computed: {
    facets: function facets() {
      return this.getObjectPath(this.request, 'result.facets', {});
    },
    relationshipId: function relationshipId() {
      if (this.relationship && this.relationship.id) {
        return this.relationship.id;
      }
      return null;
    },
    col1layoutclasses: function col1layoutclasses() {
      var classes = [];
      if (this.compact === true) {
        classes = ['xs12'];
      } else {
        classes = ['xs12', 'sm5', 'md5', 'lg3'];
      }
      if (this.$vuetify.breakpoint.smAndUp) {
        classes.push('pa-0');
      }
      return classes;
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    }
  },
  mounted: function mounted() {
    if (this.compact) {
      this.window = 0;
      if (this.initialWindow > 0) {
        this.window = this.initialWindow;
      }
    }
    if (this.initialPageSize) {
      this.pageSize = this.initialPageSize;
    }
  },

  methods: {
    setCount: function setCount(cnt) {
      this.numResults = cnt;
    },
    toggleFullScreen: function toggleFullScreen() {
      var fs = !this.fullscreen;
      this.$emit('update:fullscreen', fs);
    },
    get: function get() {
      this.$request('get', this.request);
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Select appointments',
        daterange: {
          subtitle: 'Change active date range'
        },
        client: {
          subtitle: 'Selected client'
        }
      }
    }
  }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BirthdayPicker',
  props: {
    value: { type: String }
  },
  data: function data() {
    return {
      date: '1975',
      displayType: 'year'
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.date = this.value;
        }
      }
    },
    date: function date() {
      this.$emit('input', this.date);
    }
  }
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_btns_InviteBtn_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_btns_InviteBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_btns_InviteBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CalendarTabs',
  components: { InviteBtn: __WEBPACK_IMPORTED_MODULE_3__components_btns_InviteBtn_vue___default.a },
  props: {
    value: { type: Object },
    facets: { type: Object },
    loading: { type: Boolean, default: false },
    dark: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      activeTab: 0,
      searchString: '',
      selected: null,
      selectedSpace: null,
      mobileSelectCalendar: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['me', 'meId', 'getSpacesByPractitionerId']), {
    myMemberships: function myMemberships() {
      return this.getSpacesByPractitionerId(this.meId);
    },
    colleagues: function colleagues() {
      return this.$store.getters.getColleagues;
    },
    colleagueIds: function colleagueIds() {
      if (this.colleagues) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.colleagues);
      }
      return [];
    },
    profilePicture: function profilePicture() {
      return this.getProfilePicture(this.me);
    },
    selectedProfilePicture: function selectedProfilePicture() {
      return this.getProfilePicture(this.selected);
    },
    selectedFullName: function selectedFullName() {
      var fn = this.getObjectPath(this.selected, 'full_name');
      if (!fn) {
        fn = this.formatFullName(this.selected);
      }
      return fn;
    }
  }),
  watch: {
    selectedSpace: function selectedSpace() {
      this.$emit('space', this.selectedSpace);
    },

    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.selected = this.value;
        }
      }
    }
  },
  methods: {
    setSelected: function setSelected(practitioner) {
      this.selected = practitioner;
      this.$emit('input', practitioner);
    },
    setSelectedSpace: function setSelectedSpace(id) {
      if (this.selectedSpace === id) {
        this.selectedSpace = null;
      } else {
        this.selectedSpace = id;
      }
    },
    newAppointment: function newAppointment(practitioner) {
      var _this = this;

      if (practitioner) {
        this.setSelected(practitioner);
      }
      var vm = this;
      if (this.selected && this.selected.id) {
        console.log('active practitioner', this.selected.id);
        window.setTimeout(function () {
          vm.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_constants__["j" /* SET_SETTING */], ['activePractitioner', _this.selected]);
        }, 100);
      }
      this.openGlobalDialog(true, 'QuickCreate');
    }
  }
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_client_ClientList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_Create__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_Create__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientPickerDialog',
  components: { ClientList: __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList___default.a, ClientCreate: __WEBPACK_IMPORTED_MODULE_1__components_client_Create___default.a },
  props: {
    value: { type: Object },
    initial: { type: Number, default: 10 },
    page: { type: Number, default: 25 },
    spaceId: { required: false },
    includeOwnedByMe: { type: Boolean, default: true },
    withHeader: { type: Boolean, default: true },
    showListInitially: { type: Boolean, default: true },
    canClearSpace: { type: Boolean, default: true },
    title: { type: String, default: 'Choose a client' },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      activeComponent: __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList___default.a,
      searchString: '',
      componenttouch: 1
    };
  },
  mounted: function mounted() {
    this.limit = this.initial;
  },

  methods: {
    reset: function reset() {
      this.activeComponent = __WEBPACK_IMPORTED_MODULE_0__components_client_ClientList___default.a;
      this.searchString = '';
    },
    clientSelected: function clientSelected(client) {
      this.$emit('clientselected', client);
      this.$emit('input', client);
    },
    relationshipSelected: function relationshipSelected(rel) {
      this.$emit('relationshipselected', rel);
    },
    setComponent: function setComponent(component) {
      this.componenttouch++;
      this.activeComponent = component;
    },
    clientCreated: function clientCreated(client) {
      var _this = this;

      this.$emit('relationshipselected', client);
      if (client.client) {
        client = client.client;
      }
      this.$emit('clientselected', client);
      this.$emit('input', client);
      setTimeout(function () {
        _this.activeComponent = 'ClientList';
      }, 100);
    }
  },
  watch: {
    touch: function touch() {
      this.componenttouch++;
      this.reset();
    }
  },
  computed: {
    clients: function clients() {
      return this.$store.getters.clients;
    },
    filteredClients: function filteredClients() {
      var clients = this.clients;
      var vm = this;
      if (vm.searchString && vm.searchString.length > 0) {
        clients = clients.filter(function (clientRel) {
          if (clientRel.client) {
            var client = clientRel.client;
            var index = client.first_name + ' ' + client.last_name + ' ' + client.email + ' ' + client.phone_number;
            return index.toLowerCase().indexOf(vm.searchString.toLowerCase()) !== -1;
          }
        });
      }
      return clients.slice(0, this.limit);
    }
  }
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DatePickerDialog',
  props: {
    value: { type: String },
    label: { type: String, default: 'Choose a date' },
    closeOnChange: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      showPicker: false,
      date: null
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.date = this.value;
    }
  },

  watch: {
    value: function value() {
      if (this.value) {
        this.date = this.value;
      }
    },
    date: function date() {
      this.$emit('input', this.date);
      if (this.closeOnChange) {
        this.$refs.dialog.save(this.date);
      }
    }
  }
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
  name: 'DateRangePicker',
  props: {
    value: { type: Object },
    initialFromDate: { type: String },
    initialToDate: { type: String },
    withClose: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: false },
    withMonthPicker: { type: Boolean, default: true },
    withOk: { type: Boolean, default: true },
    closeOnDone: { type: Boolean, default: true },
    title: { type: String, default: 'Choose a date range' },
    touch: { type: Number, default: 0 },
    clearTouch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      showFilters: false,
      fromDate: null,
      toDate: null,
      activeField: 'fromDate',
      pickerDate: null,
      selectedDate: [],
      calendarType: 'date',
      filters: ['This week', 'Last week', 'This month', 'Last month', 'Last 7 days', 'Last 14 days', 'Last 31 days']
    };
  },
  mounted: function mounted() {
    if (this.value) {
      if (this.value.from) {
        this.fromDate = this.value.from;
      }
      if (this.value.to) {
        this.toDate = this.value.to;
      }
    }
  },

  computed: {
    dateRangeString: function dateRangeString() {
      var str = 'No date selected';
      if (this.fromDate) {
        str = 'from ' + this.fromDate;
      }
      if (this.toDate) {
        var fromMoment = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.fromDate);
        var toMoment = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.toDate);
        var isSameMonth = fromMoment.month() === toMoment.month();
        console.log(fromMoment.month(), toMoment.month());
        if (isSameMonth) {
          str = fromMoment.format('ddd D') + ' to ' + toMoment.format('ddd D') + ' ' + fromMoment.format('MMM');
        } else {
          str = 'from ' + fromMoment.format('ddd D MMM') + ' to ' + this.dateformat(this.toDate);
        }
        var dayCount = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(toMoment.diff(fromMoment)).as('days') + 1;
        str += ' (' + dayCount + ' days)';
      }
      return str;
    },
    range: function range() {
      return {
        from: this.fromDate,
        to: this.toDate
      };
    },
    actions: function actions() {
      return [{
        id: 'clear',
        title: 'Clear',
        icon: 'close',
        onclick: this.reset
      }, {
        id: 'this-month',
        title: 'This month',
        icon: 'calendar_today',
        onclick: this.setMonth
      }];
    }
  },
  methods: {
    reset: function reset() {
      this.toDate = null;
      this.fromDate = null;
      this.activeField = 'fromDate';
    },
    ok: function ok() {
      this.$emit('input', this.range);
      this.$emit('close');
    },
    setMonthPicker: function setMonthPicker() {
      if (Array.isArray(this.selectedDate)) {
        if (this.selectedDate.length === 0) {
          this.selectedDate = null;
        } else {
          this.selectedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDate[0]).format('YYYY-MM');
        }
      }
      this.calendarType = 'month';
    },
    setDatePicker: function setDatePicker() {
      this.selectedDate = [];
      if (this.fromDate) {
        this.selectedDate.push(this.fromDate);
        this.pickerDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.fromDate).format('YYYY-MM');
      }
      if (this.toDate) {
        this.selectedDate.push(this.toDate);
      }
      if (!this.pickerDate) {
        this.pickerDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM');
      }
      var vm = this;
      window.setTimeout(function () {
        vm.pickerDate = null;
      }, 100);
      this.calendarType = 'date';
    },
    setMonth: function setMonth(selectedDate) {
      if (!selectedDate) {
        selectedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM');
      }
      var startDate = selectedDate + '-01';
      var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).endOf('month').format('YYYY-MM-DD');
      this.fromDate = startDate;
      this.toDate = endDate;
    },
    setDateRange: function setDateRange(selectedDate) {
      if (!this.selectedDate || this.selectedDate.length === 0) {
        return;
      }
      if (selectedDate.length === 1) {
        this.fromDate = selectedDate;
        return;
      }
      if (this.selectedDate.length > 2) {
        this.selectedDate = this.selectedDate.slice(1);
      }
      this.fromDate = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.min(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDate[0]), __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDate[1])).format('YYYY-MM-DD');
      this.toDate = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.max(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDate[0]), __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDate[1])).format('YYYY-MM-DD');
    }
  },
  watch: {
    selectedDate: function selectedDate() {
      if (this.selectedDate) {
        if (this.calendarType === 'month') {
          this.setMonth(this.selectedDate);
        }
        if (this.calendarType === 'date') {
          this.setDateRange(this.selectedDate);
        }
      }
    },
    clearTouch: function clearTouch() {
      this.reset();
    },
    range: function range() {
      if (!this.withOk) {
        this.$emit('input', this.range);
      }
    }
  }
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_DataList__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_DataList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_DataList__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupedPractitionerPicker',
  components: { DataList: __WEBPACK_IMPORTED_MODULE_0__components_ui_DataList___default.a },
  props: {
    groups: { type: Array, default: function _default() {
        return [];
      } },
    withActivate: { type: Boolean, default: true }
  },
  methods: {
    emitSelected: function emitSelected(item) {
      this.$emit('selected', item);
    }
  }
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IcdPicker',
  props: {
    value: { type: Object, default: null },
    touch: { type: Number, default: 0 },
    initialSearchString: { type: String, default: null },
    maxSuggestions: { type: Number, default: 15 },
    withSuggestions: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      selected: null,
      multiselected: [],
      selectMultiple: false,
      filtermit: true,
      limit: 10,
      searchReqId: 'icd10-search-request',
      suggestionsReqId: 'suggestionsReqId',
      searchString: null
    };
  },
  mounted: function mounted() {
    this.search();
    if (this.suggestions && this.suggestions.length === 0) {
      this.getSuggestions();
    }
  },

  methods: {
    selectItem: function selectItem(item) {
      this.selected = item;
      if (!item.name) {
        return;
      }

      if (!this.selectMultiple) {
        this.$emit('input', item);
      } else {
        var exists = this.multiselected.find(function (codeItem) {
          return codeItem.name === item.name;
        });
        if (!exists) {
          this.multiselected.push(item);
          this.searchString = item.name;
        }
      }
    },

    getSuggestions: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
      this.$appointmentguru.resource('appointment.codes.suggestions').id(this.suggestionsReqId).list();
    }),
    reset: function reset() {
      this.multiselected = [];
      this.searchString = '';
      this.selected = null;
    },

    search: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
      if (this.searchString && this.searchString.length > 0) {
        var params = {
          search: this.searchString
        };
        if (this.filtermit) {
          params['codepacks'] = 1;
        }
        this.$codeguru.resource('code').id(this.searchReqId).list(params);
      }
    }, 500)
  },
  watch: {
    filtermit: function filtermit() {
      this.search();
    },
    searchString: function searchString() {
      this.search();
    },
    initialSearchString: function initialSearchString() {
      this.searchString = this.initialSearchString;
    },
    touch: function touch() {
      this.reset();
    }
  },
  computed: {
    suggestions: function suggestions() {
      if (this.suggestionsRequest && this.suggestionsRequest.result && this.suggestionsRequest.result.data && this.suggestionsRequest.result.data.codes) {
        return this.suggestionsRequest.result.data.codes;
      }
      return [];
    },
    filteredSuggestions: function filteredSuggestions() {
      var _this = this;

      var hasSearchCriteria = this.searchString && this.searchString.length > 0;
      var results = this.suggestions.icd10;
      if (!results) {
        return [];
      }
      if (hasSearchCriteria) {
        results = results.filter(function (item) {
          if (item && item.startsWith(_this.searchString)) {
            return item;
          }
        });
      }
      if (this.maxSuggestions !== 0) {
        return results.slice(0, this.maxSuggestions);
      }
      return results;
    },
    searchResults: function searchResults() {
      if (this.icd10SearchRequest && this.icd10SearchRequest.result && this.icd10SearchRequest.result.data && this.icd10SearchRequest.result.data.results) {
        return this.icd10SearchRequest.result.data.results.slice(0, this.limit);
      }
      return [];
    },
    suggestionsRequest: function suggestionsRequest() {
      return this.$store.getters.getRequestById(this.suggestionsReqId, true);
    },
    icd10SearchRequest: function icd10SearchRequest() {
      return this.$store.getters.getRequestById(this.searchReqId, true);
    },
    selectedFormatted: function selectedFormatted() {
      if (this.multiselected && this.multiselected.length > 0) {
        var commaSeperated = this.multiselected.map(function (item) {
          if (item.name) {
            return item.name;
          }
        });
        if (commaSeperated && commaSeperated.length > 0) {
          return { name: commaSeperated.join(' / ') };
        }
      }
      return { name: '' };
    }
  },
  i18n: {
    messages: {
      en: {
        search: {
          recent: 'Recently used',
          label: 'Search for an ICD10 code',
          noresults: 'No codes matched your query'
        },
        inputs: {
          mit: {
            label: 'MIT Only',
            hint: 'Only include results from the Master Industry Table dictionary of codes (South Africa)'
          },
          multipleswitch: {
            label: 'Multiple codes',
            hint: 'Allows you to pick a number of ICD10 codes at once'
          }
        }
      }
    }
  }
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InlineLocationPicker',
  props: {
    spaceId: { required: true },
    value: { required: false },
    label: { type: String, default: 'Choose an address' },
    hint: { type: String, required: false },
    multiple: { type: Boolean, default: true },
    returnObject: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      selected: []
    };
  },
  mounted: function mounted() {
    if (this.multiple) {
      this.selected = [];
    } else {
      this.selected = null;
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (this.multiple) {
        return this.selected.indexOf(item.id) > -1;
      } else {
        return item.id === this.selected.id;
      }
    },
    toggleSelected: function toggleSelected(item) {
      if (this.multiple) {
        var index = this.selected.indexOf(item.id);
        if (index > -1) {
          this.selected.splice(index, 1);
        } else {
          if (this.returnObject) {
            this.selected.push(item);
          } else {
            this.selected.push(item.id);
          }
        }
      }
    }
  },
  watch: {
    selected: function selected() {
      this.$emit('input', this.selected);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['locationsBySpace']), {
    locations: function locations() {
      if (this.spaceId) {
        return this.locationsBySpace(this.spaceId);
      }
      return [];
    }
  })
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationPicker',
  props: {
    spaceId: { required: false },
    value: { type: Array },
    attrs: { type: Object, default: function _default() {
        return {};
      } },
    hint: { type: String, required: false },
    required: { type: Boolean, default: false },
    showArchived: { type: Boolean, default: false },
    errorMessages: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      selected: [],
      warningMessage: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        this.selected = this.value;
      }
    },
    selected: {
      immediate: true,
      handler: function handler() {
        this.setDefaultValue();
        this.$emit('input', this.selected);
      }
    },
    locations: {
      immediate: true,
      handler: function handler() {
        this.setDefaultValue();
      }
    }
  },
  methods: {
    setDefaultValue: function setDefaultValue() {
      if (this.required === true && !this.hasSelectedValue && this.locations && this.locations.length > 0) {
        this.selected = [this.locations[0].id];
        this.warningMessage = 'You must select at least one location';
        this.$emit('input', this.selected);
      }
    }
  },
  computed: {
    locations: function locations() {
      var locs = this.$store.getters.getLocations;
      if (this.spaceId) {
        locs = this.$store.getters.getLocationsBySpaceId(this.spaceId);
      }
      return locs;
    },
    hasSelectedValue: function hasSelectedValue() {
      return this.selected && this.selected.length > 0;
    }
  }
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MedicalAidPicker',
  props: {
    value: { type: Object, default: function _default() {
        return null;
      } }
  },
  methods: {
    select: function select(medicalaid) {
      this.$emit('input', medicalaid);
    }
  },
  computed: {
    filteredQuickPick: function filteredQuickPick() {
      var _this = this;

      if (this.searchString && this.searchString.length > 1) {
        return this.quickpicks.filter(function (item) {
          return item.name.toLowerCase().indexOf(_this.searchString.toLowerCase()) !== -1;
        });
      }
      return this.quickpicks;
    },
    filteredResults: function filteredResults() {
      var _this2 = this;

      if (this.searchString && this.searchString.length > 1) {
        return this.medicalaids.filter(function (item) {
          return item.name.toLowerCase().indexOf(_this2.searchString.toLowerCase()) !== -1;
        });
      }
      return this.medicalaids;
    }
  },
  data: function data() {
    return {
      searchString: null,
      quickpicks: [{ name: 'DISCOVERY Health Medical Scheme', email: 'claims@discovery.co.za' }, { name: 'BONITAS Medical Fund', email: 'claims@bonitas.co.za' }, { name: 'COMPCare WELLNESS Medical Scheme', email: 'claims@universal.co.za' }, { name: 'PROFMED', email: 'claims@profmed.co.za' }],
      medicalaids: [{ name: 'AECI Medical Aid Society', email: 'claims@medscheme.co.za' }, { name: 'ANGLO Medical Scheme', email: 'claims@angloms.co.za' }, { name: 'ANGLOVAAL Group Medical Scheme', email: 'claims@discovery.co.za' }, { name: 'BANKMED', email: 'claims@bankmed.co.za' }, { name: 'BARLOWORLD Medical Scheme', email: 'claims@medscheme.co.za' }, { name: 'BESTMED Medical Scheme', email: 'claims@bestmed.co.za' }, { name: 'BMW EMPLOYEES Medical Aid Society', email: 'claims@discovery.co.za' }, { name: 'BONITAS Medical Fund', email: 'claims@bonitas.co.za' }, { name: 'BP Medical Aid Society', email: 'bpmas@mhg.co.za' }, { name: 'BUILDING & CONSTRUCTION INDUSTRY Medical Aid Fund', email: 'anne.gildenhuys@universal.co.za' }, { name: 'CAPE Medical Plan', email: 'mail@cmp.co.za' }, { name: 'CHARTERED ACCOUNTANTS (SA) Medical Aid Fund (CAMAF)', email: 'claims@camaf.co.za' }, { name: 'COMMUNITY Medical Aid Scheme (COMMED)', email: 'Under liquidation' }, { name: 'COMPCare WELLNESS Medical Scheme', email: 'claims@universal.co.za' }, { name: 'DE BEERS BENEFIT Society', email: 'benefitpost@dbbs.co.za' }, { name: 'DISCOVERY Health Medical Scheme', email: 'claims@discovery.co.za' }, { name: 'ENGEN Medical BENEFIT Fund', email: 'engenaccounts@mhg.co.za' }, { name: 'FEDHealth Medical Scheme', email: 'claims@fedhealth.co.za' }, { name: 'FISHING INDUSTRY Medical Scheme (FISH-MED)', email: 'fishingindustry@mhg.co.za' }, { name: 'GENESIS Medical Scheme', email: 'claims@genesismedical.co.za' }, { name: 'GLENCORE Medical Scheme', email: 'medicalscheme.claims@glencore.co.za' }, { name: 'GOVERNMENT EMPLOYEES Medical Scheme (GEMS)', email: 'enquiries@gems.gov.za' }, { name: 'Health Squared', email: 'claims@healthsquared.co.za' }, { name: 'HORIZON Medical Scheme', email: 'claims@medscheme.co.za' }, { name: 'HOSMED Medical Aid Scheme', email: 'enquiries@hosmed.co.za' }, { name: 'IMPERIAL MOTUS MED', email: 'claims@imperialmotusmed.co.za' }, { name: 'KEYHealth', email: 'general@keyhealthmedical.co.za' }, { name: 'LA-Health Medical Scheme', email: 'claims@discovery.co.za' }, { name: 'LIBCare Medical Scheme', email: 'claims@libcare.co.za ' }, { name: 'MALCOR Medical Scheme', email: 'claims@malcormedicalaid.co.za' }, { name: 'MASSMART Health Plan', email: 'massmart@universal.co.za' }, { name: 'MBMED Medical Aid Fund', email: 'claims@medscheme.co.za' }, { name: 'MEDIHELP', email: 'claims@medihelp.co.za' }, { name: 'MEDSHIELD Medical Scheme', email: 'member@medshield.co.za' }, { name: 'MOMENTUM Health', email: 'claims@momentumhealth.co.za' }, { name: 'MOTO Health Medical', email: 'claims@mhcmf.co.za' }, { name: 'NASPERS Medical Fund', email: 'claims@discovery.co.za' }, { name: 'NEDGroup Medical Aid Scheme', email: 'nedgroup.newclaims@medscheme.co.za ' }, { name: 'NETCare Medical Scheme', email: 'claims@netcaremedicalscheme.co.za' }, { name: 'OLD MUTUAL STAFF Medical Aid Fund (OMSMAF)', email: 'claims@OMSMAF.co.za' }, { name: 'PG Group Medical Scheme', email: 'claims@pggmeds.co.za' }, { name: 'PLATINUM Health', email: 'zzgplatinumhealthclaims@platinumhealth.co.za' }, { name: 'PROFMED', email: 'claims@profmed.co.za' }, { name: 'REMEDI Medical Aid Scheme', email: 'claims@discovery.co.za' }, { name: 'RESOLUTION Health Medical Scheme', email: 'clientservices@resomed.co.za' }, { name: 'RHODES UNIVERSITY Medical Scheme', email: 'rumedclaims@providence.co.za' }, { name: 'SABC Medical Aid Scheme', email: 'claims@medscheme.co.za' }, { name: 'SASOLMED', email: 'claims@sasolmed.co.za' }, { name: 'SASOLMED Weight Management Programme', email: 'weightmanagement@sasolmed.co.za' }, { name: 'SISONKE Health Medical Scheme', email: 'sh-ms@providence.co.za' }, { name: 'Sizwe queries', email: 'queries@sizwe.co.za' }, { name: 'Sizwe escalations', email: 'escalations@sizwemedfund.co.za' }, { name: 'SizweHosmed', email: 'claims@sizwehosmed.co.za' }, { name: 'SOUTH AFRICAN BREWERIES Medical Scheme', email: 'claims@sabmas.co.za' }, { name: 'SOUTH AFRICAN POLICE SERVICE Medical Scheme (POLMED)', email: 'polmedcurrentclaims@medscheme.co.za' }, { name: 'SPECTRAMED', email: 'claims@spectramed.co.za' }, { name: 'TEST', email: 'christo@appointmentguru.co' }, { name: 'TFG Medical Aid Scheme', email: 'claims@discovery.co.za' }, { name: 'TIGER BRANDS Medical Scheme', email: 'admin@universal.co.za' }, { name: 'TRANSMED Medical Fund', email: 'claims@transmed.co.za' }, { name: 'UNIVERSITY OF KWA-ZULU NATAL Medical Scheme', email: 'claims@discovery.co.za' }, { name: 'UNIVERSITY OF THE WITWATERSRAND - JOHANNESBURG STAFF Medical Aid Fund', email: 'claims@witsmed.co.za' }, { name: 'Witbank Coalfields Medical Aid Scheme (WCMAS)', email: 'wcmas@wcmas.co.za' }, { name: 'Midmed Alliance', email: 'service@alliancemidmed.co.za' }]
    };
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaymentMethodPicker',
  props: {
    value: { type: String },
    label: { type: String, default: 'Payment method' },
    hint: { type: String, default: 'How did the client pay?' },
    small: { type: Boolean, default: false }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.method = this.value;
        }
      }
    },
    method: function method() {
      this.$emit('input', this.method);
    }
  },
  methods: {
    setMethod: function setMethod(method) {
      this.method = method.value;
    }
  },
  data: function data() {
    return {
      method: '',
      methods: [{
        value: 'eft',
        text: 'EFT'
      }, {
        value: 'cash',
        text: 'Cash'
      }, {
        value: 'snapscan',
        text: 'SnapScan'
      }, {
        value: 'credit_card',
        text: 'Creditcard'
      }, {
        value: 'medicalaid',
        text: 'Medical Aid'
      }, {
        value: 'gift',
        text: 'Gift'
      }, {
        value: 'voucher',
        text: 'Voucher'
      }, {
        value: 'other',
        text: 'Other'
      }]
    };
  }
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_listitems_PractitionerListItem__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_listitems_PractitionerListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_listitems_PractitionerListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PractitionerPicker',
  components: { PractitionerListItem: __WEBPACK_IMPORTED_MODULE_1__components_listitems_PractitionerListItem___default.a },
  props: {
    value: { type: Object },
    dense: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      showmenu: false,
      selected: {}
    };
  },

  methods: {
    isSelected: function isSelected(practitioner) {
      return practitioner.id === this.practitionerId;
    },
    getSelectedIcon: function getSelectedIcon(practitioner) {
      if (this.isSelected(practitioner)) {
        return 'check';
      }
      return null;
    },
    setSelected: function setSelected(practitioner) {
      this.selected = practitioner;
      this.$emit('input', this.selected);
      this.$emit('selected', this.selected);
    }
  },
  mounted: function mounted() {
    if (!this.value && this.meId) {
      this.selected = this.meId;
      this.$emit('input', this.selected);
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value && this.value.id) {
          var lookup = this.getPractitionerById(this.value.id);
          if (lookup) {
            this.setSelected(lookup);
          }
        }
      }
    },
    meId: function meId() {
      if (!this.selected.id) {
        this.selected = this.me;
        this.$emit('input', this.selected);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['me', 'meId', 'lookups', 'getPractitionerById']), {
    practitionerId: function practitionerId() {
      if (this.selected && this.selected) {
        return this.selected.id;
      }
      return null;
    },
    practitioners: function practitioners() {
      return this.$store.getters.getColleagues;
    },
    practitioner: function practitioner() {
      var practitionerId = this.practitionerId;
      if (!practitionerId) {
        practitionerId = this.meId;
      }
      return this.getPractitionerById(practitionerId);
    }
  })
});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pickers_PractitionerPicker_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pickers_PractitionerPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pickers_PractitionerPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_settings_locations_AppointmentTypes__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_settings_locations_AppointmentTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_settings_locations_AppointmentTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PractitionerProductSheet',
  components: {
    PractitionerPicker: __WEBPACK_IMPORTED_MODULE_2__components_pickers_PractitionerPicker_vue___default.a,
    AppointmentType: __WEBPACK_IMPORTED_MODULE_3__components_pages_settings_locations_AppointmentTypes___default.a
  },
  props: {
    space: { type: Object },
    practitioner: { type: Object },
    product: { type: Object },
    location: { type: Object }
  },
  data: function data() {
    return {
      local: {
        practitioner: { id: null },
        space: { id: null },
        product: { id: null },
        location: { id: null }
      }
    };
  },

  watch: {
    locationId: function locationId() {
      this.$emit('update:location', this.local.location);
    },
    productId: function productId() {
      this.$emit('update:product', this.local.product);
      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(this.local, 'location', { id: null });
      console.log('productid');
    },
    spaceId: function spaceId() {
      this.$emit('update:space', this.local.space);
      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(this.local, 'product', { id: null });
    },
    practitionerId: function practitionerId() {
      this.space = { id: null };
      this.$emit('update:practitioner', this.local.practitioner);
      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(this.local, 'space', { id: null });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['lookups', 'getColleagues']), {
    practitionerId: function practitionerId() {
      return this.getObjectPath(this.local, 'practitioner.id');
    },
    spaceId: function spaceId() {
      return this.getObjectPath(this.local, 'space.id');
    },
    productId: function productId() {
      return this.getObjectPath(this.local, 'product.id');
    },
    locationId: function locationId() {
      return this.getObjectPath(this.local, 'location.id');
    },
    colleagues: function colleagues() {
      var colleagues = this.getColleagues;
      if (colleagues) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(colleagues);
      }
      return [];
    },
    products: function products() {
      var _this = this;

      var p = this.getObjectPath(this.lookups, 'products', []);
      console.log(this.practitionerId, this.spaceId);
      if (p) {
        var productList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(p);
        var filtered = productList.filter(function (prod) {
          if (_this.practitionerId && !_this.idsAreEqual(_this.practitionerId, prod.owner)) {
            return null;
          }
          if (_this.spaceId && !_this.idsAreEqual(_this.spaceId, prod.space)) {
            return null;
          }
          return prod;
        });
        return filtered;
      }
      return p;
    }
  })
});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_debounce__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_RequestStatus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_RequestStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_RequestStatus_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { RequestStatus: __WEBPACK_IMPORTED_MODULE_2__ui_RequestStatus_vue___default.a },
  name: 'ProcessCodePicker',
  props: {
    value: { type: Object, default: function _default() {
        return null;
      } },
    initialSearchString: { type: String, default: null },
    maxSuggestions: { type: Number, default: 15 },
    withSuggestions: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      selected: null,
      searchString: '',
      searchReqId: 'processcode-search-request',
      suggestionsReqId: __WEBPACK_IMPORTED_MODULE_0__store_constants__["r" /* CODE_SUGGESTIONS */],
      resetSuggestionsDialog: false,
      suggestionDate: null,
      requests: {
        setsuggestions: {
          resource: 'ag.practitioner',
          extra: 'actions/clear_code_suggestions',
          method: 'post'
        }
      }
    };
  },
  mounted: function mounted() {
    this.search();
    if (this.suggestions && this.suggestions.length === 0) {
      this.getSuggestions();
    }
    this.suggestionDate = new Date().toISOString().split('T')[0];
  },

  computed: {
    afterDate: function afterDate() {
      return this.getObjectPath(this.suggestionsRequest, 'result.data.codes.meta.since', false);
    },
    suggestions: function suggestions() {
      if (this.suggestionsRequest && this.suggestionsRequest.result && this.suggestionsRequest.result.data && this.suggestionsRequest.result.data.codes) {
        return this.suggestionsRequest.result.data.codes;
      }
      return [];
    },
    filteredSuggestions: function filteredSuggestions() {
      var _this = this;

      var hasSearchCriteria = this.searchString && this.searchString.length > 0;
      var results = this.suggestions.process;
      if (!results) {
        return [];
      }
      if (hasSearchCriteria) {
        results = this.suggestions.process.filter(function (item) {
          if (item.name.startsWith(_this.searchString)) {
            return item;
          }
        });
      }
      if (this.maxSuggestions !== 0) {
        return results.slice(0, this.maxSuggestions);
      }
      return results;
    },
    setsuggestionsRequestStatus: function setsuggestionsRequestStatus() {
      return this.requests.setsuggestions.status;
    },
    suggestionsRequest: function suggestionsRequest() {
      return this.$store.getters.getRequestById(this.suggestionsReqId, true);
    },
    searchRequest: function searchRequest() {
      return this.$store.getters.getRequestById(this.searchReqId, false);
    },
    searchResults: function searchResults() {
      if (this.searchRequest && this.searchRequest.result && this.searchRequest.result.data && this.searchRequest.result.data.results) {
        return this.searchRequest.result.data.results;
      }
      return [];
    }
  },
  watch: {
    searchString: function searchString() {
      this.search();
    },
    initialSearchString: function initialSearchString() {
      this.searchString = this.initialSearchString;
    },
    setsuggestionsRequestStatus: function setsuggestionsRequestStatus() {
      if (this.setsuggestionsRequestStatus === 200) {
        this.getSuggestions();
      }
    }
  },
  methods: {
    selectItem: function selectItem(item) {
      this.selected = item;
      this.$emit('input', item);
    },
    setSuggestionDate: function setSuggestionDate() {
      this.requests.setsuggestions.data = { date: this.suggestionDate };
      this.requests.setsuggestions.resourceId = this.meId;
      this.$request('save', this.requests.setsuggestions);
    },

    getSuggestions: __WEBPACK_IMPORTED_MODULE_1__mixins_debounce___default()(function () {
      this.$appointmentguru.resource('appointment.codes.suggestions').id(this.suggestionsReqId).list();
    }, 500),
    search: __WEBPACK_IMPORTED_MODULE_1__mixins_debounce___default()(function () {
      if (this.searchString && this.searchString.length > 0) {
        var params = {
          search: this.searchString
        };
        this.$codeguru.resource('processcode').id(this.searchReqId).list(params);
      }
    }, 500)
  }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_settings_locations_AppointmentTypes__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_settings_locations_AppointmentTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_settings_locations_AppointmentTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_listitems_PractitionerListItem_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_listitems_PractitionerListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_listitems_PractitionerListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wizards_Space_index_vue__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wizards_Space_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_wizards_Space_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wizards_Location_index_vue__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wizards_Location_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_wizards_Location_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(3);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductSheet',
  components: {
    AppointmentType: __WEBPACK_IMPORTED_MODULE_4__components_pages_settings_locations_AppointmentTypes___default.a,
    PractitionerListItem: __WEBPACK_IMPORTED_MODULE_5__components_listitems_PractitionerListItem_vue___default.a,
    SpaceWizard: __WEBPACK_IMPORTED_MODULE_6__components_wizards_Space_index_vue___default.a,
    LocationWizard: __WEBPACK_IMPORTED_MODULE_7__components_wizards_Location_index_vue___default.a
  },
  props: {
    label: { type: String, default: 'Choose a product' },
    placeholder: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    value: { type: Object, default: function _default() {
        return {};
      } },
    service: { type: Object, default: function _default() {
        return {};
      } },
    practitioner: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      bottomsheet: false,
      activeWindow: 0,
      createReq: 'products-update-save-request',
      selectedService: null,
      searchString: '',
      touchLocation: 0,
      touchSpace: 0,
      LINKS: __WEBPACK_IMPORTED_MODULE_3__store_constants__["a" /* LINKS */]
    };
  },
  mounted: function mounted() {
    if (!this.practitioner && !this.practitioner.id) {
      this.$emit('update:practitioner', this.me);
    }
  },

  watch: {
    visible: function visible() {
      this.bottomsheet = this.visible;
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 201) {
        this.activeWindow = 2;
        this.refresh();
      }
    },

    service: {
      immediate: true,
      handler: function handler() {
        if (this.service) {
          this.selectedService = this.service;
        }
      }
    }
  },
  methods: {
    toggleService: function toggleService(service) {
      if (service.collapsed === true) {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(service, 'collapsed', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(service, 'collapsed', true);
      }
    },
    togglelocation: function togglelocation(loc) {
      if (loc.collapsed === true) {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(loc, 'collapsed', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(loc, 'collapsed', true);
      }
    },
    setSelected: function setSelected(service, location, productId) {
      if (Array.isArray(location) && location.length === 1) {
        location = location[0];
      }
      var product = this.$store.getters.getProductById(productId);
      var data = { service: service, location: location, product: product };
      this.$emit('selectedservice', data);
    },
    canAddProduct: function canAddProduct(space) {
      var isOwner = space.role === 'Owner';
      var isMyself = this.practitionerId === this.meId;
      if (isOwner) {
        return true;
      }
      if (isMyself) {
        return true;
      }
      return false;
    },
    canManageSpace: function canManageSpace(space) {
      var isOwner = space.role === 'Owner';
      return isOwner;
    },
    refresh: function refresh() {
      this.getMe();
      this.getLookups();
    },
    addProduct: function addProduct(product) {
      if (this.selectedService.service) {
        product.service = this.selectedService.service.id;
      } else {
        product.service = this.selectedService.id;
      }
      if (this.practitionerId) {
        product.practitioner = this.practitionerId;
      }

      product.order = 100;
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(product);
      this.$appointmentguru.resource('practitioner.services.products').id(this.createReq).create(data);
    },
    spaceCreated: function spaceCreated() {
      this.refresh();
    },
    gotoLocation: function gotoLocation(service) {
      this.touchLocation++;
      this.selectedService = service;
      this.activeWindow = 'location';
    },
    locationCreated: function locationCreated() {
      this.refresh();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['services', 'getProducts', 'getSpacesByPractitionerId']), {
    saveRequest: function saveRequest() {
      return this.$store.getters.getRequestById(this.createReq, true);
    },
    practitionerId: function practitionerId() {
      return this.getObjectPath(this.practitioner, 'id', null);
    },
    spaces: function spaces() {
      if (this.practitionerId) {
        return this.getSpacesByPractitionerId(this.practitionerId);
      }
      return [];
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.saveRequest.status;
    },
    meRequest: function meRequest() {
      return this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_3__store_constants__["f" /* GET_ME_REQ */], true);
    },
    meRequestStatus: function meRequestStatus() {
      return this.meRequest.status;
    },
    services: function services() {
      var services = this.services;
      var serviceLookup = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var service = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(service.products), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var product = _step2.value;

              var hidden = false;
              if (this.searchString) {
                if (product.title.toLowerCase().indexOf(this.searchString.toLowerCase()) === -1) {
                  hidden = true;
                }
              }
              if (!hidden) {
                serviceLookup.push({
                  product: product,
                  service: service,
                  value: product.id,
                  text: product.title
                });
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return serviceLookup;
    },
    locationSuccessSteps: function locationSuccessSteps() {
      var spaceId = null;
      var vm = this;
      if (this.selectedService) {
        spaceId = this.selectedService.id;
      }
      return [{
        click: function click() {
          console.log('touch me on my location');
          vm.touchLocation++;
        },
        events: {},
        text: 'Add another'
      }, {
        click: function click() {},
        events: {},
        attrs: {
          href: vm.LINKS.SETTINGS_SPACES + spaceId + '/locations',
          target: '_blank'
        },
        text: 'Edit further',
        icon: 'open_in_new'
      }];
    }
  })
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfessionPicker',
  props: {
    value: { type: Object },
    solo: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      reqId: 'professions-list',
      selected: null
    };
  },
  mounted: function mounted() {
    this.get();
    if (this.value) {
      this.selected = this.value;
    }
  },

  computed: {
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    professions: function professions() {
      return this.getObjectPath(this.request, 'result.data', []);
    }
  },
  watch: {
    value: function value() {
      if (this.value) {
        this.selected = this.value;
      }
    },
    selected: function selected() {
      this.$emit('input', this.selected);
    }
  },
  methods: {
    get: function get() {
      this.$appointmentguru.resource('practitioner.professions').id(this.reqId).list();
    }
  }
});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_ObjectForm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_ObjectForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_medicalaid_ObjectForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ServerErrors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ServerErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ServerErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReferralPicker',
  components: { ObjectForm: __WEBPACK_IMPORTED_MODULE_0__components_medicalaid_ObjectForm___default.a, ServerErrors: __WEBPACK_IMPORTED_MODULE_1__components_ServerErrors___default.a },
  props: {
    touch: { type: Number, default: 2 },
    closeOnSelect: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      screen: 0,
      showSearch: false,
      searchText: '',
      titles: __WEBPACK_IMPORTED_MODULE_2__store_constants__["N" /* TITLES */],
      serverErrors: {},
      newReferrer: {
        'created_by': '',
        'title': '',
        'first_name': '',
        'last_name': '',
        'reference_number': ''
      },
      screens: {
        LIST: 0,
        NEW: 1,
        SUCCESS: 2
      },
      referrerFields: ['title', 'first_name', 'last_name', 'reference_number'],
      fieldConfigs: {
        'first_name': {
          rules: [function (v) {
            return !!v || 'first name is required';
          }]
        },
        'last_name': {
          rules: [function (v) {
            return !!v || 'last name is required';
          }]
        },
        'reference_number': {
          hint: 'e.g.: BK 1234567, MP 1234567, DT 1234567, PT 1234567 etc.',
          persistentHint: true
        }
      },
      getReq: 'get-therapist-list',
      saveReq: 'save-therapist-list'
    };
  },

  computed: {
    getRequest: function getRequest() {
      return this.$store.getters.getRequestById(this.getReq, true);
    },
    saveRequest: function saveRequest() {
      return this.$store.getters.getRequestById(this.saveReq, true);
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.saveRequest.status;
    },
    therapists: function therapists() {
      return this.getObjectPath(this.getRequest, 'result.data.results', []);
    },
    filteredTherapists: function filteredTherapists() {
      var _this = this;

      if (!this.therapists) {
        return [];
      }
      if (this.searchText && this.searchText.length > 1) {
        return this.therapists.filter(function (item) {
          var index = (item.title + ' ' + item.first_name + ' ' + item.last_name + ' ' + item.reference_number).toLowerCase();
          return index.indexOf(_this.searchText) !== -1;
        });
      }
      return this.therapists;
    }
  },
  watch: {
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 201) {
        this.newReferrer = this.saveRequest.result.data;
        this.screen = this.screens.SUCCESS;
      }
    },
    touch: function touch() {
      this.reset();
      this.load();
    }
  },
  methods: {
    reset: function reset() {
      this.screen = this.screens.LIST;
    },
    load: function load() {
      this.$medicalaidguru.resource('therapist').id(this.getReq).list();
    },
    save: function save() {
      this.newReferrer.created_by = this.me.id;
      this.$medicalaidguru.resource('therapist').id(this.saveReq).create(this.newReferrer);
    },
    selected: function selected(therapist) {
      this.reset();
      this.$emit('selected', therapist);
      if (this.closeOnSelect === true) {
        this.$emit('close');
      }
    }
  },
  i18n: {
    messages: {
      en: {
        list: {
          title: 'Referrers'
        },
        buttons: {
          add: 'Add a new referrer',
          addanother: 'Add another',
          select: 'Select',
          back: 'Back',
          save: 'Save',
          searchhpcsa: 'Search HPCSA registry',
          backtostart: 'Back to search'
        },
        cards: {
          success: {
            title: 'New referrer created',
            message: 'Successfully created referrer'
          }
        }
      }
    }
  }
});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelationshipPicker',
  props: {
    label: { type: String, default: 'Choose a client' },
    value: { required: false },
    practitionerId: { required: false },
    multiple: { type: Boolean, default: false },
    withQuickPick: { type: Boolean, default: false },
    attrs: { type: Object, required: false, default: function _default() {} },
    fromDate: { type: String, required: false },
    toDate: { type: String, required: false },
    statuses: { type: Array, required: false, default: function _default() {
        return [];
      } },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      selected: null,
      search: null,
      timeout: null,
      removeClients: [],
      request: {
        resource: 'ag.spaces.relationships',
        result: { results: [] },
        status: 0,
        loading: false
      }
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.selected = this.value;
    }
    this.fetch();
  },

  watch: {
    selected: function selected() {
      this.$emit('input', this.selected);
      this.$emit('selected', this.selected);
    },
    dateRange: function dateRange() {
      this.debounceFetch();
    },
    statusString: function statusString() {
      this.debounceFetch();
    },
    touch: function touch() {
      this.debounceFetch();
    },
    practitionerId: function practitionerId() {
      this.debounceFetch();
    },
    requestStatus: function requestStatus() {
      this.$emit('count', this.numClients);
    },
    search: function search() {
      this.debounceFetch();
    }
  },
  methods: {
    debounceFetch: function debounceFetch() {
      console.log('debouncing');
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(this.fetch, 1000);
    },
    clear: function clear() {
      this.selected = null;
      this.search = null;
      this.fetch();
    },
    fetch: function fetch() {
      var params = {
        page_size: 300,
        ordering: 'first_name,last_name'
      };
      if (this.fromDate) {
        params['after_utc'] = this.fromDate;
      }
      if (this.toDate) {
        params['before_utc'] = this.toDate;
      }
      if (this.statuses && this.statuses.length > 0) {
        params.statuses = this.statuses;
      }
      if (this.search) {
        params.search = this.search;
      }
      if (this.practitionerId) {
        params.practitioner_id = this.practitionerId;
      }
      this.request.params = params;
      this.$request('get', this.request);
    },
    setSelected: function setSelected(cli) {
      var isSelected = cli && this.selected && cli.id === this.selected.id;
      if (isSelected) {
        this.selected = null;
      } else {
        this.selected = cli;
      }
    }
  },
  computed: {
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    statusString: function statusString() {
      if (this.statuses && this.statuses) {
        return this.statuses.join(',');
      }
      return '';
    },
    dateRange: function dateRange() {
      return this.fromDate + ' ' + this.toDate;
    },
    clients: function clients() {
      return this.getObjectPath(this.request, 'result.results', []);
    },
    numClients: function numClients() {
      return this.clients.length;
    },
    formattedClients: function formattedClients() {
      return this.clients.map(function (rel) {
        rel.text = '# ' + rel.id + ' ' + rel.first_name + ' ' + rel.last_name;
        return rel;
      });
    },
    showHint: function showHint() {
      if (this.hintText) {
        return true;
      }
      return false;
    },
    hintText: function hintText() {
      if (this.fromDate) {
        var txt = 'Only showing clients with appointments after ' + this.fromDate;
        if (this.toDate) {
          txt = 'Only showing clients with appointments between ' + this.fromDate + ' and ' + this.toDate;
        }
        if (this.statuses && this.statuses.length > 0) {
          txt += ' with a status in ' + this.statuses.join(', ');
        }
        return txt;
      }
      return null;
    }
  },
  i18n: {
    messages: {
      en: {
        numresults: 'no clients found|{count} client found|{count} clients found'
      },
      es: {}
    }
  }
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpacePicker',
  props: {
    value: { default: function _default() {
        return [];
      } },
    label: { type: String, default: 'Spaces' },
    multiple: { type: Boolean, default: true },
    withSelect: { type: Boolean, default: true },
    readOnly: { type: Boolean, default: false },
    isOwner: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    attrs: { type: Object, default: function _default() {} },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      selected: []
    };
  },
  mounted: function mounted() {
    this.dotouch();
  },

  watch: {
    touch: function touch() {
      this.dotouch();
    },

    value: {
      immediate: true,
      handler: function handler() {
        this.dotouch();
      }
    },
    selected: function selected() {
      this.$emit('input', this.selected);
    }
  },
  methods: {
    compare: function compare(a, b) {
      if (a.id) {
        a = a.id;
      }
      if (b.id) {
        b = b.id;
      }
      if (a && b) {
        return parseInt(a) === parseInt(b);
      }
      return false;
    },
    isSelected: function isSelected(item) {
      var vm = this;
      if (this.selected && this.selected.length > 0) {
        var index = this.selected.findIndex(function (selected) {
          return vm.compare(selected, item);
        });
        return index !== -1;
      }
      return false;
    },
    canEditSpace: function canEditSpace(space) {
      if (this.business && this.business !== space.business) {
        return false;
      }
      return true;
    },
    toggleSpace: function toggleSpace(space) {
      if (this.business && this.business !== space.business) {
        return;
      }
      if (this.readOnly) {
        return;
      }
      var index = this.selected.findIndex(function (id) {
        return id === space.id;
      });
      if (index === -1) {
        this.selected.push(space.id);
      } else {
        var isRequired = this.required === true && this.selected && this.selected.length === 1;

        if (!isRequired) {
          this.selected.splice(index, 1);
        }
      }
    },
    dotouch: function dotouch() {
      if (this.value) {
        this.selected = this.value;
      }
    }
  },
  computed: {
    spaces: function spaces() {
      var spaces = this.$store.getters.spaces;
      if (this.isOwner === true) {
        return spaces.filter(function (space) {
          return space.role === 'Owner';
        });
      }
      return spaces;
    },
    business: function business() {
      if (this.computedSelected && this.computedSelected.length > 0) {
        return this.computedSelected[0].business;
      }
      return null;
    },
    computedSelected: function computedSelected() {
      var _this = this;

      return this.spaces.filter(function (space) {
        return _this.value.indexOf(space.id) !== -1;
      });
    },
    selectedSpaceIds: function selectedSpaceIds() {
      if (this.selected) {
        return this.selected.map(function (space) {
          return space.id;
        });
      }
      return [];
    }
  }
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentFilterPicker',
  props: {
    value: { type: Array, default: function _default() {
        return [];
      } },
    facets: { type: Object, required: false },
    selectAll: { type: Boolean, default: false },
    numberOfChipsToShow: { type: Number, default: 2 }
  },
  data: function data() {
    return {
      selected: []
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.selected = this.value;
    }
    if (this.selectAll) {
      this.selected = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1__store_constants__["m" /* STATUSES */]);
    }
  },

  computed: {
    items: function items() {
      var li = [];
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1__store_constants__["m" /* STATUSES */]);
      keys.forEach(function (key) {
        var data = __WEBPACK_IMPORTED_MODULE_1__store_constants__["m" /* STATUSES */][key];
        data['id'] = key;
        li.push(data);
      });
      return li;
    }
  },
  methods: {
    isSelected: function isSelected(item) {
      return this.selected.indexOf(item.id) !== -1;
    },
    toggleSelected: function toggleSelected(item) {
      var selectedIndex = this.selected.indexOf(item.id);
      if (selectedIndex === -1) {
        this.selected.push(item.id);
      } else {
        this.selected.splice(selectedIndex, 1);
      }
      this.$emit('input', this.selected);
    }
  },
  watch: {
    selected: function selected() {
      this.$emit('input', this.selected);
    }
  }
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppointmentCodeList',
  props: {
    title: { type: String },
    appointment: { type: Object },
    withDelete: { type: Boolean, default: true },
    withInlineControls: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      resource: 'appointment.codes',
      requests: {
        delete: 'appointment-codes-delete-request'
      },
      deleteLoading: false,
      deleteDialog: false,
      selectedCode: {},
      selectedCodeIndex: 0,
      deleting: []
    };
  },

  watch: {
    deleteRequestStatus: function deleteRequestStatus() {
      if (this.deleteRequestStatus === 204) {
        this.$emit('code:deleted');
      }
      if (this.deleteRequestStatus > 299) {
        window.alert('Unable to delete code');
      }
      if (this.deleteRequestStatus > 199) {
        this.deleting = [];
        this.deleteDialog = false;
      }
    }
  },
  computed: {
    deleteRequest: function deleteRequest() {
      return this.$store.getters.getRequestById(this.requests.delete, true);
    },
    deleteRequestStatus: function deleteRequestStatus() {
      return this.deleteRequest.status;
    }
  },
  methods: {
    prepareToDelete: function prepareToDelete(code, index) {
      this.selectedCode = code;
      this.selectedCodeIndex = index;
      this.deleteDialog = true;
    },
    deleteCode: function deleteCode(data) {
      var id = this.selectedCode.id;
      var params = { appointment_id: this.appointment.id };
      this.deleting.push(id);
      this.$appointmentguru.resource(this.resource).id(this.requests.delete).delete(id, params);
    }
  },
  i18n: {
    messages: {
      en: {
        dialog: {
          delete: {
            title: 'Are you sure you want to delete this code?'
          }
        }
      }
    }
  }
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_CreateTransaction__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_CreateTransaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_CreateTransaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_appointment_BulkAddCodes__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_appointment_BulkAddCodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_appointment_BulkAddCodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentListItem__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_lists_SpaceFaces_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_lists_SpaceFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_lists_SpaceFaces_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_PractitionerFaces_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_PractitionerFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_lists_PractitionerFaces_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BulkActions',
  components: {
    CreateTransaction: __WEBPACK_IMPORTED_MODULE_3__components_appointment_actions_CreateTransaction___default.a,
    BulkAddCodes: __WEBPACK_IMPORTED_MODULE_4__components_appointment_BulkAddCodes___default.a,
    SpaceFaces: __WEBPACK_IMPORTED_MODULE_6__components_lists_SpaceFaces_vue___default.a,
    PractitionerFaces: __WEBPACK_IMPORTED_MODULE_7__components_lists_PractitionerFaces_vue___default.a,
    AppointmentListItem: __WEBPACK_IMPORTED_MODULE_5__components_appointment_AppointmentListItem___default.a
  },
  props: {
    selectedAppointments: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      dialogs: {
        edit: false,
        invoice: false,
        payments: false,
        codes: false,
        invoiceSuccess: false
      },
      reqs: {
        invoice: 'bulk-invoice-request',
        payment: 'bulk-payment-requets'
      },
      request: {
        resource: 'ag.practitioner.statement'
      },
      codeTouch: 1,
      newInvoiceResult: null
    };
  },

  computed: {
    numGloballySelectedAppointments: function numGloballySelectedAppointments() {
      if (this.selectedAppointments && this.selectedAppointments.length > 0) {
        return this.selectedAppointments.length;
      }
      return 0;
    },
    client: function client() {
      if (this.clientId) {
        return this.getClientById(this.clientId);
      }
      return null;
    },
    clientId: function clientId() {
      if (this.clientIds && this.clientIds.length === 1) {
        return this.selectedAppointments[0].client;
      }
      return null;
    },
    clientIds: function clientIds() {
      var ids = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach(function (i) {
          ids.add(i.client);
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(ids);
    },
    relationship: function relationship() {
      if (this.relationshipId) {
        return this.getRelationById(this.relationshipId);
      }
      return null;
    },
    relationshipId: function relationshipId() {
      if (this.relationshipIds && this.relationshipIds.length === 1) {
        return this.selectedAppointments[0].computed_relationship_id;
      }
      return null;
    },
    relationshipIds: function relationshipIds() {
      var ids = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach(function (i) {
          ids.add(i.computed_relationship_id);
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(ids);
    },
    practitionerIds: function practitionerIds() {
      var ids = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach(function (i) {
          ids.add(i.practitioner);
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(ids);
    },
    spaceIds: function spaceIds() {
      var ids = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach(function (i) {
          if (i.space) {
            ids.add(i.space);
          }
          if (i.service_id) {
            ids.add(i.service_id);
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(ids);
    },
    appointmentIds: function appointmentIds() {
      var ids = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach(function (i) {
          ids.add(i.id);
        });
      }
      return ids;
    },
    invoiceOptions: function invoiceOptions() {
      return {
        appointments: this.selectedAppointments,
        relationship: this.relationship
      };
    },
    paymentOptions: function paymentOptions() {
      return {
        appointments: this.selectedAppointments
      };
    },
    topOffset: function topOffset() {
      if (this.appPlatform === 'ios') {
        return '24px';
      }
      return '0px;';
    },
    invoiceRequest: function invoiceRequest() {
      return this.$store.getters.getRequestById(this.reqs.invoice, true);
    },
    invoiceRequestStatus: function invoiceRequestStatus() {
      return this.invoiceRequest.status;
    },
    paymentRequest: function paymentRequest() {
      return this.$store.getters.getRequestById(this.reqs.payment, true);
    },
    paymentRequestStatus: function paymentRequestStatus() {
      return this.paymentRequest.status;
    },
    loading: function loading() {
      return this.invoiceRequest.loading;
    },
    selectedAppointmentIds: function selectedAppointmentIds() {
      return this.selectedAppointments.map(function (appt) {
        return appt.id;
      });
    }
  },
  watch: {
    invoiceRequestStatus: function invoiceRequestStatus() {
      if (this.invoiceRequestStatus === 201) {
        this.$emit('invoice:created', this.invoiceRequest.result.data);
        this.dialogs.invoice = false;
      }
    },
    paymentRequestStatus: function paymentRequestStatus() {
      if (this.paymentRequestStatus === 201) {
        this.dialogs.payments = false;
        this.$emit('payment:created', this.paymentRequest.result.data);
      }
    },

    selectedAppointments: {
      immediate: true,
      handler: function handler() {
        if (this.selectedAppointments) {
          this.globalSelectedAppointments = this.selectedAppointments;
        }
      }
    }
  },
  methods: {
    getStatement: function getStatement(clientId) {
      if (clientId && this.selectedAppointmentIds && this.selectedAppointmentIds.length > 0) {
        this.request.resourceId = clientId;
        var apptIds = this.selectedAppointmentIds.join(',');
        this.request.params = {
          appointments: apptIds
        };
        this.$request('get', this.request);
      }
    },
    createInvoice: function createInvoice() {
      var payload = {
        customer_id: this.clientId,
        practitioner_id: this.me.id,
        appointments: this.selectedAppointmentIds
      };
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
      this.$invoiceguru.resource('invoices').id(this.reqs.invoice).create(data);
    }
  },
  i18n: {
    messages: {
      en: {
        toolbar: {
          extension: '{n} selected appointments | {n} selected appointment | {n} selected appointments'
        },
        messages: {
          noneselected: 'No appointments selected. Please choose some appointments first'
        },
        buttons: {
          setprice: 'Edit',
          codes: 'Codes',
          invoices: 'Invoice',
          payments: 'Payments',
          deselect: 'Deselect all',
          createinvoice: 'Create Invoice'
        },
        dialogs: {
          titles: {
            codes: 'Add diagnosis codes',
            invoice: 'Create an invoice with these appointments',
            payments: 'Add Payments',
            setprice: 'Set price'
          }
        }
      }
    }
  }
});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatementFilters',
  props: {
    filterFromDate: { type: String },
    filterToDate: { type: String },
    filterStatusIds: { type: Array },
    touchShow: { type: Number, default: 1 },
    noFiltersText: { type: String, default: 'No filters applied. #nofilter' }
  },
  data: function data() {
    return {
      visible: false,
      fromModal: false,
      toModal: false,
      statuses: __WEBPACK_IMPORTED_MODULE_0__store_constants__["m" /* STATUSES */],
      fromDate: null,
      toDate: null,
      showAllStatuses: true,
      selectedStatuses: [],
      selectedStatusIds: []
    };
  },
  mounted: function mounted() {
    this.emitFilters();
  },

  methods: {
    emitFilters: function emitFilters() {
      this.$emit('filters:string', this.filtersAsSentence);
      this.$emit('filters:params', this.filters);
    }
  },
  computed: {
    hasFilters: function hasFilters() {
      return this.fromDate || this.toDate || this.selectedStatusIds.length > 0;
    },
    filters: function filters() {
      var filters = {};
      if (this.fromDate) {
        filters['from_date'] = this.fromDate;
      }
      if (this.toDate) {
        filters['to_date'] = this.toDate;
      }
      if (this.selectedStatusIds && this.selectedStatusIds.length > 0 && !this.showAllStatuses) {
        filters['statuses'] = this.selectedStatusIds.join(',');
      }
      return filters;
    },
    dateRangeFormatted: function dateRangeFormatted() {
      if (this.fromDate && this.toDate) {
        return 'between ' + this.fromDate + ' and ' + this.toDate;
      }
      if (this.fromDate) {
        return 'from ' + this.fromDate;
      }
      if (this.toDate) {
        return 'before ' + this.toDate;
      }
      return 'from any date';
    },
    selectedStatusAsString: function selectedStatusAsString() {
      var _this = this;

      if (this.showAllStatuses === true) {
        return 'of any status';
      }
      var statusNames = this.selectedStatusIds.map(function (statusId) {
        return _this.statuses[statusId].title;
      });

      var prefix = 'with status: ';
      if (statusNames.length === 0) {
        return '';
      }
      if (statusNames.length === 1) {
        return prefix + statusNames[0];
      }

      var lastStatus = statusNames.pop();
      return prefix + statusNames.join(', ') + ' and ' + lastStatus;
    },
    filtersAsSentence: function filtersAsSentence() {
      if (!this.hasFilters) {
        return this.noFiltersText;
      }
      return 'Appointments ' + this.selectedStatusAsString + ' ' + this.dateRangeFormatted;
    }
  },
  watch: {
    fromDate: function fromDate() {
      this.fromModal = false;
    },
    toDate: function toDate() {
      this.toModal = false;
    },
    touchShow: function touchShow() {
      this.visible = true;
    },

    filterFromDate: {
      immediate: true,
      handler: function handler() {
        if (this.filterFromDate) {
          this.fromDate = this.filterFromDate;
        }
      }
    },
    filterToDate: {
      immediate: true,
      handler: function handler() {
        if (this.filterToDate) {
          this.toDate = this.filterToDate;
        }
      }
    },
    filterStatusIds: {
      immediate: true,
      handler: function handler() {
        var _this2 = this;

        if (this.filterStatusIds && this.filterStatusIds.length > 0) {
          this.showAllStatuses = false;
          this.selectedStatuses = [];
          this.filterStatusIds.forEach(function (id) {
            _this2.selectedStatuses.push(_this2.statuses[id]);
          });
        } else {
          this.showAllStatuses = true;
        }
      }
    }
  }
});

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaymentList',
  props: {
    title: { type: String },
    appointment: { type: Object },
    payments: { type: Array, default: function _default() {
        return [];
      } },
    withDelete: { type: Boolean, default: true },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      deleteDialog: false,
      deleteLoading: false,
      deleteReqId: 'delete-payment-req',
      selectedPayment: null,
      deletingPayments: [],
      req: {
        resource: 'invoiceguru.transactions'
      }
    };
  },

  computed: {
    deleteRequest: function deleteRequest() {
      return this.$store.getters.getRequestById(this.deleteReqId, true);
    },
    deleteRequestStatus: function deleteRequestStatus() {
      return this.deleteRequest.status;
    }
  },
  watch: {
    deleteRequestStatus: function deleteRequestStatus() {
      if (this.deleteRequestStatus === 204) {
        this.$emit('payment:deleted');
      }
      if (this.deleteRequestStatus >= 400) {
        window.alert('There was an error deleting this payment. Please try again');
      }
    }
  },
  methods: {
    deleteClicked: function deleteClicked() {
      var vm = this;
      vm.deleteLoading = true;
      vm.deletePayment();
      window.setTimeout(function () {
        vm.deleteLoading = false;
        vm.deleteDialog = false;
      }, 1000);
    },
    getPayment: function getPayment() {
      this.req.resourceId = this.selectedPayment.transaction_id;
      this.$request('get', this.req);
    },
    deletePayment: function deletePayment() {
      var _this = this;

      var action = __WEBPACK_IMPORTED_MODULE_1__store_constants__["l" /* ACTIONS */].ASSIGN_PAYMENT;
      var paymentId = this.selectedPayment.id;
      var payload = {
        transaction_id: this.selectedPayment.transaction_id,
        appointments: {
          remove: [this.appointment.id]
        }
      };
      this.deletingPayments.push(paymentId);

      var url = this.$invoiceguru.baseUrl + '/action/' + action + '/';

      var options = this.$invoiceguru.getOptions();
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload), options).then(function (result) {
        _this.$emit('payment:deleted');
      }).catch(function () {
        window.alert('Unable to remove payment');
      });
    }
  }
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaymentList__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaymentList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PaymentList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppointmentCodeList__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppointmentCodeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AppointmentCodeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientCard__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_client_ClientCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_client_ClientCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Filters__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkActions__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BulkActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_invoice_manage_create_success__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_invoice_manage_create_success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_invoice_manage_create_success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_appointments__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatementIndex',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_appointments__["a" /* default */]],
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_3__Filters___default.a,
    ClientCard: __WEBPACK_IMPORTED_MODULE_2__components_client_ClientCard___default.a,
    PaymentList: __WEBPACK_IMPORTED_MODULE_0__PaymentList___default.a,
    BulkActions: __WEBPACK_IMPORTED_MODULE_4__BulkActions___default.a,
    InvoiceSuccess: __WEBPACK_IMPORTED_MODULE_5__components_invoice_manage_create_success___default.a,
    AppointmentCodeList: __WEBPACK_IMPORTED_MODULE_1__AppointmentCodeList___default.a
  },
  props: {
    value: { type: Object },
    client: { type: Object },
    loading: { type: Boolean, default: false },
    actionItems: { type: Array },
    filterFromDate: { type: String },
    filterToDate: { type: String },
    filterStatusIds: { type: Array },

    withSelectable: { type: Boolean, default: true },
    withReload: { type: Boolean, default: true },
    withFilters: { type: Boolean, default: true },
    withClientPreview: { type: Boolean, default: true },

    withInlineControls: { type: Boolean, default: false },
    isCompact: { type: Boolean, default: false },
    withPrevNext: { type: Boolean, default: false },
    initialFilterText: { type: String }
  },
  data: function data() {
    return {
      selectAll: false,
      panelState: [],
      menus: {},
      statement: {},
      appointment: {},
      selectedAppointmentIds: [],
      clientPreviewMenu: false,
      showFilters: false,
      filterString: '',
      filterTouch: 2,
      filters: {},
      dialogs: {
        payments: false,
        invoiceSuccess: false
      },
      newInvoice: false,
      subtotalList: [{
        text: 'Appointment cost',
        key: 'appointment_total_price_before_tax'
      }, {
        text: 'Other products',
        key: 'products_total_price'
      }, {
        text: 'Tax',
        key: 'appointment_tax'
      }, {
        text: 'Total',
        key: 'final_price'
      }, {
        text: 'Payments received',
        key: 'payments_received'
      }]
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.statement = this.value;
    }
  },

  watch: {
    value: function value() {
      this.statement = this.value;
    },
    selectedAppointmentIds: function selectedAppointmentIds() {
      this.$emit('selected:list', this.selectedAppointments);
    },
    client: function client() {
      this.clearSelected();
    },
    selectAll: function selectAll() {
      this.toggleSelectAll();
    },
    globalappdialogwatcher: function globalappdialogwatcher() {
      this.$emit('reload', this.filters);
    }
  },
  computed: {
    normalizedClient: function normalizedClient() {
      if (this.client && this.client.client && this.client.client.id) {
        return this.client.client;
      }
      return this.client;
    },
    relationshipId: function relationshipId() {
      if (this.client) {
        var isRelationship = this.client.client && this.client.client.id;
        if (isRelationship) {
          return this.client.id;
        }
      }
    },
    clientFullname: function clientFullname() {
      if (this.client && this.normalizedClient) {
        return this.normalizedClient.first_name + ' ' + this.normalizedClient.last_name;
      }
      return '';
    },
    appointments: function appointments() {
      if (this.statement && this.statement.results) {
        return this.statement.results;
      }
      return [];
    },
    selectedAppointments: function selectedAppointments() {
      var vm = this;
      return this.appointments.filter(function (appt) {
        return vm.selectedAppointmentIds.indexOf(appt.id) !== -1;
      });
    },
    actions: function actions() {
      if (this.actionItems && this.actionItems.length > 0) {
        return this.getAppointmentActionItemsByKeyList(this.actionItems);
      }
    },
    firstAppointmentAgo: function firstAppointmentAgo() {
      if (this.statement && this.statement.range) {
        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.statement.range.first_appointment_ever).fromNow();
      }
    }
  },
  methods: {
    noop: function noop() {},
    actionClicked: function actionClicked(action, appointment) {
      this.$emit('action', action, appointment);
    },
    setNewInvoice: function setNewInvoice(invoice) {
      this.refresh();
      this.newInvoice = invoice;
      this.dialogs.invoiceSuccess = true;
    },
    paymentAdded: function paymentAdded(payment) {
      this.refresh();
    },
    codesAdded: function codesAdded(payment) {
      this.refresh();
    },
    clearSelected: function clearSelected() {
      this.selectedAppointmentIds = [];
    },
    setFilters: function setFilters(params) {
      this.filters = params;
      this.refresh();
    },
    clearFilters: function clearFilters() {
      this.filters = {};
      this.refresh();
    },
    setFilterString: function setFilterString(str) {
      this.filterString = str;
    },
    refresh: function refresh() {
      this.$emit('reload', this.filters);
    },
    toggleSelectAll: function toggleSelectAll() {
      if (this.selectAll) {
        this.selectedAppointmentIds = this.appointments.map(function (appt) {
          return appt.id;
        });
      } else {
        this.selectedAppointmentIds = [];
      }
    }
  },
  i18n: {
    messages: {
      en: {
        codessummary: 'no diagnosis codes|1 diagnosis code|{n} diagnosis codes',
        productsummary: 'no products|1 product|{n} products'
      }
    }
  }
});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AgIframe',
  props: {
    src: { type: String, required: true }
  },
  data: function data() {
    return {
      loading: true
    };
  },

  watch: {
    src: function src() {
      this.loading = true;
    }
  },
  methods: {
    iframeloaded: function iframeloaded() {
      this.loading = false;
    }
  }
});

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ImageSearch__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ImageSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_ImageSearch__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BackgroundSelector',
  components: { HelpPopover: __WEBPACK_IMPORTED_MODULE_0__components_ui_HelpPopover___default.a, ImageSearch: __WEBPACK_IMPORTED_MODULE_1__components_ui_ImageSearch___default.a },
  props: {
    value: { type: String, required: true, default: '' },
    errorMessages: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      showdialog: false,
      imgUrl: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        this.imgUrl = this.value;
      }
    },
    imgUrl: function imgUrl() {
      this.$emit('input', this.imgUrl);
    }
  }
});

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CopyTextField',
  props: {
    textToCopy: { type: String, required: true },
    label: { type: String, required: false },
    hint: { type: String, required: false },
    dark: { type: Boolean, default: false },
    prependIcon: { type: String, required: false },
    copiedToClipbaordText: { type: String, default: 'Copied to clipboard' }
  },
  data: function data() {
    return {
      copyLinkText: ''
    };
  },
  mounted: function mounted() {
    this.copyLinkText = this.hint;
  },

  computed: {
    uuid: function uuid() {
      return Math.random().toString().split('.')[1];
    }
  },
  methods: {
    copyToClipboard: function copyToClipboard() {
      var _this = this;

      var el = document.getElementById(this.uuid);
      el.select();
      document.execCommand('copy');
      this.copyLinkText = this.copiedToClipbaordText;
      window.setTimeout(function () {
        _this.copyLinkText = _this.hint;
      }, 4000);
    }
  }
});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AGDataList',
  props: {
    items: { type: Array, default: function _default() {
        return [];
      } },
    titlePath: { type: String, default: 'title' },
    subTitlePath: { type: String, default: 'subtitle' },
    avatarPath: { type: String, default: null },
    avatarPosition: { type: String, default: 'before' },
    actionsPosition: { type: String, default: 'after' },
    withDivider: { type: Boolean, default: false },
    dense: { type: Boolean, default: false }
  }
});

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FlexibleComponentContainer',
  data: function data() {
    return {
      activeTab: 0
    };
  },

  props: {
    items: { type: Array, default: function _default() {
        return [];
      } },
    isCompact: { type: Boolean, default: false }
  }
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HelpPopover',
  props: {
    initiallyVisible: { type: Boolean, default: false },
    icon: { type: String, default: 'info' },
    iconAttrs: { type: Object },
    withCancel: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    cancelText: { type: String, default: 'Got it' },
    color: { type: String, default: 'primary' }
  },
  mounted: function mounted() {
    if (this.initiallyVisible) {
      this.showInfo = true;
    }
  },
  data: function data() {
    return {
      showInfo: false
    };
  }
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageSearch',
  props: {
    value: { type: String, required: false },
    title: { type: String, default: 'Choose a background' },
    initialSearch: { type: String, default: 'wellness' }
  },
  data: function data() {
    return {
      activeTab: 0,
      searchString: '',
      searchResponse: {},
      manualUrl: '',
      loading: false
    };
  },
  mounted: function mounted() {
    this.searchString = this.initialSearch;
    this.search();
  },

  computed: {
    images: function images() {
      return this.getObjectPath(this.searchResponse, 'data.results', []);
    },
    perPage: function perPage() {
      return 24;
    }
  },
  methods: {
    search: function search() {
      var payload = {
        headers: {
          Authorization: 'Client-ID e844ef6b655e466ae6355a7ad45e990ca3f96928ad4fa9dc1e6a3939592a3039'
        }
      };
      var vm = this;
      vm.loading = true;
      var url = 'https://api.unsplash.com/search/photos?query=' + this.searchString + '&orientation=landscape&per_page=' + this.perPage;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, payload).then(function (data) {
        vm.searchResponse = data;
        vm.loading = false;
      });
    }
  }
});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ServerErrors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ServerErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ServerErrors__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RequestStatus',
  components: { ServerErrors: __WEBPACK_IMPORTED_MODULE_0__components_ServerErrors___default.a },
  props: {
    request: { type: Object, default: function _default() {
        return {};
      } },
    successTimeout: { type: Number, default: 1200 },
    message200: { default: 'Success' },
    message201: { default: 'Successfully created' },
    message204: { type: String, default: 'Successfully deleted' },
    message404: { type: String, default: 'Resource not found' },
    message400: { type: String, default: 'There was a problem with your request. Please check your inputs and try again' },
    message401: { type: String, default: 'Permission denied' },
    message403: { type: String, default: 'Permission denied' },
    message500: { type: String, default: 'Server error. Please try again later or contact support if the problem persists' }
  },
  data: function data() {
    return {
      showSnacker: false
    };
  },

  watch: {
    requestStatus: function requestStatus() {
      this.$emit(this.requestStatus.toString(), this.request);
      var isSuccessRequestStatus = this.requestStatus > 199 && this.requestStatus < 300;
      if (isSuccessRequestStatus) {
        this.$emit('ok', this.request);
        if (this.requestStatus === 200 && this.message200 === false) {
          return;
        }
        if (this.requestStatus === 201 && this.message201 === false) {
          return;
        }
        this.showSnacker = true;
      } else {
        this.$emit('error', this.request);
      }
    }
  },
  computed: {
    requestStatus: function requestStatus() {
      return this.request.status;
    },
    messageType: function messageType() {
      var statusMap = {
        200: 'success',
        201: 'success',
        204: 'success',
        404: 'warning',
        401: 'warning',
        403: 'warning',
        400: 'error',
        500: 'error',
        502: 'error'
      };
      return statusMap[this.request.status];
    },
    message: function message() {
      var message = null;
      var key = 'message' + this.request.status;
      if (key in this) {
        message = this[key];
      }
      return this.getObjectPath(this.request, 'result.message', message);
    }
  },
  methods: {
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SharingInformation',
  components: { SpaceFaces: __WEBPACK_IMPORTED_MODULE_0__components_lists_SpaceFaces_vue___default.a, PractitionerFaces: __WEBPACK_IMPORTED_MODULE_1__components_lists_PractitionerFaces_vue___default.a },
  props: {
    context: { type: String, default: 'PRACTITIONER' },
    ownerId: { required: true },
    spaceIds: { type: Array, default: function _default() {
        return [];
      } },
    practitionerIds: { type: Array, default: function _default() {
        return [];
      } },
    ownerTextPrefix: { type: String, default: 'owned by' },
    sharingTextPrefix: { type: String, default: 'shared with' },
    size: { type: Number, default: 16 },
    vertical: { type: Boolean, default: false }
  }
});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SnapCode',
  props: {
    title: { type: String },
    snapUrl: { type: String },
    snapImg: { type: String }
  },
  i18n: {
    messages: {
      en: {
        info: 'Ask the client to scan this QR code with SnapScan'
      }
    }
  }
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TextEditor',
  props: {
    value: { type: String, required: false, default: '' },
    label: { type: String, required: false },
    fullscreen: { type: Boolean, default: false },
    supportsMarkdown: { type: Boolean, default: false },
    initialAttrs: { type: Object, default: function _default() {
        return {};
      } },
    attrs: {
      type: Object,
      default: function _default() {
        return {
          rows: 30,
          counter: true
        };
      }
    }
  },
  data: function data() {
    return {
      showdialog: false,
      text: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.text = this.value;
          if (this.value === '{}') {
            this.text = '';
          }
        }
      }
    },
    text: function text() {
      this.$emit('input', this.text);
    }
  }
});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WhatsAppBtn',
  props: {
    number: { type: String, required: true },
    message: { type: String, required: false, default: null },
    attrs: { type: Object },
    small: { type: Boolean, default: false },
    classes: { type: String, default: '' }
  },
  methods: {
    noop: function noop() {
      return null;
    }
  }
});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessageDeliveryStatus',
  props: {
    reqId: 'get-communication-request',
    batchId: { required: true }
  },
  computed: {
    communications: function communications() {
      return this.$store.getters.getCommsByBatchId(this.batchId);
    },
    request: function request() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    requestStatus: function requestStatus() {
      return this.request.status;
    }
  },
  watch: {
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        var comms = this.geObjectPath(this.request, 'result.data.results', []);
        if (comms && comms.lenth > 0) {
          this.$store.commit('addManyCommunications', comms);
        }
      }
    }
  },
  methods: {
    isFailure: function isFailure(comm) {
      return comm && comm.status.toLowerCase() === 'failed';
    },
    status: function status(comm) {
      if (comm) {
        if (comm.communicationstatus && comm.communicationstatus.length > 0) {
          var stat = comm.communicationstatus[comm.communicationstatus.length - 1];
          if (stat) {
            return stat.status;
          }
        }
        return 'sent';
      }
    },
    get: function get() {
      var params = { batch_id: this.batchId };
      this.$communicationguru.resource('communication').id(this.reqId).list(params);
    }
  }
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecipientCard',
  props: {
    title: { type: String },
    templateSlug: { type: String },
    value: { type: Object, required: true },
    sender: { type: Object, required: false },
    context: { type: Object, required: false }
  },
  data: function data() {
    return {
      bySMS: false,
      byEmail: false,
      recipient: {}
    };
  },

  computed: {
    parsedContext: function parsedContext() {
      if (this.context) {
        this.context.recipient = this.recipient;
        this.context.sender = this.sender;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.context);
      }
      return '{}';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.recipient = this.value;
        }
      }
    },
    bySMS: function bySMS() {
      this.$emit('sendTo', 'bySMS', this.bySMS, this.recipient);
    },
    byEmail: function byEmail() {
      this.$emit('sendTo', 'byEmail', this.byEmail, this.recipient);
    }
  },
  methods: {
    emailHint: function emailHint(client) {
      if (client.email && this.isRealEmail(client.email)) {
        return client.email;
      }
      return 'No email available';
    }
  }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_CommunicationTemplateForm__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_CommunicationTemplateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_forms_CommunicationTemplateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_lists_CommunicationTemplateList__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_lists_CommunicationTemplateList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_lists_CommunicationTemplateList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_client__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecipientCard__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecipientCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RecipientCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MessageDeliveryStatus__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MessageDeliveryStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MessageDeliveryStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(3);











var SELECT_TEMPLATE_PAGE = 0;
var SELECT_RECIPIENTS_PAGE = 1;
var RESULTS_PAGE = 2;
var EDIT_COMMUNICATION_PAGE = 3;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SendTemplate',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_client__["a" /* default */]],
  components: { RecipientCard: __WEBPACK_IMPORTED_MODULE_5__RecipientCard___default.a, MessageDeliveryStatus: __WEBPACK_IMPORTED_MODULE_6__MessageDeliveryStatus___default.a, CommunicationTemplateForm: __WEBPACK_IMPORTED_MODULE_2__components_forms_CommunicationTemplateForm___default.a, CommunicationTemplateList: __WEBPACK_IMPORTED_MODULE_3__components_lists_CommunicationTemplateList___default.a },
  props: {
    title: { type: String, default: 'Select recipients' },
    initialPage: { type: Number, default: 0 },
    clients: { type: Array, required: true },
    templateContext: { type: String, required: true },
    template: { type: String, required: false },
    flat: { type: Boolean, default: true },
    withSend: { type: Boolean, default: true },
    withCancel: { type: Boolean, default: true },
    sendToMe: { type: Boolean, default: true },
    touch: { type: Number, default: 0 },
    context: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      page: 0,
      sendTo: {},
      batchId: null,
      sendReqId: 'send-templated-communication',
      selectedTemplate: null,
      sendToMeTransports: {
        byEmail: false,
        bySMS: false
      }
    };
  },
  mounted: function mounted() {
    this.batchId = Math.random().toString();
    this.page = this.initialPage;
    this.$emit('sender', this.sender);
    if (this.template) {
      this.page = SELECT_RECIPIENTS_PAGE;
    }
  },

  watch: {
    touch: function touch() {
      this.page = 0;
      setTimeout(this.reset, 100);
    },
    sender: function sender() {
      this.$emit('sender', this.sender);
    },
    template: function template() {
      if (this.template) {
        this.page = SELECT_RECIPIENTS_PAGE;
      }
    },
    selectedRecipients: function selectedRecipients() {
      this.$emit('recipients', this.selectedRecipients);
    },
    sendRequestStatus: function sendRequestStatus() {
      if (this.sendRequestStatus === 201) {
        this.page = RESULTS_PAGE;
        var data = this.getObjectPath(this.sendRequest, 'result.data', {});
        if (data && data.length > 0) {
          this.batchId = data[0].batch_id;
        }
      }
    }
  },
  computed: {
    sendRequest: function sendRequest() {
      return this.$store.getters.getRequestById(this.sendReqId, true);
    },
    sendRequestStatus: function sendRequestStatus() {
      return this.sendRequest.status;
    },
    sender: function sender() {
      var me = this.$store.getters.me;
      var sender = this.asRecipient(me);
      sender.user_id = me.id;
      sender.id = me.id;
      sender.relationship_id = null;
      return sender;
    },
    selectedRecipients: function selectedRecipients() {
      var _this = this;

      var recipients = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.sendTo).forEach(function (entry) {
        var key = entry[0];
        var yesno = entry[1];
        if (yesno === true) {
          var bits = key.split(':');
          var method = bits[0];
          var relationshipId = bits[1];
          var recipient = _this.recipients.find(function (r) {
            return r.relationship_id.toString() === relationshipId.toString();
          });
          var copy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(recipient));
          if (method === 'byEmail') {
            copy.preferred_transport = 'email';
            recipients.push(copy);
          }
          if (method === 'bySMS') {
            copy.preferred_transport = 'sms';
            recipients.push(copy);
          }
        }
      });
      if (this.sendToMeTransports.byEmail) {
        var copy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.sender));
        copy.preferred_transport = 'email';
        recipients.push(copy);
      }
      if (this.sendToMeTransports.bySMS) {
        var _copy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.sender));
        _copy.preferred_transport = 'sms';
        recipients.push(_copy);
      }
      return recipients;
    },
    recipients: function recipients() {
      var _this2 = this;

      return this.clients.map(function (cli) {
        return _this2.asRecipient(cli);
      });
    },
    payload: function payload() {
      return {
        batch_id: this.batchId,
        template: this.template,
        context: this.context,
        sender: this.sender,
        recipients: this.selectedRecipients
      };
    }
  },
  methods: {
    send: function send() {
      var result = this.performAction(this.$appointmentguru, 'practitioner', 'appointments', this.context.id, 'send_message', this.payload);
      var vm = this;
      result.then(function () {
        vm.page = RESULTS_PAGE;
      });
    },
    setCrud: function setCrud(template) {
      this.selectedTemplate = template;
      this.page = EDIT_COMMUNICATION_PAGE;
    },
    setSelectedCommunicationTemplate: function setSelectedCommunicationTemplate(template) {
      this.template = template.slug;
      this.page = SELECT_RECIPIENTS_PAGE;
    },
    reset: function reset() {
      if (this.template) {
        this.page = SELECT_RECIPIENTS_PAGE;
      } else {
        this.page = SELECT_TEMPLATE_PAGE;
      }
      this.batchId = Math.random().toString();
    },
    setSendTo: function setSendTo(method, yesno, recipient) {
      var key = method + ':' + recipient.relationship_id;
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(this.sendTo, key, yesno);
    },
    setSendToMe: function setSendToMe(method, yesno, recipient) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(this.sendToMeTransports, method, yesno);
    }
  },
  i18n: {
    messages: {
      en: {
        comms: {
          title: 'Which type of notification would you like to send?'
        }
      }
    }
  }
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_wizards_WizLayout_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_wizards_WizLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_wizards_WizLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_AddressPicker_vue__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pickers_AddressPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pickers_AddressPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wizards_screens_SuccessScreen_vue__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wizards_screens_SuccessScreen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_wizards_screens_SuccessScreen_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationWizard',
  components: { WizLayout: __WEBPACK_IMPORTED_MODULE_0__components_wizards_WizLayout_vue___default.a },
  props: {
    spaceId: { required: true },
    space: { required: false },
    successSteps: { type: Array, default: function _default() {
        return [];
      } },
    touch: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      step: 0,
      req: {
        create: {
          resource: 'ag.spaces.addresses'
        },
        save: {
          resource: 'ag.spaces.addresses'
        }
      },
      location: {
        name: null,
        is_virtual: false,
        place: {}
      }
    };
  },

  methods: {
    createLocation: function createLocation() {
      this.req.create.data = this.payload;
      this.req.create.kwargs = { spaceId: this.spaceId };
      this.$request('save', this.req.create);
    },
    saveLocation: function saveLocation(data) {
      this.req.save.data = data;
      this.req.save.kwargs = { spaceId: this.spaceId };
      this.req.save.resourceId = this.location.id;
      this.$request('save', this.req.save);
    },
    baseLocation: function baseLocation() {
      return {
        name: null,
        is_virtual: false,
        place: {}
      };
    },
    reset: function reset() {
      this.location = this.baseLocation();
      this.step = 0;
    },
    exitWizard: function exitWizard() {
      this.$emit('cancel');
      this.reset();
    }
  },
  watch: {
    createRequestStatus: function createRequestStatus() {
      if (this.createRequestStatus === 201) {
        this.step++;
        this.location = this.req.create.result;
        this.init();
      }
    },
    saveRequestStatus: function saveRequestStatus() {
      if (this.saveRequestStatus === 200) {
        this.step++;
      }
    },
    touch: function touch() {
      this.reset();
    }
  },
  computed: {
    createRequestStatus: function createRequestStatus() {
      return this.req.create.status;
    },
    saveRequestStatus: function saveRequestStatus() {
      return this.req.save.status;
    },
    place: function place() {
      return this.getObjectPath(this.obj, 'place.geometry.location', null);
    },
    lat: function lat() {
      if (this.place && this.place.lat) {
        return this.place.lat();
      }
      return null;
    },
    lng: function lng() {
      if (this.place && this.place.lng) {
        return this.place.lng();
      }
      return null;
    },
    payload: function payload() {
      var pl = this.location;
      pl['service'] = this.spaceId;
      return pl;
    },
    steps: function steps() {
      var vm = this;
      return [{
        id: 'name',
        title: 'What is the name of this location?',
        attrs: {
          label: 'Name',
          persistentHint: true,
          box: true,
          hint: 'e.g.: Melrose Arch Virgin Active, ABC Welness center, Jessie Jones Bio - Lonehill  etc.'
        },
        back: { visible: true, disabled: true },
        next: { visible: true, disabled: true },
        nextText: 'Create',
        isValid: function isValid(step, obj) {
          return obj && obj.name && obj.name.length > 1;
        },

        onNext: function onNext() {
          vm.createLocation();
        },
        events: {}
      }, {
        id: 'is_virtual',
        title: 'What type of location is this?',
        attrs: {
          label: 'Type of location',
          items: [{
            value: false,
            text: 'Physical address'
          }, {
            value: true,
            text: 'Virtual/Online'
          }]
        },
        default: false,
        vcomponent: 'vradiogroup',
        back: { visible: true, disabled: true },
        next: { visible: true, disabled: true },
        nextText: 'Next',
        isValid: function isValid() {
          return true;
        },

        onNext: function onNext(step, obj) {
          vm.saveLocation({ is_virtual: obj.is_virtual });
        },
        events: {}
      }, {
        id: 'place',
        title: 'Add address information',
        component: __WEBPACK_IMPORTED_MODULE_1__components_pickers_AddressPicker_vue___default.a,
        attrs: {
          class: 'ma-5',
          withSummary: true
        },
        back: { visible: true, disabled: true },
        next: { visible: true, disabled: true },
        nextText: 'Next',
        isValid: function isValid() {
          return vm.location && vm.location.place && vm.location.place.place_id;
        },

        onNext: function onNext(step, obj) {
          var data = {
            place_id: obj.place.place_id,
            place_data: obj.place,
            latitude: vm.lat,
            longitude: vm.lng
          };
          vm.saveLocation(data);
        },
        events: {}
      }, {
        id: 'success',
        title: 'Success!',
        component: __WEBPACK_IMPORTED_MODULE_2__components_wizards_screens_SuccessScreen_vue___default.a,
        attrs: {
          actions: vm.successSteps
        },
        back: { visible: true, disabled: true },
        next: { visible: true, disabled: true },
        nextText: 'Next',
        isValid: function isValid() {
          return vm.location && vm.location.place && vm.location.place.place_id;
        },

        events: {}
      }];
    }
  }
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_wizards_WizLayout_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_wizards_WizLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_wizards_WizLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_wizards_screens_Decision_vue__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_wizards_screens_Decision_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_wizards_screens_Decision_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpaceWizard',
  components: { WizLayout: __WEBPACK_IMPORTED_MODULE_0__components_wizards_WizLayout_vue___default.a },
  data: function data() {
    return {
      step: 0,
      obj: {},
      settings: {},
      req: {
        resource: 'ag.spaces.practitioner'
      },
      settingsReq: {
        resource: 'ag.spaces.settings'
      }
    };
  },

  methods: {
    createSpace: function createSpace() {
      this.req.data = this.obj;
      this.$request('save', this.req);
    },
    saveSetting: function saveSetting(key, value) {
      var data = {};
      data[key] = value;
      this.settingsReq.data = data;
      this.settingsReq.resourceId = this.settings.id;

      this.settingsReq.kwargs = { spaceId: this.obj.id };
      this.settingsReq.method = 'PATCH';
      this.$request('save', this.settingsReq);
    },
    reset: function reset() {
      this.step = 0;
    }
  },
  watch: {
    reqStatus: function reqStatus() {
      if (this.reqStatus === 201) {
        this.obj = this.req.result;
        this.settings = this.obj.settings;
        this.step++;

        this.getMe();
        this.getLookups();
      }
    },
    settingReqStatus: function settingReqStatus() {
      if (this.settingReqStatus === 200) {
        this.obj = this.req.result;
        this.step++;
      }
    }
  },
  computed: {
    reqStatus: function reqStatus() {
      return this.req.status;
    },
    settingReqStatus: function settingReqStatus() {
      return this.settingsReq.status;
    },
    steps: function steps() {
      var _this = this;

      var vm = this;
      return [{
        id: 'title',
        title: 'Give your space a name',
        attrs: {
          label: 'Name',
          persistentHint: true,
          box: true,
          hint: 'Choose a name for this space'
        },
        back: { visible: true, disabled: true },
        next: { visible: true, disabled: true },
        nextText: 'Create',
        isValid: function isValid(step, obj) {
          return obj && obj.title && obj.title.length > 1;
        },

        onNext: function onNext() {
          vm.createSpace();
        },
        events: {}
      }, {
        id: 'decision_configure',
        attrs: {
          title: 'Would you like to further configure this space?',
          options: [{
            id: 'yes_configure',
            text: 'Yes, let\'s finish setting up this space now'
          }, {
            id: 'no_done',
            text: 'No, I\'ll finish configuration later',
            prompt: {
              title: 'Configure later',
              description: 'You can configure all aspects of this space later from settings in the side menu',
              done: 'Got it'
            }
          }]
        },
        component: __WEBPACK_IMPORTED_MODULE_1__components_wizards_screens_Decision_vue___default.a,
        back: { visible: false },
        next: { visible: false },
        isValid: function isValid() {
          return false;
        },

        events: {
          selected: function selected(val) {
            if (val.id === 'no_done') {
              vm.$emit('cancel');
            }
            if (val.id === 'yes_configure') {
              vm.step++;
            }
          }
        }
      }, {
        id: 'practice_name',
        title: 'Practice name (if relevant)',
        attrs: {
          label: 'Practice name',
          persistentHint: true,
          box: true,
          hint: 'The official name of this practice (if relevant)'
        },
        back: { visible: true, disabled: false },
        next: { visible: true, disabled: false },
        required: false,
        isValid: function isValid(step, obj) {
          return obj.title && obj.title.length > 1;
        },

        onNext: function onNext(step, obj) {
          _this.saveSetting('practice_name', obj.practice_name);
        },
        events: {}
      }, {
        id: 'practice_number',
        title: 'Practice number (if relevant)',
        attrs: {
          label: 'Practice number',
          persistentHint: true,
          box: true,
          hint: 'If you have a registered practice, enter the practive number here'
        },
        back: { visible: true, disabled: false },
        next: { visible: true, disabled: false },
        required: false,
        isValid: function isValid(step, obj) {
          return obj.title && obj.title.length > 1;
        },

        onNext: function onNext(step, obj) {
          _this.saveSetting('practice_number', obj.practice_number);
        },
        events: {}
      }, {
        id: 'banking_details',
        title: 'Banking details',
        attrs: {
          label: 'Banking details',
          persistentHint: true,
          box: true,
          hint: 'Your bank account information as you would like it to show on your invoices'
        },
        vcomponent: 'vtextarea',
        back: { visible: true, disabled: false },
        next: { visible: true, disabled: false },
        required: false,
        isValid: function isValid(step, obj) {
          return obj.title && obj.title.length > 1;
        },

        onNext: function onNext(step, obj) {
          _this.saveSetting('banking_details', obj.banking_details);
        },
        events: {}
      }, {
        id: 'billing_address',
        title: 'Billing address',
        attrs: {
          label: 'Billing address',
          persistentHint: true,
          box: true,
          hint: 'The billing address that we will show on your invoices'
        },
        vcomponent: 'vtextarea',
        back: { visible: true, disabled: false },
        next: { visible: true, disabled: false },
        required: false,
        isValid: function isValid(step, obj) {
          return obj.title && obj.title.length > 1;
        },

        onNext: function onNext(step, obj) {
          _this.saveSetting('billing_address', obj.billing_address);
        },
        events: {}
      }];
    }
  }
});

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WizLayout',
  props: {
    value: { type: Object, required: false },
    steps: { type: Array, required: true },
    initialStep: { default: 0 },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      window: 0,
      obj: {}
    };
  },

  methods: {
    next: function next(step, obj) {
      if (this.loading) {
        return null;
      }
      if (step && step.isValid && step.isValid(step, obj)) {
        if (step.onNext) {
          step.onNext(step, obj);
        } else {
          this.window++;
        }
      } else {}
    }
  },
  watch: {
    initialStep: function initialStep() {
      this.window = this.initialStep;
    },
    window: function window() {
      this.$emit('update:initialStep', this.window);
    },

    value: {
      immediate: true,
      handler: function handler() {
        if (this.value) {
          this.obj = this.value;
        }
      }
    },
    obj: function obj() {
      this.$emit('input', this.obj);
    }
  },
  computed: {
    activeStep: function activeStep() {
      console.log(this.window, this.steps.length);
      if (this.window > this.steps.length - 1) {
        this.window = 'success';
      }
      if (this.window === 'success') {
        return this.successStep;
      }
      return this.steps[this.window];
    },
    successStep: function successStep() {
      return {
        id: 'success',
        title: 'Space created',
        back: { visible: false },
        next: { visible: false },
        required: false,
        isValid: function isValid() {
          return false;
        }
      };
    }
  }
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Decision',
  props: {
    title: { type: String, required: true },
    options: { type: Array, required: true },
    description: { type: String, required: false }
  },
  data: function data() {
    return {
      dialog: false,
      selected: {}
    };
  },

  methods: {
    setSelected: function setSelected(option) {
      if (option.prompt) {
        this.selected = option;
        this.dialog = true;
      } else {
        this.$emit('selected', option);
      }
    }
  }
});

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SuccessScreen',
  props: {
    value: { type: Object },
    actions: { type: Array, default: function _default() {
        return [];
      } },
    withDone: { type: Boolean, default: true }
  }
});

/***/ }),
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 274,
	"./af.js": 274,
	"./ar": 281,
	"./ar-dz": 275,
	"./ar-dz.js": 275,
	"./ar-kw": 276,
	"./ar-kw.js": 276,
	"./ar-ly": 277,
	"./ar-ly.js": 277,
	"./ar-ma": 278,
	"./ar-ma.js": 278,
	"./ar-sa": 279,
	"./ar-sa.js": 279,
	"./ar-tn": 280,
	"./ar-tn.js": 280,
	"./ar.js": 281,
	"./az": 282,
	"./az.js": 282,
	"./be": 283,
	"./be.js": 283,
	"./bg": 284,
	"./bg.js": 284,
	"./bm": 285,
	"./bm.js": 285,
	"./bn": 287,
	"./bn-bd": 286,
	"./bn-bd.js": 286,
	"./bn.js": 287,
	"./bo": 288,
	"./bo.js": 288,
	"./br": 289,
	"./br.js": 289,
	"./bs": 290,
	"./bs.js": 290,
	"./ca": 291,
	"./ca.js": 291,
	"./cs": 292,
	"./cs.js": 292,
	"./cv": 293,
	"./cv.js": 293,
	"./cy": 294,
	"./cy.js": 294,
	"./da": 295,
	"./da.js": 295,
	"./de": 298,
	"./de-at": 296,
	"./de-at.js": 296,
	"./de-ch": 297,
	"./de-ch.js": 297,
	"./de.js": 298,
	"./dv": 299,
	"./dv.js": 299,
	"./el": 300,
	"./el.js": 300,
	"./en-au": 301,
	"./en-au.js": 301,
	"./en-ca": 302,
	"./en-ca.js": 302,
	"./en-gb": 303,
	"./en-gb.js": 303,
	"./en-ie": 304,
	"./en-ie.js": 304,
	"./en-il": 305,
	"./en-il.js": 305,
	"./en-in": 306,
	"./en-in.js": 306,
	"./en-nz": 307,
	"./en-nz.js": 307,
	"./en-sg": 308,
	"./en-sg.js": 308,
	"./eo": 309,
	"./eo.js": 309,
	"./es": 313,
	"./es-do": 310,
	"./es-do.js": 310,
	"./es-mx": 311,
	"./es-mx.js": 311,
	"./es-us": 312,
	"./es-us.js": 312,
	"./es.js": 313,
	"./et": 314,
	"./et.js": 314,
	"./eu": 315,
	"./eu.js": 315,
	"./fa": 316,
	"./fa.js": 316,
	"./fi": 317,
	"./fi.js": 317,
	"./fil": 318,
	"./fil.js": 318,
	"./fo": 319,
	"./fo.js": 319,
	"./fr": 322,
	"./fr-ca": 320,
	"./fr-ca.js": 320,
	"./fr-ch": 321,
	"./fr-ch.js": 321,
	"./fr.js": 322,
	"./fy": 323,
	"./fy.js": 323,
	"./ga": 324,
	"./ga.js": 324,
	"./gd": 325,
	"./gd.js": 325,
	"./gl": 326,
	"./gl.js": 326,
	"./gom-deva": 327,
	"./gom-deva.js": 327,
	"./gom-latn": 328,
	"./gom-latn.js": 328,
	"./gu": 329,
	"./gu.js": 329,
	"./he": 330,
	"./he.js": 330,
	"./hi": 331,
	"./hi.js": 331,
	"./hr": 332,
	"./hr.js": 332,
	"./hu": 333,
	"./hu.js": 333,
	"./hy-am": 334,
	"./hy-am.js": 334,
	"./id": 335,
	"./id.js": 335,
	"./is": 336,
	"./is.js": 336,
	"./it": 338,
	"./it-ch": 337,
	"./it-ch.js": 337,
	"./it.js": 338,
	"./ja": 339,
	"./ja.js": 339,
	"./jv": 340,
	"./jv.js": 340,
	"./ka": 341,
	"./ka.js": 341,
	"./kk": 342,
	"./kk.js": 342,
	"./km": 343,
	"./km.js": 343,
	"./kn": 344,
	"./kn.js": 344,
	"./ko": 345,
	"./ko.js": 345,
	"./ku": 346,
	"./ku.js": 346,
	"./ky": 347,
	"./ky.js": 347,
	"./lb": 348,
	"./lb.js": 348,
	"./lo": 349,
	"./lo.js": 349,
	"./lt": 350,
	"./lt.js": 350,
	"./lv": 351,
	"./lv.js": 351,
	"./me": 352,
	"./me.js": 352,
	"./mi": 353,
	"./mi.js": 353,
	"./mk": 354,
	"./mk.js": 354,
	"./ml": 355,
	"./ml.js": 355,
	"./mn": 356,
	"./mn.js": 356,
	"./mr": 357,
	"./mr.js": 357,
	"./ms": 359,
	"./ms-my": 358,
	"./ms-my.js": 358,
	"./ms.js": 359,
	"./mt": 360,
	"./mt.js": 360,
	"./my": 361,
	"./my.js": 361,
	"./nb": 362,
	"./nb.js": 362,
	"./ne": 363,
	"./ne.js": 363,
	"./nl": 365,
	"./nl-be": 364,
	"./nl-be.js": 364,
	"./nl.js": 365,
	"./nn": 366,
	"./nn.js": 366,
	"./oc-lnc": 367,
	"./oc-lnc.js": 367,
	"./pa-in": 368,
	"./pa-in.js": 368,
	"./pl": 369,
	"./pl.js": 369,
	"./pt": 371,
	"./pt-br": 370,
	"./pt-br.js": 370,
	"./pt.js": 371,
	"./ro": 372,
	"./ro.js": 372,
	"./ru": 373,
	"./ru.js": 373,
	"./sd": 374,
	"./sd.js": 374,
	"./se": 375,
	"./se.js": 375,
	"./si": 376,
	"./si.js": 376,
	"./sk": 377,
	"./sk.js": 377,
	"./sl": 378,
	"./sl.js": 378,
	"./sq": 379,
	"./sq.js": 379,
	"./sr": 381,
	"./sr-cyrl": 380,
	"./sr-cyrl.js": 380,
	"./sr.js": 381,
	"./ss": 382,
	"./ss.js": 382,
	"./sv": 383,
	"./sv.js": 383,
	"./sw": 384,
	"./sw.js": 384,
	"./ta": 385,
	"./ta.js": 385,
	"./te": 386,
	"./te.js": 386,
	"./tet": 387,
	"./tet.js": 387,
	"./tg": 388,
	"./tg.js": 388,
	"./th": 389,
	"./th.js": 389,
	"./tk": 390,
	"./tk.js": 390,
	"./tl-ph": 391,
	"./tl-ph.js": 391,
	"./tlh": 392,
	"./tlh.js": 392,
	"./tr": 393,
	"./tr.js": 393,
	"./tzl": 394,
	"./tzl.js": 394,
	"./tzm": 396,
	"./tzm-latn": 395,
	"./tzm-latn.js": 395,
	"./tzm.js": 396,
	"./ug-cn": 397,
	"./ug-cn.js": 397,
	"./uk": 398,
	"./uk.js": 398,
	"./ur": 399,
	"./ur.js": 399,
	"./uz": 401,
	"./uz-latn": 400,
	"./uz-latn.js": 400,
	"./uz.js": 401,
	"./vi": 402,
	"./vi.js": 402,
	"./x-pseudo": 403,
	"./x-pseudo.js": 403,
	"./yo": 404,
	"./yo.js": 404,
	"./zh-cn": 405,
	"./zh-cn.js": 405,
	"./zh-hk": 406,
	"./zh-hk.js": 406,
	"./zh-mo": 407,
	"./zh-mo.js": 407,
	"./zh-tw": 408,
	"./zh-tw.js": 408
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1154;

/***/ }),
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1530),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(994)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1529),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(914)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1374),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1518),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(964)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1466),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(956)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1454),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68985aff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1398),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1473),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1453),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1514),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1380),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(998)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1540),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(897)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1340),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(902)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1354),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(898)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1345),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1319),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1452),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(982)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1499),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(984)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(967)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1474),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-797f49df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1451),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(965)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1467),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(963)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1465),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(903)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1355),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1500),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1332),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1314),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(884)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1311),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(996)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1534),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(885)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1313),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(962)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1464),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(929)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1405),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1520),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(947)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1437),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1341),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1445),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(968)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1477),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1378),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1364),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1539),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1544),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1344),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1483),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1365),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(973)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1484),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(927)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1402),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1348),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(887)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(1317),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(1377),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(993)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1528),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1415),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1002)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1549),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(997)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1538),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e1f270b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(883)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1310),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1409),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(979)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1491),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(894)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1335),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1515),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1323),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1496),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(1343),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1350),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1511),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1431),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1421),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(970)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1479),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(906)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1358),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(917)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1379),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(950)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1441),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1447),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(946)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1435),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(1366),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(910)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1363),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-263534c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(940)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(1419),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(959)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(1458),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bd0ec28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(1460),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(1395),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(901)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(1353),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(1475),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(1543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(1519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(1352),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(1522),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(1334),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(971)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(1481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d412261",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(1501),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(1494),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(1521),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(1535),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(1336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(893)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(1331),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(1414),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(1391),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(989)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(1516),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bea09ae6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(1346),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(1385),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(1470),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(742),
  /* template */
  __webpack_require__(1429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(1362),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(1446),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-637d8f20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(745),
  /* template */
  __webpack_require__(1387),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34aebdec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(1359),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(983)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(1504),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(750),
  /* template */
  __webpack_require__(1397),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(751),
  /* template */
  __webpack_require__(1424),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(909)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(753),
  /* template */
  __webpack_require__(1361),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(754),
  /* template */
  __webpack_require__(1327),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(755),
  /* template */
  __webpack_require__(1370),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(934)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(756),
  /* template */
  __webpack_require__(1411),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(757),
  /* template */
  __webpack_require__(1393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(758),
  /* template */
  __webpack_require__(1316),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(1326),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f13e816",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(1412),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(992)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(763),
  /* template */
  __webpack_require__(1527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(999)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(1542),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(938)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1417),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(988)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(949)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(767),
  /* template */
  __webpack_require__(1440),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(955)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(1449),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(1513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1005)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffc1d768",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(1512),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(1462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(990)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(779),
  /* template */
  __webpack_require__(1523),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(888)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(1322),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(974)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1486),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(918)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(786),
  /* template */
  __webpack_require__(1381),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(789),
  /* template */
  __webpack_require__(1433),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(911)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(1367),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1436),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(957)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1455),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(995)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1532),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(802),
  /* template */
  __webpack_require__(1547),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(1329),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(1533),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(807),
  /* template */
  __webpack_require__(1480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(808),
  /* template */
  __webpack_require__(1517),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.items), function(item) {
    return _c('v-chip', {
      key: item.id,
      attrs: {
        "small": "",
        "color": item.theme,
        "dark": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelected(item)
        }
      }
    }, [(_vm.facets && item.id in _vm.facets) ? _c('v-avatar', {
      staticClass: "darken-2",
      class: item.theme
    }, [_vm._v(_vm._s(_vm.facets[item.id]))]) : _vm._e(), _vm._v("\n  " + _vm._s(item.title) + "\n  "), (_vm.isSelected(item)) ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.item)
      }
    }
  }, [(_vm.withAvatar) ? _c('v-list-tile-avatar', {
    staticClass: "ma-0 mr-2 pa-0 white--text",
    staticStyle: {
      "min-width": "30px"
    },
    attrs: {
      "size": 30,
      "color": "teal"
    }
  }, [(_vm.profilePicture) ? _c('v-img', {
    attrs: {
      "src": _vm.profilePicture
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.initials(_vm.item))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item && _vm.item.id) ? _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.profilePicture && !_vm.withAvatar) ? _c('v-avatar', {
    attrs: {
      "size": 24
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.profilePicture
    }
  })], 1) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.fullname) + "\n      "), _vm._t("title-chips")], 2), _vm._v(" "), (!_vm.withAvatar) ? _c('v-list-tile-sub-title', {
    staticClass: "ml-4 pl-1"
  }, [_vm._v("\n      " + _vm._s(_vm.profession) + "\n    ")]) : _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.profession)
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._t("action")], 2)
},staticRenderFns: []}

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, _vm._l((_vm.cols), function(col) {
    return _c('v-flex', {
      key: col.value,
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-toolbar', {
      attrs: {
        "dense": "",
        "flat": ""
      }
    }, [_c('v-btn', {
      staticClass: "visible-xs-only",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleCol(col)
        }
      }
    }, [(_vm.visible[col.value]) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("expand_less")]) : _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("expand_more")])], 1), _vm._v(" "), _c('v-subheader', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(col.text) + " days")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
      staticClass: "mr-4"
    }, [_vm._v(_vm._s(_vm.formatCurrency('ZAR', _vm.totals[col.value])))])], 1), _vm._v(" "), (_vm.visible[col.value]) ? _c('invoice-list', _vm._g({
      staticClass: "invoice-list",
      class: col.color,
      attrs: {
        "invoices": _vm.report[col.value],
        "actions": _vm.actions,
        "loading": _vm.request.loading,
        "primary-action": {
          icon: 'chevron_right',
          text: 'More'
        }
      }
    }, _vm.events)) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_c('help-popover', [_vm._v("\n        This is a list of clients that you've seen within the\n        selected daterange\n      ")]), _vm._v("\n      Active clients\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.withSearch) ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "prepend-icon": "search",
      "clearable": ""
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.filteredActiveClients), function(relationship, index) {
    return [_c('v-list-tile', {
      key: relationship.id,
      class: {
        "blue lighten-5": (_vm.activeIndex === index)
      },
      on: {
        "click": function($event) {
          return _vm.setSelected(relationship, index)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(relationship.client.first_name) + " " + _vm._s(relationship.client.last_name) + "\n        ")])], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (relationship.id))
    })]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._l((_vm.practitioners), function(practitioner) {
    return [_vm._t("default"), _vm._v(" "), (practitioner) ? _c('v-tooltip', {
      key: practitioner.id,
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-avatar', _vm._g({
            staticClass: "ml-1 elevation-4",
            attrs: {
              "size": _vm.size,
              "color": "grey"
            }
          }, on), [(_vm.avatarUrl(practitioner)) ? _c('v-img', {
            attrs: {
              "lazy": "",
              "src": _vm.avatarUrl(practitioner)
            }
          }) : _c('span', {
            staticClass: "white--text"
          }, [(practitioner && practitioner.full_name) ? [_vm._v("\n              " + _vm._s(practitioner.full_name[0]) + "\n            ")] : _vm._e()], 2)], 1), _vm._v(" "), (_vm.withAdd) ? _c('v-chip', {
            attrs: {
              "outline": "",
              "outlined": "",
              "color": "primary",
              "size": _vm.size
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.$emit("add")
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("add")])], 1) : _vm._e()]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getTitle(practitioner)))])]) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.history')))]), _vm._v(" "), _c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.usage')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.activeTab == 0) ? _c('help-popover', {
    staticClass: "mr-4 mt-2"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('help.history')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 1) ? _c('help-popover', {
    staticClass: "mr-4 mt-2",
    attrs: {
      "color": "success"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('help.usage')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('treatment-logs', {
    attrs: {
      "relationship-id": _vm.relationshipId
    }
  })], 1), _vm._v(" "), _c('v-tab-item', [_c('historical-usage', {
    attrs: {
      "client-id": _vm.clientId,
      "relationship-id": _vm.relationshipId
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-auto elevation-20 pb-0 mb-0",
    staticStyle: {
      "min-height": "800px"
    }
  }, [(_vm.navDrawerIsVisible) ? _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "width": 450
    },
    model: {
      value: (_vm.showNavDrawer),
      callback: function($$v) {
        _vm.showNavDrawer = $$v
      },
      expression: "showNavDrawer"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    staticClass: "header-toolbar",
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('home-detail', {
    attrs: {
      "homepage": _vm.schedule,
      "appointment": _vm.appointment,
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.showNavDrawer = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": "3"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        left: function () {
          _vm.$emit('next')
        },
        right: function () {
          _vm.$emit('previous')
        }
      }),
      expression: "{left: () => { $emit('next') }, right: () => { $emit('previous') }}"
    }],
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [(!_vm.showDatepicker) ? _c('v-img', {
    attrs: {
      "src": _vm.backgroundImg,
      "height": "180px",
      "gradient": "to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
    }
  }, [_c('v-layout', [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "fab": "",
      "small": "",
      "absolute": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDatepicker = true
      }
    }
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('h3', {
    staticClass: "title font-weight-light mt-3 ml-3 grow"
  }, [_vm._v("\n            " + _vm._s(_vm.greeting) + " " + _vm._s(this.me.first_name) + "\n          ")])]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('strong', {
    staticClass: "display-4 font-weight-regular mr-4 ml-5",
    on: {
      "click": function($event) {
        _vm.showDatepicker = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.date, 'D')) + "\n        ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "left": "0px",
      "top": "80px"
    },
    attrs: {
      "icon": "",
      "absolute": "",
      "left": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('previous:week')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "top": "80px"
    },
    attrs: {
      "icon": "",
      "absolute": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next:week')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("chevron_right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "headline font-weight-light"
  }, [_vm._v("\n            " + _vm._s(_vm.dateformat(_vm.date, 'ddd')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase font-weight-light"
  }, [_vm._v(_vm._s(_vm.dateformat(_vm.date, 'MMMM YYYY')))]), _vm._v(" "), _c('div', [_vm._v(" ")])], 1)], 1)], 1) : _c('v-img', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "fab": "",
      "small": "",
      "absolute": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDatepicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0 pt-4 mt-4",
    attrs: {
      "dark": "",
      "flat": "",
      "full-width": "",
      "no-title": ""
    },
    model: {
      value: (_vm.localDate),
      callback: function($$v) {
        _vm.localDate = $$v
      },
      expression: "localDate"
    }
  }), _vm._v(" "), (!_vm.isToday) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "outline": ""
    },
    on: {
      "click": _vm.settoday
    }
  }, [_vm._v("Today")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/calendar",
      "block": "",
      "small": "",
      "outlined": "",
      "outline": ""
    }
  }, [_vm._v("Go to calendar")])], 1)], 1), _vm._v(" "), _c('v-slider', {
    staticClass: "mx-0 px-3 mt-0 grey lighten-5",
    attrs: {
      "ticks": "",
      "max": 6,
      "tick-labels": _vm.dow
    },
    on: {
      "change": _vm.dowChanged
    },
    model: {
      value: (_vm.debouncedDay),
      callback: function($$v) {
        _vm.debouncedDay = $$v
      },
      expression: "debouncedDay"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        left: function () {
          _vm.$emit('next')
        },
        right: function () {
          _vm.$emit('previous')
        }
      }),
      expression: "{ left: () => { $emit('next') }, right: () => { $emit('previous') } }"
    }],
    staticClass: "pa-0"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.firstload && _vm.loading) ? _c('v-card-text', {
    staticClass: "text-xs-center my-5"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2",
      "size": "70"
    }
  })], 1) : _c('v-timeline', {
    staticClass: "ml-0",
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, [_c('v-timeline-item', {
    staticClass: "mt-3 pr-2"
  }, [_vm._v("\n          " + _vm._s(_vm.welcomeNote) + "\n        ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pr-1 my-0 pl-5 bold--text grey lighten-4"
  }, [_vm._v("\n          Schedule\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": _vm.newAppointmentClicked
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")]), _vm._v(" New")], 1)], 1), _vm._v(" "), _vm._l((_vm.appointments), function(appt) {
    return _c('v-timeline-item', {
      key: appt.id,
      class: _vm.getActiveColor(appt),
      attrs: {
        "small": "",
        "color": _vm.getColor(appt)
      }
    }, [_c('template', {
      slot: "icon"
    }, [_c('v-avatar', {
      staticClass: "pl-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.iconClicked(appt)
        }
      }
    })], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "pt-3": ""
      },
      on: {
        "click": function($event) {
          return _vm.itemClicked(appt)
        }
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.dateformat(appt.start_time, 'HH:mm')))]), _vm._v(" "), _c('div', [_c('small', [_vm._v("- " + _vm._s(_vm.dateformat(appt.end_time, 'HH:mm')))])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs9": ""
      }
    }, [_c('strong', [_vm._v(_vm._s(appt.title || appt.full_name))]), _vm._v(" "), (appt.product_name) ? _c('div', {
      staticClass: "caption"
    }, [_vm._v("\n                " + _vm._s(appt.product_name) + "\n                "), (appt.address_name) ? _c('span', [_vm._v("\n                  @ " + _vm._s(appt.address_name) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (appt.tags && appt.tags.length > 0) ? _vm._l((appt.tags), function(tag) {
      return _c('v-chip', {
        key: tag,
        staticClass: "v-chip--x-small",
        attrs: {
          "label": "",
          "outline": ""
        }
      }, [_vm._v("\n                  " + _vm._s(tag) + "\n                ")])
    }) : _vm._e()], 2), _vm._v(" "), (_vm.withAction) ? _c('v-flex', {
      staticClass: "text-xs-right"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1) : _vm._e()], 1)], 2)
  }), _vm._v(" "), (_vm.appointments.length < 1) ? _c('v-timeline-item', {
    attrs: {
      "fill-dot": "",
      "color": "white"
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-avatar', {
    staticClass: "pl-2",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.iconClicked(_vm.appointment)
      }
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v("No appointments scheduled yet.")])])], 2) : _vm._e(), _vm._v(" "), _c('v-timeline-item', {
    attrs: {
      "fill-dot": "",
      "color": "white"
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-avatar', {
    staticClass: "pl-2"
  }, [_vm._v(" 🎉")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('messages.endofday')))])])], 2)], 2)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "mb-0",
    attrs: {
      "absolute": "",
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("previous")
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showDatepicker = !_vm.showDatepicker
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.dateformat(_vm.date)) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("next")
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), (_vm.selectedAppointment) ? _c('appointment-bottom-sheet', {
    attrs: {
      "appointment": _vm.selectedAppointment
    },
    model: {
      value: (_vm.showBottomSheet),
      callback: function($$v) {
        _vm.showBottomSheet = $$v
      },
      expression: "showBottomSheet"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.cols), function(col) {
    return _c('v-flex', {
      key: col.value,
      class: _vm.classWidth,
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-toolbar', {
      attrs: {
        "dense": "",
        "flat": "",
        "dark": ""
      }
    }, [_c('v-btn', {
      staticClass: "visible-xs-only",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleCol(col)
        }
      }
    }, [(_vm.visible[col.value]) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("expand_less")]) : _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("expand_more")])], 1), _vm._v(" "), _c('v-badge', {
      attrs: {
        "right": "",
        "color": "cyan"
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(_vm.getItems(col.value).length) + " ")]), _vm._v(" "), _c('h3', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(col.text))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withSearch) ? _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.showSearch = !_vm.showSearch
        }
      }
    }, [_c('v-icon', [_vm._v("search")])], 1) : _vm._e(), _vm._v(" "), (col.summary(_vm.getItems(col.value))) ? _c('span', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(col.summary(_vm.getItems(col.value))))]) : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('v-text-field', {
      attrs: {
        "slot": "extension",
        "transition": "slide-y-transition"
      },
      slot: "extension"
    }) : _vm._e()], 1), _vm._v(" "), (_vm.visible[col.value]) ? _c('div', [_vm._t("list", function() {
      return [_c('v-list', {
        attrs: {
          "dense": ""
        }
      }, _vm._l((_vm.getItems(col.value)), function(item) {
        return _c('v-list-tile', {
          key: item.id
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
      }), 1)]
    }, {
      "items": _vm.getItems(col.value),
      "col": col
    })], 2) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "extended": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.servicesRequest.loading
    },
    on: {
      "click": _vm.reload
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "mr-2",
    attrs: {
      "id": "space-title"
    }
  }, [_vm._v("Spaces")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.newspacedialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" New space\n    ")], 1), _vm._v(" "), _c('template', {
    slot: "extension"
  }, _vm._l((_vm.services), function(service) {
    return _c('v-btn', {
      key: service.id,
      staticClass: "mr-0",
      attrs: {
        "small": "",
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.$vuetify.goTo("#space-" + service.id)
        }
      }
    }, [_vm._v(_vm._s(service.title))])
  }), 1)], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.newspacedialog),
      callback: function($$v) {
        _vm.newspacedialog = $$v
      },
      expression: "newspacedialog"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.servicesNewRequest
    },
    on: {
      "ok": _vm.newSpaceCreated
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Create a new space\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.newspacedialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Give this space a name"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.newService.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.spacetitle),
      callback: function($$v) {
        _vm.spacetitle = $$v
      },
      expression: "spacetitle"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.newspacedialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.servicesNewRequest.loading
    },
    on: {
      "click": _vm.newService
    }
  }, [_vm._v("\n          Create\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.servicesRequest,
      "message200": false
    },
    on: {
      "ok": function($event) {
        _vm.newspaceloading = false
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.services), function(service, index) {
    return _c('v-flex', {
      key: service.id,
      attrs: {
        "xs12": "",
        "xl6": ""
      }
    }, [_c('space-settings', {
      key: service.id,
      staticClass: "mb-5",
      attrs: {
        "initially-expanded": _vm.services.length === 1,
        "id": ("service-" + (service.id))
      },
      on: {
        "reload": _vm.reload
      },
      model: {
        value: (_vm.services[index]),
        callback: function($$v) {
          _vm.$set(_vm.services, index, $$v)
        },
        expression: "services[index]"
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-fab-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dirty),
      expression: "dirty"
    }],
    attrs: {
      "loading": _vm.loading,
      "fab": "",
      "bottom": "",
      "left": "",
      "fixed": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("save", _vm.invoice)
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs2": "",
      "order-sm1": ""
    }
  }, [(_vm.practitioner.logo_picture) ? _c('img', {
    staticClass: "mt-4 hidden-xs-only",
    staticStyle: {
      "max-height": "200px",
      "max-width": "400px"
    },
    attrs: {
      "src": _vm.practitioner.logo_picture
    }
  }) : _c('v-alert', {
    attrs: {
      "value": true,
      "type": "info"
    }
  }, [_vm._v("\n          Looks like you haven't updated a logo.\n          "), (_vm.spaceSettings) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": "",
      "href": _vm.spaceSettings,
      "disabled": !_vm.rolesIsOwnerOfSpace(_vm.spaceId),
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list', [(_vm.practitioner.practice_name || _vm.practitioner.practice_number) ? _c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Business details:")]) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [(_vm.practitioner.practice_name) ? _c('v-list-tile-title', [_c('strong', [(_vm.practitioner.practice_number) ? _c('span', [_vm._v("Practice")]) : _c('span', [_vm._v("Business")]), _vm._v("\n                  name:\n                ")]), _vm._v("\n                " + _vm._s(_vm.practitioner.practice_name) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.practitioner.practice_number) ? _c('v-list-tile-sub-title', [_c('strong', [_vm._v("Practice number:")]), _vm._v("\n                " + _vm._s(_vm.practitioner.practice_number) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.spaceSettings) ? _c('v-btn', {
    attrs: {
      "href": _vm.spaceSettings,
      "disabled": !_vm.rolesIsOwnerOfSpace(_vm.spaceId),
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs1": "",
      "order-sm2": ""
    }
  }, [_c('date-picker-dialog', {
    attrs: {
      "close-on-change": "",
      "label": "Invoice date"
    },
    model: {
      value: (_vm.invoice.date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "date", $$v)
      },
      expression: "invoice.date"
    }
  }), _vm._v(" "), _c('date-picker-dialog', {
    attrs: {
      "close-on-change": "",
      "label": "Due date"
    },
    model: {
      value: (_vm.invoice.due_date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "due_date", $$v)
      },
      expression: "invoice.due_date"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs3": "",
      "order-sm3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Invoiced by:")]), _vm._v(" "), _c('v-textarea', {
    staticClass: "mb-0",
    attrs: {
      "box": "",
      "auto-grow": "",
      "persistent-hint": true,
      "hint": "Editing this value will only change the details for this invoice. To update the billing address for new invoices, click \"Edit billing address\""
    },
    model: {
      value: (_vm.invoice.billing_address),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "billing_address", $$v)
      },
      expression: "invoice.billing_address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs4": "",
      "order-sm4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Customer details:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "auto-grow": ""
    },
    model: {
      value: (_vm.invoice.invoicee_details),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "invoicee_details", $$v)
      },
      expression: "invoice.invoicee_details"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Include medical aid details"
    },
    model: {
      value: (_vm.invoice.integrate_medical_aid),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "integrate_medical_aid", $$v)
      },
      expression: "invoice.integrate_medical_aid"
    }
  }), _vm._v(" "), (_vm.invoice.integrate_medical_aid) ? _c('v-textarea', {
    attrs: {
      "box": "",
      "label": "Medical aid details:"
    },
    model: {
      value: (_vm.invoice.medicalaid_details),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "medicalaid_details", $$v)
      },
      expression: "invoice.medicalaid_details"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "mb-2 mt-4",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.enriching,
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.enrich(_vm.invoice.appointments)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Lineitems")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _vm._l((_vm.invoice.appointment_data), function(appointment) {
    return [_c('v-card', {
      key: appointment.id,
      staticClass: "mt-2"
    }, [_c('v-layout', {
      staticClass: "pa-1",
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      staticClass: "pt-3 pl-2 subheading",
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(appointment.invoice_title || appointment.title || appointment.full_name))]), _vm._v(" "), _c('v-flex', {
      staticClass: "pt-3",
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(_vm.dateformat(appointment.start_time)))]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right pt-3",
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, appointment.price)) + "\n        ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right",
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.openGlobalDialog(true, 'InvoiceDetails', {
            appointment: appointment,
            touch: Math.random()
          })
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: appointment.start_time
    }), _vm._v(" "), (appointment.codes && appointment.codes.length > 0) ? _c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('h3', {
      key: appointment.end_time,
      staticClass: "subheading ml-3 mt-2"
    }, [_vm._v("Sub-items")]), _vm._v(" "), _vm._l((appointment.codes), function(code) {
      return [_c('v-layout', {
        key: code.id,
        attrs: {
          "row": ""
        }
      }, [_c('v-divider', {
        key: code.process_code
      }), _vm._v(" "), _c('v-flex', {
        staticClass: "pt-3 pl-4",
        attrs: {
          "xs3": ""
        }
      }, [_vm._v(_vm._s(code.icd10))]), _vm._v(" "), _c('v-flex', {
        staticClass: "pt-3",
        attrs: {
          "xs3": ""
        }
      }, [_vm._v(_vm._s(code.process))]), _vm._v(" "), _c('v-flex', {
        staticClass: "text-xs-right pt-3",
        attrs: {
          "xs3": ""
        }
      }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, code.price)) + "\n            ")]), _vm._v(" "), _c('v-flex', {
        staticClass: "text-xs-right",
        attrs: {
          "xs3": ""
        }
      }, [_vm._v("\n               \n              ")])], 1), _vm._v(" "), _c('v-divider', {
        key: code.process
      })]
    })], 2) : _vm._e()], 1)]
  }), _vm._v(" "), _c('v-card-actions', [_c('v-icon', [_vm._v("info")]), _vm._v("\n        Appointments are saved on the invoice when created.\n        To update the appointments as they appear on this invoice\n        you will need to\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.enriching,
      "icon": _vm.$vuetify.breakpoint.xs
    },
    on: {
      "click": function($event) {
        return _vm.enrich(_vm.invoice.appointments)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Refresh Appointments")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Notes:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": ""
    },
    model: {
      value: (_vm.invoice.notes),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "notes", $$v)
      },
      expression: "invoice.notes"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Banking details:")]), _vm._v(" "), _c('v-textarea', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "box": ""
    },
    model: {
      value: (_vm.invoice.banking_details),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "banking_details", $$v)
      },
      expression: "invoice.banking_details"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "small": "",
      "flat": "",
      "to": "/settings/profile"
    }
  }, [_vm._v("Edit banking details")])], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.steps), function(step) {
    return _c('v-flex', {
      key: step.id,
      staticClass: "pa-0",
      staticStyle: {
        "border-left": "solid 1px #ccc"
      },
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_vm._t(("step-" + (step.id)))], 2)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.req
    }
  }), _vm._v(" "), (_vm.req.loading) ? _c('center', [_c('v-progress-circular', {
    staticClass: "my-4",
    attrs: {
      "color": "amber",
      "indeterminate": "",
      "size": "72"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.link && _vm.relationshipId) ? _c('share-card', {
    attrs: {
      "relationship-id": _vm.relationshipId,
      "links": _vm.links
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-group', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c('v-list-tile', {
          key: _vm.submission.id,
          staticClass: "no-pad-left pl-0"
        }, [(_vm.withActions) ? _c('v-menu', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                attrs: {
                  "slot": "activator",
                  "small": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.noop.apply(null, arguments)
                  }
                },
                slot: "activator"
              }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
            }
          }], null, false, 2269024046)
        }, [_vm._v(" "), _c('v-list', {
          staticClass: "pa-0",
          attrs: {
            "dense": "",
            "sub-header": ""
          }
        }, [_c('v-subheader', {
          staticClass: "overline py-0 py-0 pr-0"
        }, [_vm._v("Actions\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.actions), function(action) {
          return _c('v-list-tile', _vm._b({
            key: action.title,
            attrs: {
              "disabled": action.isDisabled && action.isDisabled(action)
            },
            on: {
              "click": function($event) {
                return action.onClick(action)
              }
            }
          }, 'v-list-tile', action.attrs, false), [_c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "textContent": _vm._s(action.title)
            }
          })], 1)], 1)
        })], 2)], 1) : _vm._e(), _vm._v(" "), _vm._t("list-tile-avatar"), _vm._v(" "), _c('v-list-tile-avatar', [(_vm.submission.new === "1") ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "success"
          }
        }, [_vm._v("New")]) : _vm._e(), _vm._v(" "), (_vm.submission.new === "0") ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "info"
          }
        }, [_vm._v("Read")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.submission && _vm.submission.linked_submission && _vm.submission.linked_submission.relationship) ? _c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.submission.linked_submission.relationship.first_name) + "\n            " + _vm._s(_vm.submission.linked_submission.relationship.last_name) + "\n        ")]) : (_vm.relationship && _vm.relationship.id) ? _c('v-list-tile-title', [(_vm.relationship && _vm.relationship.client) ? [_vm._v("\n              " + _vm._s(_vm.relationship.client.first_name) + "\n              " + _vm._s(_vm.relationship.client.last_name) + "\n            ")] : _vm._e()], 2) : _c('v-list-tile-title', [_vm._v("\n          Not assigned to client.\n          "), (_vm.getPotentialName(_vm.submission.answers)) ? _c('span', [_vm._v("\n            (maybe: " + _vm._s(_vm.getPotentialName(_vm.submission.answers)) + ")\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.submission.created_at) ? _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.submission.created_at)) + " at " + _vm._s((_vm.submission.created_at.split(" ")[1])) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.submission.created_date) ? _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.submission.created_date)) + " at " + _vm._s((_vm.submission.created_date.split("T")[1])) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _vm._t("list-tile-action")], 2)]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_vm._v(" "), (_vm.active) ? _c('form-submission-card', {
    attrs: {
      "submission-id": _vm.submission.id
    },
    model: {
      value: (_vm.submission),
      callback: function($$v) {
        _vm.submission = $$v
      },
      expression: "submission"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.req,
      "message200": false
    }
  }), _vm._v(" "), (_vm.withTitle) ? _c('v-card-title', {
    staticClass: "overline py-0"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.req.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("appointment.full_name")(_vm.appointment.title)))])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.financials) ? _c('v-card-text', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Appointment price")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.appointment_unit_price)))])]), _vm._v(" "), (_vm.financials.products_total_price && parseInt(_vm.financials.products_total_price) > 0) ? _c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Product sales")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.products_total_price)))])]) : _vm._e(), _vm._v(" "), (_vm.financials.appointment_tax && parseInt(_vm.financials.appointment_tax) > 0) ? _c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Tax")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.appointment_tax)))])]) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), (_vm.financials.appointment_dicount && parseInt(_vm.financials.appointment_dicount) > 0) ? _c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Discount")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.appointment_dicount)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Payments")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.payments_received)))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Due")]), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.finalPrice)))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-window', {
    model: {
      value: (_vm.screen),
      callback: function($$v) {
        _vm.screen = $$v
      },
      expression: "screen"
    }
  }, [_c('v-window-item', {
    attrs: {
      "touchless": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.load
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n          " + _vm._s(_vm.$t('list.title')) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = _vm.screens.NEW
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showSearch = !_vm.showSearch
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.load
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), (_vm.showSearch) ? _c('v-text-field', {
    staticClass: "mx-2",
    attrs: {
      "solo": "",
      "label": "search",
      "prepend-icon": "search",
      "clearable": ""
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getRequest.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "height": "3"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredTherapists), function(therapist) {
    return _c('v-list-tile', {
      key: therapist.id,
      on: {
        "click": function($event) {
          return _vm.selected(therapist)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                " + _vm._s(therapist.title) + "\n                " + _vm._s(therapist.initials) + "\n                " + _vm._s(therapist.first_name) + "\n                " + _vm._s(therapist.last_name) + "\n              ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                " + _vm._s(therapist.reference_number) + "\n              ")])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = _vm.screens.NEW
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n        " + _vm._s(_vm.$t('buttons.add')))], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('server-errors', {
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), _c('object-form', {
    ref: "createForm",
    attrs: {
      "fields": _vm.referrerFields,
      "field-configs": _vm.fieldConfigs,
      "errors": _vm.serverErrors
    },
    model: {
      value: (_vm.newReferrer),
      callback: function($$v) {
        _vm.newReferrer = $$v
      },
      expression: "newReferrer"
    }
  }, [_c('v-select', {
    attrs: {
      "slot": "title",
      "items": _vm.titles,
      "label": "Title"
    },
    slot: "title",
    model: {
      value: (_vm.newReferrer.title),
      callback: function($$v) {
        _vm.$set(_vm.newReferrer, "title", $$v)
      },
      expression: "newReferrer.title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "href": "http://isystems.hpcsa.co.za/iregister/",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("search")]), _vm._v(" " + _vm._s(_vm.$t('buttons.searchhpcsa')) + " "), _c('v-icon', {
    staticClass: "pl-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.$refs.createForm) ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = 0
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.back')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.$refs.createForm.valid,
      "color": "primary",
      "loading": _vm.saveRequest.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.save')))])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('cards.success.title')) + "\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "success",
      "large": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('cards.success.message')) + ": "), _c('br'), _vm._v("\n            " + _vm._s(_vm.newReferrer.first_name) + " " + _vm._s(_vm.newReferrer.last_name) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = _vm.screens.NEW
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.addanother')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.selected(_vm.newReferrer)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.select')) + " " + _vm._s(_vm.newReferrer.first_name) + "\n          ")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = _vm.screens.LIST
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v("\n            " + _vm._s(_vm.$t('buttons.backtostart')) + "\n          ")], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, _vm._l((_vm.steps), function(step) {
    return _c('v-window-item', {
      key: step.id
    }, [_vm._t(("step-" + (step.id)))], 2)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tile": "",
      "flat": _vm.flat,
      "height": "100%"
    }
  }, [(_vm.withTitle) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dark": ""
    }
  }, [_c('practitioner-list-item', {
    attrs: {
      "item": _vm.practitioner
    }
  }, [(_vm.request.loading) ? _c('v-list-tile-action', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "width": "2",
      "color": "amber"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_vm._t("actions")], 2)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.withDateBar && _vm.dateFormatted) ? _c('v-system-bar', {
    staticClass: "overline"
  }, [_c('v-spacer'), _vm._v("\n    " + _vm._s(_vm.dateFormatted) + "\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.withWeek) ? _c('v-toolbar', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-layout', [_c('v-btn', {
    staticClass: "pr-3",
    attrs: {
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.moveWeek(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _vm._l((_vm.week), function(day, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "week-day",
      class: {
        'blue lighten-4 week-active': (day.format('YYYY-MM-DD') === _vm.date)
      },
      on: {
        "click": function($event) {
          _vm.$emit("update:date", day.format("YYYY-MM-DD"))
        }
      }
    }, [_c('center', [_c('small', {
      staticClass: "overline"
    }, [_vm._v(_vm._s(day.format('ddd')))]), _c('br'), _vm._v("\n        " + _vm._s(day.format('D')) + "\n        ")])], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "pl-3",
    attrs: {
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.moveWeek(1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withAdd) ? _c('v-btn', {
    attrs: {
      "absolute": "",
      "fab": "",
      "top": "",
      "right": "",
      "small": ""
    },
    on: {
      "click": _vm.slotSelected
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.date && _vm.practitionerId) ? _c('day-view', {
    staticClass: "ml-1",
    attrs: {
      "flat": _vm.flat,
      "pixel-to-minute-ratio": _vm.settings.density || 1,
      "readOnly": _vm.isNotMe,
      "date": _vm.date,
      "with-fetch": false,
      "start-hour": _vm.settings.startHour,
      "end-hour": _vm.settings.endHour,
      "default-new-event-length": _vm.settings.defaultNewEventLength,
      "selected-appointment": _vm.selectedAppointment,
      "preview-event": _vm.previewEvent,
      "events": _vm.events
    },
    on: {
      "dayview:createevent": _vm.slotSelected,
      "dayview:multiselect": _vm.multiselect
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "three-line": "",
      "subheader": ""
    }
  }, [(_vm.title) ? _c('v-subheader', [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.fetch
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('span', {
    staticClass: "ml-3 overline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "placeholder": "search",
      "append-icon": "search"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.filteredTemplates), function(template) {
    return [_c('v-list-tile', {
      key: template.id,
      on: {
        "click": function($event) {
          return _vm.$emit("selected", template)
        }
      }
    }, [(_vm.showNew) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit("selected", template)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(template.ui_action_name || template.name) + "\n          "), (template.owner != "0") ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "primary",
        "x-small": "",
        "outline": "",
        "outlined": ""
      }
    }, [_vm._v("custom")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(template.description))]), _vm._v(" "), _c('v-list-tile-sub-title', [(template.is_active) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "success",
        "dark": ""
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]), _vm._v("\n            Active\n          ")], 1) : _vm._e(), _vm._v(" "), (template.shared) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": ""
      }
    }, [_vm._v("\n            Shared\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((template.categories), function(category) {
      return _c('v-chip', {
        key: category.id,
        staticClass: "v-chip--x-small"
      }, [_vm._v("\n            " + _vm._s(category.name) + "\n          ")])
    }), _vm._v(" "), (template.spaces && template.spaces.length > 0) ? _c('space-faces', {
      attrs: {
        "space-ids": template.spaces
      }
    }) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (template.id))
    })]
  }), _vm._v(" "), (_vm.showNew) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("new", null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n    Create a new template\n  ")], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4 pb-5",
    attrs: {
      "height": "100%"
    }
  }, [_c('a', {
    attrs: {
      "id": ("space-" + _vm.serviceId)
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.space
    },
    on: {
      "ok": function($event) {
        _vm.edittitle = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.backgroundDialog),
      callback: function($$v) {
        _vm.backgroundDialog = $$v
      },
      expression: "backgroundDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Choose a background picture\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.backgroundDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('image-search', {
    attrs: {
      "title": "Search for an image"
    },
    on: {
      "input": _vm.saveBackground
    },
    model: {
      value: (_vm.settings.background_picture),
      callback: function($$v) {
        _vm.$set(_vm.settings, "background_picture", $$v)
      },
      expression: "settings.background_picture"
    }
  })], 1)], 1), _vm._v(" "), (_vm.settings && _vm.settings.background_picture) ? _c('v-img', {
    attrs: {
      "height": "250",
      "src": _vm.settings.background_picture
    }
  }, [_c('v-card-title', {
    staticClass: "title pl-4 white--text",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.6)"
    }
  }, [(_vm.edittitle) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "loading": _vm.requests.space.loading,
      "append-icon": "save"
    },
    on: {
      "blur": _vm.saveTitle,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveTitle.apply(null, arguments)
      },
      "click:append": _vm.saveTitle
    },
    model: {
      value: (_vm.service.title),
      callback: function($$v) {
        _vm.$set(_vm.service, "title", $$v)
      },
      expression: "service.title"
    }
  }) : _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.edittitle = true
      }
    }
  }, [_vm._v(_vm._s(_vm.service.title) + "\n\n        "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.expand) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.expand = true;
        _vm.$vuetify.goTo(("#space-" + (_vm.service.id) + "-settings"))
      }
    }
  }, [_vm._v("Edit")]) : _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.expand = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "absolute": "",
      "bottom": "",
      "right": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.backgroundDialog = true
      }
    }
  }, [_vm._v("\n      Click to change background picture\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.logoDialog),
      callback: function($$v) {
        _vm.logoDialog = $$v
      },
      expression: "logoDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Update your Logo\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('uploader', {
    attrs: {
      "upload-path": _vm.logoUploadPath,
      "filename": "logo_picture"
    },
    on: {
      "uploadsuccess": function($event) {
        _vm.reload();
        _vm.logoDialog = false
      }
    },
    scopedSlots: _vm._u([{
      key: "gallery",
      fn: function(props) {
        return [_c('v-subheader', [_vm._v("Examples of how this may look in various places")]), _vm._v(" "), _vm._l((props.images), function(img, index) {
          return _c('v-layout', {
            key: index
          }, [_c('v-flex', [_c('v-subheader', [_vm._v("Avatar view")]), _vm._v(" "), _c('v-avatar', [_c('img', {
            attrs: {
              "src": img
            }
          })])], 1), _vm._v(" "), _c('v-flex', [_c('v-subheader', [_vm._v("Normal view")]), _vm._v(" "), _c('img', {
            attrs: {
              "src": img
            }
          })], 1)], 1)
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.settings) ? _c('v-card-text', {
    staticClass: "mb-3",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', [_c('strong', [_vm._v("Practice name")]), _vm._v(" " + _vm._s(_vm.settings.practice_name))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Practice number")]), _vm._v(" " + _vm._s(_vm.settings.practice_number))])]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "ml-4 elevation-10 align-end",
    staticStyle: {
      "margin-top": "-220px"
    },
    attrs: {
      "absolute": "",
      "width": "200",
      "height": "180"
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = true
      }
    }
  }, [(_vm.settings.logo_picture) ? [_c('v-img', {
    attrs: {
      "src": _vm.settings.logo_picture,
      "height": "150",
      "max-width": "200",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-footer', {
    staticClass: "caption justify-center ma-0",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.6)"
    },
    attrs: {
      "tile": "",
      "dark": ""
    }
  }, [_vm._v("\n          Click to edit logo\n        ")])] : _c('v-card-text', {
    staticClass: "pt-5 subheading"
  }, [_c('center', [_c('v-icon', [_vm._v("image")]), _c('br'), _vm._v("\n          Click to upload a logo\n        ")], 1)], 1)], 2), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.invoicesettingsDialog),
      callback: function($$v) {
        _vm.invoicesettingsDialog = $$v
      },
      expression: "invoicesettingsDialog"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.service.settings
    },
    on: {
      "ok": function($event) {
        _vm.reload();
        _vm.invoicesettingsDialog = false
      }
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Invoice settings\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.invoicesettingsDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('invoice-settings', {
    attrs: {
      "space-id": _vm.spaceId,
      "loading": _vm.requests.service.settings.loading
    },
    on: {
      "input": _vm.saveSettings,
      "close": function($event) {
        _vm.invoicesettingsDialog = false
      }
    },
    model: {
      value: (_vm.settings),
      callback: function($$v) {
        _vm.settings = $$v
      },
      expression: "settings"
    }
  })], 1)], 1), _vm._v(" "), _c('a', {
    attrs: {
      "id": ("space-" + (_vm.service.id) + "-settings")
    }
  }), _vm._v(" "), (_vm.settings) ? [_c('v-subheader', {
    staticClass: "overline mt-5"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "accent"
    }
  }, [_vm._v("post_add")]), _vm._v("\n      Invoice details\n      "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mx-3",
    attrs: {
      "id": ("service-" + (_vm.service.id) + "-invoice-settings")
    },
    on: {
      "click": function($event) {
        _vm.invoicesettingsDialog = true
      }
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.service.settings
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.invoicesettingfields), function(field) {
    return _c('v-flex', {
      key: field,
      staticClass: "mt-2",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('strong', {
      domProps: {
        "textContent": _vm._s(field.replace("_", " "))
      }
    }), _vm._v(" "), _c('pre', {
      staticClass: "caption",
      domProps: {
        "textContent": _vm._s(_vm.settings[field])
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "small": ""
    }
  }, [_vm._v("Edit")])], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "accent"
    }
  }, [_vm._v("paid")]), _vm._v("\n    Payments\n  ")], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mx-3"
  }, [_c('v-card-actions', [_c('img', {
    attrs: {
      "src": "https://dropbox-appointmentguru.s3.eu-central-1.amazonaws.com/yoco.jpeg",
      "height": "50"
    }
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.yocoIntegrationLink
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Accept payments with Yoco")]), _vm._v(" "), (_vm.yocoIntegrationLink) ? _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.yocoIntegrationLink))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.yocoIntegration && _vm.yocoIntegration.id) ? [_c('v-chip', {
    staticClass: "mr-3",
    attrs: {
      "color": "success",
      "dark": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check_circle")]), _vm._v("\n          Configured\n        ")], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.configureYocoDialog = true
      }
    }
  }, [_vm._v("Edit")])] : [_c('v-btn', {
    attrs: {
      "href": "https://referral.yoco.com/32Tzfb",
      "target": "_blank"
    }
  }, [_vm._v("\n          Open a free Yoco account\n          "), _c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.configureYocoDialog = true
      }
    }
  }, [_vm._v("Configure")])]], 2), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.configureYocoDialog),
      callback: function($$v) {
        _vm.configureYocoDialog = $$v
      },
      expression: "configureYocoDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n          Configure Yoco\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.configureYocoDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.configureYocoDialog) ? _c('yoco', {
    attrs: {
      "space-id": _vm.serviceId
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('reload')
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.settings && (_vm.yocoIntegration && _vm.yocoIntegration.id)) ? _c('v-footer', [(_vm.settings.payment_invoices_visible) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Show on invoices\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.settings.payment_appointments_visible) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Show on appointment page\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.settings.payment_appointments_prepayments) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Allow pre-payments\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.settings.payment_appointments_only_if_invoiceable) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Only show if appointment marked as invoiceable\n      ")], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-2"
  }, [(!_vm.expand) ? [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.expand = true
      }
    }
  }, [_vm._v("More details\n        "), _c('v-icon', [_vm._v("expand_more")])], 1), _vm._v(" "), (_vm.service && _vm.service.addresses) ? _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "outline": ""
    }
  }, [_vm._v(_vm._s(_vm.service.addresses.length) + " locations")]) : _vm._e(), _vm._v(" "), (_vm.service && _vm.service.products) ? _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "outline": ""
    }
  }, [_vm._v(_vm._s(_vm.service.products.length) + " appointment types")]) : _vm._e()] : [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.expand = false
      }
    }
  }, [_vm._v("Hide details\n        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)]], 2), _vm._v(" "), (_vm.expand) ? [_c('v-card-text', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "accent"
    }
  }, [_vm._v("location_on")]), _vm._v("\n        Locations\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mr-0",
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateLocation = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("\n          New\n        ")], 1)], 1), _vm._v(" "), (_vm.service.addresses && _vm.service.addresses.length === 0) ? _c('p', {
    staticClass: "error--text"
  }, [_vm._v("\n        There are no locations for this space.\n        "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateLocation = true
      }
    }
  }, [_vm._v("Create a location now")]), _vm._v(" or\n        "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = true
      }
    }
  }, [_vm._v("archive the space")]), _vm._v(" if you are no longer using it\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showCreateLocation),
      callback: function($$v) {
        _vm.showCreateLocation = $$v
      },
      expression: "showCreateLocation"
    }
  }, [_c('location-create', {
    attrs: {
      "with-close": "",
      "space-id": _vm.service.id,
      "touch": _vm.showCreateLocation
    },
    on: {
      "save": _vm.saveAddress,
      "created": _vm.reload,
      "close": function($event) {
        _vm.showCreateLocation = false
      }
    }
  })], 1), _vm._v(" "), (_vm.globalDataLoading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": "2"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "elevation-1"
  }, _vm._l((_vm.service.addresses), function(address, index) {
    return _c('v-expansion-panel-content', {
      key: ("loc-s-" + (_vm.service.id) + "-" + index),
      nativeOn: {
        "click": function($event) {
          _vm.activeIndex = index
        }
      }
    }, [_c('v-list', {
      staticClass: "pa-0",
      attrs: {
        "slot": "header",
        "dense": ""
      },
      slot: "header"
    }, [(address.name) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": "",
        "label": ""
      }
    }, [_vm._v(_vm._s(address.id))]), _vm._v("\n                  " + _vm._s(address.name) + "\n                  "), (_vm.service.owner_id === _vm.me.id) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "primary",
        "dark": "",
        "tile": ""
      }
    }, [_vm._v("Owner")]) : _vm._e(), _vm._v(" "), (_vm.service.private) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "success",
        "dark": "",
        "tile": ""
      }
    }, [_vm._v("Private")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "textContent": _vm._s(address.address)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "flat": "",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.showLocationDiaog(_vm.service, address, "assign")
              }
            }
          }, 'v-btn', attrs, false), on), [_vm._v("\n                      Assign")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Assign appointment types to this location")])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "flat": "",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.showLocationDiaog(_vm.service, address, "move")
              }
            }
          }, 'v-btn', attrs, false), on), [_vm._v("Move\n                    ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Move this location to a different space")])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("edit")])], 1)], 1)], 1) : _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.locationComponent = "LocationEdit"
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("warning")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Please provide a name")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Click to edit")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "text": ""
      }
    }, [_vm._v("Edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-2",
      attrs: {
        "md6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "100%"
      }
    }, [_c(_vm.locationComponent, {
      tag: "component",
      attrs: {
        "location": address
      },
      on: {
        "close": function($event) {
          _vm.locationComponent = "LocationView"
        },
        "save": _vm.saveAddress,
        "saved": _vm.reload,
        "edit": function($event) {
          _vm.locationComponent = "LocationEdit"
        }
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-2",
      attrs: {
        "md6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "100%"
      }
    }, [_c('v-card-title', [_c('v-subheader', {
      staticClass: "overline"
    }, [_vm._v("Operating hours")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-expansion-panel', {
      staticClass: "elevation-0",
      attrs: {
        "value": 0
      }
    }, [_vm._l((address.operation_hours_data), function(hours, index) {
      return [(_vm.getPractitionerById(hours.practitioner_id)) ? _c('v-expansion-panel-content', {
        key: hours.id,
        scopedSlots: _vm._u([{
          key: "header",
          fn: function() {
            return [(_vm.getPractitionerById(hours.practitioner_id)) ? _c('div', {
              staticClass: "subheading"
            }, [_vm._v(_vm._s(_vm.getPractitionerById(hours.practitioner_id).full_name))]) : _vm._e()]
          },
          proxy: true
        }], null, true)
      }, [_vm._v(" "), _c('v-card', [_c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('operating-hours-view', {
        attrs: {
          "lazy": "",
          "hours": hours
        },
        model: {
          value: (address.operation_hours_data[index]),
          callback: function($$v) {
            _vm.$set(address.operation_hours_data, index, $$v)
          },
          expression: "address.operation_hours_data[index]"
        }
      })], 1)], 1)], 1) : _vm._e()]
    })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
      staticClass: "grey lighten-2"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.showLocationDiaog(_vm.service, address, "delete")
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "accent"
    }
  }, [_vm._v("star")]), _vm._v("\n        Appointment Types\n      ")], 1), _vm._v(" "), _c('product-edit', {
    on: {
      "deleted": _vm.reload,
      "saved": _vm.reload,
      "added": _vm.reload
    },
    model: {
      value: (_vm.service),
      callback: function($$v) {
        _vm.service = $$v
      },
      expression: "service"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "warning"
    }
  }, [_vm._v("warning")]), _vm._v("\n        Danger Zone")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("archive")]), _vm._v(" Archive\n      ")], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showDeleteConfirmation),
      callback: function($$v) {
        _vm.showDeleteConfirmation = $$v
      },
      expression: "showDeleteConfirmation"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.servicesArchiveRequest
    },
    on: {
      "ok": _vm.spaceArchived
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n            Archive " + _vm._s(_vm.service.title) + "?\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("What happens when I click archive")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("If this space has no appointments, it will be permanently deleted.")]), _vm._v(" "), _c('p', [_vm._v("\n            If the space has appiontments, it will be archived."), _c('br'), _vm._v("\n            An archived space is hidden from sight, but can be recovered should need be."), _c('br'), _vm._v("\n            All existing appointments in this space will remain in this space."), _c('br')])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error",
      "loading": _vm.servicesArchiveRequest.loading
    },
    on: {
      "click": _vm.archiveSpace
    }
  }, [_vm._v("\n              Archive " + _vm._s(_vm.service.title) + "\n            ")])], 1)], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-footer', {
    staticClass: "py-0 grey lighten-2 caption",
    attrs: {
      "absolute": "",
      "bottom": ""
    }
  }, [_c('v-chip', {
    staticClass: "v-chip--x-small my-0",
    attrs: {
      "label": "",
      "outline": ""
    }
  }, [_vm._v(" #" + _vm._s(_vm.service.id))])], 1), _vm._v(" "), (_vm.selectedAddress) ? _c('v-dialog', {
    model: {
      value: (_vm.showDeleteLocation),
      callback: function($$v) {
        _vm.showDeleteLocation = $$v
      },
      expression: "showDeleteLocation"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.address,
      "message204": "Address has been deleted. Reloading"
    },
    on: {
      "ok": function($event) {
        _vm.reload();
        _vm.showDeleteLocation = false
      }
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Are you sure you want to delete " + _vm._s(_vm.selectedAddress.name) + "\n      ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteLocation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.address.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.deleteAddress(_vm.selectedAddress.id)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSpace) ? _c('v-dialog', {
    model: {
      value: (_vm.showAssignLocation),
      callback: function($$v) {
        _vm.showAssignLocation = $$v
      },
      expression: "showAssignLocation"
    }
  }, [_c('location-assign', {
    attrs: {
      "with-close": "",
      "space": _vm.selectedSpace,
      "location": _vm.selectedAddress
    },
    on: {
      "saved": _vm.reload,
      "close": function($event) {
        _vm.showAssignLocation = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSpace) ? _c('v-dialog', {
    model: {
      value: (_vm.showMoveLocation),
      callback: function($$v) {
        _vm.showMoveLocation = $$v
      },
      expression: "showMoveLocation"
    }
  }, [_c('move-location', {
    attrs: {
      "with-close": "",
      "from-space": _vm.selectedSpace
    },
    on: {
      "close": function($event) {
        _vm.showMoveLocation = false
      },
      "setproducts": _vm.reload
    },
    model: {
      value: (_vm.selectedAddress),
      callback: function($$v) {
        _vm.selectedAddress = $$v
      },
      expression: "selectedAddress"
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "my-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-0 overline grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.window === 0,
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v("\n      back")], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "dark": ""
    }
  }, [(_vm.selectedLocation) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.selectedLocation.name) ? _c('v-list-tile-title', [_vm._v("\n        Moving: " + _vm._s(_vm.selectedLocation.name) + ":\n        "), (_vm.fromSpace) ? _c('span', [_vm._v(" from " + _vm._s(_vm.fromSpace.title))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_forward")]), _vm._v(" "), (_vm.toSpace) ? _c('span', [_vm._v(" to " + _vm._s(_vm.toSpace.title))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedLocation.address) ? _c('v-list-tile-sub-title', [_vm._v("\n        " + _vm._s(_vm.selectedLocation.address) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.window === 0) ? _c('v-btn', {
    staticClass: "px-2",
    attrs: {
      "disabled": !_vm.toSpace || !_vm.toSpace.id,
      "loading": _vm.requests.setproducts.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.move
    }
  }, [_vm._v("\n          Move location\n      ")]) : _vm._e(), _vm._v(" "), (_vm.window === 1) ? _c('v-btn', {
    staticClass: "px-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.setProducts
    }
  }, [_vm._v("\n        Set appointment types\n      ")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-window', {
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n          Which space would you like to move this location to\n        ")]), _vm._v(" "), _c('v-card-text', [_c('space-picker', {
    attrs: {
      "is-owner": "",
      "multiple": false,
      "attrs": _vm.attrs,
      "label": "Choose a space"
    },
    model: {
      value: (_vm.selectedSpace),
      callback: function($$v) {
        _vm.selectedSpace = $$v
      },
      expression: "selectedSpace"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.toSpace && _vm.selectedLocation) ? _c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n          Set the appointment types for " + _vm._s(_vm.selectedLocation.name) + " at " + _vm._s(_vm.toSpace.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('v-layout', [(_vm.fromSpace && _vm.toSpace) ? _c('v-flex', {
    staticClass: "px-4",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('h3', {
    staticClass: "subheading pl-0"
  }, [_vm._v("\n              1. Which appointment types would you like to\n              " + _vm._s(_vm.action) + ":"), _c('br'), _vm._v("\n              from: "), _c('strong', [_vm._v(_vm._s(_vm.fromSpace.title))]), _vm._v("\n              to: "), _c('strong', [_vm._v(_vm._s(_vm.toSpace.title))])]), _vm._v(" "), _c('v-alert', {
    staticClass: "pa-1 my-2",
    attrs: {
      "value": true,
      "type": "info",
      "dismissible": ""
    }
  }, [_vm._v("\n              This will " + _vm._s(_vm.action) + " the selected appointment types from this space to the new space\n            ")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.action),
      callback: function($$v) {
        _vm.action = $$v
      },
      expression: "action"
    }
  }, [_c('v-radio', {
    attrs: {
      "hide-details": "",
      "label": "Move",
      "value": "move"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "hide-details": "",
      "label": "Copy",
      "value": "copy"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.fromSpace.products), function(product) {
    return [_c('v-checkbox', {
      key: product.id,
      staticClass: "caption",
      attrs: {
        "hide-details": "",
        "value": product.id,
        "label": product.title
      },
      model: {
        value: (_vm.moveProducts),
        callback: function($$v) {
          _vm.moveProducts = $$v
        },
        expression: "moveProducts"
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (_vm.toSpace) ? _c('v-flex', {
    staticClass: "px-4",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('h3', {
    staticClass: "subheading pl-0"
  }, [_vm._v("\n              2. Which appointment types (available in " + _vm._s(_vm.toSpace.title) + ")"), _c('br'), _vm._v("\n              would you like to assign to this location\n            ")]), _vm._v(" "), _c('v-alert', {
    staticClass: "pa-1 my-2",
    attrs: {
      "dismissible": "",
      "tile": "",
      "dense": "",
      "type": "info",
      "value": true
    }
  }, [_vm._v("\n              This will make the selected appointment type available in this location\n            ")]), _vm._v(" "), _vm._l((_vm.getProducts(_vm.toSpace.products)), function(product) {
    return [_c('v-checkbox', {
      key: product.id,
      staticClass: "caption",
      attrs: {
        "hide-details": "",
        "value": product.id,
        "label": _vm.getLabel(product)
      },
      model: {
        value: (_vm.assignProducts),
        callback: function($$v) {
          _vm.assignProducts = $$v
        },
        expression: "assignProducts"
      }
    })]
  })], 2) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "py-0 pr-0",
          attrs: {
            "slot": "activator",
            "small": "",
            "outlined": "",
            "outline": ""
          },
          on: {
            "click": _vm.get
          },
          slot: "activator"
        }, on), [_vm._v("\n      🎉 Birthdays\n      "), _c('v-btn', {
          staticClass: "pa-0",
          attrs: {
            "small": "",
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    attrs: {
      "width": "350"
    }
  }, [_c('v-list', {
    staticClass: "pa-0 pb-3",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('titles.today')))]), _vm._v(" "), _vm._l((_vm.birthdaysToday), function(person) {
    return (person.patient) ? _c('v-list-tile', {
      key: ("today-" + (person.relationship_id)),
      attrs: {
        "to": ("/clients/r/" + (person.relationship_id))
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(person.patient.first_name) + " " + _vm._s(person.patient.last_name) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.getString(person.patient.date_of_birth)) + "\n          ")])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (!_vm.request.loading && _vm.birthdaysToday.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('nothing.today')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('titles.month')))]), _vm._v(" "), _vm._l((_vm.birthdays), function(person) {
    return (person.patient) ? _c('v-list-tile', {
      key: ("month-" + (person.relationship_id)),
      attrs: {
        "to": ("/clients/r/" + (person.relationship_id))
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(person.patient.first_name) + " " + _vm._s(person.patient.last_name) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.getString(person.patient.date_of_birth)) + "\n          ")])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (!_vm.request.loading && _vm.birthdays.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('nothing.thismonth')) + "\n          ")])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": false
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('wiz-layout', {
    attrs: {
      "steps": _vm.steps,
      "initial-step": _vm.step
    },
    on: {
      "close": _vm.exitWizard,
      "cancel": _vm.exitWizard
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      loading: _vm.loading
    }
  }, [(_vm.client && _vm.client.id) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._t("toolbar-icon", function() {
    return [(_vm.withPrevNext) ? _c('v-toolbar-side-icon', [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit("prev")
        }
      }
    }, [_c('v-icon', [_vm._v("arrow_left")])], 1)], 1) : _vm._e()]
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._t("header", function() {
    return [(_vm.withClientPreview && _vm.relationshipId) ? _c('v-menu', {
      attrs: {
        "close-on-content-click": false,
        "nudge-width": 200,
        "offset-x": ""
      },
      model: {
        value: (_vm.clientPreviewMenu),
        callback: function($$v) {
          _vm.clientPreviewMenu = $$v
        },
        expression: "clientPreviewMenu"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [(_vm.clientPreviewMenu) ? _c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v("visibility_off")]) : _c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('v-card', {
      attrs: {
        "min-width": 280
      }
    }, [_c('client-card', {
      attrs: {
        "relationship-id": _vm.relationshipId
      }
    })], 1)], 1) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.normalizedClient.first_name) + " " + _vm._s(_vm.normalizedClient.last_name) + ".\n      ")]
  }), _vm._v(" "), _vm._t("subheader")], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("toolbar-buttons"), _vm._v(" "), (_vm.withFilters) ? _c('filters', {
    attrs: {
      "statement": _vm.statement,
      "with-actions": true,
      "filter-from-date": _vm.filterFromDate,
      "filter-to-date": _vm.filterToDate,
      "filter-status-ids": _vm.filterStatusIds,
      "touch-show": _vm.filterTouch
    },
    on: {
      "filters:string": _vm.setFilterString,
      "filters:params": _vm.setFilters
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.withReload) ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("reload", this.filters)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1) : _vm._e(), _vm._v(" "), (_vm.withPrevNext) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("next")
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_right")])], 1) : _vm._e(), _vm._v(" "), (_vm.withFilters) ? _c('span', {
    staticClass: "py-0 my-0",
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [(_vm.filterString) ? _c('span', [_vm._v(_vm._s(_vm.filterString))]) : _vm._e(), _vm._v(" "), (!_vm.filterString && _vm.initialFilterText) ? _c('span', [_vm._v(_vm._s(_vm.initialFilterText))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.filterTouch++
      }
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("Clear")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "no-pad-left",
    on: {
      "click": function($event) {
        _vm.selectAll = !_vm.selectAll
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "grey lighten-4",
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    staticClass: "ml-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Select all")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('v-divider'), _vm._v(" "), (_vm.appointments && _vm.appointments.length > 0) ? _c('v-expansion-panel', {
    staticClass: "dense elevation-0",
    attrs: {
      "expand": ""
    },
    model: {
      value: (_vm.panelState),
      callback: function($$v) {
        _vm.panelState = $$v
      },
      expression: "panelState"
    }
  }, _vm._l((_vm.appointments), function(appointment, index) {
    return _c('v-expansion-panel-content', {
      key: index
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('v-layout', [_c('v-flex', {
      staticStyle: {
        "width": "70%"
      }
    }, [_c('v-list-tile', {
      staticClass: "no-pad-left pl-0"
    }, [_c('v-list-tile-action', {
      staticClass: "grey lighten-4",
      staticStyle: {
        "min-width": "30px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.noop.apply(null, arguments)
        }
      }
    }, [(_vm.withSelectable && appointment) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedAppointmentIds),
        expression: "selectedAppointmentIds"
      }],
      staticClass: "ml-2",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": appointment.id,
        "checked": Array.isArray(_vm.selectedAppointmentIds) ? _vm._i(_vm.selectedAppointmentIds, appointment.id) > -1 : (_vm.selectedAppointmentIds)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit("selected", index)
        },
        "change": function($event) {
          var $$a = _vm.selectedAppointmentIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = appointment.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedAppointmentIds = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedAppointmentIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedAppointmentIds = $$c
          }
        }
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.actions) ? _c('v-list-tile-action', [_c('v-menu', {
      staticClass: "pb-0",
      attrs: {
        "open-on-hover": "",
        "offset-y": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((_vm.actions), function(item) {
      return _c('v-list-tile', {
        key: item.id,
        attrs: {
          "disabled": item.disableIf && item.disableIf(appointment)
        },
        on: {
          "click": function($event) {
            return _vm.actionClicked(item, appointment)
          }
        }
      }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)
    }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
      staticClass: "mr-2",
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(appointment.title || appointment.full_name)), (!_vm.isCompact) ? _c('small', [_vm._v(". " + _vm._s(_vm.dateformat(appointment.start_time)))]) : _vm._e(), _vm._v(" "), (!_vm.isCompact) ? _c('v-chip', {
      staticClass: "v-chip--x-small pa-0 text-center block",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "x-small": "",
        "label": "",
        "dark": "",
        "outline": "",
        "color": _vm.formatStatus(appointment.status).theme
      }
    }, [_vm._v("\n                            " + _vm._s(appointment.status_formatted) + "\n                          ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isCompact) ? _c('v-list-tile-sub-title', {
      staticClass: "grey--text"
    }, [_vm._v("\n                          " + _vm._s(_vm.dateformat(appointment.start_time)) + "\n                          "), _c('v-chip', {
      staticClass: "v-chip--x-small pa-0 text-center block",
      attrs: {
        "x-small": "",
        "label": "",
        "dark": "",
        "outline": "",
        "color": _vm.formatStatus(appointment.status).theme
      }
    }, [_vm._v("\n                            " + _vm._s(appointment.status_formatted) + "\n                          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isCompact) ? _c('v-list-tile-sub-title', {
      staticClass: "grey--text"
    }, [_vm._v("\n                          " + _vm._s(_vm.$tc('codessummary', appointment.codes.length, {
      n: appointment.codes.length
    })) + ".\n                          " + _vm._s(_vm.$tc('productsummary', appointment.lineitems.length, {
      n: appointment.lineitems.length
    })) + ".\n                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (!_vm.isCompact) ? _c('v-spacer', {
      staticClass: "hidden-xs-only"
    }) : _vm._e(), _vm._v(" "), _c('v-btn', {
      staticClass: "hidden-xs",
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.launchInvoiceDetailsDialog(appointment, false)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("edit")])], 1), _vm._v(" "), (!_vm.isCompact) ? _c('v-flex', {
      staticClass: "text-xs-right hidden-xs-only"
    }, [_c('div', {
      staticClass: "v-list__tile__action-text"
    }, [_vm._v("Total")]), _vm._v("\n                    " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.final_price)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.isCompact) ? _c('v-flex', {
      staticClass: "text-xs-right mr-1 hidden-xs-only"
    }, [_c('div', {
      staticClass: "v-list__tile__action-text"
    }, [_vm._v("Payments")]), _vm._v("\n                    " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.payments_received)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.isCompact) ? _c('v-divider', {
      staticClass: "hidden-xs-only",
      attrs: {
        "vertical": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right mr-2",
      attrs: {
        "xs3": "",
        "sm1": ""
      }
    }, [_c('div', {
      staticClass: "v-list__tile__action-text"
    }, [_vm._v("Outstanding")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.final_due)))])])], 1)], 1), _vm._v(" "), _c('v-sheet', [_c('v-list', {
      attrs: {
        "dense": "",
        "subheader": ""
      }
    }, [_c('v-subheader', {
      staticClass: "overline"
    }, [_vm._v("\n                  Appointment Invoice details\n                  "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.launchInvoiceDetailsDialog(appointment, false)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(appointment.invoice_title || appointment.title) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      Title\n                    ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (appointment.invoice_description) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(appointment.invoice_description) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      Description\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (appointment.product_name) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(appointment.product_name) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      Appointment type\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), (appointment.product_name) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(appointment.status_formatted) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      Appointment status\n                    ")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (appointment.codes && appointment.codes.length > 0) ? _c('v-sheet', [_c('appointment-code-list', {
      attrs: {
        "appointment": appointment,
        "title": "Diagnosis codes"
      },
      on: {
        "code:deleted": _vm.refresh
      }
    })], 1) : _vm._e(), _vm._v(" "), (appointment.total_price !== appointment.financials.sub_total) ? _c('v-sheet', {
      staticClass: "gray lighten-5"
    }, [_c('v-divider'), _vm._v(" "), _c('v-list', [
      [_c('v-list-tile', [_c('v-list-tile-content', [(appointment.discount_amount > 0) ? _c('v-list-tile-sub-title', [_vm._v("\n                      Less\n                      " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.discount_amount)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (appointment.tax_amount > 0) ? _c('v-list-tile-sub-title', [_vm._v("\n                      Tax\n                      " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.tax_amount)) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [(appointment.tax_amount > 0) ? _c('v-list-tile-action-text', [_vm._v("After Tax")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.total_price)) + "\n                    "), _c('v-list-tile-action-text', [_vm._v("Total")])], 1)], 1)]
    ], 2)], 1) : _vm._e(), _vm._v(" "), (appointment.lineitems && appointment.lineitems.length > 0) ? _c('v-sheet', {
      staticClass: "mt-2"
    }, [_c('v-list', {
      attrs: {
        "dense": "",
        "subheader": ""
      }
    }, [_c('v-subheader', [_vm._v("\n                Other purchases")]), _vm._v(" "), _vm._l((appointment.lineitems), function(product) {
      return _c('v-list-tile', {
        key: product.id
      }, [_c('v-list-tile-action', {
        staticClass: "text-xs-center"
      }, [_c('v-avatar', [_vm._v(_vm._s(product.quantity))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                    " + _vm._s(product.description) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                    @ " + _vm._s(_vm.formatCurrency(product.currency, product.unit_price)) + " each\n                  ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(product.currency, (product.quantity * product.unit_price))) + "\n                  "), _c('v-list-tile-action-text', [_vm._v("\n                    Total\n                  ")])], 1)], 1)
    }), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title')], 1)], 1)], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (appointment.payments && appointment.payments.length > 0) ? _c('v-sheet', [_c('payment-list', {
      attrs: {
        "appointment": appointment,
        "title": "Payments",
        "payments": appointment.payments
      },
      on: {
        "payment:deleted": _vm.refresh
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
      staticClass: "mt-4"
    }), _vm._v(" "), _c('v-sheet', [_c('v-list', {
      staticClass: "grey lighten-4",
      attrs: {
        "dense": "",
        "subheader": ""
      }
    }, [_c('v-subheader', [_vm._v("Totals ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.subtotalList), function(item) {
      return [(appointment.financials[item.key] > 0) ? _c('v-list-tile', {
        key: item.key
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(item.text) + "\n                    ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n                    " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials[item.key])) + "\n                  ")])], 1) : _vm._e()]
    }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "headline"
    }, [_vm._v("\n                    Sub total\n                  ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "headline"
    }, [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.final_due)) + "\n                ")])], 1)], 2)], 1)], 1)
  }), 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "amber"
    }
  }, [_vm._v("warning")]), _vm._v("\n          No appointments found for\n          "), _c('strong', [_vm._v(_vm._s(_vm.clientFullname))]), _vm._v(" from\n          "), _c('strong', [_vm._v(_vm._s(_vm.dateformat(_vm.filterFromDate)) + "\n          "), (_vm.filterToDate) ? _c('span', [_vm._v(" to " + _vm._s(_vm.dateformat(_vm.filterToDate)))]) : _vm._e()])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.filterTouch++
      }
    }
  }, [_vm._v("Change date range")])], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), (_vm.statement && _vm.statement.meta) ? _c('v-list', {
    staticClass: "mx-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Grand total")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Total")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(_vm.formatCurrency(_vm.defaultCurrency, _vm.statement.meta.price_before_tax)))])], 1), _vm._v(" "), (_vm.statement.meta.tax > 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Tax")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(_vm.formatCurrency(_vm.defaultCurrency, _vm.statement.meta.tax)))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Payments received")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(_vm.formatCurrency(_vm.defaultCurrency, _vm.statement.meta.payments_received)))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "headline"
  }, [_vm._v("Total due")])], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.defaultCurrency, _vm.statement.meta.outstanding)))])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.statement && _vm.statement.range) ? _c('v-footer', {
    staticClass: "pa-3 mt-4"
  }, [_c('div', [_vm._v("\n      Your first appointment with " + _vm._s(_vm.normalizedClient.first_name) + "\n      was on " + _vm._s(_vm.dateformat(_vm.statement.range.first_appointment_ever)) + "\n      (" + _vm._s(_vm.firstAppointmentAgo) + ").\n    ")]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.dialogs.invoiceSuccess),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "invoiceSuccess", $$v)
      },
      expression: "dialogs.invoiceSuccess"
    }
  }, [(_vm.newInvoice) ? _c('invoice-success', {
    attrs: {
      "client": _vm.normalizedClient
    },
    on: {
      "done": function($event) {
        _vm.dialogs.invoiceSuccess = false
      }
    },
    model: {
      value: (_vm.newInvoice),
      callback: function($$v) {
        _vm.newInvoice = $$v
      },
      expression: "newInvoice"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('bulk-actions', {
    attrs: {
      "client": _vm.normalizedClient,
      "selected-appointments": _vm.selectedAppointments
    },
    on: {
      "invoice:created": _vm.setNewInvoice,
      "payment:created": _vm.paymentAdded,
      "codes:created": _vm.codesAdded,
      "deselect": function($event) {
        _vm.selectAll = false;
        _vm.toggleSelectAll()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('v-card', [_c('vuex-loader', {
    attrs: {
      "request-id": "saveReqId"
    }
  }), _vm._v(" "), _c('vuex-loader', {
    attrs: {
      "request-id": "reqId"
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "extended": ""
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.invoice.status))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "loading": _vm.invoiceSaveRequest.loading,
      "placeholder": "Invoice title"
    },
    model: {
      value: (_vm.invoice.title),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "title", $$v)
      },
      expression: "invoice.title"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.getInvoice
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('span', [_vm._v("Reload invoice data")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [(_vm.invoice.relationship_id) ? _c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.gotoRelationship(_vm.invoice.relationship_id)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "ml-2"
  }, [_vm._v("person")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Show client")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [(_vm.invoiceUrl) ? _c('v-btn', {
    attrs: {
      "slot": "activator",
      "href": _vm.invoiceUrl,
      "target": "_blank",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "ml-2"
  }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Open invoice preview in a new window")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchSendInvoiceDialog({
          invoice: _vm.invoice,
          client: _vm.client,
          withClose: false
        })
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "ml-2"
  }, [_vm._v("send")])], 1), _vm._v(" "), _c('span', [_vm._v("Send via email or sms")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_c('v-breadcrumbs', {
    staticClass: "ml-2",
    attrs: {
      "divider": "/"
    }
  }, [_c('v-breadcrumbs-item', {
    attrs: {
      "to": "/invoices/",
      "exact": ""
    }
  }, [_vm._v("Invoices")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("#" + _vm._s(_vm.invoice.id))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "small": "",
      "loading": _vm.invoiceSaveRequest.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          Save changes")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.invoice.compatibility === 1 && _vm.invoice && _vm.invoice.id) ? _c('v-tabs', {
    staticClass: "mb-4",
    attrs: {
      "dark": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.edit')))]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.statementTouch++
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tabs.statement')))]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.versionTouch++
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tabs.versions')))]), _vm._v(" "), _c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.communications')))]), _vm._v(" "), _c('v-tab-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "subheading hidden-sm-and-up grey lighten-4 hidden-xs-only"
  }, [_vm._v("\n        #" + _vm._s(_vm.invoice.id) + "\n      ")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading grey lighten-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-chip', {
    staticClass: "hidden-xs-only mt-2",
    attrs: {
      "large": "",
      "label": "",
      "outline": ""
    }
  }, [_vm._v("#" + _vm._s(_vm.invoice.id))])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.invoice.encrypt_password) ? _c('v-list', {
    staticClass: "pa-0 elevation-2",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', {
    staticClass: "mt-3",
    attrs: {
      "color": "amber"
    }
  }, [_vm._v("lock")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "overline"
  }, [_vm._v("\n                    Password protected\n                  ")]), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.invoice.encrypt_password)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.invoice.encrypt_password_hint)
    }
  })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showEncrypt = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1)], 1) : _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.showEncrypt = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("lock")]), _vm._v("\n              Add password\n            ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showEncrypt),
      callback: function($$v) {
        _vm.showEncrypt = $$v
      },
      expression: "showEncrypt"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-0 grey lighten-4"
  }, [(_vm.invoice.encrypt_password) ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "amber"
    }
  }, [_vm._v("lock")]) : _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "info"
    }
  }, [_vm._v("lock_open")]), _vm._v("\n            Manage password\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showEncrypt = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('encrypt-invoice', {
    staticClass: "mt-3",
    attrs: {
      "password": _vm.invoice.encrypt_password,
      "password-hint": _vm.invoice.encrypt_password_hint
    },
    on: {
      "update:password": function($event) {
        return _vm.$set(_vm.invoice, "encrypt_password", $event)
      },
      "update:passwordHint": function($event) {
        return _vm.$set(_vm.invoice, "encrypt_password_hint", $event)
      },
      "update:password-hint": function($event) {
        return _vm.$set(_vm.invoice, "encrypt_password_hint", $event)
      }
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showEncrypt = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.invoiceSaveRequest.loading
    },
    on: {
      "click": _vm.savePassword
    }
  }, [_vm._v("save")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('invoice-detail', {
    attrs: {
      "loading": _vm.invoiceSaveRequest.loading
    },
    on: {
      "save": _vm.save,
      "refresh": _vm.getInvoice
    },
    model: {
      value: (_vm.invoice),
      callback: function($$v) {
        _vm.invoice = $$v
      },
      expression: "invoice"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('tabs.statement')) + "\n        "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n        Here is a breakdown of the appointments in this invoice:\n      ")]), _vm._v(" "), _c('invoice-payments', {
    attrs: {
      "invoice": _vm.invoice,
      "transactions": _vm.invoice.transaction_set
    }
  }), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('help-popover', [_vm._v("\n          Every change you make to invoices is recorded and safely stored\n          in the cloud as a pdf. You can view all versions of this document below\n        ")]), _vm._v("\n        " + _vm._s(_vm.$t('tabs.versions')) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.versionTouch++
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.invoice && _vm.invoice.id) ? _c('invoice-versions', {
    attrs: {
      "touch": _vm.versionTouch,
      "invoice": _vm.invoice
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('tabs.communications')) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.invoiceCommsRequest.loading,
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.commsTouch++
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), (_vm.invoice && _vm.invoice.id) ? _c('invoice-communications', {
    attrs: {
      "touch": _vm.commsTouch,
      "req-id": _vm.commsreqid,
      "invoice-id": _vm.invoice.id
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event",
    class: _vm.eventClass,
    style: (_vm.eventStyle),
    attrs: {
      "id": 'event-' + _vm.event.id
    },
    on: {
      "click": [function($event) {
        if (!$event.metaKey) { return null; }
        $event.stopPropagation();
        return _vm.$emit("dayview:multiselect", _vm.event)
      }, function($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.$emit("click", _vm.event)
      }]
    }
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.event.loading),
      expression: "event.loading"
    }],
    attrs: {
      "indeterminate": true
    }
  }), _vm._v(" "), _c('div', [_c('v-tooltip', {
    attrs: {
      "right": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.tooltips.invoiceable = !_vm.tooltips.invoiceable
      }
    },
    model: {
      value: (_vm.tooltips.invoiceable),
      callback: function($$v) {
        _vm.$set(_vm.tooltips, "invoiceable", $$v)
      },
      expression: "tooltips.invoiceable"
    }
  }, [(_vm.event.invoiceable) ? _c('v-icon', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "slot": "activator",
      "color": "amber",
      "small": ""
    },
    slot: "activator"
  }, [_vm._v("check")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Ready for invoicing")])], 1), _vm._v(" "), (_vm.event.is_online) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          attrs: {
            "dark": "",
            "small": ""
          }
        }, on), [_vm._v("headset_mic")])]
      }
    }], null, false, 1133836527)
  }, [_vm._v(" "), _c('span', [_vm._v("This meeting is online")])]) : _vm._e(), _vm._v(" "), (_vm.event.is_recurring) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "font-size": "12px"
          },
          attrs: {
            "small": "",
            "dark": ""
          }
        }, on), [_vm._v("replay")])]
      }
    }], null, false, 1234321467)
  }, [_vm._v(" "), _c('span', [_vm._v("Recurring appointment")])]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.event.start) + " - " + _vm._s(_vm.event.end))]), _vm._v(".\n    "), (_vm.event.title) ? _c('span', [_vm._v(_vm._s(_vm.event.title))]) : _c('span', [_vm._v(_vm._s(_vm.event.full_name))]), _vm._v(" "), (_vm.infoIsTeamAccount && _vm.event.space_color && _vm.event.duration > 20) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-avatar', _vm._g({
          staticClass: "white--text",
          staticStyle: {
            "font-size": "8px"
          },
          attrs: {
            "color": _vm.event.space_color,
            "size": "12"
          }
        }, on), [(_vm.event.space_name) ? [_vm._v(_vm._s(_vm.event.space_name[0]))] : (_vm.event.service_name) ? [_vm._v(_vm._s(_vm.event.service_name[0]))] : _vm._e()], 2)]
      }
    }], null, false, 4033819650)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.event.space_name || _vm.event.service_name))])]) : _vm._e(), _vm._v(" "), (_vm.event.product_color && _vm.event.duration > 20) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-avatar', _vm._g({
          staticClass: "white--text",
          staticStyle: {
            "font-size": "8px"
          },
          attrs: {
            "color": _vm.event.product_color,
            "size": "12"
          }
        }, on), [(_vm.event.product_name) ? [_vm._v(_vm._s(_vm.event.product_name[0]))] : _vm._e()], 2)]
      }
    }], null, false, 4003189756)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.event.product_name))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.value) ? _c('v-img', {
    attrs: {
      "aspect-ratio": 16 / 9,
      "height": "150",
      "src": _vm.value
    }
  }, [_c('v-card-title', [_c('v-chip', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("Current image")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Update picture")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "Search background images",
      "append-icon": "search"
    },
    on: {
      "click:append": _vm.search,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.images), function(img) {
    return _c('v-flex', {
      key: img.id,
      staticClass: "text-xs-center",
      attrs: {
        "xs4": "",
        "md3": "",
        "lg2": ""
      }
    }, [_c('v-img', {
      staticClass: "image",
      attrs: {
        "aspect-ratio": 16 / 9,
        "src": img.urls.thumb
      },
      on: {
        "click": function($event) {
          return _vm.$emit('input', img.urls.regular)
        }
      }
    })], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [(_vm.exercise.adherence) ? _c('v-list-tile-avatar', [_c('adherence-progress', {
    model: {
      value: (_vm.exercise.adherence),
      callback: function($$v) {
        _vm.$set(_vm.exercise, "adherence", $$v)
      },
      expression: "exercise.adherence"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n      " + _vm._s(_vm.exercise.name) + "\n    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._l((_vm.fields), function(field) {
    return [(_vm.getAdherence(field) || _vm.getField(field)) ? _c('v-chip', {
      key: (field + "-" + (_vm.exercise.id)),
      staticClass: "v-chip--x-small pa-0 ml-1",
      attrs: {
        "outline": "",
        "outlined": "",
        "label": ""
      }
    }, [(_vm.exercise.adherence) ? _c('span', [_c('strong', [_vm._v(_vm._s(field) + ":")]), _vm._v(" " + _vm._s(_vm.getAdherence(field)) + "\n          ")]) : _c('span', [_c('strong', [_vm._v(_vm._s(field) + ":")]), _vm._v(" " + _vm._s(_vm.getField(field)) + "\n          ")])]) : _vm._e()]
  })], 2)], 1), _vm._v(" "), (_vm.exercise.pain_level) ? _c('v-list-tile-action', [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "width": "3",
      "size": "26",
      "value": _vm.exercise.pain_level * 10
    }
  }, [_vm._v("\n      " + _vm._s(_vm.exercise.pain_level) + "\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('request-status', {
    attrs: {
      "request": _vm.invoicesRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-menu', {
    staticClass: "visible-xs-only",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Views")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("setmain", "kanban")
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("view_week")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Progress")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": "/financials/"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("account_balance_wallet")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                Statement\n              ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("setmain", "overdueReport")
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("alarm_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Past due")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": "/transactions"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("paid")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Payments\n            ")])], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("\n          Bulk actions")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("setmain", "gallery")
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("done_all")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(_vm.$t('bulk.invoiceable')))])], 1)], 1)], 1)], 1), _vm._v(" "), [_c('v-btn', {
    attrs: {
      "loading": _vm.invoicesRequest.loading,
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("reload")
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("filter_list")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showFilters),
      callback: function($$v) {
        _vm.showFilters = $$v
      },
      expression: "showFilters"
    }
  }, [_vm._v(" "), _c('invoice-filter', {
    attrs: {
      "facets": _vm.facets,
      "params": _vm.params
    },
    on: {
      "update:params": function($event) {
        _vm.params = $event
      },
      "close": function($event) {
        _vm.showFilters = false
      }
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-messages": "",
      "dense": "",
      "label": _vm.dateTypeString
    },
    model: {
      value: (_vm.localUseDateDue),
      callback: function($$v) {
        _vm.localUseDateDue = $$v
      },
      expression: "localUseDateDue"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("ACTIVATE_RANGE_PICKER")
      }
    }
  }, [_c('v-icon', {
    staticClass: "hidden-xs-only",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-2 hidden-xs-only",
    attrs: {
      "vertical": ""
    }
  }), _vm._v("\n      " + _vm._s(_vm.$tc('title.summary', _vm.totalItems, _vm.summaryParams)) + "\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withSearch) ? _c('v-text-field', {
    staticClass: "hidden-xs-only mx-3",
    attrs: {
      "placeholder": "Search on invoice number, payment reference, or invoice title",
      "clearable": "",
      "prepend-icon": "search"
    },
    on: {
      "input": _vm.debouncedSearch,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.searchString = "";
        _vm.debouncedSearch()
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showServerSearch) ? [(_vm.serverSearch) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "outline": ""
    },
    on: {
      "click": _vm.searchOnServer
    }
  }, [_vm._v("Search")]) : _vm._e(), _vm._v(" "), (_vm.searchString && _vm.searchString.length > 2) ? _c('v-checkbox', {
    staticClass: "hidden-xs-only caption pt-4",
    attrs: {
      "flat": "",
      "hide-messages": "",
      "dense": "",
      "small": "",
      "label": "Search on server"
    },
    model: {
      value: (_vm.serverSearch),
      callback: function($$v) {
        _vm.serverSearch = $$v
      },
      expression: "serverSearch"
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "fab": _vm.$vuetify.breakpoint.xs,
      "small": _vm.$vuetify.breakpoint.xs,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.launchInvoiceDialog({
          touchClear: Math.random()
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("New Invoice")])], 1)], _vm._v(" "), _c('v-layout', {
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_vm._t("extra-nav"), _vm._v(" "), _c('span', {
    staticClass: "mt-2"
  }, [_vm._v("\n      " + _vm._s(_vm.totalItems) + " invoices found\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.page && _vm.totalPages > 1) ? [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.page <= 1
    },
    on: {
      "click": function($event) {
        _vm.$emit("update:page", (_vm.page - 1))
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('span', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.page) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.page === _vm.totalPages
    },
    on: {
      "click": function($event) {
        _vm.$emit("update:page", (_vm.page + 1))
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)] : _vm._e()], 2)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading pa-0"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.get.loading,
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0;
        _vm.get()
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-3",
    attrs: {
      "vertical": ""
    }
  }), _vm._v("\n    " + _vm._s(_vm.value.first_name) + " " + _vm._s(_vm.value.last_name) + " "), _c('v-chip', {
    staticClass: "ml-2",
    attrs: {
      "outline": "",
      "small": "",
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.value.id))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": "",
      "disabled": _vm.window === 0
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    }
  }, [_vm._v("Programs")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "color": "primary",
      "disabled": _vm.window === 1
    },
    on: {
      "click": function($event) {
        _vm.window = 1
      }
    }
  }, [_vm._v("Assign a new program")]), _vm._v(" "), (_vm.physitrackClientId && _vm.clientLink) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "text": "",
      "flat": "",
      "href": _vm.clientLink,
      "target": "_blank",
      "color": "primary"
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "md4": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "",
      "one-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "subheading"
  }, [_vm._v("Programs")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "outline": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 1
      }
    }
  }, [_vm._v("New"), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [(_vm.hasActivePrograms) ? _c('program-list', {
    attrs: {
      "programs": _vm.currentlyActivePrograms,
      "title": "Active program"
    },
    on: {
      "selected": _vm.setActiveProgram
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasActivePrograms && !_vm.requests.get.loading) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "value": true,
      "type": "info"
    }
  }, [_vm._v("\n                No currently active program\n                "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 1
      }
    }
  }, [_vm._v("Assign a program")])], 1) : _vm._e(), _vm._v(" "), (_vm.previousPrograms && _vm.previousPrograms.length > 0) ? _c('program-list', {
    attrs: {
      "programs": _vm.previousPrograms,
      "title": "Previous"
    },
    on: {
      "selected": _vm.setActiveProgram
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm7": "",
      "md8": ""
    }
  }, [(_vm.selectedProgram && _vm.selectedProgram.id) ? _c('program', {
    attrs: {
      "dateOfBirth": _vm.yearOfBirth,
      "physitrack-client-id": _vm.physitrackClientId
    },
    model: {
      value: (_vm.selectedProgram),
      callback: function($$v) {
        _vm.selectedProgram = $$v
      },
      expression: "selectedProgram"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [(_vm.physitrackClientId && _vm.relationshipId) ? _c('assign-program', {
    attrs: {
      "physitrack-client-id": _vm.physitrackClientId,
      "relationship-id": _vm.relationshipId,
      "has-active-program": _vm.hasActivePrograms,
      "touch": _vm.assignTouch
    },
    on: {
      "assigned": _vm.programAssigned,
      "close": function($event) {
        _vm.window = 0
      }
    },
    model: {
      value: (_vm.physitrackClient),
      callback: function($$v) {
        _vm.physitrackClient = $$v
      },
      expression: "physitrackClient"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('v-snackbar', {
    model: {
      value: (_vm.successsnacker),
      callback: function($$v) {
        _vm.successsnacker = $$v
      },
      expression: "successsnacker"
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    staticClass: "blue",
    attrs: {
      "absolute": "",
      "dark": "",
      "fab": "",
      "top": "",
      "right": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.editmode = "add";
        _vm.setBlankSelectedRow();
        _vm.addedit = true;
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._t("before-table", null, {
    "selected": _vm.selected
  }), _vm._v(" "), _c('v-data-table', {
    class: {
      'dense': _vm.dense
    },
    attrs: {
      "dense": "",
      "loading": _vm.loading,
      "headers": _vm.tableHeaders,
      "items": _vm.tableItems,
      "hide-actions": true,
      "disable-initial-sort": true
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "grey lighten-2"
        }, [(_vm.selectable) ? _c('th', {
          staticStyle: {
            "max-width": "5px"
          }
        }, [_c('v-checkbox', {
          staticClass: "mt-4",
          model: {
            value: (_vm.selectAll),
            callback: function($$v) {
              _vm.selectAll = $$v
            },
            expression: "selectAll"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.withExpand) ? _c('th', {
          staticStyle: {
            "max-width": "50px"
          }
        }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            staticClass: "overline",
            staticStyle: {
              "text-align": "left"
            }
          }, [_vm._t(("header-" + (header.value)), function() {
            return [_vm._v(_vm._s(header.text))]
          })], 2)
        }), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "50px"
          }
        }, [_vm._v(" ")])], 2), _vm._v(" "), _c('v-divider')]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            "archived": props.item.archived
          },
          on: {
            "click": function($event) {
              _vm.editmode = "edit";
              _vm.selectedRow = props.item;
              _vm.addedit = true
            }
          }
        }, [(_vm.withExpand) ? _c('td', {
          staticStyle: {
            "max-width": "50px"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "flat": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [(!props.expanded) ? _c('v-icon', [_vm._v("expand_more")]) : _c('v-icon', [_vm._v("expand_less")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectable) ? _c('td', [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.noop.apply(null, arguments)
            }
          }
        }, [_c('v-checkbox', {
          attrs: {
            "small": "",
            "value": props.item
          },
          model: {
            value: (_vm.selected),
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableHeaders), function(header) {
          return _c('td', {
            key: header.value
          }, [_vm._t(header.value, function() {
            return [(header.component === "vcheckbox") ? [(props.item[header.value]) ? _c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("check_box")]) : _c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("check_box_outline_blank")])] : _c('span', [_vm._v(_vm._s(props.item[header.value]))])]
          }, {
            "value": props.item[header.value],
            "item": props.item
          })], 2)
        }), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "icon": "",
            "outline": "",
            "outlined": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.withInlineDelete) ? _c('v-btn', {
          attrs: {
            "small": "",
            "icon": "",
            "outline": "",
            "outlined": "",
            "color": "error"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.selectedRow = props.item;
              _vm.confirmDelete = true
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 2), _vm._v(" "), (props.item.loading) ? _c('tr', [_c('td', {
          staticStyle: {
            "padding": "0px",
            "height": "4px"
          },
          attrs: {
            "colspan": "100%"
          }
        }, [_c('v-progress-linear', {
          staticStyle: {
            "margin": "0px",
            "padding": "0px"
          },
          attrs: {
            "height": 3,
            "indeterminate": true
          }
        })], 1)]) : _vm._e()]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_vm._t("expand", null, {
          "item": props.item
        })]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "no-data"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n          " + _vm._s(_vm.noDataText) + "\n          "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.editmode = "add";
        _vm.setBlankSelectedRow();
        _vm.addedit = true;
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.emptyBtnText))])], 1) : _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    staticClass: "mr-1",
    attrs: {
      "color": "amber",
      "width": "1",
      "size": "14",
      "indeterminate": ""
    }
  }), _vm._v(" loading\n        ")], 1)])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": (_vm.dialogWidth - 30)
    },
    model: {
      value: (_vm.confirmDelete),
      callback: function($$v) {
        _vm.confirmDelete = $$v
      },
      expression: "confirmDelete"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subheading py-0"
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDeleteTitle) + "\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.successsnacker && _vm.deleteRequestStatus === 204) ? _c('v-alert', {
    staticClass: "ma-0 absolute-top",
    attrs: {
      "absolute": "",
      "dismissible": "",
      "transition": "slide-y-transition",
      "type": "success",
      "value": true
    }
  }, [_vm._v("\n            Your changes have been saved\n        ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [(_vm.confirmDeleteTagline) ? _c('v-alert', {
    staticClass: "subheading",
    attrs: {
      "type": "info",
      "value": true,
      "dense": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDeleteTagline) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.headers), function(header, index) {
    return [_c('v-list-tile', {
      key: header.index
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedRow[header.value]))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(header.value))])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: index
    })]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "error"
    },
    on: {
      "click": _vm.deleteRow
    }
  }, [_vm._v(_vm._s(_vm.deleteText))])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": _vm.dialogWidth
    },
    model: {
      value: (_vm.addedit),
      callback: function($$v) {
        _vm.addedit = $$v
      },
      expression: "addedit"
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.isValid),
      callback: function($$v) {
        _vm.isValid = $$v
      },
      expression: "isValid"
    }
  }, [_c('v-card', [(_vm.withInlineHelp) ? _c('v-navigation-drawer', {
    attrs: {
      "permanent": "",
      "absolute": "",
      "right": "",
      "value": true
    }
  }, [_vm._v("\n          Help information will show here\n        ")]) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading py-0 grey lighten-4"
  }, [(_vm.editmode == "edit") ? _c('span', [_vm._v("Edit")]) : _c('span', [_vm._v("Add")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit("crud:adddialogclosed");
        _vm.addedit = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.editRequestStatus === 400 || _vm.createRequestStatus === 0) ? _c('v-alert', {
    staticClass: "ma-0 absolute-top",
    attrs: {
      "transition": "slide-y-transition",
      "absolute": "",
      "dismissible": "",
      "type": "warning",
      "value": true
    }
  }, [_vm._v("\n            Some information you entered was invalid. Please check below and resubmit\n        ")]) : _vm._e(), _vm._v(" "), (_vm.successsnacker && (_vm.editRequestStatus === 200 || _vm.createRequestStatus === 201)) ? _c('v-alert', {
    staticClass: "ma-0 absolute-top",
    attrs: {
      "absolute": "",
      "dismissible": "",
      "transition": "slide-y-transition",
      "type": "success",
      "value": true
    }
  }, [_vm._v("\n            Your changes have been saved\n        ")]) : _vm._e(), _vm._v(" "), _vm._t("addedit-cardtext-outer"), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._t("dialog-header"), _vm._v(" "), _vm._l((_vm.headers), function(header, key) {
    return [_vm._t("field-" + header.value, function() {
      return [_c('v-flex', _vm._b({
        staticClass: "px-2",
        attrs: {
          "xs12": !header.flex
        }
      }, 'v-flex', header.flex, false), [(header.component === "vcheckbox") ? _c('v-checkbox', {
        staticClass: "mb-3",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "error-messages": _vm.getErrors(header.value),
          "hint": header.hint,
          "label": header.text,
          "prefix": header.prefix,
          "suffix": header.suffix,
          "required": header.required,
          "rules": header.rules || [],
          "type": header.type || "text",
          "persistent-hint": ""
        },
        model: {
          value: (_vm.selectedRow[header.value]),
          callback: function($$v) {
            _vm.$set(_vm.selectedRow, header.value, $$v)
          },
          expression: "selectedRow[header.value]"
        }
      }) : (header.component === "vdivider") ? _c('v-divider', {
        staticClass: "my-3"
      }) : (header.component === "vselect") ? _c('v-select', _vm._b({
        staticClass: "mb-3",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "error-messages": _vm.getErrors(header.value),
          "hint": header.hint,
          "label": header.text,
          "prefix": header.prefix,
          "suffix": header.suffix,
          "required": header.required,
          "rules": header.rules || [],
          "persistent-hint": ""
        },
        model: {
          value: (_vm.selectedRow[header.value]),
          callback: function($$v) {
            _vm.$set(_vm.selectedRow, header.value, $$v)
          },
          expression: "selectedRow[header.value]"
        }
      }, 'v-select', header.attrs, false)) : (header.component) ? _c(header.component, _vm._b({
        tag: "component",
        attrs: {
          "error-messages": _vm.getErrors(header.value)
        },
        model: {
          value: (_vm.selectedRow[header.value]),
          callback: function($$v) {
            _vm.$set(_vm.selectedRow, header.value, $$v)
          },
          expression: "selectedRow[header.value]"
        }
      }, 'component', header.attrs, false)) : _c('v-text-field', _vm._b({
        attrs: {
          "outline": _vm.getErrors(header.value).length > 0,
          "error-messages": _vm.getErrors(header.value),
          "hint": header.hint,
          "label": header.text,
          "prefix": header.prefix,
          "suffix": header.suffix,
          "required": header.required,
          "rules": header.rules || [],
          "type": header.type || "text"
        },
        model: {
          value: (_vm.selectedRow[header.value]),
          callback: function($$v) {
            _vm.$set(_vm.selectedRow, header.value, $$v)
          },
          expression: "selectedRow[header.value]"
        }
      }, 'v-text-field', header.attrs, false))], 1)]
    }, {
      "header": header,
      "selectedRow": _vm.selectedRow
    })]
  })], 2)], 1), _vm._v(" "), (_vm.editmode === "edit") ? _c('v-card-actions', {
    attrs: {
      "absolute": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedRow.id,
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = true
      }
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editmode === "edit") ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.addedit = false
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), (_vm.editmode === "edit") ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.editRow
    }
  }, [_vm._v("Save")]) : _vm._e()], 1) : _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.addedit = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.addRow(true)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), (_vm.closeOnEdit) ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.addRow(false)
      }
    }
  }, [_vm._v("Add & add more")]) : _vm._e()], 1)], 2)], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "dayview elevation-0",
    attrs: {
      "tile": "",
      "flat": _vm.flat,
      "id": "day"
    }
  }, [_c('div', {
    staticClass: "period",
    style: ({
      height: _vm.periodInMins + 'px'
    })
  }, [_vm._v("\n    " + _vm._s(_vm.startHour) + "\n  ")]), _vm._v(" "), _vm._l((_vm.numPeriods), function(period) {
    return _c('div', {
      key: period,
      staticClass: "period",
      style: ({
        height: _vm.periodHeight + 'px'
      }),
      on: {
        "click": function($event) {
          return _vm.newEvent(period)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.timeOfDay(_vm.startHour, period, _vm.periodInMins)) + "\n  ")])
  }), _vm._v(" "), _vm._l((_vm.markedUpEvents), function(event, index) {
    return _vm._t("event", function() {
      return [_c('day-event', _vm._g({
        key: ((event.id) + "-" + index),
        attrs: {
          "selected-event": _vm.selectedEvent,
          "start-hour": _vm.startHour,
          "pixel-to-minute-ratio": _vm.pixelToMinuteRatio,
          "default-new-event-length": _vm.defaultNewEventLength
        },
        on: {
          "click": function($event) {
            if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
            return _vm.eventClicked.apply(null, arguments)
          }
        },
        model: {
          value: (_vm.markedUpEvents[index]),
          callback: function($$v) {
            _vm.$set(_vm.markedUpEvents, index, $$v)
          },
          expression: "markedUpEvents[index]"
        }
      }, _vm.$listeners))]
    })
  }), _vm._v(" "), (_vm.previewEventStyle && !_vm.previewEvent.id) ? _c('div', {
    staticClass: "event transient-event",
    style: (_vm.previewEventStyle)
  }, [_vm._v("\n    " + _vm._s(_vm.previewEvent.start_time) + " - " + _vm._s(_vm.previewEvent.end_time) + ". " + _vm._s(_vm.previewEventTitle) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('appointment-bottom-sheet', {
    attrs: {
      "appointment": _vm.selectedEvent,
      "readOnly": _vm.readOnly
    },
    model: {
      value: (_vm.bottomsheet),
      callback: function($$v) {
        _vm.bottomsheet = $$v
      },
      expression: "bottomsheet"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4 pb-5",
    attrs: {
      "flat": ""
    }
  }, [(_vm.request.loading) ? _c('tombstone') : _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2 mt-2"
  }, [(_vm.relationship && _vm.relationship.client) ? _c('client-contact-details', {
    attrs: {
      "touch": _vm.touch,
      "relationship-id": _vm.relationshipId,
      "with-edit": true,
      "with-fetch": false
    },
    model: {
      value: (_vm.relationship),
      callback: function($$v) {
        _vm.relationship = $$v
      },
      expression: "relationship"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-footer', {
    staticClass: "pl-3"
  }, [(_vm.ownerId) ? _c('sharing-information', {
    attrs: {
      "context": _vm.relationship.context,
      "owner-id": _vm.ownerId,
      "space-ids": _vm.relationship.spaces
    },
    on: {
      "click": function($event) {
        return _vm.$emit("click:share", _vm.relationship)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.initPage
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.request.loading) ? _c('tombstone', {
    attrs: {
      "height": "300px"
    }
  }) : _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(_vm.relationship && _vm.relationship.computed_summary) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.relationship.computed_summary.dates) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-text', [(_vm.formattedBio) ? _c('div', [_c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v("Bio")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedBio)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.record && _vm.record.patient && _vm.record.patient.notes) ? _c('v-divider', {
    staticClass: "mb-3"
  }) : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v("Highlights")]), _vm._v(" "), _c('div', [_vm._v("First appointment:\n              "), (_vm.relationship.computed_summary.dates.first) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.dateformat(_vm.relationship.computed_summary.dates.first)) + "\n              ")]) : _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("None yet")])]), _vm._v(" "), _c('div', [_vm._v("Total appointments:\n              "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.relationship.computed_summary.dates.count) + "\n              ")])]), _vm._v(" "), (_vm.record && _vm.record.patient) ? [_c('div', [_vm._v("\n                Birthday:\n                "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.record.patient.date_of_birth || 'unknown') + "\n                "), (_vm.record.patient.date_of_birth) ? _c('span', [_vm._v("\n                  (" + _vm._s(_vm.age) + " years old)\n                ")]) : _vm._e()])])] : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.relationship.computed_summary.account) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "height": "100%"
    }
  }, [(_vm.relationship.computed_summary.account.percent_paid <= 100) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "value": _vm.relationship.computed_summary.account.percent_paid,
      "color": "amber"
    }
  }) : _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "value": 100,
      "color": "success"
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline pb-0"
  }, [_vm._v("\n            Account\n            "), _c('v-spacer'), _vm._v(" "), _c('help-popover', [_vm._v("\n              These numbers are calculated based on the appointments in this account.\n\n              "), _c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Payments received")]), _vm._v("\n              This is the sum of all payments tracked against this user's appointments\n\n              "), _c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Due")]), _vm._v("\n              This is "), _c('i', [_vm._v("payments received")]), _vm._v(" - "), _c('i', [_vm._v("Total value of appointments to date")]), _vm._v(" "), _c('br'), _c('b', [_vm._v("Note:")]), _vm._v(" Future appointments are not considered \"due\"\n            ")], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', [_vm._v("Total value of appointments to date:\n              "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formatnumber(_vm.relationship.computed_summary.account.value_past, true)) + "\n              ")])]), _vm._v(" "), _c('div', [_vm._v("Total value of future appointments:\n              "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formatnumber(_vm.relationship.computed_summary.account.value_future, true)) + "\n              ")])]), _vm._v(" "), _c('div', [_vm._v("\n              Payments received:\n              "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.formatnumber(_vm.relationship.computed_summary.account.payments, true)) + "\n              ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_vm._v("\n              Due:\n              "), _c('strong', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.formatnumber(_vm.relationship.computed_summary.account.value_outstanding, true)) + "\n              ")])])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isMedical && _vm.relationship) ? _c('v-flex', [(_vm.relationship.active_codes && _vm.relationship.active_codes.length > 0) ? _c('v-list', {
    staticClass: "mt-3 mx-2 elevation-2",
    attrs: {
      "dense": "",
      "subheader": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        Current treatment codes\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "outline": "",
      "outlined": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("goto", "codes")
      }
    }
  }, [_vm._v("\n          Manage codes\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _vm._l((_vm.relationship.active_codes), function(code) {
    return _c('treatment-log-list-item', {
      key: code.id,
      attrs: {
        "item": code,
        "with-delete": false
      }
    })
  })], 2) : _c('v-card', {
    staticClass: "mx-2 my-4"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n        No treatment codes defined\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": "https://www.loom.com/share/f26d5537be0540f7bd8fc82c61b9b6f6",
      "target": "_blank",
      "color": "primary",
      "small": "",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n              Learn more\n              "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "outline": "",
      "outlined": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("goto", "codes")
      }
    }
  }, [_vm._v("\n          Manage codes\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v("info")]), _vm._v("\n        You can define treatment codes for a client and optionally have them automatically added to new\n        appointments.\n      ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.request.loading) ? _c('tombstone', {
    attrs: {
      "height": "300px"
    }
  }) : _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 mt-3"
  }, [_vm._v("\n          Details as they will show on invoices\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "outlined": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("goto", "record")
      }
    }
  }, [_vm._v("\n            Edit\n            "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": _vm.isMedical
    }
  }, [(_vm.relationship && _vm.relationship.client && _vm.record) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline pb-0"
  }, [_vm._v("\n            Billing information\n            "), _c('v-spacer')], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, [(_vm.record && _vm.record.patient && _vm.record.patient.billing_address) ? [_c('pre', {
    staticStyle: {
      "font-family": "Roboto"
    }
  }, [_vm._v(_vm._s(_vm.record.patient.billing_address))])] : [_vm._v("\n            " + _vm._s(_vm.relationship.client.first_name) + "\n            " + _vm._s(_vm.relationship.client.last_name)), _c('br'), _vm._v(" "), (_vm.isRealEmail(_vm.relationship.client.email)) ? _c('span', [_vm._v("\n              Email: " + _vm._s(_vm.relationship.client.email)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.relationship.client.phone_number) ? _c('span', [_vm._v("\n            Phone: " + _vm._s(_vm.relationship.client.phone_number)), _c('br')]) : _vm._e()]], 2)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isMedical) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.medicalaid) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline pb-0"
  }, [_vm._v("\n            Medical Aid information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.medicalaid.name || 'No medical aid specified'))]), _vm._v(" "), (_vm.medicalaid.scheme) ? _c('small', [_vm._v("(" + _vm._s(_vm.medicalaid.scheme) + ")")]) : _vm._e(), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Membership #:")]), _vm._v(" " + _vm._s(_vm.medicalaid.number)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Patient:")]), _vm._v(" " + _vm._s(_vm.medicalaid.patient_first_name) + " " + _vm._s(_vm.medicalaid.patient_last_name)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("ID:")]), _vm._v(" " + _vm._s(_vm.medicalaid.patient_id_number) + "\n            "), (_vm.medicalaid.is_dependent) ? _c('div', [_c('strong', [_vm._v("Main member:")]), _vm._v(" " + _vm._s(_vm.medicalaid.member_first_name) + " " + _vm._s(_vm.medicalaid.member_last_name)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("ID:")]), _vm._v(" " + _vm._s(_vm.medicalaid.member_id_number) + "\n            ")]) : _c('div', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "success"
    }
  }, [_vm._v("check_circle")]), _vm._v("\n              Patient is main member\n            ")], 1)]), _vm._v(" "), (_vm.currentReferrers) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Referred by:")]), _vm._v(" "), _vm._l((_vm.currentReferrers), function(referrer) {
    return _c('v-list-tile', {
      key: referrer.id
    }, [(referrer.therapist) ? _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(referrer.therapist.title) + " " + _vm._s(referrer.therapist.first_name) + " " + _vm._s(referrer.therapist.last_name) + ".\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n                " + _vm._s(referrer.therapist.reference_number) + "\n              ")])], 1)
  })], 2) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.relationship && _vm.relationship.client) ? _c('v-card', {
    staticClass: "ma-2 mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Danger Zone\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.del.showConfirmation),
      callback: function($$v) {
        _vm.$set(_vm.del, "showConfirmation", $$v)
      },
      expression: "del.showConfirmation"
    }
  }, [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.del.window),
      callback: function($$v) {
        _vm.$set(_vm.del, "window", $$v)
      },
      expression: "del.window"
    }
  }, [_c('v-window-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }), _vm._v(" "), _c('v-card-text', [_c('center', [_vm._v("\n                    Are you sure you want to "), _c('strong', [_vm._v("archive")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote pa-0 mt-2"
  }, [_vm._v("\n                      " + _vm._s(_vm.relationship.client.first_name) + " " + _vm._s(_vm.relationship.client.last_name) + "\n                    ")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-3 pa-0",
    attrs: {
      "hide-details": "",
      "label": "Permanently delete"
    },
    model: {
      value: (_vm.del.permanent),
      callback: function($$v) {
        _vm.$set(_vm.del, "permanent", $$v)
      },
      expression: "del.permanent"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "hide-details": "",
      "label": "Also delete their appointments"
    },
    model: {
      value: (_vm.del.withAppointments),
      callback: function($$v) {
        _vm.$set(_vm.del, "withAppointments", $$v)
      },
      expression: "del.withAppointments"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.del.showConfirmation = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.del.permanent) ? _c('v-btn', {
    attrs: {
      "loading": _vm.deleteRequest.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRelationship(_vm.relationship.id)
      }
    }
  }, [_vm._v("Delete")]) : _c('v-btn', {
    attrs: {
      "loading": _vm.deleteRequest.loading,
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRelationship(_vm.relationship.id)
      }
    }
  }, [_vm._v("Archive")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', [_c('v-card-text', [_c('center', [_c('v-icon', {
    attrs: {
      "color": "green",
      "size": "72"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote pa-0 mt-2"
  }, [_vm._v("\n                      Successfully archived\n                    ")])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/clients",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.del.window = 0;
        _vm.del.showConfirmation = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.isOwner,
      "loading": _vm.deleteRequest.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.del.showConfirmation = true;
        _vm.del.window = 0
      }
    }
  }, [_vm._v("Delete")])], 1), _vm._v(" "), (!_vm.isOwner) ? _c('p', {
    staticClass: "caption mx-2"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n        Only the owner can delete this client\n      ")], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [(_vm.multiple) ? _c('selected-appointments-preview', {
    staticClass: "mb-2",
    attrs: {
      "appointment-ids": _vm.appointmentIds,
      "flat": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t('text.label')))]), _vm._v(" "), _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "value": _vm.successMessage,
      "color": "success",
      "type": "success",
      "dismissible": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('messages.success')) + "\n    ")]), _vm._v(" "), _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "value": _vm.errorMessage,
      "color": "success",
      "type": "error",
      "dismissible": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('messages.error')) + "\n    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hint": _vm.$t("text.hint"),
      "persistent-hint": "",
      "solo": "",
      "prepend-icon": "tag"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _vm._l((_vm.tags), function(tag, index) {
    return [(tag) ? _c('v-chip', {
      key: (tag + "-" + index),
      attrs: {
        "color": "primary",
        "dark": "",
        "small": "",
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.remove(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('buttons.done')) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.addRequest.loading,
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.save')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-1 grey lighten-4"
  }, [_vm._v("\n    Generate report\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-alert', {
    staticClass: "mt-0",
    attrs: {
      "type": "info",
      "value": true
    }
  }, [_vm._v("\n    This will load a print friendly report which you can either print, or save as a pdf.\n\n    "), _c('li', [_c('strong', [_vm._v("To print")]), _vm._v(": In your browser, click file -> print (or cmd/ctrl P)")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("To save as PDF")]), _vm._v(": From the print dialog, select save as PDF as your destination")])]), _vm._v(" "), _c('v-card-text', [(_vm.withTitle) ? _c('v-text-field', {
    attrs: {
      "label": "Title"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), (_vm.withDates) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.withDates = false;
        _vm.fromDate = null;
        _vm.toDate = null;
      }
    }
  }, [_vm._v("Clear date range\n        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("cancel")])], 1) : _c('v-btn', {
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.withDates = true
      }
    }
  }, [_vm._v("Add date range")])], 1), _vm._v(" "), (_vm.withDates) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("From date")]), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "no-title": "",
      "max": _vm.toDate,
      "full-width": "",
      "type": "month"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("To date")]), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "no-title": "",
      "min": _vm.fromDate,
      "full-width": "",
      "type": "month"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "target": "_blank",
      "href": _vm.reportUrl
    }
  }, [_vm._v("\n      Show report\n      "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    staticStyle: {
      "font-size": "smaller"
    },
    attrs: {
      "readlonly": "",
      "persistent-hint": "",
      "outline": "",
      "id": _vm.uuid,
      "label": _vm.label,
      "dark": _vm.dark,
      "value": _vm.textToCopy,
      "prepend-icon": _vm.prependIcon,
      "append-icon": "file_copy",
      "hint": _vm.copyLinkText
    },
    on: {
      "click:append": _vm.copyToClipboard
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    attrs: {
      "disabled": _vm.isDeleting
    }
  }, [(_vm.statement) ? _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.statement.title))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n      Date: " + _vm._s(_vm.statement.date) + "\n      "), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Due: " + _vm._s(_vm.statement.due_date))])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n    " + _vm._s(_vm.formatCurrency(_vm.me.profile.currency, _vm.statement.closing_balance)) + "\n    "), _c('v-list-tile-action-text', [_vm._v("\n      Balance\n    ")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "ml-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "href": _vm.statement.url,
      "target": "_blank",
      "icon": _vm.$vuetify.breakpoint.xs,
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("View")]), _vm._v(" "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": _vm.$vuetify.breakpoint.xs,
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("send", _vm.statement)
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Send")]), _vm._v(" "), _c('v-icon', {
    staticClass: "ml-2 visible-xs-only",
    attrs: {
      "small": ""
    }
  }, [_vm._v("send")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "40px"
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "icon": "",
      "color": "danger"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = true
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), (_vm.statement) ? _c('v-dialog', {
    model: {
      value: (_vm.showDeleteConfirmation),
      callback: function($$v) {
        _vm.showDeleteConfirmation = $$v
      },
      expression: "showDeleteConfirmation"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n          Are you sure you want to delete this statement?\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Permanently delete statement: "), _c('strong', [_vm._v(_vm._s(_vm.statement.title))]), _vm._v("?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.dodelete(_vm.statement.id);
        _vm.showDeleteConfirmation = false
      }
    }
  }, [_vm._v("\n            Delete\n          ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": 0
    }
  }, [_c('create-statement-form', {
    attrs: {
      "relationship-id": _vm.relationshipId,
      "invoices": _vm.invoices
    },
    on: {
      "success": _vm.statementCreated
    }
  })], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 1
    }
  }, [(_vm.newstatement) ? _c('statement-success', {
    attrs: {
      "statement": _vm.newstatement
    },
    on: {
      "send": function($event) {
        _vm.step = 2
      },
      "close": function($event) {
        return _vm.$emit("close")
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 2
    }
  }, [(_vm.newstatement) ? _c('send-statement', {
    attrs: {
      "touch": _vm.touchSender
    },
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      }
    },
    model: {
      value: (_vm.newstatement),
      callback: function($$v) {
        _vm.newstatement = $$v
      },
      expression: "newstatement"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-system-bar', {
    staticClass: "overline",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n    Your appointment\n  ")]), _vm._v(" "), (_vm.appointment && _vm.appointment.id) ? [(_vm.isRecurring) ? [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Recurring appointment created\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              First appointment: " + _vm._s(_vm.formatFromTo(_vm.appointment.start_time, _vm.appointment.end_time)) + "\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(_vm.appointment.num_recurrances) + " appointments recurring " + _vm._s(_vm.appointment.recurrance_rate.toLowerCase()) + "\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("reset")
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("\n          Add another")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)] : [(_vm.appointment && _vm.appointment.id) ? _c('small-appointment-card', {
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      }
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  }, [_c('template', {
    slot: "card-actions"
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("reset")
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("\n              Add another")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 2) : _vm._e()]] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticStyle: {
      "min-height": "100%"
    },
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [(_vm.request.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comm.backend_used === "services.backends.email.EmailBackend") ? _c('v-card-text', [_c('div', [_c('div', {
    staticClass: "overline"
  }, [_vm._v("To:")]), _vm._l((_vm.comm.recipient_emails), function(email) {
    return _c('v-chip', {
      key: email,
      staticClass: "v-chip--x-small"
    }, [_vm._v(_vm._s(email))])
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "overline mt-2"
  }, [_vm._v("Subject:")]), _vm._v(" " + _vm._s(_vm.comm.subject) + "\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mt-4 overline"
  }, [_vm._v("Message:")]), _vm._v(" "), _c('div', {
    staticClass: "block",
    domProps: {
      "innerHTML": _vm._s(_vm.parsedMessage)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.comm.backend_used === "services.backends.zoomconnect.ZoomSMSBackend") ? _c('v-card-text', [_c('div', [_c('span', {
    staticClass: "overline"
  }, [_vm._v("To:")]), _c('v-chip', {
    staticClass: "v-chip--x-small"
  }, [_vm._v(_vm._s(_vm.comm.recipient_phone_number))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mt-4 mb-2 overline"
  }, [_vm._v("Message:")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "pa-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.comm.short_message.trim()))]), _vm._v("\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('h4', {
    staticClass: "overline ml-3 mb-2"
  }, [_vm._v("Status history")]), _vm._v(" "), _vm._l((_vm.comm.communicationstatus), function(status) {
    return _c('v-list-tile', {
      key: status.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(status.status))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.dateformat(status.created_date, 'ddd DD MMM YYYY H:mma')))])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "loading": _vm.searchRequest.loading,
      "box": "",
      "clearable": "",
      "hint": "Start typing a code or description",
      "label": "Search for a process code"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-2"
  }, [_c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.resetSuggestionsDialog),
      callback: function($$v) {
        _vm.resetSuggestionsDialog = $$v
      },
      expression: "resetSuggestionsDialog"
    }
  }, [(_vm.resetSuggestionsDialog) ? _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.setsuggestions,
      "message200": "Suggestions have been updated"
    },
    on: {
      "ok": function($event) {
        _vm.resetSuggestionsDialog = false
      }
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_vm._v("\n            Clear suggestions\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.resetSuggestionsDialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0 pt-1 caption"
  }, [_vm._v("\n            Don't suggest codes/prices from appointments before this date.\n            Use this if you have changed your pricing and no longer want suggestions with the old pricing\n          ")]), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "no-title": "",
      "flat": "",
      "full-width": ""
    },
    model: {
      value: (_vm.suggestionDate),
      callback: function($$v) {
        _vm.suggestionDate = $$v
      },
      expression: "suggestionDate"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.requests.setsuggestions.loading
    },
    on: {
      "click": _vm.setSuggestionDate
    }
  }, [_vm._v("\n              Update suggestions")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "pl-2 overline"
  }, [_vm._v("\n        Recently used "), (_vm.afterDate) ? [_vm._v("since " + _vm._s(_vm.afterDate))] : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "py-0",
    attrs: {
      "small": "",
      "label": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.resetSuggestionsDialog = true
      }
    }
  }, [_vm._v("Reset suggestions\n        ")])], 2), _vm._v(" "), _vm._l((_vm.filteredSuggestions), function(code, index) {
    return _c('v-chip', {
      key: index,
      attrs: {
        "small": "",
        "label": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(code)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(code.name))]), _vm._v(" \n        " + _vm._s(_vm.formatCurrency('ZAR', (parseFloat(code.price)))) + "\n      ")])
  }), _vm._v(" "), (_vm.filteredSuggestions && _vm.filteredSuggestions.length === 0) ? _c('div', {
    staticClass: "caption px-2"
  }, [_vm._v("\n        No codes to suggest based on your appointments\n        "), (_vm.afterDate) ? [_vm._v("after " + _vm._s(_vm.afterDate))] : _vm._e()], 2) : _vm._e()], 2), _vm._v(" "), (_vm.searchString && _vm.searchString.length > 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Search results")]), _vm._v(" "), _vm._l((_vm.searchResults), function(result) {
    return [_c('v-list-tile', {
      key: ("li-" + (result.id)),
      on: {
        "click": function($event) {
          return _vm.selectItem(result)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v(_vm._s(result.name))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(result.description))])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n            " + _vm._s(_vm.formatCurrency('ZAR', (parseFloat(result.discovery_rate)))) + "\n          ")])], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (result.id))
    })]
  }), _vm._v(" "), (_vm.searchResults && _vm.searchResults.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("No codes matched your query")])], 1) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "mb-5",
    attrs: {
      "three-line": ""
    }
  }, [(_vm.request.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": "2"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.communications), function(communication) {
    return [_c('communication-list-item', {
      key: communication.id,
      attrs: {
        "item": communication
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (communication.id))
    })]
  }), _vm._v(" "), (!_vm.request.loading && _vm.communications.length === 0) ? _c('v-list-tile', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        No communications found for this invoice\n      ")])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    model: {
      value: (_vm.isValid),
      callback: function($$v) {
        _vm.isValid = $$v
      },
      expression: "isValid"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v("\n    Configure Yoco\n    "), (_vm.space && _vm.space.title) ? _c('span', {
    staticClass: "ml-1"
  }, [_vm._v("for " + _vm._s(_vm.space.title))]) : _vm._e(), _vm._v(" "), (_vm.isInstalled) ? _c('v-chip', {
    staticClass: "ml-3",
    attrs: {
      "success": "",
      "outline": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v("\n      Connected\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.LINKS.REFERRAL,
      "color": "success",
      "target": "_blank",
      "small": ""
    }
  }, [_vm._v("\n      Open a Yoco account\n      "), _c('v-icon', {
    staticClass: "pl-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": _vm.successMessage,
      "message204": "Successfully uninstalled",
      "message404": "Currently not installed",
      "message201": "Integration installed successfully"
    },
    on: {
      "200": function($event) {
        return _vm.$emit('saved', _vm.request)
      },
      "201": function($event) {
        return _vm.$emit('created', _vm.request)
      },
      "204": function($event) {
        return _vm.$emit('deleted', _vm.request)
      },
      "ok": function($event) {
        return _vm.$emit('ok', _vm.request)
      }
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "type": "info",
      "outline": "",
      "outlined": "",
      "value": true
    }
  }, [_vm._v("\n        You can find your Yoco payment link at:\n          "), _c('a', {
    attrs: {
      "href": _vm.LINKS.REFERRAL
    }
  }, [_vm._v("yoco.co.za")]), _vm._v(" ->\n          sell online ->\n          "), _c('a', {
    attrs: {
      "href": _vm.LINKS.PAYMENT_LINK
    }
  }, [_vm._v("payment page")]), _vm._v(" "), _c('br'), _vm._v("Copy the online link and paste it here\n      ")]), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "required": "",
      "rules": [function (v) { return !!v || 'Link is required'; }],
      "prefix": "https://pay.yoco/"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.save.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.link),
      callback: function($$v) {
        _vm.link = $$v
      },
      expression: "link"
    }
  }), _vm._v(" "), (_vm.request.data && _vm.request.result && _vm.request.result.settings) ? [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("Options")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "disabled": _vm.request.loading,
      "label": "Show on invoices",
      "persistent-hint": true,
      "hint": "Will display a button on your invoices which lets your clients pay with Yoco"
    },
    model: {
      value: (_vm.request.data.payment_invoices_visible),
      callback: function($$v) {
        _vm.$set(_vm.request.data, "payment_invoices_visible", $$v)
      },
      expression: "request.data.payment_invoices_visible"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "disabled": _vm.request.loading,
      "label": "Include link on Appointment pages"
    },
    model: {
      value: (_vm.request.data.payment_appointments_visible),
      callback: function($$v) {
        _vm.$set(_vm.request.data, "payment_appointments_visible", $$v)
      },
      expression: "request.data.payment_appointments_visible"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-4 pa-0",
    attrs: {
      "disabled": !(_vm.request.data.payment_appointments_visible) || _vm.request.loading,
      "label": "Allow pre-payments",
      "persistent-hint": true,
      "hint": "Allow people to pay for appointments before the appointment start time"
    },
    model: {
      value: (_vm.request.data.payment_appointments_prepayments),
      callback: function($$v) {
        _vm.$set(_vm.request.data, "payment_appointments_prepayments", $$v)
      },
      expression: "request.data.payment_appointments_prepayments"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-4 pa-0",
    attrs: {
      "disabled": !(_vm.request.data.payment_appointments_visible) || _vm.request.loading,
      "label": "Only allow payments on appointments marked as \"invoiceable\"",
      "persistent-hint": true,
      "hint": "Payment options will not show on the appointment page unless you have explicitly marked the appointment as invoiceable"
    },
    model: {
      value: (_vm.request.data.payment_appointments_only_if_invoiceable),
      callback: function($$v) {
        _vm.$set(_vm.request.data, "payment_appointments_only_if_invoiceable", $$v)
      },
      expression: "request.data.payment_appointments_only_if_invoiceable"
    }
  })] : _vm._e()], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.isInstalled) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.uninstalldialog = true
      }
    }
  }, [_vm._v("Uninstall")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.isValid,
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "390px"
    },
    model: {
      value: (_vm.uninstalldialog),
      callback: function($$v) {
        _vm.uninstalldialog = $$v
      },
      expression: "uninstalldialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n        Are you sure you want to uninstall Yoco?\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.uninstalldialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.uninstalldialog = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "error"
    },
    on: {
      "click": _vm.uninstall
    }
  }, [_vm._v("Uninstall")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [(_vm.request.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(comm) {
    return [_c('communication-list-item', {
      key: comm.id,
      attrs: {
        "item": comm
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div" + (comm.id))
    })]
  }), _vm._v(" "), (!_vm.request.loading && _vm.messages && _vm.messages.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(_vm.$t('nomessages')) + "\n      ")])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    style: (_vm.statusBorder),
    on: {
      "click": function($event) {
        return _vm.$emit("clicked", _vm.invoice)
      }
    }
  }, [_vm._t("actionsBefore"), _vm._v(" "), _c('v-list-tile-content', [_vm._t("title", function() {
    return [_c('v-list-tile-title', {
      attrs: {
        "slot": "tile-title"
      },
      slot: "tile-title"
    }, [(_vm.invoice.practitioner_id) ? _c('practitioner-faces', {
      attrs: {
        "size": 16,
        "tooltip-prefix": "Created by ",
        "practitioner-ids": [_vm.invoice.practitioner_id]
      }
    }) : _vm._e(), _vm._v(" "), (_vm.invoice.space_id) ? _c('space-faces', {
      attrs: {
        "size": 16,
        "space-ids": [_vm.invoice.space_id]
      }
    }) : _vm._e(), _vm._v(" "), (_vm.invoice.encrypt_password) ? _c('v-icon', {
      attrs: {
        "small": "",
        "color": "info",
        "title": _vm.invoice.encrypt_password
      }
    }, [_vm._v("\n              lock\n            ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.invoice.title))]), _vm._v(" "), _c('v-chip', {
      staticClass: "v-chip--x-small px-0 my-0",
      attrs: {
        "label": "",
        "outline": ""
      }
    }, [_vm._v(" #" + _vm._s(_vm.invoice.id))]), _vm._v(" "), (_vm.withStatus) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      staticStyle: {
        "padding": "0px 5px",
        "margin": "0px",
        "float": "right"
      },
      attrs: {
        "color": _vm.statusColor,
        "text-color": "white",
        "label": ""
      }
    }, [_vm._v(_vm._s(_vm.invoice.status.toUpperCase()) + "\n            ")]) : _vm._e()], 1)]
  }), _vm._v(" "), _vm._t("sub-title", function() {
    return [_c('v-list-tile-sub-title', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-0 ml-1",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('invoiceDate')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.dateformat(_vm.invoice.date, 'YYYY-MM-DD')))]), _vm._v(" /\n                " + _vm._s(_vm.$t('dueDate')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.dateformat(_vm.invoice.due_date, 'YYYY-MM-DD')))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0 ml-1"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('total')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, _vm.invoice.invoice_amount)))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('payments')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, _vm.invoice.amount_paid)))])])], 1)], 1)]
  })], 2), _vm._v(" "), _vm._t("actionsAfter")], 2)
},staticRenderFns: []}

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    attrs: {
      "close-on-content-click": false,
      "nudge-bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-chip', _vm._g({
          attrs: {
            "slot": "activator",
            "small": ""
          },
          slot: "activator"
        }, on), [_c('v-avatar', {
          attrs: {
            "left": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("expand_more")])], 1), _vm._v("\n      Mailchimp\n    ")], 1)]
      }
    }]),
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, 'v-menu', _vm.menuAttrs, false), [_vm._v(" "), _c('span', [(_vm.requests.get.loading) ? _c('v-card', {
    staticClass: "text-center",
    attrs: {
      "width": "360px"
    }
  }, [_c('center', [_c('v-progress-circular', {
    staticClass: "ma-5",
    attrs: {
      "size": "64",
      "color": "amber",
      "indeterminate": ""
    }
  })], 1)], 1) : _c('v-card', {
    attrs: {
      "width": "400px"
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.save
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        " + _vm._s(_vm.email) + "\n        "), _c('v-spacer'), _vm._v(" "), (_vm.member && _vm.member.status) ? _c('v-chip', {
    staticClass: "v-chip--x-small"
  }, [_vm._v(_vm._s(_vm.member.status))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.requests.get.status === 404) ? [_c('v-card-text', [_vm._v("\n          This email is not in your Mailchimp mailing list.\n          Would you like to add them?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Add to Mailchimp")])], 1)] : _vm._e(), _vm._v(" "), (_vm.member && _vm.requests.get.status === 200) ? [_c('v-card-text', [_c('strong', [_vm._v("Email client:")]), _vm._v(" " + _vm._s(_vm.member.email_client || "Unknown")), _c('br'), _vm._v(" "), (_vm.member.stats) ? _c('v-layout', {
    staticClass: "my-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('strong', [_vm._v("Open rate")]), _vm._v(" "), _c('v-progress-circular', {
    staticClass: "ml-2",
    attrs: {
      "rotate": 270,
      "size": 36,
      "width": "3",
      "color": "success",
      "value": _vm.asPercent(_vm.member.stats.avg_open_rate)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.asPercent(_vm.member.stats.avg_open_rate)) + "%\n              ")])], 1), _vm._v(" "), _c('v-flex', [_c('strong', [_vm._v("Click rate:")]), _vm._v(" "), _c('v-progress-circular', {
    staticClass: "ml-2",
    attrs: {
      "rotate": 270,
      "size": 36,
      "width": "3",
      "color": "info",
      "value": _vm.asPercent(_vm.member.stats.avg_click_rate)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.asPercent(_vm.member.stats.avg_click_rate)) + "%\n              ")])], 1), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "overline"
  }, [_vm._v("Mailchimp rating")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "half-increments": "",
      "small": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: (_vm.member.member_rating),
      callback: function($$v) {
        _vm.$set(_vm.member, "member_rating", $$v)
      },
      expression: "member.member_rating"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Last changed")]), _vm._v(" " + _vm._s(_vm.dateformat(_vm.member.last_changed)) + "\n          "), _vm._v(" "), (_vm.member.tags && _vm.member.tags.length > 0) ? _c('div', {
    staticClass: "mt-2"
  }, _vm._l((_vm.member.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": "",
        "outlined": ""
      }
    }, [_vm._v("\n              " + _vm._s(tag.name) + "\n            ")])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.relationshipId && this.member && this.member.id) ? _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "loading": _vm.requests.save.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.mailchimpURL) ? _c('v-btn', {
    attrs: {
      "href": _vm.mailchimpURL,
      "target": "_blank",
      "small": "",
      "color": "success"
    }
  }, [_vm._v("Open in Mailchimp "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e()], 1)] : _vm._e()], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [(_vm.statementRequest.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "height": 2,
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-navigation-drawer', {
    attrs: {
      "bottom": "",
      "touchless": "",
      "hide-overlay": "",
      "width": "420",
      "absolute": _vm.$vuetify.breakpoint.xs,
      "permanent": !_vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "height": "100%"
    }
  }, [_c('active-clients', {
    attrs: {
      "with-close": _vm.$vuetify.breakpoint.xs
    },
    on: {
      "selected": _vm.setSelectedClient,
      "close": function($event) {
        _vm.drawer = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "min-height": "600px"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.selectedClient && _vm.selectedClient.id) ? _c('statement', {
    attrs: {
      "is-compact": _vm.$vuetify.breakpoint.xs,
      "with-filters": false,
      "client": _vm.selectedClient,
      "filter-from-date": this.globalActiveDateRange.from,
      "filter-to-date": this.globalActiveDateRange.to,
      "with-selectable": true,
      "with-reload": true,
      "with-pre-next": false,
      "loading": _vm.statementRequest.loading
    },
    on: {
      "prev": function($event) {
        _vm.activeIndex--
      },
      "next": function($event) {
        _vm.activeIndex++
      },
      "dateRangeChangeRequested": _vm.launchDateRangePicker,
      "reload": _vm.getStatement,
      "selected:list": _vm.updateSelectedAppointments
    },
    model: {
      value: (_vm.statement),
      callback: function($$v) {
        _vm.statement = $$v
      },
      expression: "statement"
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "slot": "toolbar-icon"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    },
    slot: "toolbar-icon"
  })], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "subheading"
  }, [_vm._v("\n          Choose a customer to view a summary of their appointments between "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.globalActiveDateRangeFormatted))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.launchDateRangePicker
    }
  }, [_vm._v("Change dates")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Tags: "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("tag")]), _vm._v(" "), _vm._l((_vm.appointment.tags), function(tag) {
    return [(_vm.successfullyDeleted.indexOf(tag) === -1) ? _c('v-chip', {
      key: tag,
      attrs: {
        "close": _vm.deleteable && _vm.tagBeingDeleted === null,
        "small": "",
        "dark": "",
        "color": "primary"
      },
      on: {
        "input": function($event) {
          return _vm.remove(tag)
        }
      }
    }, [(tag === _vm.tagBeingDeleted) ? _c('v-progress-circular', {
      staticClass: "mr-2",
      attrs: {
        "indeterminate": "",
        "size": "12",
        "width": "1"
      }
    }) : _vm._e(), _vm._v("\n      " + _vm._s(tag) + "\n    ")], 1) : _vm._e()]
  }), _vm._v(" "), _c('v-chip', {
    attrs: {
      "outline": "",
      "outlined": "",
      "color": "primary",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.launchAppointmentTags({
          appointmentIds: [_vm.appointment.id],
          touch: Math.random()
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n    " + _vm._s(_vm.$t('buttons.add')) + "\n  ")], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected")
      }
    }
  }, [_c('v-list-tile-avatar', [(_vm.profilePic) ? _c('img', {
    attrs: {
      "src": _vm.profilePic
    }
  }) : _c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(_vm.practitioner.first_name) + " " + _vm._s(_vm.practitioner.last_name) + "\n      ")])], 1), _vm._v(" "), (_vm.withDropdown) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "clearable": "",
      "box": "",
      "persistent-hint": _vm.selectMultiple,
      "hint": _vm.selectedFormatted.name,
      "loading": _vm.icd10SearchRequest.loading,
      "label": _vm.$t('search.label')
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.$t("inputs.multipleswitch.label"),
      "hint": _vm.$t("inputs.multipleswitch.hint"),
      "persistent-hint": ""
    },
    model: {
      value: (_vm.selectMultiple),
      callback: function($$v) {
        _vm.selectMultiple = $$v
      },
      expression: "selectMultiple"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.$t("inputs.mit.label"),
      "hint": _vm.$t("inputs.mit.hint"),
      "persistent-hint": ""
    },
    model: {
      value: (_vm.filtermit),
      callback: function($$v) {
        _vm.filtermit = $$v
      },
      expression: "filtermit"
    }
  })], 1)], 1), _vm._v(" "), (_vm.selectMultiple && _vm.multiselected && _vm.multiselected.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('strong', [_vm._v("Selected:")]), _vm._v(" "), _vm._l((_vm.multiselected), function(item, index) {
    return _c('v-chip', {
      key: (index + "-" + (item.name)),
      attrs: {
        "small": "",
        "label": "",
        "close": "",
        "color": "primary",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.searchString = item.name
        },
        "input": function($event) {
          return _vm.multiselected.splice(index, 1)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2) : _vm._e()], 1), _vm._v(" "), (_vm.selectMultiple) ? _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "disabled": !_vm.multiselected || _vm.multiselected.length === 0,
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$emit("input", _vm.selectedFormatted);
        this.multiselected = []
      }
    }
  }, [_vm._v("\n          Select\n        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.filteredSuggestions && _vm.filteredSuggestions.length > 0) ? _c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v(_vm._s(_vm.$t('search.recent')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredSuggestions), function(code, index) {
    return _c('v-chip', {
      key: (index + "-" + code),
      attrs: {
        "small": "",
        "label": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectItem({
            name: code
          })
        }
      }
    }, [_vm._v(_vm._s(code))])
  })], 2)], 1), _vm._v(" "), (_vm.searchString && _vm.searchString.length > 0) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("search")]), _vm._v("  Results")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.searchResults), function(result) {
    return [_c('v-list-tile', {
      key: ("li-" + (result.name)),
      on: {
        "click": function($event) {
          return _vm.selectItem(result)
        }
      }
    }, [_c('v-list-tile-action', [_vm._v(_vm._s(result.name))]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(result.name) + "\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(result.description) + "\n          ")])], 1), _vm._v(" "), (result.code_pack_facets && result.code_pack_facets.length === 1) ? _c('v-list-tile-action', _vm._l((result.code_pack_facets), function(facet) {
      return _c('v-chip', {
        key: facet,
        staticClass: "v-chip--x-small",
        attrs: {
          "dark": "",
          "color": "primary"
        }
      }, [_vm._v(_vm._s(facet))])
    }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (result.name))
    })]
  }), _vm._v(" "), (_vm.searchResults.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v(_vm._s(_vm.$t('search.noresults')))])], 1) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.displayFields), function(field) {
    return _c('v-flex', _vm._b({
      key: field,
      staticClass: "pa-2",
      attrs: {
        "xs12": ""
      }
    }, 'v-flex', _vm.getWrapperAttrs(field), false), [_vm._t(field, function() {
      return [(_vm.fieldConfigs && _vm.fieldConfigs[field] && _vm.fieldConfigs[field].type === "vtextarea") ? _c('v-textarea', _vm._b({
        attrs: {
          "outline": _vm.hasErrors(field),
          "label": field.replace(/_/g, ' '),
          "error-messages": _vm.getErrors(field)
        },
        model: {
          value: (_vm.data[field]),
          callback: function($$v) {
            _vm.$set(_vm.data, field, $$v)
          },
          expression: "data[field]"
        }
      }, 'v-textarea', _vm.fieldConfigs[field] || {}, false)) : _c('v-text-field', _vm._b({
        attrs: {
          "outline": _vm.hasErrors(field),
          "label": field.replace(/_/g, ' '),
          "error-messages": _vm.getErrors(field)
        },
        model: {
          value: (_vm.data[field]),
          callback: function($$v) {
            _vm.$set(_vm.data, field, $$v)
          },
          expression: "data[field]"
        }
      }, 'v-text-field', _vm.fieldConfigs[field] || {}, false)), _vm._v(" "), _vm._t((field + "-after"))]
    })], 2)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": "",
      "subheader": ""
    }
  }, [(_vm.title) ? _c('v-subheader', [_c('strong', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.displayFields), function(key) {
    return _c('v-list-tile', {
      key: key
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.value[key]))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(key.replace(/_/g, ' ')))])], 1)], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-layout', [_c('v-flex', [_c('h3', {
    staticClass: "headline"
  }, [_vm._v("Take bookings online!")]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_vm._v("\n          Your clients can book online from your free AppointmentGuru website, your booking widget or via the mobile app. This frees up your time with less phone calls and messages for appointments.\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "hidden-xs-only": ""
    }
  }, [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "alt": "Example website and app listing",
      "width": "170",
      "src": "https://media-appointmentguru.s3.amazonaws.com/media/practitioner/logo/170_get-online-example.png"
    }
  })])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        Configure how you would like your customers to book\n      ")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Booking widget")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": _vm.bookingwidget,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.bookingwidget))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Share the direct link to let someone book online with you, or embed it on your website\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "href": _vm.bookingwidget,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            View\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-dialog', {
    attrs: {
      "width": "350"
    },
    model: {
      value: (_vm.showembedcode),
      callback: function($$v) {
        _vm.showembedcode = $$v
      },
      expression: "showembedcode"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n                Copy this code to embed a booking widget in your website\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    staticStyle: {
      "font-size": "small"
    },
    attrs: {
      "outlined": "",
      "outline": "",
      "readonly": "",
      "persistent-hint": "",
      "label": "Embed this in your website",
      "height": "200",
      "hint": "Paste this code where you would like to embed the booking widget"
    },
    model: {
      value: (_vm.embedCode),
      callback: function($$v) {
        _vm.embedCode = $$v
      },
      expression: "embedCode"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('copy-text-field', {
    staticClass: "mt-4",
    attrs: {
      "text-to-copy": _vm.bookingwidget,
      "label": "Share your online booking form",
      "hint": "Share this link to enable your clients to easily book online with you"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showembedcode = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.bookingwidget,
      "target": "_blank",
      "small": "",
      "text": "",
      "flat": ""
    }
  }, [_vm._v("\n                  Show widget\n                  "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showembedcode = true
      }
    }
  }, [_c('v-icon', [_vm._v("code")])], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            Embed\n          ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.saveRequest.loading
    },
    model: {
      value: (_vm.webEnabled),
      callback: function($$v) {
        _vm.webEnabled = $$v
      },
      expression: "webEnabled"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Your website ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Your website URL:\n            "), _c('a', {
    attrs: {
      "href": _vm.website,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.website))])]), _vm._v(" "), (!_vm.webPublished) ? _c('v-list-tile-sub-title', [_vm._v("\n            Currently disabled. Check the box on the left to enable and configure\n          ")]) : _c('v-list-tile-sub-title', [_vm._v("\n            Configure your website below\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "disabled": !_vm.webPublished,
      "href": _vm.website,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            View\n          ")])], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("Configure your website")]), _vm._v(" "), (!_vm.webPublished) ? _c('v-alert', {
    attrs: {
      "type": "info",
      "value": true,
      "outline": ""
    }
  }, [_vm._v("\n        You website is currently disabled. You need to enable it in order to configure.\n        "), _c('v-btn', {
    attrs: {
      "loading": _vm.saveRequest.loading,
      "outline": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.webEnabled = true;
        _vm.save()
      }
    }
  }, [_vm._v("Turn on website")])], 1) : _c('v-text-field', {
    attrs: {
      "outline": "",
      "outlined": "",
      "loading": _vm.actionRequest.loading,
      "error": _vm.actionRequest.status > 399,
      "success": _vm.actionRequest.status === 200,
      "success-messages": _vm.subdomainSuccessMessage,
      "error-messages": _vm.subdomainErrorMessage,
      "label": "Set your website url",
      "prefix": "appt.guru/",
      "append-icon": "save"
    },
    on: {
      "click:append": _vm.setSubdomain,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setSubdomain.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.subdomain),
      callback: function($$v) {
        _vm.subdomain = $$v
      },
      expression: "subdomain"
    }
  }), _vm._v(" "), (_vm.webPublished) ? _c('unsplash-search') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.item)
      }
    }
  }, [_c('v-list-tile-avatar', [(_vm.item.automatically_add_to_appointments) ? _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "amber"
    },
    slot: "activator"
  }, [_vm._v("flash_on")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('info.auto_on')))])], 1) : _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "green"
    },
    slot: "activator"
  }, [_vm._v("trip_origin")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('info.auto_off')))])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.item.practitioner) ? _c('practitioner-faces', {
    staticClass: "mr-2",
    attrs: {
      "size": 20,
      "practitioner-ids": [_vm.item.practitioner]
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.item.icd10) + ". " + _vm._s(_vm.item.process) + " @\n      " + _vm._s(_vm.formatCurrency(_vm.item.currency, _vm.item.price)))])], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n      " + _vm._s(_vm.luxonDateformat(_vm.item.start_date, 'ccc d MMM yyyy')) + "\n      "), (_vm.item.stop_date) ? _c('span', [_vm._v("\n        - " + _vm._s(_vm.luxonDateformat(_vm.item.stop_date, 'ccc d MMM yyyy')) + "\n      ")]) : _c('span', [_vm._v("until forever")]), _vm._v(" "), (_vm.isCurrent) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "color": "amber",
      "label": ""
    }
  }, [_vm._v("active")]) : _vm._e()], 1), _vm._v(" "), (_vm.item.automatically_add_to_appointments) ? _c('v-list-tile-sub-title', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n          Will be automatically added to appointments created between these dates\n      ")], 1) : _c('v-list-tile-sub-title', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n          Will "), _c('strong', [_vm._v("never")]), _vm._v(" be automatically added to appointments\n      ")], 1)], 1), _vm._v(" "), (_vm.withDelete) ? _vm._t("action", function() {
    return [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "disabled": !_vm.isOwner,
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit("selected", _vm.item)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "disabled": !_vm.isOwner,
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.dialogs.delete = true
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "290"
      },
      model: {
        value: (_vm.dialogs.delete),
        callback: function($$v) {
          _vm.$set(_vm.dialogs, "delete", $$v)
        },
        expression: "dialogs.delete"
      }
    }, [_c('v-card', [_c('v-card-text', [_vm._v("\n          " + _vm._s(_vm.$t('delete.confirm')) + "\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.dialogs.delete = false
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.cancel')) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          _vm.$emit("clicked:delete", _vm.item);
          _vm.dialogs.delete = false
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.delete')) + "\n          ")])], 1)], 1)], 1)]
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-img', {
    staticClass: "black--text",
    attrs: {
      "height": "200px",
      "src": _vm.mapUrl(_vm.location)
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-end": "",
      "flexbox": ""
    }
  }, [_c('span', {
    staticClass: "headline elevation-10 pa-2 white"
  }, [_vm._v(_vm._s(_vm.location.name))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-title', [_vm._v(_vm._s(_vm.location.address))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("edit")
      }
    }
  }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" Edit address")], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "height=100%"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline grey lighten-4 py-1"
  }, [_c('v-icon', {
    staticClass: "mx-2",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("tour")]), _vm._v("\n    Get started with AppointmentGuru\n    "), _c('v-spacer'), _vm._v(" "), (!_vm.showScan) ? _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showScan = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("qr_code")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "hidden-sm-and-up justify-center"
  }, [_c('center', [_vm._v("\n      Looks like you're on a mobile device.\n      "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("install")
      }
    }
  }, [_vm._v("Install AppointmentGuru on your device")])], 1)], 1), _vm._v(" "), _c('center', [(_vm.showScan) ? _c('v-card', {
    staticClass: "grey lighten-4 pb-3 hidden-xs-only my-4",
    attrs: {
      "width": "300"
    }
  }, [_c('v-card-text', {
    staticClass: "hidden-xs-only justify-center"
  }, [_c('center', [_c('v-img', {
    attrs: {
      "width": "100",
      "height": "100",
      "src": "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://app.appointmentguru.co/#/get-started"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "absolute": "",
      "fab": "",
      "small": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.showScan = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "caption mt-2"
  }, [_c('b', [_vm._v("Tip:")]), _vm._v(" Scan this code to open the app on your mobile device.\n      Then you can view the instructions and videos on your computer while you complete the tasks on your phone (or vice versa)\n      ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "top": "",
      "left": "",
      "nudge-left": "",
      "activator": "#main-speed-dail",
      "offset-x": true
    },
    model: {
      value: (_vm.showMenu),
      callback: function($$v) {
        _vm.showMenu = $$v
      },
      expression: "showMenu"
    }
  }, [_c('v-list', {
    staticClass: "pa-0 elevation-10 mr-3 mb-2 blue white--text overline",
    attrs: {
      "dense": "",
      "transition": "slide-x-transition"
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Start here")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "nudge-bottom": "",
      "activator": "#global-guides-btn",
      "offset-y": true
    },
    model: {
      value: (_vm.showFindGuides),
      callback: function($$v) {
        _vm.showFindGuides = $$v
      },
      expression: "showFindGuides"
    }
  }, [_c('v-card', {
    staticClass: "mt-3 mr-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("tour")]), _vm._v("\n        Guides are here\n      ")], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n        You can always return to this guide using the\n        "), _c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("tour")]), _vm._v("\n        icon in the toolbar above\n      ")], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showFindGuides = false
      }
    }
  }, [_vm._v("Got it")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading justify-center"
  }, [_c('blockquote', {
    staticClass: "blockquote pl-0"
  }, [_vm._v("\n    This guide will walk you through the basics of using AppointmentGuru.\n    You will learn how to: create an appointment, add medical aid codes to the appointment, create an invoice and share the invoice with your clients\n    ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-timeline', {
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-timeline-item', {
      key: item.id,
      staticClass: "pb-0",
      class: {
        'accent lighten-2': _vm.step === index
      },
      attrs: {
        "color": "success",
        "icon": "plus"
      },
      on: {
        "click": function($event) {
          return _vm.setStep(item)
        }
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c('v-avatar', {
            staticClass: "white--text",
            attrs: {
              "size": "10"
            }
          }, [(item.done === true) ? _c('v-icon', {
            attrs: {
              "color": "white"
            }
          }, [_vm._v("check")]) : _c('span', [_vm._v(_vm._s(index + 1))])], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-layout', {
      staticClass: "pt-2"
    }, [_c('v-flex', [_c('strong', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "text-caption",
      domProps: {
        "textContent": _vm._s(item.description)
      }
    })]), _vm._v(" "), _c('v-flex', {
      staticClass: "justify-right"
    }, [_c('v-btn', {
      staticClass: "right",
      attrs: {
        "disabled": item.disabled === true,
        "flat": item.done,
        "color": "success"
      },
      on: {
        "click": function($event) {
          return _vm.setStep(item)
        }
      }
    }, [_vm._v("Go")])], 1)], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pl-0"
  }, [_c('v-btn', {
    staticClass: "pl-0",
    attrs: {
      "to": "/",
      "flat": ""
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "grey lighten-4 pl-3 caption"
  }, [_vm._v("\n    AppointmentGuru > Guides > Getting started\n  ")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.showInstructions),
      callback: function($$v) {
        _vm.showInstructions = $$v
      },
      expression: "showInstructions"
    }
  }, [(_vm.selectedItem) ? _c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedItem.title) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showInstructions = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('blockquote', {
    staticClass: "blockquote pa-0",
    domProps: {
      "textContent": _vm._s(_vm.selectedItem.description)
    }
  })]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.selectedItem.instructions && _vm.selectedItem.instructions.video) ? _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "padding-bottom": "62.5%",
      "height": "0"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.selectedItem.instructions.video,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": "",
      "lazy": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.selectedItem.instructions && _vm.selectedItem.instructions.steps) ? _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n                Instructions\n              ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('ol', _vm._l((_vm.selectedItem.instructions.steps), function(item) {
    return _c('li', {
      key: item.title
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    }), _vm._v(" "), (item.items) ? _c('ol', _vm._l((item.items), function(sub) {
      return _c('li', {
        key: sub,
        domProps: {
          "textContent": _vm._s(sub)
        }
      })
    }), 0) : _vm._e()])
  }), 0)]), _vm._v(" "), ((_vm.selectedItem.id === "add_codes" || _vm.selectedItem.id === "create_invoice") && _vm.lastAppointment) ? _c('v-list', {
    staticClass: "elevation-5 mb-3 pa-0",
    attrs: {
      "subheader": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "grey lighten-4 overline my-0 py-0"
  }, [_vm._v("Appointment")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.lastAppointment
    }
  }, [_c('v-list-tile-action', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('appointment-action-menu', {
    attrs: {
      "appointment": _vm.lastAppointment
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedItem.id === "send_invoice") ? _c('v-card', [(_vm.invoices.length === 0) ? _c('v-btn', {
    on: {
      "click": _vm.loadInvoices
    }
  }, [_vm._v("Load invoices")]) : _vm._e(), _vm._v(" "), (_vm.lastInvoice) ? _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('invoice-list', _vm._g({
    attrs: {
      "invoices": [_vm.lastInvoice],
      "actions": _vm.invoiceActions
    }
  }, _vm.invoiceEvents))], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedItem.instructions && _vm.selectedItem.instructions.results) ? [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n                  By the end of this tutorial you will know:\n                ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('ol', _vm._l((_vm.selectedItem.instructions.results), function(result) {
    return _c('li', {
      key: result,
      domProps: {
        "textContent": _vm._s(result)
      }
    })
  }), 0)])] : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showInstructions = false
      }
    }
  }, [_vm._v("Got it!")])], 1)], 2)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: {
      "fullscreen": _vm.fullscreen
    },
    attrs: {
      "flat": ""
    }
  }, [_c('appointment-picker', {
    attrs: {
      "group-by-name": "",
      "multiple": "",
      "with-fullscreen": "",
      "dark": "",
      "dense": "",
      "with-quick-pick": false,
      "fullscreen": _vm.fullscreen,
      "compact": false
    },
    on: {
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    },
    model: {
      value: (_vm.appointments),
      callback: function($$v) {
        _vm.appointments = $$v
      },
      expression: "appointments"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n    Reschedule appointments in this series\n  ")]), _vm._v(" "), (!_vm.success) ? _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "type": "number",
      "label": "days"
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "type": "number",
      "label": "hours",
      "min": -24,
      "max": 24
    },
    model: {
      value: (_vm.hours),
      callback: function($$v) {
        _vm.hours = $$v
      },
      expression: "hours"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "type": "number",
      "label": "minutes",
      "min": -60,
      "max": 60
    },
    model: {
      value: (_vm.minutes),
      callback: function($$v) {
        _vm.minutes = $$v
      },
      expression: "minutes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-switch', {
    attrs: {
      "persistent-hint": "",
      "label": "Only apply rescheduling to this appointment and appointments that start after it",
      "hint": _vm.rescheduleHintText
    },
    model: {
      value: (_vm.futureOnly),
      callback: function($$v) {
        _vm.futureOnly = $$v
      },
      expression: "futureOnly"
    }
  })], 1)], 1) : _c('v-card-text', [_c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n      Appointments successfully rescheduled\n      "), _c('v-btn', {
    attrs: {
      "to": "/calendar",
      "outlined": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n        Return to calendar\n      ")])], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.success,
      "loading": _vm.loading,
      "color": "error"
    },
    on: {
      "click": _vm.performReschedule
    }
  }, [_vm._v("\n      Reschedule appointments\n    ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.actionRequest.status == 200) ? _c('v-alert', {
    staticClass: "pa-2",
    attrs: {
      "value": true,
      "type": "success",
      "dismissible": ""
    }
  }, [_vm._v("\n      Meeting information saved\n    ")]) : _vm._e(), _vm._v(" "), (_vm.actionRequest.status > 300) ? _c('server-errors', {
    attrs: {
      "request": _vm.actionRequest
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.actionRequest.result.meeting_url,
      "persistent-hint": "",
      "hint": "The url for your meeting",
      "label": "Meeting url"
    },
    model: {
      value: (_vm.appointment.zoom_join_url),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "zoom_join_url", $$v)
      },
      expression: "appointment.zoom_join_url"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.actionRequest.result.zoom_meeting_password,
      "persistent-hint": "",
      "hint": "(optional) password for your meeting (if relevant)",
      "label": "Meeting password"
    },
    model: {
      value: (_vm.appointment.zoom_meeting_password),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "zoom_meeting_password", $$v)
      },
      expression: "appointment.zoom_meeting_password"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.actionRequest.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('appointment-detail', {
    attrs: {
      "initial-appointment": _vm.appointment,
      "appointment-id": _vm.appointmentId,
      "is-compact": _vm.$vuetify.breakpoint.xs
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mb-3"
  }, [(_vm.value) ? _c('v-img', {
    attrs: {
      "aspect-ratio": 16 / 9,
      "height": "150",
      "src": _vm.imgUrl
    }
  }, [_c('v-card-title', {
    on: {
      "click": function($event) {
        _vm.showdialog = true
      }
    }
  }, [_c('v-btn', [_vm._v("Change")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('help-popover', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("\n        We'll use this image on your website and in general when we want to make your appointment types look nice\n      ")])], 1)], 1) : _c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "absolute": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.showdialog = true
      }
    }
  }, [_vm._v("Choose one")]), _vm._v("\n    No background image"), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "hidden-xs-only",
    staticStyle: {
      "max-width": "80%"
    }
  }, [_vm._v("\n      We'll use this image on your website and in general when we want to make your appointment types look nice\n    ")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.showdialog),
      callback: function($$v) {
        _vm.showdialog = $$v
      },
      expression: "showdialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Choose a background picture")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showdialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('image-search', {
    attrs: {
      "title": "Search for an image"
    },
    on: {
      "close": function($event) {
        _vm.showdialog = false
      }
    },
    model: {
      value: (_vm.imgUrl),
      callback: function($$v) {
        _vm.imgUrl = $$v
      },
      expression: "imgUrl"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.errorMessages && _vm.errorMessages.length > 0) ? _c('v-alert', {
    staticClass: "pt-0 pb-1",
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_c('ul', _vm._l((_vm.errorMessages), function(err) {
    return _c('li', {
      key: err,
      domProps: {
        "textContent": _vm._s(err)
      }
    })
  }), 0)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [(_vm.appointment) ? _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.value
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.appointmentDetailRequest.loading || _vm.actionStatus.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "height": "2",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v("Create new")]), _vm._v(" "), _c('v-tab', [_vm._v("Choose an existing client")]), _vm._v(" "), (_vm.withDependent) ? _c('v-tab', [_vm._v("Dependency details")]) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n                Create a new client\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Full name",
      "hint": "The client's name and surname. e.g.: Jon Snow"
    },
    model: {
      value: (_vm.fullname),
      callback: function($$v) {
        _vm.fullname = $$v
      },
      expression: "fullname"
    }
  }), _vm._v(" "), _c('phone-number-input', {
    attrs: {
      "short-list": ["ZA"],
      "selected-country-code": "ZA"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "type": "email",
      "hint": "e-mail address. e.g.: jon@gmail.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.actionRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.set
    }
  }, [_vm._v("Create and assign")])], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n                Choose an existing client\n              ")]), _vm._v(" "), (!_vm.selectedclient) ? _c('client-list', {
    attrs: {
      "initial-text": _vm.fullname,
      "with-create": false,
      "with-action": false
    },
    on: {
      "relationshipselected": _vm.setSelected
    }
  }) : _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [(_vm.selectedclient) ? _c('client-list-item', {
    attrs: {
      "relationship-id": _vm.selectedclient.id,
      "client": _vm.selectedclient.client
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "action",
      "loading": _vm.actionRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.set
    },
    slot: "action"
  }, [_vm._v("\n                    Set client\n                  ")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedclient = null
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v("\n                  Choose a different user")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.dep
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('input', _vm.appointment)
      }
    }
  }), _vm._v(" "), _c('v-alert', {
    staticClass: "caption pa-1 ma-0",
    attrs: {
      "tile": "",
      "value": true,
      "type": "info"
    }
  }, [_vm._v("\n                You can set the patient information specifically for this appointment.\n                Use this if the patient is different from the contact person (e.g.: a dependant)\n                - this will only set the information on this appointment\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Appointment title"
    },
    model: {
      value: (_vm.appointment.title),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "title", $$v)
      },
      expression: "appointment.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Patient full name"
    },
    model: {
      value: (_vm.appointment.full_name),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "full_name", $$v)
      },
      expression: "appointment.full_name"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.dep.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveDependent
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "flat": ""
    }
  }, [_c('center', [_c('v-icon', {
    staticClass: "mt-4",
    attrs: {
      "color": "success",
      "size": "75"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote mb-4"
  }, [_vm._v("Appointment updated")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0;
        _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), (_vm.client && _vm.client.id) ? _c('v-toolbar', {
    attrs: {
      "color": _vm.themeColor,
      "dense": "",
      "dark": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("\n      " + _vm._s(_vm.userObject.first_name) + " " + _vm._s(_vm.userObject.last_name) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading",
    class: _vm.headingClasses
  }, [_c('v-text-field', {
    attrs: {
      "name": "appointment-title",
      "required": "",
      "rules": [function (v) { return !!v || 'Title is required'; }],
      "label": "Please choose a title for your note"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "outline": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.choosedate = true
      }
    }
  }, [_c('v-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v("\n      " + _vm._s(_vm.dateformat(_vm.noteDate)) + "\n    ")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "290"
    },
    model: {
      value: (_vm.choosedate),
      callback: function($$v) {
        _vm.choosedate = $$v
      },
      expression: "choosedate"
    }
  }, [_c('v-card', [_c('v-date-picker', {
    model: {
      value: (_vm.noteDate),
      callback: function($$v) {
        _vm.noteDate = $$v
      },
      expression: "noteDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (!_vm.isNewNote) ? _c('v-card-text', {
    attrs: {
      "row": ""
    }
  }, [_c('server-errors', {
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "box": "",
      "auto-grow": "",
      "name": "appointment-notes",
      "required": "",
      "append-icon": "notes",
      "label": "Optionally write more notes here",
      "multi-line": ""
    },
    on: {
      "click:append": _vm.addTemplate
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), (_vm.id && _vm.id > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('document-list', {
    attrs: {
      "note-id": _vm.id,
      "value": _vm.documents
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('space-picker', {
    attrs: {
      "label": "Share this note",
      "with-select": false,
      "attrs": {
        hint: _vm.sharingHint,
        persistentHint: true
      }
    },
    model: {
      value: (_vm.sharing),
      callback: function($$v) {
        _vm.sharing = $$v
      },
      expression: "sharing"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
    staticClass: "px-3"
  }, [(_vm.id) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = true
      }
    }
  }, [_vm._v("\n      Delete\n    ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "290"
    },
    model: {
      value: (_vm.confirmDelete),
      callback: function($$v) {
        _vm.confirmDelete = $$v
      },
      expression: "confirmDelete"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("Are you sure you want to delete this note?")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error",
      "loading": _vm.delRequest.loading
    },
    on: {
      "click": _vm.doDelete
    }
  }, [_vm._v("Yes. Delete it")])], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.dirty,
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !(_vm.dirty) || !(_vm.valid),
      "color": "primary",
      "loading": _vm.saveRequest.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.saveText) + "\n    ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.appointmentId) ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-avatar', {
    staticClass: "teal"
  }, [_c('v-icon', {
    attrs: {
      "color": "white darken-4",
      "small": ""
    }
  }, [_vm._v("event")])], 1), _vm._v("\n      " + _vm._s(_vm.appointment.title || _vm.appointment.full_name) + "\n      " + _vm._s(_vm.dateformat(_vm.appointment.start_time)) + "\n    ")], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('v-card-title', {
    staticClass: "overline my-0 py-0 grey lighten-3"
  }, [(_vm.practitioner) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.practitioner.full_name)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.space) ? _c('span', {
    staticClass: "ml-1"
  }, [_vm._v("@ " + _vm._s(_vm.space.title))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', _vm._l((_vm.dow), function(day, index) {
    return (_vm.hours) ? _c('v-card', {
      key: index,
      staticClass: "ma-3 elevation-4",
      attrs: {
        "tile": ""
      }
    }, [_c('v-card-title', {
      staticClass: "grey lighten-2 overline py-1 my-0"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('v-list', {
      staticClass: "elevation-0 pa-0",
      attrs: {
        "dense": ""
      }
    }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.getHours(index)), function(hrSet) {
      return (hrSet !== "" && _vm.hours[_vm.dowLookup[index]]) ? _c('v-list-tile', {
        key: hrSet
      }, [_c('v-list-tile-content', {
        on: {
          "click": function($event) {
            return _vm.setHours(_vm.dowLookup[index], hrSet)
          }
        }
      }, [_c('v-list-tile-title', [_c('v-icon', {
        staticClass: "mr-2"
      }, [_vm._v("edit")]), _vm._v(" " + _vm._s(hrSet) + "\n            ")], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteHours(_vm.dowLookup[index], hrSet)
          }
        }
      }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 1) : _c('v-list-tile', {
        key: index
      }, [_c('v-list-tile-content', [_vm._v("\n            Not available for appointments\n          ")])], 1)
    }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
      staticClass: "text-xs-right"
    }, [_c('v-btn', {
      attrs: {
        "flat": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.showAddHours(_vm.dowLookup[index])
        }
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v("Add hours")], 1)], 1)], 1)], 2)], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "auto-save",
      "dense": "",
      "small": ""
    },
    model: {
      value: (_vm.autosave),
      callback: function($$v) {
        _vm.autosave = $$v
      },
      expression: "autosave"
    }
  }), _vm._v(" "), (!_vm.autosave) ? _c('v-btn', {
    attrs: {
      "loading": _vm.servicesSaveHrsRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveHours
    }
  }, [_vm._v("Save")]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300px"
    },
    model: {
      value: (_vm.rangePickerDialog),
      callback: function($$v) {
        _vm.rangePickerDialog = $$v
      },
      expression: "rangePickerDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('time-range-picker', {
    attrs: {
      "min-start-time": _vm.minStartTime,
      "initial-start-time": _vm.activeStartTime,
      "initial-end-time": _vm.activeEndTime
    },
    model: {
      value: (_vm.activeRange),
      callback: function($$v) {
        _vm.activeRange = $$v
      },
      expression: "activeRange"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.rangePickerDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editmode) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.activeRange
    },
    on: {
      "click": function($event) {
        return _vm.editHours(_vm.activeDay, _vm.originalEditRange, _vm.activeRange)
      }
    }
  }, [_vm._v("Edit")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.activeRange
    },
    on: {
      "click": function($event) {
        return _vm.addHours(_vm.activeDay, _vm.activeRange)
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "grey lighten-4 ma-0 pa-0",
    attrs: {
      "dense": _vm.dense
    }
  }, [_c('practitioner-list-item', {
    attrs: {
      "item": _vm.selected
    },
    on: {
      "selected": function($event) {
        _vm.showmenu = false;
        _vm.showmenu = true
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function(props) {
        return [(props.fullname) ? _c('v-list-tile-title', [_vm._v(_vm._s(props.fullname))]) : _c('v-list-tile-title', [_vm._v("Choose a practitioner")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list-tile-action', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("expand_more")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showmenu),
      callback: function($$v) {
        _vm.showmenu = $$v
      },
      expression: "showmenu"
    }
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 my-0 grey lighten-2"
  }, [_vm._v("Pick a practitioner")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.practitioners), function(practitioner, index) {
    return _c('practitioner-list-item', {
      key: practitioner.id,
      class: {
        "blue lighten-5": _vm.isSelected(practitioner)
      },
      attrs: {
        "item": _vm.practitioners[index],
        "badge-color": "success",
        "badge-icon": _vm.getSelectedIcon(practitioner)
      },
      on: {
        "selected": _vm.setSelected
      }
    })
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.statementRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-0 pl-0 overline",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.statementRequest.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getStatement.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    " + _vm._s(_vm.$tc('appointmentsselected', _vm.numAppointments, {
    count: _vm.numAppointments
  })) + "\n    "), _c('v-spacer'), _vm._v(" "), (_vm.collapsed) ? _c('v-icon', [_vm._v("expand_more")]) : _c('v-icon', [_vm._v("expand_less")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [(!_vm.collapsed) ? [_vm._l((_vm.statementAppointments), function(appointment) {
    return [_c('appointment-list-item', {
      key: appointment.id,
      attrs: {
        "with-status-chips": "",
        "appointment": appointment,
        "with-action": false
      }
    }, [_c('template', {
      slot: "action"
    }, [(_vm.withEdit) ? _c('v-list-tile-action', [_c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('edit', appointment)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), (appointment.financials) ? _c('v-list-tile-action', {
      staticClass: "subheading"
    }, [_c('span', {
      staticClass: "mt-3"
    }, [_vm._v("\n                " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.final_due)) + "\n              ")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("Due")])], 1) : _vm._e()], 1)], 2), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (appointment.id))
    })]
  })] : _vm._e(), _vm._v(" "), (_vm.withTotals && _vm.totalDue !== null) ? [_c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline py-0 py-0"
  }, [_vm._v("Totals")]), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pb-5"
  }, [(_vm.totalDue > 0) ? _vm._t("list-tile") : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "subheading"
  }, [(_vm.appointmentPrice && parseFloat(_vm.appointmentPrice) > 0) ? _c('v-list-tile-action-text', [_vm._v("\n              appointments: " + _vm._s(_vm.formatCurrency(_vm.currency, _vm.appointmentPrice)) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.discounts && parseFloat(_vm.discounts) > 0) ? _c('v-list-tile-action-text', [_vm._v("\n              product sales: " + _vm._s(_vm.formatCurrency(_vm.currency, _vm.productSales)) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.discounts && parseFloat(_vm.discounts) > 0) ? _c('v-list-tile-action-text', [_vm._v("\n              discounts: " + _vm._s(_vm.formatCurrency(_vm.currency, _vm.discounts)) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.totalPaid && parseFloat(_vm.totalPaid) > 0) ? _c('v-list-tile-action-text', [_vm._v("\n              payments: " + _vm._s(_vm.formatCurrency(_vm.currency, _vm.totalPaid)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "mt-1"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.currency, _vm.totalDue)))]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("outstanding")])], 1)], 2), _vm._v(" "), _vm._t("list-end")] : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-autocomplete', _vm._b({
    attrs: {
      "chips": "",
      "dense": "",
      "small-chips": "",
      "deletable-chips": "",
      "clearable": "",
      "return-object": "",
      "multiple": _vm.multiple,
      "item-value": "id",
      "item-text": "text",
      "prepend-icon": "replay",
      "search-input": _vm.search,
      "label": _vm.label,
      "loading": _vm.request.loading,
      "persistent-hint": _vm.showHint,
      "hint": _vm.hintText,
      "items": _vm.formattedClients
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "click:prepend": _vm.fetch,
      "click:clear": _vm.clear,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, 'v-autocomplete', _vm.attrs, false)), _vm._v(" "), (_vm.formattedClients) ? _c('span', {
    staticClass: "ml-4 pl-2 caption"
  }, [_vm._v("\n    " + _vm._s(_vm.$tc('numresults', this.formattedClients.length, {
    count: this.formattedClients.length
  })))]) : _vm._e(), _vm._v(" "), (_vm.withQuickPick && _vm.multiple !== true && _vm.numClients > 0) ? _c('div', [_c('v-subheader', {
    staticClass: "pl-2 my-0 py-0 overline"
  }, [_vm._v("Quick pick")]), _vm._v(" "), _vm._l((_vm.formattedClients), function(cli) {
    return _c('v-chip', {
      key: cli.id,
      staticClass: "v-chip--x-small",
      staticStyle: {
        "min-width": "120px"
      },
      attrs: {
        "label": ""
      },
      on: {
        "click": function($event) {
          return _vm.setSelected(cli)
        }
      }
    }, [(_vm.selected && cli && _vm.selected.id === cli.id) ? _c('v-icon', {
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n      " + _vm._s(cli.first_name) + " " + _vm._s(cli.last_name) + "\n    ")], 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withAccreditation && _vm.result && _vm.result.data) ? _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "white--text caption pl-3 py-0 my-0"
  }, [_vm._v("Backgrounds by Unsplash.\n      "), _c('a', {
    staticClass: "grey--text",
    attrs: {
      "href": _vm.result.data.links.html + "?utm_source=AppointmentGuru&utm_medium=referral&utm_campaign=api-credit",
      "target": "_blank"
    }
  }, [_vm._v("image")]), _vm._v("\n        by\n      "), _c('a', {
    staticClass: "grey--text",
    attrs: {
      "href": _vm.result.data.user.links.html + "?utm_source=AppointmentGuru&utm_medium=referral&utm_campaign=api-credit",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.result.data.user.name))])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withEdit && !_vm.editOnly) ? [(_vm.displayMode == "view") ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "right": "",
      "absolute": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.displayMode = "edit"
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "right": "",
      "absolute": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.displayMode = "view"
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)] : _vm._e(), _vm._v(" "), (_vm.getRequest.loading) ? _c('tombstone') : [(_vm.displayMode == "view") ? [(_vm.client && _vm.client.client) ? _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": ""
    }
  }, [_c('h3', {
    staticClass: "subheading ml-3"
  }, [(_vm.client.client.custom_id) ? _c('span', [_vm._v("[" + _vm._s(_vm.client.client.custom_id) + "] ")]) : _vm._e(), _vm._v(" \n          " + _vm._s(_vm.client.client.first_name) + "\n          "), (_vm.client.client.nickname) ? _c('span', [_vm._v(" (" + _vm._s(_vm.client.client.nickname) + ") ")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.client.client.last_name) + "\n        ")]), _vm._v(" "), (_vm.client && _vm.client.client) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    },
    on: {
      "click": function($event) {
        return _vm.setMode("edit")
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Email address")]), _vm._v(" "), (_vm.isRealEmail(_vm.client.client.email)) ? _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": "mailto:" + _vm.client.client.email
    }
  }, [_vm._v("\n              " + _vm._s(_vm.client.client.email))])]) : _c('v-list-tile-sub-title', [_vm._v("\n              No email address\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.client && _vm.client.client) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    },
    on: {
      "click": function($event) {
        return _vm.setMode("edit")
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("sms")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Phone number")]), _vm._v(" "), (_vm.client.client.phone_number) ? _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": "tel:" + _vm.client.client.phone_number
    }
  }, [_vm._v("\n                " + _vm._s(_vm.client.client.phone_number))])]) : _c('v-list-tile-sub-title', [_vm._v("\n              No phone number\n            ")])], 1), _vm._v(" "), (_vm.client.client) ? _c('v-list-tile-action', [_c('whats-app-btn', {
    attrs: {
      "number": _vm.client.client.phone_number
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()] : [(_vm.client && _vm.client.client) ? _c('client-create', {
    attrs: {
      "relationshipId": _vm.relationshipId,
      "with-header": false,
      "context": _vm.client.context,
      "initial-client": _vm.client.client
    },
    on: {
      "client:updated": _vm.clientUpdated,
      "update:loading": _vm.updateLoading,
      "update:context": function($event) {
        return _vm.$set(_vm.client, "context", $event)
      }
    }
  }) : _vm._e()]]], 2)
},staticRenderFns: []}

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.client.id) ? _c('v-list-tile', {
    key: _vm.client.id,
    nativeOn: {
      "click": function($event) {
        return _vm.$emit("listitem:clicked", _vm.client)
      }
    }
  }, [_vm._t("avatar", function() {
    return [(_vm.withGravatar && _vm.client.email) ? _c('v-list-tile-avatar', [_c('v-avatar', [_c('img', {
      attrs: {
        "src": _vm.getGravatar(_vm.client.email)
      }
    })])], 1) : _vm._e()]
  }), _vm._v(" "), (_vm.withEdit && _vm.relationshipId) ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.launchCustomerDetailsDialog(_vm.relationshipId, true)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._t("after-before"), _vm._v(" "), _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('strong', [_vm._v("\n          " + _vm._s(_vm.fullName) + "\n          "), (hover) ? _c('small', {
          staticClass: "grey--text"
        }, [(_vm.client.custom_id) ? _c('span', [_vm._v("\n              / #" + _vm._s(_vm.client.custom_id) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.client.phone_number) ? _c('span', [_vm._v("\n              / " + _vm._s(_vm.client.phone_number) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isRealEmail(_vm.client.email)) ? _c('span', {
          attrs: {
            "span": ""
          }
        }, [_vm._v("\n              / " + _vm._s(_vm.client.email) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.relationshipId) ? _c('span', [_vm._v("\n              / # " + _vm._s(_vm.relationshipId) + "\n            ")]) : _vm._e()]) : _vm._e()])]
      }
    }], null, false, 2417675565)
  }), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _vm._t("subtitle", function() {
    return [(_vm.withDetails) ? _c('v-list-tile-sub-title', [(_vm.client.phone_number) ? _c('span', {
      attrs: {
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$emit("phoneClicked", _vm.client.phone_number)
        }
      }
    }, [_c('v-icon', {
      staticClass: "hidden-xs-only",
      attrs: {
        "small": ""
      }
    }, [_vm._v("phone")]), _vm._v("\n        " + _vm._s(_vm.client.phone_number) + "\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.isRealEmail(_vm.client.email)) ? _c('span', {
      attrs: {
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$emit("emailClicked", _vm.client.email)
        }
      }
    }, [_c('v-icon', {
      staticClass: "hidden-xs-only",
      attrs: {
        "small": ""
      }
    }, [_vm._v("mail")]), _vm._v(" " + _vm._s(_vm.client.email))], 1) : _vm._e()]) : _vm._e()]
  }), _vm._v(" "), _vm._t("extrasubtitle")], 2), _vm._v(" "), _vm._t("actions"), _vm._v(" "), _c('space-faces', {
    attrs: {
      "tooltip-prefix": "Shared with ",
      "space-ids": _vm.spaces,
      "size": 16
    }
  }), _vm._v(" "), (_vm.owner) ? _c('v-divider', {
    staticClass: "mx-2",
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.owner) ? _c('practitioner-faces', {
    attrs: {
      "tooltip-prefix": "Owned by ",
      "practitioner-ids": [_vm.owner],
      "size": 16
    }
  }) : _vm._e(), _vm._v(" "), (_vm.withWhatsApp) ? [_c('v-divider', {
    staticClass: "ml-3",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (_vm.client.phone_number) ? _c('whats-app-btn', {
    attrs: {
      "small": "",
      "number": _vm.client.phone_number,
      "classes": "mr-0"
    }
  }) : _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "disabled": "",
      "flat": "",
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("whatsapp")])], 1)] : _vm._e(), _vm._v(" "), (_vm.withAction) ? _c('v-list-tile-action', [_vm._t("action", function() {
    return [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit("listitem:goclicked", _vm.client)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("chevron_right")])], 1)]
  })], 2) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "width": "300"
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4 overline"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.practitionerIds.length > 0) ? [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("Practitioner")]), _vm._v(" "), _vm._l((this.facets.practitioner_id), function(count, practitionerId) {
    return _c('v-checkbox', {
      key: practitionerId,
      staticClass: "ma-0 pa-0 caption",
      attrs: {
        "dense": "",
        "hide-messages": "",
        "value": practitionerId,
        "label": _vm.getPractitionerLabel(practitionerId, count)
      },
      model: {
        value: (_vm.selectedPractitioners),
        callback: function($$v) {
          _vm.selectedPractitioners = $$v
        },
        expression: "selectedPractitioners"
      }
    })
  })] : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', {
    attrs: {
      "flat": _vm.flat,
      "dark": _vm.dark
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('title')) + "\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "error",
    on: {
      "click": function($event) {
        _vm.showDeleteDialog = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.delete')) + "\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        _vm.showRescheduleDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.reschedule')))])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('delete-recurring-appointment-form', {
    on: {
      "close": function($event) {
        _vm.showDeleteDialog = false
      }
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showRescheduleDialog),
      callback: function($$v) {
        _vm.showRescheduleDialog = $$v
      },
      expression: "showRescheduleDialog"
    }
  }, [_c('reschedule-recurring-appointment-form', {
    on: {
      "close": function($event) {
        _vm.showRescheduleDialog = false
      }
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withTitle && _vm.person && _vm.person.id) ? [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("\n      Editing " + _vm._s(_vm.person.first_name) + " " + _vm._s(_vm.person.last_name) + "\n      "), _c('v-spacer')], 1)] : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('object-form', {
    attrs: {
      "errors": _vm.errors,
      "fields": _vm.fields
    },
    model: {
      value: (_vm.person),
      callback: function($$v) {
        _vm.person = $$v
      },
      expression: "person"
    }
  }, [_c('v-flex', {
    attrs: {
      "slot": "title",
      "xs12": ""
    },
    slot: "title"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.titles,
      "outline": _vm.hasErrors('title'),
      "error-messages": _vm.getErrors('title'),
      "label": "title"
    },
    model: {
      value: (_vm.person.title),
      callback: function($$v) {
        _vm.$set(_vm.person, "title", $$v)
      },
      expression: "person.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "slot": "email",
      "xs12": ""
    },
    slot: "email"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email address",
      "hint": "Please provide a valid email address",
      "outline": _vm.hasErrors('email'),
      "error-messages": _vm.getErrors('email'),
      "type": "email"
    },
    model: {
      value: (_vm.person.email),
      callback: function($$v) {
        _vm.$set(_vm.person, "email", $$v)
      },
      expression: "person.email"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "date_of_birth"
  }, [_c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "readonly": "",
      "append-icon": "event",
      "outline": _vm.hasErrors('date_of_birth'),
      "hint": _vm.birthdayHint,
      "error-messages": _vm.getErrors('date_of_birth'),
      "label": "date of birth"
    },
    on: {
      "click": function($event) {
        _vm.showBdayPicker = true
      },
      "click:append": function($event) {
        _vm.showBdayPicker = true
      }
    },
    model: {
      value: (_vm.person.date_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.person, "date_of_birth", $$v)
      },
      expression: "person.date_of_birth"
    }
  }), _vm._v(" "), _c('v-dialog', {
    staticClass: "text-xs-center",
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.showBdayPicker),
      callback: function($$v) {
        _vm.showBdayPicker = $$v
      },
      expression: "showBdayPicker"
    }
  }, [_c('birthday-picker', {
    on: {
      "close": function($event) {
        _vm.showBdayPicker = false
      }
    },
    model: {
      value: (_vm.person.date_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.person, "date_of_birth", $$v)
      },
      expression: "person.date_of_birth"
    }
  })], 1)], 1), _vm._v(" "), _c('phone-number-input', {
    attrs: {
      "slot": "cell_phone",
      "verbose": false
    },
    slot: "cell_phone",
    model: {
      value: (_vm.person.cell_phone),
      callback: function($$v) {
        _vm.$set(_vm.person, "cell_phone", $$v)
      },
      expression: "person.cell_phone"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "slot": "billing_address",
      "box": "",
      "persistent-hint": "",
      "hint": "We'll use this address on invoices",
      "label": "Billing address"
    },
    slot: "billing_address",
    model: {
      value: (_vm.person.billing_address),
      callback: function($$v) {
        _vm.$set(_vm.person, "billing_address", $$v)
      },
      expression: "person.billing_address"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "slot": "notes",
      "box": "",
      "persistent-hint": "",
      "hint": "Add any interesting information about the user here. For example, you might note who referred them, if they are related to another patient etc.",
      "label": "Bio"
    },
    slot: "notes",
    model: {
      value: (_vm.person.notes),
      callback: function($$v) {
        _vm.$set(_vm.person, "notes", $$v)
      },
      expression: "person.notes"
    }
  })], 2), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center mt-3"
  }, [(_vm.showAllFields === false) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showAllFields = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.showmore')) + "\n          ")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showAllFields = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.showless')) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), (_vm.withSearch) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('person-list', {
    attrs: {
      "with-edit": false
    }
  })], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.req,
      "message200": false
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.savereq,
      "message200": "Codes have been added"
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    Copy codes from other appointments\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.selectedIds && _vm.selectedIds.length > 0) ? _c('v-card', [_c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4"
  }, [_vm._v("\n        Codes to add\n        "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), [_vm._l((_vm.selectedItems), function(code) {
    return _c('v-card', {
      key: code.id,
      staticClass: "ml-3",
      attrs: {
        "flat": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, _vm._l((_vm.headers), function(field) {
      return _c('v-flex', {
        key: field.value
      }, [(field.value === "price") ? [_vm._v("\n                " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n              ")] : [_vm._v("\n                " + _vm._s(code[field.value]) + "\n              ")]], 2)
    }), 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (code.id))
    })], 1)
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-2 caption mt-0",
    attrs: {
      "dense": "",
      "persistent-hint": "",
      "label": "Clear existing codes",
      "hint": "Will remove any codes currently on this appointment - replacing them with the copied codes"
    },
    model: {
      value: (_vm.withClear),
      callback: function($$v) {
        _vm.withClear = $$v
      },
      expression: "withClear"
    }
  })], _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("reset")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "loading": _vm.savereq.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Choose codes from previous appointments")]), _vm._v(" "), (!_vm.req.loading && _vm.appointments && _vm.appointments.length === 0) ? [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Couldn't find any other appointments with codes added for this client")])] : _vm._e(), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.appointments), function(appt) {
    return _c('v-expansion-panel-content', {
      key: appt.id,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_vm._v("\n          " + _vm._s(appt.title) + ". " + _vm._s(_vm.dateformat(appt.start_time)) + "\n          "), _c('v-spacer')]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (appt && appt.codes) ? _vm._l((appt.codes), function(code) {
      return _c('v-card', {
        key: code.id,
        staticClass: "ml-3",
        on: {
          "click": function($event) {
            return _vm.toggleCode(code)
          }
        }
      }, [_c('v-layout', {
        attrs: {
          "row": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs1": ""
        }
      }, [(_vm.selectedIds.indexOf(code.id) === -1) ? _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("check_box_outline_blank")]) : _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("check_box_outline")])], 1), _vm._v(" "), _vm._l((_vm.headers), function(field) {
        return _c('v-flex', {
          key: field.value
        }, [(field.value === "price") ? [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n                ")] : [_vm._v("\n                  " + _vm._s(code[field.value]) + "\n                ")]], 2)
      })], 2), _vm._v(" "), _c('v-divider', {
        key: ("div-" + (code.id)),
        staticClass: "mb-2"
      })], 1)
    }) : _vm._e()], 2)
  }), 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "right": "",
      "close-on-click": true,
      "close-on-content-click": false,
      "transition": "slide-x-transition"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("filter_list")])], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "min-width": 280,
      "max-width": 280,
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading py-0"
  }, [_vm._v("\n        Filter results\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Date Range")]), _vm._v(" "), _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.fromModal),
      callback: function($$v) {
        _vm.fromModal = $$v
      },
      expression: "fromModal"
    }
  }, [_c('v-text-field', {
    staticClass: "px-3 py-0 mb-0",
    attrs: {
      "slot": "activator",
      "label": "Start date",
      "prepend-icon": "event",
      "clearable": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "max": _vm.toDate
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.toModal),
      callback: function($$v) {
        _vm.toModal = $$v
      },
      expression: "toModal"
    }
  }, [_c('v-text-field', {
    staticClass: "px-3 py-0 mb-0",
    attrs: {
      "slot": "activator",
      "label": "End date",
      "prepend-icon": "event",
      "clearable": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.fromDate
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', [_vm._v("Appointment Status")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-2",
    attrs: {
      "label": "Show all statuses"
    },
    model: {
      value: (_vm.showAllStatuses),
      callback: function($$v) {
        _vm.showAllStatuses = $$v
      },
      expression: "showAllStatuses"
    }
  }), _vm._v(" "), (!_vm.showAllStatuses) ? _c('v-list', {
    attrs: {
      "transition": "slide-y-transition"
    }
  }, _vm._l((_vm.statuses), function(status, index) {
    return _c('v-list-tile', {
      key: status.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedStatusIds),
        expression: "selectedStatusIds"
      }],
      staticClass: "mr-2",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": index,
        "checked": Array.isArray(_vm.selectedStatusIds) ? _vm._i(_vm.selectedStatusIds, index) > -1 : (_vm.selectedStatusIds)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedStatusIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = index,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedStatusIds = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedStatusIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedStatusIds = $$c
          }
        }
      }
    }), _vm._v("\n                    " + _vm._s(status.title) + "\n                ")])])], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.filtersAsSentence) + "\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.emitFilters
    }
  }, [_vm._v(" Apply filters")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs,
      "max-width": "600px"
    },
    model: {
      value: (_vm.bottomsheet),
      callback: function($$v) {
        _vm.bottomsheet = $$v
      },
      expression: "bottomsheet"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline py-0 grey lighten-2"
  }, [(_vm.activeWindow === 1) ? _c('v-btn', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")])], 1) : _vm._e(), _vm._v("\n        Choose an appointment type\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.bottomsheet = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "dark": ""
    }
  }, [(_vm.practitioner) ? _c('practitioner-list-item', {
    attrs: {
      "item": _vm.practitioner
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeWindow > 0) ? _c('v-footer', {
    staticClass: "pl-4"
  }, [_vm._v(_vm._s(_vm.selectedService.title))]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.activeWindow),
      callback: function($$v) {
        _vm.activeWindow = $$v
      },
      expression: "activeWindow"
    }
  }, [_c('v-window-item', {
    key: 0
  }, [_c('v-card', {
    staticClass: "rounded",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "rounded",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.spaces), function(service, index) {
    return [_c('v-list-tile', {
      key: (index + "-" + (service.id)),
      staticClass: "grey lighten-2 py-1 mt-4 elevation-5",
      class: ['staticClass', service.collapsed ? 'rounded' : 'rounded-collapsed'],
      on: {
        "click": function($event) {
          return _vm.toggleService(service)
        }
      }
    }, [(_vm.spaces && _vm.spaces.length > 1) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [(service.collapsed === true) ? _c('v-icon', [_vm._v("expand_more")]) : _c('v-icon', [_vm._v("expand_less")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-avatar', [(service.logo_picture) ? _c('v-img', {
      attrs: {
        "src": service.logo_picture
      }
    }) : _c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("star_outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(service.title)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [(service.locations && service.locations.length === 1) ? _c('span', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("location_on")]), _vm._v("\n                          " + _vm._s(service.locations[0].name) + "\n                        ")], 1) : _vm._e(), _vm._v(" "), (service.role) ? _c('v-chip', {
      staticClass: "v-chip--x-small ml-0",
      attrs: {
        "color": _vm.roleColor(service.role),
        "dark": "",
        "outline": ""
      }
    }, [_vm._v("\n                          " + _vm._s(service.role) + "\n                        ")]) : _vm._e(), _vm._v(" "), (service.members && service.members.length > 1) ? _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', _vm._g({
            staticClass: "v-chip--x-small ml-0",
            attrs: {
              "color": "info",
              "dark": "",
              "outline": ""
            }
          }, on), [_vm._v("\n                              shared space\n                            ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("All members of this space will be able to see this appointment")])]) : _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', _vm._g({
            staticClass: "v-chip--x-small ml-0",
            attrs: {
              "color": "info",
              "dark": "",
              "outline": ""
            }
          }, on), [_vm._v("\n                              Private\n                            ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("You are currently the only member of this space")])])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "mr-5"
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": "",
              "href": ("" + (_vm.LINKS.SETTINGS_SPACES) + (service.id)),
              "disabled": !_vm.canManageSpace(service),
              "target": "_blank"
            }
          }, on), [_c('v-icon', [_vm._v("open_in_new")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Manage this space")])])], 1), _vm._v(" "), (_vm.canAddProduct(service)) ? _c('v-btn', {
      attrs: {
        "small": "",
        "fab": "",
        "top": "",
        "right": "",
        "absolute": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.selectedService = service;
          _vm.activeWindow = 1
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("add")])], 1) : _vm._e()], 1), _vm._v(" "), (!service.collapsed) ? _c('v-divider', {
      key: ("div-" + (service.id))
    }) : _vm._e(), _vm._v(" "), (service.collapsed !== true) ? [(service.locations && service.locations.length <= 1) ? _c('v-card', {
      key: ("noloc-" + (service.id))
    }, [_vm._l((_vm.getProducts(_vm.practitioner.id, service.id, null)), function(product, index) {
      return [(product.archived !== true) ? _c('v-list-tile', {
        key: ("p-" + (product.id) + "-" + (service.id) + "-noloc-" + index),
        on: {
          "click": function($event) {
            return _vm.setSelected(service, service.locations, product.id)
          }
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
        domProps: {
          "textContent": _vm._s(product.title)
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
        key: ("div-" + (product.id) + "-noloc-" + (service.id) + "-" + (_vm.practitioner.id) + "-" + index)
      })]
    }), _vm._v(" "), (service.locations.length === 0) ? _c('v-card-actions', [_c('span', {
      staticClass: "ml-2"
    }, [_vm._v("No locations defined.")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.canAddProduct(service)) ? _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.gotoLocation(service)
        }
      }
    }, [_vm._v("Create one?")]) : _vm._e()], 1) : [(_vm.getProducts(_vm.practitioner.id, service.id, null).length === 0) ? _c('v-card-actions', [_c('span', {
      staticClass: "ml-2"
    }, [_vm._v("No appointment types defined.")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.canAddProduct(service)) ? _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedService = service;
          _vm.activeWindow = 1
        }
      }
    }, [_vm._v("Create one?")]) : _vm._e()], 1) : _vm._e()]], 2) : _vm._l((service.locations), function(location) {
      return _c('v-card', {
        key: ((service.id) + "-" + (location.id))
      }, [_c('v-card-title', {
        key: ("loc-" + (location.id)),
        staticClass: "pl-0 py-0 grey lighten-5",
        on: {
          "click": function($event) {
            return _vm.togglelocation(location)
          }
        }
      }, [(service.locations.length > 1) ? _c('v-btn', {
        attrs: {
          "icon": "",
          "small": ""
        }
      }, [(location.collapsed === true) ? _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("expand_more")]) : _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("expand_less")])], 1) : _vm._e(), _vm._v(" "), _c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v("location_on")]), _vm._v(" "), _c('strong', {
        staticClass: "overline",
        domProps: {
          "textContent": _vm._s(location.name)
        }
      }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (location.collapsed === true) ? _c('v-chip', {
        staticClass: "caption",
        attrs: {
          "outline": "",
          "small": "",
          "color": "primary"
        }
      }, [_vm._v("\n                            " + _vm._s(_vm.getProducts(_vm.practitioner.id, service.id, location.id).length) + "\n                          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (location.collapsed !== true) ? [_vm._l((_vm.getProducts(_vm.practitioner.id, service.id, location.id)), function(product, index) {
        return [(product.archived !== true) ? _c('v-list-tile', {
          key: ("p-" + (product.id) + "-" + (service.id) + "-" + (location.id) + "-" + index),
          on: {
            "click": function($event) {
              return _vm.setSelected(service, location, product.id)
            }
          }
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "textContent": _vm._s(product.title)
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
          key: ("div-" + (product.id) + "-" + (location.id) + "-" + (service.id) + "-" + (_vm.practitioner.id) + "-" + index)
        })]
      }), _vm._v(" "), (_vm.getProducts(_vm.practitioner.id, service.id, location.id).length === 0) ? _c('v-card-actions', [_c('span', {
        staticClass: "ml-2"
      }, [_vm._v("No appointment types defined.")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.canAddProduct(service)) ? _c('v-btn', {
        attrs: {
          "small": "",
          "flat": ""
        },
        on: {
          "click": function($event) {
            _vm.selectedService = service;
            _vm.activeWindow = 1
          }
        }
      }, [_vm._v("Create one?")]) : _vm._e()], 1) : _vm._e()] : _vm._e()], 2)
    })] : _vm._e(), _vm._v(" "), (service.collapsed !== true) ? _c('v-footer', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "pa-1",
      attrs: {
        "small": "",
        "outline": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.selectedService = service;
          _vm.activeWindow = "location"
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("add")]), _vm._v(" New location\n                    ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = "space"
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v(" New space\n                ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.bottomsheet = false
      }
    }
  }, [_vm._v("\n                  cancel\n                ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.getMeReq.loading,
      "small": "",
      "outline": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")]), _vm._v(" Refresh\n                ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', {
    key: 1
  }, [_c('request-status', {
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), _c('appointment-type', {
    attrs: {
      "practitioner": _vm.practitioner,
      "service": _vm.selectedService,
      "withTitle": false,
      "withCancel": true,
      "loading": _vm.saveRequest.loading
    },
    on: {
      "cancel": function($event) {
        _vm.activeWindow = 0
      },
      "save": _vm.addProduct,
      "add:location": function($event) {
        return _vm.gotoLocation(_vm.selectedService)
      }
    }
  })], 1), _vm._v(" "), _c('v-window-item', {
    key: 2,
    staticClass: "text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "size": 72,
      "color": "success"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('h3', {
    staticClass: "subheading mb-4"
  }, [_vm._v("Product added")]), _vm._v(" "), (_vm.globalInitRequestLoading) ? [_c('v-progress-circular', {
    staticClass: "pb-4",
    attrs: {
      "indeterminate": "",
      "color": "amber"
    }
  }), _vm._v(" Updating profile\n            ")] : _vm._e(), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "rounded px-5 mt-4",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = 0
      }
    }
  }, [_vm._v("Done")])], 1)], 2), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": "space"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_back")])], 1), _vm._v("\n                Add a new space\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.LINKS.SETTINGS_SPACES,
      "small": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n                  Manage spaces\n                  "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('space-wizard', {
    on: {
      "cancel": function($event) {
        _vm.activeWindow = 0
      },
      "success": _vm.spaceCreated
    }
  })], 1)], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": "location"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_back")])], 1), _vm._v("\n                Add a new location\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": ((_vm.LINKS.SETTINGS_SPACES) + "--/locations"),
      "small": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n                  Manage locations\n                  "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), (_vm.selectedService && _vm.selectedService.id) ? _c('location-wizard', {
    attrs: {
      "space-id": _vm.selectedService.id,
      "space": _vm.selectedService,
      "success-steps": _vm.locationSuccessSteps,
      "touch": _vm.touchLocation
    },
    on: {
      "cancel": function($event) {
        _vm.activeWindow = 0
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": "flat"
    }
  }, [(_vm.withClientName) ? _c('v-toolbar', {
    staticClass: "subheading py-2",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("account_circle")]), _vm._v("\n    " + _vm._s(_vm.formatFullName(_vm.client)) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.withClientName) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.request.loading) ? _c('v-progress-linear', {
    staticClass: "mt-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.client && _vm.client.id) ? _c('v-list', [_c('v-subheader', {
    staticClass: "overline"
  }, [(!_vm.withClientName) ? _c('v-btn', {
    staticClass: "pl-0",
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1) : _vm._e(), _vm._v("\n      Contact information\n      "), _c('v-spacer'), _vm._v(" "), (_vm.relationshipId) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchCustomerDetailsDialog(_vm.relationshipId, true)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("phone")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.client.phone_number) ? _c('v-list-tile-title', [_vm._v(_vm._s(_vm.client.phone_number))]) : _c('v-list-tile-title', [_vm._v("No phone number")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Contact number")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.isRealEmail(_vm.client.email)) ? _c('v-list-tile-title', [_vm._v(_vm._s(_vm.client.email))]) : _c('v-list-tile-title', [_vm._v("No e-mail address")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("E-mail address")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.record && _vm.record.id) ? _c('v-list', {
    attrs: {
      "three-line": "",
      "dense": "",
      "subheader": ""
    }
  }, [(_vm.record.medical_aid) ? [_c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Medical aid details\n        "), _c('v-spacer'), _vm._v(" "), (_vm.relationshipId) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchCustomerDetailsDialog(_vm.relationshipId, true, 1)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.record.medical_aid.name || 'n/a'))]), _vm._v(" "), (_vm.record.medical_aid.scheme) ? _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_vm._v("\n            " + _vm._s(_vm.record.medical_aid.scheme) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("# " + _vm._s(_vm.record.medical_aid.number || 'no membership number'))])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "overline"
  }, [_vm._v("Patient")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "text--primary"
  }, [_vm._v("\n            " + _vm._s(_vm.record.medical_aid.patient_first_name) + " " + _vm._s(_vm.record.medical_aid.patient_last_name) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("ID: " + _vm._s(_vm.record.medical_aid.patient_id_number || 'unknown'))])], 1)], 1), _vm._v(" "), (_vm.record.medical_aid.is_dependent === true) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "overline"
  }, [_vm._v("Main member")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_vm._v(_vm._s(_vm.record.medical_aid.member_first_name) + " " + _vm._s(_vm.record.medical_aid.member_last_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("ID: " + _vm._s(_vm.record.medical_aid.member_id_number || 'unknown'))])], 1)], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n      Invoice information\n      "), _c('v-spacer'), _vm._v(" "), (_vm.relationshipId) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchCustomerDetailsDialog(_vm.relationshipId, true, 2)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.record.patient) ? [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Billing address")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_c('pre', {
    staticStyle: {
      "font-family": "Roboto,sans-serif"
    }
  }, [_vm._v(_vm._s(_vm.record.patient.billing_address || 'Unknown. We\'ll use contact details above') + "\n            ")])])], 1)], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-alert', {
    staticClass: "mb-0",
    attrs: {
      "type": "warning",
      "value": _vm.request.status > 299
    }
  }, [_vm._v("\n    Unable to load client record\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_vm._v("Try again")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1 overline grey darken-4 text white--text"
  }, [_vm._v("\n    Please confirm:\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dark": "",
      "three-line": ""
    }
  }, [(_vm.appointment) ? _c('v-list-tile', [(_vm.profilePicture) ? _c('v-list-tile-avatar', [_c('v-img', {
    attrs: {
      "src": _vm.profilePicture
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [(_vm.appointment.title) ? _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relationship) ? _c('v-list-tile-title', [_vm._v("\n          " + _vm._s(_vm.formatFullName(_vm.relationship)) + "\n          "), (_vm.practitioner) ? _c('small', [_vm._v("with " + _vm._s(_vm.formatFullName(_vm.practitioner)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.appointment.product) ? [_vm._v(_vm._s(_vm.appointment.product.title))] : _vm._e(), _vm._v(" "), (_vm.appointment.service) ? [_vm._v("@ " + _vm._s(_vm.appointment.service.title))] : _vm._e()], 2), _vm._v(" "), _c('v-list-tile-sub-title', [_c('strong', [_vm._v(_vm._s(_vm.dateformat(_vm.appointment.day)) + ".")]), _vm._v("\n          " + _vm._s(_vm.appointment.start_time) + " - " + _vm._s(_vm.appointment.end_time) + "\n        ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-tile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.relationship && _vm.relationship.id),
      expression: "relationship && relationship.id"
    }],
    on: {
      "click": function($event) {
        _vm.confirmOptions.create_process = !_vm.confirmOptions.create_process
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-checkbox', {
    attrs: {
      "disabled": !_vm.hasContacts
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.confirmOptions.create_process),
      callback: function($$v) {
        _vm.$set(_vm.confirmOptions, "create_process", $$v)
      },
      expression: "confirmOptions.create_process"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            Send notifications\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Send confirmation and reminders to\n            "), (_vm.appointment.client) ? _c('span', [_vm._v(" " + _vm._s(_vm.formatFullName(_vm.relationship)))]) : _c('span', [_vm._v("client")])]), _vm._v(" "), _c('v-list-tile-sub-title', [(!_vm.hasContacts) ? [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No contact info\n              ")], 1)] : [(_vm.clientPhoneNumber) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.clientPhoneNumber) + "\n                ")]) : _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No phone no.\n              ")], 1), _vm._v(" "), (_vm.clientEmail) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.clientEmail) + "\n                ")]) : _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No email\n              ")], 1)]], 2), _vm._v(" "), (_vm.isInPast && _vm.confirmOptions.create_process) ? _c('v-list-tile-sub-title', {
    staticClass: "amber px-2 caption"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Note, you've opted to send notifications, but this appointment is in the past. Are you sure?\n          ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.editClient
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.confirmOptions.create_process) ? _c('v-icon', [_vm._v("notifications_on")]) : _c('v-icon', [_vm._v("notifications_off")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-checkbox', {
    model: {
      value: (_vm.confirmOptions.recurring),
      callback: function($$v) {
        _vm.$set(_vm.confirmOptions, "recurring", $$v)
      },
      expression: "confirmOptions.recurring"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            Make this appointment repeat\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Check to configure how this appointment should recur\n          ")])], 1)], 1), _vm._v(" "), (_vm.confirmOptions.recurring) ? _c('v-list-tile', [_c('v-list-tile-content', {
    staticClass: "ml-3"
  }, [_c('v-list-tile-title', {
    staticStyle: {
      "height": "32px"
    }
  }, [_vm._v("\n            Repeat\n            "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmOptions.recurrance.count--
      }
    }
  }, [_c('v-icon', [_vm._v("remove_circle")])], 1), _vm._v("\n            " + _vm._s(_vm.confirmOptions.recurrance.count) + "\n            "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmOptions.recurrance.count++
      }
    }
  }, [_c('v-icon', [_vm._v("add_circle")])], 1), _vm._v("\n            times\n          ")], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-dialog', {
    attrs: {
      "lazy": ""
    },
    model: {
      value: (_vm.recurranceIntervalPicker),
      callback: function($$v) {
        _vm.recurranceIntervalPicker = $$v
      },
      expression: "recurranceIntervalPicker"
    }
  }, [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "slot": "activator",
      "small": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("expand_more")]), _vm._v("\n              " + _vm._s(_vm.confirmOptions.recurrance.interval) + "\n            ")], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Choose an interval rate")]), _vm._v(" "), _vm._l((_vm.recurranceItems), function(item) {
    return _c('v-list-tile', {
      key: item,
      on: {
        "click": function($event) {
          _vm.confirmOptions.recurrance.interval = item;
          _vm.recurranceIntervalPicker = false
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item))])], 1)], 1)
  })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [(_vm.confirmOptions.recurring) ? _c('v-list-tile-sub-title', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n              This will create " + _vm._s(_vm.confirmOptions.recurrance.count) + " appointments\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.confirmOptions.create_process) ? [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("notifications_on")]), _vm._v("\n                We will send a confirmation to the client now, and a reminder one day before the appointment\n              ")] : _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("notifications_off")]), _vm._v(" No notifications will be sent\n              ")], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "block": "",
      "large": "",
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("confirm", _vm.confirmOptions)
      }
    }
  }, [_vm._v("Create")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('client-list', {
    attrs: {
      "show-list-initially": false,
      "with-action": false,
      "with-create": false
    },
    on: {
      "relationshipselected": _vm.setRelationship
    },
    model: {
      value: (_vm.recipient),
      callback: function($$v) {
        _vm.recipient = $$v
      },
      expression: "recipient"
    }
  }), _vm._v(" "), (_vm.recipient) ? [(_vm.recipient.phone_number) ? _c('v-chip', {
    staticClass: "v-chip--x-small ml-2",
    attrs: {
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 0
      }
    }
  }, [_vm._v(_vm._s(_vm.recipient.phone_number))]) : _vm._e(), _vm._v(" "), (_vm.recipient.email) ? _c('v-chip', {
    staticClass: "v-chip--x-small ml-2",
    attrs: {
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.recipient.email))]) : _vm._e(), _vm._v(" "), (_vm.recipientId) ? _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    attrs: {
      "disabled": !_vm.recipient.phone_number
    }
  }, [_vm._v("Short message")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "disabled": !_vm.recipient.email
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-textarea', {
    attrs: {
      "box": "",
      "label": "short message",
      "counter": "140"
    },
    model: {
      value: (_vm.shortMessage),
      callback: function($$v) {
        _vm.shortMessage = $$v
      },
      expression: "shortMessage"
    }
  })], 1), _vm._v(" "), _c('v-tab-item', [_c('v-text-field', {
    attrs: {
      "label": "subject"
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "label": "message"
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value === 100) ? _c('v-progress-circular', {
    attrs: {
      "color": "success",
      "width": "3",
      "size": "26",
      "value": _vm.value
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")])], 1) : (_vm.value === 0) ? _c('v-icon', {
    attrs: {
      "color": "error"
    }
  }, [_vm._v("warning")]) : _c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "width": "3",
      "size": "26",
      "value": _vm.value
    }
  }, [_vm._v("\n  " + _vm._s(_vm.percent) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('title')) + "\n  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.me) ? _c('v-card-text', [_c('blockquote', {
    staticClass: "blockquote pl-0 pt-0"
  }, [_vm._v(_vm._s(_vm.$t('subtitle')) + "\n    ")]), _vm._v(" "), _c('h4', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('link.overline')))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "file_copy",
      "value": _vm.referralLink,
      "hint": _vm.copyLinkText,
      "persistent-hint": true,
      "box": ""
    },
    on: {
      "click:append": _vm.copyToClipboard
    }
  }), _vm._v(" "), (_vm.loadingFunnel) ? _c('v-progress-linear', {
    attrs: {
      "height": 2,
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.funnel) ? [_c('h4', {
    staticClass: "overline mt-4"
  }, [_vm._v(_vm._s(_vm.$t('stats.title')))]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "metric"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('subtitles.referred')) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.funnel.total) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "metric"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('subtitles.ontrial')) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.funnel.referred) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "metric"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('subtitles.converted')) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.funnel.converted) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "metric"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('subtitles.creditbalance')) + "\n              "), _c('v-spacer'), _vm._v(" "), _c('help-popover', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('credits.helptext')) + "\n              ")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.formatnumber(_vm.credits.available, true)) + "\n            ")])], 1)], 1)], 1)] : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "login-box elevation-23 bg"
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "indeterminate": true,
      "height": 3
    }
  }), _vm._v(" "), _c('v-card-title', [_c('img', {
    staticClass: "login-header",
    attrs: {
      "width": "330",
      "height": "80",
      "src": "https://s3.eu-central-1.amazonaws.com/static.appointmentguru.co/images/logo.png"
    }
  })]), _vm._v(" "), (_vm.requests.start.status !== 401) ? _c('request-status', {
    attrs: {
      "request": _vm.requests.start,
      "message200": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status !== _vm.states.LOGIN) ? _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "color": "amber",
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "headline mt-4"
  }, [_vm._v(_vm._s(_vm.statusMessage))]), _vm._v(" "), (_vm.requests.start.status === 500) ? _c('v-card-actions', {
    staticStyle: {
      "background-color": "white",
      "border-top": "solid 1px #ccc"
    }
  }, [_vm._v("\n      Login request failed. Try again?\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.start.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Retry")])], 1) : _vm._e()], 1) : _c('v-card-text', [_c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('request-status', {
    attrs: {
      "request": _vm.requests.login,
      "message200": false,
      "message401": "Authentication failed. Invalid username or password"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "name": "id-username",
      "id": "id-username",
      "label": "Your e-mail address",
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "name": "id-password",
      "type": "password",
      "label": "Password",
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "background-color": "white",
      "border-top": "solid 1px #ccc"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.prepareLinkPage
    }
  }, [_vm._v("Send me a login link")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('request-status', {
    attrs: {
      "request": _vm.requests.requestOTP
    }
  }), _vm._v(" "), (_vm.requests.login.status === 401) ? _c('v-alert', {
    attrs: {
      "value": true
    }
  }, [_vm._v("\n          The code you entered is incorrect or has expired\n        ")]) : _vm._e(), _vm._v(" "), (_vm.requests.requestOTP.status != 200) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "name": "id-email",
      "id": "id-email",
      "type": "email",
      "label": "Your e-mail address",
      "hint": "If you have an account, we will send an code to this email which you can enter below",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "color": "primary",
      "disabled": !_vm.email
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("Send code")])], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "name": "id-code",
      "id": "id-code",
      "label": "Type your code in here",
      "hint": "We sent it to your email address. Check your SPAM folder if you can't see it",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("Resend code")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.step === 1) ? _c('v-card-actions', {
    staticStyle: {
      "background-color": "white",
      "border-top": "solid 1px #ccc"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 0
      }
    }
  }, [_vm._v("Back to login")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.code.length != 4,
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Verify")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-wrapper",
    style: ({
      'height': this.height
    })
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-item"
  }, [_c('div', {
    staticClass: "animated-background"
  }, [_c('div', {
    staticClass: "background-masker header-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-first-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-second-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-second-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-third-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-third-end"
  })])])
}]}

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.treatmentLogsRequest.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    " + _vm._s(_vm.$t('logs.title')) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "outline": "",
      "outlined": "",
      "small": "",
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.touchers.editform++;
        _vm.selectedLog = {};
        _vm.dialogs.add = true;
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('buttons.add')) + "\n    ")], 1)], 1), _vm._v(" "), (_vm.treatmentLogs && _vm.treatmentLogs.length > 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [(_vm.changeLogsRequest.loading) ? _c('v-progress-linear', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "indeterminate": "",
      "height": 3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.treatmentLogsRequest.loading) ? _c('v-progress-linear', {
    staticClass: "pa-0 pa-0",
    attrs: {
      "indeterminate": "",
      "height": 3
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.treatmentLogs), function(log, index) {
    return [(_vm.isNewPractitioner(log, index, _vm.treatmentLogs)) ? [_c('v-subheader', {
      staticClass: "grey lighten-4 overline"
    }, [_vm._v("\n              " + _vm._s(_vm.getPractitionerById(log.practitioner).full_name) + "\n          ")]), _vm._v(" "), _c('v-divider')] : _vm._e(), _vm._v(" "), _c('treatment-log-list-item', {
      key: log.id,
      attrs: {
        "item": log
      },
      on: {
        "selected": function($event) {
          _vm.selectedLog = log;
          _vm.dialogs.add = true
        },
        "clicked:delete": _vm.dodelete
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.treatmentLogs && _vm.treatmentLogs.length === 0 && !_vm.treatmentLogsRequest.loading) ? [_c('v-divider'), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n          " + _vm._s(_vm.$t('zerocurrentresults')) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": "https://www.loom.com/share/f26d5537be0540f7bd8fc82c61b9b6f6",
      "target": "_blank",
      "color": "primary",
      "small": "",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n              Watch a quick video tutorial\n              "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('h3', {
    staticClass: "subheader"
  }, [_vm._v("What is this?")]), _vm._v(" "), _c('p', [_vm._v("\n            Client history is a place for you to manually record treatment of a patient (ICD-10 and treatment codes) over time.\n            You can record diagnosis without needing to add it to your appointments and invoices.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("Benefits of keeping a manual treatment record")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Track information from other practitioners (e.g.: referring practitioner diagnosis)")]), _vm._v(" "), _c('li', [_vm._v("Track diagnosis and treatment other than what you need to bill for")]), _vm._v(" "), _c('li', [_c('v-icon', {
    attrs: {
      "color": "amber",
      "small": ""
    }
  }, [_vm._v("flash_on")]), _c('strong', [_vm._v("Automation:")]), _vm._v(" AppointmentGuru can automatically add codes to new appointments for you")], 1)]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_c('strong', [_vm._v("AppointmentGuru")]), _vm._v(" will also automatically keep a record of the codes you have used on appointments.\n            You can access this information from the\n            "), _c('strong', [_vm._v(_vm._s(_vm.$t('tabs.usage')))]), _vm._v("\n            tab\n          ")])])], 1)] : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.dialogs.add),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "add", $$v)
      },
      expression: "dialogs.add"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "color": _vm.themeColor
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.add = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.changeLogsRequest
    }
  }), _vm._v(" "), _c('client-treatment', {
    attrs: {
      "loading": _vm.changeLogsRequest.loading,
      "touch": _vm.touchers.editform
    },
    on: {
      "save": _vm.save
    },
    model: {
      value: (_vm.selectedLog),
      callback: function($$v) {
        _vm.selectedLog = $$v
      },
      expression: "selectedLog"
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("insert_chart")]), _vm._v("\n    Reports have moved\n  ")], 1), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n    Check out our new reports with\n    "), _c('a', {
    attrs: {
      "href": "https://dashboard.appointmentguru.co",
      "target": "_blank"
    }
  }, [_vm._v("\n      AppointmentGuru Numbers\n      "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "href": "https://dashboard.appointmentguru.co",
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("\n      Open the Dashboard\n      "), _c('v-icon', {
    staticClass: "ml-2"
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-icon', {
    staticClass: "mt-4 pt-4",
    staticStyle: {
      "font-size": "60px"
    },
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('h3', {
    staticClass: "subheading mt-4"
  }, [_vm._v("Invoice created")]), _vm._v(" "), (_vm.value) ? _c('p', [_vm._v(_vm._s(_vm.value.title))]) : _vm._e(), _vm._v(" "), _c('v-list', [_c('v-subheader', [_vm._v("Next Steps:")]), _vm._v(" "), _vm._l((_vm.actions), function(action) {
    return [_c('v-list-tile', {
      key: action.title,
      on: {
        "click": function($event) {
          return action.onclick(_vm.value)
        }
      }
    }, [(action.icon) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(action.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(action.title))]), _vm._v(" "), (action.subtitle) ? _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(action.subtitle) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("d-" + (action.title))
    })]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "overline pl-5"
  }, [_vm._v("\n  Appointment Types (" + _vm._s(_vm.filteredProducts.length) + ")\n  "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showArchived = !_vm.showArchived
      }
    }
  }, [(!_vm.showArchived) ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("check_box_outline_blank")]) : _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("check_box")]), _vm._v("\n    Show archived\n  ")], 1)], 1), _vm._v(" "), (_vm.members && _vm.members.length > 1) ? [_c('v-tabs', _vm._l((_vm.members), function(membership) {
    return _c('v-tab', {
      key: membership.id,
      on: {
        "click": function($event) {
          _vm.selectedPractitionerId = membership.user
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.practitionerFullName(membership.user)) + "\n      ")])
  }), 1)] : _vm._e(), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.servicesSaveProductRequest,
      "message200": false
    },
    on: {
      "ok": _vm.requestOK
    }
  }), _vm._v(" "), _c('crud-table', {
    attrs: {
      "flat": "",
      "dense": "",
      "headers": _vm.productHeaders,
      "items": _vm.filteredProducts,
      "with-expand": true,
      "delete-icon": "archive",
      "delete-text": "Archive",
      "confirm-delete-title": "Are you sure you want to archive this appointment type?",
      "confirm-delete-tagline": "We will not delete this appointment type unless it has no appointments attached to it. If it has appointments, it will be archived. So previous appointments with this appointment type will retain this information, but this appointment type will no longer be visible",
      "wait-for-server": true,
      "delete-req-id": _vm.requests.service.products,
      "create-req-id": _vm.requests.service.products,
      "edit-req-id": _vm.requests.service.products,
      "close-on-edit": false,
      "dialog-width": 800,
      "with-inline-help": false,
      "loading": _vm.servicesSaveProductRequest.loading
    },
    on: {
      "add": _vm.addProduct,
      "edit": _vm.editProduct,
      "delete": _vm.deleteProduct,
      "input": _vm.itemsChanged
    },
    scopedSlots: _vm._u([{
      key: "duration",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.value) + " mins\n    ")]
      }
    }, {
      key: "booking_notice_in_minutes",
      fn: function(props) {
        return [(props.value < 1440) ? _c('span', [_vm._v("Same day")]) : (props.value < 2880) ? _c('span', [_vm._v("Next day")]) : (props.value >= 2880) ? _c('span', [_vm._v("2 day")]) : _vm._e()]
      }
    }, {
      key: "price",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatCurrency(props.item.currency, props.value)) + "\n    ")]
      }
    }, {
      key: "locations",
      fn: function(props) {
        return [(props.value && props.value.length === 0) ? [_c('span', {
          staticClass: "warning--text"
        }, [_c('v-icon', {
          staticClass: "mr-1 warning--text",
          attrs: {
            "small": ""
          }
        }, [_vm._v("warning")]), _vm._v(" Add a location\n        ")], 1)] : _vm._l((props.value), function(locId) {
          return [(_vm.$store.getters.getLocationById(locId) && _vm.$store.getters.getLocationById(locId).id) ? _c('v-chip', {
            staticClass: "v-chip--x-small",
            attrs: {
              "id": locId,
              "label": ""
            }
          }, [_c('span', {
            domProps: {
              "textContent": _vm._s(_vm.$store.getters.getLocationById(locId).name)
            }
          })]) : _c('span', [_vm._v(_vm._s(locId))])]
        })]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-card', {
          attrs: {
            "full-width": "",
            "flat": ""
          }
        }, [_c('v-card-text', [_c('copy-text-field', {
          attrs: {
            "text-to-copy": ("https://book.appt.guru/?p=" + (_vm.selectedPractitioner.id) + "&at=" + (props.item.id)),
            "label": "Booking link",
            "prepend-icon": "link",
            "hint": "This link will take your client to a booking page with this appointment type pre-selected"
          }
        })], 1)], 1)]
      }
    }])
  }, [(_vm.selectedPractitioner && _vm.selectedPractitioner.id) ? _c('v-list', {
    attrs: {
      "slot": "addedit-cardtext-outer",
      "dense": "",
      "dark": ""
    },
    slot: "addedit-cardtext-outer"
  }, [_c('practitioner-list-item', {
    attrs: {
      "item": _vm.selectedPractitioner
    }
  }), _vm._v(" "), _c('v-divider')], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-avatar', [(!_vm.isFailure) ? _c('v-icon', [_vm._v("check")]) : _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.comm) ? _c('v-list-tile-content', [(_vm.comm.preferred_transport === "email") ? _c('v-list-tile-title', _vm._l((_vm.comm.recipient_emails), function(email) {
    return _c('span', {
      key: email
    }, [_vm._v(_vm._s(email))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.comm.preferred_transport === "sms") ? _c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(_vm.comm.recipient_phone_number))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n    " + _vm._s(_vm.status) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "elevation-20 pa-0",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('page-toolbar', {
    attrs: {
      "initial-extended": false,
      "with-search": false
    },
    on: {
      "pagetoolbar:homeclicked": _vm.homeClicked
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }, [_c('template', {
    slot: "buttons-after"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'CreateClient')
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.reload
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "toolbar-right"
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("filter_list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-subheader', {
    staticClass: "overline py-0"
  }, [_vm._v("Filter clients in space:")]), _vm._v(" "), _vm._l((_vm.spaces), function(space, index) {
    return _c('v-list-tile', {
      key: ((space.id) + "-" + index),
      on: {
        "click": function($event) {
          return _vm.addFilter(space)
        }
      }
    }, [_c('v-list-tile-avatar', [(_vm.selectedSpaceId === space.id) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]) : _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("radio_button_unchecked")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(space.title))])], 1)], 1)
  })], 2)], 1)], 1)], 2), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('client-list', {
    attrs: {
      "space-id": _vm.selectedSpaceId,
      "include-owned-by-me": false,
      "clear-on-select": false,
      "with-action": true,
      "with-create": false
    },
    on: {
      "relationshipselected": _vm.clientClicked,
      "update:spaceId": function($event) {
        _vm.selectedSpaceId = $event
      },
      "update:space-id": function($event) {
        _vm.selectedSpaceId = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openGlobalDialog(true, 'CreateClient')
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" New client\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-sm-and-down pt-0 pl-2",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.selectedClient.id) ? _c('client-details', {
    on: {
      "close": _vm.homeClicked
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }) : _c('client-home', {
    on: {
      "clientClicked": _vm.clientClicked
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withSelect) ? _c('v-select', _vm._b({
    ref: "spacePicker",
    attrs: {
      "dense": "",
      "clearable": "",
      "label": _vm.label,
      "items": _vm.spaces,
      "multiple": _vm.multiple,
      "value-comparator": _vm.compare,
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "item-text": "title",
      "item-value": "id"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', [_c('v-avatar', {
          staticClass: "mr-1 elevation-4",
          attrs: {
            "size": 28,
            "color": "gray",
            "color": item.color
          }
        }, [(item.logo_picture) ? _c('v-img', {
          attrs: {
            "src": item.logo_picture
          }
        }) : _vm._e()], 1), _vm._v("\n        " + _vm._s(item.title) + "\n      ")], 1)]
      }
    }, {
      key: "item",
      fn: function(props) {
        return [_c('v-list-tile-action', [_c('v-avatar', {
          attrs: {
            "size": 28,
            "color": props.item.color
          }
        }, [(props.item.logo_picture) ? _c('v-img', {
          attrs: {
            "src": props.item.logo_picture
          }
        }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            # " + _vm._s(props.item.id) + ":\n            " + _vm._s(props.item.title) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.isSelected(props.item)) ? _c('v-icon', [_vm._v("check")]) : _c('v-icon', [_vm._v("check_box_outline_blank")])], 1)]
      }
    }, {
      key: "append-item",
      fn: function() {
        return [_c('v-divider', {
          staticClass: "mb-2"
        }), _vm._v(" "), _c('v-btn', {
          attrs: {
            "text": "",
            "flat": "",
            "small": "",
            "block": ""
          },
          on: {
            "click": function($event) {
              return _vm.$refs.spacePicker.blur()
            }
          }
        }, [_vm._v("Done")])]
      },
      proxy: true
    }], null, false, 2158007421),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, 'v-select', _vm.attrs, false)) : _c('v-card', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "subheader": "",
      "flat": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline my-0"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.spaces), function(space, index) {
    return _c('v-flex', {
      key: ((space.id) + "-" + index)
    }, [_c('v-list', {
      staticClass: "pa-0",
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-tile', {
      key: space.id,
      class: {
        "grey--text": !_vm.canEditSpace(space)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSpace(space)
        }
      }
    }, [(_vm.readOnly) ? _c('v-list-tile-action', [(_vm.isSelected(space)) ? _c('v-icon', [_vm._v("check")]) : _vm._e()], 1) : _c('v-list-tile-action', [(_vm.isSelected(space)) ? _c('v-icon', [_vm._v("check_box")]) : _c('v-icon', [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(space.title))])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-avatar', {
      staticClass: "mr-1 elevation-4",
      attrs: {
        "size": 28,
        "color": space.color,
        "dark": ""
      }
    }, [(space.logo_picture) ? _c('v-img', {
      attrs: {
        "src": space.logo_picture
      }
    }) : (space.title) ? _c('span', {
      domProps: {
        "textContent": _vm._s(space.title[0])
      }
    }) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  }), 1), _vm._v(" "), (_vm.required && !_vm.readOnly) ? _c('div', {
    staticClass: "caption info--text ml-3 mt-1"
  }, [_vm._v("\n      * required: at least one space must be selected\n    ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline grey lighten-4 py-0"
  }, [_vm._v("\n    Assign appointment types to this location\n    ("), _c('strong', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.location.name))]), _vm._v(")\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.setproducts
    },
    on: {
      "ok": function($event) {
        return _vm.$emit("close")
      }
    }
  }), _vm._v(" "), _c('v-card-text', [_vm._l((_vm.products), function(product) {
    return [_c('v-checkbox', {
      key: product.id,
      staticClass: "caption",
      attrs: {
        "hide-details": "",
        "value": product.id,
        "label": product.title
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "loading": _vm.setproducts.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Set Appointment Types")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey overline darken-4 py-1 white--text"
  }, [_vm._v("\n    Change appointment type/practitioner\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.req
    },
    on: {
      "ok": _vm.transferSuccess
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('center', [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("\n    Where would you like to move this appointment?\n  ")]), _vm._v(" "), _c('practitioner-product-picker', {
    attrs: {
      "practitioner": _vm.topractitioner,
      "product": _vm.toproduct,
      "location": _vm.tolocation
    },
    on: {
      "update:practitioner": function($event) {
        _vm.topractitioner = $event
      },
      "update:product": function($event) {
        _vm.toproduct = $event
      },
      "update:location": function($event) {
        _vm.tolocation = $event
      }
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-4 py-2"
  }, [(_vm.product) ? [_c('strong', {
    staticClass: "overline ml-2"
  }, [_vm._v("Change appointment type:")]), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "overline ml-2"
  }, [_vm._v("from:")]), _vm._v(" " + _vm._s(_vm.product.title) + " with " + _vm._s(_vm.appointment.practitioner_name)), _c('br')] : _vm._e(), _vm._v(" "), (_vm.toproduct && _vm.topractitioner) ? _c('div', {
    staticClass: "subheading"
  }, [_c('strong', {
    staticClass: "overline ml-2"
  }, [_vm._v("to:")]), _vm._v(" " + _vm._s(_vm.toproduct.title) + " with " + _vm._s(_vm.topractitioner.full_name) + " @ " + _vm._s(_vm.tolocation.name) + "\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.locationId,
      "loading": _vm.req.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.updateRequest
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('saved')
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('v-card-title', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "mb-3"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-text-field', {
    attrs: {
      "label": "Location name",
      "hint": "This is the business name that people will recognize. E.g.: Virgin Active Gym Melrose Arch",
      "persistent-hint": "",
      "box": "",
      "required": ""
    },
    model: {
      value: (_vm.address.name),
      callback: function($$v) {
        _vm.$set(_vm.address, "name", $$v)
      },
      expression: "address.name"
    }
  }), _vm._v(" "), _c('v-divider')], 1)], 1)], 1), _vm._v(" "), (!_vm.address.is_online) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading pb-0 pt-4"
  }, [_vm._v("\n        Address details\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v("\n          Search Google places for your address\n        ")]), _vm._v(" "), _c('address-picker', {
    model: {
      value: (_vm.place),
      callback: function($$v) {
        _vm.place = $$v
      },
      expression: "place"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.address.address || _vm.address.latitude),
      expression: "address.address || address.latitude"
    }]
  }, [_c('v-flex', [_c('v-form', [_c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v("\n                Confirm that these details are correct and hit save\n              ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.address,
      "label": "Address",
      "hint": "The physical address",
      "required": ""
    },
    model: {
      value: (_vm.address.address),
      callback: function($$v) {
        _vm.$set(_vm.address, "address", $$v)
      },
      expression: "address.address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.latitude,
      "label": "Latitude",
      "required": ""
    },
    model: {
      value: (_vm.address.latitude),
      callback: function($$v) {
        _vm.$set(_vm.address, "latitude", $$v)
      },
      expression: "address.latitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.longitude,
      "label": "Longitude",
      "required": ""
    },
    model: {
      value: (_vm.address.longitude),
      callback: function($$v) {
        _vm.$set(_vm.address, "longitude", $$v)
      },
      expression: "address.longitude"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), [_c('v-textarea', {
    staticClass: "mt-3",
    attrs: {
      "outline": "",
      "hide-details": "",
      "label": _vm.extraInfoNotes,
      "placeholder": "For example: When you arrive at the address. We are in the red building no. 401 A. If you ring the doorbell the receptionist will let you in.",
      "multi-line": "",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.address.notes),
      callback: function($$v) {
        _vm.$set(_vm.address, "notes", $$v)
      },
      expression: "address.notes"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tiny"
  }, [_c('li', [_vm._v("This information can be used in your notifications ("), _c('code', [_vm._v("appointment.product.address.notes")]), _vm._v(")")]), _vm._v(" "), _c('li', [_vm._v("This information will appear on your appointment detail page.")]), _vm._v(" "), _c('li', [_vm._v("You can use markdown.")])])]], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_vm._t("form-secondary-action", function() {
    return [_c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [_vm._v("Done")])]
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('vuex-btn', {
    attrs: {
      "req-id": _vm.reqId,
      "text": "Save"
    },
    on: {
      "save": function($event) {
        return _vm.$emit("save", _vm.address)
      }
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-system-bar', [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/invoices'
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v("\n      Return to invoices\n    ")], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "extended": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.requests.get.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "mr-3"
  }, [_vm._v("Payments")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "color": "info"
    },
    on: {
      "click": _vm.launchDateRangePicker
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")]), _vm._v("\n    " + _vm._s(_vm.globalActiveDateRangeFormatted) + "\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Search",
      "type": "Search",
      "hint": "Search on reference, or amount",
      "append-icon": "search"
    },
    on: {
      "click:append": _vm.doSearch,
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doSearch.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.clearSearch.apply(null, arguments)
      }]
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-3 ml-2 mr-0",
    attrs: {
      "label": "within date range"
    },
    model: {
      value: (_vm.searchwithdaterange),
      callback: function($$v) {
        _vm.searchwithdaterange = $$v
      },
      expression: "searchwithdaterange"
    }
  }), _vm._v(" "), _c('template', {
    slot: "extension"
  }, [_vm._v("\n      " + _vm._s(_vm.numTransactions) + " payments found\n      "), (_vm.activesearch) ? _c('v-chip', {
    staticClass: "v-chip--x-small ml-2",
    attrs: {
      "close": ""
    },
    on: {
      "input": _vm.clearSearch
    }
  }, [_vm._v(_vm._s(_vm.activesearch))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.numPages && _vm.numPages > 0) ? [_c('v-btn', {
    attrs: {
      "disabled": _vm.page <= 1,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.page--
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v("\n        Page " + _vm._s(_vm.page) + " of " + _vm._s(_vm.numPages) + "\n        "), _c('v-btn', {
    attrs: {
      "disabled": _vm.page >= _vm.numPages,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.page++
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)] : _vm._e()], 2)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.get,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-list', [_vm._l((_vm.transactions), function(payment) {
    return [_c('payment-list-item', {
      key: payment.id,
      attrs: {
        "item": payment
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (payment.id))
    })]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.page <= 1,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.page--
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.page >= _vm.numPages,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.page++
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.tables && _vm.tables.length > 0),
            expression: "tables && tables.length > 0"
          }],
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": "",
            "loading": _vm.req.loading
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showdetail = true
            }
          },
          slot: "activator"
        }, on), [_c('v-icon', {
          attrs: {
            "color": "amber"
          }
        }, [_vm._v("flash_on")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showdetail),
      callback: function($$v) {
        _vm.showdetail = $$v
      },
      expression: "showdetail"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "overline py-1 grey darken-3 white--text"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "amber"
    }
  }, [_vm._v("flash_on")]), _vm._v("\n      The following codes will automatically be added to this appointment\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showdetail = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.tables), function(table, index) {
    return _c('v-card', {
      key: (index + "-" + (table.id)),
      staticClass: "ma-2"
    }, [_c('v-card-title', {
      staticClass: "overline grey lighten-4",
      domProps: {
        "textContent": _vm._s(table.title)
      }
    }), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "dense": "",
        "hide-actions": "",
        "hide-default-footer": "",
        "disable-initial-sort": "",
        "disable-sort": "",
        "disable-filter": "",
        "disable-pagination": "",
        "no-data-text": "No autocodes found",
        "headers": table.headers,
        "items": table.codes,
        "items-per-page": 10
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.item.icd10 || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.process || '-'))]), _vm._v(" "), _c('td', [(props.item.price) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.formatCurrency(props.item.currency, props.item.price)) + "\n            ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), (table.id === 'client') ? [_c('td', [_vm._v(_vm._s(_vm.dateformat(props.item.start_date)))]), _vm._v(" "), _c('td', [(props.item.stop_date) ? _c('span', {
            domProps: {
              "textContent": _vm._s(props.item.stop_date)
            }
          }) : _c('span', [_vm._v("No end date")])])] : _vm._e()]
        }
      }], null, true)
    }), _vm._v(" "), (table.footertext) ? _c('v-footer', {
      staticClass: "caption py-0 pl-2 hidden-xs-only",
      domProps: {
        "textContent": _vm._s(table.footertext)
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-divider')], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.loading && _vm.appointmentCount === 0) ? _c('v-card', {
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    staticClass: "ma-4 pa-4",
    attrs: {
      "color": "amber",
      "size": "42",
      "width": "2",
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.$t('loading')))])], 1)], 1) : [(_vm.appointmentCount > 0) ? _c('v-card', {
    attrs: {
      "flat": _vm.$vuetify.breakpoint.xs
    }
  }, [_c('v-card-title', [_c('v-menu', [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("expand_more")]), _vm._v(" "), (_vm.mainchartId === "value") ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t('mainchart.titles.value')) + "\n                ")]) : _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t('mainchart.titles.count')) + "\n                ")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.mainchartId = "value"
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    " + _vm._s(_vm.$t('mainchart.titles.value')) + "\n                  ")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.mainchartId = "count"
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    " + _vm._s(_vm.$t('mainchart.titles.count')) + "\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.chartType = "bar"
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("bar_chart")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.chartType = "area"
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("show_chart")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('h3', {
    staticClass: "subheader"
  }, [_vm._v(_vm._s(_vm.dateRangeFormatted))])], 1), _vm._v(" "), _c('apex-chart', {
    attrs: {
      "height": "200px",
      "width": "100%",
      "type": _vm.chartType,
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _c('v-card', [_c('v-layout', {
    staticStyle: {
      "background-image": "url(\"/static/img/placeholders/analyza_data_and_chart.png\")",
      "background-repeat": "no-repeat",
      "background-attachment": "fixed",
      "background-position": "right top"
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": ""
    }
  }, [_c('h3', {
    staticClass: "headline mt-4 pa-4"
  }, [_vm._v("Looks like you don't have any recent appointments")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "ma-4",
    attrs: {
      "large": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'QuickCreate')
      }
    }
  }, [_vm._v("Create an appointment")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-4",
    attrs: {
      "to": "/settings/get-online",
      "large": "",
      "color": "primary"
    }
  }, [_vm._v("Get online bookings")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mr-4"
  })], 1)], 1)]], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "white pa-0",
    attrs: {
      "column": "",
      "xs12": "",
      "sm12": "",
      "md6": "",
      "md12": _vm.appointmentCount === 0
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "238"
    },
    attrs: {
      "tile": "",
      "dark": "",
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-flex', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "title font-weight-light mb-2"
  }, [_vm._v(_vm._s(_vm.$t('metrics.titles.count')))]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-light grey--text"
  }, [_vm._v(_vm._s(_vm.dateRangeFormatted))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right headline pt-2"
  }, [_vm._v("\n          " + _vm._s(_vm.appointmentCount) + "\n          ")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-flex', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "title font-weight-light mb-2"
  }, [_vm._v(_vm._s(_vm.$t('metrics.titles.value')))]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-light grey--text"
  }, [_vm._v(_vm._s(_vm.$t('metrics.subtitles.value')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right headline pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formatCurrency(_vm.settings.currency, _vm.appointmentValue)) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), (_vm.appointmentCount > 0) ? _c('v-flex', {
    staticClass: "white pa-0",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "column": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [_c('apex-chart', {
    attrs: {
      "height": "250",
      "type": "radialBar",
      "options": _vm.statusBreakdown.chartOptions,
      "series": _vm.statusBreakdown.series
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.request
    }
  }), _vm._v(" "), _c('v-alert', {
    staticClass: "mt-0",
    attrs: {
      "value": true,
      "type": "info"
    }
  }, [_c('strong', [_vm._v("Note")]), _vm._v("\n    Automations (like automatically adding codes and invoice details) do not run for\n    cloned appointments\n    "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "dark": ""
    }
  }, [_vm._v("Learn more "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), (_vm.appointment) ? _c('v-list', {
    staticClass: "ma-0 pa-0 grey lighten-4"
  }, [_c('appointment-list-item', {
    attrs: {
      "with-color-coding": false,
      "with-action": false,
      "appointment": _vm.appointment
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.window === _vm.WINDOWS.CLIENT_CLONE || _vm.window === _vm.WINDOWS.DATE_CLONE) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v("\n      Back\n    ")], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0 mt-4",
    attrs: {
      "label": "Add reminders"
    },
    model: {
      value: (_vm.withReminders),
      callback: function($$v) {
        _vm.withReminders = $$v
      },
      expression: "withReminders"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0 mt-4",
    attrs: {
      "label": "Copy codes"
    },
    model: {
      value: (_vm.copyCodes),
      callback: function($$v) {
        _vm.copyCodes = $$v
      },
      expression: "copyCodes"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.selected.length === 0 && _vm.selectedRelationshipsList.length === 0,
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Create " + _vm._s(_vm.selected.length || _vm.selectedRelationshipsList.length) + " appointments")])], 1) : _vm._e(), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-layout', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10 ma-4",
    on: {
      "click": function($event) {
        _vm.window = _vm.WINDOWS.CLIENT_CLONE
      }
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              Clone by client\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n              Copy all the information on this appointment across onto different clients\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Clone by client")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10 ma-4",
    on: {
      "click": function($event) {
        _vm.window = _vm.WINDOWS.DATE_CLONE
      }
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              Clone by date\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n              Create copies of this appointment for different dates\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Clone by date")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('client-list', {
    staticClass: "pt-2 pl-4",
    attrs: {
      "clear-on-select": false
    },
    on: {
      "relationshipselected": _vm.relationshipselected
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-list', {
    staticClass: "ma-3"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n              Copy this appointment to these clients:\n            ")]), _vm._v(" "), _vm._l((_vm.selectedRelationshipsList), function(rel) {
    return _c('client-list-item', {
      key: rel.id,
      attrs: {
        "client": rel.client,
        "relationship-id": rel.id,
        "with-action": false
      }
    }, [_c('v-list-tile-action', {
      attrs: {
        "slot": "actions"
      },
      slot: "actions"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeRelationship(rel)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)
  }), _vm._v(" "), (_vm.selectedRelationshipsList.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("No clients selected")])], 1)], 1) : _vm._e()], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs-4": ""
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('v-date-picker', {
      key: month,
      staticClass: "elevation-0 py-0 my-0",
      attrs: {
        "no-title": "",
        "multiple": "",
        "show-current": "",
        "allowed-dates": _vm.isAllowed,
        "scrollable": false,
        "prev-icon": "",
        "next-icon": "",
        "events": _vm.events,
        "disabled-dates": _vm.events,
        "picker-date": month
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-flex', {
    attrs: {
      "xs-12": "",
      "sm4": "",
      "offset-sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "text-center justify-center mt-5 elevation-10"
  }, [_c('v-card-title', {
    staticClass: "subheading justify-center"
  }, [_c('v-icon', {
    attrs: {
      "size": 42,
      "color": "success"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading justify-center"
  }, [_vm._v("\n            Successfully created " + _vm._s(_vm.clones.length) + " clones\n          ")]), _vm._v(" "), _c('v-list', [_vm._l((_vm.clones), function(appt) {
    return [_c('appointment-list-item', {
      key: appt.id,
      attrs: {
        "with-action": false,
        "appointment": appt
      }
    })]
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.saveReq
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.getReq,
      "message404": "Unable to load settings"
    }
  }), _vm._v(" "), (_vm.getReq.status === 404) ? [_c('v-card-text', [_vm._v("\n      Unable to load settings.\n      You might not have permission to edit these settings.\n      You need to be an owner in order edit settings\n    ")]), _vm._v(" "), _c('v-card-actions', [(_vm.withClose) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Close")]) : _vm._e()], 1)] : [(_vm.settings && _vm.settings.id) ? _c('v-card-text', [
    [_c('v-list', {
      staticClass: "elevation-5 pa-0"
    }, [_c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.uploadLogo = true
        }
      }
    }, [_c('v-list-tile-avatar', [(_vm.resizedLogoPicture) ? _c('v-img', {
      attrs: {
        "src": _vm.resizedLogoPicture
      }
    }) : _c('v-icon', [_vm._v("face")])], 1), _vm._v(" "), (_vm.logoPicture) ? _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Your logo")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Click to change")])], 1) : _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("No logo")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Click to upload")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("upload")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "400"
      },
      model: {
        value: (_vm.uploadLogo),
        callback: function($$v) {
          _vm.uploadLogo = $$v
        },
        expression: "uploadLogo"
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "overline py-0 mb-0 grey lighten-4"
    }, [_vm._v("\n              Upload a logo\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.uploadLogo = false
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('uploader', {
      attrs: {
        "upload-path": _vm.logoUploadPath,
        "title": "Upload a logo",
        "subtitle": "The logo should be a rectangle (for best results) and it will be used on your invoices and free website.",
        "filename": "logo_picture"
      },
      on: {
        "uploadsuccess": _vm.get
      }
    })], 1)], 1)], _vm._v(" "), (_vm.settings) ? _c('object-form', {
      attrs: {
        "field-configs": _vm.config,
        "fields": _vm.fields
      },
      on: {
        "valid": _vm.setValid
      },
      model: {
        value: (_vm.settings),
        callback: function($$v) {
          _vm.settings = $$v
        },
        expression: "settings"
      }
    }, [_c('v-checkbox', {
      attrs: {
        "slot": "include_booking_info",
        "hint": "A link to your website is added to the bottom of invoices",
        "persistent-hint": "",
        "label": "Show online booking details"
      },
      slot: "include_booking_info",
      model: {
        value: (_vm.settings.include_booking_info),
        callback: function($$v) {
          _vm.$set(_vm.settings, "include_booking_info", $$v)
        },
        expression: "settings.include_booking_info"
      }
    }), _vm._v(" "), _c('v-checkbox', {
      attrs: {
        "slot": "integrate_medical_aid",
        "hint": "If checked, then we'll show medical aid information on invoices",
        "persistent-hint": "",
        "label": "Include medical information"
      },
      slot: "integrate_medical_aid",
      model: {
        value: (_vm.settings.integrate_medical_aid),
        callback: function($$v) {
          _vm.$set(_vm.settings, "integrate_medical_aid", $$v)
        },
        expression: "settings.integrate_medical_aid"
      }
    }), _vm._v(" "), _c('v-checkbox', {
      attrs: {
        "slot": "allow_submit_to_medical_aid",
        "hint": "Your clients can submit the invoice to medical aids at the click of a button!",
        "persistent-hint": "",
        "label": "Submit to medical aids"
      },
      slot: "allow_submit_to_medical_aid",
      model: {
        value: (_vm.settings.allow_submit_to_medical_aid),
        callback: function($$v) {
          _vm.$set(_vm.settings, "allow_submit_to_medical_aid", $$v)
        },
        expression: "settings.allow_submit_to_medical_aid"
      }
    })], 1) : _vm._e()
  ], 2) : _vm._e(), _vm._v(" "), _c('v-card-actions', [(_vm.withClose) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Close")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "loading": _vm.saveReq.loading,
      "disabled": !_vm.isValid || _vm.getReq.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('v-form', [_c('v-layout', [_c('v-flex', [_c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.dialogs.icd10),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "icd10", $$v)
      },
      expression: "dialogs.icd10"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "color": _vm.themeColor
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "short": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.icd10picker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.icd10 = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('icd-picker', {
    attrs: {
      "initial-search-string": _vm.codeSearchString
    },
    on: {
      "input": _vm.setIcdCode
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.icd10 = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "box": "",
      "label": "icd10 code"
    },
    on: {
      "click:append": _vm.showICDPicker
    },
    model: {
      value: (_vm.treatmentlog.icd10),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "icd10", $$v)
      },
      expression: "treatmentlog.icd10"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.dialogs.process),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "process", $$v)
      },
      expression: "dialogs.process"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "color": _vm.themeColor
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "short": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.processpicker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.process = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('process-code-picker', {
    attrs: {
      "initial-search-string": _vm.processSearchString
    },
    on: {
      "input": _vm.setProcessCode
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.processcodepicker = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.done')))])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "box": "",
      "label": "process code"
    },
    on: {
      "click:append": _vm.showProcessPicker
    },
    model: {
      value: (_vm.treatmentlog.process),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "process", $$v)
      },
      expression: "treatmentlog.process"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "prefix": _vm.currency,
      "box": "",
      "label": "price"
    },
    model: {
      value: (_vm.treatmentlog.price),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "price", $$v)
      },
      expression: "treatmentlog.price"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v(_vm._s(_vm.$t('subtitles.dates')))]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.dialogs.startdate),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "startdate", $$v)
      },
      expression: "dialogs.startdate"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "scrollable": ""
    },
    model: {
      value: (_vm.treatmentlog.start_date),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "start_date", $$v)
      },
      expression: "treatmentlog.start_date"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.startdate = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.cancel')))])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "readonly": "",
      "label": _vm.$t("fields.labels.started"),
      "hint": _vm.$t("fields.hints.started"),
      "prepend-icon": "event"
    },
    on: {
      "click": function($event) {
        _vm.dialogs.startdate = true
      },
      "click:prepend": function($event) {
        _vm.dialogs.startdate = true
      }
    },
    model: {
      value: (_vm.treatmentlog.start_date),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "start_date", $$v)
      },
      expression: "treatmentlog.start_date"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.dialogs.stopdate),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "stopdate", $$v)
      },
      expression: "dialogs.stopdate"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "min": _vm.treatmentlog.start_date,
      "scrollable": ""
    },
    model: {
      value: (_vm.treatmentlog.stop_date),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "stop_date", $$v)
      },
      expression: "treatmentlog.stop_date"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.stopdate = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.cancel')))])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "readonly": "",
      "clearable": "",
      "label": _vm.$t("fields.labels.end_date"),
      "hint": _vm.$t("fields.hints.end_date"),
      "prepend-icon": "event"
    },
    on: {
      "click": function($event) {
        _vm.dialogs.stopdate = true
      },
      "click:prepend": function($event) {
        _vm.dialogs.stopdate = true
      }
    },
    model: {
      value: (_vm.treatmentlog.stop_date),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "stop_date", $$v)
      },
      expression: "treatmentlog.stop_date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "persistent-hint": "",
      "label": _vm.$t('fields.labels.auto'),
      "hint": _vm.$t('fields.hints.auto')
    },
    model: {
      value: (_vm.treatmentlog.automatically_add_to_appointments),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "automatically_add_to_appointments", $$v)
      },
      expression: "treatmentlog.automatically_add_to_appointments"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("save", _vm.treatmentlog)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('buttons.save')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onScroll),
      expression: "onScroll"
    }],
    staticClass: "grey lighten-4",
    class: _vm.appClasses,
    style: (_vm.appStyle),
    attrs: {
      "id": "app"
    }
  }, [(_vm.globalSelectedAppointments && _vm.globalSelectedAppointments.length > 0) ? _c('bulk-actions', {
    attrs: {
      "selected-appointments": _vm.globalSelectedAppointments
    },
    on: {
      "deselect": function($event) {
        _vm.globalSelectedAppointments = []
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "11"
    },
    attrs: {
      "touchless": "",
      "disable-resize-watcher": true,
      "dark": "",
      "width": "450",
      "app": "",
      "right": ""
    },
    model: {
      value: (_vm.showHelp),
      callback: function($$v) {
        _vm.showHelp = $$v
      },
      expression: "showHelp"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    staticClass: "visible-ios-only main",
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('contextual-help', {
    attrs: {
      "touch": _vm.tutToucher
    },
    on: {
      "close": function($event) {
        _vm.showHelp = false
      }
    }
  })], 1), _vm._v(" "), _c('v-navigation-drawer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }],
    staticStyle: {
      "z-index": "11"
    },
    attrs: {
      "app": "",
      "enable-resize-watcher": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    staticClass: "visible-ios-only main",
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('account-switcher', {
    staticClass: "mt-2",
    attrs: {
      "groups": _vm.groups
    },
    on: {
      "became": _vm.doLogin
    },
    model: {
      value: (_vm.me),
      callback: function($$v) {
        _vm.me = $$v
      },
      expression: "me"
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0 mt-3",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.navItems), function(item) {
    return [(!item.meta.hidden_from_nav && !item.meta.showChildren) ? _c('v-list-tile', {
      key: ("menu-" + (item.name)),
      class: item.meta.klass,
      on: {
        "click": function($event) {
          return _vm.goto(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(item.meta.icon))]), _vm._v(" " + _vm._s(item.name) + "\n              ")], 1)], 1), _vm._v(" "), (item.meta.new) ? _c('v-list-tile-avatar', [_c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "dark": "",
        "color": "primary"
      }
    }, [_vm._v("New")])], 1) : _vm._e(), _vm._v(" "), (item.meta.updated) ? _c('v-list-tile-avatar', [_c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "dark": "",
        "color": "warning"
      }
    }, [_vm._v("Updated")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.children && item.meta.showChildren) ? _c('v-list-group', {
      key: ("group-" + (item.name))
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(item.meta.icon))]), _vm._v(" " + _vm._s(item.name))], 1)], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return (!child.meta.hidden_from_nav === true) ? _c('v-list-tile', {
        key: ("child-" + i),
        staticClass: "nav child ml-3",
        class: ("hidden-ios-" + (child.meta.hidden_from_ios)),
        nativeOn: {
          "click": function($event) {
            return _vm.goto(child)
          }
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
        staticClass: "mr-2"
      }, [_vm._v(_vm._s(child.meta.icon))]), _vm._v(" " + _vm._s(child.name))], 1)], 1), _vm._v(" "), (child.meta.new) ? _c('v-list-tile-avatar', [_c('v-chip', {
        staticClass: "v-chip--x-small",
        attrs: {
          "dark": "",
          "color": "primary"
        }
      }, [_vm._v("New")])], 1) : _vm._e(), _vm._v(" "), (child.meta.updated) ? _c('v-list-tile-avatar', [_c('v-chip', {
        staticClass: "v-chip--x-small",
        attrs: {
          "dark": "",
          "color": "warning"
        }
      }, [_vm._v("Updated")])], 1) : _vm._e()], 1) : _vm._e()
    })], 2) : _vm._e()]
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        More apps\n      ")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.LINKS.SETTINGS,
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("settings")]), _vm._v(" Advanced settings\n          ")], 1)], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.LINKS.DASHBOARD,
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("dashboard")]), _vm._v("\n            Dashboard\n          ")], 1)], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4"
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("exit_to_app")]), _vm._v(" Logout\n          ")], 1)], 1)], 1)], 2), _vm._v(" "), _c('v-card-text', [_c('v-btn', {
    attrs: {
      "href": _vm.LINKS.INVITE,
      "target": "_blank",
      "small": "",
      "block": "",
      "outline": ""
    }
  }, [_vm._v("\n        Invite teammates\n      ")]), _vm._v(" "), (!_vm.isInstalled) ? _c('v-img', {
    staticClass: "mt-3 hidden-sm-and-up",
    attrs: {
      "src": "/static/img/pwa.png"
    },
    on: {
      "click": _vm.installMobile
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('version', {
    staticClass: "pa-3 white--text"
  }), _vm._v(" "), _c('random-splash', {
    staticClass: "p-4 mt-2",
    attrs: {
      "with-accreditation": true,
      "with-description": false
    },
    on: {
      "unpashbackground": _vm.setBackground
    }
  })], 1), _vm._v(" "), (_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    staticClass: "header-toolbar",
    class: _vm.themeColor,
    attrs: {
      "status": "",
      "fixed": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }],
    staticClass: "header-toolbar main",
    class: _vm.themeColor,
    attrs: {
      "dark": "",
      "fixed": "",
      "app": "",
      "flat": ""
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    on: {
      "click": function($event) {
        return _vm.$router.push("/")
      }
    }
  }, [_c('span', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("Appointment")]), _c('span', {
    staticStyle: {
      "color": "black !important"
    }
  }, [_vm._v("Guru")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "hidden-xs-only",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ml-3",
          attrs: {
            "to": "/calendar",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("event")])], 1)]
      }
    }], null, false, 3781911913)
  }, [_vm._v(" "), _c('span', [_vm._v("Calendar")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "to": "/appointments",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("alarm_on")])], 1)]
      }
    }], null, false, 2719616345)
  }, [_vm._v(" "), _c('span', [_vm._v("Appointments")])]), _vm._v(" "), _c('v-tooltip', {
    staticClass: "hidden-xs-only",
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "id": "global-link-clients",
            "to": "/clients",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("people")])], 1)]
      }
    }], null, false, 2808696110)
  }, [_vm._v(" "), _c('span', [_vm._v("Clients")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "id": "global-link-invoices",
            "to": "/invoices",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("post_add")])], 1)]
      }
    }], null, false, 4038287915)
  }, [_vm._v(" "), _c('span', [_vm._v("Invoices")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "id": "global-link-reports",
            "to": "/reports",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("trending_up")])], 1)]
      }
    }], null, false, 2718203230)
  }, [_vm._v(" "), _c('span', [_vm._v("Reports")])])] : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.appIsReady && _vm.showUpgrade) ? [_c('v-btn', {
    attrs: {
      "icon": "",
      "to": "/get-started",
      "color": "info",
      "id": "global-guides-btn"
    }
  }, [_c('v-icon', [_vm._v("tour")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.billingUrl,
      "color": "green",
      "icon": _vm.$vuetify.breakpoint.xs
    }
  }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('span', [_vm._v("Upgrade")]) : _vm._e(), _vm._v(" "), _c('v-icon', [_vm._v("upgrade")])], 1)] : _vm._e(), _vm._v(" "), (true) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showHelp = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_vm._v("help")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.meta.with_datepicker === true),
      expression: "$route.meta.with_datepicker === true"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showRangePicker = true
      }
    }
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-2 hidden-xs-only",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.showProfileDialog),
      callback: function($$v) {
        _vm.showProfileDialog = $$v
      },
      expression: "showProfileDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n          Update your profile picture\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showProfileDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('uploader', {
    attrs: {
      "title": "Upload a profile picture",
      "subtitle": "A profile picture or square logo will be used in the AppointmentGuru app for your clients and in your own account. It will be shown as a round picture or avatar.",
      "filename": "profile_picture"
    },
    on: {
      "uploadsuccess": function($event) {
        _vm.getMe();
        _vm.showProfileDialog = false
      }
    },
    scopedSlots: _vm._u([{
      key: "gallery",
      fn: function(props) {
        return [_c('v-subheader', [_vm._v("Examples of how this may look in various places")]), _vm._v(" "), _vm._l((props.images), function(img, index) {
          return _c('v-layout', {
            key: index
          }, [_c('v-flex', [_c('v-subheader', [_vm._v("Avatar view")]), _vm._v(" "), _c('v-avatar', [_c('img', {
            attrs: {
              "src": img
            }
          })])], 1), _vm._v(" "), _c('v-flex', [_c('v-subheader', [_vm._v("Normal view")]), _vm._v(" "), _c('img', {
            attrs: {
              "src": img
            }
          })], 1)], 1)
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "open-on-hover": "",
      "bottom": "",
      "offset-y": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-avatar', _vm._g({
          staticClass: "black--text",
          attrs: {
            "slot": "activator",
            "color": "white"
          },
          slot: "activator"
        }, on), [(_vm.globalInitRequestLoading) ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "amber",
            "width": "2"
          }
        }) : [(_vm.getProfilePicture(_vm.me)) ? _c('img', {
          attrs: {
            "src": _vm.getProfilePicture(_vm.me)
          }
        }) : _c('span', [_vm._v(_vm._s(_vm.initials(_vm.me)))])]], 2)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 grey lighten-4"
  }, [_vm._v("Hi " + _vm._s(_vm.me.first_name) + "\n          "), _vm._v(" "), (_vm.appIsReady && _vm.showUpgrade) ? _c('v-btn', {
    staticClass: "pa-0",
    staticStyle: {
      "font-size": "10px",
      "height": "18px"
    },
    attrs: {
      "small": "",
      "dark": "",
      "label": "",
      "href": _vm.billingUrl,
      "color": "success"
    }
  }, [_vm._v("upgrade")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.showProfileDialog = true
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Update profile picture")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("face")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.LINKS.SETTINGS_SPACES,
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Account")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("settings")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.LINKS.SETTINGS_PROFILE,
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("My profile")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("account_box")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.init
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Reload settings")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Logout")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("logout")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.showiframe),
      callback: function($$v) {
        _vm.showiframe = $$v
      },
      expression: "showiframe"
    }
  }, [(_vm.showiframe) ? _c('ag-iframe', {
    attrs: {
      "src": _vm.iframeSrc
    },
    on: {
      "update:src": function($event) {
        _vm.iframeSrc = $event
      },
      "close": function($event) {
        _vm.showiframe = false
      }
    }
  }) : _vm._e()], 1)], 2), _vm._v(" "), _c('main', [_c('v-content', [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }],
    staticClass: "flat",
    attrs: {
      "indeterminate": true,
      "height": 3
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "zeropadd",
    attrs: {
      "grid-list-md": "",
      "fluid": ""
    }
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }],
    staticClass: "flat",
    attrs: {
      "indeterminate": true,
      "height": 3
    }
  }), _vm._v(" "), (!_vm.globalDataLoading && _vm.isLoggedIn && _vm.isReadOnly === true) ? _c('read-only-block', {
    attrs: {
      "xs12": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lookups.invitations && _vm.lookups.invitations.length > 0) ? _c('space-invite-handler') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoggedIn) ? _c('router-view', {
    on: {
      "install": function($event) {
        _vm.showInstallInstructions = true
      }
    }
  }) : _c('login-page')], 1), _vm._v(" "), (_vm.isLoggedIn) ? _c('session', {
    on: {
      "loggedin": _vm.initSession
    }
  }) : _vm._e(), _vm._v(" "), _c('GlobalEvents', {
    attrs: {
      "filter": _vm.globalEventFilter
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 191) { return null; }
        return _vm.launchClientSearch.apply(null, arguments)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "w", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        _vm.showiframe = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "a", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.openGlobalDialog(true, 'QuickCreate')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "i", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.launchInvoiceDialog({
          appointments: _vm.$store.getters.activeAppointments
        })
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "t", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.launchPaymentDialog()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "n", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        _vm.launchNewClientDialog({
          touch: Math.random()
        })
      }]
    }
  }), _vm._v(" "), _c('v-fab-transition', [_c('v-speed-dial', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }],
    class: {
      'mb-5': _vm.$vuetify.breakpoint.xsOnly
    },
    attrs: {
      "id": "main-speed-dail",
      "bottom": "",
      "right": "",
      "fixed": "",
      "direction": "top"
    },
    model: {
      value: (_vm.expandFab),
      callback: function($$v) {
        _vm.expandFab = $$v
      },
      expression: "expandFab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "blue darken-2",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.expandFab),
      callback: function($$v) {
        _vm.expandFab = $$v
      },
      expression: "expandFab"
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20,
      "open-delay": 1000
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'QuickCreate')
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("alarm_on")])], 1), _vm._v(" "), _c('span', [_vm._v("New Appointment (ctrl + a)")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "indigo"
    },
    on: {
      "click": function($event) {
        return _vm.launchInvoiceDialog({
          appointments: _vm.$store.getters.activeAppointments
        })
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("content_copy")])], 1), _vm._v(" "), _c('span', [_vm._v("New Invoice (ctrl + i)")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "orange"
    },
    on: {
      "click": function($event) {
        return _vm.launchPaymentDialog()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("attach_money")])], 1), _vm._v(" "), _c('span', [_vm._v("New Payment (ctrl + t)")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.launchNewClientDialog({
          touch: Math.random()
        })
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("New Client (ctrl + n)")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "small": "",
      "color": "yellow"
    },
    on: {
      "click": _vm.launchClientSearch
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('span', [_vm._v("Search (/)")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('real-time-beacon'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.spaces.globalDialog.fullscreen,
      "max-width": "600",
      "lazy": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showGlobalDialogSpace),
      callback: function($$v) {
        _vm.showGlobalDialogSpace = $$v
      },
      expression: "showGlobalDialogSpace"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.spaces.globalDialog.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("HIDE_SPACE", "globalDialog")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$store.dispatch("HIDE_SPACE", "globalDialog")
      }
    }
  }, [(_vm.spaces.globalDialog.visible) ? _c(_vm.spaces.globalDialog.component, _vm._g(_vm._b({
    tag: "component",
    on: {
      "success": _vm.pushGlobalEvent,
      "close": function($event) {
        return _vm.$store.dispatch("HIDE_SPACE", "globalDialog")
      }
    }
  }, 'component', _vm.spaces.globalDialog.options, false, true), _vm.spaces.globalDialog.actions)) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "persistent": "",
      "fullscreen": _vm.spaces.secondaryGlobalDialog.fullscreen,
      "max-width": "600"
    },
    model: {
      value: (_vm.showGlobalDialogSecondarySpace),
      callback: function($$v) {
        _vm.showGlobalDialogSecondarySpace = $$v
      },
      expression: "showGlobalDialogSecondarySpace"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.spaces.secondaryGlobalDialog.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")
      }
    }
  }, [(_vm.showGlobalDialogSecondarySpace) ? _c(_vm.spaces.secondaryGlobalDialog.component, _vm._g(_vm._b({
    tag: "component",
    on: {
      "close": function($event) {
        return _vm.$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")
      }
    }
  }, 'component', _vm.spaces.secondaryGlobalDialog.options, false, true), _vm.spaces.secondaryGlobalDialog.actions)) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.showRangePicker),
      callback: function($$v) {
        _vm.showRangePicker = $$v
      },
      expression: "showRangePicker"
    }
  }, [(_vm.appPlatform === 'ios' && _vm.$vuetify.breakpoint.xsOnly) ? _c('v-system-bar', {
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "dense": "",
      "dark": "",
      "flat": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v("Choose a date range")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showRangePicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('date-range-picker', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.showRangePicker = false
      },
      "close": function($event) {
        _vm.showRangePicker = false
      }
    },
    model: {
      value: (_vm.activeDateRange),
      callback: function($$v) {
        _vm.activeDateRange = $$v
      },
      expression: "activeDateRange"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: (_vm.activeDialog),
      callback: function($$v) {
        _vm.activeDialog = $$v
      },
      expression: "activeDialog"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "flat": "",
      "color": _vm.themeColor
    }
  }, [(_vm.dialogTitle) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.dialogTitle))]) : _c('v-toolbar-title', [_vm._v(_vm._s(_vm.appointment.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeActiveDialog
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeActiveDialog.apply(null, arguments)
      }
    }
  }, [(_vm.activeComponent && _vm.activeComponent.length > 1) ? _c('global-dialog-container', {
    attrs: {
      "with-toolbar": false,
      "initial": _vm.activeComponent,
      "appointment": _vm.appointment
    },
    on: {
      "close": _vm.closeActiveDialog
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isLoggedIn) ? _c('v-bottom-nav', {
    staticClass: "elevation-20",
    staticStyle: {
      "border-top": "1px solid #ccc"
    },
    attrs: {
      "app": "",
      "value": _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/",
      "value": "home"
    }
  }, [_c('span', [_vm._v("Home")]), _vm._v(" "), _c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/calendar",
      "value": "calendar"
    }
  }, [_c('span', [_vm._v("Calendar")]), _vm._v(" "), _c('v-icon', [_vm._v("today")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/invoices",
      "value": "invoices"
    }
  }, [_c('span', [_vm._v("Invoices")]), _vm._v(" "), _c('v-icon', [_vm._v("content_copy")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/clients",
      "value": "clients"
    }
  }, [_c('span', [_vm._v("Clients")]), _vm._v(" "), _c('v-icon', [_vm._v("group")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-footer', {
    staticClass: "pa-3 mt-5 hidden-xs-only",
    attrs: {
      "app": "",
      "fluid": ""
    }
  }, [_c('span', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n        Crafted in South Africa especially for you.")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('version', {
    attrs: {
      "withReload": false
    }
  })], 1), _vm._v(" "), _c('v-bottom-sheet', {
    model: {
      value: (_vm.showInstallInstructions),
      callback: function($$v) {
        _vm.showInstallInstructions = $$v
      },
      expression: "showInstallInstructions"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline justify-center grey lighten-4 py-0"
  }, [_vm._v("\n          Install on this device\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showInstallInstructions = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('center', [_c('v-img', {
    staticClass: "mb-3",
    attrs: {
      "src": "/static/img/icons/apple-touch-icon-60x60.png",
      "alt": "AppointmentGuru",
      "width": "60",
      "height": "60"
    }
  })], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-0 pb-0 mb-0"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('ul', {
    staticClass: "mb-3"
  }, [_c('li', [_vm._v("Click on the share icon "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("ios_share")])], 1), _vm._v(" "), _c('li', [_vm._v("Scroll and click on \"add to home screen\"")])]), _vm._v(" "), _c('p', [_vm._v("\n          The app icon will be added to your home screen and you can interact\n          with AppointmentGuru just like you would any app that you have installed\n          from the iStore or Play store\n          ")])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-icon', [_vm._v("south")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.mobileAppNotice),
      callback: function($$v) {
        _vm.mobileAppNotice = $$v
      },
      expression: "mobileAppNotice"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n          A better option for mobile\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          We are moving our app out of the app stores.\n          We are moving to a mobile web app.\n          It will allow us to ship updates to our mobile app more regularly\n          and provide you with a better experience on mobile.\n\n          To install our mobile app: click the button below.\n\n          "), _c('a', {
    attrs: {
      "href": "https://app.appointmentguru.co/",
      "target": "_blank"
    }
  }, [_c('v-img', {
    staticClass: "my-3 mx-3",
    attrs: {
      "src": "/static/img/pwa.png"
    }
  })], 1), _vm._v("\n\n          This will launch the app in your browser.\n          Click on the share icon and then \"add to home screen\"\n        ")]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mobileAppNotice = false
      }
    }
  }, [_vm._v("I'll keep with this app for now")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4",
    attrs: {
      "flat": "",
      "height": "100%"
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.req
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.statementRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-0 px-1"
  }, [(_vm.practitionerId) ? _c('v-chip', {
    attrs: {
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.getPractitionerById(_vm.practitionerId).full_name) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.success) ? _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "disabled": _vm.statementRequest.loading || !_vm.hasCreateInvoicePermissions || !_vm.metaIsValid || !_vm.hasAppointments,
      "loading": _vm.req.loading
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n      Create invoice\n    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.title) ? [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_c('v-btn', {
    staticClass: "ml-1 pl-0",
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("post_add")])], 1), _vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.success) ? _c('invoice-success', _vm._g({
    model: {
      value: (_vm.remoteInvoice),
      callback: function($$v) {
        _vm.remoteInvoice = $$v
      },
      expression: "remoteInvoice"
    }
  }, _vm.$listeners)) : [(_vm.statementRequest && _vm.hasCreateInvoicePermissions) ? _c('invoice-billing-details', {
    staticClass: "ma-2 elevation-2",
    attrs: {
      "expanded": false,
      "request": _vm.statementRequest,
      "settings": _vm.spaceSettings
    },
    on: {
      "update:settings": [function($event) {
        _vm.spaceSettings = $event
      }, _vm.setSpaceSettings]
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0 pt-0"
  }, [_c('v-text-field', {
    staticClass: "pb-0 mb-0",
    attrs: {
      "label": "Invoice name"
    },
    model: {
      value: (_vm.invoice.title),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "title", $$v)
      },
      expression: "invoice.title"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.showDatepicker),
      callback: function($$v) {
        _vm.showDatepicker = $$v
      },
      expression: "showDatepicker"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0 mb-0 mr-2",
    attrs: {
      "slot": "activator",
      "label": "Invoice date",
      "readonly": "",
      "append-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.invoice.date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "date", $$v)
      },
      expression: "invoice.date"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "flat": "",
      "tile": "",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.showDatepicker = false
      }
    },
    model: {
      value: (_vm.invoice.date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "date", $$v)
      },
      expression: "invoice.date"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDatepicker = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.showDueDatepicker),
      callback: function($$v) {
        _vm.showDueDatepicker = $$v
      },
      expression: "showDueDatepicker"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0 mb-0",
    attrs: {
      "slot": "activator",
      "label": "Invoice due date",
      "readonly": "",
      "append-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.invoice.due_date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "due_date", $$v)
      },
      expression: "invoice.due_date"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "flat": "",
      "no-title": "",
      "min": _vm.invoice.date,
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.showDueDatepicker = false
      }
    },
    model: {
      value: (_vm.invoice.due_date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "due_date", $$v)
      },
      expression: "invoice.due_date"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDueDatepicker = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.invoice.due_date < _vm.latestDate) ? _c('v-alert', {
    staticClass: "pa-1 ma-0 caption",
    attrs: {
      "outline": "",
      "dismissible": "",
      "value": true,
      "type": "warning"
    }
  }, [_vm._v("\n          You have selected a due date earlier than the latest appointment included on this invoice"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("You can still create the invoice, we just wanted to let you know")])]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.hasAppointments) ? _c('v-list', {
    staticClass: "ma-0",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [_c('v-list-group', [_c('v-subheader', {
    staticClass: "overline",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("person")]), _vm._v("\n          " + _vm._s(_vm.fullname) + "\n        ")], 1), _vm._v(" "), (_vm.relationshipId) ? _c('client-card', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "flat": "",
      "with-client-name": false,
      "relationship-id": _vm.relationshipId
    },
    on: {
      "relationship": _vm.setRelationship
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-group', [_c('v-subheader', {
    staticClass: "overline",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [(_vm.password) ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "amber"
    }
  }, [_vm._v("lock")]) : _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "info"
    }
  }, [_vm._v("lock_open")]), _vm._v("\n          Password protect\n        ")], 1), _vm._v(" "), _c('encrypt-invoice', {
    attrs: {
      "password": _vm.password,
      "password-hint": _vm.passwordHint,
      "relationship": _vm.rel
    },
    on: {
      "update:password": function($event) {
        _vm.password = $event
      },
      "update:passwordHint": function($event) {
        _vm.passwordHint = $event
      },
      "update:password-hint": function($event) {
        _vm.passwordHint = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.computedInvoice && _vm.computedInvoice.appointments) ? _c('read-only-statement-list', {
    attrs: {
      "flat": "",
      "debounce": "",
      "initially-collapsed": true,
      "due": _vm.finaldue,
      "with-edit": _vm.withEdit,
      "appointment-ids": _vm.computedInvoice.appointments
    },
    on: {
      "update:due": function($event) {
        _vm.finaldue = $event
      },
      "edit": _vm.editInvoiceDetails,
      "remove": _vm.removeAppointment
    },
    model: {
      value: (_vm.statementRequest),
      callback: function($$v) {
        _vm.statementRequest = $$v
      },
      expression: "statementRequest"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.finaldue && _vm.finaldue > 0) ? [_c('div', {
    staticClass: "px-3 mb-3"
  }, [_c('v-checkbox', {
    staticClass: "caption",
    attrs: {
      "label": "Mark as paid",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: (_vm.markPaid),
      callback: function($$v) {
        _vm.markPaid = $$v
      },
      expression: "markPaid"
    }
  }), _vm._v(" "), (_vm.markPaid) ? _c('payment-method-picker', {
    attrs: {
      "small": ""
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }) : _vm._e()], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.ready) ? [_c('transition', {
    attrs: {
      "name": "delay-display-none"
    }
  }, [(!_vm.metaIsValid) ? _c('v-alert', {
    staticClass: "pa-1 my-0",
    attrs: {
      "type": "warning",
      "dense": "",
      "value": true
    }
  }, [_vm._v("\n          Some information required to create an invoice is missing.\n          "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.relationship.loading || _vm.requests.appt.loading
    },
    on: {
      "click": _vm.fetchMeta
    }
  }, [_vm._v("Fetch data from server")])], 1) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (!_vm.hasAppointments) ? _c('div', {
    staticClass: "warning--text caption px-3"
  }, [_c('v-icon', {
    staticClass: "warning--text",
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n      No appointments selected\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.statementRequest.loading || !_vm.hasCreateInvoicePermissions || !_vm.metaIsValid || !_vm.hasAppointments,
      "loading": _vm.req.loading,
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n        Create Invoice\n      ")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": !_vm.hasCreateInvoicePermissions
    }
  }, [_vm._v("\n      You do not have permission to create invoices in this space or spaces\n    ")])]], 2)
},staticRenderFns: []}

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "px-3 mb-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "clearable": "",
      "label": "Password",
      "hint": "The password your client needs to use to access this invoice"
    },
    model: {
      value: (_vm.localpassword),
      callback: function($$v) {
        _vm.localpassword = $$v
      },
      expression: "localpassword"
    }
  }), _vm._v(" "), (_vm.relIdNumber) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.localpassword = _vm.relIdNumber;
        _vm.localpasswordHint = "Use your ID number to unlock the pdf"
      }
    }
  }, [_vm._v(_vm._s(_vm.relIdNumber))]) : _vm._e(), _vm._v(" "), (_vm.relEmail) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.localpassword = _vm.relEmail;
        _vm.localpasswordHint = "Use your email address to unlock the pdf"
      }
    }
  }, [_vm._v(_vm._s(_vm.relEmail))]) : _vm._e(), _vm._v(" "), (_vm.relPhone) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.localpassword = _vm.relPhone;
        _vm.localpasswordHint = "Use your 12 digit phone number starting with + to unlock the pdf"
      }
    }
  }, [_vm._v(_vm._s(_vm.relPhone))]) : _vm._e()], 1), _vm._v(" "), (_vm.localpassword) ? [_c('v-flex', [_c('v-text-field', {
    staticClass: "caption",
    attrs: {
      "persistent-hint": "",
      "clearable": "",
      "label": "Password hint",
      "hint": "You can add a hint to help your client know what password to use"
    },
    model: {
      value: (_vm.localpasswordHint),
      callback: function($$v) {
        _vm.localpasswordHint = $$v
      },
      expression: "localpasswordHint"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "amber lighten-3 pa-1 mt-2"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Encrypted PDFs may effect the delivery of your emails\n      ")], 1)])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('kanban', {
    attrs: {
      "cols": _vm.cols,
      "data": _vm.data
    },
    scopedSlots: _vm._u([{
      key: "list",
      fn: function(props) {
        return [_c('invoice-list', _vm._g({
          staticClass: "invoice-list",
          attrs: {
            "invoices": _vm.visibleItems[props.col.value],
            "actions": _vm.actions,
            "loading": _vm.invoicesRequest.loading
          }
        }, _vm.events)), _vm._v(" "), (_vm.items[props.col.value] && (_vm.items[props.col.value].length >= _vm.visibleItemCount)) ? _c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-card-actions', [_vm._v("\n        Showing " + _vm._s(_vm.visibleItemCount) + " of " + _vm._s(_vm.items[props.col.value].length) + "\n        "), _c('v-btn', {
          attrs: {
            "flat": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.visibleItemCount += _vm.pageSize
            }
          }
        }, [_vm._v("Load more")])], 1)], 1) : _vm._e()]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-system-bar', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "height": "30",
      "dense": "",
      "flat": "",
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.step === 0,
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.step--
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.canNext
    },
    on: {
      "click": function($event) {
        _vm.step++
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c(_vm.layoutComponent, {
    tag: "component",
    attrs: {
      "step": _vm.step
    },
    on: {
      "update:step": function($event) {
        _vm.step = $event
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-4",
    attrs: {
      "slot": "step-0",
      "flat": "",
      "dark": "",
      "tile": "",
      "height": "100%"
    },
    slot: "step-0"
  }, [_vm._t("ag-filters", function() {
    return [_c('appointment-filters', {
      staticClass: "mx-2",
      attrs: {
        "mini": "",
        "require-daterange": "",
        "title": "Find appointments",
        "with-icon": false,
        "with-theme-toggle": false,
        "compact": _vm.compact,
        "touch": _vm.filterTouch,
        "page-size": _vm.pageSize,
        "num-results": _vm.appointments.length,
        "practitioner-id": _vm.computedPractitionerId,
        "relationship": _vm.relationship,
        "initial-relationship": _vm.initialRelationship,
        "multiple-relationships": false,
        "relationship-statuses": _vm.statuses.split(',')
      },
      on: {
        "update:pageSize": function($event) {
          _vm.pageSize = $event
        },
        "update:page-size": function($event) {
          _vm.pageSize = $event
        },
        "update:relationship": _vm.setRelationship,
        "count": _vm.setCount
      },
      model: {
        value: (_vm.filters),
        callback: function($$v) {
          _vm.filters = $$v
        },
        expression: "filters"
      }
    }, [(_vm.componentName === "CreateInvoice") ? _c('template', {
      slot: "actions"
    }, [(_vm.infoIsTeamAccount) ? _c('v-switch', {
      staticClass: "mb-0 mx-4",
      attrs: {
        "dense": "",
        "label": "Only my appointments"
      },
      model: {
        value: (_vm.withPersonalFilter),
        callback: function($$v) {
          _vm.withPersonalFilter = $$v
        },
        expression: "withPersonalFilter"
      }
    }) : _vm._e(), _vm._v(" "), _c('v-switch', {
      staticClass: "my-0 mx-4",
      attrs: {
        "dense": "",
        "label": "Include paid appointments"
      },
      model: {
        value: (_vm.withPaid),
        callback: function($$v) {
          _vm.withPaid = $$v
        },
        expression: "withPaid"
      }
    }), _vm._v(" "), _c('v-switch', {
      staticClass: "my-0 mx-4",
      attrs: {
        "dense": "",
        "label": "Include previously invoiced appointments"
      },
      model: {
        value: (_vm.withInvoiced),
        callback: function($$v) {
          _vm.withInvoiced = $$v
        },
        expression: "withInvoiced"
      }
    }), _vm._v(" "), _c('v-switch', {
      staticClass: "my-0 mx-4",
      attrs: {
        "dense": "",
        "label": "Oldest first"
      },
      model: {
        value: (_vm.oldestFirst),
        callback: function($$v) {
          _vm.oldestFirst = $$v
        },
        expression: "oldestFirst"
      }
    })], 1) : _vm._e()], 2)]
  })], 2), _vm._v(" "), _c('template', {
    slot: "step-1"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.showinvoicedetails),
      callback: function($$v) {
        _vm.showinvoicedetails = $$v
      },
      expression: "showinvoicedetails"
    }
  }, [(_vm.selectedAppointment) ? _c('invoice-details', {
    attrs: {
      "with-create": false
    },
    on: {
      "finalprice": function($event) {
        _vm.dirty = true
      },
      "close": function($event) {
        _vm.showinvoicedetails = false
      }
    },
    model: {
      value: (_vm.selectedAppointment),
      callback: function($$v) {
        _vm.selectedAppointment = $$v
      },
      expression: "selectedAppointment"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.appointmentsLoading) ? _c('tombstone') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.appointmentsLoading === false),
      expression: "appointmentsLoading===false"
    }]
  }, [(_vm.relationship && _vm.relationship.id) ? _c('appointment-list', {
    attrs: {
      "dense": "",
      "with-select-all": "",
      "selected": _vm.appointments,
      "title": "Choose appointments",
      "cards": _vm.cardView,
      "with-price": false,
      "page-size": _vm.pageSize,
      "loading": _vm.appointmentsLoading,
      "relationship": _vm.relationship,
      "relationship-statuses": _vm.statuses,
      "with-action": false,
      "with-actions": false,
      "multiple": true,
      "params": _vm.params,
      "touch": _vm.listTouch
    },
    on: {
      "update:selected": function($event) {
        _vm.appointments = $event
      },
      "update:cards": function($event) {
        _vm.cardView = $event
      },
      "update:loading": function($event) {
        _vm.appointmentsLoading = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "listaction",
      fn: function(appt) {
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.selectedAppointment = appt.appointment;
              _vm.showinvoicedetails = true
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1)]
      }
    }], null, false, 2019933857)
  }, [(_vm.filters && _vm.filters.after_utc) ? _c('template', {
    slot: "top"
  }, [_c('v-system-bar', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.launchDateRangePicker
    }
  }, [_c('v-icon', {
    staticClass: "mr-2 pl-3",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")])], 1), _vm._v("\n              " + _vm._s(_vm.filters.after_utc) + " - " + _vm._s(_vm.filters.before_utc) + "\n            ")], 1)], 1) : _vm._e()], 2) : _c('v-card', {
    staticClass: "ma-3 blue lighten-5"
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-icon', [_vm._v("arrow_left")]), _vm._v("\n            " + _vm._s(_vm.activeComponent.step1Instructions.title) + "\n          ")], 1), _vm._v(" "), _c('v-card-text', [_c('ul', _vm._l((_vm.activeComponent.step1Instructions.bullets), function(li) {
    return _c('li', {
      key: li,
      domProps: {
        "textContent": _vm._s(li)
      }
    })
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "hidden-sm-and-up"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.canNext,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.step++
      }
    }
  }, [_vm._v("next")])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "step-2"
  }, [(_vm.relationship && _vm.relationship.id && _vm.appointments && _vm.appointments.length > 0) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [
    [(_vm.activeComponent && _vm.activeComponent.title) ? _c('v-card-title', {
      staticClass: "overline grey lighten-4 py-2"
    }, [(_vm.activeComponent.icon) ? _c('v-icon', {
      staticClass: "mr-2 small"
    }, [_vm._v(_vm._s(_vm.activeComponent.icon))]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.activeComponent.title) + "\n            "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": _vm.reset
      }
    }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.activeComponent && _vm.activeComponent.title) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c(_vm.activeComponent.component, _vm._b({
      tag: "component",
      attrs: {
        "relationship": _vm.relationship,
        "appointments": _vm.appointments
      },
      on: {
        "close": function($event) {
          _vm.listTouch++;
          _vm.appointments = [];
          _vm.step = 0;
          _vm.$emit("close")
        },
        "done": function($event) {
          _vm.listTouch++;
          _vm.appointments = [];
          _vm.step = 0;
          _vm.$emit("close")
        },
        "next": function($event) {
          _vm.appointments = [];
          _vm.listTouch++;
          _vm.filterTouch++;
          _vm.step = 0;
        },
        "success": function($event) {
          return _vm.$emit("success")
        }
      }
    }, 'component', _vm.activeComponent.attrs, false))]
  ], 2) : _c('v-card', {
    staticClass: "ma-3 blue lighten-5"
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-icon', [_vm._v("arrow_left")]), _vm._v("\n          " + _vm._s(_vm.activeComponent.step2Instructions.title) + "\n        ")], 1), _vm._v(" "), _c('v-card-text', [_c('ul', _vm._l((_vm.activeComponent.step2Instructions.bullets), function(li) {
    return _c('li', {
      key: li,
      domProps: {
        "textContent": _vm._s(li)
      }
    })
  }), 0)])], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('div', [_c('strong', [_vm._v("Monday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["mon"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Tuesday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["tues"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Wednesday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["wed"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Thursday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["thurs"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Friday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["fri"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Saturday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["sat"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Sunday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["sun"])))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.edit = true
      }
    }
  }, [_vm._v("\n      Edit\n    ")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400",
      "scrollable": ""
    },
    model: {
      value: (_vm.edit),
      callback: function($$v) {
        _vm.edit = $$v
      },
      expression: "edit"
    }
  }, [(_vm.edit) ? _c('operating-hours', {
    attrs: {
      "autosave": _vm.edit
    },
    on: {
      "close": function($event) {
        _vm.edit = false
      }
    },
    model: {
      value: (_vm.hours),
      callback: function($$v) {
        _vm.hours = $$v
      },
      expression: "hours"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.hourSlots(_vm.minStartTime, '23:45', _vm.periodInMins),
      "label": "Start time"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.hourSlots(_vm.startTime || _vm.minStartTime, '23:45', _vm.periodInMins),
      "label": "End time"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": 0
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.errorMessage) ? _c('v-alert', {
    staticClass: "ma-2",
    attrs: {
      "value": true,
      "type": "error",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.statementClients.length === 0) ? _c('v-alert', {
    staticClass: "ma-2",
    attrs: {
      "value": true,
      "type": "warning",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n        Warning: could not find any contacts to send this statement to\n      ")]) : _vm._e(), _vm._v(" "), (_vm.statement) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("post_add")]), _vm._v("\n        " + _vm._s(_vm.statement.title) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs-only"
  }, [_c('strong', {
    staticClass: "mr-2"
  }, [_vm._v("Closing balance:")]), _vm._v(" " + _vm._s(_vm.formatCurrency(_vm.$store.getters.settings.currency, _vm.statement.closing_balance)) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.statement) ? _c('send-template', {
    attrs: {
      "template": "STATEMENT",
      "template-context": "Statement",
      "title": "Who would you like to send this statement to?",
      "initial-page": 1,
      "clients": _vm.statementClients,
      "context": _vm.statement,
      "send-to-me": true,
      "with-send": false,
      "touch": _vm.toucher
    },
    on: {
      "sender": _vm.setSender,
      "recipients": _vm.setRecipients
    }
  }) : _c('div', [_vm._v("Unable to provide sendiing options. Please try again")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.canSend,
      "loading": _vm.sending,
      "color": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 1
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center",
    staticStyle: {
      "max-width": "500px",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "mt-4",
    attrs: {
      "dark": "",
      "size": "76",
      "color": "green"
    }
  }, [_vm._v("\n          check_circle\n        ")]), _vm._v(" "), _c('h3', {
    staticClass: "subheading text-xs-center mb-4"
  }, [_vm._v("\n          Statement sent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "overline text-xs-left ml-4"
  }, [_vm._v("Messages:")]), _vm._v(" "), (_vm.batchId) ? _c('batch-id-list', {
    staticClass: "pb-4",
    attrs: {
      "batch-id": _vm.batchId
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "py-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.paymentSavedRequest
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.deleteInvoiceRequest
    }
  }), _vm._v(" "), _c('invoices-toolbar', {
    attrs: {
      "page": _vm.page,
      "use-date-due": _vm.useDateDue,
      "with-search": _vm.activeMainComponent === "kanban",
      "title": _vm.title
    },
    on: {
      "reload": _vm.refresh,
      "setmain": _vm.setMainComponent,
      "setsecondary": _vm.setSecondaryComponent,
      "search": _vm.setSearch,
      "update:page": function($event) {
        _vm.page = $event
      },
      "update:useDateDue": function($event) {
        _vm.useDateDue = $event
      },
      "update:use-date-due": function($event) {
        _vm.useDateDue = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.mainComponentClasses
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "out-in": ""
    }
  }, [_c(_vm.mainComponent, {
    tag: "component",
    attrs: {
      "lazy-load": "",
      "loading": _vm.invoicesRequest.loading,
      "title": _vm.title,
      "headers": _vm.headers,
      "actions": _vm.invoiceActions,
      "appointments": _vm.appointmentsNeedingAttention,
      "transactions": _vm.transactions,
      "data": _vm.filteredInvoices,
      "search-string": _vm.searchString,
      "date-range": _vm.activeDateRange,
      "page": _vm.page
    },
    on: {
      "update:page": function($event) {
        _vm.page = $event
      },
      "edit": _vm.gotoInvoice,
      "view": _vm.openInNew,
      "send": _vm.gotoSend,
      "share": _vm.invoiceEvents.share,
      "delete": _vm.prepareToDelete,
      "addpayment": _vm.addPayment,
      "markaspaid": _vm.markAsPaid,
      "preview": _vm.setPreview,
      "primarycta": _vm.setPreview,
      "reload": _vm.refresh,
      "sendtomedicalaid": _vm.sendtomedicalaid,
      "showpaymentdialog": _vm.showPaymentDialog,
      "showcustomer": _vm.gotoCustomer
    }
  })], 1)], 1), _vm._v(" "), (_vm.activeSecondaryComponent) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "transition": "slide-x-reverse-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "right": "",
      "absolute": "",
      "fab": "",
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.activeSecondaryComponent = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c(_vm.secondaryComponent, {
    tag: "component",
    staticClass: "elevation-20",
    attrs: {
      "client": _vm.selectedClient,
      "invoice": _vm.invoice,
      "search-string": _vm.searchString,
      "appointments": _vm.activeAppointments,
      "with-close": false
    },
    on: {
      "close": function($event) {
        _vm.secondaryComponent = false
      },
      "edit": _vm.gotoInvoice,
      "send": _vm.gotoSend,
      "view": _vm.openInNew,
      "reload": _vm.refresh,
      "created": _vm.setPreview
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300px"
    },
    model: {
      value: (_vm.showConfirmDeleteDialog),
      callback: function($$v) {
        _vm.showConfirmDeleteDialog = $$v
      },
      expression: "showConfirmDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', [_vm._v("Please confirm")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to delete this invoice:\n        "), _c('p', [_vm._v(_vm._s(_vm.invoice.title) + " - " + _vm._s(_vm.invoice.date))])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showConfirmDeleteDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error",
    on: {
      "click": function($event) {
        return _vm.deleteInvoice(_vm.invoice)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n    " + _vm._s(_vm.invoice.title) + "\n    "), _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.invoice.status))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "pr-4"
  }, [_vm._v("\n      " + _vm._s(_vm.formatCurrency(_vm.invoice.currency, _vm.invoice.invoice_amount)) + "\n    ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Invoice date: " + _vm._s(_vm.invoice.date))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          Due date: " + _vm._s(_vm.invoice.due_date) + "\n        ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.invoice.context) ? _c('v-list-group', [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("My info")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Address, banking details, practice name and number\n          ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Practice: " + _vm._s(_vm.invoice.context.practice_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Number: " + _vm._s(_vm.invoice.context.practice_number) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Contact details")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.invoice.invoicee_details || _vm.invoice.context.from_string) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Banking details")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.invoice.context.banking_details) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.invoice.context) ? _c('v-list-group', [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Customer billing info")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Bill to, medical aid info\n          ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Bill to")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.invoice.context.customer_info))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Medical Aid info")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.invoice.context.medicalaid_info))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.invoice.context) ? _c('v-list-group', [_c('v-subheader', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Line items")]), _vm._v(" "), _vm._l((_vm.invoice.context.appointments), function(appointment) {
    return [_c('v-divider', {
      key: ((appointment.id) + "-d")
    }), _vm._v(" "), _c('v-list-tile', {
      key: appointment.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(appointment.invoice_title || appointment.full_name) + "\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(_vm.dateformat(appointment.start_time)) + "\n            ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n            " + _vm._s(_vm.formatCurrency(_vm.invoice.currency, appointment.price)) + "\n          ")])], 1), _vm._v(" "), (appointment.codes && appointment.codes.length > 0) ? [_c('v-subheader', {
      key: ((appointment.id) + "-h"),
      staticClass: "py-0 my-0"
    }, [_vm._v("Codes:")]), _vm._v(" "), _vm._l((appointment.codes), function(code) {
      return _c('div', {
        key: code.id,
        staticClass: "mr-3 text-xs-right"
      }, [_c('span', {
        staticClass: "mx-2"
      }, [_vm._v(_vm._s(code.icd10))]), _vm._v(" "), _c('span', {
        staticClass: "mx-2"
      }, [_vm._v(_vm._s(code.process))]), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, code.price)))])])
    })] : _vm._e()]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("view", _vm.invoice)
      }
    }
  }, [_vm._v("View "), _c('v-icon', {
    staticClass: "pl-1"
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("send", _vm.invoice)
      }
    }
  }, [_vm._v("Send "), _c('v-icon', {
    staticClass: "pl-1"
  }, [_vm._v("send")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("edit", _vm.invoice)
      }
    }
  }, [_vm._v("More "), _c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "pl-2"
  }, [_vm._v("\n    #" + _vm._s(_vm.invoice.id) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', {
    staticClass: "grey lighten-4",
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.paymentRequest
    }
  }), _vm._v(" "), (_vm.isSuccess) ? _c('v-card-text', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-badge', {
    attrs: {
      "overlap": ""
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function() {
        return [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("check_circle")])]
      },
      proxy: true
    }], null, false, 2123438404)
  }, [_vm._v(" "), _c('v-icon', {
    staticClass: "pt-2",
    attrs: {
      "size": 72,
      "color": "green"
    }
  }, [_vm._v("paid")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "subheading"
  }, [_vm._v("\n          Payment tracked")]), _vm._v(" "), (_vm.totalDue > 0) ? _c('v-btn', {
    staticClass: "mb-0",
    attrs: {
      "disabled": _vm.statementLoading,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("Add another payment")]) : _vm._e(), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.reset();
        _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1) : _vm._e(), _vm._v(" "), [_c('v-card-text', [_c('read-only-statement-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.withAppointmentInfo),
      expression: "withAppointmentInfo"
    }],
    attrs: {
      "initially-collapsed": "",
      "appointment-ids": _vm.computedAppointmentIds,
      "relationships": _vm.relationships,
      "due": _vm.totalDue,
      "touch": _vm.statementTouch,
      "loading": _vm.statementLoading
    },
    on: {
      "update:relationships": function($event) {
        _vm.relationships = $event
      },
      "update:due": function($event) {
        _vm.totalDue = $event
      },
      "update:loading": function($event) {
        _vm.statementLoading = $event
      },
      "update:currency": _vm.setCurrency
    }
  }, [_c('template', {
    slot: "list-tile"
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    model: {
      value: (_vm.paidInFull),
      callback: function($$v) {
        _vm.paidInFull = $$v
      },
      expression: "paidInFull"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', {
    on: {
      "click": function($event) {
        _vm.paidInFull = !_vm.paidInFull
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Paid in full")])], 1)], 1), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "pa-0",
    attrs: {
      "slot": "list-end",
      "value": _vm.percentPaid,
      "height": "2"
    },
    slot: "list-end"
  })], 2), _vm._v(" "), (!_vm.isSuccess) ? [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "persistent-hint": "",
      "hint": "The date on which you received this payment",
      "label": "Payment date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.payment.date),
      callback: function($$v) {
        _vm.$set(_vm.payment, "date", $$v)
      },
      expression: "payment.date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "reactive": ""
    },
    model: {
      value: (_vm.payment.date),
      callback: function($$v) {
        _vm.$set(_vm.payment, "date", $$v)
      },
      expression: "payment.date"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.paidInFull,
      "prefix": _vm.currency,
      "label": "Payment amount",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reference",
      "hint": "(optional) - record a reference for this payment"
    },
    model: {
      value: (_vm.payment.reference),
      callback: function($$v) {
        _vm.$set(_vm.payment, "reference", $$v)
      },
      expression: "payment.reference"
    }
  })], 1), _vm._v(" "), [_c('v-subheader', {
    staticClass: "overline my-0 px-0"
  }, [_vm._v("Payment method")]), _vm._v(" "), _vm._l((_vm.paymentMethods), function(method) {
    return _c('v-chip', {
      key: method.value,
      staticClass: "mt-0",
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.payment.payment_method = method.value
        }
      }
    }, [(_vm.payment.payment_method === method.value) ? _c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n              " + _vm._s(method.text) + "\n            ")], 1)
  })], _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error",
      "value": _vm.paymentExceedsAppointments
    }
  }, [_c('strong', [_vm._v("Warning!")]), _vm._v("\n            You are about to add a payment larger than the value\n            of the appointments. You can do this .. but it might not be a good idea.\n          ")])] : _vm._e(), _vm._v(" "), (_vm.withActions && !_vm.isSuccess) ? [_c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-5"
  }, [(_vm.totalDue && _vm.dueAfterPayment !== false) ? _c('span', [(_vm.dueAfterPayment > 0) ? _c('v-chip', [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.currency, _vm.dueAfterPayment)))]), _vm._v("   still owed to you\n              ")]) : _vm._e(), _vm._v(" "), (_vm.dueAfterPayment < 0) ? _c('v-chip', {
    attrs: {
      "outline": "",
      "color": "warning"
    }
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v(" Payment amount higher than the value of these appointments\n              ")], 1) : _vm._e(), _vm._v(" "), (_vm.dueAfterPayment === 0) ? _c('v-chip', {
    attrs: {
      "color": "success",
      "dark": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")]), _vm._v(" Paid in full\n              ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isValid !== true) ? _c('span', {
    staticClass: "red--text caption"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n              " + _vm._s(_vm.isValid) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [(_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.isValid !== true,
      "loading": _vm.paymentRequest.loading,
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.trackPayment
    }
  }, [_vm._v("Add payment")])], 1)] : _vm._e()], 2)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "pa-0 ma-0 nopadd",
    attrs: {
      "dense": "",
      "flat": "",
      "dark": _vm.dark
    }
  }, [(_vm.colleagueIds && _vm.colleagueIds.length > 1) ? [(_vm.$vuetify.breakpoint.xs) ? _c('v-list', {
    staticClass: "pt-0 mb-0 pl-2",
    attrs: {
      "dark": ""
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.mobileSelectCalendar = true
      }
    }
  }, [_c('v-list-tile-avatar', {
    staticClass: "white--text",
    attrs: {
      "color": "teal"
    }
  }, [(_vm.getProfilePicture(_vm.selected)) ? _c('v-img', {
    attrs: {
      "src": _vm.getProfilePicture(_vm.selected)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.initials(_vm.selected)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.selectedFullName)
    }
  })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("expand_more")])], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "persistent": false,
      "inset": ""
    },
    model: {
      value: (_vm.mobileSelectCalendar),
      callback: function($$v) {
        _vm.mobileSelectCalendar = $$v
      },
      expression: "mobileSelectCalendar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-2"
  }, [_vm._v("\n            Pick a calendar\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.mobileSelectCalendar = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', _vm._l((_vm.colleagues), function(colleague) {
    return _c('v-list-tile', {
      key: colleague.id,
      on: {
        "click": function($event) {
          _vm.setSelected(colleague);
          _vm.mobileSelectCalendar = false
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "white--text",
      attrs: {
        "color": "teal"
      }
    }, [(_vm.getProfilePicture(colleague)) ? _c('v-img', {
      attrs: {
        "src": _vm.getProfilePicture(colleague)
      }
    }) : _c('span', [_vm._v(_vm._s(_vm.initials(colleague)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(colleague.full_name)
      }
    })], 1)], 1)
  }), 1)], 1)], 1)], 1) : _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        return _vm.setSelected(_vm.me)
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-avatar', _vm._g(_vm._b({
          staticClass: "mr-2",
          attrs: {
            "size": "24"
          }
        }, 'v-avatar', attrs, false), on), [(_vm.profilePicture) ? _c('v-img', {
          attrs: {
            "src": _vm.profilePicture
          }
        }) : _c('span', [_vm._v(_vm._s(_vm.initials(_vm.me)))])], 1)]
      }
    }], null, false, 1246988026)
  }, [_vm._v(" "), _c('strong', [_vm._v("it's you!")]), _vm._v(" "), _vm._l((_vm.myMemberships), function(mem) {
    return _c('div', [_vm._v("\n            " + _vm._s(mem.role) + " @ " + _vm._s(mem.title) + "\n          ")])
  })], 2), _vm._v(" "), _c('v-badge', {
    staticClass: "ctabs",
    attrs: {
      "bordered": "",
      "overlap": "",
      "small": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function() {
        return [_vm._v("+")]
      },
      proxy: true
    }], null, false, 2848459955)
  }, [_vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newAppointment(_vm.me)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.colleagues), function(colleague) {
    return [_c('v-divider', {
      key: ("div-" + (colleague.id)),
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), (colleague.id !== _vm.me.id) ? _c('v-tab', {
      key: colleague.id,
      attrs: {
        "outlined": ""
      },
      on: {
        "click": function($event) {
          return _vm.setSelected(colleague)
        }
      }
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-avatar', _vm._g(_vm._b({
            staticClass: "mr-2 white--text",
            attrs: {
              "size": "24",
              "color": "teal"
            }
          }, 'v-avatar', attrs, false), on), [(_vm.getProfilePicture(colleague)) ? _c('v-img', {
            attrs: {
              "src": _vm.getProfilePicture(colleague)
            }
          }) : _c('span', [_vm._v(_vm._s(_vm.initials(colleague)))])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(colleague.full_name))]), _vm._v(" "), _vm._l((colleague.memberships), function(mem) {
      return _c('div', [_vm._v("\n                    " + _vm._s(mem.role) + " @ " + _vm._s(mem.space_name) + "\n                  ")])
    })], 2)]), _vm._v(" "), _c('v-badge', {
      staticClass: "ctabs",
      attrs: {
        "bordered": "",
        "overlap": "",
        "small": "",
        "right": ""
      },
      scopedSlots: _vm._u([{
        key: "badge",
        fn: function() {
          return [_vm._v("+")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "outline": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.newAppointment(colleague)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("event")])], 1)], 1)], 1) : _vm._e()]
  }), _vm._v(" "), _c('invite-btn', {
    attrs: {
      "text": "Invite",
      "icon": "add",
      "attrs": {
        flat: true
      }
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loading) ? _c('v-progress-circular', {
    staticClass: "ma-2",
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.facets && _vm.facets.spaces) ? _vm._l((Object.keys(_vm.facets.spaces)), function(id) {
    return _c('v-chip', {
      key: id,
      staticClass: "v-chip--x-small mt-2",
      staticStyle: {
        "margin-top": "12px!important"
      },
      attrs: {
        "outline": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.setSelectedSpace(id)
        }
      }
    }, [(_vm.selectedSpace === id) ? _c('v-icon', {
      staticClass: "ma-0",
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.facets.spaces[id].title) + "\n        ")], 1)
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/calendar/team",
      "outline": "",
      "small": ""
    }
  }, [_vm._v("Team View")])], 2)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.data) ? _c('crud-table', {
    attrs: {
      "flat": "",
      "headers": _vm.data.headers,
      "deleteable": true,
      "items": _vm.data.data,
      "loading": _vm.getProductsRequest.loading,
      "no-data-text": "No products found for this appointment",
      "empty-btn-text": "Add a product"
    },
    on: {
      "add": _vm.addProduct,
      "edit": _vm.editProduct,
      "delete": _vm.deleteProduct
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-icon', [_vm._v("credit_card")]), _vm._v(" Billing information\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-ios-true",
    attrs: {
      "small": "",
      "color": "primary",
      "href": _vm.billingUrl,
      "target": "_blank"
    }
  }, [_vm._v("Make a payment")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.nextPayment) ? _c('v-list', {
    staticClass: "elevation-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-subheader', [_vm._v("Your next payment:")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.dateformat(_vm.nextPayment.scheduled_date)) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Scheduled date.")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(_vm.formatCurrency(_vm.nextPayment.currency, _vm.nextPayment.amount)) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-subheader', [_vm._v("Invoices / Payments")]), _vm._v(" "), _c('vuex-loader', {
    attrs: {
      "request-id": "requests.transactions"
    }
  }), _vm._v(" "), (_vm.transactions && _vm.transactions.length > 0) ? _c('v-list', {
    staticClass: "elevation-4",
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.transactions), function(transaction) {
    return (transaction) ? _c('v-list-tile', {
      key: transaction.id
    }, [_c('v-list-tile-action', [(transaction.result_code === "000.000.000") ? _c('v-icon', {
      attrs: {
        "color": "success"
      }
    }, [_vm._v("check")]) : _c('v-icon', {
      attrs: {
        "color": "error"
      }
    }, [_vm._v("warning")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.dateformat(transaction.created_date)) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("#" + _vm._s(transaction.transaction_id) + ". " + _vm._s(transaction.result_description) + ".")])], 1), _vm._v(" "), (transaction.result_code === "000.000.000") ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "href": _vm.transactoinUrl(transaction.id, transaction.transaction_id),
        "target": "_blank",
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 1) : _vm._e()
  }), 1) : _c('v-card', [(!_vm.transactionRequest.loading) ? _c('v-card-text', [_vm._v("No invoices found")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-5"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n      Cancel account\n    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      To cancel your account,\n      please email support@appointmentguru.co with the subject: \"Please cancel my account\"\n      from the email address associated with this account (" + _vm._s(_vm.me.email) + ").\n\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mt-5",
    class: _vm.calculatedClasses
  }, [_c('v-sheet', {
    staticClass: "v-sheet--offset mx-auto",
    attrs: {
      "color": "cyan",
      "elevation": "12",
      "max-width": "calc(100% - 32px)"
    }
  }, [_c('v-toolbar', {
    staticClass: "elevation-10",
    class: _vm.color,
    attrs: {
      "dense": "",
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "loading": _vm.getRequest.loading || _vm.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-tabs', {
    attrs: {
      "color": _vm.color
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.pages), function(page) {
    return _c('v-tab', {
      key: page.title
    }, [_vm._v(_vm._s(page.title))])
  })], 2) : [_c('v-toolbar-title', [_vm._v("\n            " + _vm._s(_vm.activePage.title) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isMobile) ? _c('v-menu', {
    staticClass: "v-tabs__div hidden-sm-and-up mr-0 pr-0",
    attrs: {
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('a', _vm._g({
          staticClass: "v-tabs__item",
          attrs: {
            "text": ""
          }
        }, on), [_vm._v("\n                MORE\n                "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }], null, false, 664498919)
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.pages), function(page, index) {
    return _c('v-list-tile', {
      key: page.title,
      on: {
        "click": function($event) {
          return _vm.setTab(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page.title) + "\n              ")])
  }), 1)], 1) : _vm._e()], _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withDone) ? _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")]) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.getRequest.loading) ? _c('tombstone') : _c('v-card-text', [_c('v-card-title', {
    staticClass: "title font-weight-light mb-2 hidden-xs-only",
    domProps: {
      "textContent": _vm._s(_vm.activePage.title)
    }
  }, [_c('v-spacer'), _vm._v(" "), (_vm.activePage.withSaveButton) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.saveRequest.loading,
      "small": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), (_vm.activePage.component) ? _c(_vm.activePage.component, _vm._b({
    tag: "component",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "update:loading": function($event) {
        _vm.loading = $event
      },
      "reload": _vm.get
    }
  }, 'component', _vm.activePage.attrs, false)) : _vm._e()], 1), _vm._v(" "), (_vm.activePage.withSaveButton) ? _c('v-card-actions', [(_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      Cancel\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary",
      "loading": _vm.saveRequest.loading,
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.closeOnSave = true;
        _vm.save()
      }
    }
  }, [_vm._v("\n      Save and close\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.saveRequest.loading,
      "small": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mb-5"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n    Form Submissions\n    "), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('share-form', {
    attrs: {
      "relationship-id": _vm.relationshipId
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.getSubmissions
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), [_c('v-list', {
    staticClass: "pa-0 elevation-0 my-4",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.submissions), function(submission) {
    return [_c('v-list-tile', {
      key: submission.submission_id,
      on: {
        "click": function($event) {
          _vm.selectedSubmission = submission;
          _vm.submissiondetaildialog = true
        }
      }
    }, [_c('v-list-tile-content', [(submission.form) ? _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(submission.form.title)
      }
    }) : _c('v-list-tile-title', [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "info"
      }
    }, [_vm._v("info")]), _vm._v("\n            Form is no longer linked, or no longer exists\n          ")], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Submitted: " + _vm._s(_vm.dateformat(submission.created_date)) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.confirmSync = true
        }
      }
    }, [_vm._v("Re-Sync")])], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "450"
      },
      model: {
        value: (_vm.confirmSync),
        callback: function($$v) {
          _vm.confirmSync = $$v
        },
        expression: "confirmSync"
      }
    }, [_c('request-status', {
      attrs: {
        "request": _vm.syncRequest,
        "message200": false
      },
      on: {
        "ok": function($event) {
          _vm.confirmSync = false
        }
      }
    }), _vm._v(" "), _c('v-card', [_c('v-card-title', {
      staticClass: "subtitle-1 overline"
    }, [_vm._v("\n              Sync this submission to AppointmentGuru client\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.confirmSync = false
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("This will sync the data from the form submission with their AppointmentGuru client information\n              such as their contact information and medical aid information.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Note")]), _vm._v(" Normally you should not need to perform this step manually as\n              the information is typically automatically synced when the submission is received")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.confirmSync = false
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "loading": _vm.syncRequest.loading
      },
      on: {
        "click": function($event) {
          return _vm.sync(submission)
        }
      }
    }, [_vm._v("Sync")])], 1)], 1)], 1), _vm._v(" "), (submission.submission_id && submission.form && submission.form.form_id) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "href": ("https://jotform.com/inbox/" + (submission.form.form_id) + "/" + (submission.submission_id)),
        "target": "_blank",
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.noop.apply(null, arguments)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 1)]
  }), _vm._v(" "), (_vm.submissions && _vm.submissions.length === 0) ? _c('v-list-tile', {
    staticClass: "mb-5"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("No linked submissions found.\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "460"
    },
    model: {
      value: (_vm.showSubmissionPicker),
      callback: function($$v) {
        _vm.showSubmissionPicker = $$v
      },
      expression: "showSubmissionPicker"
    }
  }, [_c('assign-submission', {
    attrs: {
      "relationship-id": _vm.relationshipId
    },
    on: {
      "close": function($event) {
        _vm.showSubmissionPicker = false
      },
      "ok": _vm.getSubmissions
    }
  }, [_c('v-card-actions', {
    attrs: {
      "slot": "card-actions"
    },
    slot: "card-actions"
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSubmissionPicker = false
      }
    }
  }, [_vm._v("Cancel ")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/integrations/jotform",
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("search")]), _vm._v("\n        Find a submission\n      ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/integrations/jotform",
      "flat": ""
    }
  }, [_vm._v("Manage integration")])], 1)], _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.submissiondetaildialog),
      callback: function($$v) {
        _vm.submissiondetaildialog = $$v
      },
      expression: "submissiondetaildialog"
    }
  }, [(_vm.selectedSubmission) ? _c('form-submission-card', {
    key: _vm.selectedSubmission.submission_id,
    attrs: {
      "with-close": "",
      "submission-id": _vm.selectedSubmission.submission_id
    },
    on: {
      "close": function($event) {
        _vm.submissiondetaildialog = false
      }
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-bottom-sheet', {
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-list', {
    staticClass: "pa-0 grey grey lighten-2",
    attrs: {
      "three-line": _vm.$vuetify.breakpoint.xs
    }
  }, [_c('v-list-tile', [(_vm.appointment && _vm.appointment.is_online) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("headset_mic")])], 1) : _vm._e(), _vm._v(" "), (_vm.withPreview) ? _c('v-list-tile-action', [(_vm.screen === _vm.screens.ACTIONS) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = _vm.screens.PREVIEW
      }
    }
  }, [_c('v-icon', [_vm._v("visibility")])], 1) : _vm._e(), _vm._v(" "), (_vm.screen === _vm.screens.PREVIEW) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = _vm.screens.ACTIONS
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.appointmentId) ? _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sharedialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("ios_share")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.title) + "\n            "), (_vm.formattedStatus && _vm.formattedStatus.title) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    class: _vm.formattedStatus.theme,
    attrs: {
      "label": "",
      "dark": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formattedStatus.title) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.appointment.product) ? _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.product.title) + "\n            "), (_vm.appointment.practitioner_name) ? _c('span', [_vm._v("with " + _vm._s(_vm.appointment.practitioner_name))]) : _vm._e(), _vm._v(" "), (_vm.appointment.service_name) ? _c('span', [_vm._v("@ " + _vm._s(_vm.appointment.service_name))]) : _vm._e(), _vm._v(" "), (_vm.appointment.address_name) ? _c('v-chip', {
    staticClass: "v-chip--x-small hidden-xs-only"
  }, [_vm._v("\n              " + _vm._s(_vm.appointment.address_name) + "\n            ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.xs) ? _c('v-list-tile-sub-title', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("location_on")]), _vm._v("\n            " + _vm._s(_vm.appointment.address_name) + ".\n            "), _c('v-spacer'), _vm._v(" "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.appointment.price)))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.appointment && _vm.appointment.price) ? _c('v-list-tile-action', {
    staticClass: "hidden-xs-only"
  }, [_c('v-chip', {
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'InvoiceDetails', {
          appointment: _vm.appointment
        })
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.appointment.price)))])], 1) : _vm._e(), _vm._v(" "), (_vm.appointmentDetail && _vm.appointmentDetail.zoom_start_url) ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "href": _vm.appointmentDetail.zoom_start_url,
      "target": "_blank",
      "flat": "",
      "text": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("\n            Start meeting\n            "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false;
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('action-list', {
    attrs: {
      "appointment": _vm.appointment
    },
    on: {
      "actionselected": function($event) {
        _vm.visible = false
      }
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment) ? _c('v-footer', {
    staticClass: "py-0 caption px-2",
    attrs: {
      "dark": ""
    }
  }, [(_vm.appointment.tags) ? [_vm._v("\n          Tags:\n          "), _vm._l((_vm.appointment.tags), function(tag) {
    return _c('v-chip', {
      key: tag,
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": ""
      }
    }, [_vm._v(_vm._s(tag))])
  })] : _vm._e(), _vm._v("\n        Created " + _vm._s(_vm.dateformat(_vm.appointment.created_date)) + ".\n        "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "label": ""
    }
  }, [_vm._v("#" + _vm._s(_vm.appointment.id))])], 2) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "460",
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.sharedialog),
      callback: function($$v) {
        _vm.sharedialog = $$v
      },
      expression: "sharedialog"
    }
  }, [(_vm.sharedialog) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4"
  }, [_vm._v("\n          Share appointment\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sharedialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointmentId) ? _c('share-appointment', {
    attrs: {
      "appointment-id": _vm.appointmentId
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "value": _vm.visible
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icon))]), _vm._v(" " + _vm._s(_vm.text))], 1), _vm._v(" "), _c('action-list', {
    attrs: {
      "appointment": _vm.appointment
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Add a location\n        "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "The name of this location",
      "hint": "e.g.: Virgin Active Melrose, The Health Center Randburg, etc"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.create.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.location.name),
      callback: function($$v) {
        _vm.$set(_vm.location, "name", $$v)
      },
      expression: "location.name"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.req.loading,
      "disabled": _vm.location.name.length === 0,
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('location-edit', _vm._g({
    attrs: {
      "location": _vm.location
    },
    on: {
      "close": _vm.bubbleClose
    }
  }, _vm.$listeners))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline pb-0"
  }, [(_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v("\n    " + _vm._s(_vm.dateRangeString) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "nudge-bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.actions), function(action) {
    return _c('v-list-tile', {
      key: action.id,
      on: {
        "click": action.onclick
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(action.title))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), (_vm.showFilters) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-list-tile', {
      key: filter
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(filter) + "\n          ")])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0 mb-0 pb-0",
    attrs: {
      "flat": "",
      "full-width": "",
      "no-title": "",
      "no-messages": "",
      "pickerDate": _vm.pickerDate,
      "multiple": _vm.calendarType === "date",
      "type": _vm.calendarType
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-0"
  }, [(_vm.withMonthPicker) ? [(_vm.calendarType == "date") ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "flat": ""
    },
    on: {
      "click": _vm.setMonthPicker
    }
  }, [_vm._v("Month picker")]) : _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "flat": ""
    },
    on: {
      "click": _vm.setDatePicker
    }
  }, [_vm._v("Date picker")])] : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withOk) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("OK")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.getApptReq,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline py-1"
  }, [_vm._v("\n    Appointment details\n    "), _c('v-spacer'), _vm._v(" "), (_vm.sharelink) ? [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sharedialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("share")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "360"
    },
    model: {
      value: (_vm.sharedialog),
      callback: function($$v) {
        _vm.sharedialog = $$v
      },
      expression: "sharedialog"
    }
  }, [_c('share-card', {
    attrs: {
      "links": [_vm.sharelink],
      "relationship-id": _vm.appointment.computed_relationship_id
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Date and time")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.formatFromTo(_vm.appointment.start_time, _vm.appointment.end_time)) + "\n        ")]), _vm._v(" "), (_vm.appointment.client_timezone && _vm.appointment.client_timezone !== _vm.$store.getters.settings.timezone) ? _c('v-list-tile-sub-title', [_vm._v("\n          Client's timezone: " + _vm._s(_vm.appointment.client_timezone) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$store.dispatch("SHOW_APPOINTMENT_DIALOG", [true, "Reschedule", _vm.appointment])
      }
    }
  }, [_vm._v("\n          Reschedule\n        ")])], 1)], 1), _vm._v(" "), (_vm.appointment.location && (_vm.appointment.location.address || _vm.appointment.location.name)) ? [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Flexible location")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.location.name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.location.formatted_address || _vm.appointment.location.address)
    }
  })], 1), _vm._v(" "), (_vm.appointment.location.url) ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "href": _vm.appointment.location.url,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', {
    on: {
      "click": function($event) {
        _vm.editLocation = true
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "340"
    },
    model: {
      value: (_vm.editLocation),
      callback: function($$v) {
        _vm.editLocation = $$v
      },
      expression: "editLocation"
    }
  }, [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save({
          location: _vm.appointment.location
        })
      }
    },
    model: {
      value: (_vm.locationIsValid),
      callback: function($$v) {
        _vm.locationIsValid = $$v
      },
      expression: "locationIsValid"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.apptReq,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              Edit this location\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.editLocation = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Place of interest name"
    },
    model: {
      value: (_vm.appointment.location.name),
      callback: function($$v) {
        _vm.$set(_vm.appointment.location, "name", $$v)
      },
      expression: "appointment.location.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Physical address"
    },
    model: {
      value: (_vm.appointment.location.address),
      callback: function($$v) {
        _vm.$set(_vm.appointment.location, "address", $$v)
      },
      expression: "appointment.location.address"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "link",
      "type": "url",
      "clearable": "",
      "label": "Map address",
      "placeholder": "https://",
      "rules": _vm.urlRules,
      "hint": "Link to an address in google maps or whatever mapping software you use"
    },
    model: {
      value: (_vm.appointment.location.url),
      callback: function($$v) {
        _vm.$set(_vm.appointment.location, "url", $$v)
      },
      expression: "appointment.location.url"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.editLocation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": !_vm.locationIsValid,
      "loading": _vm.apptReq.loading,
      "color": "primary"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)] : (_vm.appointment.address_data) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Location")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.appointment.address_data.name) + ". " + _vm._s(_vm.appointment.address_data.address) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.productData && _vm.productData.id) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("star")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Appointment Type")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.productData.title) + "\n          "), (_vm.appointment.practitioner_name) ? _c('span', [_vm._v(" with " + _vm._s(_vm.appointment.practitioner_name))]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.changeAppointmentType = true
      }
    }
  }, [_vm._v("Change")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "640"
    },
    model: {
      value: (_vm.changeAppointmentType),
      callback: function($$v) {
        _vm.changeAppointmentType = $$v
      },
      expression: "changeAppointmentType"
    }
  }, [_c('v-card', [(_vm.changeAppointmentType) ? _c('transfer-appointment', {
    attrs: {
      "appointment": _vm.appointment
    },
    on: {
      "saved": function($event) {
        _vm.get();
        _vm.changeAppointmentType = false
      },
      "close": function($event) {
        _vm.changeAppointmentType = false
      }
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relationship && _vm.relationship.id && _vm.appointment.status && _vm.appointment.status.toLowerCase() !== "b") ? _c('div', [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Customer information")]), _vm._v(" "), (_vm.appointment.relationships && _vm.appointment.relationships.length > 0 && isNaN(_vm.appointment.relationships[0])) ? _vm._l((_vm.appointment.relationships), function(relationship) {
    return _c('client-list-item', {
      key: relationship.id,
      attrs: {
        "with-details": "",
        "with-whatsapp": "",
        "with-edit": "",
        "relationship-id": relationship.relationship.id,
        "client": relationship.relationship
      },
      on: {
        "listitem:clicked": function($event) {
          return _vm.gotoClient(relationship.relationship)
        }
      }
    }, [_c('template', {
      slot: "actions"
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": !_vm.$vuetify.breakpoint.xs,
        "icon": _vm.$vuetify.breakpoint.xs
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.launchSetAppointmentClient({
            value: _vm.appointment,
            withDependent: true
          })
        }
      }
    }, [(_vm.$vuetify.breakpoint.xs) ? _c('v-icon', [_vm._v("manage_accounts")]) : _c('span', [_vm._v("Change")])], 1)], 1), _vm._v(" "), (_vm.sharelink) ? _c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": "",
              "href": _vm.sharelink.url,
              "target": "_blank"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
              }
            }
          }, on), [_c('v-icon', [_vm._v("open_in_new")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Open client appointment page")])])], 1) : _vm._e()], 1)], 2)
  }) : _c('client-list-item', {
    attrs: {
      "relationship-id": _vm.relationship.id,
      "client": _vm.relationship.client
    },
    on: {
      "listitem:clicked": function($event) {
        return _vm.gotoClient(_vm.relationship)
      }
    }
  }), _vm._v(" "), (_vm.fullName && _vm.fullName !== _vm.appointment.full_name) ? _c('div', [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n          Patient name: " + _vm._s(_vm.appointment.full_name) + "\n          "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.launchSetAppointmentClient({
          value: _vm.appointment,
          withDependent: true
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1)], 1) : _vm._e()], 2) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-list', {
    staticClass: "orange lighten-2 elevation-4",
    attrs: {
      "subheader": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n            Please choose a client\n            "), _c('v-spacer'), _vm._v("\n            The client used the following information when making the appointment\n          ")], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("warning")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.full_name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.appointment.contact_email))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.appointment.contact_phone))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchSetAppointmentClient({
          value: _vm.appointment
        })
      }
    }
  }, [_vm._v("Set client")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment && _vm.appointment.is_online) ? [_c('online-meeting-card', {
    attrs: {
      "withedit": true,
      "editmode": !_vm.appointment.zoom_meeting_id,
      "appointment": _vm.appointment
    }
  })] : _vm._e(), _vm._v(" "), (_vm.codes) ? _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('appointment-codes', {
    attrs: {
      "title": "Codes",
      "with-title": "",
      "with-done": false
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.appointment.notes) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-0 mt-4"
  }, [_vm._v("Appointment notes")]), _vm._v(" "), _c('v-card-text', [_c('pre', {
    staticClass: "blue lighten-5 pa-2 caption"
  }, [_vm._v(_vm._s(_vm.appointment.notes))])])], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('tag-list', {
    attrs: {
      "appointment": _vm.appointment,
      "deleteable": true
    }
  })], 1), _vm._v(" "), (_vm.appointment.recurring_appointment) ? _c('v-card-text', [_c('recurring-appointment-form', {
    attrs: {
      "flat": false
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "ma-0 pa-0",
    attrs: {
      "indeterminate": true,
      "height": 3,
      "color": "primary"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drop-area",
    class: _vm.classList,
    on: {
      "dragenter": function($event) {
        $event.preventDefault();
        return _vm.setHover(true)
      },
      "dragover": function($event) {
        $event.preventDefault();
        return _vm.setHover(true)
      },
      "dragleave": function($event) {
        $event.preventDefault();
        return _vm.setHover(false)
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.drop.apply(null, arguments)
      }
    }
  }, [_c('form', {
    staticClass: "my-form"
  }, [_c('h5', [(_vm.uploadSuccess) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check_circle")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('input', {
    staticClass: "fileElem",
    attrs: {
      "type": "file",
      "name": "fileElem",
      "id": _vm.id,
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        return _vm.filesSelected.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (!_vm.uploading) ? _c('label', {
    staticClass: "button",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v("Select some files")]) : _vm._e(), _vm._v(" "), (!_vm.uploading) ? _c('label', [_vm._v("or drop some files here")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gallery"
  }, [_vm._t("gallery", function() {
    return [_c('div', _vm._l((_vm.images), function(img, index) {
      return _c('img', {
        key: index,
        staticClass: "img",
        attrs: {
          "src": img
        }
      })
    }), 0)]
  }, {
    "images": _vm.images
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "disabled": !_vm.file,
      "loading": _vm.uploading,
      "color": "primary",
      "block": ""
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_c('v-icon', [_vm._v("file_upload")]), _vm._v(" Upload")], 1)], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ma-0"
  }, [_c('a', {
    attrs: {
      "name": "top",
      "id": "top"
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.response.loading) ? _c('v-progress-circular', {
    attrs: {
      "width": "2",
      "color": "amber",
      "indeterminate": ""
    }
  }) : _c('v-icon', [_vm._v("send")]), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("\n      Messages\n    ")]), _vm._v(" "), (_vm.totalResults) ? _c('span', {
    staticClass: "ml-2 pt-1 hidden-xs-only"
  }, [_vm._v("\n      Showing " + _vm._s(_vm.messages.length) + " of " + _vm._s(_vm.totalResults) + " messages\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "search",
      "hint": "press enter to search",
      "clearable": "",
      "append-icon": "search"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.dosearch.apply(null, arguments)
      },
      "click:append": _vm.dosearch,
      "click:clear": function($event) {
        return _vm.dosearch(10)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "pl-3 ml-3 mr-3 mt-3",
    staticStyle: {
      "flex": "none"
    },
    attrs: {
      "label": "Only failed"
    },
    model: {
      value: (_vm.failed),
      callback: function($$v) {
        _vm.failed = $$v
      },
      expression: "failed"
    }
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.fetch
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), (_vm.response.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "height": "2",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "background-color": "gray lighten-4"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.inbox')))]), _vm._v(" "), (_vm.$store.getters.isAdmin) ? _c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.communicationtemplates')))]) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-tab-item', [_c('inbox', {
    attrs: {
      "messages": _vm.messages
    },
    on: {
      "selected": _vm.setSelected
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-pagination', {
    staticClass: "my-2 mr-4",
    attrs: {
      "circle": "",
      "length": _vm.numPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": function($event) {
        return _vm.$vuetify.goTo("#top")
      }
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1), _vm._v(" "), (_vm.numPages > 1) ? _c('v-footer', {
    staticClass: "text-xs-center"
  }, [_c('v-icon', {
    staticClass: "ml-2 mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('small', [_vm._v("Notification data is only available for more recent notifications")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.response.loading) ? _c('v-progress-circular', {
    attrs: {
      "width": "2",
      "color": "amber",
      "indeterminate": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.response.loading && _vm.messages.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("\n            No messages found\n          ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.templatePage),
      callback: function($$v) {
        _vm.templatePage = $$v
      },
      expression: "templatePage"
    }
  }, [_c('v-window-item', [_c('communication-template-list', {
    attrs: {
      "title": _vm.$t("comms.title")
    },
    on: {
      "selected": _vm.setSelectedCommunicationTemplate,
      "new": function($event) {
        return _vm.setSelectedCommunicationTemplate(null)
      }
    }
  })], 1), _vm._v(" "), _c('v-window-item', [_c('communication-template-form', {
    attrs: {
      "context-type": "Appointment"
    },
    on: {
      "close": function($event) {
        _vm.templatePage = 0
      }
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.showCompose),
      callback: function($$v) {
        _vm.showCompose = $$v
      },
      expression: "showCompose"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 overline grey lighten-4"
  }, [_vm._v("\n          Compose message\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showCompose = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('compose')], 1)], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "11"
    },
    attrs: {
      "persistent": "",
      "right": "",
      "fixed": "",
      "hide-overlay": "",
      "width": "400"
    },
    model: {
      value: (_vm.showDetail),
      callback: function($$v) {
        _vm.showDetail = $$v
      },
      expression: "showDetail"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "status": "",
      "dark": ""
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": "",
      "dark": "",
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.selected = null;
        _vm.showDetail = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.selected) ? _c('communication-card', {
    attrs: {
      "id": _vm.selected.id,
      "initial-data": _vm.selected,
      "fetch": true
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ml-3 overline"
  }, [_vm._v("\n    Delivery status\n  ")]), _vm._v(" "), _c('v-list', {
    staticClass: "mx-4",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.communications), function(comm) {
    return _c('v-list-tile', {
      key: comm.id
    }, [_c('v-list-tile-avatar', [(!_vm.isFailure(comm)) ? _c('v-icon', [_vm._v("check")]) : _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (comm) ? _c('v-list-tile-content', [(comm.preferred_transport === "email") ? _c('v-list-tile-title', _vm._l((comm.recipient_emails), function(email) {
      return _c('span', {
        key: email
      }, [_vm._v(_vm._s(email))])
    }), 0) : _vm._e(), _vm._v(" "), (comm.preferred_transport === "sms") ? _c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(comm.recipient_phone_number))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n        " + _vm._s(_vm.status(comm)) + "\n      ")])], 1)
  }), _vm._v(" "), (!_vm.communications || _vm.communications.length === 0) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "width": "2",
      "color": "amber"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          waiting for status updates\n        ")])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('v-card-text', [_c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_vm._v("Fetch from server")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.statementRequest.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "subheading hidden-xs-only"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('title')) + "\n    ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.statementRequest.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "pb-0"
  }, [_vm._l((_vm.statements), function(statement) {
    return [_c('statement-list-item', {
      key: statement.id,
      attrs: {
        "value": statement
      },
      on: {
        "send": _vm.initSend,
        "deleted": _vm.get
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-stat-" + (statement.id))
    })]
  }), _vm._v(" "), (!_vm.statementRequest.loading && _vm.statements.length === 0) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('nostatements.title')) + "\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('nostatements.content')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showSendDialog),
      callback: function($$v) {
        _vm.showSendDialog = $$v
      },
      expression: "showSendDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v("\n            " + _vm._s(_vm.$t('dialogs.titles.send')) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showSendDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.selectedStatement) ? _c('send-statement', {
    attrs: {
      "touch": _vm.sendTouch
    },
    on: {
      "close": function($event) {
        _vm.showSendDialog = false
      }
    },
    model: {
      value: (_vm.selectedStatement),
      callback: function($$v) {
        _vm.selectedStatement = $$v
      },
      expression: "selectedStatement"
    }
  }) : _vm._e()], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isCompact) ? _c('v-tabs', {
    attrs: {
      "vertical": "",
      "dark": "",
      "show-arrows": "",
      "grow": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('v-tab', {
      key: item.id
    }, [(index === 0) ? _c('v-icon', [_vm._v("home")]) : _c('span', [_vm._v(_vm._s(item.title))])], 1)
  }), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-tab-item', {
      key: item.id
    }, [(item.component && _vm.activeTab === index) ? _c(item.component, _vm._g(_vm._b({
      tag: "component",
      attrs: {
        "lazy": ""
      }
    }, 'component', item.attrs, false), item.evnts || {})) : _vm._e()], 1)
  }), 1)], 2) : _c('v-expansion-panel', {
    staticClass: "elevation-0",
    attrs: {
      "focusable": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-expansion-panel-content', {
      key: item.id,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('div', {
            staticClass: "subheading"
          }, [_vm._v("\n          " + _vm._s(item.title))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (item.component && _vm.activeTab === index) ? _c(item.component, _vm._g(_vm._b({
      tag: "component",
      attrs: {
        "lazy": ""
      }
    }, 'component', item.attrs, false), item.evnts || {})) : _vm._e()], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tile": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-2 overline grey darken-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('center', [_c('v-progress-circular', {
    staticClass: "mt-5",
    attrs: {
      "indeterminate": "",
      "size": "72",
      "color": "amber"
    }
  }), _c('br'), _vm._v("\n    Loading ..\n  ")], 1) : _vm._e(), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "id": "settingsiframe",
      "src": _vm.src,
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": _vm.iframeloaded
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.messages), function(message) {
    return _c('communication-watcher', {
      key: message.id,
      attrs: {
        "message-id": message.id
      }
    })
  }), _vm._v(" "), (_vm.messages && _vm.messages.length === 0) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        Waiting for status updates ...\n      ")])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.record.referrers.length > 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": ""
    }
  }, [_vm._l((_vm.record.referrers), function(referrer) {
    return _c('v-list-tile', {
      key: referrer.id
    }, [_c('v-list-tile-action', [_c('v-menu', {
      attrs: {
        "offset-y": ""
      }
    }, [_c('template', {
      slot: "activator"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.changeCurrent(referrer)
        }
      }
    }, [(referrer.is_current_referrer) ? _c('v-list-tile-title', [_vm._v("\n             Not curent referrer")]) : _c('v-list-tile-title', [_vm._v("\n             Make curent referrer")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.markedForDelete = referrer;
          _vm.showRemoveConfirmation = true
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('buttons.remove')))])], 1)], 1)], 2)], 1), _vm._v(" "), (referrer.therapist) ? _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(referrer.therapist.title) + "\n          " + _vm._s(referrer.therapist.initials) + "\n          " + _vm._s(referrer.therapist.first_name) + "\n          " + _vm._s(referrer.therapist.last_name) + ".\n          "), _c('small', [_vm._v(_vm._s(referrer.therapist.reference_number))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.$t('added')) + ": " + _vm._s(_vm.dateformat(referrer.created_date)) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [(referrer.is_current_referrer) ? _c('v-icon', [_vm._v("check")]) : _vm._e(), _vm._v(" "), (referrer.is_current_referrer) ? _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.$t('current')))]) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    staticClass: "my-0",
    attrs: {
      "indeterminate": "",
      "height": "3"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showReferralPicker = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Add a referrer")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.showReferralPicker),
      callback: function($$v) {
        _vm.showReferralPicker = $$v
      },
      expression: "showReferralPicker"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.pickerTouch++
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("home")])], 1), _vm._v("\n    Choose a referrer\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showReferralPicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('referral-picker', {
    attrs: {
      "touch": _vm.pickerTouch
    },
    on: {
      "selected": _vm.addReferrer,
      "close": function($event) {
        _vm.showReferralPicker = false
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.showRemoveConfirmation),
      callback: function($$v) {
        _vm.showRemoveConfirmation = $$v
      },
      expression: "showRemoveConfirmation"
    }
  }, [(_vm.markedForDelete && _vm.markedForDelete.therapist) ? _c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('dialogs.confirmremove.title')))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_vm._v("\n      Remove\n      "), _c('strong', [_vm._v(_vm._s(_vm.markedForDelete.therapist.first_name) + " " + _vm._s(_vm.markedForDelete.therapist.last_name))]), _vm._v("\n      as a referrer for this record.\n      "), _c('v-alert', {
    attrs: {
      "type": "info",
      "value": true,
      "dismissible": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dialogs.confirmremove.notes.p1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('dialogs.confirmremove.notes.p2')))])])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showRemoveConfirmation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.removeRequest.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.removeReferrer(_vm.markedForDelete.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.remove')))])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": _vm.dense
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.$emit("selected", item)
        }
      }
    }, [_vm._t("avatar-before", function() {
      return [(_vm.avatarPosition === "before" && _vm.avatarPath) ? _c('v-list-tile-avatar', [_c('img', {
        attrs: {
          "src": _vm.getObjectPath(item, _vm.avatarPath)
        }
      })]) : _vm._e()]
    }, {
      "item": item
    }), _vm._v(" "), _c('v-list-tile-content', [_vm._t("title", function() {
      return [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.getObjectPath(item, _vm.titlePath)) + "\n      ")])]
    }, {
      "item": item
    }), _vm._v(" "), _vm._t("subtitle", function() {
      return [(_vm.subTitlePath) ? _c('v-list-tile-sub-title', [_vm._v("\n        " + _vm._s(_vm.getObjectPath(item, _vm.subTitlePath)) + "\n      ")]) : _vm._e()]
    }, {
      "item": item
    })], 2), _vm._v(" "), _vm._t("avatar-after", function() {
      return [(_vm.avatarPosition === "after" && _vm.avatarPath) ? _c('v-list-tile-avatar', [_c('img', {
        attrs: {
          "src": _vm.getObjectPath(item, _vm.avatarPath)
        }
      })]) : _vm._e()]
    }, {
      "item": item
    })], 2), _vm._v(" "), (_vm.withDivider) ? _c('v-divider', {
      key: ("div-" + index)
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "outline": _vm.activeTab === 1,
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 0;
        _vm.setPreviousParams()
      }
    }
  }, [_vm._v("Recent and previous appointments")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "outline": _vm.activeTab === 0,
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 1;
        _vm.setUpcomingParams()
      }
    }
  }, [_vm._v("Upcoming appointments")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "mr-5 overline",
    attrs: {
      "label": ""
    }
  }, [_vm._v("\n      Today:\n      " + _vm._s(_vm.todaysDate) + "\n    ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('appointment-list', {
    attrs: {
      "dense": "",
      "group-by-month": "",
      "params": _vm.params,
      "title": _vm.title,
      "touch": _vm.fetchTrigger,
      "page-size": _vm.pageSize,
      "selected": _vm.selected,
      "loading": _vm.loading,
      "facets": "status,practitioner"
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:loading": function($event) {
        _vm.loading = $event
      },
      "update:request": _vm.setRequest
    }
  }, [_c('v-card-title', {
    staticClass: "py-0 hidden-xs-only",
    attrs: {
      "slot": "top"
    },
    slot: "top"
  }, [_c('v-spacer'), _vm._v(" "), _c('status-picker', {
    attrs: {
      "facets": _vm.facetCount.status
    },
    on: {
      "input": _vm.updateParams
    },
    model: {
      value: (_vm.statuses),
      callback: function($$v) {
        _vm.statuses = $$v
      },
      expression: "statuses"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _vm._l((_vm.practitioners), function(p) {
    return _c('v-chip', {
      key: p.id,
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.setSelectedPractitioner(p.id)
        }
      }
    }, [_c('v-avatar', {
      staticClass: "white--text mr-0 grey darken-2",
      attrs: {
        "dark": ""
      }
    }, [_vm._v(_vm._s(p.count))]), _vm._v(" "), (p.img) ? _c('v-avatar', {
      staticClass: "ml-1"
    }, [_c('v-img', {
      attrs: {
        "src": p.img
      }
    })], 1) : _vm._e(), _vm._v("\n\n        " + _vm._s(p.full_name) + "\n\n        "), (_vm.isSelectedPractitioner(p.id)) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), (_vm.relationship && _vm.relationship.id) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "top": "",
      "right": "",
      "small": "",
      "dark": "",
      "absolute": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        return _vm.launchCreateAppointment({
          relationship: _vm.relationship
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "mt-0 pa-0",
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.invoices), function(invoice) {
    return [_c('invoice-list-item', {
      key: ("item-" + (invoice.id)),
      class: {
        'light-blue lighten-5': _vm.isSelected(invoice)
      },
      attrs: {
        "withStatus": _vm.withStatus,
        "withStatusBorder": _vm.withStatusBorder,
        "invoice": invoice
      },
      on: {
        "clicked": function($event) {
          return _vm.$emit("selected", invoice)
        }
      }
    }, [(_vm.actions.length > 0) ? _c('v-list-tile-action', {
      staticClass: "thin",
      attrs: {
        "slot": "actionsBefore"
      },
      slot: "actionsBefore"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSelectedInvoice(invoice)
        }
      }
    }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.primaryAction) ? _c('v-list-tile-action', {
      attrs: {
        "slot": "actionsAfter"
      },
      slot: "actionsAfter"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('primarycta', invoice)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(_vm.primaryAction.icon))])], 1)], 1) : _c('v-list-tile-action', {
      attrs: {
        "slot": "actionsAfter"
      },
      slot: "actionsAfter"
    }, [_c('strong', {
      staticClass: "subheading mt-3"
    }, [_vm._v(_vm._s(_vm.getAmountDue(invoice)))]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("Due")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (invoice.id))
    })]
  }), _vm._v(" "), (_vm.invoices && _vm.invoices.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [(!_vm.loading) ? _c('span', [_vm._v("No invoices found")]) : _c('span', [_c('v-progress-circular', {
    staticClass: "amber--text",
    attrs: {
      "size": 10,
      "width": 1,
      "small": "",
      "indeterminate": ""
    }
  }), _vm._v("\n            loading ..\n          ")], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "scrollable": ""
    },
    model: {
      value: (_vm.bottomsheet),
      callback: function($$v) {
        _vm.bottomsheet = $$v
      },
      expression: "bottomsheet"
    }
  }, [(_vm.selectedInvoice && _vm.selectedInvoice.id) ? [_c('v-subheader', {
    staticClass: "grey lighten-4 overline py-0 my-0"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("post_add")]), _vm._v("\n          " + _vm._s(_vm.selectedInvoice.title) + "\n          "), (_vm.viewUrl) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "icon": "",
      "target": "_blank",
      "href": _vm.viewUrl
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "small": "",
      "flat": "",
      "outline": _vm.sheetWindow === 0,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sheetWindow = 0
      }
    }
  }, [_vm._v("Actions")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "outline": _vm.sheetWindow === 1,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sheetWindow = 1
      }
    }
  }, [_vm._v("Appointments")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.selectedInvoice.status) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    staticStyle: {
      "padding": "0px 5px",
      "margin": "0px",
      "float": "right"
    },
    attrs: {
      "color": _vm.statusColor,
      "text-color": "white",
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.selectedInvoice.status.toUpperCase()) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.closeBottomSheet
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.sheetWindow),
      callback: function($$v) {
        _vm.sheetWindow = $$v
      },
      expression: "sheetWindow"
    }
  }, [_c('v-window-item', [_c('v-list', _vm._l((_vm.actions), function(action) {
    return _c('v-list-tile', {
      key: action.icon,
      attrs: {
        "disabled": action.disableIf && action.disableIf(_vm.selectedInvoice),
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.$root.$emit(action.action, _vm.selectedInvoice);
          _vm.bottomsheet = false
        }
      }
    }, [_c('v-list-tile-title', {
      on: {
        "click": function($event) {
          return _vm.$emit(action.action, _vm.selectedInvoice)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(action.icon))]), _vm._v(" " + _vm._s(action.text) + "\n                  ")], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', [_c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "overflow-y": "auto",
      "height": "550px"
    }
  }, [_c('invoice-payments', {
    attrs: {
      "invoice": _vm.selectedInvoice,
      "transactions": _vm.selectedInvoice.transaction_set
    }
  }, [_c('template', {
    slot: "subheader"
  }, [_c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "small": "",
      "outline": "",
      "color": "primary",
      "disabled": !_vm.selectedInvoice,
      "loading": _vm.requests.enrich.loading
    },
    on: {
      "click": _vm.refreshInvoice
    }
  }, [_vm._v("\n                        Update invoice\n                        "), _c('help-popover', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("\n                          Click to update the appointments on this invoice."), _c('br'), _vm._v("\n                          Changes below are on the appointments attached to this invoice."), _c('br'), _vm._v("\n                          Make sure to click this button to update your invoice to reflect any changes made below.\n                        ")])], 1), _vm._v(" "), (_vm.requests.enrich.status === 200) ? _c('span', {
    staticClass: "caption success--text"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Invoice updated\n                    ")], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1)], 1)] : _vm._e()], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', _vm._b({
    attrs: {
      "flat": ""
    }
  }, 'v-card', _vm.attrs, false), [_c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_c('v-btn', {
    staticClass: "ml-1 pl-0",
    attrs: {
      "loading": _vm.request.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.debounceExpensiveMethod
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-3",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _vm._t("toolbar-before"), _vm._v(" "), (_vm.views && _vm.views.length > 0) ? _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "outline": ""
          },
          slot: "activator"
        }, on), [_vm._v("\n          " + _vm._s(_vm.selectedView.title) + "\n          "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }], null, false, 550626377)
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "overline py-1 my-0 grey lighten-4"
  }, [_vm._v("\n            Quick filters\n          ")]), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.views), function(view) {
    return [_c('v-list-tile', {
      key: view.title,
      on: {
        "click": function($event) {
          _vm.selectedView = view
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(view.title)
      }
    })], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (view.title))
    })]
  })], 2)], 1)], 1) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("toolbar"), _vm._v(" "), _vm._t("pagination", function() {
    return [(_vm.totalPages && _vm.totalPages > 1) ? [(_vm.totalPages > 3) ? _c('v-btn', {
      staticClass: "hidden-xs-only",
      attrs: {
        "disabled": _vm.page <= 2 || _vm.request.loading,
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.page = 1
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fast_rewind")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "disabled": _vm.page <= 1 || _vm.request.loading,
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.page--
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('span', {
      staticClass: "ml-2"
    }, [_vm._v("\n            " + _vm._s(Math.max(1, (_vm.page - 1) * _vm.pageSize)) + " -\n            " + _vm._s(Math.min(_vm.numResults, _vm.page * _vm.pageSize)) + " of\n            " + _vm._s(_vm.numResults) + "\n          ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "disabled": _vm.page >= _vm.totalPages || _vm.request.loading,
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.page++
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("chevron_right")])], 1), _vm._v(" "), (_vm.totalPages > 3) ? _c('v-btn', {
      staticClass: "hidden-xs-only",
      attrs: {
        "disabled": _vm.page >= _vm.totalPages || _vm.request.loading,
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.page = _vm.totalPages
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fast_forward")])], 1) : _vm._e()] : _vm._e()]
  }), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-up"
  }), _vm._v(" "), (_vm.withAdd) ? [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")])], 1)] : _vm._e(), _vm._v(" "), _vm._t("toolbar-end"), _vm._v(" "), [(_vm.cards) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('update:cards', false)
      }
    }
  }, [_c('v-icon', [_vm._v("unfold_less")])], 1) : _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('update:cards', true)
      }
    }
  }, [_c('v-icon', [_vm._v("unfold_more")])], 1)], _vm._v(" "), (_vm.multiple && _vm.withSelectAll) ? [(_vm.selectAll === false) ? _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.selectAll = true
      }
    }
  }, [_vm._v("check_box_outline_blank")]) : _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.selectAll = false
      }
    }
  }, [_vm._v("check_box")])] : _vm._e()], 2), _vm._v(" "), _vm._t("top"), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0 elevation-0 grey lighten-4",
    attrs: {
      "subheader": "",
      "three-line": "",
      "dense": _vm.dense
    }
  }, [(_vm.withSearch) ? [_c('v-text-field', {
    staticClass: "ma-0 pl-3 pt-0",
    attrs: {
      "single-line": "",
      "hide-details": "",
      "prepend-inner-icon": "search",
      "label": "search within results"
    }
  }), _vm._v(" "), _c('v-divider')] : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredAppointments), function(appt, index) {
    return _c('v-card', {
      key: ("card-" + (appt.id)),
      class: {
        'ma-2': _vm.cards
      },
      attrs: {
        "flat": !_vm.cards
      }
    }, [(_vm.withSubheaders && _vm.isNewCategory(index, _vm.filteredAppointments, 'title')) ? _c('v-subheader', {
      staticClass: "overline py-0 my-0 grey lighten-4"
    }, [_vm._v("\n          " + _vm._s(appt.title) + "\n      ")]) : _c('appointment-list-item', _vm._b({
      class: {
        "cyan lighten-4": _vm.isSelected(appt)
      },
      attrs: {
        "appointment": appt,
        "with-actions": false,
        "with-action": _vm.withAction,
        "with-pricing": _vm.withPrice,
        "with-color-coding": false,
        "with-status-chips": true
      },
      on: {
        "listitem:clicked": _vm.appointmentSelected
      }
    }, 'appointment-list-item', _vm.listAttrs, false), [(_vm.withActions) ? _c('template', {
      slot: "actions"
    }, [_vm._t("listaction", function() {
      return [_c('v-btn', {
        attrs: {
          "icon": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.showOptions(appt)
          }
        }
      }, [_c('v-icon', [_vm._v("more_vert")])], 1)]
    }, {
      "appointment": appt
    })], 2) : _c('template', {
      slot: "actions"
    }, [_vm._t("listaction", null, {
      "appointment": appt
    })], 2), _vm._v(" "), (_vm.multiple) ? _c('template', {
      slot: "action"
    }, [_c('v-divider', {
      staticClass: "ml-1",
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [(_vm.isSelected(appt)) ? _c('v-icon', [_vm._v("check_box")]) : _c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.cards && appt.codes && appt.codes.length > 0) ? _c('v-card', {
      staticClass: "ma-0",
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.launchDiagnosisCodes({
            value: appt,
            appointmentId: appt.id,
            editable: true,
            withTitle: true,
            withTotal: true,
            withRefresh: true,
            withInvoiceable: true
          })
        }
      }
    }, [_c('v-card-title', {
      staticClass: "pb-0 pt-1 overline"
    }, [_vm._v("Codes\n          ")]), _vm._v(" "), _c('v-card-text', _vm._l((appt.codes), function(code) {
      return _c('v-layout', {
        key: code.id
      }, [_c('v-flex', {
        attrs: {
          "xs6": ""
        }
      }, [_vm._v(_vm._s(code.icd10))]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }, [_vm._v(_vm._s(code.process))]), _vm._v(" "), _c('v-flex', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "xs3": ""
        }
      }, [_vm._v("\n              " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n            ")])], 1)
    }), 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.filteredAppointments && _vm.filteredAppointments.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.noResultsText)
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), (_vm.withActions && _vm.selectedAppointment && _vm.selectedAppointment.id) ? _c('appointment-bottom-sheet', {
    attrs: {
      "appointment": _vm.selectedAppointment
    },
    model: {
      value: (_vm.showBottomSheet),
      callback: function($$v) {
        _vm.showBottomSheet = $$v
      },
      expression: "showBottomSheet"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "return-value": _vm.date,
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.label,
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showPicker = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog.save(_vm.date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.filteredPeople), function(person) {
    return [(person) ? _c('person-list-item', {
      key: person.id,
      attrs: {
        "with-edit": _vm.withEdit,
        "person": person
      },
      on: {
        "selected": function($event) {
          return _vm.$emit("selected", person)
        },
        "edit": function($event) {
          return _vm.$emit("selected", person)
        }
      }
    }) : _vm._e(), _vm._v(" "), (person) ? _c('v-divider', {
      key: ("div-" + (person.id))
    }) : _vm._e()]
  }), _vm._v(" "), _c('v-layout', [(_vm.filteredPeople && _vm.filteredPeople.length === 0 && _vm.request && _vm.request.loading) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "20",
      "width": "2",
      "indeterminate": "",
      "color": "amber"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t("notices.searching")) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.filteredPeople && _vm.filteredPeople.length === 0 && _vm.request && !_vm.request.loading) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("notices.noresults")) + "\n    ")]) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": false,
      "message401": null,
      "message404": "Could not find a matching incoming notification from JotForm - some fields may not be formatted correctly"
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-1 overline grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.getSubmission
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    Submission:\n    "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.request.status === 401,
      "text": ""
    }
  }, [_vm._v("\n    Unable to fetch this response from JotForm (permission denied).\n    Have you uninstalled the integration or changed your API key?\n    "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Open submission in JotForm")])]), _vm._v(" "), (_vm.submission && _vm.submission.id) ? _c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Answers\n      "), _c('v-spacer'), _vm._v(" "), (_vm.submissionLink) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "href": _vm.submissionLink,
      "target": "_blank"
    }
  }, [_vm._v("\n        Open in JotForm\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.submission.answers), function(answer, index) {
    return [(answer.answer) ? [_c('v-card', {
      key: ((_vm.submission.id) + "-" + (answer.name)),
      attrs: {
        "flat": ""
      }
    }, [(answer.type === 'control_head') ? _c('v-subheader', [_vm._v(_vm._s(answer.text))]) : _vm._e(), _vm._v(" "), (answer.type === 'control_divider') ? _c('v-divider') : _vm._e(), _vm._v(" "), (answer.answer) ? _c('v-card-text', {
      staticClass: "py-1 px-3"
    }, [(answer.type === 'control_signature') ? [_c('v-subheader', {
      staticClass: "overline"
    }, [_vm._v("Signature:")]), _c('br'), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.getRawAnswer(index, answer)
      }
    }), _vm._v(" "), (answer.prettyFormat) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.sanitize(answer.prettyFormat))
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), (answer.type === 'control_fileupload') ? [_c('strong', [_vm._v(_vm._s(answer.text))]), _vm._v(" "), (answer.prettyFormat) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.sanitize(answer.prettyFormat))
      }
    }) : _vm._e()] : [_c('strong', [_vm._v(_vm._s(answer.text))]), _vm._v(" "), (answer.prettyFormat) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.sanitize(answer.prettyFormat))
      }
    }) : _c('div', [_vm._v(_vm._s(answer.answer))])]], 2) : _vm._e()], 1), _vm._v(" "), (answer.answer) ? _c('v-divider', {
      key: ("div-" + (_vm.submission.id) + "-" + (answer.name) + "-" + index)
    }) : _vm._e()] : _vm._e()]
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")])], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._t("prepend"), _vm._v(" "), _vm._l((_vm.selectedSpaces), function(space, index) {
    return _c('v-tooltip', {
      key: ((space.id) + "-" + index),
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-avatar', _vm._g({
            staticClass: "ml-1",
            attrs: {
              "color": space.color,
              "size": _vm.size
            }
          }, on), [(space.logo_picture) ? _c('v-img', {
            attrs: {
              "src": _vm.imageKitUrl(space.logo_picture, "n-avatar")
            }
          }) : _c('span', {
            staticClass: "white--text"
          }, [(space && space.title) ? [_vm._v(_vm._s(space.title[0]))] : _vm._e()], 2)], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getTitle(space)))])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "icon": "",
            "loading": _vm.downloading || _vm.getClientsRequest.loading
          },
          on: {
            "click": _vm.download
          }
        }, on), [_c('v-icon', [_vm._v("cloud_download")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Download your client list as a csv file")])]), _vm._v("\n    Clients\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/clients/merge"
    }
  }, [_c('v-icon', [_vm._v("merge_type")]), _vm._v("\n      Merge clients\n    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'CreateClient')
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" New client\n    ")], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.requests.appointmentInRange
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "hidden-xs-only"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_vm._v("\n        You saw these\n        "), _c('v-chip', {
    staticClass: "green white--text",
    attrs: {
      "label": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.clientsInRange.length) + " clients\n        ")], 1), _vm._v("\n        from\n        "), _c('v-chip', {
    attrs: {
      "label": ""
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("ACTIVATE_RANGE_PICKER")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("event")]), _vm._v(" " + _vm._s(_vm.globalActiveDateRangeFormatted) + "\n        ")], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('birthday-bar')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.visibleClients), function(clientId) {
    return _c('v-flex', {
      key: clientId,
      attrs: {
        "xs12": "",
        "md6": "",
        "lg6": "",
        "xl4": ""
      }
    }, [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [(_vm.getClientById(clientId) && _vm.getClientById(clientId).id) ? _c('client-list-item', {
      attrs: {
        "client": _vm.getClientById(clientId),
        "relationship-id": _vm.getClientById(clientId).id,
        "with-details": false
      },
      on: {
        "listitem:clicked": function($event) {
          return _vm.gotoClient(clientId)
        }
      }
    }, [_c('v-list-tile-sub-title', {
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(_vm.appointmentsByClient[clientId].length) + " appointment"), (_vm.appointmentsByClient[clientId].length > 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(".\n                Due: " + _vm._s(_vm.formatCurrency(_vm.appointmentsByClient[clientId][0].currency, _vm.appointmentsByClient[clientId].totalOwed)) + ".\n                Paid: " + _vm._s(_vm.formatCurrency(_vm.appointmentsByClient[clientId][0].currency, _vm.appointmentsByClient[clientId].totalPaid)) + "\n              ")])], 1) : _c('v-list-tile', [_c('v-list-tile-action', [_c('v-progress-circular', {
      attrs: {
        "width": "2",
        "indeterminate": "",
        "color": "amber"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("loading ..")])], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)
  }), 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "pt-2"
  }, [_vm._v("Showing " + _vm._s(_vm.displayLimit) + " of " + _vm._s(_vm.clientsInRange.length))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.displayLimit += _vm.displayLimit
      }
    }
  }, [_vm._v("Load more")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n    Delete this appointment and other appointments in the series\n  ")]), _vm._v(" "), (!_vm.successfullyDeleted) ? _c('v-card-text', [_c('v-switch', {
    attrs: {
      "persistent-hint": "",
      "label": "Only delete this appointment and appointments that start after it",
      "hint": _vm.deleteHintText
    },
    model: {
      value: (_vm.futureOnly),
      callback: function($$v) {
        _vm.futureOnly = $$v
      },
      expression: "futureOnly"
    }
  })], 1) : _c('v-card-text', [_c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n      Appointments successfully deleted\n      "), _c('v-btn', {
    attrs: {
      "to": "/calendar",
      "outlined": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n        Return to calendar\n      ")])], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.successfullyDeleted,
      "loading": _vm.loading,
      "color": "error"
    },
    on: {
      "click": _vm.performDelete
    }
  }, [_vm._v("\n      Delete appointments\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "hidden-ios-true hidden-android-true"
  }, [_c('v-card-text', [_c('h3', {
    staticClass: "headline"
  }, [_vm._v("Get the app")])]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "subheading"
  }, [_vm._v("Download the AppointmentGuru app on your phone so you can manage everything on the go!")]), _vm._v(" "), (_vm.installer) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.installMobile
    }
  }, [_vm._v("Install on this device")]) : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("To install on iOS: ")]), _vm._v(" "), _c('li', [_vm._v("Click on the share icon "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("ios_share")])], 1), _vm._v(" "), _c('li', [_vm._v("Scroll and click on \"add to home screen\"")]), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("To install on Android: ")]), _vm._v(" "), _c('p', [_vm._v("If you visit\n        "), _c('a', {
    attrs: {
      "href": "https://app.appointmentguru.co"
    }
  }, [_vm._v("app.appointmentguru.co")]), _vm._v("\n        you should be prompted to install the app\n      ")]), _vm._v(" "), _c('strong', {
    staticClass: "overline"
  }, [_vm._v("If not, try this:")]), _vm._v(" "), _c('li', [_vm._v("Click on the three dots (top right in Chrome)")]), _vm._v(" "), _c('li', [_vm._v("Click on \"Install app\"")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-card-text', [_c('h3', {
    staticClass: "headline"
  }, [_vm._v("Calender")]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_vm._v("Use the address below to sync your AppointmentGuru calendar to your phone calendar app.")])]), _vm._v(" "), _c('v-card-text', [_c('copy-text-field', {
    attrs: {
      "label": "Your calendar address",
      "hint": "Add your calendar feed to pull your AppointmentGuru appointments into your calendar of choice",
      "text-to-copy": _vm.feedUrl
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "href": "https://appointmentguru.co/help/sync-to-a-phone-calendar-app/",
      "target": "_blank"
    }
  }, [_vm._v("More info "), _c('v-icon', [_vm._v("open_in_new")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.person)
      }
    }
  }, [_vm._t("tile-before-content", function() {
    return [_c('v-list-tile-avatar', [_c('v-avatar', [(_vm.person.profile_picture) ? _c('img', {
      attrs: {
        "src": _vm.person.profile_picture
      }
    }) : _c('v-icon', [_vm._v("\n        account_circle\n      ")])], 1)], 1)]
  }), _vm._v(" "), _c('v-list-tile-content', [_vm._t("tile-title", function() {
    return [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(_vm.person.title) + "\n        " + _vm._s(_vm.person.initials) + "\n        " + _vm._s(_vm.person.first_name) + "\n        " + _vm._s(_vm.person.last_name) + "\n        "), (_vm.person.nickname) ? _c('span', [_vm._v("(" + _vm._s(_vm.person.nickname) + ")")]) : _vm._e()])]
  }), _vm._v(" "), _vm._t("tile-sub-title", function() {
    return [(!_vm.compact) ? _c('v-list-tile-sub-title', [_c('v-icon', [_vm._v("phone")]), _vm._v(" " + _vm._s(_vm.person.cell_phone) + "\n      ")], 1) : _vm._e()]
  }), _vm._v(" "), _vm._t("tile-extra", function() {
    return [(!_vm.compact) ? _c('v-list-tile-sub-title', [_c('v-icon', [_vm._v("email")]), _vm._v(" " + _vm._s(_vm.person.email) + "\n      ")], 1) : _vm._e()]
  })], 2), _vm._v(" "), _vm._t("tile-after-content", function() {
    return [(_vm.withEdit) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit("edit", _vm.person)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.backgroundDialog),
      callback: function($$v) {
        _vm.backgroundDialog = $$v
      },
      expression: "backgroundDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n          Choose a background picture\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.backgroundDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('image-search', {
    attrs: {
      "title": "Search for an image"
    },
    on: {
      "input": _vm.saveBackground
    },
    model: {
      value: (_vm.profile.background_picture),
      callback: function($$v) {
        _vm.$set(_vm.profile, "background_picture", $$v)
      },
      expression: "profile.background_picture"
    }
  })], 1)], 1), _vm._v(" "), _c('v-img', {
    attrs: {
      "height": "250",
      "src": _vm.backgroundPicture
    }
  }, [_c('v-card-title', {
    staticClass: "title pl-4 white--text",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.me.first_name) + " " + _vm._s(_vm.me.last_name) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "small": "",
      "loading": _vm.getMeReq.loading
    },
    on: {
      "click": _vm.getMe
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = true
      }
    }
  }, [_vm._v("\n          Change profile picture\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.backgroundDialog = true
      }
    }
  }, [_vm._v("\n          Change background picture\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.profile.profile_picture) ? _c('v-avatar', {
    staticClass: "elevation-10",
    staticStyle: {
      "margin-top": "-120px",
      "margin-left": "50px"
    },
    attrs: {
      "absolute": "",
      "size": 180
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = true
      }
    }
  }, [(_vm.getMeReq.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "size": 100
    }
  }) : _c('v-img', {
    attrs: {
      "src": _vm.profile.profile_picture,
      "height": "180",
      "width": "180"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.logoDialog),
      callback: function($$v) {
        _vm.logoDialog = $$v
      },
      expression: "logoDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Update your Profile picture\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('uploader', {
    attrs: {
      "path": _vm.profilePath,
      "filename": "profile_picture"
    },
    on: {
      "uploadsuccess": function($event) {
        _vm.getMe();
        _vm.logoDialog = false
      }
    },
    scopedSlots: _vm._u([{
      key: "gallery",
      fn: function(props) {
        return [_c('v-subheader', [_vm._v("Examples of how this may look in various places")]), _vm._v(" "), _vm._l((props.images), function(img, index) {
          return _c('v-layout', {
            key: index
          }, [_c('v-flex', [_c('v-subheader', [_vm._v("Avatar view")]), _vm._v(" "), _c('v-avatar', [_c('img', {
            attrs: {
              "src": img
            }
          })])], 1), _vm._v(" "), _c('v-flex', [_c('v-subheader', [_vm._v("Normal view")]), _vm._v(" "), _c('img', {
            attrs: {
              "src": img
            }
          })], 1)], 1)
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3",
    attrs: {
      "tile": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.me
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Contact details\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.contactsForm), function(field) {
    return _c('v-flex', {
      key: field.label,
      class: field.flexClass
    }, [(field.type === "divider") ? _c('v-divider') : _c('v-text-field', {
      attrs: {
        "hint": field.hint,
        "label": field.label,
        "multi-line": field.multiLine,
        "error-messages": _vm.getErrors(_vm.requests.me, field.model)
      },
      model: {
        value: (_vm.me[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.me, field.model, $$v)
        },
        expression: "me[field.model]"
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.getMeReq.loading
    },
    on: {
      "click": _vm.getMe
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.me.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveMe
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.profile
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Extra information\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('profession-picker', {
    model: {
      value: (_vm.profile.profession),
      callback: function($$v) {
        _vm.$set(_vm.profile, "profession", $$v)
      },
      expression: "profile.profession"
    }
  }), _vm._v(" "), _vm._l((_vm.extrasForm), function(field) {
    return [(field.type === "divider") ? _c('v-divider', {
      key: field.label
    }) : (field.type === "checkbox") ? _c('v-checkbox', {
      attrs: {
        "label": field.label,
        "error-messages": _vm.getErrors(_vm.requests.me, field.model)
      },
      model: {
        value: (_vm.profile[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.profile, field.model, $$v)
        },
        expression: "profile[field.model]"
      }
    }) : (field.component) ? _c(field.component, {
      tag: "component",
      attrs: {
        "attrs": field.attrs
      },
      model: {
        value: (_vm.profile[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.profile, field.model, $$v)
        },
        expression: "profile[field.model]"
      }
    }) : _c('v-text-field', {
      key: field.label,
      attrs: {
        "hint": field.hint,
        "label": field.label,
        "multi-line": field.multiLine,
        "error-messages": _vm.getErrors(_vm.requests.profile, field.model)
      },
      model: {
        value: (_vm.profile[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.profile, field.model, $$v)
        },
        expression: "profile[field.model]"
      }
    })]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.getMeReq.loading
    },
    on: {
      "click": _vm.getMe
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.profile.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveExtras
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.profile
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Social's\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._l((_vm.socialsForm), function(field) {
    return [(field.type === "divider") ? _c('v-divider', {
      key: field.label
    }) : _c('v-text-field', {
      key: field.label,
      attrs: {
        "hint": field.hint,
        "label": field.label,
        "multi-line": field.multiLine,
        "error-messages": _vm.getErrors(_vm.requests.profile, field.model)
      },
      model: {
        value: (_vm.profile[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.profile, field.model, $$v)
        },
        expression: "profile[field.model]"
      }
    })]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.getMeReq.loading
    },
    on: {
      "click": _vm.getMe
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.profile.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveSocials
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-card-title', [_c('h2', {
    staticClass: "overline"
  }, [_vm._v("Change your password")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Enter a new password",
      "hint": "At least 8 characters",
      "min": "8",
      "loading": _vm.changePasswordReq.loading,
      "append-icon": _vm.passwordVisible ? 'visibility' : 'visibility_off',
      "type": _vm.passwordVisible ? 'password' : 'text',
      "counter": ""
    },
    on: {
      "click:append": function($event) {
        _vm.passwordVisible = !_vm.passwordVisible
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('vuex-btn', {
    attrs: {
      "req-id": _vm.changePassReqId,
      "text": "Save"
    },
    on: {
      "save": _vm.changePassword
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', [_vm._l((_vm.groups), function(group) {
    return [_c('data-list', {
      key: ("group-" + (group.id)),
      staticClass: "pa-0",
      attrs: {
        "items": group.data,
        "title-path": "first_name",
        "sub-title-path": "profile.practice_name",
        "avatar-path": "profile.profile_picture",
        "avatar-position": "after"
      },
      on: {
        "selected": _vm.emitSelected
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function(props) {
          return [_vm._v("\n            " + _vm._s(props.item.first_name) + " " + _vm._s(props.item.last_name) + "\n        ")]
        }
      }, {
        key: "avatar-after",
        fn: function(props) {
          return [_c('v-list-tile-avatar', [(props.item.profile && props.item.profile.profile_picture) ? _c('img', {
            attrs: {
              "src": props.item.profile.profile_picture
            }
          }) : _c('v-icon', [_vm._v("account_circle")])], 1)]
        }
      }], null, true)
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline pb-0"
  }, [_vm._v("\n    Online meeting details\n    "), _c('v-spacer'), _vm._v(" "), (_vm.withedit) ? [(!_vm.editmode) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.editmode = true
      }
    }
  }, [_vm._v("Edit")]) : _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.editmode = false
      }
    }
  }, [_vm._v("Cancel")])] : _vm._e()], 2), _vm._v(" "), (!_vm.editmode) ? _c('v-card-text', [(_vm.appointment.zoom_meeting_id) ? [_c('strong', [_vm._v("Meeting ID:")]), _vm._v("\n        " + _vm._s(_vm.appointment.zoom_meeting_id) + "\n      ")] : _vm._e(), _vm._v(" "), (_vm.appointment.zoom_join_url) ? _c('copy-text-field', {
    attrs: {
      "label": "Meeting join url",
      "text-to-copy": _vm.appointment.zoom_join_url,
      "hint": "Your customer will use this to join the meeting"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appointment.zoom_meeting_password) ? _c('copy-text-field', {
    attrs: {
      "label": "Meeting password",
      "text-to-copy": _vm.appointment.zoom_meeting_password,
      "hint": "The password for this meeting"
    }
  }) : _vm._e()], 2) : _c('v-card-text', [_c('manual-online-meeting-form', {
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1), _vm._v(" "), (_vm.appointment.zoom_meeting_id) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "href": ("https://zoom.us/meeting/" + (_vm.appointment.zoom_meeting_id)),
      "target": "_blank"
    }
  }, [_vm._v("\n      View meeting\n      "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "href": _vm.appointment.zoom_start_url,
      "color": "primary",
      "target": "_blank"
    }
  }, [_vm._v("\n      Start meeting\n      "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [(_vm.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), _c('v-window-item', [(_vm.saveRequest) ? _c('request-status', {
    attrs: {
      "request": _vm.saveRequest
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "three-line": "",
      "dark": ""
    }
  }, [_c('appointment-list-item', {
    attrs: {
      "appointment": _vm.appointment,
      "with-color-coding": false,
      "with-status-chips": true,
      "with-action": false
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.viz.daymodal),
      callback: function($$v) {
        _vm.$set(_vm.viz, "daymodal", $$v)
      },
      expression: "viz.daymodal"
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [(!_vm.timeData.date) ? _c('v-list-tile-title', [_vm._v("Day")]) : _c('v-list-tile-title', [_c('v-btn', {
    staticClass: "ma-0 hidden-xs-only",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dateDelta(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v("\n                  " + _vm._s(_vm.dateformat(_vm.timeData.date, 'ddd DD MMM')) + "\n                  "), _c('v-btn', {
    staticClass: "ma-0 hidden-xs-only",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dateDelta(1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("click to change selected day")])], 1), _vm._v(" "), (_vm.appointment.day) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "full-width": "",
      "scrollable": "",
      "actions": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        _vm.viz.daymodal = false
      }
    },
    model: {
      value: (_vm.timeData.date),
      callback: function($$v) {
        _vm.$set(_vm.timeData, "date", $$v)
      },
      expression: "timeData.date"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "height": "32px"
    }
  }, [_c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.viz.starttime),
      callback: function($$v) {
        _vm.$set(_vm.viz, "starttime", $$v)
      },
      expression: "viz.starttime"
    }
  }, [_c('v-chip', {
    attrs: {
      "slot": "activator",
      "small": ""
    },
    slot: "activator"
  }, [(!_vm.timeData.start) ? _c('span', [_vm._v("Start time")]) : _c('span', [_vm._v(_vm._s(_vm.timeData.start))])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    attrs: {
      "full-width": "",
      "scrollable": "",
      "format": "24hr",
      "autosave": ""
    },
    on: {
      "input": _vm.startTimeChanged
    },
    model: {
      value: (_vm.timeData.start),
      callback: function($$v) {
        _vm.$set(_vm.timeData, "start", $$v)
      },
      expression: "timeData.start"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.viz.starttime = false
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.viz.starttime = false;
        _vm.viz.endtime = true
      }
    }
  }, [_vm._v("Choose end time "), _c('v-icon', [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_forward")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.viz.endtime),
      callback: function($$v) {
        _vm.$set(_vm.viz, "endtime", $$v)
      },
      expression: "viz.endtime"
    }
  }, [_c('v-chip', {
    attrs: {
      "slot": "activator",
      "small": ""
    },
    slot: "activator"
  }, [(!_vm.timeData.end) ? _c('span', [_vm._v("End time")]) : _c('span', [_vm._v(_vm._s(_vm.timeData.end))])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    attrs: {
      "full-width": "",
      "min": _vm.timeData.start,
      "scrollable": "",
      "format": "24hr",
      "autosave": ""
    },
    on: {
      "input": _vm.endTimeChanged
    },
    model: {
      value: (_vm.timeData.end),
      callback: function($$v) {
        _vm.$set(_vm.timeData, "end", $$v)
      },
      expression: "timeData.end"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.viz.endtime = false;
        _vm.viz.starttime = true
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("Change start time")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.viz.endtime = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.timeData.start && _vm.timeData.end) ? _c('v-list-tile-sub-title', [_vm._v("\n                    " + _vm._s(_vm.timeData.difference) + " minutes\n                  ")]) : _c('v-list-tile-sub-title', [_vm._v("\n                    Choose a start and end time\n                  ")])], 1), _vm._v(" "), (_vm.timeData.start && _vm.timeData.end) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "single-line": "",
      "disabled": !_vm.messageTarget
    }
  }, [_c('v-list-tile-avatar', [(_vm.apptDetailReq.loading || _vm.clientReq.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  }) : _c('v-checkbox', {
    attrs: {
      "disabled": !_vm.messageTarget
    },
    model: {
      value: (_vm.notifications),
      callback: function($$v) {
        _vm.notifications = $$v
      },
      expression: "notifications"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Notify the customer of the change?\n                ")]), _vm._v(" "), (_vm.messageTarget) ? _c('v-list-tile-sub-title', [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "color": "primary"
    }
  }, [(_vm.message.type === 'Email') ? _c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("email")]) : _vm._e(), _vm._v(" "), (_vm.message.type === 'SMS') ? _c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("phone")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.messageTarget) + "\n                  ")], 1)], 1) : _c('v-list-tile-sub-title', [_vm._v("\n                  Notifications are send via " + _vm._s(_vm.message.type) + ", and " + _vm._s(_vm.client.first_name) + " has no\n                  "), (_vm.message.type === "Email") ? _c('span', [_vm._v("email address")]) : _vm._e(), _vm._v(" "), (_vm.message.type === "SMS") ? _c('span', [_vm._v("phone number")]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "amber"
    }
  }, [_vm._v("warning")])], 1), _vm._v(" "), (_vm.notifications === true) ? _c('v-list-tile-sub-title', [_vm._v("\n                  We'll send an " + _vm._s(_vm.message.type) + " to the client informing them that their appointment has been rescheduled\n                ")]) : _c('v-list-tile-sub-title', [_vm._v("\n                  No notifications will be sent\n                ")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [(_vm.notifications) ? _c('v-icon', [_vm._v("notifications_on")]) : _c('v-icon', [_vm._v("notifications_off")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Reschedule")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', {
    staticClass: "overline"
  }, [_vm._v("From")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\n                " + _vm._s(_vm.dateformat(_vm.appointment.start_time, 'ddd DD MMM \\at HH:mma')) + "\n              ")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', {
    staticClass: "overline"
  }, [_vm._v("To")]), _vm._v(" "), _c('v-list-tile-title', [_c('v-icon', {
    staticClass: "mr-4",
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_forward")]), _vm._v("\n                " + _vm._s(_vm.dateformat(_vm.formattedAppointment.new_start_time, 'ddd DD MMM \\at HH:mma')) + "\n              ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": _vm.resetDateTime
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.clientErrors && _vm.clientErrors.length > 0) ? _c('span', {
    staticClass: "orange--text subheading"
  }, [_c('v-icon', {
    staticClass: "ml-2 mr-2",
    attrs: {
      "color": "orange"
    }
  }, [_vm._v("warning")]), _vm._v("\n              " + _vm._s(_vm.clientErrors[0]) + "\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isValid || !_vm.isNewTime,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n              Reschedule")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "sm6": ""
    }
  }, [(_vm.practitioner && _vm.timeData && _vm.timeData.date) ? _c('practitioner-day-view', {
    staticClass: "ma-2 elevation-10",
    attrs: {
      "with-title": "",
      "with-date-bar": "",
      "block-events": "",
      "with-week": "",
      "practitioner": _vm.practitioner,
      "date": _vm.timeData.date,
      "preview-event": _vm.previewEvent
    },
    on: {
      "slotSelected": _vm.setStartTime,
      "update:date": function($event) {
        return _vm.$set(_vm.timeData, "date", $event)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-layout', [_c('v-flex'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center ma-4"
  }, [_c('v-icon', {
    staticClass: "ma-4",
    attrs: {
      "size": "72",
      "color": "green"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n            Appointment Rescheduled\n          ")]), _vm._v(" "), (_vm.batchId) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Notifications:")]), _vm._v(" "), _c('batch-id-list', {
    attrs: {
      "batch-id": _vm.batchId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.updatedAppointment && _vm.updatedAppointment.id) ? _c('v-list', {
    staticClass: "my-0 py-0",
    attrs: {
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Updated appointment:")]), _vm._v(" "), _c('appointment-list-item', {
    attrs: {
      "with-status-chips": "",
      "with-color-coding": false,
      "appointment": _vm.updatedAppointment,
      "with-ction": false,
      "with-tags": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.init();
        _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pb-4",
    attrs: {
      "tile": "",
      "flat": _vm.flat
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.touch++
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    " + _vm._s(_vm.$t('comms.messagelist.title')) + "\n  ")], 1), _vm._v(" "), _c('communication-list', {
    attrs: {
      "touch": _vm.touch,
      "params": {
        'objects_appointment': _vm.appointment.id
      }
    },
    on: {
      "loading": _vm.setLoading
    }
  }), _vm._v(" "), (_vm.value && _vm.value.process) ? [_c('v-subheader', {
    staticClass: "overline mt-2"
  }, [_vm._v("Schedule")]), _vm._v(" "), _vm._l((_vm.value.process), function(process) {
    return _c('v-list', {
      key: process.id,
      staticClass: "mt-1",
      attrs: {
        "dense": ""
      }
    }, [_c('v-divider'), _vm._v(" "), _vm._l((process.triggers), function(trigger) {
      return [(trigger.task in _vm.SCHEDULED_TASKS) ? _c('v-list-tile', {
        key: trigger.id
      }, [(trigger.status === "N") ? [_c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "title": "Cancel",
          "color": "error"
        }
      }, [_vm._v("delete")])], 1)] : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.SCHEDULED_TASKS[trigger.task].title))]), _vm._v(" "), _c('v-list-tile-sub-title', [(trigger.time_offset_in_minutes === 0) ? _c('span', [_vm._v("Runs immediately")]) : _vm._e(), _vm._v(" "), (trigger.time_offset_in_minutes < 0) ? _c('span', [_vm._v("Runs " + _vm._s(Math.abs(trigger.time_offset_in_minutes) / 60) + " hrs before the appointment")]) : _vm._e()])], 1), _vm._v(" "), (trigger.status === "C") ? _c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "title": "Task run successfully",
          "color": "success"
        }
      }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (trigger.status === "N") ? [_c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "small": "",
          "title": "Scheduled",
          "color": "info"
        }
      }, [_vm._v("schedule_send")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("scheduled")])], 1)] : _vm._e(), _vm._v(" "), (trigger.status === "X") ? _c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "small": "",
          "title": "Scheduled",
          "color": "warning"
        }
      }, [_vm._v("event_busy")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("cancelled")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-divider', {
        key: ("div-" + (trigger.id))
      })]
    })], 2)
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('request-status', {
    attrs: {
      "request": _vm.appointmentRequest,
      "message404": "Unable to load appointment. You may not have sufficient permissions to view this appointment"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.appointmentRequest.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.loadAppointment
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (!_vm.editTitle) ? _c('v-toolbar-title', [(_vm.appointment.is_online) ? _c('v-icon', [_vm._v("headset_mic")]) : _vm._e(), _vm._v(" "), (_vm.appointment.title) ? _c('span', [_vm._v(_vm._s(_vm.appointment.title))]) : _c('span', [_vm._v(_vm._s(_vm.appointment.full_name))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.editTitle = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("edit")])], 1)], 1) : _c('v-text-field', {
    staticClass: "ml-0 mt-3",
    attrs: {
      "dense": "",
      "loading": _vm.editAppointmentRequest.loading,
      "append-icon": "save",
      "append-outer-icon": "cancel",
      "label": "Appointment title"
    },
    on: {
      "click:append": function($event) {
        return _vm.savetitle(_vm.appointment.title)
      },
      "click:append-outer": function($event) {
        _vm.editTitle = false
      }
    },
    model: {
      value: (_vm.appointment.title),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "title", $$v)
      },
      expression: "appointment.title"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.appointment.is_online) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n      Online\n    ")]) : _vm._e(), _vm._v(" "), (_vm.appointment.source && _vm.appointment.source.startsWith("online-booking")) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": "",
      "dark": "",
      "color": "success"
    }
  }, [_vm._v("\n      Booked online\n    ")]) : _vm._e(), _vm._v(" "), (_vm.appointment.status) ? _c('v-chip', {
    class: _vm.formatStatus(_vm.appointment.status).theme,
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.formatStatus(_vm.appointment.status).title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('action-menu', {
    attrs: {
      "appointment": _vm.appointment,
      "exclude": ["open_appointment"]
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.appointment && _vm.appointment.id) ? [_c('flexible-component-container', {
    attrs: {
      "items": _vm.items,
      "isCompact": _vm.isCompact
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "caption pl-3"
  }, [_vm._v("\n    #" + _vm._s(_vm.appointment.id) + ".\n    Created: " + _vm._s(_vm.dateformat(_vm.appointment.created_date, 'ddd DD MMM YYYY \\at HH:mm')) + ".\n    Source: " + _vm._s(_vm.appointment.source) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.send
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "dark": ""
    }
  }, [_c('invoice-list-item', {
    attrs: {
      "invoice": _vm.invoiceDetail
    }
  }, [_c('template', {
    slot: "actionsAfter"
  }, [_c('v-list-tile-action', [_c('strong', {
    staticClass: "subheading mt-3"
  }, [_vm._v("\n                " + _vm._s(_vm.formatCurrency(_vm.invoiceDetail.currency, _vm.invoiceDetail.amount_due)) + "\n              ")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("Due")])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.requests.get.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.invoicePreviewUrl) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "target": "_blank",
      "href": _vm.invoicePreviewUrl
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1) : _vm._e()], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("Medical Aid Information as displayed on invoice:")]), _vm._v(" "), _c('pre', {
    staticClass: "text-small mad pa-2"
  }, [_vm._v(_vm._s(_vm.invoiceDetail.medicalaid_details))]), _vm._v(" "), _c('v-window', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("\n              Choose a medical aid\n            ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "readonly": "",
      "outline": "",
      "persistent-hint": "",
      "value": _vm.medicalaid.name,
      "hint": _vm.medicalAidHint,
      "label": "medical aid",
      "append-icon": "arrow_drop_down"
    },
    on: {
      "click:append": function($event) {
        _vm.choosemedicalaiddialog = true
      },
      "click": function($event) {
        _vm.choosemedicalaiddialog = true
      }
    }
  }), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_vm._v("\n              Use a custom email\n              "), _c('v-icon', {
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("\n              Custom email address\n            ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "outline": "",
      "persistent-hint": "",
      "clearable": "",
      "type": "email",
      "hint": "Write the email address for the medical aid you want to send this invoice to",
      "label": "Enter an email address"
    },
    model: {
      value: (_vm.customemail),
      callback: function($$v) {
        _vm.customemail = $$v
      },
      expression: "customemail"
    }
  }), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v("\n              Search for an email\n            ")], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.choosemedicalaiddialog),
      callback: function($$v) {
        _vm.choosemedicalaiddialog = $$v
      },
      expression: "choosemedicalaiddialog"
    }
  }, [_c('v-sheet', {
    attrs: {
      "height": "600"
    }
  }, [_c('medical-aid-picker', {
    on: {
      "input": function($event) {
        _vm.choosemedicalaiddialog = false
      }
    },
    model: {
      value: (_vm.medicalaid),
      callback: function($$v) {
        _vm.medicalaid = $$v
      },
      expression: "medicalaid"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), (_vm.medicalAidEmail) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0 pt-0",
    model: {
      value: (_vm.sendFrom),
      callback: function($$v) {
        _vm.sendFrom = $$v
      },
      expression: "sendFrom"
    }
  }, [_c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Send from\n                "), _c('help-popover', {
    staticClass: "ml-4"
  }, [_vm._v("\n                  The medical aid will send status updates to this email address\n                ")])], 1), _vm._v(" "), _c('v-radio', {
    attrs: {
      "persistent-hint": "",
      "value": "me",
      "label": "Send from my email address",
      "hint": "Replies and notifications from medical aid will come to this email address"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "persistent-hint": "",
      "disabled": !_vm.clientHasEmail,
      "value": "client",
      "label": "Send from the client's email address",
      "hint": "Replies and notifications from medical aid will be sent to your client"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0 pt-0",
    model: {
      value: (_vm.reimburse),
      callback: function($$v) {
        _vm.reimburse = $$v
      },
      expression: "reimburse"
    }
  }, [_c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("\n                Who should be re-imbursed\n                "), _c('help-popover', {
    staticClass: "ml-4"
  }, [_vm._v("\n                  We'll add a note to the email.\n                  We can't guarantee the provider will necessary get this right though\n                ")])], 1), _vm._v(" "), _c('v-radio', {
    attrs: {
      "persistent-hint": "",
      "value": "me",
      "label": "Me"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "persistent-hint": "",
      "value": "client",
      "label": "Client"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "cc me on the email"
    },
    model: {
      value: (_vm.ccme),
      callback: function($$v) {
        _vm.ccme = $$v
      },
      expression: "ccme"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.medicalAidEmail) ? _c('div', {
    staticClass: "blue lighten-4 pa-1 px-3"
  }, [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n              Invoice will be sent")], 1), _vm._v(" "), (_vm.step === 0) ? _c('div', [_vm._v("\n              to: "), _c('strong', [_vm._v(_vm._s(_vm.medicalaid.name) + " «" + _vm._s(_vm.medicalAidEmail) + "»")])]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('div', [_vm._v("\n              to: "), _c('strong', [_vm._v("«" + _vm._s(_vm.medicalAidEmail) + "»")])]) : _vm._e(), _vm._v(" "), (_vm.fromPerson && _vm.fromPerson.email) ? _c('div', [_vm._v("\n              from: "), _c('strong', [_vm._v(_vm._s(_vm.fromPerson.first_name) + " " + _vm._s(_vm.fromPerson.last_name) + " «" + _vm._s(_vm.fromPerson.email) + "»")])]) : _vm._e(), _vm._v(" "), (_vm.ccme) ? _c('div', [_vm._v("\n              cc: "), _c('strong', [_vm._v(_vm._s(_vm.me.first_name) + " " + _vm._s(_vm.me.last_name) + " «" + _vm._s(_vm.me.email) + "»")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [(_vm.withCancel) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.send.loading,
      "disabled": !_vm.medicalAidEmail,
      "color": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send\n          "), _c('v-icon', {
    staticClass: "ml-2 small"
  }, [_vm._v("send")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "flat": ""
    }
  }, [_c('center', [
    [_c('h3', {
      staticClass: "pt-4 headline"
    }, [_vm._v("Invoice submitted")]), _vm._v(" "), _c('v-icon', {
      staticClass: "pa-4",
      attrs: {
        "size": "72",
        "color": "success"
      }
    }, [_vm._v("check_circle")]), _vm._v(" "), _c('message-delivery-status', {
      attrs: {
        "batch-id": _vm.batchId
      }
    })]
  ], 2), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-5"
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit("close");
        _vm.window = 0
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.title) ? _c('v-card-title', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('a', {
    attrs: {
      "target": "_top",
      "href": _vm.snapUrl
    }
  }, [_c('img', {
    staticStyle: {
      "min-width": "150px",
      "min-height": "150px"
    },
    attrs: {
      "src": _vm.snapImg
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('info')))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "dark": _vm.dark,
      "flat": "",
      "height": "100%"
    }
  }, [_c('v-img', {
    class: {
      "white--text": !_vm.dark
    },
    attrs: {
      "src": _vm.backgroundImg,
      "height": "180px",
      "gradient": "to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
    }
  }, [_c('v-layout', [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mt-4",
          attrs: {
            "slot": "activator",
            "fab": "",
            "small": "",
            "absolute": "",
            "top": "",
            "right": "",
            "dark": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), (_vm.appointment) ? _c('action-list', {
    attrs: {
      "appointment": _vm.appointment
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.sharelink && _vm.sharelink.url) ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "fab": "",
      "small": "",
      "absolute": "",
      "bottom": "",
      "right": "",
      "dark": ""
    },
    on: {
      "click": _vm.share
    }
  }, [_c('v-icon', [_vm._v("share")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('h3', {
    staticClass: "title font-weight-light mt-3 ml-3 grow"
  }, [_vm._v("\n            " + _vm._s(_vm.appointment.title) + "\n            "), _c('small', [_vm._v("with " + _vm._s(_vm.appointment.practitioner_name))])]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.appointment.product_name) + " @ " + _vm._s(_vm.appointment.space_name))])]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('strong', {
    staticClass: "display-4 font-weight-regular mr-4 ml-3"
  }, [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.appointment.start_time, 'D')) + "\n        ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "justify-end": ""
    }
  }, [_c('div', {
    staticClass: "headline font-weight-light"
  }, [_vm._v("\n            " + _vm._s(_vm.dateformat(_vm.appointment.start_time, 'ddd')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase font-weight-light"
  }, [_vm._v(_vm._s(_vm.dateformat(_vm.appointment.start_time, 'MMMM YYYY')))]), _vm._v(" "), _c('div', [_vm._v(" ")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "dark": ""
    }
  }, [(_vm.relationship && _vm.relationship.id) ? _c('client-list-item', {
    attrs: {
      "with-details": "",
      "relationship-id": _vm.relationship.id,
      "client": _vm.relationship.client
    },
    on: {
      "listitem:clicked": function($event) {
        return _vm.gotoClient(_vm.relationship)
      }
    }
  }, [_c('v-list-tile-avatar', {
    attrs: {
      "slot": "avatar"
    },
    slot: "avatar"
  }, [_c('v-icon', [_vm._v("person")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return _c('v-list-tile', {
          attrs: {
            "avatar": ""
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Date and time")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.formatFromTo(_vm.appointment.start_time, _vm.appointment.end_time)) + "\n          ")]), _vm._v(" "), (_vm.appointment.client_timezone && _vm.appointment.client_timezone !== _vm.$store.getters.settings.timezone) ? _c('v-list-tile-sub-title', [_vm._v("\n            Client's timezone: " + _vm._s(_vm.appointment.client_timezone) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.openGlobalDialog(true, 'Reschedule', {
                appointment: _vm.appointment
              })
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("edit")])], 1)], 1)], 1)
      }
    }])
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment.location && (_vm.appointment.location.address || _vm.appointment.location.name)) ? [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Flexible location")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.location.name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.location.formatted_address || _vm.appointment.location.address)
    }
  })], 1), _vm._v(" "), (_vm.appointment.location.url) ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "href": _vm.appointment.location.url,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 1)] : (_vm.appointment.zoom_join_url) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Online")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": _vm.appointment.zoom_join_url,
      "title": "Join URL",
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.appointment.zoom_join_url))])]), _vm._v(" "), (_vm.appointment.zoom_meeting_password) ? _c('v-list-tile-sub-title', [_vm._v("\n          Password: " + _vm._s(_vm.appointment.zoom_meeting_password) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.appointment.zoom_start_url) ? _c('v-list-tile-action', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "href": _vm.appointment.zoom_start_url,
            "target": "_blank",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("open_in_new")])], 1)]
      }
    }], null, false, 3002636037)
  }, [_vm._v(" "), _c('span', [_vm._v("Meeting start URL")])])], 1) : _vm._e()], 1) : (_vm.appointment.address_data) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Location")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.appointment.address_data.name) + ". " + _vm._s(_vm.appointment.address_data.address) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.product && _vm.product.id) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("star")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Appointment Type")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.product.title) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment.codes) ? [_c('appointment-codes', {
    attrs: {
      "dense": "",
      "with-title": "",
      "with-total": "",
      "appointment-id": _vm.appointment.id,
      "value": _vm.appointment,
      "with-done": false,
      "title": "Codes"
    }
  })] : _vm._e(), _vm._v(" "), _vm._t("card-actions", function() {
    return [_c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', [_vm._v("Open")])], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search for a medical aid",
      "prepend-icon": "search",
      "clearable": "",
      "hint": "Start typing the name of a medical aid"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [(_vm.filteredQuickPick && _vm.filteredQuickPick.length > 0) ? _c('v-subheader', [_vm._v("Quick pick")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredQuickPick), function(medicalaid, index) {
    return [_c('v-list-tile', {
      key: ("li-" + (medicalaid.email) + "-" + index),
      on: {
        "click": function($event) {
          return _vm.select(medicalaid)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(medicalaid.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(medicalaid.email))])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (medicalaid.email) + "-" + index)
    })]
  }), _vm._v(" "), _c('v-subheader', [_vm._v("All medical aids")]), _vm._v(" "), _vm._l((_vm.filteredResults), function(medicalaid, index) {
    return [_c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.select(medicalaid)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(medicalaid.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(medicalaid.email))])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: (index + "-div")
    })]
  }), _vm._v(" "), (_vm.filteredResults.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Your search returned no results.\n          "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.searchString = ""
      }
    }
  }, [_vm._v("Try again?")])], 1)], 1)], 1) : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "calendar"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "fullscreen": ""
    },
    model: {
      value: (_vm.settingsDialog),
      callback: function($$v) {
        _vm.settingsDialog = $$v
      },
      expression: "settingsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-subheader', [_vm._v("Settings")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.settingsDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "calendar-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.appointmentsRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-system-bar', {
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("replay")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.doShowCalendar(true, "date")
      }
    }
  }, [_vm._v(_vm._s(_vm.naturalday(_vm.selectedDate)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('calendar-settings', {
    model: {
      value: (_vm.settings),
      callback: function($$v) {
        _vm.settings = $$v
      },
      expression: "settings"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.doShowCalendar(true, "date")
      }
    }
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "350"
    },
    model: {
      value: (_vm.showCalendar),
      callback: function($$v) {
        _vm.showCalendar = $$v
      },
      expression: "showCalendar"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "type": _vm.datePickerType,
      "full-width": ""
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.doShowCalendar(false)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "overline",
    on: {
      "click": _vm.gotoToday
    }
  }, [_vm._v("Today is " + _vm._s(_vm.dateformat(_vm.now, 'ddd D MMM YY')))])], 1), _vm._v(" "), (_vm.infoTeamCount > 1) ? _c('calendar-tabs', {
    attrs: {
      "dark": "",
      "facets": _vm.facets
    },
    on: {
      "space": _vm.setSelectedSpace
    },
    model: {
      value: (_vm.practitioner),
      callback: function($$v) {
        _vm.practitioner = $$v
      },
      expression: "practitioner"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "solid py-1 hidden-xs-only",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "horizontal-scrolling-wrapper week",
    attrs: {
      "id": "week-view"
    }
  }, _vm._l((_vm.monthDates), function(day) {
    return _c('div', {
      key: day,
      staticClass: "day",
      class: {
        'blue lighten-2': _vm.isActive(day),
        'yellow lighten-5': _vm.isToday(day),
        'blue lighten-4 black--text': _vm.isVisible(day),
        'grey--text': !_vm.isVisible(day)
      },
      on: {
        "click": function($event) {
          _vm.selectedDate = day
        }
      }
    }, [_c('div', {
      staticClass: "dow overline",
      class: "dow-" + _vm.dateformat(day, "ddd").toLowerCase()
    }, [_vm._v(_vm._s(_vm.dateformat(day, 'ddd')))]), _vm._v(" "), _c('div', {
      staticClass: "date black--text"
    }, [_vm._v(_vm._s(_vm.dateformat(day, 'D')))])])
  }), 0)]), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        left: function () {
          _vm.dateMath(1, 'days')
        },
        right: function () {
          _vm.dateMath(-1, 'days')
        }
      }),
      expression: "{left: () => { dateMath(1, 'days') }, right: () => { dateMath(-1, 'days') }}"
    }],
    staticClass: "px-1",
    attrs: {
      "row": ""
    }
  }, _vm._l((_vm.daysToShow), function(day) {
    return _c('v-flex', {
      key: day,
      staticClass: "pa-0",
      class: {
        weekviewactive: _vm.isActive(day)
      },
      attrs: {
        "xs12": "",
        "sm3": ""
      }
    }, [_c('v-subheader', {
      staticClass: "hidden-xs-only overline pl-1 grey lighten-4 justify-center",
      class: {
        'grey lighten-2': _vm.isActive(day),
        'grey lighten-4': !_vm.isActive(day)
      },
      staticStyle: {
        "height": "24px",
        "border-right": "solid 1px #DDD"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.dateformat(day, 'ddd D MMM')) + "\n            ")]), _vm._v(" "), (_vm.practitioner) ? _c('practitioner-day-view', {
      class: {
        'elevation-5': _vm.isActive(day)
      },
      staticStyle: {
        "border-right": "solid 1px #ccc"
      },
      attrs: {
        "practitioner": _vm.practitioner,
        "with-fetch": false,
        "withWeek": _vm.$vuetify.breakpoint.xs,
        "withAdd": _vm.$vuetify.breakpoint.xs,
        "settings": _vm.settings,
        "date": day
      },
      on: {
        "dayview:createevent": _vm.slotSelected,
        "dayview:delete": _vm.deleteEvent,
        "dayview:save": _vm.showQuickCreate,
        "dayview:eventclicked": _vm.eventClicked,
        "dayview:multiselect": _vm.setMultiSelect,
        "update:date": _vm.setDate,
        "facets": _vm.setFacets
      }
    }) : _vm._e()], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dark": ""
    }
  }, [(_vm.invoice) ? _c('invoice-list-item', {
    attrs: {
      "invoice": _vm.invoice
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Send to client\n          "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showCustomMessage = !_vm.showCustomMessage
      }
    }
  }, [_vm._v("Add custom message")])], 1), _vm._v(" "), (_vm.showCustomMessage) ? _c('v-textarea', {
    staticClass: "caption",
    attrs: {
      "outline": "",
      "rows": "2",
      "label": "Custom message",
      "hint": "Include a custom message in your email"
    },
    model: {
      value: (_vm.customMessage),
      callback: function($$v) {
        _vm.customMessage = $$v
      },
      expression: "customMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.whatsapplink) ? _c('v-btn', {
    staticStyle: {
      "float": "right",
      "margin-top": "2px"
    },
    attrs: {
      "outline": "",
      "href": _vm.whatsapplink,
      "target": "_blank",
      "color": "green",
      "dark": "",
      "small": ""
    }
  }, [_vm._v("\n          Send via WhatsApp\n          "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "label": "Send as SMS",
      "disabled": !_vm.hasPhoneNumber,
      "hint": _vm.sendAsSMSHint,
      "persistent-hint": "",
      "light": ""
    },
    model: {
      value: (_vm.sendAsSMS),
      callback: function($$v) {
        _vm.sendAsSMS = $$v
      },
      expression: "sendAsSMS"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0 mt-2",
    attrs: {
      "label": "Send to email",
      "hint": _vm.sendToCustomerHint,
      "disabled": _vm.hasValidEmail === false,
      "persistent-hint": "",
      "light": ""
    },
    model: {
      value: (_vm.sendToCustomer),
      callback: function($$v) {
        _vm.sendToCustomer = $$v
      },
      expression: "sendToCustomer"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "pa-0 ma-0 overline"
  }, [_vm._v("Send to me")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "label": "Send to me",
      "hint": _vm.sendToMeHint,
      "persistent-hint": "",
      "light": ""
    },
    model: {
      value: (_vm.sendToMe),
      callback: function($$v) {
        _vm.sendToMe = $$v
      },
      expression: "sendToMe"
    }
  }), _vm._v(" "), _c('vuex-loader', {
    attrs: {
      "request-id": _vm.sendSMSReqId
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "clearable": "",
      "type": "email",
      "label": "Send to email",
      "hint": "Type the email address you would like to send this invoice to",
      "rules": [_vm.rules.email]
    },
    model: {
      value: (_vm.freeFormEmail),
      callback: function($$v) {
        _vm.freeFormEmail = $$v
      },
      expression: "freeFormEmail"
    }
  }), _vm._v(" "), (_vm.recipientsExist) ? _c('div', {
    staticClass: "mt-2",
    attrs: {
      "transition": "slide-y-transition"
    }
  }, [_c('v-subheader', {
    staticClass: "pa-0"
  }, [_vm._v("Sending to")]), _vm._v(" "), _vm._l((_vm.emailList), function(email) {
    return _c('v-chip', {
      key: email,
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "color": "teal white--text"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("email")])], 1), _vm._v("\n            " + _vm._s(email) + "\n          ")], 1)
  }), _vm._v(" "), (_vm.sendAsSMS) ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "teal white--text"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("chat")])], 1), _vm._v("\n            " + _vm._s(_vm.normalizedClient.phone_number) + "\n          ")], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [(_vm.withClose) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.relationshipId) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.requests.contact.loading
    },
    on: {
      "click": _vm.refreshContact
    }
  }, [_vm._v("Reload contact info")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "disabled": !_vm.recipientsExist
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send  \n            "), _c('v-icon', [_vm._v("send")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [(_vm.loading) ? [_c('v-progress-circular', {
    attrs: {
      "width": "2",
      "color": "amber",
      "size": "36",
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("Sending")])] : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "warning",
      "value": _vm.failedMessages && _vm.failedMessages.length > 0
    }
  }, [_vm._v("\n          Some messages failed to send\n        ")]), _vm._v(" "), (_vm.messageIdsToWatch && _vm.messageIdsToWatch.length > 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Sent messages")]), _vm._v(" "), _vm._l((_vm.messageIdsToWatch), function(messageId) {
    return _c('communication-watcher', {
      key: messageId,
      attrs: {
        "message-id": messageId
      }
    })
  })], 2) : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit("close");
        _vm.window = 0;
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "min-height": "300"
    }
  }, [(_vm.loading) ? _c('v-card-text', [_c('center', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "height": "2",
      "size": "70",
      "width": "2",
      "color": "amber"
    }
  }), _c('br'), _c('br'), _vm._v("\n    Loading\n    ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [
    [(_vm.clientId) ? _c('client-details', {
      attrs: {
        "value": _vm.client,
        "is-compact": _vm.$vuetify.breakpoint.xs
      }
    }) : (_vm.clientNotFound) ? _c('v-alert', {
      staticClass: "ma-0 py-0 caption lighten-1",
      attrs: {
        "value": true,
        "type": "info"
      }
    }, [_vm._v("\n        Unable to find the requested client.\n        "), _c('v-btn', {
      on: {
        "click": _vm.get
      }
    }, [_vm._v("Try again")]), _vm._v(" "), _c('v-btn', {
      on: {
        "click": function($event) {
          _vm.$store.dispatch('SET_SPACE', ['globalDialog', 'ClientList', 'Find a client', {
            showListInitially: true,
            withCreate: false,
            touch: Math.random()
          }, {
            clientselected: _vm.gotoClient
          }, _vm.$vuetify.breakpoint.xsOnly])
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v("search")]), _vm._v("\n          Search")], 1)], 1) : _vm._e()]
  ], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.appointment && _vm.appointment.id) ? _c('v-card', {
    key: "client",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_c('appointment-list-item', {
    attrs: {
      "with-status-chips": "",
      "with-color-coding": false,
      "appointment": _vm.appointment
    }
  }, [_c('v-list-tile-action', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('appointment-action-menu', {
    attrs: {
      "appointment": _vm.appointment
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "action",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    },
    slot: "action"
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "dark": "",
      "grow": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(_vm.client) ? _c('v-tab', [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("person")]), _vm._v("\n          Client ")], 1) : _vm._e(), _vm._v(" "), (_vm.appointment) ? _c('v-tab', [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")]), _vm._v("\n          Appointment ")], 1) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(_vm.client) ? _c('v-tab-item', [_c('client-details', {
    attrs: {
      "value": _vm.client,
      "with-title": false,
      "is-compact": true,
      "with-fetch": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-tab-item', [_c('appointment-card', {
    attrs: {
      "fetch": ""
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1)], 1)], 1)], 1) : _c('welcome', {
    key: "home",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "chart:appointments:clicked": _vm.bubble
    },
    model: {
      value: (_vm.homepage),
      callback: function($$v) {
        _vm.homepage = $$v
      },
      expression: "homepage"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Choose a practitioner:")]), _vm._v(" "), _vm._l((_vm.getColleagues), function(practitioner) {
    return [(practitioner.is_active) ? _c('v-chip', {
      key: practitioner.id,
      class: {
        'info white--text': _vm.idsAreEqual(practitioner.id, _vm.practitionerId)
      },
      on: {
        "click": function($event) {
          _vm.local.practitioner = practitioner
        }
      }
    }, [(_vm.idsAreEqual(practitioner.id, _vm.practitionerId)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n        " + _vm._s(practitioner.full_name) + "\n      ")], 1) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.practitionerId) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Choose a space:")]), _vm._v(" "), _vm._l((_vm.local.practitioner.memberships), function(mem) {
    return [(mem.is_active) ? _c('v-chip', {
      key: mem.id,
      class: {
        'info white--text': _vm.idsAreEqual(mem.service, _vm.spaceId)
      },
      on: {
        "click": function($event) {
          _vm.local.space = mem.service_data
        }
      }
    }, [(_vm.idsAreEqual(mem.service, _vm.spaceId)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n        " + _vm._s(mem.space_name) + "\n      ")], 1) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.practitionerId && _vm.spaceId) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Choose an appointment type:")]), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return [_c('v-chip', {
      key: product.id,
      class: {
        'info white--text': _vm.idsAreEqual(_vm.local.product.id, product.id)
      },
      on: {
        "click": function($event) {
          _vm.local.product = product
        }
      }
    }, [(_vm.idsAreEqual(_vm.local.product.id, product.id)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n        " + _vm._s(product.title) + "\n      ")], 1)]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.productId && _vm.local.product.locations && _vm.local.product.locations.length > 0) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Choose a location:")]), _vm._v(" "), _vm._l((_vm.local.product.locations), function(location) {
    return [_c('v-chip', {
      key: ((location.id) + "-" + _vm.productId),
      class: {
        'info white--text': _vm.idsAreEqual(location.id, _vm.local.location.id)
      },
      on: {
        "click": function($event) {
          _vm.local.location = location
        }
      }
    }, [(_vm.idsAreEqual(location.id, _vm.local.location.id)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n        " + _vm._s(location.name) + "\n      ")], 1)]
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "type": "tel",
      "append-icon": _vm.iconAppend,
      "hint": _vm.hintText,
      "persistent-hint": "",
      "label": "phone number"
    },
    model: {
      value: (_vm.rawPhoneNumber),
      callback: function($$v) {
        _vm.rawPhoneNumber = $$v
      },
      expression: "rawPhoneNumber"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0",
    staticStyle: {
      "min-width": "40px"
    },
    attrs: {
      "slot": "prepend",
      "outline": "",
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.countryCodePicker = true
      }
    },
    slot: "prepend"
  }, [_vm._v("+" + _vm._s(_vm.selectedCountry.code))])], 1), _vm._v(" "), (_vm.verbose) ? _c('pre', [_vm._v("      inferred: " + _vm._s(_vm.inferredCountryCode) + "\n      selected: " + _vm._s(_vm.isocode) + "\n      valid: " + _vm._s(_vm.isValidNumber) + "\n      raw: " + _vm._s(_vm.rawPhoneNumber) + "\n      parsed: " + _vm._s(_vm.parsedNumber) + "\n      formatted: " + _vm._s(_vm.formattedNumber) + "\n      type: " + _vm._s(_vm.numberType) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.countryCodePicker),
      callback: function($$v) {
        _vm.countryCodePicker = $$v
      },
      expression: "countryCodePicker"
    }
  }, [_c('v-list', {
    staticStyle: {
      "height": "500px",
      "overflow": "scroll"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "elevation-0",
    attrs: {
      "color": "white",
      "dense": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "clearable": "",
      "label": "search",
      "prepend-icon": "search",
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1), _vm._v(" "), (_vm.filteredShortList.length > 0) ? _c('v-subheader', [_vm._v("Quickpick")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredShortList), function(country, index) {
    return _c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.setCountry(country)
        }
      }
    }, [_c('v-list-tile-action', [_vm._v("\n          +" + _vm._s(country.code) + "\n        ")]), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n          " + _vm._s(country.name) + "\n        ")])], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.filteredCountries), function(country) {
    return _c('v-list-tile', {
      key: country.name,
      on: {
        "click": function($event) {
          return _vm.setCountry(country)
        }
      }
    }, [_c('v-list-tile-action', [_vm._v("\n          +" + _vm._s(country.code) + "\n        ")]), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n          " + _vm._s(country.name) + "\n        ")])], 1)
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.one')))]), _vm._v(" "), _c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.two')))]), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.invoicesRequest.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.getInvoices
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "subheading hidden-xs-only"
  }, [_vm._v("\n            Invoices\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "small": "",
      "disabled": !(_vm.selectedInvoices) || _vm.selectedInvoices.length === 0
    },
    on: {
      "click": function($event) {
        _vm.showCreateStatement = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("\n            " + _vm._s(_vm.$t('buttons.createstatement')) + "\n          ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.launchInvoiceDialog({
          relationshipId: _vm.relationshipId
        })
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("Invoice")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.mdAndDown,
      "width": 800
    },
    model: {
      value: (_vm.showCreateStatement),
      callback: function($$v) {
        _vm.showCreateStatement = $$v
      },
      expression: "showCreateStatement"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v("\n                    " + _vm._s(_vm.$t('dialogs.titles.statement')) + "\n                  ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateStatement = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.selectedInvoices && _vm.selectedInvoices.length > 0) ? _c('statement', {
    attrs: {
      "touch": _vm.statementToucher,
      "relationship-id": _vm.relationshipId,
      "invoices": _vm.selectedInvoices
    },
    on: {
      "close": function($event) {
        _vm.showCreateStatement = false
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('invoice-list', _vm._g({
    staticClass: "invoice-list",
    attrs: {
      "invoices": _vm.pagedInvoices,
      "selected-invoice-ids": _vm.selectedInvoiceIds,
      "actions": _vm.invoiceActions,
      "withStatus": true,
      "loading": _vm.invoicesRequest.loading
    },
    on: {
      "selected": _vm.setSelected
    }
  }, _vm.invoiceEvents)), _vm._v(" "), (_vm.invoicesRequest.status === 200 && _vm.invoices.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("\n              No invoices found\n            ")])], 1) : _c('v-subheader', [_vm._v("Showing " + _vm._s(Math.min(_vm.itemsToShow, _vm.invoices.length)) + " of " + _vm._s(_vm.invoices.length) + " Invoices")]), _vm._v(" "), _c('v-list-tile', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasMore),
      expression: "hasMore"
    }],
    attrs: {
      "block": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.itemsToShow += _vm.pageSize
      }
    }
  }, [_vm._v("Load more")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('statement-list', {
    attrs: {
      "touch": _vm.statementListToucher,
      "relationship-id": _vm.relationshipId
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "overlay-opacity": "90",
      "width": "360px"
    },
    model: {
      value: (_vm.loginchallenge),
      callback: function($$v) {
        _vm.loginchallenge = $$v
      },
      expression: "loginchallenge"
    }
  }, [_c('v-card', [(_vm.loginchallenge) ? _c('login', {
    attrs: {
      "with-init": false
    },
    on: {
      "loggedin": function($event) {
        _vm.loginchallenge = false;
        _vm.$emit('loggedin')
      }
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "caption text-center"
  }, [_c('center', [_c('span', {
    staticClass: "black--text",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v(" AppointmentGuru version: " + _vm._s(_vm.version))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadRequired),
      expression: "reloadRequired"
    }],
    staticStyle: {
      "position": "fixed",
      "top": "5px",
      "right": "5px",
      "z-index": "10"
    },
    attrs: {
      "small": "",
      "success": ""
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Update available. Please reload")]), _vm._v(" "), (_vm.withReload) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "block": ""
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Get latest version")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-status', {
    staticStyle: {
      "padding": "1px 0px"
    },
    attrs: {
      "with-dropdown": _vm.groups && _vm.groups.length > 0,
      "practitioner": _vm.currentUser
    },
    on: {
      "selected": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('v-card', [_c('grouped-practitioner-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    attrs: {
      "groups": _vm.groups,
      "withActivate": false
    },
    on: {
      "selected": _vm.triggerBecome
    }
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.switching')) + "\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [(_vm.requestStatus !== 200) ? _c('v-progress-circular', {
    attrs: {
      "color": "amber",
      "size": 70,
      "indeterminate": true
    }
  }) : _c('v-icon', {
    attrs: {
      "size": 70,
      "color": "green"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), (_vm.status === "switching") ? _c('p', {
    staticClass: "subheading"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.progress', {
    user: _vm.currentUser.first_name
  })) + "\n          ")]) : (_vm.status === "success") ? _c('p', {
    staticClass: "subheading"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.success', {
    user: _vm.currentUser.first_name
  })) + "\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', _vm._b({
    attrs: {
      "dark": _vm.dark,
      "flat": ""
    }
  }, 'v-card', _vm.attrs, false), [_c('v-card-title', {
    staticClass: "pb-2 overline"
  }, [(_vm.withIcon) ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("filter_list")]) : _vm._e(), _vm._v(" "), (_vm.initialRelationship && _vm.initialRelationship.client) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.initialRelationship.client.first_name) + "\n      " + _vm._s(_vm.initialRelationship.client.last_name) + "\n    ")]) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.numResults) ? _c('v-chip', {
    staticClass: "mr-0 v-chip--x-small",
    attrs: {
      "color": "primary",
      "outline": ""
    }
  }, [_vm._v(_vm._s(_vm.numResults) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.withThemeToggle) ? [(_vm.dark) ? _c('v-icon', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dark = false
      }
    }
  }, [_vm._v("light_mode")]) : _c('v-icon', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dark = true
      }
    }
  }, [_vm._v("dark_mode")])] : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "py-0 overline"
  }, [_vm._v("\n      Choose a date range\n      "), _c('v-spacer'), _vm._v(" "), (!_vm.requireDaterange) ? [(_vm.disableDate) ? _c('v-chip', {
    staticClass: "mr-0 v-chip--x-small",
    attrs: {
      "icon": "",
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.disableDate = false
      }
    }
  }, [_vm._v("\n          Apply\n          "), _c('v-icon', {
    attrs: {
      "right": "",
      "small": ""
    }
  }, [_vm._v("timer")])], 1) : _c('v-chip', {
    staticClass: "mr-0 v-chip--x-small",
    attrs: {
      "icon": "",
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.disableDate = true
      }
    }
  }, [_vm._v("\n          Clear\n          "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("timer_off")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "disabled": _vm.disableDate
    },
    on: {
      "click": function($event) {
        _vm.datepickervisible = true
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.dateRange.from)) + " - " + _vm._s(_vm.dateformat(_vm.dateRange.to)) + "\n        ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          Click to change dates\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.datepickervisible) ? _c('date-range-picker', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "with-ok": "",
      "with-close": "",
      "transition": "scroll-y-transition"
    },
    on: {
      "close": function($event) {
        _vm.datepickervisible = false
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 my-2"
  }), _vm._v(" "), _vm._t("relationship-picker", function() {
    return [(_vm.dateRange.from && !_vm.initialRelationship) ? _c('relationship-picker', {
      staticClass: "mx-3",
      attrs: {
        "with-quick-pick": "",
        "multiple": _vm.multipleRelationships,
        "practitioner-id": _vm.practitionerId,
        "statuses": _vm.relationshipStatuses,
        "from-date": _vm.dateRange.from,
        "to-date": _vm.dateRange.to,
        "touch": _vm.touch
      },
      on: {
        "count": _vm.setCount
      },
      model: {
        value: (_vm.selectedRelationships),
        callback: function($$v) {
          _vm.selectedRelationships = $$v
        },
        expression: "selectedRelationships"
      }
    }) : _vm._e()]
  }), _vm._v(" "), (!_vm.mini && _vm.dateRange.from && _vm.dateRange.to) ? [(_vm.facets && _vm.facets.practitioner) ? [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        Practitioner\n        "), _c('v-spacer'), _vm._v(" "), (_vm.selectedPractitioners > 0) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedPractitioners = []
      }
    }
  }, [_vm._v("clear")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.getColleagues), function(data, pk) {
    return [_c('v-checkbox', {
      key: pk,
      staticClass: "pa-0 ma-0 ml-2",
      attrs: {
        "hide-details": "",
        "dense": "",
        "value": pk,
        "color": data.color,
        "label": _vm.getPractitionerLabel(data, _vm.facets.practitioner)
      },
      model: {
        value: (_vm.selectedPractitioners),
        callback: function($$v) {
          _vm.selectedPractitioners = $$v
        },
        expression: "selectedPractitioners"
      }
    })]
  })] : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Status\n      "), _c('v-spacer'), _vm._v(" "), (_vm.selectedStatuses > 0) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedStatuses = []
      }
    }
  }, [_vm._v("clear")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.statuses), function(data, code) {
    return [_c('v-checkbox', {
      key: code,
      staticClass: "pa-0 ma-0 ml-2",
      attrs: {
        "hide-details": "",
        "dense": "",
        "value": code,
        "color": data.theme,
        "label": _vm.getStatusLabel(code, data, _vm.facets.status)
      },
      model: {
        value: (_vm.selectedStatuses),
        callback: function($$v) {
          _vm.selectedStatuses = $$v
        },
        expression: "selectedStatuses"
      }
    })]
  }), _vm._v(" "), (_vm.facets && _vm.facets.space) ? [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Space\n        "), _c('v-spacer'), _vm._v(" "), (_vm.selectedSpaces > 0) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedSpaces = []
      }
    }
  }, [_vm._v("clear")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.spaces), function(space) {
    return [_c('v-checkbox', {
      key: space.id,
      staticClass: "pa-0 ma-0 ml-2",
      attrs: {
        "hide-details": "",
        "dense": "",
        "value": space.id,
        "color": space.color,
        "label": _vm.getSpaceLabel(space, _vm.facets.space)
      },
      model: {
        value: (_vm.selectedSpaces),
        callback: function($$v) {
          _vm.selectedSpaces = $$v
        },
        expression: "selectedSpaces"
      }
    })]
  })] : _vm._e(), _vm._v(" "), [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Codes\n        "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.hasCodes = null
      }
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), _c('v-radio-group', {
    staticClass: "pa-0 ma-0 ml-2",
    model: {
      value: (_vm.hasCodes),
      callback: function($$v) {
        _vm.hasCodes = $$v
      },
      expression: "hasCodes"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "yes",
      "label": "Have ICD-10 codes"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "no",
      "label": "Without ICD-10 codes"
    }
  })], 1)]] : _vm._e(), _vm._v(" "), _vm._t("actions"), _vm._v(" "), [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Results per page")]), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-4"
  }, [_c('v-spacer'), _vm._v(" "), _vm._l((_vm.pageSizes), function(size) {
    return _c('v-flex', {
      key: size
    }, [_c('v-checkbox', {
      key: size,
      staticClass: "pa-0 ma-0",
      attrs: {
        "hide-details": "",
        "dense": "",
        "value": size,
        "label": ("" + (size.toString()))
      },
      model: {
        value: (_vm.selectedPageSize),
        callback: function($$v) {
          _vm.selectedPageSize = $$v
        },
        expression: "selectedPageSize"
      }
    })], 1)
  }), _vm._v(" "), _c('v-spacer')], 2)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(_vm.selectedAppointments.length > 0) ? _c('v-toolbar', {
    staticStyle: {
      "z-index": "15"
    },
    style: ({
      top: _vm.topOffset
    }),
    attrs: {
      "extended": "",
      "fixed": "",
      "dark": "",
      "flat": "",
      "top": "",
      "extension-height": "28",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": _vm.$vuetify.breakpoint.xs,
      "flat": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("deselect")
      }
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v(" " + _vm._s(_vm.$t('buttons.deselect')))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "dark": "",
      "flat": "",
      "small": "",
      "outline": "",
      "disabled": _vm.permissionsCanBulkAddCodes === false
    },
    on: {
      "click": function($event) {
        _vm.codeTouch++;
        _vm.dialogs.codes = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('buttons.codes')) + "\n      ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "dark": "",
      "flat": "",
      "small": "",
      "outline": "",
      "disabled": (_vm.clientIds && _vm.clientIds.length > 1) || _vm.permissionsCanCreateInvoice === false
    },
    on: {
      "click": function($event) {
        return _vm.launchQuickInvoiceDialog(_vm.invoiceOptions)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('buttons.invoices')) + "\n      ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "dark": "",
      "flat": "",
      "small": "",
      "outline": "",
      "disabled": (_vm.clientIds && _vm.clientIds.length > 1) || (_vm.spaceIds && _vm.spaceIds.length > 1) || _vm.permissionsCanBulkAddPayment === false
    },
    on: {
      "click": function($event) {
        return _vm.launchAppointmentPaymentDialog(_vm.paymentOptions)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v("\n          " + _vm._s(_vm.$t('buttons.payments')) + "\n      ")], 1), _vm._v(" "), (_vm.selectedAppointments && _vm.selectedAppointments.length > 0) ? _c('template', {
    slot: "extension"
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ma-0 pl-0 mr-2 mb-3 white--text",
          class: {
            "ml-0": _vm.$vuetify.breakpoint.xs,
            "ml-3": _vm.$vuetify.breakpoint.smAndUp
          },
          attrs: {
            "slot": "activator",
            "small": "",
            "flat": ""
          },
          slot: "activator"
        }, on), [_vm._v("\n                " + _vm._s(_vm.$tc('toolbar.extension', _vm.selectedAppointments.length, {
          n: _vm.selectedAppointments.length
        })) + "\n              "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }], null, false, 988659059)
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 grey lighten-4"
  }, [_vm._v("\n                Selected appointments\n\n              ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.selectedAppointments), function(appointment) {
    return _c('appointment-list-item', {
      key: appointment.id,
      attrs: {
        "with-tags": "",
        "with-action": false,
        "with-status-chips": "",
        "with-color-coding": false,
        "appointment": appointment
      }
    })
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.spaceIds && _vm.spaceIds.length > 0) ? _c('space-faces', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "space-ids": _vm.spaceIds
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('practitioner-faces', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "practitioner-ids": _vm.practitionerIds
    }
  })], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.dialogs.codes),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "codes", $$v)
      },
      expression: "dialogs.codes"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": _vm.themeColor,
      "dense": "",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.codes')) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.codes = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('bulk-add-codes', {
    attrs: {
      "with-title": true,
      "with-done": true,
      "touch": _vm.codeTouch,
      "appointment-ids": _vm.selectedAppointmentIds
    },
    on: {
      "saved": function($event) {
        return _vm.$emit("codes:created")
      },
      "close": function($event) {
        _vm.dialogs.codes = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    staticClass: "pt-0"
  }, [_c('v-list', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "dense": "",
      "three-line": "",
      "subheader": ""
    }
  }, [_vm._l((_vm.messages), function(message, index) {
    return [(_vm.isNewDate(message, index)) ? _c('v-subheader', {
      key: ("sub-" + (message.id)),
      staticClass: "overline grey lighten-4"
    }, [_vm._v(_vm._s(_vm.dateformat(message.created_date)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-divider', {
      key: ("dt-div-" + (message.id))
    }), _vm._v(" "), _c('communication-list-item', _vm._g({
      attrs: {
        "item": message
      }
    }, _vm.$listeners)), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (message.id))
    })]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": "",
      "full-width": ""
    }
  }, [_vm._l((_vm.filteredActions), function(action) {
    return [(action.type === "divider") ? _c('v-divider', {
      key: action.id
    }) : [(_vm.exclude.indexOf(action.id) === -1) ? _c('v-list-tile', {
      key: action.id,
      attrs: {
        "disabled": action.disableIf && action.disableIf(_vm.appointment)
      },
      on: {
        "close": function($event) {
          _vm.visible = false
        },
        "click": function($event) {
          return _vm.itemAction(action)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(action.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(action.title))])], 1), _vm._v(" "), (action.extraActions) ? _vm._l((action.extraActions(_vm.appointment)), function(extra) {
      return _c('v-list-tile-action', {
        key: extra.icon
      }, [_c('v-btn', {
        attrs: {
          "outline": "",
          "outlined": "",
          "icon": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return extra.action(_vm.appointment)
          }
        }
      }, [(extra.icon) ? _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v(_vm._s(extra.icon))]) : _vm._e()], 1)], 1)
    }) : _vm._e()], 2) : _vm._e()]]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.activeStep) ? _c('v-card-title', {
    staticClass: "subtitle-1 overline grey lighten-4 py-0"
  }, [(_vm.activeStep.back && _vm.activeStep.back.visible) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.activeStep.back.disabled || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.window--
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v("\n    " + _vm._s(_vm.activeStep.title) + "\n    "), _c('v-spacer'), _vm._v(" "), (_vm.activeStep.next && _vm.activeStep.next.visible) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.activeStep.next.disabled || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.activeStep, _vm.obj)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_forward")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-window', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_vm._l((_vm.steps), function(step) {
    return _c('v-window-item', {
      key: step.id
    }, [(step.component) ? _c(step.component, _vm._g(_vm._b({
      tag: "v-component",
      on: {
        "close": function($event) {
          return _vm.$emit("cancel")
        },
        "cancel": function($event) {
          return _vm.$emit("cancel")
        }
      },
      model: {
        value: (_vm.obj[step.id]),
        callback: function($$v) {
          _vm.$set(_vm.obj, step.id, $$v)
        },
        expression: "obj[step.id]"
      }
    }, 'v-component', step.attrs, false), step.events)) : [(step.vcomponent && step.vcomponent === "vtextarea") ? _c('v-textarea', _vm._g(_vm._b({
      staticClass: "ma-5",
      attrs: {
        "autofocus": ""
      },
      model: {
        value: (_vm.obj[step.id]),
        callback: function($$v) {
          _vm.$set(_vm.obj, step.id, $$v)
        },
        expression: "obj[step.id]"
      }
    }, 'v-textarea', step.attrs, false), step.events)) : (step.vcomponent && step.vcomponent === "vradiogroup") ? _c('v-radio-group', _vm._g(_vm._b({
      staticClass: "ma-5",
      model: {
        value: (_vm.obj[step.id]),
        callback: function($$v) {
          _vm.$set(_vm.obj, step.id, $$v)
        },
        expression: "obj[step.id]"
      }
    }, 'v-radio-group', step.attrs, false), step.events), _vm._l((step.attrs.items), function(item) {
      return _c('v-radio', {
        key: item.value,
        attrs: {
          "value": item.value,
          "label": item.text
        }
      })
    }), 1) : _c('v-text-field', _vm._g(_vm._b({
      staticClass: "ma-5",
      attrs: {
        "autofocus": ""
      },
      on: {
        "keypress": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.next(step, _vm.obj)
        }
      },
      model: {
        value: (_vm.obj[step.id]),
        callback: function($$v) {
          _vm.$set(_vm.obj, step.id, $$v)
        },
        expression: "obj[step.id]"
      }
    }, 'v-text-field', step.attrs, false), step.events))]], 2)
  }), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": "success"
    }
  }, [_vm._t("success")], 2)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("cancel")
      }
    }
  }, [_vm._v("\n      cancel\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.activeStep && _vm.activeStep.required === false) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.window++
      }
    }
  }, [_vm._v("\n      skip\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "loading": _vm.loading,
      "disabled": _vm.activeStep.isValid && !_vm.activeStep.isValid(_vm.activeStep, _vm.obj),
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.activeStep, _vm.obj)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.activeStep.nextText || "next") + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "320"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.appointmentId) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "flat": "",
            "loading": _vm.request.loading,
            "disabled": _vm.disabled
          },
          on: {
            "click": function($event) {
              _vm.step = 0
            }
          }
        }, 'v-btn', attrs, false), on), [_vm._v(_vm._s(_vm.cta))]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-1 overline"
  }, [_vm._v("\n            Please confirm\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n            This will copy the codes from this appointment to all the appointments in the recurring series\n            "), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Clear any existing codes on other appointments"
    },
    model: {
      value: (_vm.withClear),
      callback: function($$v) {
        _vm.withClear = $$v
      },
      expression: "withClear"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Ignore invoiced and paid appointments"
    },
    model: {
      value: (_vm.excludeInvoiced),
      callback: function($$v) {
        _vm.excludeInvoiced = $$v
      },
      expression: "excludeInvoiced"
    }
  }), _vm._v(" "), (_vm.afterDate) ? _c('v-checkbox', {
    attrs: {
      "persistent-hint": "",
      "hint": ("Only update appointments after " + _vm.afterDate),
      "label": "Only apply to appointments after this one"
    },
    model: {
      value: (_vm.onlyAfter),
      callback: function($$v) {
        _vm.onlyAfter = $$v
      },
      expression: "onlyAfter"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Apply Codes")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n            Codes successfully copied\n          ")]), _vm._v(" "), (_vm.request.result) ? _c('v-card-text', [_vm._v("\n            Codes copied to " + _vm._s(_vm.request.result.clone_count) + " appointments\n          ")]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.step = 0;
        _vm.dialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("attach_file")]), _vm._v("\n    Documents\n  ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.documents && _vm.documents.length > 0) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Attached documents")]), _vm._v(" "), _vm._l((_vm.documents), function(doc, index) {
    return [_c('v-list-tile', {
      key: ("doc-" + (doc.name) + "-" + index),
      attrs: {
        "href": doc.file,
        "target": "_blank"
      }
    }, [_c('v-list-tile-avatar', [_c('v-btn', {
      attrs: {
        "loading": doc.deleting === true,
        "color": "error",
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.confirmDeleteFile = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "300"
      },
      model: {
        value: (_vm.confirmDeleteFile),
        callback: function($$v) {
          _vm.confirmDeleteFile = $$v
        },
        expression: "confirmDeleteFile"
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "subheading"
    }, [_vm._v("\n                Are you sure you want to delete this file?\n              ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "text": ""
      },
      on: {
        "click": function($event) {
          _vm.confirmDeleteFile = false
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "loading": _vm.deleting,
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(doc, index)
        }
      }
    }, [_vm._v("Delete")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "mr-2",
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(doc.id) + ". " + _vm._s(doc.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (doc.name) + "-" + index)
    })]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.documents && _vm.documents.length > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Upload documents")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "filepicker grey lighten-3 pa-3",
    attrs: {
      "type": "file",
      "id": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.setFiles
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.files) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.files), function(file, index) {
    return _c('v-list-tile', {
      key: ((file.name) + "-" + index)
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("cloud_upload")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(file.name))])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.files.length === 0,
      "flat": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.clearfiles
    }
  }, [_vm._v("Clear files")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.uploading,
      "disabled": _vm.files.length === 0,
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tc('upload.button', _vm.files.length, {
    n: _vm.files.length
  })) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showScheduleBlock) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('schedule', {
    staticClass: "pb-0",
    attrs: {
      "date": _vm.date,
      "schedule": _vm.homepage,
      "appointment": _vm.currentAppointment,
      "loading": _vm.scheduleRequest.loading
    },
    on: {
      "today": function($event) {
        return _vm.gotoToday()
      },
      "previous": function($event) {
        return _vm.changeDate(-1)
      },
      "next": function($event) {
        return _vm.changeDate(1)
      },
      "previous:week": function($event) {
        return _vm.changeDate(-7)
      },
      "next:week": function($event) {
        return _vm.changeDate(7)
      },
      "date": _vm.setDate,
      "selected": _vm.setCurrentAppointment,
      "close": function($event) {
        _vm.listSpaceIndex = 0
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$vuetify.breakpoint.xs) ? _c('v-flex', {
    staticClass: "hidden-xs",
    attrs: {
      "xs12": "",
      "sm12": !_vm.showScheduleBlock,
      "sm7": _vm.showScheduleBlock,
      "md7": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-2",
    attrs: {
      "dense": ""
    }
  }, [(_vm.$vuetify.breakpoint.xl) ? [_c('v-toolbar-side-icon', [_c('v-icon', {
    attrs: {
      "color": "amber"
    }
  }, [_vm._v("flash_on")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })] : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/calendar"
    }
  }, [_vm._v("Calendar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/clients"
    }
  }, [_vm._v("Clients")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/invoices"
    }
  }, [_vm._v("Invoices")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/reports"
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('birthday-bar')], 2), _vm._v(" "), _c('home-detail', {
    staticClass: "mt-2",
    attrs: {
      "homepage": _vm.homepage,
      "appointment": _vm.currentAppointment,
      "loading": _vm.scheduleRequest.loading
    },
    on: {
      "close": function($event) {
        _vm.currentAppointment = null
      },
      "chart:appointments:clicked": _vm.chartClicked
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading py-0 pl-0"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.noteRequest.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.getNotes
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), (_vm.notes && _vm.notes.length > 0) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.$tc('summary', _vm.notes.length, {
    count: _vm.notes.length,
    date: _vm.dateformat(_vm.notes[_vm.notes.length - 1].created_date)
  })) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("toolbar-buttons")], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.withAdd) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "top": "",
      "right": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.selectedNote = null;
        _vm.showNotes = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.clientId) ? _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.showNotes),
      callback: function($$v) {
        _vm.showNotes = $$v
      },
      expression: "showNotes"
    }
  }, [_c('v-card', [_c('notes', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "note:deleted": function($event) {
        _vm.getNotes();
        _vm.showNotes = false
      },
      "close": function($event) {
        _vm.showNotes = false
      }
    },
    model: {
      value: (_vm.selectedNote),
      callback: function($$v) {
        _vm.selectedNote = $$v
      },
      expression: "selectedNote"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.noteRequest.loading) ? _c('tombstone') : [(_vm.notes && _vm.notes.length > 0) ? _c('v-timeline', {
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, _vm._l((_vm.notesToShow), function(note, index) {
    return _c('v-timeline-item', {
      key: ("note-" + (note.id) + "-" + index),
      attrs: {
        "color": "pink",
        "small": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "pt-3": "",
        "row": "",
        "wrap": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "absolute": "",
        "small": "",
        "right": "",
        "fab": "",
        "flat": "",
        "text": "",
        "disabled": !_vm.canEdit(note)
      },
      on: {
        "click": function($event) {
          _vm.selectedNote = note;
          _vm.showNotes = true
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": ""
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.dateformat(note.date)))]), _c('br'), _vm._v(" "), _c('small', [_vm._v("created " + _vm._s(_vm.dateformat(note.created_date)))]), _c('br'), _vm._v(" "), _c('practitioner-faces', {
      attrs: {
        "practitioner-ids": note.owners,
        "size": 18
      }
    }, [_c('small', {
      staticClass: "caption"
    }, [_vm._v("created by")])]), _vm._v(" "), _c('br'), _vm._v(" "), (note.spaces && note.spaces.length > 0) ? _c('space-faces', {
      attrs: {
        "size": 16,
        "space-ids": note.spaces
      }
    }, [_c('span', {
      staticClass: "caption",
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_vm._v("shared with")])]) : _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "amber",
        "label": ""
      }
    }, [_vm._v("Private")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": ""
      }
    }, [_c('strong', [_vm._v(_vm._s(note.title))]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "mt-2",
      domProps: {
        "innerHTML": _vm._s(_vm.markdown(note.text))
      }
    }), _vm._v(" "), _vm._l((note.object_ids), function(obj) {
      return _c('object-chip', {
        key: ("obj-" + obj),
        staticClass: "ml-0",
        attrs: {
          "small": "",
          "object": obj
        }
      })
    }), _vm._v(" "), (note.documents && note.documents.length > 0) ? _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', _vm._g({
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, on), [_vm._v("\n                  Files\n                  "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), (note && note.documents) ? _c('v-list', {
      staticClass: "pa-0",
      attrs: {
        "dense": ""
      }
    }, _vm._l((note.documents), function(doc) {
      return _c('v-list-tile', {
        key: doc.name,
        attrs: {
          "href": doc.file,
          "target": "_blank"
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(doc.name))])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("open_in_new")])], 1)], 1)
    }), 1) : _vm._e()], 1) : _vm._e()], 2)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.notesExist) ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": !_vm.areMoreNotesToShow,
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.numNotesToShow += _vm.pageSize
      }
    }
  }, [_vm._v("Load more")])], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        No notes found.\n        "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.getNotes
    }
  }, [_vm._v("Reload")]), _vm._v(" "), (_vm.withAdd) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedNote = null;
        _vm.showNotes = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n          New note\n        ")], 1) : _vm._e()], 1)], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "clearable": "",
      "append-icon": "search",
      "label": _vm.label,
      "persistent-hint": _vm.persistentHint,
      "hint": _vm.hint
    },
    on: {
      "click:append": _vm.showSearch,
      "keypress": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('input', _vm.icd10)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "s", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.showSearch.apply(null, arguments)
      }]
    },
    model: {
      value: (_vm.icd10),
      callback: function($$v) {
        _vm.icd10 = $$v
      },
      expression: "icd10"
    }
  }), _vm._v(" "), _c('v-bottom-sheet', {
    model: {
      value: (_vm.searchsheet),
      callback: function($$v) {
        _vm.searchsheet = $$v
      },
      expression: "searchsheet"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline grey lighten-2"
  }, [_vm._v("\n        search ICD-10 codes\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.searchsheet = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-text-field', {
    attrs: {
      "clearable": "",
      "autofocus": "",
      "persistent-hint": "",
      "box": "",
      "id": "icd-10-search",
      "label": "Search for a ICD-10 code",
      "hint": "You can search using a keyword, or on the ICD-10 code itself"
    },
    on: {
      "click:clear": function($event) {
        _vm.results = null
      },
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "c", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        _vm.search = ''
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0 searchresult",
    staticStyle: {
      "overflow-y": "auto",
      "height": "500px"
    }
  }, [(_vm.search && _vm.search.length > 0) ? [_c('div', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.searchSummary)
    }
  }), _vm._v(" "), (_vm.results && _vm.results.hits) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.results.hits), function(res) {
    return [_c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.setSelected(res)
        }
      }
    }, [_c('v-list-tile-action', [(_vm.selected && _vm.selected.length > 0 && _vm.selected.indexOf(res.name) > -1) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("\n                    check_box")]) : _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(res.name)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "textContent": _vm._s(res._formatted.description)
      }
    })], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (res.id))
    })]
  })], 2) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.selected && _vm.selected.length > 0) ? _vm._l((_vm.selected), function(code, index) {
    return _c('span', {
      key: code
    }, [(index > 0) ? _c('span', {
      staticClass: "ml-1"
    }, [_vm._v("/")]) : _vm._e(), _vm._v(" "), _c('v-chip', {
      attrs: {
        "outline": "",
        "label": "",
        "small": "",
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.setSelected({
            name: code
          })
        }
      }
    }, [_vm._v(_vm._s(code))])], 1)
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.selected || _vm.selected.length === 0
    },
    on: {
      "click": _vm.completeSearch
    }
  }, [_vm._v("Done")])], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        return _vm.$emit("save", _vm.product)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "flat": ""
    }
  }, [(_vm.withTitle) ? _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("Add a new appointment type:\n      ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.fields), function(field) {
    return _c('v-flex', _vm._b({
      key: field.value
    }, 'v-flex', field.containerAttrs, false), [(!field.component) ? _c('v-text-field', _vm._b({
      attrs: {
        "rules": [function (v) { return !!v || ((field.text) + " is required"); }],
        "label": field.text,
        "hint": field.hint
      },
      model: {
        value: (_vm.product[field.value]),
        callback: function($$v) {
          _vm.$set(_vm.product, field.value, $$v)
        },
        expression: "product[field.value]"
      }
    }, 'v-text-field', field.attrs, false)) : _c(field.component, _vm._g(_vm._b({
      tag: "component",
      model: {
        value: (_vm.product[field.value]),
        callback: function($$v) {
          _vm.$set(_vm.product, field.value, $$v)
        },
        expression: "product[field.value]"
      }
    }, 'component', field.attrs, false), field.events))], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.withCancel) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("cancel")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.nextRequired) ? _c('v-btn', {
    attrs: {
      "readonly": "",
      "disabled": "",
      "flat": "",
      "small": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.nextRequired)
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.isValid,
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("save", _vm.product)
      }
    }
  }, [_vm._v("\n          Save")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('titles.patientinfo')) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.setPatientInformation(_vm.patientData, _vm.overwrite = true)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.usecontactinfo')) + "\n      ")])], 1), _vm._v(" "), _c('v-card-text', [_c('object-form', {
    attrs: {
      "touch": _vm.touch,
      "fields": _vm.formsets.patient
    },
    model: {
      value: (_vm.medicalaid),
      callback: function($$v) {
        _vm.medicalaid = $$v
      },
      expression: "medicalaid"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('titles.medicalaid')) + "\n    ")]), _vm._v(" "), _c('v-card-text', [_c('object-form', {
    attrs: {
      "touch": _vm.touch,
      "fields": _vm.formsets.medical_aid,
      "field-configs": _vm.formsets.medical_aid_config
    },
    model: {
      value: (_vm.medicalaid),
      callback: function($$v) {
        _vm.medicalaid = $$v
      },
      expression: "medicalaid"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "slot": "is_dependent",
      "label": "Patient is a dependant"
    },
    slot: "is_dependent",
    model: {
      value: (_vm.medicalaid.is_dependent),
      callback: function($$v) {
        _vm.$set(_vm.medicalaid, "is_dependent", $$v)
      },
      expression: "medicalaid.is_dependent"
    }
  }), _vm._v(" "), _c('template', {
    slot: "name-after"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Quick picks")]), _vm._v(" "), _vm._l((_vm.quickpicks), function(pick) {
    return _c('v-chip', {
      key: pick,
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": ""
      },
      on: {
        "click": function($event) {
          _vm.medicalaid.name = pick
        }
      }
    }, [_vm._v(_vm._s(pick))])
  })], 2)], 2), _vm._v(" "), (_vm.medicalaid.is_dependent) ? _c('div', [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Main member details")]), _vm._v(" "), (_vm.medicalaid.is_dependent) ? _c('object-form', {
    attrs: {
      "touch": _vm.touch,
      "fields": _vm.formsets.main_member
    },
    model: {
      value: (_vm.medicalaid),
      callback: function($$v) {
        _vm.medicalaid = $$v
      },
      expression: "medicalaid"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-5"
  }, _vm._l((_vm.options), function(option) {
    return _c('v-btn', {
      key: option.id,
      staticClass: "mb-3",
      staticStyle: {
        "border-radius": "25px"
      },
      attrs: {
        "outline": "",
        "rounded": "",
        "x-large": "",
        "block": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.setSelected(option)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.text) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.selected && _vm.selected.prompt) ? _c('v-card', [(_vm.selected.prompt.title) ? _c('v-card-title', {
    staticClass: "overline",
    domProps: {
      "textContent": _vm._s(_vm.selected.prompt.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selected.prompt.description) ? _c('v-card-text', {
    domProps: {
      "textContent": _vm._s(_vm.selected.prompt.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selected.prompt) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.dialog = false;
        _vm.$emit("selected", _vm.selected)
      }
    }
  }, [_vm._v(_vm._s(_vm.selected.prompt.done || "Got it"))])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-timeline', [_vm._l((_vm.allMessages), function(message) {
    return [_c('v-timeline-item', {
      key: message.id,
      attrs: {
        "small": "",
        "right": message.sender_type === "practitioner",
        "left": message.sender_type === "client"
      }
    }, [_c('span', {
      attrs: {
        "slot": "opposite"
      },
      slot: "opposite"
    }, [_vm._v("\n        " + _vm._s(message.sender_email)), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.dateformat(message.created, 'ddd, MMM Do YYYY, h:mm a')))])]), _vm._v(" "), _c('v-alert', {
      staticClass: "ma-2 rounded-lg",
      attrs: {
        "value": true,
        "dense": "",
        "outline": ""
      }
    }, [_vm._v("\n        " + _vm._s(message.body)), _c('br'), _vm._v(" "), (message.exercise_name) ? _c('v-chip', {
      staticClass: "v-chip--x-small ml-0",
      attrs: {
        "outline": "",
        "outlined": ""
      }
    }, [_vm._v(_vm._s(message.exercise_name))]) : _vm._e(), _vm._v(" "), (message.exercise_name) ? _c('v-chip', {
      staticClass: "v-chip--x-small ml-0",
      attrs: {
        "outline": "",
        "outlined": "",
        "color": "error"
      }
    }, [_vm._v("\n          Pain: " + _vm._s(message.pain_level))]) : _vm._e(), _vm._v(" "), (message.persisted === false) ? _c('v-progress-circular', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "size": "12",
        "indeterminate": "",
        "width": "1",
        "color": "amber"
      }
    }) : _vm._e()], 1)], 1)]
  })], 2), _vm._v(" "), _c('v-textarea', {
    staticClass: "mx-2",
    attrs: {
      "outline": "",
      "outlined": "",
      "auto-grow": "",
      "persistent-hint": "",
      "rows": 1,
      "error-messages": _vm.sendErrors,
      "label": "Send message",
      "append-icon": "send",
      "prepend-icon": "replay",
      "hint": "Press enter to send (shift-enter for a new line)"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.send.apply(null, arguments)
      },
      "click:append": _vm.send,
      "click:prepend": _vm.t
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.invoice && _vm.invoice.id) ? _c('statement', {
    attrs: {
      "client": _vm.invoiceClient,
      "with-selectable": true,
      "with-reload": true,
      "with-pre-next": false,
      "with-filters": false,
      "with-client-preview": false,
      "loading": _vm.statementRequest.loading
    },
    on: {
      "reload": _vm.getStatement
    },
    model: {
      value: (_vm.statement),
      callback: function($$v) {
        _vm.statement = $$v
      },
      expression: "statement"
    }
  }, [_c('template', {
    slot: "subheader"
  }, [_vm._t("subheader")], 2)], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v("Zoom")]), _vm._v(" "), _c('v-tab', [_vm._v("Manually configure")]), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n            Make this appointment online\n            "), _c('v-spacer'), _vm._v(" "), (_vm.integrationIsConnected) ? _c('v-chip', {
    attrs: {
      "small": "",
      "dark": "",
      "color": "success"
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v("\n              Zoom Connected\n            ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.appointment.is_online) ? _c('v-alert', {
    attrs: {
      "type": "success",
      "value": _vm.appointment.is_online
    }
  }, [_vm._v("\n            This appointment is online\n          ")]) : _vm._e(), _vm._v(" "), (_vm.integrationIsConnected) ? [(_vm.zoommeeting) ? _c('online-meeting-card', {
    attrs: {
      "appointment": _vm.zoommeeting
    }
  }) : _c('v-list', {
    staticClass: "elevation-0"
  }, [(_vm.appointment) ? _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.appointment,
      "with-color-coding": false
    }
  }, [(!_vm.appointment.is_online) ? _c('v-list-tile-action', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "small": ""
    },
    on: {
      "click": _vm.makeOnline
    }
  }, [_vm._v("\n                    Make online\n                  ")])], 1) : _vm._e()], 1) : _vm._e()], 1)] : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 subheading"
  }, [_vm._v("\n              Connect to your Zoom account\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": "https://appointmentguru.co/help/zoom-integration/",
      "flat": "",
      "text": "",
      "target": "_blank"
    }
  }, [_vm._v("Learn more "), _c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), (_vm.isEnabled) ? _c('v-btn', {
    attrs: {
      "href": _vm.oauthUrl,
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("\n                Install "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _c('v-btn', {
    attrs: {
      "outline": "",
      "disabled": "",
      "href": _vm.oauthUrl,
      "color": "primary"
    }
  }, [_vm._v("\n                Coming soon\n              ")])], 1), _vm._v(" "), _c('v-card-text', [_c('ul', [_c('li', [_c('strong', [_vm._v("To create online appointments, you will need to configure an integration with\n                  "), _c('a', {
    attrs: {
      "href": "https://zoom.us",
      "target": "_blank"
    }
  }, [_vm._v("Zoom")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Zoom is a tool for doing online meetings")]), _vm._v(" "), _c('li', [_vm._v("Zoom is free to use for 1-on-1 meetings")]), _vm._v(" "), _c('li', [_vm._v("Zoom is free to use for group meetings shorter than 40 minutes")]), _vm._v(" "), _c('li', [_vm._v("There are paid plans should you need more")])])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("With the AppointmentGuru integration, you can:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Make an appointment into an \"online appointment\"")]), _vm._v(" "), _c('li', [_vm._v("AppointmentGuru will automatically create the meeting in Zoom and make all the relevent information available to you and easy to share")]), _vm._v(" "), _c('li', [_vm._v("Automatically add meeting information to your notifications")]), _vm._v(" "), _c('li', [_vm._v("Easily share Zoom meeting information with your clients")]), _vm._v(" "), _c('li', [_vm._v("Start the meeting directly from AppointmentGuru")])])])])])], 1)], 2)], 1), _vm._v(" "), _c('v-tab-item', [(_vm.appointment) ? _c('online-meeting-card', {
    attrs: {
      "editmode": true,
      "appointment": _vm.appointment
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [_c('v-icon', [_vm._v("help")]), _vm._v(" "), _c('v-toolbar-title', [_vm._v("GuruSupport")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [(_vm.step === 1) ? [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("keyboard_backspace")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })] : _vm._e(), _vm._v(" "), _c('v-text-field', {
    staticClass: "mx-1 mb-2",
    attrs: {
      "clearable": "",
      "persistent-hint": "",
      "hint": "Type a query to search our online knowledgebase",
      "prepend-icon": "search",
      "placeholder": "How do I .."
    },
    on: {
      "input": _vm.doSearch
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-spacer')], 2), _vm._v(" "), _c('v-card-text', [_c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    staticClass: "searchresult"
  }, [(_vm.results && _vm.results.hits) ? [_c('v-subheader', {
    staticClass: "overline pa-0"
  }, [_vm._v("Search results\n            "), (_vm.search && _vm.search.length > 0) ? _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(" for "), _c('i', [_vm._v(_vm._s(_vm.search))])]) : _vm._e()]), _vm._v(" "), (_vm.pageCount === 1) ? _c('small', {
    staticClass: "text-xs text-gray-400 ml-3"
  }, [_vm._v("\n            " + _vm._s(_vm.results.nbHits) + " results returned in " + _vm._s(_vm.results.processingTimeMs) + "ms\n          ")]) : (_vm.pageCount > 1) ? _c('small', {
    staticClass: "text-xs text-gray-400 ml-3"
  }, [_vm._v("\n            Showing Page " + _vm._s(_vm.pageNumber) + " of " + _vm._s(_vm.results.nbHits) + " results returned in " + _vm._s(_vm.results.processingTimeMs) + "ms\n          ")]) : _c('small', {
    staticClass: "text-xs text-gray-400 ml-3"
  }, [_vm._v("\n            0 results returned in " + _vm._s(_vm.results.processingTimeMs) + "ms\n          ")]), _vm._v(" "), _vm._l((_vm.paginatedData), function(result) {
    return _c('div', {
      key: result.id
    }, [_c('v-card', {
      staticClass: "grey darken-2 mt-2",
      attrs: {
        "dark": ""
      }
    }, [_c('v-list', {
      attrs: {
        "dense": "",
        "dark": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(result._formatted.title)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": "",
        "href": ("https://help.appointmentguru.co/" + (result._formatted.slug) + ".html"),
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), (result.video_embed_url) ? _c('v-list-tile-action', {
      staticClass: "ml-0"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedVideo = result
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("videocam")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (result && result._formatted) ? _c('v-card-text', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatSummary(result._formatted.summary))
      }
    }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.setSelectedArticle(result)
        }
      }
    }, [_vm._v("More\n                  "), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("chevron_right")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (result.articleVisibility),
        expression: "result.articleVisibility"
      }]
    }, [_c('v-card-title', {
      staticClass: "subheading secondary darken-1"
    }, [_vm._v("\n                Article Fetched: " + _vm._s(result.title) + "\n              ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Fetched Article To Come Here\n              ")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount
    },
    on: {
      "input": _vm.nextPage
    },
    model: {
      value: (_vm.pageNumber),
      callback: function($$v) {
        _vm.pageNumber = $$v
      },
      expression: "pageNumber"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-window-item', [(_vm.selectedArticle) ? _c('v-card', {
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.step--
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    domProps: {
      "textContent": _vm._s(_vm.selectedArticle.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "href": ("https://help.appointmentguru.co/" + (_vm.selectedArticle.slug) + ".html"),
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "py-2"
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedSummary)
    }
  }), _vm._v(" "), (_vm.selectedEmbed) ? _c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%"
    },
    attrs: {
      "src": _vm.selectedEmbed,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.selectedContent)
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "my-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-1 justify-center",
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [_vm._v("\n          Still need help?\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "outline": "",
      "outlined": "",
      "dark": "",
      "href": "https://help.appointmentguru.co/",
      "target": "_blank"
    }
  }, [_vm._v("\n          Open Knowledgebase\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "outline": "",
      "outlined": "",
      "dark": "",
      "href": "https://help.appointmentguru.co/",
      "target": "_blank"
    }
  }, [_vm._v("\n          Email support\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("email")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "outline": "",
      "outlined": "",
      "href": "https://book.appt.guru/?s=9",
      "target": "_blank"
    }
  }, [_vm._v("\n          Book a demo\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), (_vm.selectedVideo) ? _c('v-dialog', {
    attrs: {
      "width": "680",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "flat": "",
      "dark": ""
    },
    model: {
      value: (_vm.selectedVideo),
      callback: function($$v) {
        _vm.selectedVideo = $$v
      },
      expression: "selectedVideo"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-1"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedVideo.title) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedVideo = null
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "padding-bottom": "70.45009784735812%",
      "height": "0"
    }
  }, [(_vm.selectedVideo) ? _c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.selectedVideo,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  }) : _vm._e()])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.request.status > 299) ? _c('v-alert', {
    staticClass: "pa-1 lighten-1 mt-0 mb-0",
    attrs: {
      "dark": "",
      "error": "",
      "value": "showAlert",
      "dismissible": ""
    }
  }, [(_vm.errorsIsIterable) ? _c('v-list', {
    staticClass: "error lighten-1",
    attrs: {
      "dense": "",
      "dark": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline",
    attrs: {
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.errors), function(errors, field) {
    return [_c('v-divider', {
      key: ("div-" + field)
    }), _vm._v(" "), _vm._l(([].concat(errors)), function(error) {
      return _c('v-list-tile', {
        key: error
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
        domProps: {
          "textContent": _vm._s(error)
        }
      }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(field.split("_").join(" ")) + "\n            ")])], 1)], 1)
    })]
  })], 2) : _c('div', [_vm._v(_vm._s(_vm.errors))])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [(_vm.withInlineControls) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "blue": "",
      "absolute": "",
      "right": ""
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-subheader', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.appointment.codes), function(code, index) {
    return _c('v-list-tile', {
      key: code.id,
      attrs: {
        "disabled": _vm.deleting.indexOf(code.id) !== -1
      }
    }, [(_vm.withDelete) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.prepareToDelete(code, index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(code.icd10) + ". " + _vm._s(code.process) + "\n      ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n      " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n    ")])], 1)
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": 300
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.$t('dialog.delete.title')) + "\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.deleteRequest.loading,
      "color": "error"
    },
    on: {
      "click": _vm.deleteCode
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', _vm._b({
    attrs: {
      "href": _vm.LINKS.INVITE,
      "target": "_blank"
    }
  }, 'v-btn', _vm.attrs, false), [(_vm.icon) ? _c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.text) + "\n")], 1)
},staticRenderFns: []}

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    key: _vm.appointment.id,
    class: _vm.listItemColor,
    attrs: {
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit("listitem:clicked", _vm.appointment)
      }
    }
  }, [_vm._t("actions", function() {
    return [(_vm.withActions) ? _c('v-list-tile-action', [_c('appointment-action-menu', {
      attrs: {
        "appointment": _vm.appointment
      }
    })], 1) : _vm._e()]
  }), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "appointment-list-item-content"
  }, [_vm._t("title", function() {
    return [(_vm.appointment) ? _c('v-list-tile-title', [(_vm.appointment.is_online) ? _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "small": "",
              "x-small": ""
            }
          }, on), [_vm._v("\n            headset_mic\n          ")])]
        }
      }], null, false, 4011458489)
    }, [_vm._v(" "), _c('span', [_vm._v("This appointment is online")])]) : _vm._e(), _vm._v(" "), (_vm.withStatusChips) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      class: _vm.formattedStatus.theme,
      attrs: {
        "label": "",
        "dark": ""
      }
    }, [_vm._v("\n          " + _vm._s(_vm.formattedStatus.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.appointment.title) ? _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.appointment.title)
      }
    }) : _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.appointment.full_name)
      }
    }), _vm._v(" "), (_vm.appointment.zoom_meeting_id) ? _c('v-btn', {
      staticClass: "pa-0 ma-0",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "href": ("https://zoom.us/meeting/" + (_vm.appointment.zoom_meeting_id)),
        "target": "_blank",
        "small": "",
        "x-small": "",
        "color": "primary",
        "flat": "",
        "text": ""
      }
    }, [_vm._v("Open in Zoom\n          "), _c('v-icon', {
      staticClass: "ml-2",
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "max-width": 150
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [(_vm.appointment.invoiceable) ? _c('v-chip', _vm._g({
            staticClass: "v-chip--x-small",
            attrs: {
              "color": "success",
              "outline": "",
              "outlined": "",
              "label": "",
              "dark": ""
            },
            on: {
              "click": function($event) {
                return _vm.$store.dispatch("SHOW_APPOINTMENT_DIALOG", [true, "InvoiceDetails", _vm.appointment])
              }
            }
          }, on), [_vm._v("Invoiceable")]) : _vm._e()]
        }
      }], null, false, 1874073358)
    }, [_vm._v(" "), _c('span', [_vm._v("Invoiceable is an optional manual flag that you can apply to keep\n            track of which appointments can safely be invoiced\n          ")])]), _vm._v(" "), (_vm.$vuetify.breakpoint.xs) ? _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.appointment.price)))]) : _vm._e()], 1) : _vm._e()]
  }), _vm._v(" "), _vm._t("sub-title", function() {
    return [_c('v-list-tile-sub-title', [_c('div', [_vm._v("\n        " + _vm._s(_vm.formatFromTo(_vm.appointment.start_time, _vm.appointment.end_time)) + "\n      ")])]), _vm._v(" "), (_vm.withTags && _vm.appointment.tags) ? _c('v-list-tile-sub-title', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("tag")]), _vm._v(" " + _vm._s(_vm.appointment.tags) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.appointment.product_name) ? [_vm._v("\n      " + _vm._s(_vm.appointment.product_name) + "\n      ")] : _vm._e(), _vm._v(" "), (_vm.appointment.practitioner_name) ? [_vm._v("\n      with " + _vm._s(_vm.appointment.practitioner_name) + "\n      ")] : _vm._e(), _vm._v(" "), (_vm.appointment.address_name) ? [_vm._v("@ " + _vm._s(_vm.appointment.address_name))] : _vm._e()], 2)]
  })], 2), _vm._v(" "), (_vm.withPricing) ? _c('v-list-tile-action', {
    staticClass: "hidden-xs-only"
  }, [_c('strong', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.appointment.price)))])]) : _vm._e(), _vm._v(" "), _vm._t("action", function() {
    return [(_vm.withAction) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('goto', _vm.appointment)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("chevron_right")])], 1)], 1) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withTitle) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "extended": _vm.$vuetify.breakpoint.xs
    }
  }, [_c('v-toolbar-title', [_c('span', [_vm._v(_vm._s(_vm.clientFullName))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? [(_vm.mailchimpIntegration && _vm.clientEmail && _vm.relationshipId) ? _c('mailchimp-chip', {
    attrs: {
      "email": _vm.clientEmail,
      "relationship-id": _vm.relationshipId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.physitrackIntegration && _vm.relationshipId) ? _c('physitrack-embed', {
    attrs: {
      "relationship-id": _vm.relationshipId
    }
  }) : _vm._e()] : _c('template', {
    slot: "extension"
  }, [(_vm.mailchimpIntegration && _vm.clientEmail && _vm.relationshipId) ? _c('mailchimp-chip', {
    attrs: {
      "email": _vm.clientEmail,
      "relationship-id": _vm.relationshipId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.physitrackIntegration && _vm.relationshipId) ? _c('physitrack-embed', {
    attrs: {
      "relationship-id": _vm.relationshipId
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.client && _vm.client.id) ? [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.sharingdialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("share")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "360"
    },
    model: {
      value: (_vm.sharingdialog),
      callback: function($$v) {
        _vm.sharingdialog = $$v
      },
      expression: "sharingdialog"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1 overline"
  }, [_vm._v("\n            Sharing\n            "), _c('help-popover', [_vm._v("\n              Members of spaces with which this client is shared will be able to view and edit the client\n              as well as creating appointments and invoices for them. "), _c('br'), _vm._v("\n              Only the owner is able to change sharing settings\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sharingdialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.share
    }
  }), _vm._v(" "), _c('v-card-text', [(_vm.ownerId) ? _c('sharing-information', {
    staticClass: "ml-3",
    attrs: {
      "context": _vm.client.context,
      "owner-id": _vm.ownerId,
      "space-ids": _vm.client.spaces
    }
  }) : _vm._e(), _vm._v(" "), _c('space-picker', {
    attrs: {
      "required": "",
      "with-select": false,
      "label": "Contact is shared with these spaces",
      "direction": "bottom"
    },
    model: {
      value: (_vm.client.spaces),
      callback: function($$v) {
        _vm.$set(_vm.client, "spaces", $$v)
      },
      expression: "client.spaces"
    }
  }), _vm._v(" "), _c('v-alert', {
    staticClass: "py-1 caption lighten-1 mt-3",
    attrs: {
      "type": "info",
      "value": true,
      "dismissible": ""
    }
  }, [_c('strong', [_vm._v("Note:")]), _vm._v("\n              only an owner of these spaces can change the sharing preferences\n            ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": this.requests.share.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.setSharing
    }
  }, [(_vm.client.spaces.length === 0) ? _c('span', [_vm._v("Clear sharing")]) : _c('span', [_vm._v("Update sharing")])])], 1)], 1)], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.client && _vm.client.id) ? [(!_vm.isCompact) ? _c('v-tabs', {
    attrs: {
      "vertical": "",
      "dark": "",
      "show-arrows": "",
      "grow": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('v-tab', {
      key: item.id
    }, [(index === 0) ? _c('v-icon', [_vm._v("home")]) : _c('span', [_vm._v(_vm._s(item.title))])], 1)
  }), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-tab-item', {
      key: item.id
    }, [(item.component && _vm.activeTab === index) ? _c(item.component, _vm._g(_vm._b({
      tag: "component",
      attrs: {
        "lazy": ""
      },
      on: {
        "report": _vm.showReport,
        "close": function($event) {
          return _vm.$emit("close")
        },
        "click:share": function($event) {
          _vm.sharingdialog = true
        },
        "goto": _vm.gotoTabName
      }
    }, 'component', item.attrs, false), item.evnts || {}), [_c('template', {
      slot: "toolbar-buttons"
    }, [(item.id === "Statement") ? _c('v-btn', {
      staticClass: "hidden-xs-only",
      attrs: {
        "flat": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.showReport('account')
        }
      }
    }, [_vm._v("Print report\n              ")]) : _vm._e(), _vm._v(" "), (item.id === "Notes") ? _c('v-btn', {
      staticClass: "hidden-xs-only mr-5",
      attrs: {
        "flat": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.showReport('client-report')
        }
      }
    }, [_vm._v("Print report\n              ")]) : _vm._e()], 1)], 2) : _vm._e()], 1)
  }), 1)], 2) : _c('v-expansion-panel', {
    staticClass: "elevation-0",
    attrs: {
      "focusable": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-expansion-panel-content', {
      key: item.id,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('div', {
            staticClass: "subheading"
          }, [_vm._v("\n            " + _vm._s(item.title))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (item.component && _vm.activeTab === index) ? _c(item.component, _vm._g(_vm._b({
      tag: "component",
      attrs: {
        "lazy": ""
      },
      on: {
        "click:share": function($event) {
          _vm.sharingdialog = true
        },
        "goto": _vm.gotoTabName
      }
    }, 'component', item.attrs, false), item.evnts || {})) : _vm._e()], 1)
  }), 1)] : _vm._e(), _vm._v(" "), (_vm.client && _vm.client.client) ? _c('v-footer', {
    staticClass: "px-3 mt-4"
  }, [_c('small', [_vm._v("\n    " + _vm._s(_vm.clientFullName) + ", Client #" + _vm._s(_vm.client.client.id) + ". Rel #" + _vm._s(_vm.client.id) + "\n    ")]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.showReportDialog),
      callback: function($$v) {
        _vm.showReportDialog = $$v
      },
      expression: "showReportDialog"
    }
  }, [_c('report-form', {
    attrs: {
      "relationship-id": _vm.relationshipId,
      "report-name": _vm.reportName
    },
    on: {
      "close": function($event) {
        _vm.showReportDialog = false
      }
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Got it")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "rows-per-page-items": [10, 25, 50],
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.data,
      "search": _vm.search,
      "select-all": _vm.selectable,
      "full-width": "",
      "dense": "",
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.selectable) ? _c('td', [_c('v-checkbox', {
          attrs: {
            "input-value": props.selected,
            "primary": "",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.headers), function(header) {
          return _c('td', {
            key: header.value
          }, [_vm._v(_vm._s(props.item[header.value]))])
        }), _vm._v(" "), _c('td', [_c('v-menu', {
          attrs: {
            "bottom": "",
            "left": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
          attrs: {
            "dense": ""
          }
        }, _vm._l((_vm.actions), function(action) {
          return _c('v-list-tile', {
            key: action.icon,
            on: {
              "click": function($event) {
                return _vm.$emit(action.action, props.item)
              }
            }
          }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v(_vm._s(action.icon))]), _vm._v("\n                    " + _vm._s(action.text) + "\n                  ")], 1)], 1)
        }), 1)], 1)], 1)], 2)]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withCreate && _vm.createInvoice && _vm.appointment && _vm.appointment.client) ? _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "15"
    },
    attrs: {
      "right": "",
      "overlay": "",
      "fixed": "",
      "bottom": "",
      "disable-resize-watcher": "",
      "disable-route-watcher": "",
      "stateless": "",
      "touchless": "",
      "hide-overlay": false,
      "width": "440"
    },
    model: {
      value: (_vm.createInvoice),
      callback: function($$v) {
        _vm.createInvoice = $$v
      },
      expression: "createInvoice"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-1 grey lighten-4"
  }, [_vm._v("\n        Create an invoice\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.createInvoice = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.computedRelationship && _vm.computedRelationship.id) ? _c('confirm-invoice', {
    attrs: {
      "with-header": false,
      "relationship": _vm.computedRelationship,
      "appointments": [_vm.appointment]
    },
    on: {
      "success": _vm.loadAppointment,
      "done": function($event) {
        return _vm.$emit("close")
      }
    },
    model: {
      value: (_vm.invoice),
      callback: function($$v) {
        _vm.invoice = $$v
      },
      expression: "invoice"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.appointment && _vm.withDone) ? _c('v-list', {
    staticStyle: {
      "position": "fixed",
      "top": "0px",
      "left": "0px",
      "right": "0px",
      "z-index": "14"
    },
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.appointmentRequest.loading
    },
    on: {
      "click": _vm.loadAppointment
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.formattedStatus && _vm.formattedStatus.theme) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    class: _vm.formattedStatus.theme,
    attrs: {
      "label": "",
      "dark": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formattedStatus.title) + "\n            ")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.appointmentInvoiceTitle) + "\n          ")], 1), _vm._v(" "), (_vm.appointment.invoice_description) ? _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.invoice_description)
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.appointmentRequest.loading) ? _c('v-list-tile-action', [_c('v-progress-circular', {
    staticClass: "mr-3",
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  })], 1) : _c('v-list-tile-action', [(_vm.withCreate) ? _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "small": "",
      "icon": _vm.$vuetify.breakpoint.xs,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createInvoice = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 hidden-xs-only"
  }, [_vm._v("Invoice")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-5"
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.set_discount,
      "message200": "Discount successfully applied"
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.appointmentEditRequest,
      "message200": "Appointment details updated"
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.appointmentRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs2": "",
      "order-sm1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Ready for invoicing",
      "persistent-hint": "",
      "hint": "Tick this so that you know this appointment can be safely added to invoices",
      "color": "success",
      "loading": _vm.appointmentEditRequest.loading
    },
    on: {
      "change": _vm.markAsInvoiceable
    },
    model: {
      value: (_vm.appointment.invoiceable),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "invoiceable", $$v)
      },
      expression: "appointment.invoiceable"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs1": "",
      "order-sm2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "elevation-4 mt-2",
    attrs: {
      "box": "",
      "persistent-hint": "",
      "id": "appointmentPrice",
      "name": "appointmentPrice",
      "append-icon": "save",
      "loading": _vm.appointmentEditRequest.loading,
      "prefix": _vm.appointment.currency,
      "disabled": _vm.appointmentEditRequest.loading || (_vm.appointment.codes && _vm.appointment.codes.length > 0),
      "hint": _vm.appointmentPriceHint,
      "rules": _vm.appointmentPriceRules,
      "type": "tel",
      "label": "Appointment price"
    },
    on: {
      "blur": _vm.saveAppointmentDetails,
      "append:click": _vm.saveAppointmentDetails,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveAppointmentDetails.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.appointment.price),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "price", $$v)
      },
      expression: "appointment.price"
    }
  }), _vm._v(" "), (_vm.appointment) ? _c('v-text-field', {
    staticClass: "mt-2 mx-2",
    attrs: {
      "dense": "",
      "filled": "",
      "clearable": "",
      "loading": _vm.requests.set_discount.loading,
      "disabled": _vm.requests.set_discount.loading,
      "label": "Add a discount",
      "placeholder": "0.00",
      "prefix": _vm.appointment.currency,
      "append-icon": "save"
    },
    on: {
      "click:clear": function($event) {
        _vm.appointment.discount_amount = 0
      },
      "append:click": _vm.setDiscount,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setDiscount.apply(null, arguments)
      },
      "blur": _vm.setDiscount
    },
    model: {
      value: (_vm.appointment.discount_amount),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "discount_amount", $$v)
      },
      expression: "appointment.discount_amount"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panel', {
    staticClass: "elevation-4",
    attrs: {
      "flat": ""
    },
    model: {
      value: (_vm.activePanel),
      callback: function($$v) {
        _vm.activePanel = $$v
      },
      expression: "activePanel"
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Appointment information")]), _vm._v(" "), _c('v-form', {
    staticClass: "grey lighten-4"
  }, [_c('v-card', {
    staticClass: "grey lighten-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "appointment-invoice-title",
      "append-icon": "save",
      "label": "Invoice title",
      "persistent-hint": "",
      "hint": "Change the title as it appears in the invoice"
    },
    on: {
      "blur": _vm.saveAppointmentDetails,
      "append:click": _vm.saveAppointmentDetails,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveAppointmentDetails.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.invoiceTitle),
      callback: function($$v) {
        _vm.invoiceTitle = $$v
      },
      expression: "invoiceTitle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "appointmentDescription",
      "name": "appointmentDescription",
      "append-icon": "save",
      "label": "Appointment description",
      "persistent-hint": "",
      "hint": "You can add further information about the appointment here. For example: \"knee rehab\""
    },
    on: {
      "blur": _vm.saveAppointmentDetails,
      "append:click": _vm.saveAppointmentDetails,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveAppointmentDetails.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.invoiceDescription),
      callback: function($$v) {
        _vm.invoiceDescription = $$v
      },
      expression: "invoiceDescription"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Medical aid coding")]), _vm._v(" "), _c('v-form', {
    staticClass: "grey lighten-4"
  }, [(_vm.activePanel === _vm.PANELS.CODES) ? _c('appointment-codes', {
    ref: "invoiceCodes",
    staticClass: "mt-4",
    attrs: {
      "with-clone": "",
      "editable": "",
      "with-refresh": "",
      "with-title": "",
      "appointment-id": _vm.appointment.id
    },
    on: {
      "pricechange": _vm.setAppointmentPrice
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Product sales\n        ")]), _vm._v(" "), _c('v-form', [(_vm.activePanel === _vm.PANELS.PRODUCTS && _vm.appointment.id) ? _c('appointment-product', {
    attrs: {
      "appointment-id": _vm.appointment.id
    },
    on: {
      "updated": _vm.loadAppointment
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('titles.invoices')) + "\n      ")]), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.invoiceRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-form', {
    staticClass: "grey lighten-4"
  }, [_c('h3', {
    staticClass: "overline pa-4"
  }, [_vm._v("\n          This appointment is included in the following invoices\n        ")]), _vm._v(" "), (_vm.invoices && _vm.invoices.length > 0) ? _c('invoice-list', {
    staticClass: "pa-4",
    attrs: {
      "transition": "fade",
      "invoices": _vm.invoices
    },
    on: {
      "selected": _vm.gotoInvoice
    }
  }) : _c('div', {
    staticClass: "px-4 pb-4"
  }, [_vm._v("\n          No invoices found for this appointment\n        ")])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Payments\n        ")]), _vm._v(" "), _c('v-form', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.appointment && _vm.appointment.payments) ? _c('payment-list', {
    attrs: {
      "with-delete": "",
      "appointment": _vm.appointment,
      "payments": _vm.appointment.payments
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "disabled": _vm.isPaid
    },
    on: {
      "click": function($event) {
        _vm.addPaymentDialog = true;
        _vm.touchPayment++
      }
    }
  }, [_vm._v("Add a payment")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.addPaymentDialog),
      callback: function($$v) {
        _vm.addPaymentDialog = $$v
      },
      expression: "addPaymentDialog"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Add a payment")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.addPaymentDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.activePanel === _vm.PANELS.PAYMENTS) ? _c('create-transaction', {
    attrs: {
      "with-appointment-info": false,
      "with-done": false,
      "touch": _vm.touchPayment,
      "appointment": _vm.appointment
    },
    on: {
      "success": function($event) {
        return _vm.loadAppointment()
      },
      "close": function($event) {
        _vm.addPaymentDialog = false
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.appointment && _vm.appointment.financials) ? _c('appointment-price-details', {
    attrs: {
      "with-title": false
    },
    on: {
      "finalprice": function($event) {
        return _vm.$emit("finalprice")
      }
    },
    model: {
      value: (_vm.appointment.financials),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "financials", $$v)
      },
      expression: "appointment.financials"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.createInvoice) ? _c('v-card-actions', {
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [(_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withCreate) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createInvoice = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v(" Create invoice\n    ")], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.bgImage,
      "aspect-ratio": "2.75",
      "height": "170"
    }
  }, [_c('center', [(_vm.qr) ? _c('v-img', {
    staticClass: "elevation-20 mt-2",
    staticStyle: {
      "border": "solid 2px black"
    },
    attrs: {
      "width": "150px",
      "height": "150px",
      "src": _vm.qr
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._t("card-title", function() {
    return [_c('v-card-title', {
      staticClass: "subheading"
    }, [_vm._v("\n      Share: " + _vm._s(_vm.link.title) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "href": _vm.link.url,
        "title": _vm.link.title,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1)]
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-alert', {
    staticClass: "pa-2 mx-3",
    attrs: {
      "outline": "",
      "value": true,
      "type": "info"
    }
  }, [_vm._v("\n    Point your phone's camera at this code to open the link\n  ")]), _vm._v(" "), _c('v-card-text', [_c('copy-text-field', {
    attrs: {
      "text-to-copy": _vm.link.url,
      "label": "Copy link to clipboard"
    }
  }), _vm._v(" "), (_vm.email || _vm.phone || _vm.firstName) ? _c('v-list', {
    staticClass: "mt-0 pa-0",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "mt-0 py-0 overline"
  }, [_vm._v("Contact information")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.phone)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.email)
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success",
      "href": _vm.whatsappIt(_vm.phone, _vm.link.url),
      "target": "_blank",
      "block": ""
    }
  }, [_vm._v("Whatsapp\n      "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "href": _vm.mailIt(_vm.email, _vm.link),
      "target": "_blank",
      "block": ""
    }
  }, [_vm._v("Open in mail\n      "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), (_vm.canShare) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.share
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Physitrack")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.requests.get.loading) ? _c('v-card-text', [_c('center', [_c('v-progress-circular', {
    staticClass: "ma-4 pa-4",
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "3",
      "size": "36"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Loading\n        ")], 1)], 1) : [(!_vm.physitrackClientId) ? [_c('v-alert', {
    staticClass: "ma-3",
    attrs: {
      "value": true,
      "type": "info",
      "outline": "",
      "outlined": ""
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.relationshipFirstName) + " " + _vm._s(_vm.relationshipLastName) + "\n              "), (_vm.dob) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.dob)
    }
  }) : _vm._e()]), _c('br'), _vm._v("\n            User does not exist in Physitrack. Would you like to create a user?\n            "), _c('request-status', {
    attrs: {
      "request": _vm.requests.create
    }
  }), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.isValid),
      callback: function($$v) {
        _vm.isValid = $$v
      },
      expression: "isValid"
    }
  }, [_c('v-layout', {
    staticClass: "mt-2"
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required, _vm.rules.validDate],
      "hint": "Date of birth is required by Physitrack and the user will use the _year_ to log in to physitrack",
      "persistent-hint": true,
      "error-messages": _vm.createClientErrors.date_of_birth,
      "placeholder": "yyyy-mm-dd",
      "label": "Date of birth (yyyy-mm-dd)"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.create.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.date_of_birth),
      callback: function($$v) {
        _vm.date_of_birth = $$v
      },
      expression: "date_of_birth"
    }
  }), _vm._v(" "), _c('small', [_c('strong', [_vm._v("TIP:")]), _vm._v("\n                  if you do not know the date of birth, you can make something up. But try get the year right if you can\n                ")])], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    attrs: {
      "disabled": !_vm.isValid,
      "loading": _vm.requests.create.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Or, link to an existing client in Physitrack")])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    staticClass: "ma-3",
    attrs: {
      "persistent-hint": "",
      "loading": _vm.requests.clients.loading,
      "label": "Look for a client in Physitrack",
      "hint": "Search the last name of a client in Physitrack (note: search is case sensitive and must be an exact match)",
      "append-icon": "search"
    },
    on: {
      "click:append": function($event) {
        return _vm.getClients(_vm.lastName)
      },
      "keypress": _vm.debounceSearch
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "small": "",
      "loading": _vm.requests.clients.loading
    },
    on: {
      "click": function($event) {
        return _vm.getClients(_vm.lastName)
      }
    }
  }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), (_vm.requests.clients.status === 200) ? [(_vm.clients && _vm.clients.length > 0) ? _c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n                Matches found\n              ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, _vm._l((_vm.clients), function(client, index) {
    return _c('physitrack-client-list-item', {
      key: client.id,
      model: {
        value: (_vm.clients[index]),
        callback: function($$v) {
          _vm.$set(_vm.clients, index, $$v)
        },
        expression: "clients[index]"
      }
    }, [_c('v-list-tile-action', {
      attrs: {
        "slot": "action"
      },
      slot: "action"
    }, [_c('v-btn', {
      attrs: {
        "loading": _vm.requests.link.loading,
        "color": "primary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.link(client.id)
        }
      }
    }, [_vm._v("Link")])], 1)], 1)
  }), 1)], 1)], 1) : _c('v-alert', {
    staticClass: "pa-0 mx-3",
    attrs: {
      "value": true,
      "outline": "",
      "type": "info"
    }
  }, [_vm._v("\n              No clients found with surname "), _c('strong', [_vm._v(_vm._s(_vm.lastName))])])] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.physitrackClientId && _vm.relationshipId) ? _c('programs', {
    attrs: {
      "physitrack-client-id": _vm.physitrackClientId,
      "relationship-id": _vm.relationshipId,
      "touch": _vm.physiTouch
    },
    model: {
      value: (_vm.physitrackClient),
      callback: function($$v) {
        _vm.physitrackClient = $$v
      },
      expression: "physitrackClient"
    }
  }) : _vm._e()]], 2)], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = true
      }
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("expand_more")])], 1), _vm._v("\n    Physitrack\n  ")], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.activeWindow),
      callback: function($$v) {
        _vm.activeWindow = $$v
      },
      expression: "activeWindow"
    }
  }, [_c('v-window-item', {
    key: 0
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "flat": ""
    }
  }, [(_vm.withHeader) ? _c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        return _vm.$emit("back")
      }
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n        " + _vm._s(_vm.title) + "\n        "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    class: {
      "pa-2": _vm.$vuetify.breakpoint.xsOnly
    }
  }, [(!_vm.editMode) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('space-picker', {
    attrs: {
      "with-select": false,
      "label": "Where would you like to save this client?"
    },
    model: {
      value: (_vm.client.spaces),
      callback: function($$v) {
        _vm.$set(_vm.client, "spaces", $$v)
      },
      expression: "client.spaces"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editMode || (_vm.client.spaces && _vm.client.spaces.length > 0)) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('server-errors', {
    attrs: {
      "request": _vm.createRequest
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Full name",
      "rules": [_vm.rules.required],
      "hint": "The client's name and surname. e.g.: Jon Snow"
    },
    model: {
      value: (_vm.client.full_name),
      callback: function($$v) {
        _vm.$set(_vm.client, "full_name", $$v)
      },
      expression: "client.full_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('phone-number-input', {
    attrs: {
      "short-list": ["ZA"],
      "selected-country-code": "ZA",
      "touch": _vm.contactSelectedPhone
    },
    on: {
      "number": _vm.setClientPhone,
      "valid": _vm.setValidPhoneNumber
    },
    model: {
      value: (_vm.contactSelectedPhone),
      callback: function($$v) {
        _vm.contactSelectedPhone = $$v
      },
      expression: "contactSelectedPhone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "type": "email",
      "rules": [_vm.rules.email],
      "hint": "e-mail address. e.g.: jon@gmail.com"
    },
    model: {
      value: (_vm.client.email),
      callback: function($$v) {
        _vm.$set(_vm.client, "email", $$v)
      },
      expression: "client.email"
    }
  })], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": "",
      "full-width": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pl-0 overline py-0",
    on: {
      "click": function($event) {
        _vm.showExtra = !_vm.showExtra
      }
    }
  }, [(_vm.showExtra === false) ? _c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.showExtra === true) ? _c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("remove")])], 1) : _vm._e(), _vm._v("\n                Extra fields\n              ")], 1), _vm._v(" "), (_vm.showExtra) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Client ID",
      "hint": "If you store some form of ID for recognizing your clients, you can use this to keep track"
    },
    model: {
      value: (_vm.client.custom_id),
      callback: function($$v) {
        _vm.$set(_vm.client, "custom_id", $$v)
      },
      expression: "client.custom_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nickname",
      "hint": "If the client has a nickname or a name that they prefer to be called by"
    },
    model: {
      value: (_vm.client.nickname),
      callback: function($$v) {
        _vm.$set(_vm.client, "nickname", $$v)
      },
      expression: "client.nickname"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.editMode) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mb-1 pb-0",
    attrs: {
      "hide-details": "",
      "label": "Update information on related appointments"
    },
    model: {
      value: (_vm.updateAppointments),
      callback: function($$v) {
        _vm.updateAppointments = $$v
      },
      expression: "updateAppointments"
    }
  }), _vm._v(" "), _c('small', {
    attrs: {
      "color": "primary mt-1"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n                When you create an appointment contact information is copied to the appointment (name, phone, email).\n                Select this option to have AppointmentGuru update this information on this user's appointments with your changes\n              ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.contactClient && _vm.showContactClient) ? _c('v-card', {
    attrs: {
      "full-width": ""
    }
  }, [_c('v-card-text', [_c('v-layout', [_c('v-subheader', [_c('v-icon', [_vm._v("person")]), _vm._v("\n                      Contact details: " + _vm._s(_vm.contactClient.name.formatted))], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showContactClient = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', [_vm._v("Phone numbers")]), _vm._v(" "), (_vm.contactClient.phoneNumbers && _vm.contactClient.phoneNumbers.length > 0) ? _c('v-radio-group', {
    attrs: {
      "mandatory": false
    }
  }, _vm._l((_vm.contactClient.phoneNumbers), function(number) {
    return _c('v-radio', {
      key: number,
      attrs: {
        "label": number,
        "value": number
      },
      on: {
        "change": function($event) {
          return _vm.setSelectedNumber(number)
        }
      }
    })
  }), 1) : _c('div', [_vm._v("No phone numbers found")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', [_vm._v("Email")]), _vm._v(" "), (_vm.contactClient.emails && _vm.contactClient.emails.length > 0) ? _c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.contactSelectedEmail),
      callback: function($$v) {
        _vm.contactSelectedEmail = $$v
      },
      expression: "contactSelectedEmail"
    }
  }, _vm._l((_vm.contactClient.emails), function(email) {
    return _c('v-radio', {
      key: email.id,
      attrs: {
        "label": email,
        "value": email
      },
      on: {
        "change": function($event) {
          _vm.client.email = email
        }
      }
    })
  }), 1) : _c('div', [_vm._v("No emails found")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(!_vm.editMode) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("\n                  Clear")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.hasContacts) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.pickContact
    }
  }, [_c('v-icon', [_vm._v("person_add")]), _vm._v(" Contacts")], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2"
  }, [(_vm.matchingClients && _vm.matchingClients.length > 0 && !_vm.editMode) ? _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "color": "warning",
            "outline": "",
            "block": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("warning")]), _vm._v("\n                " + _vm._s(_vm.matchingClients.length) + "\n                Similar clients found\n                "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }], null, false, 3454799101),
    model: {
      value: (_vm.showMatchingClients),
      callback: function($$v) {
        _vm.showMatchingClients = $$v
      },
      expression: "showMatchingClients"
    }
  }, [_vm._v(" "), _c('span', [_c('v-list', {
    staticClass: "pa-0 elevation-10",
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline grey lighten-4"
  }, [_vm._v("\n                    Some matches found\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMatchingClients = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.matchingClients.slice(0, 10)), function(client) {
    return [_c('client-list-item', {
      key: client.id,
      attrs: {
        "with-action": false,
        "relationship-id": client.id,
        "client": client.client
      },
      on: {
        "listitem:clicked": function($event) {
          return _vm.$emit("clientselected", client.client)
        }
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (client.id))
    })]
  }), _vm._v(" "), (_vm.matchingClients.length > 10) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("\n                      .. and " + _vm._s(_vm.matchingClients.length - 10) + " more\n                    ")])], 1) : _vm._e()], 2)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "width": "100%"
    }
  }, [(_vm.editMode) ? _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Updated client: Please confirm")]) : _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("New client: Please confirm")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [(_vm.client.full_name) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('client-list-item', {
    attrs: {
      "relationship-id": 0,
      "client": _vm.clientFormatted
    }
  }, [_c('template', {
    slot: "action"
  }, [(_vm.clientIsValid && _vm.hasSomeContactDetails) ? _c('v-icon', {
    attrs: {
      "slot": "action",
      "color": "success",
      "dark": ""
    },
    slot: "action"
  }, [_vm._v("check_circle")]) : _vm._e(), _vm._v(" "), (_vm.clientIsValid && !_vm.hasSomeContactDetails) ? _c('v-icon', {
    attrs: {
      "slot": "action",
      "color": "amber",
      "dark": ""
    },
    slot: "action"
  }, [_vm._v("warning")]) : _vm._e()], 1), _vm._v(" "), (!_vm.hasSomeContactDetails) ? _c('template', {
    slot: "subtitle"
  }, [_c('v-list-tile-sub-title', [_c('span', {
    staticClass: "yellow pa-2"
  }, [_c('strong', [_vm._v("Warning")]), _vm._v(" This client has no contact details specified")])]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "pl-1"
  }, [_vm._v("\n                        You can still save this client. It's just recommended to capture some form of contact information\n                      ")])], 1) : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-right pb-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('vuex-btn', {
    attrs: {
      "is-block": "",
      "is-disabled": !_vm.clientIsValid,
      "req-id": _vm.reqId,
      "text": _vm.btnTxt,
      "classes": ["ma-0"]
    },
    on: {
      "save": _vm.save
    }
  })], 1)], 1), _vm._v(" "), (_vm.singleErrorMessage) ? _c('p', {
    staticClass: "warning lighten-2 pa-3 subheading"
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v("\n              " + _vm._s(_vm.singleErrorMessage))], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.withBack) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("back")
      }
    }
  }, [_vm._v(_vm._s(_vm.backText))]) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', {
    key: 1
  }, [_c('v-list', _vm._l((_vm.actions), function(action) {
    return _c('v-list-tile', {
      key: action.icon,
      on: {
        "click": function($event) {
          return action.onclick(_vm.savedContact)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(action.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(action.title)
      }
    }), _vm._v(" "), (action.subtitle) ? _c('v-list-tile-sub-title', {
      domProps: {
        "textContent": _vm._s(action.subtitle)
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("attach_money")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n      " + _vm._s(_vm.fullName) + " paid " + _vm._s(_vm.amountFormatted) + " on " + _vm._s(_vm.dateformat(_vm.item.date)) + "\n      "), (_vm.item.method) ? _c('span', [_vm._v("via " + _vm._s(_vm.item.method) + ".")]) : _vm._e(), _vm._v(" "), (_vm.item.reference) ? _c('span', [_vm._v("ref: " + _vm._s(_vm.item.reference))]) : _vm._e()]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('v-chip', {
    staticClass: "v-chip--x-small ml-0",
    attrs: {
      "color": "success",
      "outline": ""
    },
    on: {
      "click": function($event) {
        return _vm.gotoClient({
          id: _vm.item.customer_id
        })
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.fullName) + "\n        "), _c('v-icon', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _vm._l((_vm.item.related_invoices_formatted), function(invoice) {
    return _c('v-chip', {
      key: invoice.invoice_number,
      staticClass: "v-chip--x-small ml-0",
      attrs: {
        "outline": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          _vm.gotoPage('invoice', invoice.invoice_number.split('-')[1])
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("post_add")]), _vm._v("\n        " + _vm._s(invoice.invoice_number) + ".\n        " + _vm._s(_vm.formatCurrency(invoice.currency, invoice.invoice_amount)) + "\n        "), _c('v-icon', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "small": "",
        "right": ""
      }
    }, [_vm._v("open_in_new")])], 1)
  }), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small ml-0",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.showAppointments
    }
  }, [_vm._v("\n        " + _vm._s(_vm.appointments.length) + " appointments\n        "), _c('v-icon', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 2)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('strong', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.amountFormatted))])]), _vm._v(" "), (_vm.dialogs.appt) ? _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.dialogs.appt),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "appt", $$v)
      },
      expression: "dialogs.appt"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.appt
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline py-0 grey lighten-4"
  }, [_vm._v("\n        Appointments\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.appt = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.remoteAppts), function(appt) {
    return [_c('appointment-list-item', {
      key: appt.id,
      attrs: {
        "with-color-coding": false,
        "with-status-chips": true,
        "appointment": appt
      },
      on: {
        "goto": function($event) {
          return _vm.gotoPage('appointment', appt.id)
        }
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (appt.id))
    })]
  })], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "flat": "",
      "xs12": "",
      "full-width": ""
    }
  }, [(_vm.withTitle && _vm.window === 0 && _vm.appointmentIds) ? _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n      " + _vm._s(_vm.$tc('messages.selectedappointments', _vm.appointmentIds.length, {
    n: _vm.appointmentIds.length
  })) + "\n      "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', {
    key: 0
  }, [(_vm.codes.length > 0) ? [_c('v-list', {
    staticClass: "mb-0"
  }, [_vm._l((_vm.codes), function(code, index) {
    return [_c('v-list-tile', {
      key: code.key
    }, [(code.currency) ? _c('v-list-tile-avatar', [_vm._v("\n                    " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "pl-2"
    }, [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(code.icd10) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      " + _vm._s(code.process) + "\n                    ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.del(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("d-" + index),
      attrs: {
        "inset": ""
      }
    })]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.appointmentIds.length === 0 || _vm.codes.length === 0
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save codes")])], 1)] : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-form', {
    staticClass: "grey lighten-4",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.fields), function(field) {
    return _c('v-flex', {
      key: field.label,
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-text-field', _vm._b({
      staticClass: "mx-1 mt-1 pb-0",
      attrs: {
        "solo": !_vm.$vuetify.breakpoint.xs
      },
      on: {
        "keypress": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.add.apply(null, arguments)
        }
      },
      model: {
        value: (_vm.code[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.code, field.key, $$v)
        },
        expression: "code[field.key]"
      }
    }, 'v-text-field', field, false))], 1)
  }), 1), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.valid,
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.add
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n                Add code")], 1)], 1)], 1)], 2), _vm._v(" "), _c('v-window-item', {
    key: 1
  }, [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "green"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 blockquote"
  }, [_vm._v("Codes have been added")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    }
  }, [_vm._v("Add more")])], 1), _vm._v(" "), (_vm.withDone) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.processcodepicker),
      callback: function($$v) {
        _vm.processcodepicker = $$v
      },
      expression: "processcodepicker"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "color": _vm.themeColor
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "short": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.processpicker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.processcodepicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('process-code-picker', {
    attrs: {
      "initial-search-string": _vm.processSearchString
    },
    on: {
      "input": _vm.setProcessCode
    },
    model: {
      value: (_vm.code.process),
      callback: function($$v) {
        _vm.$set(_vm.code, "process", $$v)
      },
      expression: "code.process"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.processcodepicker = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.ICD10codepicker),
      callback: function($$v) {
        _vm.ICD10codepicker = $$v
      },
      expression: "ICD10codepicker"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "color": _vm.themeColor
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "short": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.icd10picker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.ICD10codepicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('icd-picker', {
    attrs: {
      "touch": _vm.icdtouch,
      "initial-search-string": _vm.codeSearchString
    },
    on: {
      "input": _vm.setIcdCode
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.ICD10codepicker = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": 0
    }
  }, [_c('communication-template-list', {
    attrs: {
      "title": _vm.$t("comms.title"),
      "context": _vm.templateContext
    },
    on: {
      "selected": _vm.setSelectedCommunicationTemplate,
      "new": _vm.setCrud
    }
  })], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 1
    }
  }, [_c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [(_vm.title) ? _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.sender && _vm.sendToMe) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('recipient-card', {
    attrs: {
      "title": "Send to me"
    },
    on: {
      "sendTo": _vm.setSendToMe
    },
    model: {
      value: (_vm.sender),
      callback: function($$v) {
        _vm.sender = $$v
      },
      expression: "sender"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.recipients), function(recipient, index) {
    return _c('v-flex', {
      key: recipient.id,
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('recipient-card', {
      attrs: {
        "template-slug": _vm.template,
        "sender": _vm.sender,
        "context": _vm.context
      },
      on: {
        "sendTo": _vm.setSendTo
      },
      model: {
        value: (_vm.recipients[index]),
        callback: function($$v) {
          _vm.$set(_vm.recipients, index, $$v)
        },
        expression: "recipients[index]"
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.withSend) ? _c('v-card-actions', [(_vm.withCancel) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.sendRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.withSend) ? _c('v-window-item', {
    attrs: {
      "value": 2
    }
  }, [_c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('message-delivery-status', {
    attrs: {
      "batch-id": _vm.batchId
    }
  }), _vm._v(" "), (_vm.withSend) ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.page = 0
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 3
    }
  }, [_c('communication-template-form', {
    attrs: {
      "context-type": "Appointment"
    },
    on: {
      "close": function($event) {
        _vm.page = 0
      }
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Are you sure you want to cancel this appointment?\n      "), _c('v-spacer'), _vm._v(" "), (_vm.appointmentRequest.loading) ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "size": "20",
      "width": "2",
      "indeterminate": "",
      "color": "amber"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', {
    staticClass: "elevation-4 mb-4 pa-0",
    attrs: {
      "subheader": "",
      "dense": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_vm._v("Appointment details:")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.appointment
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "disabled": !_vm.hasContacts,
      "hint": _vm.sendCommsHint,
      "persistent-hint": !_vm.hasContacts,
      "label": "Send a message to the customer?",
      "light": ""
    },
    model: {
      value: (_vm.withCommunication),
      callback: function($$v) {
        _vm.withCommunication = $$v
      },
      expression: "withCommunication"
    }
  }), _vm._v(" "), (_vm.appointmentDetail && _vm.appointmentDetail.contact_phone) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "outline": "",
      "color": "success",
      "href": _vm.whatsappIt(_vm.appointmentDetail.contact_phone, _vm.cancelMessage),
      "target": "_blank"
    }
  }, [_vm._v("\n          WhatsApp\n          "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.withCommunication) ? [_c('small', {
    staticClass: "overline"
  }, [_vm._v("Contact details:")]), _vm._v(" "), (_vm.appointmentDetail.contact_phone) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.appointmentDetail.contact_phone))]) : _vm._e(), _vm._v(" "), (_vm.appointmentDetail.contact_phone) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.appointmentDetail.contact_email))]) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "persistent-hint": "",
      "label": "Include link to book a new appointment",
      "hint": "Will include a link to your booking widget so that they can schedule a new appointment",
      "light": ""
    },
    model: {
      value: (_vm.withBookingLink),
      callback: function($$v) {
        _vm.withBookingLink = $$v
      },
      expression: "withBookingLink"
    }
  })] : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm9": "",
      "md10": "",
      "lg11": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": _vm.clearpriceIcon,
      "prefix": _vm.appointment.currency,
      "type": "number",
      "label": "Clear codes and set new price"
    },
    on: {
      "click:prepend": _vm.toggleClearPrice
    },
    model: {
      value: (_vm.price),
      callback: function($$v) {
        _vm.price = $$v
      },
      expression: "price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": "",
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "disabled": !_vm.clearprice,
      "small": "",
      "outline": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.price = 0
      }
    }
  }, [_vm._v("Set Zero")])], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "prepend-icon": _vm.withInvoiceDescriptionIcon,
      "readonly": !_vm.withInvoiceDescription,
      "hint": "You can add an invoice description - something like: \"late cancellation\"",
      "label": "Set invoice description"
    },
    on: {
      "click:prepend": _vm.toggleInvoiceDescription
    },
    model: {
      value: (_vm.invoiceDescription),
      callback: function($$v) {
        _vm.invoiceDescription = $$v
      },
      expression: "invoiceDescription"
    }
  }), _vm._v(" "), (_vm.withInvoiceDescription) ? [_c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Quick picks")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.invoiceDescription = "Appointment cancelled"
      }
    }
  }, [_vm._v("Appointment cancelled")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.invoiceDescription = "Late cancellation"
      }
    }
  }, [_vm._v("Late cancellation")])] : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.response.loading,
      "disabled": !_vm.appointment.id
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Cancel Appointment\n      ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("settings")])], 1)]
      }
    }]),
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-2"
  }, [_vm._v("\n      Calendar settings\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('v-list', {
      key: option.value,
      attrs: {
        "dense": ""
      }
    }, [_c('v-subheader', {
      staticClass: "overline"
    }, [_vm._v(_vm._s(option.text))]), _vm._v(" "), _vm._l((option.items), function(item) {
      return _c('v-list-tile', {
        key: item.value,
        on: {
          "click": function($event) {
            return _vm.setItem(option.value, item.value)
          }
        }
      }, [(_vm.settings[option.value] === item.value) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1) : _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.text))])], 1)], 1)
    })], 2)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n      " + _vm._s(_vm.value.first_name) + " " + _vm._s(_vm.value.last_name) + "\n      "), _c('small', [_vm._v("(" + _vm._s(_vm.value.year_of_birth) + ")")])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n      " + _vm._s(_vm.value.email) + "\n    ")])], 1), _vm._v(" "), _vm._t("action")], 2)
},staticRenderFns: []}

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.request.loading) ? [_c('v-progress-linear', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "indeterminate": "",
      "height": "2"
    }
  })] : [(_vm.request.status === 400) ? _c('server-errors', {
    attrs: {
      "request": _vm.request
    }
  }) : (_vm.request.status >= 300 && _vm.message) ? _c('v-alert', {
    staticClass: "pa-2 mt-0",
    attrs: {
      "dense": "",
      "dismissible": "",
      "type": _vm.messageType,
      "value": true
    }
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n      "), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "outline": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Refresh app")])], 1) : _vm._e()], _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.messageType
    },
    model: {
      value: (_vm.showSnacker),
      callback: function($$v) {
        _vm.showSnacker = $$v
      },
      expression: "showSnacker"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.showSnacker = false
      }
    }
  }, [_vm._v("close")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "flat": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")]), _vm._v("\n      Share a form\n    ")], 1)]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('form-list', {
    attrs: {
      "relationship-id": _vm.relationshipId
    },
    on: {
      "selected": _vm.setSelectedForm
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "420",
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.showShare),
      callback: function($$v) {
        _vm.showShare = $$v
      },
      expression: "showShare"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showShare = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.links && _vm.links.length > 0) ? _c('share-card', {
    attrs: {
      "links": _vm.links
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "flat ma-0 pa-0",
    attrs: {
      "indeterminate": true,
      "height": 3
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Choose a background "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v(" for your website")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "Search background images",
      "append-icon": "search"
    },
    on: {
      "click:append": _vm.search,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.images), function(img) {
    return _c('v-flex', {
      key: img.id,
      staticClass: "text-xs-center",
      attrs: {
        "xs4": "",
        "md3": "",
        "lg2": ""
      }
    }, [(_vm.activeImg === img.id) ? _c('div', {
      staticClass: "mt-3"
    }, [_c('v-progress-circular', {
      attrs: {
        "indeterminate": "",
        "size": 50,
        "color": "amber"
      }
    }), _vm._v(" "), _c('div', [_vm._v("Setting background")])], 1) : _c('img', {
      staticClass: "image",
      attrs: {
        "src": img.urls.thumb
      },
      on: {
        "click": function($event) {
          return _vm.save(img)
        }
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 10000,
      "top": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    Background image updated\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Are you sure you want to delete this appointment?\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "type": "warning",
      "warning": "",
      "value": true
    }
  }, [_vm._v("This will permanently delete this appointment")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Appointment details:")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.appointment
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('vuex-btn', {
    attrs: {
      "is-disabled": !_vm.appointment.id,
      "reqId": _vm.reqId,
      "text": "Delete appointment"
    },
    on: {
      "save": _vm.save
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isReadOnly === true) ? _c('v-alert', {
    staticClass: "pa-2",
    attrs: {
      "value": "true",
      "type": "warning",
      "dismissible": "",
      "color": "error"
    }
  }, [_vm._v("Account is not active. It is in read-only mode\n    "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showmore = true
      }
    }
  }, [_vm._v("More info")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.billingUrl,
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("Reactivate account\n      "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "xs12": "",
      "dense": "",
      "type": "error",
      "width": "460"
    },
    model: {
      value: (_vm.showmore),
      callback: function($$v) {
        _vm.showmore = $$v
      },
      expression: "showmore"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-1"
  }, [_vm._v("\n        Account is in read-only mode\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showmore = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "mb-3",
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('center', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "href": "mailto:support@appointmentguru.co",
      "target": "_blank"
    }
  }, [_vm._v("\n          Contact support\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "flat": "",
      "text": "",
      "target": "_blank",
      "href": "https://appointmentguru.co/help/why-am-i-seeing-an-upgrade-notice"
    }
  }, [_vm._v("\n          Why am I seeing this\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.billingUrl,
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("Reactivate account\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [(_vm.title) ? _c('v-subheader', [(_vm.loading) ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "indeterminate": "",
      "size": 18,
      "width": 2,
      "color": "amber"
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.payments), function(payment) {
    return _c('v-list-tile', {
      key: payment.id,
      attrs: {
        "disabled": _vm.deletingPayments.indexOf(payment.id) !== -1
      }
    }, [(_vm.withDelete) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteDialog = true;
          _vm.selectedPayment = payment
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(_vm.dateformat(payment.transaction_date)) + "\n        "), (payment.method) ? [_vm._v(" via " + _vm._s(payment.method))] : _vm._e()], 2), _vm._v(" "), (payment.reference) ? _c('v-list-tile-sub-title', [_vm._v("\n        ref: " + _vm._s(payment.reference) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n      " + _vm._s(_vm.formatCurrency(payment.currency, payment.amount)) + "\n    ")])], 1)
  }), _vm._v(" "), (_vm.payments && _vm.payments.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        No payments found for this appointment\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": 300
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Are you sure you want to delete this payment\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.deleteLoading,
      "color": "error"
    },
    on: {
      "click": _vm.deleteClicked
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "color": _vm.color
    },
    model: {
      value: (_vm.snacker),
      callback: function($$v) {
        _vm.snacker = $$v
      },
      expression: "snacker"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.message) + "\n  "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    class: _vm.themeColor,
    attrs: {
      "dark": "",
      "dense": "",
      "flat": ""
    }
  }, [_vm._t("buttons-before"), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("pagetoolbar:homeclicked")
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _vm._t("buttons-after"), _vm._v(" "), (_vm.extended) ? _c('v-text-field', {
    staticClass: "white--text",
    attrs: {
      "slot": "extension",
      "dark": "",
      "prepend-icon": "search"
    },
    slot: "extension",
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withSearch) ? _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extended !== true),
      expression: "extended!==true"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.extended = true
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extended === true),
      expression: "extended===true"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.searchText = "";
        _vm.extended = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _vm._t("toolbar-right")], 2)
},staticRenderFns: []}

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withHeader) ? _c('v-system-bar', {
    staticStyle: {
      "position": "inherit"
    },
    attrs: {
      "color": _vm.themeColor,
      "status": "",
      "floating": "",
      "dark": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', [_c(_vm.activeComponent, {
    tag: "component",
    attrs: {
      "touch": _vm.componenttouch,
      "space-id": _vm.spaceId,
      "include-owned-by-me": _vm.includeOwnedByMe,
      "limit": 10,
      "can-clear-space": _vm.canClearSpace,
      "with-header": false,
      "with-back": true,
      "mode": "out-in",
      "show-list-initially": _vm.showListInitially,
      "initial": _vm.initial,
      "page": _vm.page,
      "title": _vm.title
    },
    on: {
      "clientselected": _vm.clientSelected,
      "relationshipselected": _vm.relationshipSelected,
      "client:created": _vm.clientCreated,
      "componentchanged": _vm.setComponent,
      "back": function($event) {
        _vm.activeComponent = "ClientList"
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Forms")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.request.loading) ? [_c('center', [_c('v-progress-circular', {
    staticClass: "ma-4",
    attrs: {
      "color": "amber",
      "indeterminate": "",
      "width": "2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("loading forms")])], 1)] : [_vm._l((_vm.forms), function(form) {
    return _c('v-list-tile', {
      key: form.id,
      on: {
        "click": function($event) {
          return _vm.$emit("selected", form)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(form.linked_form.title) + "\n        ")])], 1)], 1)
  }), _vm._v(" "), (_vm.forms && _vm.forms.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          No linked forms found\n        ")])], 1)], 1) : _vm._e()]], 2)
},staticRenderFns: []}

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-subheader', {
    staticClass: "overline pa-0",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _vm._l((_vm.methods), function(m) {
    return _c('v-chip', {
      key: m.value,
      attrs: {
        "small": _vm.small
      },
      on: {
        "click": function($event) {
          return _vm.setMethod(m)
        }
      }
    }, [(_vm.method === m.value) ? _c('v-icon', {
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n    " + _vm._s(m.text) + "\n  ")], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.hint)
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.label) ? _c('v-subheader', {
    staticClass: "overline pl-0",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.locations), function(location) {
    return _c('v-chip', {
      key: location.id,
      on: {
        "click": function($event) {
          return _vm.toggleSelected(location)
        }
      }
    }, [(_vm.isSelected(location)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n    " + _vm._s(location.name) + "\n  ")], 1)
  }), _vm._v(" "), (_vm.hint) ? _c('div', {
    staticClass: "caption text--grey mt-2 pl-2",
    domProps: {
      "textContent": _vm._s(_vm.hint)
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "460",
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.appointmentId && _vm.relationshipId) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "flat": "",
            "loading": _vm.request.loading,
            "disabled": _vm.disabled
          }
        }, 'v-btn', attrs, false), on), [_vm._v(_vm._s(_vm.cta) + "\n    ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline grey lighten-4 py-1"
  }, [_vm._v("\n          Please confirm\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "overline pa-0"
  }, [_vm._v("\n            These codes will automatically be added to new appointments\n          ")]), _vm._v("\n          For "), _c('strong', [_vm._v(_vm._s(_vm.clientName))]), _vm._v(" with "), _c('strong', [_vm._v(_vm._s(_vm.practitionerName))]), _c('br'), _vm._v("\n          for new appointments after\n          "), (_vm.startDate) ? _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.startDate)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stopDate) ? [_vm._v(" until "), (_vm.stopDate) ? _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.stopDate)
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-1"
  }, [_vm._v("Apply to all new appointments: ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    class: {
      'blue lighten-4': (_vm.dateFocus === 'start')
    },
    attrs: {
      "box": "",
      "hide-details": "",
      "readonly": "",
      "label": "Created after",
      "value": _vm.startDate
    },
    on: {
      "click": function($event) {
        _vm.dateFocus = "start"
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    class: {
      'blue lighten-4': (_vm.dateFocus === 'stop')
    },
    attrs: {
      "box": "",
      "readonly": "",
      "hide-details": "",
      "clearable": "",
      "placeholder": "Until forever",
      "label": "Until (leave blank for forever)",
      "value": _vm.stopDate
    },
    on: {
      "click": function($event) {
        _vm.dateFocus = "stop"
      },
      "click:clear": function($event) {
        _vm.stopDate = null
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.dateFocus === "start") ? _c('v-subheader', {
    staticClass: "overline pl-1"
  }, [_vm._v("Choose a start date on the calendar")]) : _vm._e(), _vm._v(" "), (_vm.dateFocus === "stop") ? _c('v-subheader', {
    staticClass: "overline pl-1"
  }, [_vm._v("Choose a stop date on the calendar")]) : _vm._e(), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "no-title": "",
      "flat": "",
      "full-width": "",
      "min": _vm.calMin,
      "max": _vm.calMax
    },
    on: {
      "change": _vm.dateSelected
    },
    model: {
      value: (_vm.startStopDate),
      callback: function($$v) {
        _vm.startStopDate = $$v
      },
      expression: "startStopDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout')], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.setCodes
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "success"
    }
  }, [_vm._v("check_circle")]), _vm._v("\n          Auto-codes have been added to this client\n        ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.request.result) ? _c('v-card-text', [_c('div', [_vm._v(_vm._s(_vm.request.result.description))]), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("Codes")]), _vm._v(" "), _c('div', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.request.result.codes_formatted)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false;
        _vm.step = 0
      }
    }
  }, [_vm._v("Done")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "caption pl-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n          You can manage auto-codes for a client from the client detail page on the \"codes\" tab\n        ")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.spaces && _vm.spaces.length > 0) ? _c('div', [_c('v-alert', {
    staticClass: "py-0 px-2 ma-0",
    attrs: {
      "dismissible": "",
      "type": "warning",
      "value": true
    }
  }, [_vm._v("\n      These appointments span multiple spaces.\n      Please pick to which space you would like to assign this invoice to\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "px-2"
  }, [_c('v-subheader', {
    staticClass: "py-0 px-2 overline ma-0"
  }, [_vm._v("Choose a space")]), _vm._v(" "), _vm._l((_vm.spaces), function(space, index) {
    return _c('v-chip', {
      key: space.id,
      staticClass: "mt-0",
      attrs: {
        "outline": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedSpaceSettings = index
        }
      }
    }, [(index === _vm.selectedSpaceSettings) ? _c('v-icon', [_vm._v("check")]) : _vm._e(), _vm._v("\n          " + _vm._s(space.space_name || space.practice_name) + "\n      ")], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-system-bar', {
    staticClass: "overline"
  }, [_vm._v("Business settings")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "one-line": ""
    }
  }, [_c('v-list-tile', [(_vm.resizedLogoPicture) ? _c('v-list-tile-avatar', {
    attrs: {
      "tile": "",
      "small": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.resizedLogoPicture
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.settings && _vm.settings.practice_name) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.settings.practice_name)
    }
  }) : _c('span', [_vm._v("Business details")])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "small": "",
      "icon": "",
      "label": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.configureSettings.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.localExpanded === false) ? _c('v-btn', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "small": "",
      "icon": "",
      "label": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.localExpanded = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("expand_more")])], 1) : _c('v-btn', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "small": "",
      "icon": "",
      "label": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.localExpanded = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("expand_less")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.localExpanded) ? [_c('v-card-text', {
    on: {
      "click": _vm.configureSettings
    }
  }, [_c('strong', {
    staticClass: "overline"
  }, [_vm._v("Practice number:")]), _vm._v(" " + _vm._s(_vm.settings.practice_number) + "\n        "), _c('v-divider'), _vm._v(" "), _c('strong', {
    staticClass: "overline"
  }, [_vm._v("Billing address")]), _vm._v(":\n        "), (_vm.settings.billing_address) ? _c('pre', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.settings.billing_address)
    }
  }) : _c('div', [_vm._v("Add a billing address")]), _vm._v(" "), _c('strong', {
    staticClass: "overline"
  }, [_vm._v("Banking details")]), _vm._v(":\n        "), (_vm.settings.banking_details) ? _c('pre', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.settings.banking_details)
    }
  }) : _c('div', [_vm._v("Add banking details")])], 1), _vm._v(" "), (_vm.settings && _vm.requiredProgress < 100) ? _c('v-footer', {
    staticClass: "mt-0 pl-2 py-0 caption",
    attrs: {
      "small": "",
      "block": "",
      "tile": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "value": _vm.progressPercent,
      "color": _vm.progressColor,
      "rotate": -90,
      "width": "2",
      "size": 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.configureSettings.apply(null, arguments)
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.progressColor
    }
  }, [_vm._v(_vm._s(_vm.progressIcon))])], 1)], 1), _vm._v("\n        Configuration suggestions\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.configureSettings.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1) : _vm._e()] : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/settings/home",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Settings")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/settings/locations",
      "flat": ""
    }
  }, [_vm._v("Spaces")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/settings/profile",
      "flat": ""
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "href": "https://settings.appointmentguru.co",
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("\n      Advanced settings\n      "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('v-card-text', [_c('v-alert', {
    staticClass: "pa-1",
    attrs: {
      "dismissible": "",
      "value": (_vm.currentPage === "Spaces"),
      "type": "info"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "target": "_blank",
      "dark": "",
      "href": "https://book.appt.guru/?p=1",
      "small": "",
      "outline": ""
    }
  }, [_vm._v("Book a consultation\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "target": "_blank",
      "dark": "",
      "href": "https://www.loom.com/share/c264dda3a91a4f37a2a0f57132ca3bad",
      "small": "",
      "outline": ""
    }
  }, [_vm._v("Watch a video\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("ondemand_video")])], 1), _vm._v("\n        Need help setting up your account?"), _c('br'), _vm._v("\n        Book a one on one session with us to help you get the most out of AppointmentGuru\n      ")], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "default": "Profile",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center",
    staticStyle: {
      "max-width": "380px",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_vm._l((_vm.actions), function(action) {
    return _c('v-btn', _vm._g(_vm._b({
      key: action.id,
      staticClass: "mb-4",
      staticStyle: {
        "border-radius": "25px"
      },
      attrs: {
        "block": "",
        "rounded": "",
        "x-large": "",
        "outline": "",
        "color": "primary"
      },
      on: {
        "click": action.click
      }
    }, 'v-btn', action.attrs, false), action.events), [_vm._v("\n      " + _vm._s(action.text) + "\n      "), (action.icon) ? _c('v-icon', {
      staticClass: "ml-2",
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(action.icon))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.withDone) ? _c('v-btn', {
    staticClass: "my-4",
    attrs: {
      "block": "",
      "rounded": "",
      "x-large": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      Done\n    ")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "multi-line": true,
      "timeout": _vm.snackbarTimeout,
      "success": _vm.snackbarStatus === 'success',
      "info": _vm.snackbarStatus === 'info',
      "warning": _vm.snackbarStatus === 'warning',
      "error": _vm.snackbarStatus === 'error',
      "primary": _vm.snackbarStatus === 'primary',
      "secondary": _vm.snackbarStatus === 'secondary'
    },
    model: {
      value: (_vm.snackbarVisible),
      callback: function($$v) {
        _vm.snackbarVisible = $$v
      },
      expression: "snackbarVisible"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n      "), _c('v-btn', {
    staticClass: "pink--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbarVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.get,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline py-0 grey lighten-4"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    staticClass: "ma-0 lighten-2",
    attrs: {
      "type": "info",
      "value": true,
      "dismissible": "",
      "dense": ""
    }
  }, [_vm._v("\n    Below is a list of submissions which could not be automatically assigned to a client.\n    Choose \"assign\" next to the submission/s you would like to set for this client\n  ")]), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.assign,
      "message200": false
    },
    on: {
      "ok": _vm.assignSuccess
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Unlinked submissions\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.get.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (!_vm.requests.get.loading && _vm.submissions && _vm.submissions.length === 0) ? _c('div', {
    staticClass: "pa-3"
  }, [_vm._v("\n      Couldn't find any unlinked sumissions\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.submissions), function(sub) {
    return _c('submission-list-item', {
      key: sub.id,
      attrs: {
        "item": sub,
        "with-actions": false
      }
    }, [_c('v-list-tile-action', {
      attrs: {
        "slot": "list-tile-action"
      },
      slot: "list-tile-action"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outline": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.assign(sub)
        }
      }
    }, [_vm._v("\n          Assign\n        ")])], 1)], 1)
  })], 2), _vm._v(" "), _vm._t("card-actions")], 2)
},staticRenderFns: []}

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-flex', [_vm._v("\n        " + _vm._s(_vm.$t('logs.historical')) + ". "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('logs.historicalsubtitle')))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Search",
      "append-icon": "search",
      "clearable": ""
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), (_vm.treatmentLogsRequest.loading) ? _c('v-progress-circular', {
    attrs: {
      "color": "amber",
      "size": "20",
      "width": "2",
      "indeterminate": ""
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-timeline', {
    staticClass: "mb-4 ml-3",
    attrs: {
      "dense": "",
      "clipped": ""
    }
  }, [(_vm.searchString && _vm.searchString.length > 0) ? _c('v-timeline-item', {
    staticClass: "subheading",
    attrs: {
      "hide-dot": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('logs.searchinfo', {
    string: _vm.searchString
  })) + "\n      ")]) : _c('v-timeline-item', {
    staticClass: "subheading",
    attrs: {
      "hide-dot": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tc('logs.summary', _vm.historicalTreatmentLogs.length, {
    n: _vm.historicalTreatmentLogs.length,
    from: _vm.oldestAppointmentDate
  }))), _c('br'), _vm._v(" "), (_vm.historicalTreatmentLogs.length > 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('logs.lastseen', {
    date: _vm.mostRecentAppointmentDate
  })) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.filteredHistoricalTreatmentLogs), function(log, index) {
    return [(_vm.isNewDate(log, index, _vm.filteredHistoricalTreatmentLogs)) ? _c('v-timeline-item', {
      key: ("dt-" + index),
      staticClass: "mt-3"
    }, [_c('template', {
      slot: "icon"
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "small": ""
      }
    }, [_vm._v("event")])], 1), _vm._v(" "), _c('span', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(_vm.luxonDateformat(log.last_used, 'ccc d MMM yyyy')))])], 2) : _vm._e(), _vm._v(" "), _c('v-timeline-item', {
      key: index,
      staticClass: "mb-0",
      attrs: {
        "small": "",
        "color": "pink",
        "icon-color": "grey lighten-2"
      }
    }, [_c('v-layout', {
      attrs: {
        "justify-space-between": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(log.code))]), _vm._v(" "), _vm._v("\n                " + _vm._s(_vm.$tc('logs.count', log.count, {
      n: log.count
    })) + "\n              ")]), _vm._v(" "), (log.count > 1) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.luxonDateformat(log.first_used, 'ccc d MMM yyyy')) + " -\n                " + _vm._s(_vm.luxonDateformat(log.last_used, 'ccc d MMM yyyy')) + "\n              ")]) : _c('div', [_vm._v("\n                " + _vm._s(_vm.luxonDateformat(log.first_used, 'ccc d MMM yyyy')) + "\n              ")])])], 1)], 1)]
  }), _vm._v(" "), (!_vm.treatmentLogsRequest.loading) ? [(_vm.historicalTreatmentLogs && _vm.historicalTreatmentLogs.length === 0) ? _c('v-timeline-item', [_vm._v("\n          " + _vm._s(_vm.$t('zeroresults')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.historicalTreatmentLogs.length > 0 && _vm.filteredHistoricalTreatmentLogs && _vm.filteredHistoricalTreatmentLogs.length === 0) ? _c('v-timeline-item', [_vm._v("\n          " + _vm._s(_vm.$t('zerosearchresults')) + "\n        ")]) : _vm._e()] : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.program.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.program.start_date)) + " - " + _vm._s(_vm.dateformat(_vm.program.end_date)) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-tab', [_vm._v("Exercises")]), _vm._v(" "), _c('v-tab', [_vm._v("Progress")]), _vm._v(" "), _c('v-tab', [_vm._v("Messages")]), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "label": "Track adherence",
      "readonly": ""
    },
    model: {
      value: (_vm.program.track_adherence),
      callback: function($$v) {
        _vm.$set(_vm.program, "track_adherence", $$v)
      },
      expression: "program.track_adherence"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "label": "Track pain levels",
      "readonly": ""
    },
    model: {
      value: (_vm.program.track_pain_levels),
      callback: function($$v) {
        _vm.$set(_vm.program, "track_pain_levels", $$v)
      },
      expression: "program.track_pain_levels"
    }
  }), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Access code sent:")]), _vm._v(" " + _vm._s(_vm.dateformat(_vm.program.access_code_sent_date)) + " via " + _vm._s(_vm.program.access_code_sent_via)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Last accessed:")]), _vm._v(" " + _vm._s(_vm.dateformat(_vm.program.last_access_date)) + "\n          ")])], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Access details")]), _vm._v(" "), _c('v-card-text', [(_vm.programUrl) ? _c('copy-text-field', {
    attrs: {
      "label": "Share this url with you client so that they can access Physitrack",
      "text-to-copy": _vm.programUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Access code:")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(_vm.program.access_code))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date of birth:")]), _vm._v(" " + _vm._s(_vm.dateOfBirth) + "\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [(_vm.requests.exercises.loading) ? [(!_vm.exercises || _vm.exercises.length === 0) ? _c('tombstone') : _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 1
    }
  })] : _vm._e(), _vm._v(" "), _c('v-list', [_vm._l((_vm.exercises), function(exercise, index) {
    return [_c('exercise-list-item', {
      key: ("ex-" + (exercise.id) + "-" + index),
      model: {
        value: (_vm.exercises[index]),
        callback: function($$v) {
          _vm.$set(_vm.exercises, index, $$v)
        },
        expression: "exercises[index]"
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-exercises-" + (exercise.id) + "-" + index)
    })]
  })], 2)], 2), _vm._v(" "), _c('v-tab-item', [(_vm.requests.adherence.loading) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.progress || !_vm.progress.days) ? _c('tombstone') : _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 1
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "grey lighten-4",
    attrs: {
      "xs4": ""
    }
  }, [(_vm.progress && _vm.progress.days) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.progress.days), function(day) {
    return [_c('v-list-tile', {
      key: day.date,
      on: {
        "click": function($event) {
          _vm.selectedDate = day.date
        }
      }
    }, [_c('v-list-tile-avatar', [_c('adherence-progress', {
      model: {
        value: (day.avg_day_adherence),
        callback: function($$v) {
          _vm.$set(day, "avg_day_adherence", $$v)
        },
        expression: "day.avg_day_adherence"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.dateformat(day.date)) + "\n                    ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-progress-linear', {
      key: ("div-" + (day.date)),
      staticClass: "ma-0",
      attrs: {
        "value": day.avg_day_adherence,
        "height": "1"
      }
    })]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [(_vm.progressDetail) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.dateformat(_vm.selectedDate)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('adherence-progress', {
    model: {
      value: (_vm.progressDetail.avg_day_adherence),
      callback: function($$v) {
        _vm.$set(_vm.progressDetail, "avg_day_adherence", $$v)
      },
      expression: "progressDetail.avg_day_adherence"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.progressDetail && _vm.progressDetail.exercises) ? [_c('v-list', {
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [_vm._l((_vm.progressDetail.exercises), function(exercise, index) {
    return [_c('exercise-list-item', {
      key: ("prog-" + (exercise.id) + "-" + index),
      model: {
        value: (_vm.progressDetail.exercises[index]),
        callback: function($$v) {
          _vm.$set(_vm.progressDetail.exercises, index, $$v)
        },
        expression: "progressDetail.exercises[index]"
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (exercise.id) + "-" + index)
    })]
  }), _vm._v(" "), (_vm.progressDetail.exercises.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                    No exercises completed\n                  ")])], 1)], 1) : _vm._e()], 2)] : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-tab-item', [(_vm.requests.messages.loading) ? [(!_vm.messages || _vm.messages.length === 0) ? _c('tombstone') : _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 1
    }
  })] : _vm._e(), _vm._v(" "), _c('messages', {
    attrs: {
      "physitrack-client-id": _vm.physitrackClientId,
      "messages": _vm.messages
    },
    on: {
      "new": _vm.getMessages
    }
  })], 2)], 1)], 1), _vm._v(" "), (_vm.requests.send.status === 409) ? _c('v-alert', {
    attrs: {
      "disabled": "",
      "outlined": "",
      "outline": "",
      "small": "",
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.requests.send.errors.errors) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.requests.send.status !== 200) ? _c('v-btn', {
    attrs: {
      "small": "",
      "disabled": !_vm.program.access_code,
      "loading": _vm.requests.send.loading
    },
    on: {
      "click": function($event) {
        return _vm.send(_vm.program.access_code)
      }
    }
  }, [_vm._v("\n      Send "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("send")])], 1) : _vm._e(), _vm._v(" "), (_vm.requests.send.status === 200) ? _c('v-btn', {
    attrs: {
      "disabled": "",
      "outlined": "",
      "outline": "",
      "small": "",
      "color": "success"
    }
  }, [_vm._v("Sent")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "loading": _vm.downloading
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.program.access_code)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("cloud_download")]), _vm._v(" Download PDF\n    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "href": _vm.program.sso_url,
      "target": "_blank"
    }
  }, [_vm._v("\n      Open Program "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading py-0 grey lighten-4"
  }, [_vm._v("\n    Assign a program\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    staticClass: "ma-2",
    attrs: {
      "outline": "",
      "outlined": "",
      "loading": _vm.requests.templates.loading,
      "hint": "Press enter to search or click the search button",
      "label": "Search templates",
      "append-icon": "search"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTemplates.apply(null, arguments)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        _vm.search = ""
      },
      "keyup": _vm.debounceTemplates,
      "click:append": _vm.getTemplates
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.templates), function(template) {
    return [_c('v-list-tile', {
      key: template.id,
      class: _vm.selectedClass(template, _vm.selectedTemplate),
      on: {
        "click": function($event) {
          _vm.selectedTemplate = template
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('V-list-tile-sub-title', [_vm._v("\n                By " + _vm._s(template.author || 'Physitrack') + "\n              ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div=" + (template.id))
    })]
  })], 2)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm7": ""
    }
  }, [(_vm.hasActiveProgram) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "warning",
      "dismissible": "",
      "text": "",
      "dense": "",
      "outline": "",
      "tile": ""
    }
  }, [_c('strong', [_vm._v("Warning")]), _vm._v("\n        This client has an active program. Assigning a new program will terminate the current program\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTemplate && _vm.selectedTemplate.id) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedTemplate.name))]), _vm._v(" "), _c('V-list-tile-sub-title', [_vm._v("\n                " + _vm._s(_vm.selectedTemplate.description) + "\n              ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.assign.loading,
      "color": "primary",
      "small": ""
    },
    on: {
      "click": _vm.assign
    }
  }, [_vm._v("Assign")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "290"
    },
    model: {
      value: (_vm.showdatepicker),
      callback: function($$v) {
        _vm.showdatepicker = $$v
      },
      expression: "showdatepicker"
    }
  }, [_c('v-card', [_c('v-date-picker', {
    attrs: {
      "min": _vm.today,
      "full-width": ""
    },
    model: {
      value: (_vm.program.start_date),
      callback: function($$v) {
        _vm.$set(_vm.program, "start_date", $$v)
      },
      expression: "program.start_date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "ma-2",
    attrs: {
      "readonly": "",
      "label": "Start date"
    },
    on: {
      "click": function($event) {
        _vm.showdatepicker = true
      }
    },
    model: {
      value: (_vm.program.start_date),
      callback: function($$v) {
        _vm.$set(_vm.program, "start_date", $$v)
      },
      expression: "program.start_date"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "ma-2",
    attrs: {
      "label": "Duration",
      "type": "number",
      "suffix": "weeks"
    },
    model: {
      value: (_vm.program.num_weeks),
      callback: function($$v) {
        _vm.$set(_vm.program, "num_weeks", $$v)
      },
      expression: "program.num_weeks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "label": "Track adherence"
    },
    model: {
      value: (_vm.program.track_adherence),
      callback: function($$v) {
        _vm.$set(_vm.program, "track_adherence", $$v)
      },
      expression: "program.track_adherence"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "label": "Track pain levels"
    },
    model: {
      value: (_vm.program.track_pain_levels),
      callback: function($$v) {
        _vm.$set(_vm.program, "track_pain_levels", $$v)
      },
      expression: "program.track_pain_levels"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "label": "Don't send program to user"
    },
    model: {
      value: (_vm.program.skip_access_code),
      callback: function($$v) {
        _vm.$set(_vm.program, "skip_access_code", $$v)
      },
      expression: "program.skip_access_code"
    }
  })], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "sub-header": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n            Exercises\n          ")]), _vm._v(" "), _vm._l((_vm.selectedTemplate.exercises), function(exercise) {
    return _c('v-list-tile', {
      key: exercise.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(exercise.name)
      }
    })], 1)], 1)
  })], 2)], 1) : _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    staticClass: "pr-3"
  }, [_vm._v("arrow_back")]), _vm._v(" Choose an exercise template\n        ")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.solo) ? _c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Please choose a profession")]) : _vm._e(), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "autocomplete": "",
      "label": "Select a profession",
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      "items": _vm.professions,
      "solo": _vm.solo,
      "clearable": "",
      "loading": _vm.request.loading
    },
    on: {
      "click:clear": function($event) {
        return _vm.$emit("clear")
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._t("default", function() {
    return [_c('v-btn', {
      class: _vm.classes,
      attrs: {
        "icon": "",
        "small": _vm.small,
        "attrs": _vm.attrs,
        "disabled": !_vm.number,
        "href": _vm.whatsappIt(_vm.number, _vm.message),
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.noop.apply(null, arguments)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": _vm.small,
        "color": "success"
      }
    }, [_vm._v("whatsapp")])], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "open-on-hover": "",
      "close-on-content-click": "",
      "nudge-width": 200,
      "offset-x": ""
    },
    model: {
      value: (_vm.showInfo),
      callback: function($$v) {
        _vm.showInfo = $$v
      },
      expression: "showInfo"
    }
  }, [_c('v-icon', _vm._b({
    attrs: {
      "slot": "activator",
      "small": _vm.small,
      "color": _vm.color
    },
    slot: "activator"
  }, 'v-icon', _vm.iconAttrs, false), [_vm._v(_vm._s(_vm.icon))]), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "width": "250px"
    }
  }, [_c('v-card-text', [_vm._t("default")], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showInfo = false
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('note-list', {
    attrs: {
      "with-add": false,
      "client": _vm.clientObject,
      "appointment": _vm.appointment
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, "Notes", {
          appointment: _vm.appointment
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add a note\n      ")], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: _vm.col1layoutclasses
  }, [_c('v-card', {
    attrs: {
      "dark": _vm.dark,
      "flat": "",
      "tile": "",
      "height": "100%"
    }
  }, [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('appointment-filters', {
    attrs: {
      "relationship": _vm.relationship,
      "page-size": _vm.pageSize,
      "initial-relationship": _vm.relationship,
      "facets": _vm.facets,
      "mini": _vm.mini,
      "clear-date-range": _vm.clearDateRange,
      "withClose": _vm.compact,
      "attrs": {
        dark: _vm.dark,
        flat: true
      }
    },
    on: {
      "update:pageSize": function($event) {
        _vm.pageSize = $event
      },
      "update:page-size": function($event) {
        _vm.pageSize = $event
      },
      "close": function($event) {
        _vm.window++
      }
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  }, [_c('template', {
    slot: "actions"
  }, [(_vm.compact) ? _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.window++
      }
    }
  }, [_vm._v("\n                  Show appointments\n                ")])], 1) : _vm._e()], 1)], 2)], 1), _vm._v(" "), (_vm.compact) ? _c('v-window-item', [_c('appointment-list', {
    attrs: {
      "attrs": {
        height: '100%',
        flat: true
      },
      "dense": _vm.dense,
      "page-size": _vm.pageSize,
      "group-by-name": true,
      "with-subheaders": true,
      "with-actions": true,
      "selected": _vm.selected,
      "request": _vm.request,
      "params": _vm.filters,
      "list-attrs": {
        withActions: true,
        withAction: false
      },
      "facets": "practitioner,space,address,status"
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:request": function($event) {
        _vm.request = $event
      },
      "count": _vm.setCount
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "toolbar-before",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    },
    slot: "toolbar-before"
  }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (!_vm.compact) ? _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-left": "1px solid #ccc"
    },
    attrs: {
      "xs12": "",
      "sm7": "",
      "md7": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "flat": "",
      "height": "100%"
    }
  }, [(_vm.filters) ? _c('appointment-list', {
    attrs: {
      "dense": _vm.dense,
      "initial-page-size": _vm.pageSize,
      "group-by-name": true,
      "with-subheaders": true,
      "with-actions": true,
      "selected": _vm.selected,
      "request": _vm.request,
      "params": _vm.filters,
      "ordering": _vm.ordering,
      "list-attrs": {
        withActions: true,
        withAction: false,
        withPricing: true
      },
      "facets": "practitioner,space,address,status"
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:request": function($event) {
        _vm.request = $event
      }
    }
  }, [(_vm.withFullscreen) ? _c('v-btn', {
    attrs: {
      "slot": "toolbar-end",
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.toggleFullScreen
    },
    slot: "toolbar-end"
  }, [(_vm.fullscreen) ? _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close_fullscreen")]) : _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fullscreen")])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-list', {
    staticClass: "mb-4 pb-0"
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('subheaders.current')))]), _vm._v(" "), _vm._l((_vm.versions), function(version, index) {
    return [(index === 1) ? _c('v-subheader', {
      key: ("sh-" + (version.VersionId))
    }, [_vm._v("\n        " + _vm._s(_vm.$t('subheaders.older')) + "\n      ")]) : _vm._e(), _vm._v(" "), (version.StorageClass === "GLACIER" && index > 0 && _vm.versions[index - 1].StorageClass !== "GLACIER") ? _c('v-subheader', {
      key: ("sh-" + (version.VersionId))
    }, [_vm._v("\n        " + _vm._s(_vm.$t('subheaders.archived')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
      key: ("tile-" + (version.VersionId)),
      attrs: {
        "disabled": version.StorageClass === "GLACIER"
      }
    }, [_c('v-list-tile-action', [(version.StorageClass !== "GLACIER") ? _c('v-btn', {
      staticClass: "ml-1",
      attrs: {
        "href": version.url,
        "target": "_blank",
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("cloud_download")])], 1) : _c('v-icon', {
      staticClass: "ml-2",
      attrs: {
        "small": "",
        "disabled": ""
      }
    }, [_vm._v("fiber_manual_record")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.dateformat(version.LastModified)) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.dateformat(version.LastModified, 'HH:mm a')) + "\n          ")])], 1), _vm._v(" "), (version.IsLatest) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "success"
      }
    }, [_vm._v("check")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            Latest\n          ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (version.VersionId))
    })]
  }), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('v-footer', [_c('span', {
    staticClass: "px-3"
  }, [_vm._v("\n      Please note versions can take a few minutes to update\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-chip', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v(_vm._s(_vm.object))])
},staticRenderFns: []}

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withToolbar) ? _c('div', [_c('v-btn', {
    staticClass: "indigo--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeComponent = "Reschedule"
      }
    }
  }, [_c('v-icon', [_vm._v("today")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "indigo--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeComponent = "InvoiceDetails"
      }
    }
  }, [_c('v-icon', [_vm._v("account_balance_wallet")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "indigo--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeComponent = "Notes"
      }
    }
  }, [_c('v-icon', [_vm._v("note")])], 1)], 1) : _vm._e(), _vm._v(" "), _c(_vm.activeComponent, {
    tag: "component",
    attrs: {
      "stand-alone": _vm.standAlone,
      "with-time-selector": _vm.withTimeSelector,
      "with-back": false,
      "appointment": _vm.appointment,
      "value": _vm.appointment,
      "touch": _vm.touch
    },
    on: {
      "note:save": function($event) {
        return _vm.$emit("close")
      },
      "appointmentcancelled": function($event) {
        return _vm.$emit("close")
      },
      "appointmentrescheduled": function($event) {
        return _vm.$emit("close")
      },
      "close": function($event) {
        return _vm.$emit("close")
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ml-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-0",
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading pa-0 ma-0"
  }, [(_vm.withBack) ? _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v(" Back\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (_vm.template.id) ? _c('span', [_vm._v("\n          Editing template: " + _vm._s(_vm.template.name) + "\n        ")]) : _c('span', [_vm._v("\n          Create a new template\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.isDirty
    },
    on: {
      "click": _vm.sendExample
    }
  }, [_vm._v("\n          Send test\n        ")]), _vm._v(" "), (_vm.isEditMode) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "loading": _vm.request.loading,
      "disabled": _vm.errors.length > 0,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]) : _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "primary",
      "disabled": _vm.errors.length > 0,
      "dark": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Create template")])], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2 my-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pl-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "hint": "A name that will help understand the purpose of this communication"
    },
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-width": 200,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("settings")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showSettings),
      callback: function($$v) {
        _vm.showSettings = $$v
      },
      expression: "showSettings"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("Advanced settings")]), _vm._v(" "), _c('v-card-text', [(_vm.isAdmin) ? [_c('v-text-field', {
    attrs: {
      "label": "practitioner id",
      "persistent-hint": "",
      "hint": "Use 0 to create a default template"
    },
    model: {
      value: (_vm.template.owner),
      callback: function($$v) {
        _vm.$set(_vm.template, "owner", $$v)
      },
      expression: "template.owner"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "This is a shared template"
    },
    model: {
      value: (_vm.template.shared),
      callback: function($$v) {
        _vm.$set(_vm.template, "shared", $$v)
      },
      expression: "template.shared"
    }
  }), _vm._v(" "), _c('hr')] : _vm._e(), _vm._v(" "), [_c('v-subheader', {
    staticClass: "pa-0 mb-0 overline mt-3"
  }, [_vm._v("Share with your Spaces")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Add to UI"
    },
    model: {
      value: (_vm.template.allow_ad_hoc_sending),
      callback: function($$v) {
        _vm.$set(_vm.template, "allow_ad_hoc_sending", $$v)
      },
      expression: "template.allow_ad_hoc_sending"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.transports,
      "label": "Default sending option"
    },
    model: {
      value: (_vm.template.preferred_transport),
      callback: function($$v) {
        _vm.$set(_vm.template, "preferred_transport", $$v)
      },
      expression: "template.preferred_transport"
    }
  })]], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "2",
      "label": "Description",
      "hint": "A brief description of the purpose of this template"
    },
    model: {
      value: (_vm.template.description),
      callback: function($$v) {
        _vm.$set(_vm.template, "description", $$v)
      },
      expression: "template.description"
    }
  }), _vm._v(" "), _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        return _vm.setLastFocussed("short-message-textarea")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tabs.short')))]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        return _vm.setLastFocussed("email-content")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tabs.long')) + "\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('help-popover', {
    staticClass: "mt-3 mr-1"
  }, [_c('v-subheader', {
    staticClass: "overline ml-0 pl-0"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('info.merge_tags_title')) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('info.merge_tags')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('info.merge_tags_example')))])], 1), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "small": "",
      "box": "",
      "label": "Merge tags",
      "items": _vm.merge_tags,
      "return-object": "",
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": _vm.insertVariable
    },
    model: {
      value: (_vm.selectedMergeTag),
      callback: function($$v) {
        _vm.selectedMergeTag = $$v
      },
      expression: "selectedMergeTag"
    }
  }), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-tab-item', [_c('v-textarea', {
    attrs: {
      "box": "",
      "counter": "",
      "auto-grow": "",
      "persistent-hint": "",
      "no-resize": false,
      "id": "short-message-textarea",
      "rows": 25,
      "label": _vm.$t("forms.shortmessage.label"),
      "hint": _vm.$t("forms.shortmessage.hint")
    },
    on: {
      "focus": function($event) {
        return _vm.setLastFocussed("short-message-textarea")
      }
    },
    model: {
      value: (_vm.template.short_message),
      callback: function($$v) {
        _vm.$set(_vm.template, "short_message", $$v)
      },
      expression: "template.short_message"
    }
  })], 1), _vm._v(" "), _c('v-tab-item', [_c('v-text-field', {
    attrs: {
      "box": "",
      "id": "email-subject",
      "label": _vm.$t("forms.email.subject")
    },
    on: {
      "focus": function($event) {
        return _vm.setLastFocussed("email-subject")
      }
    },
    model: {
      value: (_vm.template.subject),
      callback: function($$v) {
        _vm.$set(_vm.template, "subject", $$v)
      },
      expression: "template.subject"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "box": "",
      "no-resize": false,
      "id": "email-content",
      "rows": 25,
      "label": _vm.$t("forms.email.content")
    },
    on: {
      "focus": function($event) {
        return _vm.setLastFocussed("email-content")
      }
    },
    model: {
      value: (_vm.template.message),
      callback: function($$v) {
        _vm.$set(_vm.template, "message", $$v)
      },
      expression: "template.message"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2 my-4",
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading pb-1"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('titles.preview.main')) + "\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.template.short_message || _vm.template.message || _vm.template.subject) ? _c('v-card-text', [(_vm.template.short_message) ? _c('div', [_c('h3', {
    staticClass: "overline mt-3"
  }, [_vm._v(_vm._s(_vm.$t('titles.preview.shortmessage')))]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "value": _vm.parsedShortMessage,
      "auto-grow": "",
      "box": "",
      "readonly": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.template.subject || _vm.template.message) ? _c('div', [_c('h3', {
    staticClass: "overline mt-3"
  }, [_vm._v(_vm._s(_vm.$t('titles.preview.email')))]), _vm._v(" "), _c('strong', [_vm._v("Subject:")]), _vm._v(" " + _vm._s(_vm.parsedSubject) + "\n          "), _c('div', [_c('strong', {
    staticClass: "overline"
  }, [_vm._v("Message:")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.parsedMessage)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? [_c('h3', {
    staticClass: "overline mt-4"
  }, [_vm._v("Raw data")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.payload))])] : _vm._e()], 2) : _c('v-card-text', [_c('v-icon', [_vm._v("info")]), _vm._v("\n        Start typing your message and the preview will show up here.\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.isEditMode) ? _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "disabled": _vm.errors.length > 0,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.request.loading,
      "disabled": _vm.errors.length > 0
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Create template")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-textarea', _vm._b({
    attrs: {
      "label": _vm.label,
      "append-icon": "fullscreen"
    },
    on: {
      "click:append": function($event) {
        _vm.showdialog = true
      }
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }, 'v-textarea', _vm.initialAttrs, false)), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    model: {
      value: (_vm.showdialog),
      callback: function($$v) {
        _vm.showdialog = $$v
      },
      expression: "showdialog"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showdialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-textarea', _vm._b({
    attrs: {
      "label": _vm.label
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }, 'v-textarea', _vm.attrs, false))], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showdialog = false
      }
    }
  }, [_vm._v("\n          Done\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('request-status', {
    attrs: {
      "request": _vm.req
    }
  }), _vm._v(" "), _c('wiz-layout', {
    attrs: {
      "steps": _vm.steps,
      "initial-step": _vm.step,
      "loading": _vm.req.loading || _vm.settingsReq.loading
    },
    on: {
      "update:initialStep": function($event) {
        _vm.step = $event
      },
      "update:initial-step": function($event) {
        _vm.step = $event
      },
      "close": function($event) {
        return _vm.$emit("close")
      },
      "cancel": function($event) {
        return _vm.$emit("cancel")
      }
    },
    model: {
      value: (_vm.obj),
      callback: function($$v) {
        _vm.obj = $$v
      },
      expression: "obj"
    }
  }, [_c('template', {
    slot: "success"
  }, [_vm._v("\n      This is the success\n    ")])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', [_vm._v("Generate Invoice")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [(_vm.title) ? _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.programs), function(program) {
    return [_c('v-list-tile', {
      key: program.id,
      on: {
        "click": function($event) {
          return _vm.$emit("selected", program)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(program.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(program.start_date)) + " - " + _vm._s(_vm.dateformat(program.end_date)) + "\n        ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div=" + (program.id))
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('practitioner-faces', {
    attrs: {
      "practitioner-ids": [_vm.ownerId],
      "size": 18
    }
  }, [_c('small', {
    staticClass: "caption"
  }, [_vm._v("created by")])]), _vm._v(" "), (_vm.spaceIds && _vm.spaceIds.length > 0 && _vm.context === "SPACE") ? _c('space-faces', {
    attrs: {
      "size": _vm.size,
      "space-ids": _vm.spaceIds
    }
  }, [_c('span', {
    staticClass: "caption",
    attrs: {
      "slot": "prepend"
    },
    domProps: {
      "textContent": _vm._s(_vm.ownerTextPrefix)
    },
    slot: "prepend"
  })]) : _vm._e(), _vm._v(" "), (_vm.vertical) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.spaceIds && _vm.spaceIds.length > 0 && _vm.context === "PRACTITIONER") ? _c('space-faces', {
    attrs: {
      "size": _vm.size,
      "space-ids": _vm.spaceIds
    }
  }, [_c('span', {
    staticClass: "caption",
    attrs: {
      "slot": "prepend"
    },
    domProps: {
      "textContent": _vm._s(_vm.sharingTextPrefix)
    },
    slot: "prepend"
  })]) : _vm._e(), _vm._v(" "), (!_vm.spaceIds || _vm.spaceIds.length === 0) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "label": "",
      "color": "amber"
    }
  }, [_vm._v("Private")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pb-0",
    attrs: {
      "dark": "",
      "flat": "",
      "height": "100%"
    }
  }, [_c('v-list', {
    staticClass: "black pa-0"
  }, [_c('v-list-tile', {
    on: {
      "click": _vm.launchDateRangePicker
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(_vm.params.after) + " - " + _vm._s(_vm.params.before) + "\n        ")]), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.invoiceableClients) ? _c('span', [_vm._v(_vm._s(_vm.invoiceableClients.count))]) : _vm._e(), _vm._v("\n          Clients with appointments\n        ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("event")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-0 pl-0 black lighten-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('status-picker', {
    model: {
      value: (_vm.selectedStatuses),
      callback: function($$v) {
        _vm.selectedStatuses = $$v
      },
      expression: "selectedStatuses"
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.request
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "mb-0 pb-0"
  }, [_vm._l((_vm.invoiceableClients), function(client, index) {
    return [_c('v-list-tile', {
      key: index,
      class: {
        'grey darken-4': (client.id === _vm.selectedClientId)
      },
      on: {
        "click": function($event) {
          return _vm.clientClicked(client)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "mb-1"
    }, [_vm._v("\n                " + _vm._s(client.first_name) + " " + _vm._s(client.last_name) + "\n              ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                " + _vm._s(client.count) + " " + _vm._s(_vm.$tc('list.appointments', client.count, {
      count: client.count
    })) + "\n              ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', [_vm._v(_vm._s(_vm.$t('btn.createInvoice')))])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("d-" + index)
    })]
  }), _vm._v(" "), (_vm.invoiceableClients.length === 0 && !_vm.request.loading) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('page.noresults')))])], 1)], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-2 pl-1",
    attrs: {
      "id": "invoiceable-top"
    }
  }, [_c('appointment-action', {
    attrs: {
      "component-name": "CreateInvoice",
      "initial-filters": _vm.filters,
      "initial-relationship": _vm.selectedRelationship,
      "touch": _vm.actionTouch
    },
    on: {
      "success": function($event) {
        _vm.touch++
      }
    }
  }, [_c('template', {
    slot: "ag-filters"
  }, [_c('invoiceable-client-list', {
    attrs: {
      "touch": _vm.touch
    },
    on: {
      "update:params": _vm.setFilters,
      "selected": _vm.setRelationship
    }
  })], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "filled": "",
      "persistent-hint": "",
      "clearable": "",
      "prefix": _vm.$store.getters.settings.currency,
      "label": _vm.$t('inputs.opening.label'),
      "hint": _vm.$t('inputs.opening.hint')
    },
    model: {
      value: (_vm.openingBalance),
      callback: function($$v) {
        _vm.openingBalance = $$v
      },
      expression: "openingBalance"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-2",
          attrs: {
            "persistent-hint": "",
            "readlonly": "",
            "clearable": "",
            "placeholder": "yyyy-mm-dd",
            "hint": "Choose an invoice date, or leave blank to use the latest invoice date from the selected invoices",
            "label": "invoice date",
            "prepend-icon": "event"
          },
          model: {
            value: (_vm.date),
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.date_modal),
      callback: function($$v) {
        _vm.date_modal = $$v
      },
      expression: "date_modal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.date_modal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-2",
          attrs: {
            "persistent-hint": "",
            "readlonly": "",
            "clearable": "",
            "placeholder": "yyyy-mm-dd",
            "hint": "Choose a due date, or leave blank to use the latest invoice due date from the selected invoices",
            "label": "due date",
            "prepend-icon": "event"
          },
          model: {
            value: (_vm.due_date),
            callback: function($$v) {
              _vm.due_date = $$v
            },
            expression: "due_date"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.due_date_modal),
      callback: function($$v) {
        _vm.due_date_modal = $$v
      },
      expression: "due_date_modal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.date
    },
    model: {
      value: (_vm.due_date),
      callback: function($$v) {
        _vm.due_date = $$v
      },
      expression: "due_date"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.due_date_modal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "subheader": "",
      "two-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('subtitles.invoices')) + "\n    ")]), _vm._v(" "), _vm._l((_vm.invoices), function(invoice) {
    return [_c('v-list-tile', {
      key: invoice.id
    }, [_c('v-list-tile-action', {
      staticClass: "mr-2"
    }, [_vm._v("\n          #" + _vm._s(invoice.id) + "\n        ")]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "hidden-xs-only"
    }, [_vm._v("\n            " + _vm._s(invoice.title) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(invoice.date) + ".\n            "), _c('strong', [_vm._v("Due:")]), _vm._v(" " + _vm._s(invoice.due_date) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "hidden-xs-only mr-2"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.currency, invoice.invoice_amount)))]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.invoiced')) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "hidden-xs-only"
    }, [_vm._v("\n          " + _vm._s(_vm.formatCurrency(_vm.currency, invoice.amount_paid)) + "\n          "), _c('v-list-tile-action-text', [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.payments')) + "\n          ")])], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ml-2",
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "grey lighten-4 px-1"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.currency, (invoice.invoice_amount - invoice.amount_paid))))]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.due')) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(!_vm.showNotes) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showNotes = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("\n          " + _vm._s(_vm.$t('buttons.note')) + "\n        ")], 1) : [_c('h4', {
    staticClass: "overline ml-1"
  }, [_vm._v(_vm._s(_vm.$t('subtitles.notes')))]), _vm._v(" "), _c('v-textarea', {
    staticClass: "ma-1 mr-2",
    attrs: {
      "filled": "",
      "box": "",
      "filled": "",
      "label": "Add a note"
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })]], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-right"
  }, [_c('v-flex', {
    staticClass: "text-uppercase",
    attrs: {
      "xs7": "",
      "sm10": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.opening')) + "\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_vm._v(_vm._s(_vm.formatCurrency(this.currency, _vm.openingBalance)))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-right"
  }, [_c('v-flex', {
    staticClass: "text-uppercase",
    attrs: {
      "xs7": "",
      "sm10": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.invoiced')) + "\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_vm._v(_vm._s(_vm.formatCurrency(this.currency, _vm.invoiceTotal)))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-right mb-2"
  }, [_c('v-flex', {
    staticClass: "text-uppercase",
    attrs: {
      "xs7": "",
      "sm10": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.payments')) + "\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_vm._v(_vm._s(_vm.formatCurrency(this.currency, _vm.paymentsTotal)))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-right mt-2 subtitle-1 text-uppercase"
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm10": ""
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('subtitles.total')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-right",
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_c('strong', [_vm._v("\n              " + _vm._s(_vm.formatCurrency(this.currency, _vm.grandTotal)) + "\n            ")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.noInvoices,
      "loading": _vm.statementRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.create')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [(_vm.appointmentIds) ? _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n    " + _vm._s(_vm.$tc('title', _vm.appointmentIds.length, {
    count: _vm.appointmentIds.length
  })) + "\n    "), _c('v-spacer'), _vm._v(" "), (!_vm.showDetails) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.expand
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.more')))]) : _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showDetails = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.less')))])], 1) : _vm._e(), _vm._v(" "), (_vm.showDetails) ? _c('v-card-text', [(_vm.request.loading) ? _c('v-progress-linear', {
    staticClass: "my-0",
    attrs: {
      "height": "3",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appointments) ? _c('v-list', {
    staticClass: "elevation-3",
    attrs: {
      "three-line": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('sleecteditems')))]), _vm._v(" "), _vm._l((_vm.appointments), function(appointment) {
    return _c('appointment-list-item', {
      key: appointment.id,
      attrs: {
        "with-action": false,
        "with-tags": true,
        "appointment": appointment
      }
    })
  })], 2) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    key: _vm.item.id,
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.item)
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    attrs: {
      "title": _vm.transport
    }
  }, [_vm._v(_vm._s(_vm.transport))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_c('strong', [_vm._v("to:")]), _vm._v(" "), _vm._l((_vm.item.recipient_emails), function(recipient) {
    return (_vm.transport === "email") ? [_c('v-chip', {
      key: recipient,
      staticClass: "v-chip--x-small",
      attrs: {
        "label": "",
        "small": "",
        "outline": "",
        "color": "primary"
      }
    }, [_vm._v(_vm._s(recipient))])] : _vm._e()
  }), _vm._v(" "), (_vm.transport === "sms" && _vm.item.recipient_phone_number) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "small": "",
      "outline": "",
      "label": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.recipient_phone_number))]) : _vm._e()], 2), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Sent: " + _vm._s(_vm.dateformat(_vm.item.created_date, 'ddd DD MMM YYYY H:mma')) + " via " + _vm._s(_vm.transport))])])], 1), _vm._v(" "), (_vm.item.communicationstatus && _vm.item.communicationstatus.length > 0) ? _c('v-list-tile-action', {
    staticClass: "hidden-xs-only"
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "flat": "",
            "small": ""
          },
          slot: "activator"
        }, on), [_vm._v("\n        " + _vm._s(_vm.item.communicationstatus[_vm.item.communicationstatus.length - 1].status) + "\n        "), _c('v-icon', [_vm._v("expand_more")])], 1)]
      }
    }], null, false, 295767040)
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.item.communicationstatus), function(status) {
    return _c('v-list-tile', {
      key: status.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(status.status.toLowerCase()))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.dateformat(status.created_date, 'ddd DD MMM YYYY H:mm a')))])], 1)], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "type": _vm.displayType,
      "max": new Date().toISOString().substr(0, 10),
      "min": "1900-01-01",
      "full-width": "",
      "flat": ""
    },
    on: {
      "click:month": function($event) {
        _vm.displayType = "date"
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.done')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.visibleIntegrations), function(integration) {
    return _c('v-flex', {
      key: integration.title,
      attrs: {
        "xs12": "",
        "sm6": "",
        "lg4": ""
      }
    }, [_c('v-card', {
      staticClass: "mb-3",
      attrs: {
        "height": "100%"
      }
    }, [_c('v-list', {
      attrs: {
        "three-line": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('img', {
      staticClass: "mr-3",
      attrs: {
        "height": "50",
        "src": integration.logo
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(integration.title) + "\n              "), (_vm.isInstalled(integration)) ? _c('v-chip', {
      staticClass: "ml-3 v-chip--x-small",
      attrs: {
        "color": "success",
        "label": "",
        "dark": "",
        "small": ""
      }
    }, [_vm._v("\n                Installed\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": integration.serviceURL,
        "target": "_blank"
      }
    }, [_vm._v("\n                Open " + _vm._s(integration.title) + "\n                "), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1)])], 1), _vm._v(" "), _c('v-list-tile-action', [(integration.installPath) ? _c('v-btn', {
      attrs: {
        "small": "",
        "to": integration.installPath,
        "color": "primary"
      }
    }, [_vm._v("\n                Manage\n                ")]) : _vm._e(), _vm._v(" "), (integration.installURL) ? _c('v-btn', {
      attrs: {
        "href": integration.installURL,
        "color": "primary"
      }
    }, [_vm._v("\n                " + _vm._s(integration.cta) + "\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(integration.tagline) ? _c('blockquote', {
      staticClass: "blockquote"
    }, [_vm._v(_vm._s(integration.tagline))]) : _vm._e(), _vm._v(" "), (integration.description) ? _c('p', {
      attrs: {
        "vhtml": "integration.description"
      }
    }) : _vm._e(), _vm._v(" "), (integration.features) ? _c('ul', [_c('v-subheader', {
      staticClass: "ml-0 pl-0"
    }, [_vm._v("Features")]), _vm._v(" "), _vm._l((integration.features), function(feature, index) {
      return _c('li', {
        key: index,
        staticClass: "ml-4"
      }, [_vm._v("\n            " + _vm._s(feature) + "\n          ")])
    })], 2) : _vm._e()]), _vm._v(" "), (integration.helpDocs && integration.helpDocs.length > 0) ? _c('v-card-actions', [_c('v-btn', {
      staticClass: "ml-4",
      attrs: {
        "color": "primary",
        "outline": ""
      }
    }, [_vm._v("Learn more\n          "), _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, on), [_c('v-icon', [_vm._v("expand_more")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((integration.helpDocs), function(doc) {
      return _c('v-list-tile', {
        key: doc.title
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(doc.title))])], 1), _vm._v(" "), (doc.video) ? _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "href": doc.video,
          "target": "_blank",
          "icon": ""
        }
      }, [_c('v-icon', [_vm._v("videocam")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "href": doc.link,
          "target": "_blank",
          "icon": ""
        }
      }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1)], 1)
    }), 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-card', {
    staticClass: "my-4",
    attrs: {
      "flat": "",
      "width": "250"
    }
  }, [_c('v-card-text', {
    staticClass: "text-center text-xs-center"
  }, [_c('v-icon', {
    staticClass: "mt-4",
    attrs: {
      "dark": "",
      "size": "76",
      "color": "green"
    }
  }, [_vm._v("\n        check_circle\n      ")]), _vm._v(" "), _c('h3', {
    staticClass: "subheading text-xs-center mb-4"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('title')) + "\n      ")]), _vm._v(" "), _c('h3', {
    staticClass: "overline text-center"
  }, [_vm._v(_vm._s(_vm.$t('subtitles.nextsteps')) + ":")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "color": "primary",
      "outlined": "",
      "block": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("send", _vm.statement)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.send')) + "\n        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("send")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "href": _vm.statement.url,
      "target": "_blank",
      "outlined": "",
      "block": "",
      "small": "",
      "outline": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.view')) + "\n        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.done')) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gmaps",
    class: {
      loading: _vm.loading,
      failed: _vm.failed
    }
  }, [_vm._t("default", function() {
    return [_c('v-text-field', {
      staticClass: "input-group--focused",
      attrs: {
        "prepend-icon": "place",
        "hint": "Start typing an address and we'll search Google for places",
        "solo": "",
        "persistent-hint": "",
        "clearable": true,
        "type": "text",
        "id": _vm.id
      },
      on: {
        "focus": _vm.start
      },
      model: {
        value: (_vm.addressString),
        callback: function($$v) {
          _vm.addressString = $$v
        },
        expression: "addressString"
      }
    })]
  }), _vm._v(" "), (_vm.withSummary && _vm.location && _vm.location.adr_address) ? _c('v-card-text', [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.location.adr_address)
    }
  }), _vm._v(" "), _c('div', [_c('strong', [_vm._v("coordinates:")]), _vm._v(" "), (_vm.lat) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.lat)
    }
  }) : _vm._e(), _vm._v(",\n      "), (_vm.lng) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.lng)
    }
  }) : _vm._e()])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    class: _vm.classes,
    attrs: {
      "type": "submit",
      "primary": _vm.isPrimary,
      "flat": _vm.isFlat,
      "success": _vm.isSuccess,
      "error": _vm.isError,
      "disabled": _vm.isDisabled,
      "block": _vm.isBlock,
      "color": _vm.color,
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.iconText))]), _vm._v(" " + _vm._s(_vm.buttonText) + "\n")], 1)
},staticRenderFns: []}

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ma-2 elevation-6"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("send")])], 1), _vm._v("\n    " + _vm._s(_vm.title || _vm.value.full_name) + "\n    "), _c('v-spacer'), _vm._v(" "), (_vm.value.phone_number && _vm.context && _vm.sender && _vm.templateSlug) ? _c('form', {
    attrs: {
      "action": "https://unibox.appointmentguru.co/whatsapp/",
      "method": "POST",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "small": "",
      "outline": "",
      "round": "",
      "color": "success"
    }
  }, [_vm._v("WhatsApp\n        "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.phone_number),
      expression: "value.phone_number"
    }],
    attrs: {
      "type": "hidden",
      "name": "to"
    },
    domProps: {
      "value": (_vm.value.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "phone_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "template"
    },
    domProps: {
      "value": _vm.templateSlug
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "context"
    },
    domProps: {
      "value": _vm.parsedContext
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3 py-2 pa-0 ma-0",
    attrs: {
      "label": "email",
      "disabled": !(_vm.value.email) || !_vm.isRealEmail(_vm.value.email),
      "hint": _vm.emailHint(_vm.value),
      "persistent-hint": ""
    },
    model: {
      value: (_vm.byEmail),
      callback: function($$v) {
        _vm.byEmail = $$v
      },
      expression: "byEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3 py-2 pa-0 ma-0",
    attrs: {
      "label": "sms",
      "disabled": !_vm.value.phone_number,
      "hint": _vm.value.phone_number || "No phone number available",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.bySMS),
      callback: function($$v) {
        _vm.bySMS = $$v
      },
      expression: "bySMS"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.appointment && _vm.appointment.id && _vm.table && _vm.table.data && _vm.table.activeCodeTypes) ? _c('v-card', {
    attrs: {
      "dark": _vm.dark,
      "tile": "",
      "flat": ""
    }
  }, [(_vm.withTitle) ? _c('v-card-title', {
    staticClass: "py-2 mr-4 pr-5"
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }], null, false, 1583155356)
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 grey lighten-4 overline pl-4"
  }, [_vm._v("\n            Coding utilities\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "disabled": _vm.table.data.length <= 1
    },
    on: {
      "click": function($event) {
        _vm.showOrder = true
      }
    }
  }, [_vm._v("\n              Set order of codes")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-dialog', {
    attrs: {
      "width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "flat": "",
            "small": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v("\n                  Copy codes from previous apointments")])]
      }
    }], null, false, 1455719181),
    model: {
      value: (_vm.copycodes),
      callback: function($$v) {
        _vm.copycodes = $$v
      },
      expression: "copycodes"
    }
  }, [_vm._v(" "), _c('copy-codes', {
    attrs: {
      "appointment": _vm.appointment
    },
    on: {
      "update": _vm.clearAndLoadAppointments,
      "close": function($event) {
        _vm.copycodes = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('apply-appointment-codes', {
    attrs: {
      "disabled": _vm.table.data.length === 0 || _vm.appointment.recurring_appointment === null,
      "appointment": _vm.appointment
    }
  })], 1), _vm._v(" "), _c('v-list-tile', [(_vm.withClone) ? _c('clone-appointment-codes', {
    attrs: {
      "disabled": _vm.table.data.length === 0,
      "appointment": _vm.appointment
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.title) ? _c('strong', {
    staticClass: "overline",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _c('strong', {
    staticClass: "overline"
  }, [_vm._v("\n        " + _vm._s(_vm.appointment.title) + ". " + _vm._s(_vm.dateformat(_vm.appointment.start_time, 'ddd DD MMM @ hh:mma')) + "\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showOrder) ? _c('v-btn', {
    attrs: {
      "disabled": _vm.codeOrder && Object.keys(_vm.codeOrder).length === 0,
      "loading": _vm.requests.setorder.loading,
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.setOrder
    }
  }, [_vm._v("Save order")]) : _vm._e(), _vm._v(" "), (_vm.showOrder) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showOrder = false
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.appointmentRequest.loading
    },
    on: {
      "click": _vm.clearAndLoadAppointments
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": _vm.alert.type,
      "dismissible": ""
    },
    model: {
      value: (_vm.alert.visible),
      callback: function($$v) {
        _vm.$set(_vm.alert, "visible", $$v)
      },
      expression: "alert.visible"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.alert.message) + "\n    ")]), _vm._v(" "), (_vm.table) ? _c('crud-table', {
    attrs: {
      "flat": "",
      "dense": "",
      "with-inline-delete": "",
      "selectable": false,
      "loading": _vm.codesUpdating || _vm.appointmentRequest.loading,
      "headers": _vm.table.headers,
      "deleteable": true,
      "items": _vm.table.data,
      "dialog-width": 600,
      "no-data-text": _vm.$t('messages.nocodes')
    },
    on: {
      "add": _vm.addCode,
      "edit": _vm.editCode,
      "delete": _vm.deleteCode
    },
    scopedSlots: _vm._u([{
      key: "before-table",
      fn: function(props) {
        return [(props.selected && props.selected.length > 0) ? _c('v-layout', {
          staticClass: "mx-2 mb-2"
        }, [_c('v-flex', {
          attrs: {
            "xs8": ""
          }
        }, [_c('icd-input', {
          attrs: {
            "persistent-hint": "",
            "label": "Apply ICD-10 code to selected rows",
            "hint": "Type an ICD-10 code, or click the search icon to search (ctrl s). "
          },
          model: {
            value: (_vm.icdCode),
            callback: function($$v) {
              _vm.icdCode = $$v
            },
            expression: "icdCode"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-btn', {
          staticClass: "mt-4",
          attrs: {
            "small": "",
            "outline": "",
            "disabled": !_vm.icdCode,
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.setcodes(props.selected)
            }
          }
        }, [_vm._v("Set ICD\n              "), _c('span', {
          staticClass: "hidden-xs-only ml-1"
        }, [_vm._v(" for selected line items")])])], 1)], 1) : _vm._e()]
      }
    }, {
      key: "order",
      fn: function(props) {
        return [_c('v-text-field', {
          staticClass: "caption",
          attrs: {
            "hide-details": "",
            "type": "number"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.noop.apply(null, arguments)
            },
            "input": function($event) {
              return _vm.updateOrder(props.item, props.value)
            }
          },
          model: {
            value: (props.value),
            callback: function($$v) {
              _vm.$set(props, "value", $$v)
            },
            expression: "props.value"
          }
        })]
      }
    }, {
      key: "field-icd10",
      fn: function(props) {
        return [_c('v-dialog', {
          attrs: {
            "fullscreen": ""
          },
          model: {
            value: (_vm.ICD10codepicker),
            callback: function($$v) {
              _vm.ICD10codepicker = $$v
            },
            expression: "ICD10codepicker"
          }
        }, [_c('v-system-bar', {
          staticClass: "visible-ios-only main",
          attrs: {
            "color": _vm.themeColor
          }
        }), _vm._v(" "), _c('v-toolbar', {
          attrs: {
            "dark": "",
            "dense": "",
            "short": "",
            "color": _vm.themeColor
          }
        }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.icd10picker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.ICD10codepicker = false
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('icd-picker', {
          attrs: {
            "touch": _vm.icdtouch,
            "initial-search-string": _vm.codeSearchString
          },
          on: {
            "input": function($event) {
              return _vm.setIcdCode(props)
            }
          },
          model: {
            value: (_vm.code),
            callback: function($$v) {
              _vm.code = $$v
            },
            expression: "code"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "append-icon": "search",
            "label": "ICD10 code",
            "hint": "Please provide an ICD10 diagnosis code",
            "required": "",
            "rules": [function (v) { return !!v || 'IDC10 code is required'; }]
          },
          on: {
            "click:append": function($event) {
              return _vm.showICDPicker(props)
            },
            "input": function($event) {
              _vm.typedIcd10Code = props.selectedRow[props.header.value]
            }
          },
          model: {
            value: (props.selectedRow[props.header.value]),
            callback: function($$v) {
              _vm.$set(props.selectedRow, props.header.value, $$v)
            },
            expression: "props.selectedRow[props.header.value]"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_vm._l((_vm.suggestedICD10), function(code, index) {
          return [(code) ? _c('v-chip', {
            key: (code + "-" + index),
            attrs: {
              "small": "",
              "label": ""
            },
            on: {
              "click": function($event) {
                props.selectedRow.icd10 = code
              }
            }
          }, [_vm._v("\n            " + _vm._s(code) + "\n          ")]) : _vm._e()]
        })], 2)]
      }
    }, {
      key: "field-process",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-dialog', {
          attrs: {
            "fullscreen": ""
          },
          model: {
            value: (_vm.processcodepicker),
            callback: function($$v) {
              _vm.processcodepicker = $$v
            },
            expression: "processcodepicker"
          }
        }, [_c('v-system-bar', {
          staticClass: "visible-ios-only main",
          attrs: {
            "color": _vm.themeColor
          }
        }), _vm._v(" "), _c('v-toolbar', {
          attrs: {
            "dark": "",
            "dense": "",
            "short": "",
            "color": _vm.themeColor
          }
        }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.processpicker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.processcodepicker = false
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('process-code-picker', {
          attrs: {
            "initial-search-string": _vm.processSearchString
          },
          on: {
            "input": function($event) {
              return _vm.setProcessCode(props)
            }
          },
          model: {
            value: (_vm.process),
            callback: function($$v) {
              _vm.process = $$v
            },
            expression: "process"
          }
        })], 1), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "append-icon": "search",
            "label": "Process code",
            "required": "",
            "rules": [function (v) { return !!v || 'Process code is required (just put a - if you really don\'t want to use it)'; }]
          },
          on: {
            "click:append": function($event) {
              return _vm.showProcessPicker(props)
            },
            "input": function($event) {
              _vm.typedProcessCode = props.selectedRow[props.header.value]
            }
          },
          model: {
            value: (props.selectedRow[props.header.value]),
            callback: function($$v) {
              _vm.$set(props.selectedRow, props.header.value, $$v)
            },
            expression: "props.selectedRow[props.header.value]"
          }
        })], 1)]
      }
    }, {
      key: "field-nappi",
      fn: function(props) {
        return _c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          staticClass: "text-xs-right",
          attrs: {
            "xs12": ""
          }
        }, [(_vm.moreCodes === false) ? _c('v-btn', {
          staticClass: "ma-0",
          attrs: {
            "flat": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              _vm.moreCodes = true
            }
          }
        }, [_vm._v("More code options")]) : _c('v-btn', {
          staticClass: "ma-0",
          attrs: {
            "flat": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              _vm.moreCodes = false
            }
          }
        }, [_vm._v("Fewer options")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [(_vm.moreCodes) ? _c('v-text-field', {
          attrs: {
            "label": "NAPPI code"
          },
          model: {
            value: (props.selectedRow[props.header.value]),
            callback: function($$v) {
              _vm.$set(props.selectedRow, props.header.value, $$v)
            },
            expression: "props.selectedRow[props.header.value]"
          }
        }) : _vm._e()], 1)], 1)
      }
    }, {
      key: "field-price",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "prefix": _vm.defaultCurrency,
            "label": "Price",
            "type": "number",
            "required": "",
            "rules": [function (v) { return !!v || 'Price is required'; }]
          },
          model: {
            value: (props.selectedRow[props.header.value]),
            callback: function($$v) {
              _vm.$set(props.selectedRow, props.header.value, $$v)
            },
            expression: "props.selectedRow[props.header.value]"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, _vm._l((_vm.suggestedPrices), function(code, index) {
          return _c('v-chip', {
            key: index,
            attrs: {
              "small": "",
              "label": ""
            },
            on: {
              "click": function($event) {
                props.selectedRow.price = code.price;
                props.selectedRow.process = code.name
              }
            }
          }, [_c('strong', [_vm._v(_vm._s(code.name))]), _vm._v(" \n            " + _vm._s(_vm.formatCurrency(code.currency, (parseFloat(code.price)))) + "\n          ")])
        }), 1)]
      }
    }], null, false, 1766410603)
  }, [_vm._v(" "), _c('div', {
    attrs: {
      "slot": "dialog-header"
    },
    slot: "dialog-header"
  }, [_c('v-snackbar', {
    staticClass: "ma-0",
    attrs: {
      "absolute": "",
      "top": "",
      "color": _vm.snack.type
    },
    model: {
      value: (_vm.snack.visible),
      callback: function($$v) {
        _vm.$set(_vm.snack, "visible", $$v)
      },
      expression: "snack.visible"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.snack.message) + "\n          "), _c('v-btn', {
    attrs: {
      "color": "pink",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snack.visible = false
      }
    }
  }, [_vm._v("\n            Close\n          ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.withTotal) ? _c('v-card-actions', {
    staticClass: "grey lighten-2"
  }, [_c('v-chip', {
    staticClass: "pa-0",
    attrs: {
      "small": "",
      "label": "",
      "outline": ""
    }
  }, [_vm._v("#" + _vm._s(_vm.appointmentId))]), _vm._v(" "), (_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.table.data && _vm.table.data.length > 0) ? _c('h3', {
    staticClass: "subheading mr-4"
  }, [_vm._v("\n        Total:\n        " + _vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.totalPrice)) + "\n      ")]) : _vm._e()], 1) : _vm._e()], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!this.appointmentRequest.loading) ? _c('v-card-text', [(_vm.appointmentId && _vm.appointmentId > 0) ? _c('div', [_c('v-icon', [_vm._v("warning")]), _vm._v(" unable to load codes.\n      "), _c('v-btn', {
    attrs: {
      "loading": _vm.appointmentRequest.loading,
      "flat": ""
    },
    on: {
      "click": _vm.loadAppointments
    }
  }, [_vm._v("Try again ")])], 1) : _c('v-alert', {
    attrs: {
      "value": true
    }
  }, [_vm._v("\n      Something has gone wrong.\n      Try choosing another appointment and then\n      coming back to this one?\n    ")])], 1) : _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "size": "32",
      "width": "2"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs2": "",
      "order-sm1": ""
    }
  }, [_c('v-list', {
    staticClass: "pb-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search",
      "prepend-icon": "search",
      "clearable": "",
      "solo": ""
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('v-subheader', [_c('help-popover', [_vm._v(_vm._s(_vm.$t('help.text')))]), _vm._v("\n      " + _vm._s(_vm.$t('help.title')) + "\n    ")], 1), _vm._v(" "), _vm._l((_vm.filteredAppointments), function(item) {
    return [(!item.invoiceable) ? _c('v-list-tile', {
      key: item.id
    }, [_c('v-list-tile-action', [_c('v-checkbox', {
      attrs: {
        "value": item.id
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title || item.full_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(item.start_time)) + "\n        ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "to": ("/appointments/" + (item.id)),
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('span', [_vm._v("Go to appointment")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
      key: ("d-" + (item.id))
    })]
  })], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "appear": "",
      "mode": "in-out"
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": "",
      "order-xs1": "",
      "order-sm2": ""
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "mode": "out-in",
      "name": "fade"
    }
  }, [(_vm.selected && _vm.selected.length > 0) ? _c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-chip', {
    attrs: {
      "color": "primary",
      "dark": "",
      "text-color": "white"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selected.length) + " selected appointments\n          ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panel', {
    staticClass: "elevation-4",
    model: {
      value: (_vm.exandr),
      callback: function($$v) {
        _vm.exandr = $$v
      },
      expression: "exandr"
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Invoice details")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "value": _vm.showSuccessNotification,
      "color": "success",
      "dismissible": ""
    }
  }, [_vm._v("\n                    Selected appointments successfully updated\n                  ")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote px-0"
  }, [_vm._v("\n                    Set the invoice title and description for " + _vm._s(_vm.selected.length) + " appointments\n                  ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Invoice title",
      "hint": "The line item title we will show on invoices"
    },
    model: {
      value: (_vm.appointmentData.invoice_title),
      callback: function($$v) {
        _vm.$set(_vm.appointmentData, "invoice_title", $$v)
      },
      expression: "appointmentData.invoice_title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Invoice description",
      "hint": "An optional extra description to show on the invoice"
    },
    model: {
      value: (_vm.appointmentData.invoice_description),
      callback: function($$v) {
        _vm.$set(_vm.appointmentData, "invoice_description", $$v)
      },
      expression: "appointmentData.invoice_description"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.invoiceDataRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Add Codes")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('v-card-text', [_c('bulk-add-codes', {
    attrs: {
      "appointment-ids": _vm.selected
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.selected && _vm.selected.length > 0) ? _c('v-card', {
    staticClass: "my-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "loading": _vm.markInvoiceableRequest.loading
    },
    on: {
      "click": _vm.markInvoiceable
    }
  }, [_c('v-icon', {
    staticClass: "mx-2"
  }, [_vm._v("check_circle_outline")]), _vm._v("\n              Mark " + _vm._s(_vm.selected.length) + " appointments as invoiceable\n            ")], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('vuex-snackbar', {
    attrs: {
      "req-id": _vm.bulkReqId,
      "success-message": "Appointments marked as invoiceable",
      "error-message": "Unable to update invoices. Please try again"
    }
  }), _vm._v(" "), _c('vuex-snackbar', {
    attrs: {
      "req-id": _vm.bulkReqIdData,
      "success-message": "Appointments updated",
      "error-message": "Unable to update invoices. Please try again"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('request-status', {
    staticClass: "mt-0",
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.globalRequests.appointmentsv2,
      "message200": false
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.practitioner) ? _c('practitioner-picker', {
    model: {
      value: (_vm.practitioner),
      callback: function($$v) {
        _vm.practitioner = $$v
      },
      expression: "practitioner"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "id": "appointment-create-container"
    }
  }, [_c('v-window', {
    attrs: {
      "touchless": "",
      "vertical": "",
      "min-height": 500
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('v-sheet', {
    attrs: {
      "height": "100%",
      "min-height": 500,
      "flat": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "block": "",
            "tile": "",
            "outline": _vm.appointment.is_custom,
            "color": "accent"
          },
          on: {
            "click": function($event) {
              _vm.appointment.is_custom = false
            }
          }
        }, 'v-btn', attrs, false), on), [_vm._v("Normal appointment")])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Use this when creating a normal appointment for a client")])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1 mr-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "block": "",
            "tile": "",
            "outline": !_vm.appointment.is_custom,
            "color": "accent"
          },
          on: {
            "click": function($event) {
              _vm.appointment.is_custom = true
            }
          }
        }, 'v-btn', attrs, false), on), [_vm._v("Personal appointment")])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Use this to create an appointment for yourself - you can use this to block time out from your calendar")])])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.appointment.is_custom) ? _c('v-text-field', {
    staticClass: "mb-1",
    attrs: {
      "persistent-hint": "",
      "name": "input-title",
      "label": "Appointment title",
      "hint": "Give the appointment a name. e.g.: Lunch, Yoga, Gym, Meeting with Jane etc.",
      "id": "appointment-title"
    },
    model: {
      value: (_vm.appointment.title),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "title", $$v)
      },
      expression: "appointment.title"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    class: {
      'mb-4': _vm.$vuetify.breakpoint.xs
    },
    attrs: {
      "two-line": "",
      "avatar": "",
      "subheader": ""
    }
  }, [(!_vm.appointment.is_custom) ? _c('v-list-tile', {
    class: _vm.getStepClasses("product"),
    nativeOn: {
      "click": function($event) {
        _vm.productpicker = !_vm.productpicker
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("star")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.appointment.product && _vm.appointment.product.title) ? _c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(_vm.appointment.product.title) + "\n                ")]) : _c('v-list-tile-title', [_vm._v("\n                  Type of appointment\n                ")]), _vm._v(" "), (_vm.appointment.product && _vm.appointment.product.duration) ? _c('v-list-tile-sub-title', [_vm._v("\n                  " + _vm._s(_vm.appointment.product.duration) + " mins.\n                  " + _vm._s(_vm.appointment.product.currency) + " " + _vm._s(_vm.appointment.product.price) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.selectedServiceTitle) ? _c('v-list-tile-sub-title', [_vm._v("@ " + _vm._s(_vm.selectedServiceTitle) + "\n                  "), (_vm.appointment && _vm.appointment.address) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "label": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("location_on")]), _vm._v("\n                    " + _vm._s(_vm.appointment.address.name))], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [(_vm.appointment.product && _vm.appointment.product.title) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("task_alt")]) : _c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("arrow_back")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.appointment && _vm.appointment.product && _vm.appointment.product.comes_to_you === true) ? _c('v-list-tile', [_c('v-text-field', {
    staticClass: "mx-4",
    attrs: {
      "prepend-icon": "location_on",
      "label": "Appointment Address",
      "hint": "(optional), store the custom address for this appointment"
    },
    model: {
      value: (_vm.appointmentLocation),
      callback: function($$v) {
        _vm.appointmentLocation = $$v
      },
      expression: "appointmentLocation"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.appointment && _vm.appointment.product && _vm.appointment.product.is_online === true) ? [_c('v-divider'), _vm._v(" "), (_vm.hasZoomIntegration) ? _c('div', {
    staticClass: "caption amber lighten-2 mx-4"
  }, [_c('v-icon', {
    staticClass: "mt-2 mr-2 float-left",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('v-btn', {
    staticClass: "caption py-0 px-1",
    staticStyle: {
      "float": "right",
      "height": "24px"
    },
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.overrideZoomIntegration = true
      }
    }
  }, [_vm._v("Manually enter meeting URL")]), _vm._v("\n              Zoom integration detected."), _c('br'), _vm._v("\n              A Zoom meeting will be created for this appointment\n            ")], 1) : _vm._e(), _vm._v(" "), (!_vm.hasZoomIntegration || _vm.overrideZoomIntegration) ? _c('v-list-tile', [_c('v-text-field', {
    staticClass: "mx-4 caption",
    attrs: {
      "persistent-hint": "",
      "prepend-icon": "language",
      "label": "Provide a meeting URL",
      "hint": "(optional) If you don't have the Zoom integration, you can manually provide a meeting URL, or you can provide a custom URL if you do not want AppointmentGuru to generate a custom Zoom meeting for you"
    },
    model: {
      value: (_vm.appointmentURL),
      callback: function($$v) {
        _vm.appointmentURL = $$v
      },
      expression: "appointmentURL"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider')] : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    class: _vm.getStepClasses("day"),
    on: {
      "click": function($event) {
        _vm.daymodal = true
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [(!_vm.appointment.day) ? _c('v-list-tile-title', [_vm._v("Day")]) : _c('v-list-tile-title', [_vm._v("\n                " + _vm._s(_vm.dateformat(_vm.appointment.day, 'ddd DD MMM')) + "\n              ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("click to change selected day")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": "",
      "value": true
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mb-5 hidden-sm-and-up",
          attrs: {
            "fab": "",
            "small": "",
            "fixed": "",
            "bottom": "",
            "left": "",
            "color": "info"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showcalendar = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("event")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Show schedule")])]), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [(_vm.appointment.day) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("task_alt")]) : _c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("arrow_back")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.daymodal),
      callback: function($$v) {
        _vm.daymodal = $$v
      },
      expression: "daymodal"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    attrs: {
      "full-width": "",
      "scrollable": "",
      "actions": "",
      "autosave": ""
    },
    model: {
      value: (_vm.appointment.day),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "day", $$v)
      },
      expression: "appointment.day"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.daymodal = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    class: _vm.getStepClasses("time"),
    on: {
      "click": function($event) {
        _vm.starttime = true
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "height": "32px"
    }
  }, [_c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.starttime),
      callback: function($$v) {
        _vm.starttime = $$v
      },
      expression: "starttime"
    }
  }, [_c('v-chip', {
    attrs: {
      "slot": "activator",
      "small": ""
    },
    on: {
      "click": _vm.setDefaultStartTime
    },
    slot: "activator"
  }, [(!_vm.appointment.start_time) ? _c('span', [_vm._v("Start time")]) : _c('span', [_vm._v(_vm._s(_vm.appointment.start_time))])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    staticClass: "elevation-0",
    attrs: {
      "full-width": "",
      "scrollable": "",
      "format": "24hr",
      "autosave": ""
    },
    on: {
      "input": _vm.startTimeChanged
    },
    model: {
      value: (_vm.appointment.start_time),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "start_time", $$v)
      },
      expression: "appointment.start_time"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.starttime = false
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.starttime = false;
        _vm.endtime = true
      }
    }
  }, [_vm._v("Choose end time "), _c('v-icon', [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_forward")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.endtime),
      callback: function($$v) {
        _vm.endtime = $$v
      },
      expression: "endtime"
    }
  }, [_c('v-chip', {
    attrs: {
      "slot": "activator",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDefaultEndTime.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [(!_vm.appointment.end_time) ? _c('span', [_vm._v("End time")]) : _c('span', [_vm._v(_vm._s(_vm.appointment.end_time))])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    staticClass: "elevation-0",
    attrs: {
      "full-width": "",
      "min": _vm.appointment.start_time,
      "scrollable": "",
      "format": "24hr",
      "autosave": ""
    },
    model: {
      value: (_vm.appointment.end_time),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "end_time", $$v)
      },
      expression: "appointment.end_time"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.endtime = false;
        _vm.starttime = true
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("Change start time")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.endtime = false
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                  Choose a start and end time\n                ")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [(_vm.appointment.start_time && _vm.appointment.end_time) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("task_alt")]) : _c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("arrow_back")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.isProductSelected) ? _c('div', {
    staticClass: "overline pl-4 grey lighten-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "nudge-bottom": "",
      "absolute": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.operatingHours) ? [_c('v-icon', {
          staticClass: "hidden-xs-only",
          attrs: {
            "color": "primary",
            "small": ""
          }
        }, [_vm._v("alarm")]), _vm._v(" "), _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "label": "",
            "outline": ""
          }
        }, [_vm._v(_vm._s(_vm.practitionerName))]), _vm._v("\n                      " + _vm._s(_vm.dateformat(_vm.appointment.day, 'ddd')) + "\n                      @ " + _vm._s(_vm.appointment.address.name) + ":\n                      "), _c('strong', [_vm._v(_vm._s(_vm.selectedDayHours))]), _vm._v(" "), _c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("arrow_drop_down")])], 1)] : [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": "",
            "color": "amber"
          }
        }, [_vm._v("warning")]), _vm._v("\n                      Unable to load operating hours\n                      "), _c('v-spacer'), _vm._v(" "), (_vm.operationHoursLink && _vm.appointmentServiceId) ? _c('v-btn', {
          attrs: {
            "flat": "",
            "small": "",
            "href": _vm.operationHoursLink,
            "target": "_blank",
            "disabled": !_vm.rolesIsOwnerOfSpace(_vm.appointmentServiceId)
          }
        }, [_vm._v("Edit hours")]) : _vm._e()]]
      }
    }], null, false, 1287228531)
  }, [_vm._v(" "), (_vm.operatingHours) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "subheader": "",
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 my-0"
  }, [_vm._v("\n                      " + _vm._s(_vm.practitionerName) + " @ " + _vm._s(_vm.appointment.address.name) + ":\n                      "), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return [_c('v-list-tile', {
      key: day
    }, [_c('v-list-tile-content', {
      staticClass: "text-capitalize"
    }, [(day in _vm.operatingHours && _vm.operatingHours[day]) ? _c('v-list-tile-title', [_c('strong', [_vm._v(_vm._s(day))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "padding-left": "20px"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.formatHours(_vm.operatingHours[day])) + "\n                            ")])]) : _c('v-list-tile-title', [_c('strong', [_vm._v(_vm._s(day))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "padding-left": "20px"
      }
    }, [_vm._v("Not available")])])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + day)
    })]
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.operationHoursLink && _vm.appointmentServiceId) ? _c('v-list-tile', [_c('v-btn', {
    attrs: {
      "block": "",
      "small": "",
      "flat": "",
      "href": _vm.operationHoursLink,
      "disabled": !_vm.rolesIsOwnerOfSpace(_vm.appointmentServiceId),
      "target": "_blank"
    }
  }, [_vm._v("Edit hours\n                        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.appointment.is_custom && _vm.isProductSelected),
      expression: "!appointment.is_custom && isProductSelected"
    }],
    class: _vm.getStepClasses("client"),
    on: {
      "click": function($event) {
        _vm.clientmodal = true;
        _vm.clientToucher++
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person_add")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.appointment.client && _vm.appointment.client.first_name) ? _c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(_vm.formatFullName(_vm.selectedRelationship)) + "\n                ")]) : _c('v-list-tile-title', [_vm._v("Contact person")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                  Click to change")]), _vm._v(" "), (_vm.appointment.client && !_vm.clientIsSharedWithSelectedSpace) ? _c('v-list-tile-sub-title', {
    staticClass: "warning--text"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n                  This client will automatically be shared with the space " + _vm._s(_vm.appointmentServiceTitle) + "\n                ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.relationshipId && _vm.practitionerId && _vm.appointment.day) ? _c('v-list-tile-action', [_c('automation-indicator', {
    attrs: {
      "relationship-id": _vm.relationshipId,
      "practitioner-id": _vm.practitionerId,
      "product-id": _vm.formattedAppointment.product,
      "dt": _vm.appointment.day
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.relationshipId) ? _c('v-list-tile-action', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "ml-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [(_vm.appointment.client && _vm.appointment.client.id) ? _c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("task_alt")]) : _c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("arrow_back")])], 1)], 1), _vm._v(" "), (_vm.appointment.client && _vm.appointment.client.id) ? _c('div', {
    staticClass: "overline pl-3 pt-1 grey lighten-4"
  }, [_c('v-divider'), _vm._v(" "), (!_vm.hasContacts) ? [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No contact info\n              ")], 1)] : [(_vm.clientPhoneNumber) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.clientPhoneNumber) + "\n                ")]) : _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No phone no.\n              ")], 1), _vm._v(" "), (_vm.clientEmail) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.clientEmail) + "\n                ")]) : _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No email\n              ")], 1)], _vm._v(" "), _c('v-divider')], 2) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": true,
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.clientmodal),
      callback: function($$v) {
        _vm.clientmodal = $$v
      },
      expression: "clientmodal"
    }
  }, [_c('client-picker-dialog', {
    attrs: {
      "can-clear-space": false,
      "space-id": _vm.spaceId,
      "include-owned-by-me": true,
      "touch": _vm.clientToucher
    },
    on: {
      "clientselected": _vm.clientSelected,
      "relationshipselected": _vm.relationshipSelected,
      "close": function($event) {
        _vm.clientmodal = false
      }
    }
  })], 1), _vm._v(" "), (_vm.appointment.client && _vm.appointment.client.first_name) ? _c('section', [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-spacer'), _vm._v(" "), (!_vm.selectCustomTitle) ? _c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.selectCustomTitle = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("\n                      Add a dependant")], 1) : _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.selectCustomTitle = false;
        _vm.appointment.title = ""
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), (_vm.selectCustomTitle) ? [_c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "outline": "",
      "persistent-hint": "",
      "name": "input-title",
      "hint": "Dependant's name will show on calendar and invoices. Appointment is attached to the contact person's account",
      "label": "Dependant's full name",
      "id": "appointment-title"
    },
    model: {
      value: (_vm.appointment.title),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "title", $$v)
      },
      expression: "appointment.title"
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-right"
  }, [(_vm.appointmentIsValid && _vm.selectCustomTitle) ? _c('span', {
    staticClass: "mr-4"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n                Appointment will be stored under " + _vm._s(_vm.clientFirstName) + "\n              ")], 1) : _vm._e()])], 1), _vm._v(" "), (!_vm.appointmentIsValid) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "color": "orange"
    }
  }, [_vm._v("warning")])], 1), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "orange--text"
  }, [_vm._v("\n              " + _vm._s(_vm.invalidReason) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.isReadOnly === true) ? _c('read-only-block', {
    attrs: {
      "xs12": "",
      "text": "This account is in read-only mode. Please resolve the account status in order to create new appointments"
    }
  }) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.savedAppointment && _vm.savedAppointment.id) ? _c('appointments-after-actions', {
    attrs: {
      "appointment": _vm.savedAppointment
    },
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      },
      "reset": _vm.clear
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 0),
      expression: "step===0"
    }],
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "loading": _vm.saveRequest.loading,
      "disabled": !_vm.appointmentIsValid
    },
    on: {
      "click": function($event) {
        _vm.confirmAndCreate = true
      }
    }
  }, [_vm._v("Confirm and create")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-divider'), _vm._v(" "), (_vm.appointment.day) ? _c('practitioner-day-view', {
    staticClass: "mr-3 mt-2 elevation-10",
    attrs: {
      "with-week": "",
      "with-date-bar": "",
      "block-events": "",
      "with-fetch": false,
      "practitioner": _vm.practitioner,
      "date": _vm.appointment.day,
      "settings": _vm.dayViewSettings,
      "preview-event": _vm.appointmentPreview
    },
    on: {
      "update:date": function($event) {
        return _vm.$set(_vm.appointment, "day", $event)
      },
      "dayview:createevent": _vm.slotSelected
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.xs) ? _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "scrollable": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.showcalendar),
      callback: function($$v) {
        _vm.showcalendar = $$v
      },
      expression: "showcalendar"
    }
  }, [(_vm.appointment.day) ? _c('v-card', {
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey darken-4 py-1 white--text"
  }, [_vm._v("\n        Schedule for " + _vm._s(_vm.dateformat(_vm.appointment.day)) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showcalendar = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment.day) ? _c('practitioner-day-view', {
    attrs: {
      "with-week": "",
      "with-date-bar": "",
      "block-events": "",
      "with-fetch": false,
      "practitioner": _vm.practitioner,
      "date": _vm.appointment.day,
      "settings": _vm.dayViewSettings,
      "preview-event": _vm.appointmentPreview
    },
    on: {
      "update:date": function($event) {
        return _vm.$set(_vm.appointment, "day", $event)
      },
      "dayview:createevent": _vm.slotSelected
    }
  }) : _vm._e(), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sheetdateselected),
      expression: "sheetdateselected"
    }],
    staticClass: "success",
    attrs: {
      "fab": "",
      "small": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.showcalendar = false
      }
    }
  }, [_c('v-icon', [_vm._v("check")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('product-sheet', {
    attrs: {
      "visible": _vm.productpicker,
      "practitioner": _vm.practitioner
    },
    on: {
      "selectedservice": _vm.productSelected
    }
  }), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "inset": ""
    },
    model: {
      value: (_vm.confirmAndCreate),
      callback: function($$v) {
        _vm.confirmAndCreate = $$v
      },
      expression: "confirmAndCreate"
    }
  }, [_c('confirm-appointment', {
    attrs: {
      "practitioner": _vm.practitioner,
      "appointment": _vm.appointment,
      "loading": _vm.saveRequest.loading
    },
    on: {
      "close": function($event) {
        _vm.confirmAndCreate = false
      },
      "confirm": _vm.confirmAndSave
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "name": "client-search",
      "label": "Search",
      "hint": _vm.hintText,
      "append-icon": "search",
      "prepend-icon": _vm.prependIcon,
      "loading": _vm.clientsRequest.loading,
      "browser-autocomplete": "off",
      "box": "",
      "clearable": "",
      "autofocus": "",
      "id": "client-search"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchClients(_vm.searchString)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.searchString = ''
      },
      "click:prepend": _vm.newClient
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), (_vm.spaceName) ? _c('div', {
    staticClass: "caption px-2 blue lighten-4",
    attrs: {
      "type": "info"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n  Only showing clients in "), _c('i', [_vm._v(_vm._s(_vm.spaceName))]), _vm._v(" "), (_vm.includeOwnedByMe) ? _c('i', [_vm._v(" or owned by me")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.withClientsInRange && (!_vm.searchString || _vm.searchString.length === 0)) ? _c('div', [_c('v-subheader', {
    staticClass: "overline pl-1 my-0"
  }, [_vm._v("\n      People you've seen in this period\n      "), _c('v-spacer')], 1), _vm._v(" "), (_vm.withNotInvoicedFilter) ? _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "label": "show only people who have not been invoiced"
    },
    model: {
      value: (_vm.showOnlyNotInvoiced),
      callback: function($$v) {
        _vm.showOnlyNotInvoiced = $$v
      },
      expression: "showOnlyNotInvoiced"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.quicklist), function(clientId, index) {
    return _c('v-chip', {
      key: ("chip-" + clientId + "-" + index),
      attrs: {
        "small": "",
        "label": ""
      },
      on: {
        "click": function($event) {
          _vm.clientSelected(_vm.getRelationByClientId(clientId))
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.formatFullName(_vm.getClientById(clientId))) + "\n    ")])
  }), _vm._v(" "), (_vm.showList) ? _c('v-subheader', {
    staticClass: "overline pl-1 my-0"
  }, [_vm._v("\n      Other contacts\n      "), _c('v-spacer')], 1) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.filteredClients), function(client, index) {
    return [_c('client-list-item', {
      key: ("cli-" + (client.id) + "-" + index),
      class: {
        "blue lighten-5": (_vm.selected && _vm.selected.id === client.id)
      },
      attrs: {
        "client": client.client,
        "relationship-id": client.id,
        "owner": client.practitioner,
        "spaces": client.spaces,
        "with-details": false,
        "with-action": _vm.withAction,
        "with-whats-app": _vm.withWhatsApp
      },
      on: {
        "listitem:clicked": function($event) {
          return _vm.clientSelected(client)
        }
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (client.id) + "-" + index)
    })]
  }), _vm._v(" "), (_vm.limit <= _vm.filteredClients.length) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.limit = _vm.limit + _vm.page
      }
    }
  }, [_vm._v("load more")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.searchString && _vm.searchString.length > 0) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-alert', {
    staticClass: "amber py-1",
    attrs: {
      "dismissible": "",
      "type": "warning",
      "value": _vm.spaceName && _vm.filteredClients.length === 0
    }
  }, [_vm._v("\n        Only showing clients shared with " + _vm._s(_vm.spaceName) + ".\n        If you cannot find a specific client, you may need to share them with this space\n      ")]), _vm._v(" "), _c('v-card-actions', [_vm._v("\n        " + _vm._s(Math.min(_vm.limit, _vm.filteredClients.length)) + " results found\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "small": "",
      "loading": _vm.searchRequest.loading,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.searchClients(_vm.searchString)
      }
    }
  }, [_vm._v("Continue search on server")]), _vm._v(" "), (_vm.withCreate) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": _vm.newClient
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("person_add")]), _vm._v("\n          New\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.clientsRequest.loading,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.getClients(1, _vm.pageSize)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1)], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-actions', [_vm._v("\n        Showing " + _vm._s(Math.min(_vm.limit, _vm.clients.length)) + " of " + _vm._s(_vm.clients.length) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.clientsRequest.loading,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.getClients(1, _vm.pageSize)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('v-subheader', {
    staticClass: "overline pa-0"
  }, [_vm._v("Locations")]), _vm._v(" "), _vm._l((_vm.locations), function(location) {
    return _c('v-checkbox', _vm._b({
      key: location.id,
      staticClass: "mt-0",
      attrs: {
        "dense": "",
        "hide-details": "",
        "row": "",
        "value": location.id,
        "label": location.name
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }, 'v-checkbox', _vm.attrs, false))
  }), _vm._v(" "), (_vm.hint) ? _c('div', {
    staticClass: "caption grey--text",
    domProps: {
      "textContent": _vm._s(_vm.hint)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.warningMessage) ? _c('div', {
    staticClass: "caption warning--text",
    domProps: {
      "textContent": _vm._s(_vm.warningMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errorMessages && _vm.errorMessages.length > 0) ? _vm._l((_vm.errorMessages), function(error) {
    return _c('div', {
      staticClass: "caption error--text",
      domProps: {
        "textContent": _vm._s(error)
      }
    })
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ })
],[547]);


// WEBPACK FOOTER //
// static/js/app.b6651d9380b04677b80a.js